import trainingAdminTranslations from "../app/components/dashboard/training/trainingAdminTranslations";
import { trainingParticipantEn } from "./trainingParticipantTranslations";
export const en = {


    translation: {
        "trainingAdmin.jsonLanguage": "Unknown language. Use nb, en, sv or pl, and do not translate into the course's own language.",
        "trainingAdmin.jsonLanguageMismatch": "The JSON is written in a different language from the course. Include a complete translation into the course language, or use “Replace content”.",
        "trainingAdmin.jsonTranslations": "A translation refers to a page, card or answer option that is not in the course.",
        "trainingAdmin.languages": "Languages",
        "trainingAdmin.validationTranslations": "Complete or remove translations with missing text before publishing.",
        "trainingAdmin.translation.baseTitle": "Course language",
        "trainingAdmin.translation.baseHint": "The language the course is written in. Participants see this language when the course is not available in theirs.",
        "trainingAdmin.translation.title": "Translations",
        "trainingAdmin.translation.hint": "Add the languages the course should be available in. Participants choose the language at the top of the course. Questions, answer keys, documents and images are the same in every language, and answers count regardless of language.",
        "trainingAdmin.translation.missing": "Missing: {{count}}",
        "trainingAdmin.translation.complete": "Complete",
        "trainingAdmin.translation.edit": "Edit",
        "trainingAdmin.translation.ai": "Translate with AI",
        "trainingAdmin.translation.aiBusy": "Translating …",
        "trainingAdmin.translation.aiDone": "AI filled in {{count}} texts. Review them before publishing.",
        "trainingAdmin.translation.add": "Add language:",
        "trainingAdmin.translation.saveFirst": "Save the course before using AI translation.",
        "trainingAdmin.translation.editorTitle": "Translation into {{language}}",
        "trainingAdmin.translation.onlyMissing": "Show only missing texts",
        "trainingAdmin.translation.nothingMissing": "All texts are translated.",
        "trainingAdmin.translation.done": "Close translation",
        "trainingAdmin.translation.courseTitle": "Course title",
        "trainingAdmin.translation.courseDescription": "Course description",
        "trainingAdmin.translation.pageTitle": "Page title",
        "trainingAdmin.translation.cardTitle": "Card title",
        "trainingAdmin.translation.cardBody": "Content",
        "trainingAdmin.translation.explanation": "Explanation after answer",
        "trainingAdmin.translation.imageAlt": "Image text (alternative text)",
        "trainingAdmin.translation.option": "Answer option",
        "trainingParticipant.languages.title": "This course is available in several languages",
        "trainingParticipant.languages.hint": "Choose the language you want to take the course in. Your answers count in every language.",
        "trainingParticipant.languages.choose": "Choose course language",
        "pmStepper.decrease": "Decrease",
        "pmStepper.increase": "Increase",
        "hseCompliance.source.manual": "Added",
        "hseCompliance.source.audience": "Audience",
        "hseCompliance.source.training": "Via training",
        "hseCompliance.source.training_named": "Training: {{title}}",
        "hseCompliance.source.creator": "Author",
        "hseCompliance.status.acknowledged": "Confirmed",
        "hseCompliance.status.pending": "Waiting",
        "hseCompliance.status.pending_due": "Due {{date}}",
        "hseCompliance.status.overdue": "Overdue",
        "hseCompliance.status.optional": "Not required",
        "hseCompliance.status.no_access": "Not assigned",
        "hseCompliance.status.exempt": "Author",
        "hseCompliance.via.training": "via training",
        "hseCompliance.via.carried_forward": "carried over from the previous version",
        "hseCompliance.via.creator": "author",
        "hseCompliance.due.overdue_flag": "Overdue",
        "hseCompliance.due.soon_flag": "Soon",
        "hseCompliance.postpone.dots_label": "{{used}} of {{max}} postponements used",
        "hseCompliance.people.search": "Search for a person …",
        "hseCompliance.people.empty": "No matches",
        "hseCompliance.people.remove": "Remove {{name}}",
        "hseCompliance.people.selected": "{{count}} selected",
        "hseCompliance.audience.all": "All employees",
        "hseCompliance.audience.all_desc": "{{count}} employees now – new hires get access automatically",
        "hseCompliance.audience.positions": "Selected positions",
        "hseCompliance.audience.positions_desc": "Follows the position – changes when someone changes position",
        "hseCompliance.audience.none": "Selected people only",
        "hseCompliance.audience.none_desc": "Only the people you add, and participants of training that uses the document",
        "hseCompliance.dialog.menu_label": "Access and read requirement",
        "hseCompliance.dialog.eyebrow": "HSE document",
        "hseCompliance.dialog.title": "Access and read requirement",
        "hseCompliance.dialog.title_bulk": "Access and read requirement for {{count}} documents",
        "hseCompliance.dialog.subtitle": "Who should read the document, and when it must be confirmed",
        "hseCompliance.dialog.subtitle_bulk": "Turn on the parts you want to change. Everything else stays as it is per document.",
        "hseCompliance.dialog.load_error": "Could not load access and read requirement",
        "hseCompliance.dialog.save_error": "Could not save access and read requirement",
        "hseCompliance.dialog.saved": "Access and read requirement saved",
        "hseCompliance.dialog.saved_bulk": "Saved for {{count}} documents",
        "hseCompliance.dialog.save": "Save",
        "hseCompliance.dialog.save_bulk": "Apply to {{count}} documents",
        "hseCompliance.dialog.bulk_action": "Access and read requirement ({{count}})",
        "hseCompliance.dialog.audience_title": "Who has access",
        "hseCompliance.dialog.audience_hint": "A rule also covers new employees, so you never update each document.",
        "hseCompliance.dialog.positions_label": "Positions",
        "hseCompliance.dialog.positions_empty": "The company has no active positions. Add them under employees.",
        "hseCompliance.dialog.people_extra_label": "Additional people",
        "hseCompliance.dialog.people_only_label": "People with access",
        "hseCompliance.dialog.people_add_label": "Add people",
        "hseCompliance.dialog.people_help": "Give access to people outside the rule, for example contractors.",
        "hseCompliance.dialog.people_add_help": "The people are added to every selected document. Nobody is removed.",
        "hseCompliance.dialog.reach": "{{count}} of {{total}} employees get access (plus training participants).",
        "hseCompliance.dialog.reach_bulk": "The rule gives {{count}} employees access today.",
        "hseCompliance.dialog.requirement_title": "Read requirement",
        "hseCompliance.dialog.requirement_hint": "Required documents get a deadline, reminders and a notice to the manager and HSE lead.",
        "hseCompliance.dialog.required_label": "Must be read and confirmed",
        "hseCompliance.dialog.required_desc": "Everyone with access must confirm «read and understood» by the deadline. A completed guide with the document counts.",
        "hseCompliance.dialog.not_required_help": "The document is available for reference. No deadline or reminders.",
        "hseCompliance.dialog.deadline_label": "Deadline",
        "hseCompliance.dialog.deadline_help": "From assignment – also for new employees and new versions.",
        "hseCompliance.dialog.postponements_label": "Number of postponements",
        "hseCompliance.dialog.postponements_help": "How many times the employee can postpone.",
        "hseCompliance.dialog.postpone_days_label": "Max per postponement",
        "hseCompliance.dialog.postpone_days_help": "When postponements are used up, the manager and HSE lead are notified.",
        "hseCompliance.dialog.days": "days",
        "hseCompliance.dialog.training_title": "Via training",
        "hseCompliance.dialog.training_hint": "Training that uses the document gives participants access, and completing it counts as confirmed.",
        "hseCompliance.dialog.training_empty": "No active training uses this document.",
        "hseCompliance.dialog.fact_readers": "Have access",
        "hseCompliance.dialog.fact_readers_value": "{{count}} of {{total}}",
        "hseCompliance.dialog.open_employees": "See routines per employee →",
        "hseCompliance.dialog.change_access": "Change access",
        "hseCompliance.dialog.change_requirement": "Change read requirement",
        "hseCompliance.dialog.error_positions": "Choose at least one position.",
        "hseCompliance.dialog.error_nothing": "Turn on what you want to change.",
        "hseCompliance.notice.exempt_title": "You are the author",
        "hseCompliance.notice.exempt_desc": "The author does not need to confirm their own document.",
        "hseCompliance.notice.done_title": "Read and understood",
        "hseCompliance.notice.done_direct": "You confirmed on {{date}}.",
        "hseCompliance.notice.done_training": "Confirmed through completed training on {{date}}. No need to confirm again.",
        "hseCompliance.notice.done_carried": "The change in this version did not require a new confirmation.",
        "hseCompliance.notice.optional_title": "For information",
        "hseCompliance.notice.optional_desc": "Confirming this document is not required, but you may confirm that you have read it.",
        "hseCompliance.notice.due_title": "Must be read by {{date}} ({{count}} days left)",
        "hseCompliance.notice.due_title_one": "Must be read by {{date}} (1 day left)",
        "hseCompliance.notice.overdue_title": "The deadline was {{date}}",
        "hseCompliance.notice.required_desc": "Read the document and confirm that you have read and understood it. Your manager and the HSE lead are notified when the deadline passes.",
        "hseCompliance.notice.postponements_left": "{{count}} postponements left",
        "hseCompliance.notice.postponements_left_one": "1 postponement left",
        "hseCompliance.notice.postpone": "Postpone",
        "hseCompliance.notice.postpone_choose": "Choose number of days",
        "hseCompliance.notice.postpone_confirm": "Postpone {{count}} days",
        "hseCompliance.notice.postpone_confirm_one": "Postpone 1 day",
        "hseCompliance.notice.days": "{{count}} days",
        "hseCompliance.notice.days_one": "1 day",
        "hseCompliance.notice.postponed": "New deadline: {{date}}",
        "hseCompliance.reminder.label": "Required reading for HSE documents",
        "hseCompliance.reminder.title": "{{count}} HSE routines must be read and confirmed",
        "hseCompliance.reminder.title_one": "1 HSE routine must be read and confirmed",
        "hseCompliance.reminder.overdue_title": "{{count}} HSE routines are past their deadline",
        "hseCompliance.reminder.overdue_title_one": "1 HSE routine is past its deadline",
        "hseCompliance.reminder.next_due": "Next deadline {{date}}",
        "hseCompliance.reminder.was_due": "The deadline was {{date}}",
        "hseCompliance.reminder.open_one": "Read now",
        "hseCompliance.reminder.open_all": "See routines",
        "hseCompliance.reminder.snooze": "Hide for an hour",
        "hseCompliance.home.none": "No HSE routines are waiting for you",
        "hseCompliance.home.required": "{{count}} required routines are waiting for you",
        "hseCompliance.home.required_one": "1 required routine is waiting for you",
        "hseCompliance.home.overdue": "{{count}} are past the deadline",
        "hseCompliance.home.overdue_one": "1 is past the deadline",
        "hseCompliance.home.show_all": "Show all ({{count}})",
        "employee_handbook.library.no_chapter": "No chapter",
        "employee_handbook.library.must_read_title": "Must read ({{count}})",
        "employee_handbook.library.must_read_hint": "Required routines. Read and confirm before the deadline.",
        "employee_handbook.library.show_all": "Show all ({{count}})",
        "employee_handbook.library.search": "Search title, number or chapter",
        "employee_handbook.library.clear_search": "Clear search",
        "employee_handbook.library.filter_label": "Show documents",
        "employee_handbook.library.filter_all": "All",
        "employee_handbook.library.filter_required": "Must read",
        "employee_handbook.library.filter_done": "Confirmed",
        "employee_handbook.library.discipline_label": "Trade",
        "employee_handbook.library.discipline_all": "All trades",
        "employee_handbook.library.toc": "Chapters",
        "employee_handbook.library.toc_all": "All chapters",
        "employee_handbook.library.results": "{{count}} documents",
        "employee_handbook.library.results_one": "1 document",
        "employee_handbook.library.empty_title": "No matching documents",
        "employee_handbook.library.empty_desc": "Try another search or clear the filters.",
        "employee_handbook.library.clear": "Clear filters",
        "hseCompliance.notice.postpone_error": "Could not postpone the deadline",
        "hseCompliance.employees.title": "Routines per employee",
        "hseCompliance.employees.subtitle": "Required reading, deadlines and access for each employee",
        "hseCompliance.employees.read_overview": "Read / understood",
        "hseCompliance.employees.kpi_overdue": "Employees overdue",
        "hseCompliance.employees.kpi_overdue_hint": "{{count}} overdue documents in total",
        "hseCompliance.employees.kpi_pending": "Waiting for confirmation",
        "hseCompliance.employees.kpi_pending_hint": "Within the deadline",
        "hseCompliance.employees.kpi_employees": "Employees",
        "hseCompliance.employees.kpi_documents": "Approved routines",
        "hseCompliance.employees.search": "Search for employee or position",
        "hseCompliance.employees.filter": "Filter",
        "hseCompliance.employees.filter_all": "All",
        "hseCompliance.employees.filter_overdue": "Overdue",
        "hseCompliance.employees.filter_pending": "Waiting",
        "hseCompliance.employees.filter_missing": "Missing access",
        "hseCompliance.employees.col_employee": "Employee",
        "hseCompliance.employees.col_progress": "Required reading",
        "hseCompliance.employees.col_next_due": "Next deadline",
        "hseCompliance.employees.col_without_access": "Not assigned",
        "hseCompliance.employees.progress_label": "{{done}} of {{total}} confirmed",
        "hseCompliance.employees.empty_title": "No employees to show",
        "hseCompliance.employees.empty_desc": "Nothing matches the search or filter.",
        "hseCompliance.employees.clear_filters": "Clear filters",
        "hseCompliance.routines.title": "Employee routines",
        "hseCompliance.routines.subtitle": "All approved HSE routines",
        "hseCompliance.routines.kpi_overdue": "Overdue",
        "hseCompliance.routines.kpi_pending": "Waiting",
        "hseCompliance.routines.kpi_acknowledged": "Confirmed",
        "hseCompliance.routines.kpi_no_access": "Not assigned",
        "hseCompliance.routines.search": "Search routines",
        "hseCompliance.routines.filter": "Filter",
        "hseCompliance.routines.filter_all": "All",
        "hseCompliance.routines.filter_no_access": "Not assigned",
        "hseCompliance.routines.filter_pending": "Waiting",
        "hseCompliance.routines.filter_overdue": "Overdue",
        "hseCompliance.routines.filter_acknowledged": "Confirmed",
        "hseCompliance.routines.manage_hint": "Select routines to give access or remove access you added. Access from the audience rule and training is managed on the document and in the training.",
        "hseCompliance.routines.change_error": "Could not change access",
        "hseCompliance.routines.granted": "Access given to {{count}} routines",
        "hseCompliance.routines.revoked": "Access removed from {{count}} routines",
        "hseCompliance.routines.no_chapter": "No chapter",
        "hseCompliance.routines.former_title": "Former employee",
        "hseCompliance.routines.former_desc": "The person has left. History is shown, but no new deadlines are set.",
        "hseCompliance.routines.empty_title": "No routines to show",
        "hseCompliance.routines.empty_desc": "Nothing matches the search or filter.",
        "hseCompliance.routines.select_all": "Select all visible",
        "hseCompliance.routines.select_one": "Select {{title}}",
        "hseCompliance.routines.col_document": "Routine",
        "hseCompliance.routines.col_access": "Access",
        "hseCompliance.routines.col_status": "Status",
        "hseCompliance.routines.col_due": "Deadline",
        "hseCompliance.routines.col_action": "Action",
        "hseCompliance.routines.required": "Required",
        "hseCompliance.routines.not_required": "Not required",
        "hseCompliance.routines.no_access": "No access",
        "hseCompliance.routines.grant": "Give access",
        "hseCompliance.routines.add_manual": "Add permanently",
        "hseCompliance.routines.remove": "Remove",
        "hseCompliance.routines.bulk_grant": "Give access ({{count}})",
        "hseCompliance.routines.bulk_remove": "Remove access ({{count}})",
        "hseCompliance.overview.summary_overdue": "Overdue",
        "hseCompliance.overview.overdue_count": "{{count}} overdue",
        "hseCompliance.overview.open_routines": "See employee routines",
        "hseCompliance.approve.eyebrow": "Approve revision",
        "hseCompliance.approve.title": "Approve version {{version}}",
        "hseCompliance.approve.subtitle": "Choose whether the change requires employees to confirm the document again",
        "hseCompliance.approve.reack_label": "Requires new read confirmation",
        "hseCompliance.approve.reack_on": "Everyone with a read requirement must read and confirm the new version by the deadline.",
        "hseCompliance.approve.reack_off": "Minor change: earlier «read and understood» is carried over. Only people who had not confirmed get a deadline.",
        "featureAnnouncements.eyebrow": "New feature",
        "featureAnnouncements.eyebrow_counter": "New feature · {{current}} of {{total}}",
        "featureAnnouncements.confirm": "Got it",
        "featureAnnouncements.learn_more": "Show me",
        "featureAnnouncements.language.title": "New language: {{language}}",
        "featureAnnouncements.language.subtitle": "Promang is now available in this language. Do you want to switch?",
        "featureAnnouncements.language.hint": "You can change the language at any time in your user settings.",
        "featureAnnouncements.language.keep": "Keep {{language}}",
        "featureAnnouncements.language.switch": "Switch to {{language}}",
        "featureAnnouncements.language.switch_failed": "Could not save your language choice. Please try again.",
        "agreementWorkflow.typeHint": "Choose an agreement type and review its defaults, agreement text and terms.",
        "agreementWorkflow.applyDefaults": "Use suggestions from this type",
        "agreementWorkflow.preserveEdits": "Fields you edit yourself are preserved when changing type or template.",
        "agreementWorkflow.draftHint": "Drafts and proposals do not generate service follow-up. The agreement becomes active after customer approval or signature is recorded.",
        "agreementWorkflow.saveDraft": "Save draft",
        "agreementWorkflow.created": "The agreement draft has been created.",
        "agreementWorkflow.openAgreement": "Open agreement",
        "agreementWorkflow.createdRefreshFailed": "The agreement was created, but the related view could not be updated. Open the agreement to continue.",
        "agreementWorkflow.unknown": "We could not confirm the result. Check agreement status before trying again.",
        "agreementWorkflow.noticeMonths": "Notice period (months)",
        "agreementWorkflow.durationYears": "Duration (years)",
        "agreementWorkflow.agreementText": "Agreement text",
        "agreementWorkflow.noFollowUp": "No service follow-up",
        "agreementWorkflow.title": "Agreement phase and approval",
        "agreementWorkflow.activeHint": "The agreement is active and included in service follow-up.",
        "agreementWorkflow.toProposal": "Move to proposal",
        "agreementWorkflow.toDraft": "Return to draft",
        "agreementWorkflow.send": "Send proposal to customer",
        "agreementWorkflow.approve": "Record approval/signature",
        "agreementWorkflow.reject": "Mark rejected",
        "agreementWorkflow.signingHint": "The agreement is awaiting signature. Returning to draft prevents the earlier signature from activating it.",
        "agreementWorkflow.approvalHint": "Record the customer’s approval or manual signature. Start date and service interval are required before activation.",
        "agreementWorkflow.approver": "Approved/signed by at customer",
        "agreementWorkflow.approvedOn": "Approval/signature date",
        "agreementWorkflow.methodLabel": "Method",
        "agreementWorkflow.method.manual_signature": "Manual signature",
        "agreementWorkflow.method.manual_approval": "Manual approval",
        "agreementWorkflow.method.posten": "Signed with Posten",
        "agreementWorkflow.evidence": "Signed PDF (optional)",
        "agreementWorkflow.uploadEvidence": "Upload signed PDF under Documents",
        "agreementWorkflow.documentsFailed": "Could not load attachments. Try reopening the dialog.",
        "agreementWorkflow.confirmApproval": "Confirm and activate agreement",
        "agreementWorkflow.sendHint": "The saved agreement is sent as a PDF. Sending does not activate service follow-up.",
        "agreementWorkflow.recipient": "Recipient email",
        "agreementWorkflow.recipientName": "Recipient name",
        "agreementWorkflow.message": "Message to customer",
        "agreementWorkflow.sent": "The proposal has been sent.",
        "agreementWorkflow.sendUnknown": "Delivery is unconfirmed. Check the email log and recipient before considering another send.",
        "agreementWorkflow.updated": "Agreement phase updated.",
        "agreementWorkflow.updatedRefreshFailed": "The change was saved, but the view could not be updated.",
        "agreementWorkflow.refreshFailed": "Could not check agreement status. Try checking again.",
        "agreementWorkflow.checkStatus": "Check status",
        "agreementWorkflow.delivery.sent": "Sent",
        "agreementWorkflow.delivery.sending": "Sending started",
        "agreementWorkflow.delivery.unknown": "Delivery unknown",
        "agreementWorkflow.delivery.not_sent": "Not sent",
        "agreementWorkflow.resolveNotSent": "Mark as not sent",
        "agreementWorkflow.resolveSent": "Mark as sent",
        "agreementWorkflow.resolvedNotSent": "Delivery is marked as not sent. You can send again.",
        "agreementWorkflow.resolvedSent": "Delivery is marked as sent. The email is not sent again.",
        "agreementWorkflow.status.draft": "Draft",
        "agreementWorkflow.status.proposal": "Proposal",
        "agreementWorkflow.status.awaiting_signature": "Awaiting signature",
        "agreementWorkflow.status.active": "Active",
        "agreementWorkflow.status.rejected": "Rejected",
        "agreementWorkflow.typeDefaults": "Creation defaults",

        "labels.printSelected": "Print labels ({{count}})",
        "labels.fields.navn": "Name",
        "labels.fields.nr": "Number",
        "labels.fields.pris": "Price",
        "labels.fields.beskrivelse": "Description",
        "labels.fields.merke": "Brand",
        "labels.fields.kategori": "Category",
        "labels.fields.lokasjon": "Location",
        "labels.fields.url": "Link (QR)",
        "labels.fields.dato": "Date",
        "labels.fields.kunde": "Customer",
        "labels.fields.adresse": "Address",
        "labels.fields.modell": "Model",
        "labels.fields.serienr": "Serial number",
        "labels.fields.info": "Additional info",
        "labels.designer.title": "Print label",
        "labels.designer.loading": "Loading data…",
        "labels.designer.prev": "Previous",
        "labels.designer.next": "Next",
        "labels.designer.refresh": "Reload data",
        "labels.designer.close": "Close",
        "labels.designer.printer": "Printer",
        "labels.designer.media": "Label roll",
        "labels.designer.mediaContinuous": "{{id}} · {{w}} mm continuous",
        "labels.designer.mediaDieCut": "{{id}} · {{w}} × {{h}} mm",
        "labels.designer.length": "Length in mm",
        "labels.designer.browserPrintHint": "Prints through the browser print dialog",
        "labels.designer.autoLayout": "Auto layout",
        "labels.designer.autoLayoutHint": "Create the standard layout for this label size",
        "labels.designer.tools": "Elements",
        "labels.designer.kind.text": "Text",
        "labels.designer.kind.barcode": "Barcode",
        "labels.designer.kind.qr": "QR code",
        "labels.designer.kind.line": "Line",
        "labels.designer.grid": "Grid",
        "labels.designer.zoomOut": "Zoom out",
        "labels.designer.zoomFit": "Fit",
        "labels.designer.zoomIn": "Zoom in",
        "labels.designer.loadFailed": "Could not load label data.",
        "labels.designer.retry": "Try again",
        "labels.designer.empty": "Nothing to print.",
        "labels.designer.feedContinuous": "Continuous tape · cut automatically",
        "labels.designer.feedDieCut": "Die-cut label",
        "labels.designer.overridden": "Manually overridden",
        "labels.designer.inspector": "Properties",
        "labels.designer.duplicate": "Duplicate",
        "labels.designer.delete": "Delete",
        "labels.designer.content": "Content",
        "labels.designer.manual": "Manual",
        "labels.designer.fromData": "From data",
        "labels.designer.dataValue": "Data",
        "labels.designer.reset": "Reset",
        "labels.designer.template": "Template",
        "labels.designer.templatePlaceholder": "Template, e.g. {navn}",
        "labels.designer.font": "Font",
        "labels.designer.size": "Size in pt",
        "labels.designer.weight": "Weight",
        "labels.designer.weightNormal": "Normal",
        "labels.designer.weightBold": "Bold",
        "labels.designer.align": "Alignment",
        "labels.designer.alignLeft": "Left",
        "labels.designer.alignCenter": "Center",
        "labels.designer.alignRight": "Right",
        "labels.designer.shrinkToFit": "Shrink to fit",
        "labels.designer.showText": "Show text",
        "labels.designer.code39Info": "Code 39 · {{count}} characters",
        "labels.designer.code39Dropped": "Code 39 only supports A–Z, 0–9, space, - and . – other characters are left out.",
        "labels.designer.widthShort": "W",
        "labels.designer.heightShort": "H",
        "labels.designer.geom.x": "X position in mm",
        "labels.designer.geom.y": "Y position in mm",
        "labels.designer.geom.w": "Width in mm",
        "labels.designer.geom.h": "Height in mm",
        "labels.designer.fields": "Data fields",
        "labels.designer.clickToInsert": "Click to insert",
        "labels.designer.newField": "Insert {{field}}",
        "labels.designer.overrideCount": "{{count}} manually changed",
        "labels.designer.dots": "dots",
        "labels.designer.copies": "Copies",
        "labels.designer.printAll": "All ({{count}})",
        "labels.designer.cancel": "Cancel",
        "labels.designer.print": "Print",
        "labels.designer.sent": "{{count}} labels sent to print ({{printer}})",
        "labels.designer.printFailed": "Could not open printing. Try again.",
        "labels.designer.newText": "New text",
        "inventory.picking.labels_for_lines": "Labels for all items in the document",
        "inventory.picking.quick_print.tooltip": "Print label",
        "inventory.picking.quick_print.document_tooltip": "Document label (number, customer, address, type)",
        "inventory.stock.title": "Warehouse stock",
        "inventory.stock.subtitle": "Stock and available quantities by product, with storage filters and label printing.",
        "inventory.stock.search": "Search products…",
        "inventory.stock.storage": "Storage",
        "inventory.stock.tracked": "Tracked quantity",
        "inventory.stock.min": "Min",
        "inventory.stock.max": "Max",
        "inventory.stock.legacyWarning": "Stock uses legacy quantities without an approved opening. Check the valuation report before treating these figures as accounting value.",
        "inventory.stock.selection": "Selected products",
        "inventory.stock.selected": "{{count}} products selected",
        "inventory.stock.printLabels": "Print labels",
        "inventory.stock.loadFailed": "Could not load warehouse stock. Try again.",
        "inventory.stock.loading": "Loading warehouse stock…",
        "inventory.stock.empty": "No products found",
        "inventory.stock.emptyHint": "Try another search or clear the filters.",
        "inventory.stock.clearFilters": "Clear filters",
        "inventory.stock.selectAll": "Select all visible products",
        "inventory.stock.selectProduct": "Select {{product}}",
        "inventory.stock.product": "Product",
        "inventory.stock.outgoing": "Outgoing",
        "inventory.stock.incoming": "Incoming",
        "inventory.stock.available": "Available",
        "inventory.count.csv.invalid_quantity": "Row {{row}} has an invalid quantity. Use zero or a positive number with at most four decimals.",
        "inventoryPurchases.title": "Purchases",
        "inventoryPurchases.eyebrow": "Purchasing",
        "inventoryPurchases.overview": "Purchase overview",
        "inventoryPurchases.openOrders": "Open orders",
        "inventoryPurchases.draftOrders": "Drafts",
        "inventoryPurchases.overdueOrders": "Overdue",
        "inventoryPurchases.exVat": "excl. VAT",
        "inventoryPurchases.unknownAmount": "Amount incomplete",
        "inventoryPurchases.activeOrders": "Active orders",
        "inventoryPurchases.notSent": "Not sent to supplier",
        "inventoryPurchases.pastDelivery": "Past requested delivery date",
        "inventoryPurchases.statusTabs": "Purchase status",
        "inventoryPurchases.tab.all": "All",
        "inventoryPurchases.tab.draft": "Drafts",
        "inventoryPurchases.tab.openTab": "Open",
        "inventoryPurchases.tab.received": "Received",
        "inventoryPurchases.project": "Project",
        "inventoryPurchases.amount": "Amount excl. VAT",
        "inventoryPurchases.lineCount": "{{count}} lines",
        "inventoryPurchases.overdue": "Overdue",
        "inventoryPurchase.details": "Details",
        "inventoryPurchase.project": "Project",
        "inventoryPurchase.contact": "Supplier contact",
        "inventoryPurchase.contactHint": "Choose or create a contact. Sending uses this email first.",
        "inventoryPurchase.sendToContact": "Supplier contact",
        "inventoryPurchase.sendToContactNamed": "Contact · {{name}}",
        "inventoryPurchase.contactEmailMissing": "The contact is missing an email address.",
        "inventoryPurchase.chooseProject": "Choose project",
        "inventoryPurchase.deliveryAddress": "Delivery address",
        "inventoryPurchase.localAddressHint": "Internal Promang information. Tripletex currently uses the company delivery address.",
        "inventoryPurchase.costCode": "Cost code",
        "inventoryPurchase.localCostCodeHint": "Internal Promang code, not transferred to Tripletex.",
        "inventoryPurchase.summary": "Summary",
        "inventoryPurchase.netAmount": "Total excl. VAT",
        "inventoryPurchase.grossAmount": "Total incl. VAT",
        "inventoryPurchase.orderLines": "Order lines",
        "inventoryPurchase.itemNumber": "Item no.",
        "inventoryPurchase.product": "Product",
        "inventoryPurchase.comment": "Comment",
        "inventoryPurchase.lineTotal": "Total",
        "inventoryPurchase.addProduct": "Add product",
        "inventoryPurchase.addFirstProduct": "Add first product",
        "inventoryPurchase.emptyLines": "No products added yet",
        "inventoryPurchase.send": "Send",
        "inventoryPurchase.sending": "Sending…",
        "inventoryPurchase.sendAsMe": "Me",
        "inventoryPurchase.lineTitle": "Item name",
        "inventoryPurchase.changeProduct": "Change product",
        "inventoryPurchase.unit": "Unit",
        "inventoryPurchase.saveDraft": "Save draft",
        "inventoryPurchase.sendToSupplier": "Send to supplier",
        "inventoryPurchase.sendDialogTitle": "Send purchase to supplier",
        "inventoryPurchase.sendMessageLabel": "Message to supplier",
        "inventoryPurchase.missingId": "Missing ID",
        "inventoryPurchase.sendFailed": "Something went wrong. Could not send the purchase.",
        "inventoryPurchase.sendNeedsSave": "Save the draft before sending. Delivery was not started.",
        "inventoryPurchases.subtitle": "Supplier orders, delivery and Tripletex status in one place.",
        "inventoryPurchases.new": "New purchase",
        "inventoryPurchases.search": "Search purchases…",
        "inventoryPurchases.filterStatus": "Filter by status",
        "inventoryPurchases.loading": "Loading purchases…",
        "inventoryPurchases.loadFailed": "Could not load purchases. Try again.",
        "inventoryPurchases.number": "Purchase number",
        "inventoryPurchases.supplier": "Supplier",
        "inventoryPurchases.purchaseDate": "Purchase date",
        "inventoryPurchases.deliveryDate": "Delivery date",
        "inventoryPurchases.status": "Status",
        "inventoryPurchases.delivery": "Supplier delivery",
        "inventoryPurchases.sync": "Tripletex",
        "inventoryPurchases.reference": "Reference",
        "inventoryPurchases.open": "Open",
        "inventoryPurchases.empty": "No purchases yet",
        "inventoryPurchases.emptyHint": "Create a purchase to get started.",
        "inventoryPurchases.emptyFiltered": "No purchases match your search or filters.",
        "inventoryPurchases.clearFilters": "Clear filters",
        "inventoryPurchases.status.draft": "Draft",
        "inventoryPurchases.status.sent": "Sent",
        "inventoryPurchases.status.confirmed": "Confirmed",
        "inventoryPurchases.status.received": "Received",
        "inventoryPurchases.status.cancelled": "Cancelled",
        "inventoryPurchases.createTitle": "Create purchase",
        "inventoryPurchases.createHint": "Choose a supplier. Complete the purchase on the next page.",
        "inventoryPurchases.continue": "Continue",
        "inventoryPurchases.searchSupplier": "Search suppliers…",
        "inventoryPurchases.noSuppliers": "No suppliers found",
        "inventoryPurchases.loadingSuppliers": "Loading suppliers…",
        "inventoryPurchases.supplierLoadFailed": "Could not load suppliers. Try the search again.",
        "inventoryPurchases.supplierRequired": "Choose a supplier before creating the purchase.",
        "inventoryPurchases.createFailed": "Could not create the purchase. Check the fields and try again.",
        "inventoryPurchases.createUnknown": "It is unclear whether the purchase was created. Check the list before trying again.",
        "inventoryPurchases.recoveryTitle": "Review unresolved purchase",
        "inventoryPurchases.recoveryHint": "This attempt keeps the same key. Resume it to avoid a duplicate; a new draft is available only after a definitive server rejection.",
        "inventoryPurchases.pendingAttempt": "Saved creation attempt",
        "inventoryPurchases.pendingSummary": "Supplier: {{supplier}} · Date: {{date}} · Reference: {{reference}}",
        "inventoryPurchases.checkBeforeRetry": "Check the purchase list before resending this attempt.",
        "inventoryPurchases.storageUnavailable": "The browser could not save the operation key. The purchase was not sent; try again when session storage works.",
        "inventoryPurchases.payloadConflict": "The server rejected this key for this content. The attempt is preserved; investigate a possible existing purchase before continuing.",
        "inventoryPurchases.checkFailed": "Could not check the purchase list. Try again; the attempt is still preserved.",
        "inventoryPurchases.listChecked": "The first list page has been checked. Matches below may be older identical purchases; absence does not prove this attempt failed. You can safely resume the exact same attempt.",
        "inventoryPurchases.possibleMatches": "Possible matches on the first list page",
        "inventoryPurchases.checking": "Checking…",
        "inventoryPurchases.newAttempt": "Correct rejected draft",
        "inventoryPurchases.retrySame": "Resume same attempt",
        "inventoryPurchases.created": "Purchase created.",
        "inventoryPurchases.cancel": "Cancel",
        "inventoryPurchases.create": "Create",
        "inventoryPurchases.creating": "Creating…",
        "inventoryPurchases.checkList": "Check purchase list",
        "inventoryReconciliation.title": "Accounting reconciliation",
        "inventoryReconciliation.nowHint": "Inventory value above is as of now. Accounting reconciliation uses the full selected calendar period; an open period cannot show a final variance.",
        "inventoryIntegration.receiptUnsupported": "Tripletex receiving is unavailable. The receipt remains posted in Promang.",
        "inventoryReceipt.syncTitle": "Stock posting and synchronization",
        "inventoryReceipt.localPosted": "Posted to stock in Promang",
        "inventoryReceipt.remoteConfirmed": "The receipt is also confirmed in Tripletex. Remaining goods stay on the same purchase.",
        "inventoryReceipt.remotePending": "Tripletex synchronization is not confirmed yet. Do not register the receipt again.",
        "inventoryReceipt.resumeHint": "This checks Tripletex and continues from the last confirmed step. Changed quantities, products or warehouses stop for reconciliation.",
        "inventoryReceipt.resumeSync": "Check and complete sync",
        "inventoryReceipt.checkingSync": "Checking Tripletex…",
        "inventoryReceipt.resumeFailed": "Synchronization could not be confirmed. Refresh the status and review conflicts in inventory settings. The receipt remains posted locally.",
        "inventoryReconciliation.bookClosing": "Closing book value",
        "inventoryReconciliation.bookOpening": "Opening book value",
        "inventoryReconciliation.approvedBaselines": "Approved opening balances",
        "inventoryReconciliation.bookProvisional": "Provisional value. Sync or period coverage is incomplete.",
        "inventoryReconciliation.bookDifference": "Difference from book value",
        "inventoryReconciliation.bookIncomplete": "A verified opening balance and complete sync for a closed period are required for comparison.",
        "inventoryReconciliation.bookAsOf": "Book value as of sync",
        "inventoryReconciliation.addBaseline": "Add accounting opening balance",
        "inventoryReconciliation.baselineHint": "Approve a documented balance per account before the period starts. It cannot be edited after saving.",
        "inventoryReconciliation.account": "Account",
        "inventoryReconciliation.baselineDate": "Balance date",
        "inventoryReconciliation.openingBalance": "Opening balance (NOK)",
        "inventoryReconciliation.evidence": "Evidence / reference",
        "inventoryReconciliation.baselineFailed": "Could not save the balance. Check the date, amount, and whether one already exists.",
        "inventoryReconciliation.saveBaseline": "Approve balance",
        "inventoryReconciliation.hint": "Compare physical inventory value movement with ledger postings on selected inventory accounts for the period.",
        "inventoryReconciliation.companyWide": "Reconciliation covers the whole company regardless of product or storage filters in the table.",
        "inventoryReconciliation.accounts": "Inventory accounts",
        "inventoryReconciliation.chooseAccount": "Choose account",
        "inventoryReconciliation.addAccount": "Add account",
        "inventoryReconciliation.loadFailed": "Could not load reconciliation.",
        "inventoryReconciliation.loading": "Loading reconciliation…",
        "inventoryReconciliation.physicalMovement": "Inventory movement",
        "inventoryReconciliation.ledgerMovement": "Ledger period movement",
        "inventoryReconciliation.difference": "Period difference",
        "inventoryReconciliation.notComparable": "Cannot compare",
        "inventoryReconciliation.opening": "Opening inventory value",
        "inventoryReconciliation.closing": "Closing inventory value",
        "inventoryReconciliation.incomplete": "Comparison requires complete cost history, selected accounts and confirmed ledger sync for the period.",
        "inventoryReconciliation.source": "Source: locally synced Tripletex vouchers",
        "inventoryReconciliation.lastCovered": "Last covering sync",
        "inventoryReconciliation.noBookBalance": "Book balance is hidden without a verified opening balance.",
        "inventoryIntegration.title": "Purchase order sync",
        "inventoryIntegration.field": "Field",
        "inventoryIntegration.sourceSystem": "Source system",
        "inventoryIntegration.compare.number": "Order number",
        "inventoryIntegration.compare.supplier": "Supplier ID",
        "inventoryIntegration.compare.date": "Order date",
        "inventoryIntegration.compare.deliveryDate": "Delivery date",
        "inventoryIntegration.compare.status": "Status / closed",
        "inventoryIntegration.closed": "Closed",
        "inventoryIntegration.open": "Open",
        "inventoryIntegration.noLines": "No item lines in the available data.",
        "inventoryIntegration.hint": "Promang owns inventory and purchasing. Track the Tripletex transition and items needing review.",
        "inventoryIntegration.loadFailed": "Could not load sync status. Try again.",
        "inventoryIntegration.mutationFailed": "The action could not be confirmed. Refresh status before retrying.",
        "inventoryIntegration.conflictChanged": "The purchase or Tripletex order changed. Review the refreshed values before confirming your choice again.",
        "inventoryIntegration.queued": "Sync queued. Refresh later for a confirmed result.",
        "inventoryIntegration.loading": "Loading sync status…",
        "inventoryIntegration.mode": "Operating mode",
        "inventoryIntegration.mode.off": "Sync off",
        "inventoryIntegration.mode.bridge": "Two-way transition",
        "inventoryIntegration.mode.local_only": "Promang only",
        "inventoryIntegration.remoteCapability": "Tripletex logistics",
        "inventoryIntegration.capability.available": "Available",
        "inventoryIntegration.capability.missing": "No access",
        "inventoryIntegration.capability.unchecked": "Not checked",
        "inventoryIntegration.pending": "Awaiting confirmation",
        "inventoryIntegration.needsReview": "Needs review",
        "inventoryIntegration.logisticsMissing": "Tripletex Logistics Basic is unavailable. Local inventory and purchasing in Promang continue.",
        "inventoryIntegration.lastVerified": "Last verified",
        "inventoryIntegration.syncNow": "Start reconciliation",
        "inventoryIntegration.conflicts": "Sync conflicts",
        "inventoryIntegration.conflict": "Conflict",
        "inventoryIntegration.review": "Review",
        "inventoryIntegration.reviewHint": "Compare the order in both systems before choosing which version to keep. The server checks the remote version again.",
        "inventoryIntegration.reason": "Reason",
        "inventoryIntegration.remoteVersion": "Tripletex version",
        "inventoryIntegration.resolution": "Choice",
        "inventoryIntegration.choose": "Choose action",
        "inventoryIntegration.keepLocal": "Keep Promang version",
        "inventoryIntegration.acceptRemote": "Use Tripletex version",
        "inventoryIntegration.applyResolution": "Confirm choice",
        "inventoryPurchase.conflict": "The purchase was changed elsewhere. Your unsaved work is preserved; reload and compare before continuing.",
        "inventoryPurchase.unknownSave": "The save outcome is unknown. Your unsaved work is preserved; check the purchase before retrying.",
        "inventoryPurchase.finishHeaderFirst": "Wait for the purchase changes to save before editing product lines.",
        "inventoryPurchase.markSentManually": "Mark sent manually",
        "inventoryPurchase.markingSent": "Marking as sent...",
        "inventoryPurchase.markSentFailed": "Could not mark the purchase as sent.",
        "inventoryPurchase.markConfirmedFailed": "Could not mark the purchase as confirmed.",
        "inventoryPurchase.markSentSuccess": "The purchase is marked as sent manually.",
        "inventoryPurchase.markConfirmedSuccess": "The purchase is marked as confirmed.",
        "inventoryPurchase.confirmed": "Confirmed",
        "inventoryPurchase.goodsReceipt": "Goods receipt",
        "inventoryPurchase.tripletexSync": "Tripletex sync",
        "inventoryPurchase.delivery.not_sent": "Not sent",
        "inventoryPurchase.delivery.queued": "Delivery pending",
        "inventoryPurchase.deliveryQueued": "Delivery queued. Check status before treating it as delivered.",
        "inventoryPurchase.sendQueueHint": "Sending is queued. Delivery to the supplier is confirmed only when the transport status reports acceptance.",
        "inventoryPurchase.delivery.accepted": "Transport confirmed delivery",
        "inventoryPurchase.delivery.manual": "Marked sent manually",
        "inventoryPurchase.delivery.unknown": "Delivery outcome unknown",
        "inventoryPurchase.delivery.failed": "Delivery failed",
        "inventoryPurchase.sync.queued": "Pending",
        "inventoryPurchase.sync.not_sent": "Not synchronized",
        "inventoryPurchase.sync.processing": "Syncing",
        "inventoryPurchase.sync.synced": "Synchronized",
        "inventoryPurchase.sync.unknown": "Outcome unknown",
        "inventoryPurchase.sync.conflict": "Conflict",
        "inventoryPurchase.sync.failed": "Failed",
        "inventoryPurchase.sync.unsupported": "Unavailable",
        "inventoryPurchase.addProducts": "Add product lines",
        "inventoryPurchase.addProductsHint": "Supplier products are searched first. If none match, sales products appear and are linked to the supplier when you save. Choose products, quantities and prices here.",
        "supplierProducts.title": "Supplier products",
        "supplierProducts.description": "Supplier item number, name and purchase price for each supplier.",
        "supplierProducts.add": "Link supplier",
        "supplierProducts.supplier": "Supplier",
        "supplierProducts.chooseSupplier": "Choose supplier",
        "supplierProducts.itemNumber": "Supplier item number",
        "supplierProducts.productTitle": "Supplier product name",
        "supplierProducts.purchasePrice": "Purchase price",
        "supplierProducts.empty": "No supplier products are linked to this product.",
        "supplierProducts.loadFailed": "Could not load supplier products.",
        "supplierProducts.saveFailed": "Could not save the supplier product.",
        "supplierProducts.linked": "Supplier product",
        "supplierProducts.willLink": "Sales product · linked on save",
        "supplierProducts.salesProduct": "Sales product",
        "supplierProducts.supplierDescription": "Products linked to this supplier. Open the sales product to edit item number, name and purchase price.",
        "supplierProducts.search": "Search supplier products…",
        "supplierProducts.emptySupplier": "No products are linked to this supplier yet.",
        "inventoryPurchase.chooseProducts": "Choose products",
        "inventoryPurchase.quantity": "Quantity",
        "inventoryPurchase.price": "Cost",
        "inventoryPurchase.actions": "Actions",
        "inventoryPurchase.remove": "Remove",
        "inventoryPurchase.noProducts": "No products selected yet.",
        "inventoryPurchase.close": "Close",
        "inventoryPurchase.saving": "Saving…",
        "inventoryPurchase.retrySame": "Check result with same key",
        "inventoryPurchase.addSelected": "Add {{count}} lines",
        "inventoryPurchase.quantityInvalid": "Every line must have a quantity greater than zero.",
        "inventoryPurchase.addFailed": "Could not add product lines.",
        "inventoryPurchase.unknownAdd": "Outcome unknown. Lines and operation key were preserved. Check with the same key before making changes.",
        "inventoryPurchase.linesAdded": "Product lines added.",
        "inventoryPurchase.title": "Purchases",
        "inventoryPurchase.loading": "Loading…",
        "inventoryPurchase.loadError": "Could not load the purchase",
        "inventoryPurchase.notFound": "Purchase not found",
        "inventoryPurchase.back": "Back",
        "inventoryPurchase.purchaseDate": "Purchase date",
        "inventoryPurchase.deliveryDate": "Delivery date",
        "inventoryPurchase.sendDate": "Send date",
        "inventoryPurchase.reference": "Reference",
        "inventoryPurchase.removeConfirm": "Are you sure you want to remove this line?",
        "inventoryPurchase.lineRemoved": "Line removed",
        "inventoryPurchase.removeFailed": "Could not remove the line",
        "inventoryPurchase.markingConfirmed": "Marking as confirmed…",
        "inventoryPurchase.status.draft": "Draft",
        "inventoryPurchase.status.sent": "Sent",
        "inventoryPurchase.status.confirmed": "Confirmed",
        "inventoryPurchase.status.received": "Received",
        "inventoryPurchase.status.cancelled": "Cancelled",
        "inventoryValuation.title": "Inventory value",
        "inventoryOpening.title": "Opening inventory balance",
        "inventoryOpening.emptyCounts": "Approved full counts contain no products. A zero opening is valid when every storage and count is certified.",
        "inventoryOpening.countDayOpen": "The count day has not ended in Europe/Oslo. Wait until the next day before approving the opening balance.",
        "inventoryOpening.allStorages": "All storages requiring a full count",
        "inventoryOpening.inactive": "Inactive",
        "inventoryOpening.hint": "Approve a full count from the previous day for every storage before inventory value can be complete.",
        "inventoryOpening.approved": "Opening inventory balance approved from {{date}}.",
        "inventoryOpening.open": "Prepare opening balance",
        "inventoryOpening.irreversible": "This posts opening stock and cannot be edited after approval. Review counts, costs, and evidence carefully.",
        "inventoryOpening.effectiveDate": "Effective date",
        "inventoryOpening.method": "Cost method",
        "inventoryOpening.chooseMethod": "Choose cost method",
        "inventoryOpening.weightedAverage": "Weighted average",
        "inventoryOpening.loading": "Checking approved counts…",
        "inventoryOpening.previewFailed": "Could not load counts for the selected date.",
        "inventoryOpening.countDate": "A full count must be approved on {{date}}",
        "inventoryOpening.rows": "{{count}} count rows",
        "inventoryOpening.missingStorages": "No approved full count for storage",
        "inventoryOpening.legacyPartialUsed": "At least one approved count was stored as partial (legacy default). It is used as that storage’s count for this date.",
        "inventoryOpening.latestApproved": "Latest approved count for {{storage}} is {{date}} ({{coverage}}). Set the effective date to the day after the count date.",
        "inventoryOpening.coverageFull": "full",
        "inventoryOpening.coveragePartial": "partial",
        "inventoryOpening.invalidCounts": "Not every row is approved in counts",
        "inventoryOpening.duplicateProducts": "A product occurs twice in one storage. Correct the count first.",
        "inventoryOpening.unknownCosts": "{{count}} rows lack cost. Value remains incomplete until cost evidence is documented.",
        "inventoryOpening.quantity": "Quantity",
        "inventoryOpening.costStatus": "Cost status",
        "inventoryOpening.unitCost": "Unit cost (NOK)",
        "inventoryOpening.evidence": "Cost evidence / reference",
        "inventoryOpening.known": "Documented",
        "inventoryOpening.certify": "I confirm every storage was fully counted the previous day and every row and cost source was reviewed.",
        "inventoryOpening.costEvidenceRequired": "Every valued positive-quantity row needs a valid unit cost and evidence.",
        "inventoryOpening.approveFailed": "Could not approve the opening inventory balance.",
        "inventoryOpening.unknownOutcome": "The outcome is unknown. Check status before trying again.",
        "inventoryOpening.checkStatus": "Check status",
        "inventoryOpening.approve": "Approve opening balance",
        "inventoryValuation.currentPeriod": "This month",
        "inventoryValuation.openReport": "Open report",
        "inventoryValuation.totalValue": "Total inventory value",
        "inventoryValuation.unvaluedQuantity": "Quantity without cost",
        "inventoryValuation.valuedSubtotal": "Valued subtotal",
        "inventoryValuation.openingMissing": "Opening inventory balance and cost method have not been approved. Inventory value is incomplete.",
        "inventoryReceipt.postedImmutable": "A posted receipt cannot be edited. Use a documented correction.",
        "inventoryReceipt.storageLoadFailed": "Could not load storages. Retry before saving the goods receipt.",
        "inventoryReceipt.saveFailed": "Could not save the goods receipt.",
        "inventoryReceipt.unknownOutcome": "Outcome unknown. Check the receipt with the same operation key before changing it.",
        "inventoryReceipt.remaining": "Remaining",
        "inventoryReceipt.receiveRemaining": "Receive remaining",
        "inventoryReceipt.saving": "Saving…",
        "inventoryReceipt.retrySame": "Check result with same key",
        "inventoryReceipt.quantityInvalid": "Quantity must be 0 or a positive number with at most four decimal places.",
        "inventoryReceipt.addProduct": "Add at least one receipt line before saving.",
        "inventoryCost.title": "Cost adjustments",
        "inventoryCost.hint": "Record a later supplier invoice against a posted goods receipt. Inventory value is recalculated without changing the purchase order.",
        "inventoryCost.new": "New cost adjustment",
        "inventoryCost.loading": "Loading cost data…",
        "inventoryCost.historyFailed": "Could not load cost adjustments.",
        "inventoryCost.empty": "No cost adjustments recorded.",
        "inventoryCost.receipt": "Goods receipt",
        "inventoryCost.invoice": "Supplier invoice",
        "inventoryCost.unitCost": "New unit cost",
        "inventoryCost.approved": "Approved",
        "inventoryCost.formHint": "Select a posted goods receipt and enter the documented cost from the supplier invoice. Editing the purchase order cannot undo this.",
        "inventoryCost.searchReceipt": "Search goods receipts",
        "inventoryCost.searchPlaceholder": "Product, item number or receipt number",
        "inventoryCost.receiptsFailed": "Could not load goods receipts. Try the search again.",
        "inventoryCost.openingRequired": "Approve the opening inventory balance before recording a cost adjustment.",
        "inventoryCost.noReceipts": "No posted goods receipts found.",
        "inventoryCost.product": "Product",
        "inventoryCost.quantity": "Quantity",
        "inventoryCost.previous": "Previous",
        "inventoryCost.next": "Next",
        "inventoryCost.selected": "Selected receipt movement #{{id}}",
        "inventoryCost.evidence": "Reason and evidence",
        "inventoryCost.error.invalid": "Check the receipt, amount, invoice reference and evidence. No adjustment was recorded.",
        "inventoryCost.error.forbidden": "You no longer have access to record a cost adjustment.",
        "inventoryCost.error.noRemaining": "This receipt has been fully consumed. Handle the invoice difference in accounting; it cannot be added to remaining inventory value.",
        "inventoryCost.error.unknown": "Outcome unknown. Check with the same operation key; fields are locked to avoid duplicates.",
        "inventoryCost.error.conflict": "Save conflict. Check the adjustment before continuing.",
        "inventoryCost.startNewAfterConflict": "Close conflict and start a new attempt",
        "inventoryCost.saved": "Cost adjustment approved.",
        "inventoryCost.impact": "Effect on remaining inventory value",
        "inventoryCost.impactUnknown": "Unknown because the prior cost was missing",
        "inventoryCost.close": "Close",
        "inventoryCost.saving": "Saving…",
        "inventoryCost.retry": "Check with same key",
        "inventoryCost.save": "Approve adjustment",
        "inventoryValuation.eyebrow": "Inventory and accounting",
        "inventoryValuation.hint": "Quantity and acquisition value for the selected period, calculated from posted movements.",
        "inventoryValuation.now": "Now",
        "inventoryValuation.refresh": "Refresh",
        "inventoryValuation.export": "Export",
        "inventoryValuation.printPdf": "Print PDF",
        "inventoryValuation.printing": "Preparing PDF…",
        "inventoryValuation.printFailed": "Could not create the PDF. Try again.",
        "inventoryValuation.exporting": "Exporting…",
        "inventoryValuation.download": "Download CSV",
        "inventoryValuation.checkExport": "Check export",
        "inventoryValuation.retryExport": "Check with same key",
        "inventoryValuation.exportUnknown": "Export outcome unknown. Check with the same operation key.",
        "inventoryValuation.exportQueued": "Export is being prepared. Check status before downloading.",
        "inventoryValuation.exportStatus.queued": "Export is queued.",
        "inventoryValuation.exportStatus.processing": "Export is being prepared.",
        "inventoryValuation.exportStatus.completed": "Export is ready to download.",
        "inventoryValuation.exportStatus.failed": "Export failed. Check status before retrying.",
        "inventoryValuation.exportStatus.unknown": "Outcome unknown. Check with the same key.",
        "inventoryValuation.search": "Search by product or number",
        "inventoryValuation.storage": "Storage",
        "inventoryValuation.forbidden": "You do not have access to inventory values.",
        "inventoryValuation.loadFailed": "Could not load inventory values. Try again.",
        "inventoryValuation.incomplete": "History is incomplete for this period. Earliest reliable date: {{date}}.",
        "inventoryValuation.opening": "Opening value",
        "inventoryValuation.incoming": "In, including transfers",
        "inventoryValuation.outgoing": "Out, including transfers",
        "inventoryValuation.closing": "Closing value",
        "inventoryValuation.method": "Cost method",
        "inventoryValuation.unvalued": "Quantity without cost",
        "inventoryValuation.asOf": "Calculated",
        "inventoryValuation.rows": "Inventory valuation rows",
        "inventoryValuation.loading": "Loading inventory values…",
        "inventoryValuation.product": "Product",
        "inventoryValuation.openingQuantity": "Opening quantity",
        "inventoryValuation.receivedQuantity": "Received",
        "inventoryValuation.issuedQuantity": "Issued",
        "inventoryValuation.closingQuantity": "Closing quantity",
        "inventoryValuation.missingCost": "Missing cost",
        "inventoryValuation.incompleteAmount": "Not calculated",
        "inventoryValuation.estimated": "Estimated",
        "inventoryValuation.empty": "No products for this period and filter.",
        "inventoryValuation.movements": "Movements",
        "inventoryValuation.movementsFailed": "Could not load movements.",
        "inventoryValuation.clearFilters": "Clear filters",
        "inventoryValuation.estimatesWarning": "{{count}} inventory rows use estimated cost ({{opening}} from opening balance, {{period}} from this period). Amounts are provisional; accounting differences are not final.",
        "inventoryValuation.movementsShown": "Showing {{shown}} of {{total}} movements",
        "inventoryValuation.loadMoreMovements": "Show more movements",
        "inventoryValuation.movement": "Movement",
        "inventoryValuation.openSource": "Open source",
        "inventoryValuation.noMovements": "No movements in this period.",
        "dashboardDesign.writeUpdate": "Write an update",
        "dashboardDesign.updatePrompt": "What's happening? Use @ to mention or / to link a module",
        "dashboardDesign.mentionEmployee": "Mention an employee",
        "dashboardDesign.dayOverview": "Day overview",
        "dashboardDesign.dayTasks": "All assignments for the day",
        "dashboardDesign.agendaDescription": "Work orders, activities, projects and appointments in one place.",
        "dashboardDesign.calendarHint": "Open the calendar for a complete overview and planning.",
        "dashboardDesign.viewCalendar": "View calendar",
        "dashboardDesign.timeRegistration": "Time registration",
        "dashboardDesign.hoursHint": "Register and adjust your working hours.",
        "dashboardDesign.openHours": "Register hours",
        "dashboardDesign.registeredDay": "Registered on selected day",
        "dashboardDesign.emptyHours": "No hours registered yet.",
        "dashboardDesign.noProject": "No project",
        "dashboardDesign.handbook": "Employee handbook",
        "dashboardDesign.handbookHint": "Your handbook, colleagues and incident reporting.",
        "dashboardDesign.openHandbook": "Open handbook",
        "dashboardDesign.handbookDetails": "Procedures, documentation and shared practices.",
        "dashboardDesign.colleagues": "Colleagues",
        "dashboardDesign.colleagueDetails": "Find colleagues and their contact details.",
        "dashboardDesign.tools": "Tools",
        "dashboardDesign.toolsDetails": "See the tools assigned to you.",
        "dashboardDesign.incident": "Report incident",
        "dashboardDesign.incidentDetails": "Report a health and safety incident or deviation.",
        "dashboardDesign.driving": "Driving log",
        "dashboardDesign.drivingHint": "Your current vehicle and quick access to vehicle selection.",
        "dashboardDesign.adminHint": "Quick access to administration.",
        "dashboardDesign.employees": "Employees",
        "dashboardDesign.employeesHint": "Manage users, roles and access.",
        "dashboardDesign.loadingVehicle": "Loading vehicle",
        "dashboardDesign.noVehicle": "No vehicle selected",
        "dashboardDesign.noDriver": "Not registered as a driver",
        "dashboardDesign.selectVehicle": "Open driving log and select a vehicle",
        "dashboardDesign.noDriverProfile": "No driver profile available",
        "dashboardDesign.dayAssignments": "Assignments for the day",
        "dashboardDesign.daySummary": "{{count}} assignments · {{hours}} h planned",
        "dashboardDesign.hourLines": "{{count}} entries",
        "dashboardDesign.distanceToday": "{{distance}} km driven today",
        "dashboardDesign.title": "Dashboard",
        "dashboardDesign.subtitleAdmin": "Your assignments, items needing attention and finances at a glance.",
        "dashboardDesign.subtitlePersonal": "Your assignments, hours and tasks for the day.",
        "dashboardDesign.registerHours": "Register hours",
        "dashboardDesign.newWorkOrder": "New work order",
        "dashboardDesign.newIncident": "Report incident",
        "dashboardDesign.keyFigures": "Daily overview",
        "dashboardDesign.assignments": "Your assignments",
        "dashboardDesign.plannedHours": "{{hours}} h planned",
        "dashboardDesign.service": "Service",
        "dashboardDesign.workOrders": "Work orders",
        "dashboardDesign.hours": "Hours",
        "dashboardDesign.yourDay": "Your assignments on the selected day",
        "dashboardDesign.yourHours": "Your registered hours",
        "dashboardDesign.setup": "Complete setup",
        "dashboardDesign.setupCount": "{{areas}} areas need attention · {{count}} items",
        "dashboardDesign.hide": "Hide",
        "dashboardDesign.showAll": "Show all",
        "dashboardDesign.filterDay": "Filter daily assignments",
        "dashboardDesign.all": "All",
        "dashboardDesign.date": "Choose date",
        "dashboardDesign.eventsError": "Could not load assignments.",
        "dashboardDesign.hoursError": "Could not load hours.",
        "dashboardDesign.retry": "Try again",
        "dashboardDesign.loading": "Loading…",
        "dashboardDesign.noEvents": "No assignments on this day",
        "dashboardDesign.noFilterEvents": "No assignments match this filter",
        "dashboardDesign.weekHours": "Your hours this week",
        "dashboardDesign.weekTotal": "{{hours}} h registered this week",
        "dashboardDesign.admin": "Administration",
        "dashboardDesign.theme": "Appearance",
        "dashboardDesign.light": "Light theme",
        "dashboardDesign.dark": "Dark theme",
        "dashboardDesign.visibleTo": "Visible to: {{audience}}",
        "dashboardDesign.attention": "Needs attention",
        "dashboardDesign.statsError": "Could not load follow-up items.",
        "dashboardDesign.economy": "Finances",
        "dashboardDesign.details": "View details",
        "recipients.label": "Email address",
        "recipients.count": "{{count}} recipients",
        "recipients.me": "Me",
        "recipients.channel.private_email": "Private email",
        "recipients.channel.work_email": "Work email",
        "recipients.group.customer": "Customer contacts",
        "recipients.group.team": "Our team",
        "recipients.group.other": "Other contacts",
        "recipients.placeholder": "Search contacts or enter an email address",
        "recipients.placeholderMore": "name@example.com",
        "recipients.manual": "Manual",
        "recipients.remove": "Remove {{email}}",
        "recipients.showContacts": "Show contacts",
        "recipients.add": "Add {{email}}",
        "recipients.help": "Choose from the list, or type an address and press Enter. Separate multiple addresses with commas.",
        "recipients.singleHelp": "Choose from the list, or type an address and press Enter. This send supports one recipient.",
        "recipients.singleOnly": "Choose one email address for this send.",
        "recipients.extraLimit": "You can choose multiple project contacts and one other or manual address.",
        "recipients.invalid": "Check the address: {{value}}",
        "recipients.finishInput": "Choose a contact, or finish the address with Enter before sending.",
        "recipients.loading": "Loading contacts…",
        "recipients.loadFailed": "Some contacts could not be loaded. You can still enter an address manually.",
        "recipients.retry": "Try again",
        "recipients.empty": "No contacts found. Enter a complete email address to add it manually.",
        "recipients.moreResults": "Showing up to 30 results per group. Search to find more.",
        "recipients.keyMove": "↑↓ navigate",
        "recipients.keySelect": "Enter select / add",
        "recipients.keyClose": "Esc close",

        "hse.sja.fields.required": "Complete this field.",
        "hse.sja.fields.choose_score": "Choose a value (1–5)",
        "hse.sja.fields.hazard": "Hazard",
        "hse.sja.fields.add_hazard": "Add hazard",
        "hse.sja.fields.remove_hazard": "Remove hazard",
        "hse.sja.fields.remove_step": "Remove work step",
        "hse.sja.fields.existing_measures": "Existing measures",
        "hse.sja.fields.additional_measures": "Additional measures",
        "hse.sja.fields.score": "Risk: {{likelihood}} × {{consequence}} = {{score}}",
        "hse.sja.fields.fix_errors": "Check the highlighted fields before saving.",
        "hse.sja.fields.save_unknown": "Saving could not be confirmed. Keep this page open and check the SJA list in a new tab before trying again.",

        "deviation.health.title": "Deviation notifications – delivery status",
        "deviation.health.trigger": "This setting chooses the delivery mode. Open a deviation, choose Send notification and select recipients to start delivery. New deviations are not emailed automatically.",
        "deviation.health.unverified": "Configuration was checked without sending email. Recipient delivery and operation of the scheduled job have not been verified.",
        "deviation.health.mail_unconfigured": "Email delivery is disabled or no email connection is configured. Ask an administrator to check the company email connection and server mail configuration.",
        "deviation.health.digest_overdue": "Digest deliveries are more than two hours overdue. Ask operations to check the scheduled job and queue worker.",
        "deviation.health.digest_failed": "One or more digest deliveries failed. Check the deviation send log and email connection before retrying.",
        "deviation.health.digest_inactive": "Pending digests exist, but digest delivery is no longer selected. They are not sent automatically as individual messages.",
        "deviation.health.digest_scheduler": "Digests require operations to schedule deviations:daily_digest hourly and run a worker for the mailers queue. This page cannot confirm that the job is running.",
        "deviation.health.counts": "Digest: {{pending}} pending · {{overdue}} overdue · {{failed}} failed",

        "trainingAdmin.healthTitle": trainingAdminTranslations.en["trainingAdmin.healthTitle"],
        "trainingAdmin.healthNeedsFix": trainingAdminTranslations.en["trainingAdmin.healthNeedsFix"],
        "trainingAdmin.healthSummary": trainingAdminTranslations.en["trainingAdmin.healthSummary"],
        "trainingAdmin.healthSummaryHint": trainingAdminTranslations.en["trainingAdmin.healthSummaryHint"],
        "trainingAdmin.healthShow": trainingAdminTranslations.en["trainingAdmin.healthShow"],
        "trainingAdmin.healthBlocked": trainingAdminTranslations.en["trainingAdmin.healthBlocked"],
        "trainingAdmin.healthDetails": trainingAdminTranslations.en["trainingAdmin.healthDetails"],
        "trainingAdmin.healthHelp": trainingAdminTranslations.en["trainingAdmin.healthHelp"],
        "trainingAdmin.healthChecking": trainingAdminTranslations.en["trainingAdmin.healthChecking"],
        "trainingAdmin.healthClear": trainingAdminTranslations.en["trainingAdmin.healthClear"],
        "trainingAdmin.healthProblem": trainingAdminTranslations.en["trainingAdmin.healthProblem"],
        "trainingAdmin.healthDocument": trainingAdminTranslations.en["trainingAdmin.healthDocument"],
        "trainingAdmin.healthImage": trainingAdminTranslations.en["trainingAdmin.healthImage"],
        "trainingAdmin.healthRecheck": trainingAdminTranslations.en["trainingAdmin.healthRecheck"],
        "trainingParticipant.dependencyTitle": trainingParticipantEn["trainingParticipant.dependencyTitle"],
        "trainingParticipant.dependencyHelp": trainingParticipantEn["trainingParticipant.dependencyHelp"],
        "trainingParticipant.dependencyOwner": trainingParticipantEn["trainingParticipant.dependencyOwner"],
        "trainingAdmin.jsonTools": trainingAdminTranslations.en["trainingAdmin.jsonTools"],
        "trainingAdmin.jsonContent": trainingAdminTranslations.en["trainingAdmin.jsonContent"],
        "trainingAdmin.jsonAi": trainingAdminTranslations.en["trainingAdmin.jsonAi"],
        "trainingAdmin.jsonScope": trainingAdminTranslations.en["trainingAdmin.jsonScope"],
        "trainingAdmin.jsonCopy": trainingAdminTranslations.en["trainingAdmin.jsonCopy"],
        "trainingAdmin.jsonReload": trainingAdminTranslations.en["trainingAdmin.jsonReload"],
        "trainingAdmin.jsonExample": trainingAdminTranslations.en["trainingAdmin.jsonExample"],
        "trainingAdmin.jsonImport": trainingAdminTranslations.en["trainingAdmin.jsonImport"],
        "trainingAdmin.jsonReplace": trainingAdminTranslations.en["trainingAdmin.jsonReplace"],
        "trainingAdmin.jsonAppend": trainingAdminTranslations.en["trainingAdmin.jsonAppend"],
        "trainingAdmin.jsonReplaceHint": trainingAdminTranslations.en["trainingAdmin.jsonReplaceHint"],
        "trainingAdmin.jsonAppendHint": trainingAdminTranslations.en["trainingAdmin.jsonAppendHint"],
        "trainingAdmin.jsonReview": trainingAdminTranslations.en["trainingAdmin.jsonReview"],
        "trainingAdmin.jsonReviewSummary": trainingAdminTranslations.en["trainingAdmin.jsonReviewSummary"],
        "trainingAdmin.jsonReferences": trainingAdminTranslations.en["trainingAdmin.jsonReferences"],
        "trainingAdmin.jsonApply": trainingAdminTranslations.en["trainingAdmin.jsonApply"],
        "trainingAdmin.jsonApplied": trainingAdminTranslations.en["trainingAdmin.jsonApplied"],
        "trainingAdmin.jsonReadOnly": trainingAdminTranslations.en["trainingAdmin.jsonReadOnly"],
        "trainingAdmin.jsonAiHint": trainingAdminTranslations.en["trainingAdmin.jsonAiHint"],
        "trainingAdmin.jsonCopyAi": trainingAdminTranslations.en["trainingAdmin.jsonCopyAi"],
        "trainingAdmin.jsonCopied": trainingAdminTranslations.en["trainingAdmin.jsonCopied"],
        "trainingAdmin.jsonClipboardFailed": trainingAdminTranslations.en["trainingAdmin.jsonClipboardFailed"],
        "trainingAdmin.jsonInvalid": trainingAdminTranslations.en["trainingAdmin.jsonInvalid"],
        "trainingAdmin.jsonUnsupported": trainingAdminTranslations.en["trainingAdmin.jsonUnsupported"],
        "trainingAdmin.jsonSize": trainingAdminTranslations.en["trainingAdmin.jsonSize"],
        "trainingAdmin.jsonIdentity": trainingAdminTranslations.en["trainingAdmin.jsonIdentity"],
        "trainingAdmin.jsonAnswers": trainingAdminTranslations.en["trainingAdmin.jsonAnswers"],
        "trainingAdmin.jsonDependency": trainingAdminTranslations.en["trainingAdmin.jsonDependency"],
        "trainingAdmin.jsonReference": trainingAdminTranslations.en["trainingAdmin.jsonReference"],
        "trainingAdmin.jsonAudienceInvalid": trainingAdminTranslations.en["trainingAdmin.jsonAudienceInvalid"],
        "trainingAdmin.jsonPositionsFailed": trainingAdminTranslations.en["trainingAdmin.jsonPositionsFailed"],
        "trainingAdmin.jsonPositionsLoading": trainingAdminTranslations.en["trainingAdmin.jsonPositionsLoading"],
        "trainingAdmin.jsonPositionsIncluded": trainingAdminTranslations.en["trainingAdmin.jsonPositionsIncluded"],
        "trainingAdmin.jsonDocumentsLoading": trainingAdminTranslations.en["trainingAdmin.jsonDocumentsLoading"],
        "trainingAdmin.jsonDocumentsFailed": trainingAdminTranslations.en["trainingAdmin.jsonDocumentsFailed"],
        "trainingAdmin.jsonDocumentsIncluded": trainingAdminTranslations.en["trainingAdmin.jsonDocumentsIncluded"],
        "trainingAdmin.jsonDocumentsEmpty": trainingAdminTranslations.en["trainingAdmin.jsonDocumentsEmpty"],
        "trainingAdmin.jsonIncludeExcerpts": trainingAdminTranslations.en["trainingAdmin.jsonIncludeExcerpts"],
        "trainingAdmin.jsonIncludeExcerptsHelp": trainingAdminTranslations.en["trainingAdmin.jsonIncludeExcerptsHelp"],
        "trainingAdmin.jsonDocumentUnknown": trainingAdminTranslations.en["trainingAdmin.jsonDocumentUnknown"],
        "trainingAdmin.documentAccessHint": trainingAdminTranslations.en["trainingAdmin.documentAccessHint"],
        "trainingAdmin.jsonPositionsEmpty": trainingAdminTranslations.en["trainingAdmin.jsonPositionsEmpty"],
        "trainingAdmin.jsonAudienceChanges": trainingAdminTranslations.en["trainingAdmin.jsonAudienceChanges"],
        "trainingAdmin.jsonAudienceUnchanged": trainingAdminTranslations.en["trainingAdmin.jsonAudienceUnchanged"],
        "trainingAdmin.deliveries": trainingAdminTranslations.en["trainingAdmin.deliveries"],
        "trainingAdmin.deliveryPending": trainingAdminTranslations.en["trainingAdmin.deliveryPending"],
        "trainingAdmin.deliverySending": trainingAdminTranslations.en["trainingAdmin.deliverySending"],
        "trainingAdmin.deliverySent": trainingAdminTranslations.en["trainingAdmin.deliverySent"],
        "trainingAdmin.deliveryFailed": trainingAdminTranslations.en["trainingAdmin.deliveryFailed"],
        "trainingAdmin.deliveryUnknown": trainingAdminTranslations.en["trainingAdmin.deliveryUnknown"],
        "trainingAdmin.deliveryCancelled": trainingAdminTranslations.en["trainingAdmin.deliveryCancelled"],
        "trainingAdmin.deliveryDigest": trainingAdminTranslations.en["trainingAdmin.deliveryDigest"],
        "trainingAdmin.recipient": trainingAdminTranslations.en["trainingAdmin.recipient"],
        "trainingAdmin.scheduledAt": trainingAdminTranslations.en["trainingAdmin.scheduledAt"],
        "trainingAdmin.sentAt": trainingAdminTranslations.en["trainingAdmin.sentAt"],
        "trainingAdmin.deliveryPolicy": trainingAdminTranslations.en["trainingAdmin.deliveryPolicy"],
        "trainingAdmin.deliveryNoRetry": trainingAdminTranslations.en["trainingAdmin.deliveryNoRetry"],
        "trainingAdmin.deliveryFailureHint": trainingAdminTranslations.en["trainingAdmin.deliveryFailureHint"],

        "trainingAdmin.dueBefore": trainingAdminTranslations.en["trainingAdmin.dueBefore"],
        "trainingAdmin.archive": trainingAdminTranslations.en["trainingAdmin.archive"],
        "trainingAdmin.archived": trainingAdminTranslations.en["trainingAdmin.archived"],
        "trainingAdmin.archiveInfo": trainingAdminTranslations.en["trainingAdmin.archiveInfo"],
        "trainingParticipant.reminders": trainingParticipantEn["trainingParticipant.reminders"],
        "trainingParticipant.reminderCount": trainingParticipantEn["trainingParticipant.reminderCount"],
        "trainingParticipant.snoozeReminders": trainingParticipantEn["trainingParticipant.snoozeReminders"],

        "trainingAdmin.receipt": trainingAdminTranslations.en["trainingAdmin.receipt"],
        "trainingAdmin.receiptKind": trainingAdminTranslations.en["trainingAdmin.receiptKind"],
        "trainingAdmin.cardKey": trainingAdminTranslations.en["trainingAdmin.cardKey"],
        "trainingAdmin.sourceRevision": trainingAdminTranslations.en["trainingAdmin.sourceRevision"],
        "trainingAdmin.acknowledged": trainingAdminTranslations.en["trainingAdmin.acknowledged"],
        "trainingAdmin.createdEvent": trainingAdminTranslations.en["trainingAdmin.createdEvent"],
        "trainingAdmin.savedEvent": trainingAdminTranslations.en["trainingAdmin.savedEvent"],
        "trainingAdmin.copiedEvent": trainingAdminTranslations.en["trainingAdmin.copiedEvent"],
        "trainingAdmin.publishedEvent": trainingAdminTranslations.en["trainingAdmin.publishedEvent"],
        "trainingAdmin.assignedEvent": trainingAdminTranslations.en["trainingAdmin.assignedEvent"],
        "trainingAdmin.startedEvent": trainingAdminTranslations.en["trainingAdmin.startedEvent"],
        "trainingAdmin.answeredEvent": trainingAdminTranslations.en["trainingAdmin.answeredEvent"],
        "trainingAdmin.documentOpenedEvent": trainingAdminTranslations.en["trainingAdmin.documentOpenedEvent"],
        "trainingAdmin.completedEvent": trainingAdminTranslations.en["trainingAdmin.completedEvent"],
        "trainingAdmin.extendedEvent": trainingAdminTranslations.en["trainingAdmin.extendedEvent"],
        "trainingAdmin.archivedEvent": trainingAdminTranslations.en["trainingAdmin.archivedEvent"],

        "trainingAdmin.title": trainingAdminTranslations.en["trainingAdmin.title"],
        "trainingAdmin.intro": trainingAdminTranslations.en["trainingAdmin.intro"],
        "trainingAdmin.guides": trainingAdminTranslations.en["trainingAdmin.guides"],
        "trainingAdmin.reports": trainingAdminTranslations.en["trainingAdmin.reports"],
        "trainingAdmin.audit": trainingAdminTranslations.en["trainingAdmin.audit"],
        "trainingAdmin.newGuide": trainingAdminTranslations.en["trainingAdmin.newGuide"],
        "trainingAdmin.edit": trainingAdminTranslations.en["trainingAdmin.edit"],
        "trainingAdmin.revise": trainingAdminTranslations.en["trainingAdmin.revise"],
        "trainingAdmin.copy": trainingAdminTranslations.en["trainingAdmin.copy"],
        "trainingAdmin.deactivate": trainingAdminTranslations.en["trainingAdmin.deactivate"],
        "trainingAdmin.reactivate": trainingAdminTranslations.en["trainingAdmin.reactivate"],
        "trainingAdmin.deactivateInfo": trainingAdminTranslations.en["trainingAdmin.deactivateInfo"],
        "trainingAdmin.reactivateInfo": trainingAdminTranslations.en["trainingAdmin.reactivateInfo"],
        "trainingAdmin.copyInfo": trainingAdminTranslations.en["trainingAdmin.copyInfo"],
        "trainingAdmin.saved": trainingAdminTranslations.en["trainingAdmin.saved"],
        "trainingAdmin.published": trainingAdminTranslations.en["trainingAdmin.published"],
        "trainingAdmin.updated": trainingAdminTranslations.en["trainingAdmin.updated"],
        "trainingAdmin.saving": trainingAdminTranslations.en["trainingAdmin.saving"],
        "trainingAdmin.loadError": trainingAdminTranslations.en["trainingAdmin.loadError"],
        "trainingAdmin.reload": trainingAdminTranslations.en["trainingAdmin.reload"],
        "trainingAdmin.refreshWarning": trainingAdminTranslations.en["trainingAdmin.refreshWarning"],
        "trainingAdmin.unknown": trainingAdminTranslations.en["trainingAdmin.unknown"],
        "trainingAdmin.checkStatus": trainingAdminTranslations.en["trainingAdmin.checkStatus"],
        "trainingAdmin.conflict": trainingAdminTranslations.en["trainingAdmin.conflict"],
        "trainingAdmin.loadServer": trainingAdminTranslations.en["trainingAdmin.loadServer"],
        "trainingAdmin.useServer": trainingAdminTranslations.en["trainingAdmin.useServer"],
        "trainingAdmin.serverVersion": trainingAdminTranslations.en["trainingAdmin.serverVersion"],
        "trainingAdmin.unsaved": trainingAdminTranslations.en["trainingAdmin.unsaved"],
        "trainingAdmin.discard": trainingAdminTranslations.en["trainingAdmin.discard"],
        "trainingAdmin.keepEditing": trainingAdminTranslations.en["trainingAdmin.keepEditing"],
        "trainingAdmin.leaveQuestion": trainingAdminTranslations.en["trainingAdmin.leaveQuestion"],
        "trainingAdmin.saveDraft": trainingAdminTranslations.en["trainingAdmin.saveDraft"],
        "trainingAdmin.publish": trainingAdminTranslations.en["trainingAdmin.publish"],
        "trainingAdmin.publishConfirm": trainingAdminTranslations.en["trainingAdmin.publishConfirm"],
        "trainingAdmin.publishInfo": trainingAdminTranslations.en["trainingAdmin.publishInfo"],
        "trainingAdmin.about": trainingAdminTranslations.en["trainingAdmin.about"],
        "trainingAdmin.content": trainingAdminTranslations.en["trainingAdmin.content"],
        "trainingAdmin.audience": trainingAdminTranslations.en["trainingAdmin.audience"],
        "trainingAdmin.followup": trainingAdminTranslations.en["trainingAdmin.followup"],
        "trainingAdmin.review": trainingAdminTranslations.en["trainingAdmin.review"],
        "trainingAdmin.name": trainingAdminTranslations.en["trainingAdmin.name"],
        "trainingAdmin.purpose": trainingAdminTranslations.en["trainingAdmin.purpose"],
        "trainingAdmin.minutes": trainingAdminTranslations.en["trainingAdmin.minutes"],
        "trainingAdmin.owner": trainingAdminTranslations.en["trainingAdmin.owner"],
        "trainingAdmin.selectOwner": trainingAdminTranslations.en["trainingAdmin.selectOwner"],
        "trainingAdmin.revision": trainingAdminTranslations.en["trainingAdmin.revision"],
        "trainingAdmin.changeNote": trainingAdminTranslations.en["trainingAdmin.changeNote"],
        "trainingAdmin.addPage": trainingAdminTranslations.en["trainingAdmin.addPage"],
        "trainingAdmin.page": trainingAdminTranslations.en["trainingAdmin.page"],
        "trainingAdmin.pageTitle": trainingAdminTranslations.en["trainingAdmin.pageTitle"],
        "trainingAdmin.addCard": trainingAdminTranslations.en["trainingAdmin.addCard"],
        "trainingAdmin.card": trainingAdminTranslations.en["trainingAdmin.card"],
        "trainingAdmin.cardTitle": trainingAdminTranslations.en["trainingAdmin.cardTitle"],
        "trainingAdmin.cardType": trainingAdminTranslations.en["trainingAdmin.cardType"],
        "trainingAdmin.body": trainingAdminTranslations.en["trainingAdmin.body"],
        "trainingAdmin.contentType": trainingAdminTranslations.en["trainingAdmin.contentType"],
        "trainingAdmin.acknowledgementType": trainingAdminTranslations.en["trainingAdmin.acknowledgementType"],
        "trainingAdmin.singleType": trainingAdminTranslations.en["trainingAdmin.singleType"],
        "trainingAdmin.multipleType": trainingAdminTranslations.en["trainingAdmin.multipleType"],
        "trainingAdmin.documentType": trainingAdminTranslations.en["trainingAdmin.documentType"],
        "trainingAdmin.required": trainingAdminTranslations.en["trainingAdmin.required"],
        "trainingAdmin.options": trainingAdminTranslations.en["trainingAdmin.options"],
        "trainingAdmin.addOption": trainingAdminTranslations.en["trainingAdmin.addOption"],
        "trainingAdmin.correct": trainingAdminTranslations.en["trainingAdmin.correct"],
        "trainingAdmin.explanation": trainingAdminTranslations.en["trainingAdmin.explanation"],
        "trainingAdmin.moveUp": trainingAdminTranslations.en["trainingAdmin.moveUp"],
        "trainingAdmin.moveDown": trainingAdminTranslations.en["trainingAdmin.moveDown"],
        "trainingAdmin.remove": trainingAdminTranslations.en["trainingAdmin.remove"],
        "trainingAdmin.dependency": trainingAdminTranslations.en["trainingAdmin.dependency"],
        "trainingAdmin.imageAlt": trainingAdminTranslations.en["trainingAdmin.imageAlt"],
        "trainingAdmin.saveBeforeImage": trainingAdminTranslations.en["trainingAdmin.saveBeforeImage"],
        "trainingAdmin.imageReady": trainingAdminTranslations.en["trainingAdmin.imageReady"],
        "trainingAdmin.document": trainingAdminTranslations.en["trainingAdmin.document"],
        "trainingAdmin.documentSearch": trainingAdminTranslations.en["trainingAdmin.documentSearch"],
        "trainingAdmin.noDocuments": trainingAdminTranslations.en["trainingAdmin.noDocuments"],
        "trainingAdmin.boundVersion": trainingAdminTranslations.en["trainingAdmin.boundVersion"],
        "trainingAdmin.readRequired": trainingAdminTranslations.en["trainingAdmin.readRequired"],
        "trainingAdmin.allUsers": trainingAdminTranslations.en["trainingAdmin.allUsers"],
        "trainingAdmin.positions": trainingAdminTranslations.en["trainingAdmin.positions"],
        "trainingAdmin.namedUsers": trainingAdminTranslations.en["trainingAdmin.namedUsers"],
        "trainingAdmin.audienceHint": trainingAdminTranslations.en["trainingAdmin.audienceHint"],
        "trainingAdmin.searchPeople": trainingAdminTranslations.en["trainingAdmin.searchPeople"],
        "trainingAdmin.requirement": trainingAdminTranslations.en["trainingAdmin.requirement"],
        "trainingAdmin.immediate": trainingAdminTranslations.en["trainingAdmin.immediate"],
        "trainingAdmin.deadline": trainingAdminTranslations.en["trainingAdmin.deadline"],
        "trainingAdmin.optional": trainingAdminTranslations.en["trainingAdmin.optional"],
        "trainingAdmin.newUsersOnly": trainingAdminTranslations.en["trainingAdmin.newUsersOnly"],
        "trainingAdmin.newUsersOnlyHint": trainingAdminTranslations.en["trainingAdmin.newUsersOnlyHint"],
        "trainingAdmin.newUsersImmediateWarning": trainingAdminTranslations.en["trainingAdmin.newUsersImmediateWarning"],
        "trainingAdmin.deadlineType": trainingAdminTranslations.en["trainingAdmin.deadlineType"],
        "trainingAdmin.fixedDate": trainingAdminTranslations.en["trainingAdmin.fixedDate"],
        "trainingAdmin.relativeDays": trainingAdminTranslations.en["trainingAdmin.relativeDays"],
        "trainingAdmin.dueAt": trainingAdminTranslations.en["trainingAdmin.dueAt"],
        "trainingAdmin.dueDays": trainingAdminTranslations.en["trainingAdmin.dueDays"],
        "trainingAdmin.snooze": trainingAdminTranslations.en["trainingAdmin.snooze"],
        "trainingAdmin.immediateWarning": trainingAdminTranslations.en["trainingAdmin.immediateWarning"],
        "trainingAdmin.overdueWarning": trainingAdminTranslations.en["trainingAdmin.overdueWarning"],
        "trainingAdmin.emailOptIn": trainingAdminTranslations.en["trainingAdmin.emailOptIn"],
        "trainingAdmin.emailHint": trainingAdminTranslations.en["trainingAdmin.emailHint"],
        "trainingAdmin.cadence": trainingAdminTranslations.en["trainingAdmin.cadence"],
        "trainingAdmin.daily": trainingAdminTranslations.en["trainingAdmin.daily"],
        "trainingAdmin.weekly": trainingAdminTranslations.en["trainingAdmin.weekly"],
        "trainingAdmin.events": trainingAdminTranslations.en["trainingAdmin.events"],
        "trainingAdmin.completed": trainingAdminTranslations.en["trainingAdmin.completed"],
        "trainingAdmin.overdue": trainingAdminTranslations.en["trainingAdmin.overdue"],
        "trainingAdmin.blocked": trainingAdminTranslations.en["trainingAdmin.blocked"],
        "trainingAdmin.preview": trainingAdminTranslations.en["trainingAdmin.preview"],
        "trainingAdmin.desktop": trainingAdminTranslations.en["trainingAdmin.desktop"],
        "trainingAdmin.mobile": trainingAdminTranslations.en["trainingAdmin.mobile"],
        "trainingAdmin.previewHint": trainingAdminTranslations.en["trainingAdmin.previewHint"],
        "trainingAdmin.impact": trainingAdminTranslations.en["trainingAdmin.impact"],
        "trainingAdmin.reviewImpact": trainingAdminTranslations.en["trainingAdmin.reviewImpact"],
        "trainingAdmin.affectedUsers": trainingAdminTranslations.en["trainingAdmin.affectedUsers"],
        "trainingAdmin.withoutPosition": trainingAdminTranslations.en["trainingAdmin.withoutPosition"],
        "trainingAdmin.changedCards": trainingAdminTranslations.en["trainingAdmin.changedCards"],
        "trainingAdmin.carriedCards": trainingAdminTranslations.en["trainingAdmin.carriedCards"],
        "trainingAdmin.removedCards": trainingAdminTranslations.en["trainingAdmin.removedCards"],
        "trainingAdmin.dependencyProblems": trainingAdminTranslations.en["trainingAdmin.dependencyProblems"],
        "trainingAdmin.acknowledgeImpact": trainingAdminTranslations.en["trainingAdmin.acknowledgeImpact"],
        "trainingAdmin.saveForReview": trainingAdminTranslations.en["trainingAdmin.saveForReview"],
        "trainingAdmin.emptyGuides": trainingAdminTranslations.en["trainingAdmin.emptyGuides"],
        "trainingAdmin.emptyHint": trainingAdminTranslations.en["trainingAdmin.emptyHint"],
        "trainingAdmin.noResults": trainingAdminTranslations.en["trainingAdmin.noResults"],
        "trainingAdmin.status": trainingAdminTranslations.en["trainingAdmin.status"],
        "trainingAdmin.draft": trainingAdminTranslations.en["trainingAdmin.draft"],
        "trainingAdmin.active": trainingAdminTranslations.en["trainingAdmin.active"],
        "trainingAdmin.inactive": trainingAdminTranslations.en["trainingAdmin.inactive"],
        "trainingAdmin.notStarted": trainingAdminTranslations.en["trainingAdmin.notStarted"],
        "trainingAdmin.inProgress": trainingAdminTranslations.en["trainingAdmin.inProgress"],
        "trainingAdmin.snoozed": trainingAdminTranslations.en["trainingAdmin.snoozed"],
        "trainingAdmin.exempt": trainingAdminTranslations.en["trainingAdmin.exempt"],
        "trainingAdmin.withdrawn": trainingAdminTranslations.en["trainingAdmin.withdrawn"],
        "trainingAdmin.user": trainingAdminTranslations.en["trainingAdmin.user"],
        "trainingAdmin.guide": trainingAdminTranslations.en["trainingAdmin.guide"],
        "trainingAdmin.progress": trainingAdminTranslations.en["trainingAdmin.progress"],
        "trainingAdmin.actions": trainingAdminTranslations.en["trainingAdmin.actions"],
        "trainingAdmin.perGuide": trainingAdminTranslations.en["trainingAdmin.perGuide"],
        "trainingAdmin.perUser": trainingAdminTranslations.en["trainingAdmin.perUser"],
        "trainingAdmin.exportCsv": trainingAdminTranslations.en["trainingAdmin.exportCsv"],
        "trainingAdmin.exportPdf": trainingAdminTranslations.en["trainingAdmin.exportPdf"],
        "trainingAdmin.details": trainingAdminTranslations.en["trainingAdmin.details"],
        "trainingAdmin.giveExemption": trainingAdminTranslations.en["trainingAdmin.giveExemption"],
        "trainingAdmin.extendDeadline": trainingAdminTranslations.en["trainingAdmin.extendDeadline"],
        "trainingAdmin.reason": trainingAdminTranslations.en["trainingAdmin.reason"],
        "trainingAdmin.exemptionInfo": trainingAdminTranslations.en["trainingAdmin.exemptionInfo"],
        "trainingAdmin.at": trainingAdminTranslations.en["trainingAdmin.at"],
        "trainingAdmin.actor": trainingAdminTranslations.en["trainingAdmin.actor"],
        "trainingAdmin.event": trainingAdminTranslations.en["trainingAdmin.event"],
        "trainingAdmin.attempt": trainingAdminTranslations.en["trainingAdmin.attempt"],
        "trainingAdmin.response": trainingAdminTranslations.en["trainingAdmin.response"],
        "trainingAdmin.correctResult": trainingAdminTranslations.en["trainingAdmin.correctResult"],
        "trainingAdmin.incorrectResult": trainingAdminTranslations.en["trainingAdmin.incorrectResult"],
        "trainingAdmin.carried": trainingAdminTranslations.en["trainingAdmin.carried"],
        "trainingAdmin.previous": trainingAdminTranslations.en["trainingAdmin.previous"],
        "trainingAdmin.next": trainingAdminTranslations.en["trainingAdmin.next"],
        "trainingAdmin.cancel": trainingAdminTranslations.en["trainingAdmin.cancel"],
        "trainingAdmin.close": trainingAdminTranslations.en["trainingAdmin.close"],
        "trainingAdmin.confirm": trainingAdminTranslations.en["trainingAdmin.confirm"],
        "trainingAdmin.readOnly": trainingAdminTranslations.en["trainingAdmin.readOnly"],
        "trainingAdmin.priceOnRequest": trainingAdminTranslations.en["trainingAdmin.priceOnRequest"],
        "trainingAdmin.commercialActivation": trainingAdminTranslations.en["trainingAdmin.commercialActivation"],
        "trainingAdmin.responsibleReports": trainingAdminTranslations.en["trainingAdmin.responsibleReports"],
        "trainingAdmin.validationTitle": trainingAdminTranslations.en["trainingAdmin.validationTitle"],
        "trainingAdmin.validationCards": trainingAdminTranslations.en["trainingAdmin.validationCards"],
        "trainingAdmin.validationAnswer": trainingAdminTranslations.en["trainingAdmin.validationAnswer"],
        "trainingAdmin.validationAudience": trainingAdminTranslations.en["trainingAdmin.validationAudience"],
        "trainingAdmin.validationDocument": trainingAdminTranslations.en["trainingAdmin.validationDocument"],
        "trainingAdmin.validationImage": trainingAdminTranslations.en["trainingAdmin.validationImage"],
        "trainingAdmin.validationReason": trainingAdminTranslations.en["trainingAdmin.validationReason"],
        "trainingParticipant.title": trainingParticipantEn["trainingParticipant.title"],
        "trainingAdmin.snoozeBeforeDeadline": trainingAdminTranslations.en["trainingAdmin.snoozeBeforeDeadline"],
        "trainingAdmin.mandatorySnooze": trainingAdminTranslations.en["trainingAdmin.mandatorySnooze"],
        "trainingAdmin.mandatorySnoozeHint": trainingAdminTranslations.en["trainingAdmin.mandatorySnoozeHint"],
        "trainingParticipant.mandatoryDeferHint": trainingParticipantEn["trainingParticipant.mandatoryDeferHint"],
        "trainingParticipant.mandatoryDeferValidation": trainingParticipantEn["trainingParticipant.mandatoryDeferValidation"],
        "trainingParticipant.adminDefer": trainingParticipantEn["trainingParticipant.adminDefer"],
        "trainingParticipant.adminDeferShort": trainingParticipantEn["trainingParticipant.adminDeferShort"],
        "trainingParticipant.adminDeferHint": trainingParticipantEn["trainingParticipant.adminDeferHint"],
        "trainingParticipant.adminDeferProgress": trainingParticipantEn["trainingParticipant.adminDeferProgress"],
        "trainingParticipant.adminDeferChoiceHint": trainingParticipantEn["trainingParticipant.adminDeferChoiceHint"],
        "trainingParticipant.adminDeferValidation": trainingParticipantEn["trainingParticipant.adminDeferValidation"],
        "trainingParticipant.creatorApproved": trainingParticipantEn["trainingParticipant.creatorApproved"],
        "trainingParticipant.creatorApprovalStatement": trainingParticipantEn["trainingParticipant.creatorApprovalStatement"],
        "trainingParticipant.requiredDialogTitle": trainingParticipantEn["trainingParticipant.requiredDialogTitle"],
        "trainingParticipant.requiredDialogIntro": trainingParticipantEn["trainingParticipant.requiredDialogIntro"],
        "trainingParticipant.goToTraining": trainingParticipantEn["trainingParticipant.goToTraining"],
        "trainingParticipant.openGuide": trainingParticipantEn["trainingParticipant.openGuide"],
        "trainingParticipant.showRequirements": trainingParticipantEn["trainingParticipant.showRequirements"],
        "trainingParticipant.intro": trainingParticipantEn["trainingParticipant.intro"],
        "trainingParticipant.gateIntro": trainingParticipantEn["trainingParticipant.gateIntro"],
        "trainingParticipant.requiredCount": trainingParticipantEn["trainingParticipant.requiredCount"],
        "trainingParticipant.completedCount": trainingParticipantEn["trainingParticipant.completedCount"],
        "trainingParticipant.assignments": trainingParticipantEn["trainingParticipant.assignments"],
        "trainingParticipant.history": trainingParticipantEn["trainingParticipant.history"],
        "trainingParticipant.group.required": trainingParticipantEn["trainingParticipant.group.required"],
        "trainingParticipant.group.deadline": trainingParticipantEn["trainingParticipant.group.deadline"],
        "trainingParticipant.group.optional": trainingParticipantEn["trainingParticipant.group.optional"],
        "trainingParticipant.group.recommended": trainingParticipantEn["trainingParticipant.group.recommended"],
        "trainingParticipant.group.completed": trainingParticipantEn["trainingParticipant.group.completed"],
        "trainingParticipant.status.not_started": trainingParticipantEn["trainingParticipant.status.not_started"],
        "trainingParticipant.status.assigned": trainingParticipantEn["trainingParticipant.status.assigned"],
        "trainingParticipant.status.in_progress": trainingParticipantEn["trainingParticipant.status.in_progress"],
        "trainingParticipant.status.completed": trainingParticipantEn["trainingParticipant.status.completed"],
        "trainingParticipant.status.passed": trainingParticipantEn["trainingParticipant.status.passed"],
        "trainingParticipant.status.snoozed": trainingParticipantEn["trainingParticipant.status.snoozed"],
        "trainingParticipant.status.overdue": trainingParticipantEn["trainingParticipant.status.overdue"],
        "trainingParticipant.status.exempt": trainingParticipantEn["trainingParticipant.status.exempt"],
        "trainingParticipant.status.withdrawn": trainingParticipantEn["trainingParticipant.status.withdrawn"],
        "trainingParticipant.status.blocked_dependency": trainingParticipantEn["trainingParticipant.status.blocked_dependency"],
        "trainingParticipant.progress": trainingParticipantEn["trainingParticipant.progress"],
        "trainingParticipant.due": trainingParticipantEn["trainingParticipant.due"],
        "trainingParticipant.snoozedUntil": trainingParticipantEn["trainingParticipant.snoozedUntil"],
        "trainingParticipant.start": trainingParticipantEn["trainingParticipant.start"],
        "trainingParticipant.continue": trainingParticipantEn["trainingParticipant.continue"],
        "trainingParticipant.view": trainingParticipantEn["trainingParticipant.view"],
        "trainingParticipant.snooze": trainingParticipantEn["trainingParticipant.snooze"],
        "trainingParticipant.snoozeHint": trainingParticipantEn["trainingParticipant.snoozeHint"],
        "trainingParticipant.remindAt": trainingParticipantEn["trainingParticipant.remindAt"],
        "trainingParticipant.saveReminder": trainingParticipantEn["trainingParticipant.saveReminder"],
        "trainingParticipant.snoozeValidation": trainingParticipantEn["trainingParticipant.snoozeValidation"],
        "trainingParticipant.subscriptionInactive": trainingParticipantEn["trainingParticipant.subscriptionInactive"],
        "trainingParticipant.noAssignments": trainingParticipantEn["trainingParticipant.noAssignments"],
        "trainingParticipant.noHistory": trainingParticipantEn["trainingParticipant.noHistory"],
        "trainingParticipant.guide": trainingParticipantEn["trainingParticipant.guide"],
        "trainingParticipant.revisionLabel": trainingParticipantEn["trainingParticipant.revisionLabel"],
        "trainingParticipant.completedAt": trainingParticipantEn["trainingParticipant.completedAt"],
        "trainingParticipant.receipt": trainingParticipantEn["trainingParticipant.receipt"],
        "trainingParticipant.loading": trainingParticipantEn["trainingParticipant.loading"],
        "trainingParticipant.saving": trainingParticipantEn["trainingParticipant.saving"],
        "trainingParticipant.saved": trainingParticipantEn["trainingParticipant.saved"],
        "trainingParticipant.savedRefreshFailed": trainingParticipantEn["trainingParticipant.savedRefreshFailed"],
        "trainingParticipant.loadFailed": trainingParticipantEn["trainingParticipant.loadFailed"],
        "trainingParticipant.revisionChanged": trainingParticipantEn["trainingParticipant.revisionChanged"],
        "trainingParticipant.accessChanged": trainingParticipantEn["trainingParticipant.accessChanged"],
        "trainingParticipant.unknownOutcome": trainingParticipantEn["trainingParticipant.unknownOutcome"],
        "trainingParticipant.sameAttempt": trainingParticipantEn["trainingParticipant.sameAttempt"],
        "trainingParticipant.statusFailed": trainingParticipantEn["trainingParticipant.statusFailed"],
        "trainingParticipant.checkStatus": trainingParticipantEn["trainingParticipant.checkStatus"],
        "trainingParticipant.retrySame": trainingParticipantEn["trainingParticipant.retrySame"],
        "trainingParticipant.refresh": trainingParticipantEn["trainingParticipant.refresh"],
        "trainingParticipant.back": trainingParticipantEn["trainingParticipant.back"],
        "trainingParticipant.next": trainingParticipantEn["trainingParticipant.next"],
        "trainingParticipant.close": trainingParticipantEn["trainingParticipant.close"],
        "trainingParticipant.finish": trainingParticipantEn["trainingParticipant.finish"],
        "trainingParticipant.revision": trainingParticipantEn["trainingParticipant.revision"],
        "trainingParticipant.pageCount": trainingParticipantEn["trainingParticipant.pageCount"],
        "trainingParticipant.revisionProgress": trainingParticipantEn["trainingParticipant.revisionProgress"],
        "trainingParticipant.carried": trainingParticipantEn["trainingParticipant.carried"],
        "trainingParticipant.multipleHint": trainingParticipantEn["trainingParticipant.multipleHint"],
        "trainingParticipant.singleHint": trainingParticipantEn["trainingParticipant.singleHint"],
        "trainingParticipant.readDocument": trainingParticipantEn["trainingParticipant.readDocument"],
        "trainingParticipant.moreInformation": trainingParticipantEn["trainingParticipant.moreInformation"],
        "trainingParticipant.confirmContent": trainingParticipantEn["trainingParticipant.confirmContent"],
        "trainingParticipant.answerPassed": trainingParticipantEn["trainingParticipant.answerPassed"],
        "trainingParticipant.answerIncorrect": trainingParticipantEn["trainingParticipant.answerIncorrect"],
        "trainingParticipant.checkAnswer": trainingParticipantEn["trainingParticipant.checkAnswer"],
        "trainingParticipant.confirm": trainingParticipantEn["trainingParticipant.confirm"],
        "trainingParticipant.completed": trainingParticipantEn["trainingParticipant.completed"],
        "trainingParticipant.completionStatement": trainingParticipantEn["trainingParticipant.completionStatement"],
        "trainingParticipant.emptyGuide": trainingParticipantEn["trainingParticipant.emptyGuide"],
        "trainingParticipant.previewNotice": trainingParticipantEn["trainingParticipant.previewNotice"],
        "trainingParticipant.previewImage": trainingParticipantEn["trainingParticipant.previewImage"],
        "trainingParticipant.imageFailed": trainingParticipantEn["trainingParticipant.imageFailed"],
        "trainingParticipant.document": trainingParticipantEn["trainingParticipant.document"],
        "trainingParticipant.backToGuide": trainingParticipantEn["trainingParticipant.backToGuide"],
        "trainingParticipant.documentRevision": trainingParticipantEn["trainingParticipant.documentRevision"],
        "trainingParticipant.documentFailed": trainingParticipantEn["trainingParticipant.documentFailed"],
        "trainingParticipant.textAlternative": trainingParticipantEn["trainingParticipant.textAlternative"],
        "trainingParticipant.documentPages": trainingParticipantEn["trainingParticipant.documentPages"],
        "trainingParticipant.readUnderstood": trainingParticipantEn["trainingParticipant.readUnderstood"],
        "trainingParticipant.confirmReading": trainingParticipantEn["trainingParticipant.confirmReading"],
        "trainingParticipant.previewConfirm": trainingParticipantEn["trainingParticipant.previewConfirm"],
        "trainingParticipant.cardNumber": trainingParticipantEn["trainingParticipant.cardNumber"],
        "trainingParticipant.carriedReceipt": trainingParticipantEn["trainingParticipant.carriedReceipt"],
        "trainingParticipant.confirmedReceipt": trainingParticipantEn["trainingParticipant.confirmedReceipt"],
        "trainingParticipant.recovery": trainingParticipantEn["trainingParticipant.recovery"],
        "trainingParticipant.adminRecovery": trainingParticipantEn["trainingParticipant.adminRecovery"],
        "trainingParticipant.checkingRequirements": trainingParticipantEn["trainingParticipant.checkingRequirements"],
        "trainingParticipant.gateFailed": trainingParticipantEn["trainingParticipant.gateFailed"],
        "trainingParticipant.gateRecovery": trainingParticipantEn["trainingParticipant.gateRecovery"],

        "serviceReminders.title": "Automatic appointment reminders",
        "serviceReminders.intro": "Choose when and how to remind the customer. All channels are off by default.",
        "serviceReminders.visit": "Before confirmed service",
        "serviceReminders.visitHint": "Remind the customer about an upcoming confirmed service visit.",
        "serviceReminders.visitDays": "days before the appointment",
        "serviceReminders.confirmation": "Awaiting confirmation",
        "serviceReminders.confirmationHint": "Follow up a sent appointment that the customer has not confirmed.",
        "serviceReminders.confirmationDays": "days after the appointment was sent",
        "serviceReminders.sms": "SMS",
        "serviceReminders.email": "Email",
        "serviceReminders.once": "One reminder per appointment and channel. Rescheduling may trigger a new reminder. Nothing is sent on or after the appointment date.",
        "serviceReminders.save": "Save reminders",
        "serviceReminders.invalidDays": "Enter a whole number of days from 1 to 365.",
        "serviceReminders.unknown": "We could not confirm the save. Reload saved settings before trying again.",
        "serviceReminders.reload": "Reload saved settings",
        "serviceReminders.disabledHint": "No channel selected means the reminder is off.",
        "serviceReminders.history": "Appointment reminder",
        "serviceReminders.state.sent": "Sent",
        "serviceReminders.state.sending": "Sending started – result not confirmed",
        "serviceReminders.state.unknown": "Uncertain – no resend without conclusive evidence",
        "serviceReminders.state.retrying": "Not sent – retry scheduled",
        "serviceReminders.state.connection_required": "Check the connection to the company mailbox",
        "serviceReminders.state.lookup_unavailable": "Delivery status is temporarily unavailable",
        "serviceReminders.state.failed": "Not sent – automatic attempts finished",
        "serviceReminders.state.skipped": "Not sent",
        "histories.action.service_appointment_reminder": "Appointment reminder",
        "collaboration.changed.order": "This order has new changes",
        "collaboration.changed.calculation": "This calculation has new changes",
        "collaboration.changed.meeting_minutes_meeting": "This meeting has new changes",
        "collaboration.changed.project_plan": "The project plan has new changes",
        "collaboration.title": "Collaboration",
        "collaboration.live": "Live updates connected",
        "collaboration.offline": "Live updates unavailable – check the latest version before saving",
        "collaboration.viewing": "viewing",
        "collaboration.editing": "editing",
        "collaboration.away": "away",
        "collaboration.changed": "This report has new changes",
        "collaboration.reviewNeeded": "Check the latest version before trying again",
        "collaboration.keepDraft": "Your draft is preserved. Check the latest version before continuing to save.",
        "collaboration.minimize": "Minimize notification",
        "collaboration.reload": "Load latest version",
        "collaboration.discardWarning": "Reloading discards unsaved changes on this page and in open dialogs. Copy any text you want to keep before continuing.",
        "collaboration.keepEditing": "Keep draft",
        "collaboration.confirmReload": "Discard draft and reload",
        "collaboration.section.overview": "Overview",
        "collaboration.section.info": "Information",
        "collaboration.section.report": "Report text",
        "collaboration.section.checklist": "Checklist",
        "collaboration.section.items": "Items",
        "collaboration.section.hours": "Hours",
        "collaboration.section.variables": "Variables",
        "collaboration.section.price": "Price lines",
        "collaboration.section.team": "Team",
        "collaboration.section.status": "Status",
        "collaboration.section.agenda": "Agenda",
        "collaboration.section.plan": "Plan",
        "collaboration.section.resources": "Resources",
        "reportWizard.details": "Details",
        "reportWizard.review": "Review",
        "reportWizard.eyebrow": "New service report",
        "reportWizard.subtitle": "Choose a type, fill in the details and review before the report is created.",
        "reportWizard.section.parties": "Customer and project",
        "reportWizard.section.partiesHint": "Who the report is for and where it belongs.",
        "reportWizard.section.job": "Job",
        "reportWizard.section.jobHint": "Date, facility and checklist for the job.",
        "reportWizard.section.text": "Descriptions",
        "reportWizard.section.textHint": "Text the customer sees, and internal notes.",
        "reportWizard.section.addressHint": "Where the job is done. Defaults to the customer's address.",
        "reportWizard.section.billingHint": "Optional. Invoice recipient and project finances.",
        "pickers.system.placeholder": "Select facility",
        "pickers.system.needsCustomer": "Select a customer first",
        "pickers.system.search": "Search product, serial number or placement",
        "pickers.system.empty": "The customer has no facilities yet",
        "pickers.system.create": "New facility",
        "pickers.address.placeholder": "Select job address",
        "pickers.address.search": "Search name or address",
        "pickers.address.filterCompany": "Company",
        "pickers.address.filterProject": "Project",
        "pickers.address.filterCustomer": "Customer's",
        "pickers.address.filterAll": "All",
        "pickers.address.empty": "No addresses in this selection",
        "pickers.address.create": "New address",
        "pickers.address.companyPostal": "Postal address",
        "pickers.address.companyPhysical": "Visiting address",
        "pickers.address.companyPostalAndPhysical": "Postal and visiting address",
        "pickers.search": "Search …",
        "pickers.clear": "Clear selection",
        "pickers.clearSearch": "Clear search",
        "pickers.filters": "Filter",
        "pickers.empty": "No matches",
        "pickers.emptyQuery": "No matches for “{{query}}”",
        "pickers.loadFailed": "Could not load the list.",
        "pickers.retry": "Try again",
        "pickers.moreResults": "Showing the first {{count}}. Search to narrow down.",
        "pickers.hintMove": "↑↓ move",
        "pickers.hintSelect": "↵ select",
        "pickers.hintClose": "esc close",
        "pickers.customer.placeholder": "Select customer",
        "pickers.customer.search": "Search name, customer number or address",
        "pickers.customer.filterAll": "All",
        "pickers.customer.filterCompany": "Company",
        "pickers.customer.filterPrivate": "Private",
        "pickers.customer.create": "New customer",
        "pickers.project.placeholder": "Select project",
        "pickers.project.search": "Search name or project number",
        "pickers.project.filterCustomer": "Customer's",
        "pickers.project.filterActive": "Active",
        "pickers.project.filterInactive": "Closed",
        "pickers.project.empty": "No projects in this selection",
        "pickers.contact.placeholder": "Select contact",
        "pickers.contact.search": "Search name, email or phone",
        "pickers.contact.filterCustomer": "Customer's",
        "pickers.contact.filterAll": "All",
        "pickers.contact.empty": "No contacts in this selection",
        "pickers.contact.create": "New contact",
        "pickers.folder.label": "Folder",
        "pickers.folder.placeholder": "Select folder",
        "pickers.folder.needsProject": "Select a project first",
        "pickers.folder.search": "Search folders",
        "pickers.folder.empty": "The project has no folders",
        "reportWizard.invoiceCustomer": "Invoice customer",
        "reportWizard.intro": "Create a report, step by step",
        "reportWizard.typeHint": "Choose the report type for this job and review its recommended settings.",
        "reportWizard.typeRange": "Showing {{from}}–{{to}} of {{total}} types",
        "reportWizard.previousTypes": "Previous types",
        "reportWizard.nextTypes": "Next types",
        "reportWizard.selectedType": "Selected type: {{title}}",
        "reportWizard.searchTypes": "Search report types",
        "reportWizard.noResults": "No matches. Try another search.",
        "reportWizard.loadFailed": "Could not load the options.",
        "reportWizard.template": "Use as template",
        "reportWizard.suggestion": "Show as suggestions",
        "reportWizard.recommended": "Recommended settings",
        "reportWizard.applyDefaults": "Use recommended settings",
        "reportWizard.preserveEdits": "Fills fields you have not edited. Your own text and choices are preserved.",
        "reportWizard.noChecklist": "No preset checklist",
        "reportWizard.searchChecklist": "Search checklist templates",
        "reportWizard.internalDescription": "Internal description",
        "reportWizard.customerVisible": "Visible to the customer.",
        "reportWizard.internalOnly": "Visible internally only.",
        "reportWizard.applied": "Recommended settings applied",
        "reportWizard.manual": "Custom settings",
        "reportWizard.billingOptions": "Billing and project finances",
        "reportWizard.reviewHint": "Check the details. The report is created only when you confirm below.",
        "reportWizard.afterCreate": "After creation, complete the checklist and add hours, items, price lines and documents in the report.",
        "reportWizard.create": "Create report",
        "reportWizard.unknown": "We could not confirm whether the report was created. Check the report list before trying again.",
        "reportWizard.unknownType": "We could not confirm the save. Close and reload the report type before trying again.",
        "reportWizard.refreshFailed": "The report was created, but its link or view refresh could not be confirmed. Do not create it again.",
        "reportWizard.saved": "The report was created.",
        "reportWizard.openReport": "Open report",
        "reportWizard.settingsHint": "These fields are used when creating reports. Existing reports are unchanged. The type description above is guidance only.",
        "reportWizard.application": "Apply on creation",
        "reportWizard.defaultChecklist": "Recommended checklist template",
        "reportWizard.enableChecklist": "Enable Checklist below to use this template when creating a report.",
        "reportWizard.defaultDescription": "Default report description",
        "reportWizard.defaultInternalDescription": "Default internal description",
        "reportWizard.module.checklist": "Checklist",
        "reportWizard.module.items": "Items",
        "reportWizard.module.hours": "Hours",
        "reportWizard.module.variables": "Variables",
        "reportWizard.module.system": "Facility",
        "reportWizard.module.agreement": "Agreement",
        "reportWizard.type": "Report type",
        "reportWizard.next": "Next",
        "reportWizard.orderDate": "Order date",
        "reportWizard.useCustomerAddress": "Use customer address",
        "reportWizard.deliveryAddress": "Delivery address",
        "reportWizard.system": "Facility",
        "reportWizard.loading": "Loading…",
        "reportWizard.retry": "Retry",









































        "serviceSettings.title": "Service settings",
        "serviceSettings.hour_product": "Default service hour product",
        "serviceSettings.product": "Product",
        "serviceSettings.search_label": "Search",
        "serviceSettings.previous": "Previous",
        "serviceSettings.next": "Next",
        "serviceSettings.name": "Name",
        "serviceSettings.interval": "Interval",
        "serviceSettings.report_type": "Report type",
        "serviceSettings.agreement_type": "Agreement type",
        "serviceSettings.agreement_start_date": "Agreement start date",
        "serviceSettings.title_no_ampersand": "Title cannot include the '&' symbol",
        "serviceSettings.description": "Description",
        "serviceSettings.conditions": "Terms",
        "serviceSettings.active": "Active",
        "serviceSettings.system": "Facility",
        "serviceSettings.simple_report": "Simple report",
        "serviceSettings.agreement": "Agreement",
        "serviceSettings.items": "Items",
        "serviceSettings.checklist": "Checklist",
        "serviceSettings.hours": "Hours",
        "serviceSettings.variables": "Variables",
        "itemListDetail.change_product": "Change product",
        "serviceSettings.eyebrow": "Service / settings",
        "serviceSettings.intro": "Manage agreement types, reports and defaults for your service team.",
        "serviceSettings.types": "Types and report guides",
        "serviceSettings.general": "General",
        "serviceSettings.agreement_hint": "Terms and report defaults used when creating service agreements.",
        "serviceSettings.report_hint": "Choose the content and features available in each report type.",
        "serviceSettings.variable_hint": "Name measurements and other variables used in reports.",
        "serviceSettings.search": "Search types…",
        "serviceSettings.no_results": "No matches",
        "serviceSettings.search_hint": "Try another search term.",
        "serviceSettings.empty": "No types yet",
        "serviceSettings.empty_hint": "Add your first type to get started.",
        "serviceSettings.load_failed": "Could not load settings.",
        "serviceSettings.save_failed": "Could not save. Check the fields and try again.",
        "serviceSettings.unknown": "The save could not be confirmed. Reload the page and check the result before trying again.",
        "serviceSettings.saved_type": "“{{title}}” was saved.",
        "serviceSettings.create_reports": "Create reports when performing service",
        "serviceSettings.mission_hint": "Create both a report and an order when performing the agreement. When off, only an order is created.",
        "serviceSettings.report_content": "Report content and availability",
        "serviceSettings.notifications": "Report notifications",
        "serviceSettings.notifications_hint": "Choose who is notified when a report is completed.",
        "serviceSettings.email": "Email for completed reports",
        "serviceSettings.product_hint": "The default product used when recording service hours.",
        "serviceSettings.conditions_hint": "Default terms included in agreement confirmation emails.",
        "serviceSettings.unsaved": "You have unsaved changes.",
        "serviceSettings.save_hint": "Use Save settings to apply your changes.",
        "serviceSettings.save": "Save settings",
        "serviceSettings.no_access": "You do not have access to service settings.",
        "itemListDetail.heading": "Material consumption",
        "itemListDetail.pick_date": "Pick date",
        "itemListDetail.save_date": "Save date",
        "itemListDetail.eyebrow": "Project / materials",
        "itemListDetail.back": "Back to project",
        "itemListDetail.refresh": "Refresh",
        "itemListDetail.pdf": "Download PDF",
        "itemListDetail.pdf_failed": "Could not download PDF. Try again.",
        "itemListDetail.pdf_ready": "PDF is ready to download.",
        "itemListDetail.load_failed": "Could not load the list. Select Refresh to try again.",
        "itemListDetail.loading": "Loading…",
        "itemListDetail.add": "Add products",
        "itemListDetail.edit": "Edit",
        "itemListDetail.title": "Product / title",
        "itemListDetail.description": "Description",
        "itemListDetail.quantity": "Quantity",
        "itemListDetail.purchase_price": "Purchase price excl. VAT",
        "itemListDetail.sales_price": "Sales price excl. VAT",
        "itemListDetail.discount": "Discount (%)",
        "itemListDetail.surcharge": "Surcharge (%)",
        "itemListDetail.price_options": "More price options",
        "itemListDetail.product_id": "Product ID",
        "itemListDetail.status": "Status",
        "itemListDetail.approval_comment": "Comment",
        "itemListDetail.line": "Line {{number}}",
        "itemListDetail.lines": "Product lines",
        "itemListDetail.total_purchase": "Total purchase excl. VAT",
        "itemListDetail.total_sales": "Sales value excl. VAT before adjustments",
        "itemListDetail.line_total": "Purchase total",
        "itemListDetail.products": "Products",
        "itemListDetail.filter": "Search this list…",
        "itemListDetail.empty": "No products to display.",
        "itemListDetail.edit_line": "Edit {{title}}",
        "itemListDetail.remove_line": "Remove {{title}}",
        "itemListDetail.edit_hint": "Use the pencil on each line to edit product, quantity and purchase price. Changes are recorded in history.",
        "itemListDetail.locked_hint": "This list is locked. Admins can reopen submitted or approved consumption lists. Invoiced lists remain locked.",
        "itemListDetail.action_reopen": "Reopen consumption list",
        "itemListDetail.action_submit": "Submit for approval",
        "itemListDetail.action_approve": "Approve",
        "itemListDetail.action_reject": "Reject",
        "itemListDetail.action_invoice": "Mark manually invoiced",
        "itemListDetail.action_delete": "Delete list",
        "itemListDetail.action_remove": "Remove product",
        "itemListDetail.confirm": "Confirm",
        "itemListDetail.confirm_hint": "Confirm this action for “{{title}}”.",
        "itemListDetail.reopen_hint": "The list becomes editable and must be submitted for approval again. The previous approval and this reopening are recorded in history.",
        "itemListDetail.completed": "Action completed.",
        "itemListDetail.find_product": "Find product",
        "itemListDetail.search_hint": "Name, product number or QR code",
        "itemListDetail.scan": "Scan QR code",
        "itemListDetail.stop_camera": "Stop camera",
        "itemListDetail.camera_failed": "Could not open camera. Check camera access or use the search field.",
        "itemListDetail.searching": "Searching products…",
        "itemListDetail.search_failed": "Product search failed.",
        "itemListDetail.results": "{{count}} products found",
        "itemListDetail.select": "Select",
        "itemListDetail.manual": "Add manual line",
        "itemListDetail.remove": "Remove",
        "itemListDetail.save": "Save",
        "itemListDetail.saving": "Saving…",
        "itemListDetail.saved": "Saved",
        "itemListDetail.save_failed": "Could not save. Check the fields.",
        "itemListDetail.invalid": "Enter a product/title. Quantity must exceed zero; prices, discount and surcharge must be non-negative numbers.",
        "itemListDetail.discard": "Discard unsaved changes?",
        "itemListDetail.unknown": "The result is unknown. Keep your values, close this dialog and refresh the list to check the result before trying again.",
        "itemListDetail.refresh_failed": "The change was saved, but the list could not refresh. Close this dialog and select Refresh.",
        "itemListDetail.progress": "{{count}} of {{total}} lines saved",
        "itemListDetail.product_change_hint": "Changing product keeps quantity and prices. Adjust them as needed; the product catalogue is unchanged.",
        "itemListDetail.history": "History",
        "itemListDetail.history_hint": "Recorded changes with user, time and before/after values. Older unrecorded changes are not available.",
        "itemListDetail.history_failed": "Could not load history.",
        "itemListDetail.history_empty": "No recorded changes yet.",
        "itemListDetail.system": "System",
        "itemListDetail.event_create": "List created",
        "itemListDetail.event_update": "List updated",
        "itemListDetail.event_destroy": "List deleted",
        "itemListDetail.event_add_item": "Product added",
        "itemListDetail.event_update_item": "Product line updated",
        "itemListDetail.event_remove_item": "Product removed",
        "itemListDetail.event_approve": "Approved",
        "itemListDetail.event_reject": "Rejected",
        "itemListDetail.event_submit_for_approval": "Submitted for approval",
        "itemListDetail.event_mark_invoiced_manually": "Marked manually invoiced",
        "itemListDetail.event_reopen": "Reopened for editing",
        "service.agreements.subs.facility_select": "Select registered facility",
        "service.agreements.subs.facility_manual": "Enter manually",
        "service.agreements.subs.filter_manual": "Manual filter text",
        "service.agreements.subs.filter_products": "Products as rows",
        "service.agreements.subs.find_filter_product": "Search and add filter product",
        "service.agreements.subs.filters_empty": "Search for a product to add a filter row.",
        "service.agreements.subs.use_suggestion": "Use suggestion: {{suggestion}}",
        "service.agreements.subs.address_loading": "Loading facility address…",
        "service.agreements.subs.address_failed": "Could not load the facility address.",
        "itemListDetail.bulk_add": "Bulk add products",
        "itemListDetail.add_selected": "Add selected ({{count}})",
        "itemListDetail.scan_no_exact_match": "No exact match for the scanned code. Use Search manually.",
        "product.selector.dialog_title": "Select product",
        "product.selector.dialog_title_multiple": "Select products",
        "service.agreements.subs.quantity": "Quantity",
        "service.agreements.subs.quantity_invalid": "Quantity must be greater than 0 and at most 10,000.",
        "service.agreements.subs.save_unknown": "The save could not be confirmed. Close the dialog and reload the list to check the result before trying again.",
  "service.agreements.filters.active": "Active agreements",
  "service.agreements.filters.service_soon": "Service due soon",
  "relatedEntries.search": "Search this list…",
  "relatedEntries.preview": "Preview",
  "relatedEntries.previewEntry": "Preview #{{number}}",
  "relatedEntries.filters": "Filters",
  "relatedEntries.clear": "Clear filters",
  "relatedEntries.newest": "Newest first",
  "relatedEntries.loading": "Loading…",
  "relatedEntries.loadFailed": "Could not load the list.",
  "relatedEntries.retry": "Try again",
  "relatedEntries.empty": "No results",
  "relatedEntries.emptyHint": "Try another search or change the filters.",
  "relatedEntries.loadMore": "Show more",
  "relatedEntries.select": "Select #{{number}}",
  "relatedEntries.created": "Created",
  "relatedEntries.date": "Date",
  "relatedEntries.agreed": "Agreed date",
  "relatedEntries.delivery": "Delivery date",
  "relatedEntries.due": "Due date",
  "relatedEntries.nextService": "Next service",
  "relatedEntries.project": "Project",
  "relatedEntries.customer": "Customer",
  "relatedEntries.address": "Address",
  "relatedEntries.description": "Description",
  "relatedEntries.viewFullDescription": "View full description",
  "relatedEntries.viewFullDescriptionEntry": "View full description for #{{number}}",
  "relatedEntries.descriptionDialogTitle": "Report description",
  "relatedEntries.descriptionDialogEyebrow": "Report #{{number}}",
  "relatedEntries.assigned": "Assigned to",
  "relatedEntries.type": "Type",
  "relatedEntries.serial": "Serial number",
  "relatedEntries.reports": "Reports",
  "relatedEntries.orders": "Orders",
  "relatedEntries.workOrders": "Work orders",
  "relatedEntries.agreements": "Agreements",
  "relatedEntries.projects": "Projects",
  "relatedEntries.cases": "Cases",
  "relatedEntries.facilities": "Facilities",
        "hourBilling.workspace": "Time reconciliation",
        "hourBilling.refresh": "Refresh",
        "hourBilling.searchHours": "Search employee, project or description…",
        "hourBilling.selectInTable": "Select entries in the table",
        "hourBilling.tableHint": "Select individual entries or this page. Selection resets when the page or filters change.",
        "hourBilling.clearSelection": "Clear selection",
        "hourBilling.selectPage": "Select this page",
        "hourBilling.selectEntry": "Select entry",
        "hourBilling.employeeDate": "Employee / date",
        "hourBilling.project": "Project",
        "hourBilling.actions": "Action",
        "hourBilling.editEntry": "Reconcile",
        "hourBilling.emptyHint": "This list shows hired hours without full invoice coverage. Try changing the search or filters.",
        "hourBilling.search_orders": "Search order number, reference or comment…",
        "hourBilling.search_invoices": "Search invoice number, supplier, voucher or description…",
        "hourBilling.searching": "Searching all eligible results…",
        "hourBilling.searchResults": "Showing {{count}} results",
        "hourBilling.noChoices": "No eligible results. Try another search.",
        "hourBilling.searchFailed": "Search could not be completed.",
        "hourBilling.moreChoices": "Show more results",
        "hourBilling.applySelection": "Changes apply to all selected entries.",
        "hourBilling.customerSection": "Customer billing",
        "hourBilling.costSection": "Hired work and cost coverage",
        "hourBilling.salarySection": "Payroll and employees",
        "hourBilling.reloadStatus": "Load latest status",
        "hourBilling.unknownSave": "The save could not be confirmed. Load the latest status before making further changes.",
        "hourBilling.hours": "hours",
        "announcements.communication": "Communication",
        "announcements.headline": "Keep everyone informed",
        "announcements.intro": "Share important information, routines and news. Choose who can see each message and how it reaches them.",
        "announcements.scheduled": "Scheduled",
        "announcements.expired": "Expired",
        "announcements.all": "All",
        "announcements.search": "Search messages…",
        "announcements.filter": "Filter by publication status",
        "announcements.noDate": "Not set",
        "announcements.empty": "Your first message starts here",
        "announcements.emptyHint": "Write an update for your colleagues, an internal routine or news for your website.",
        "announcements.noMatches": "No matching messages",
        "announcements.searchHint": "Try another search term or status filter.",
        "announcements.preview": "Message preview",
        "announcements.channelApp": "App / website",
        "announcements.channelEmail": "Email",
        "announcements.edit": "Edit message",
        "announcements.message": "Write your message",
        "announcements.messageHint": "A clear title and concise text make information easy to find.",
        "announcements.titlePlaceholder": "What would you like to share?",
        "announcements.bodyPlaceholder": "Write what your readers need to know…",
        "announcements.in_appHint": "Shown to your chosen audience when published and within the active period.",
        "announcements.email_enabledHint": "Choose recipients and confirm delivery after saving. Saving does not send email.",
        "announcements.visibility": "Publication and dates",
        "announcements.publishToggle": "Publish this message",
        "announcements.visibilityHint": "Leave off to keep a draft. A future start date schedules visibility. Email delivery is a separate action.",
        "announcements.saveHint": "Email is sent in a separate step",
        "announcements.discard": "Discard unsaved message changes?",
        "announcements.searchRecipients": "Search recipients…",
        "announcements.selectVisible": "Select all available in search",
        "announcements.noRecipients": "No recipients in this search",
        "announcements.selected": "{{count}} recipients selected",
        "announcements.confirmTitle": "Confirm email delivery",
        "announcements.confirmHint": "Send the saved message to {{count}} selected recipients. A future start date schedules delivery. Previously registered recipients will not be sent again.",
        "announcements.confirmSend": "Confirm delivery",
        "announcements.sending": "Queuing delivery…",
        "announcements.sendFailed": "Delivery could not be confirmed. Refresh delivery status before trying again.",
        "hourBilling.open": "Billing / reconciliation",
        "hourBilling.selectFirst": "Select one or more time entries to mark as invoiced or reconcile.",
        "hourBilling.unchanged": "Leave unchanged",
        "hourBilling.customer_invoiced": "Invoiced to customer",
        "hourBilling.hired_invoiced": "Hired work invoiced",
        "hourBilling.billing_order_id": "Link to order",
        "hourBilling.supplierinvoice_id": "Supplier invoice",
        "hourBilling.salary_voucher_id": "Payroll voucher",
        "hourBilling.bulkHint": "Choose only the fields to change. All selected entries are saved together. Hour approval is unaffected.",
        "hourBilling.commonOptions": "Shows links valid for every selected entry. Invoice links require hired hours; adjust coverage per entry. Existing links are replaced only when you select a new value.",
        "hourBilling.selection": "{{count}} selected entries",
        "hourBilling.entries": "Time entries",
        "hourBilling.current": "Current status",
        "hourBilling.notInvoiced": "Not invoiced to customer",
        "hourBilling.invoiceRef": "Invoice #{{id}} · {{hours}} h covered",
        "hourBilling.saveSelected": "Save selected entries",
        "hourBilling.discard": "Discard unsaved changes?",
        "hourBilling.conflict": "An entry changed after you opened this dialog. Nothing was saved. Reload and choose your changes again.",
        "hourBilling.selectEntries": "Select entries to reconcile",
        "hourBilling.visiblePeriod": "Choose from the entries in the current period and filter.",
        "hourBilling.selectAll": "Select all shown",
        "hourBilling.limit": "Select up to 100 entries at a time.",
        "common.retry": "Retry",
        "common.save": "Save",
        "project.billing_plan.save_settings_failed": "Could not confirm that the settings were saved.",
        "announcements.openPublic": "Open public announcements page",
        "announcements.title": "Announcements and newsletters",
        "announcements.previousMessage": "Previous announcement",
        "announcements.deactivated": "Deactivated",
        "announcements.deactivate": "Deactivate announcement",
        "announcements.reactivate": "Reactivate",
        "announcements.stopHint": "End this announcement early without deleting its content.",
        "announcements.inactiveHint": "This announcement is deactivated. Content and dates are preserved.",
        "announcements.deactivateHint": "The announcement will be hidden and pending emails cancelled. Sent emails or sends already in progress cannot be recalled. Open dashboards refresh within one minute; public pages on their next load.",
        "announcements.reactivateHint": "Original publication settings and dates will apply again. Expired announcements need a new end date to appear. Cancelled emails will not be resent automatically.",
        "announcements.confirmDeactivate": "Yes, deactivate",
        "announcements.confirmReactivate": "Yes, reactivate",
        "announcements.deactivatedResult": "Announcement deactivated. Pending emails were cancelled.",
        "announcements.reactivatedResult": "Announcement reactivated with its original publication settings and dates.",
        "announcements.activationNotApplied": "The current status is unchanged. You can try the action again.",
        "announcements.activationFailed": "The action was rejected. Check your access and refresh the page.",
        "announcements.activationUnknown": "The result could not be confirmed. Check status before trying again.",
        "announcements.checkStatus": "Check status",
        "announcements.nextMessage": "Next announcement",
        "announcements.new": "New message",
        "announcements.body": "Content",
        "announcements.audience": "Audience",
        "announcements.admin": "Admins only",
        "announcements.users": "All users",
        "announcements.public": "Public on website",
        "announcements.in_app": "Show in app / on website",
        "announcements.email_enabled": "Enable email",
        "announcements.published": "Published",
        "announcements.draft": "Draft",
        "announcements.starts_at": "From (optional)",
        "announcements.ends_at": "Until (optional)",
        "announcements.publicHint": "Public messages are available to the connected website. Do not include internal information here.",
        "announcements.recipients": "Selected email recipients",
        "announcements.emailHint": "Save first. Sending uses a snapshot and sends once per recipient. Start date schedules delivery. Unknown outcomes are not resent automatically.",
        "announcements.send": "Send / schedule email to selected users",
        "announcements.refresh": "Refresh delivery status",
        "announcements.queued": "Email queued. See delivery status below.",
        "announcements.saved": "Message saved.",
        "announcements.loadFailed": "Could not load messages.",
        "announcements.saveFailed": "Could not save. Your draft is preserved.",
        "announcements.delivery.pending": "Pending",
        "announcements.delivery.sending": "Sending – check if delayed",
        "announcements.delivery.sent": "Sent",
        "announcements.delivery.unknown": "Unknown outcome – check the email log",
        "announcements.delivery.failed": "Failed",
        "announcements.delivery.cancelled": "Cancelled",
        "documentUpload.attachments.pick": "Add document or photo",
        "documentUpload.attachments.add": "Add",
        "statusAttachments.attachmentPost": "Update with attachments",
        "statusAttachments.backgroundHint": "Attachments upload in the background after publishing. Keep Promang open until the upload finishes.",
        "statusPhotos.photoPost": "Photo update",
        "statusPhotos.destination": "Update #{{id}}",
        "statusPhotos.backgroundHint": "Photos upload in the background after publishing. Keep Promang open until the upload finishes.",
        "accounting.project_summary.methodology.labor_primary_mixed": "Posted payroll costs plus estimates for hours without voucher or invoice coverage. Reconcile hours to their payroll voucher.",
        "project.summary.labor_source_mixed": "Payroll vouchers and estimates for unreconciled hours",
        "project.summary.load_failed": "Could not load the project summary",
        "project.copy.success": "Copied to clipboard",
        "project.copy.failed": "Could not copy",
        "accounting.project_summary.labor_source_mixed": "Payroll vouchers and estimates for unreconciled hours",
        "accounting.summary.labor_source_mixed": "Payroll vouchers and estimates for unreconciled hours",
        "hourBilling.title": "Billing and cost reconciliation",
        "hourBilling.customer": "Invoiced to customer",
        "hourBilling.hired": "Hired resource",
        "hourBilling.supplierInvoiced": "Hire invoiced",
        "hourBilling.reminder": "Missing invoice coverage",
        "hourBilling.order": "Link to order",
        "hourBilling.orderHint": "An invoiced order automatically marks the time entry as invoiced to the customer.",
        "hourBilling.invoice": "Supplier invoice (project/supplier suggestions)",
        "hourBilling.invoiceHint": "The link covers cost independently of the flags above. Remaining hours retain estimated cost.",
        "hourBilling.coveredHours": "Hours on invoice",
        "hourBilling.rate": "Hourly rate excluding VAT",
        "hourBilling.salaryVoucher": "Reconciled to payroll voucher",
        "hourBilling.salaryHint": "Select only the voucher that actually covers these hours. Posting date does not establish the earning period.",
        "hourBilling.none": "No link",
        "hourBilling.loadFailed": "Could not load billing details.",
        "hourBilling.saveFailed": "Could not save billing details. Your draft is preserved.",
        "hourBilling.saved": "Billing details saved.",
        "hourBilling.followup": "Hour invoice follow-up",
        "hourBilling.followupHint": "Hired hours without full invoice coverage. Open a time entry for suggestions and reconciliation.",
        "hourBilling.noReminders": "All hired hours have invoice coverage.",
        "service.agreements.subs.edit": "Edit included facility",
        "service.agreements.subs.saved": "Facility updated.",
        "service.agreements.subs.save_failed": "Could not save the facility.",
        "customer.systems.linked_customer": "Linked customer",
        "customer.systems.move_hint": "Choose another customer to move the facility, or remove the customer. Existing reports and history are retained.",
        "customer.systems.save_failed": "Could not save the facility.",
        "customer.systems.connections_history": "Connections and history",
        "customer.systems.load_failed": "Could not load facility data.",
        "customer.systems.no_customer": "No linked customer",
        "customer.systems.history_limit": "Shows the latest 100 entries and connections you can access.",
        "customer.systems.all_title": "Facilities",
        "deliveryRegistry.title": "Delivery addresses",
        "deliveryRegistry.save": "Save",
        "deliveryRegistry.register": "Address register",
        "deliveryRegistry.intro": "Manage delivery addresses registered to your company. Find, create and maintain addresses used in Promang.",
        "deliveryRegistry.search": "Search name, street, postal code or city",
        "deliveryRegistry.new": "New delivery address",
        "deliveryRegistry.edit": "Edit address",
        "deliveryRegistry.editHint": "Changes update the same address wherever it is used. Check the name and country before saving.",
        "deliveryRegistry.newHint": "Create a company delivery address, available in Promang’s address selectors.",
        "deliveryRegistry.name": "Name / recipient",
        "deliveryRegistry.address": "Address",
        "deliveryRegistry.address2": "Address line 2",
        "deliveryRegistry.postal": "Postal code",
        "deliveryRegistry.place": "City",
        "deliveryRegistry.country": "Country",
        "deliveryRegistry.optional": "(optional)",
        "deliveryRegistry.selectCountry": "Select country",
        "deliveryRegistry.required": "This field is required.",
        "deliveryRegistry.validCountry": "Select a valid country code.",
        "deliveryRegistry.loading": "Loading addresses…",
        "deliveryRegistry.loadFailed": "Could not load addresses.",
        "deliveryRegistry.results": "{{count}} addresses found",
        "deliveryRegistry.empty": "No addresses found",
        "deliveryRegistry.emptyHint": "Try another search, remove a filter or create an address.",
        "deliveryRegistry.refresh": "Refresh",
        "deliveryRegistry.complete": "Complete",
        "deliveryRegistry.incomplete": "Missing details",
        "deliveryRegistry.unnamed": "Unnamed address",
        "deliveryRegistry.previous": "Previous",
        "deliveryRegistry.next": "Next",
        "deliveryRegistry.page": "Page {{page}} of {{pages}}",
        "deliveryRegistry.discard": "Discard unsaved address changes?",
        "deliveryRegistry.saved": "Address saved.",
        "deliveryRegistry.saving": "Saving…",
        "deliveryRegistry.saveFailed": "The address could not be saved. Your changes are preserved.",
        "deliveryRegistry.unknown": "The save result is unknown. Check status before continuing.",
        "deliveryRegistry.createUnknown": "The save result is unknown. Close the dialog and refresh the list to check whether the address was created before trying again.",
        "deliveryRegistry.conflict": "The address has changed since you opened it. Reload the latest version and review before saving.",
        "deliveryRegistry.reload": "Reload latest version",
        "deliveryRegistry.checkStatus": "Check status",
        "deliveryRegistry.refreshWarning": "The address was saved, but the list could not be refreshed. Close the dialog and refresh the overview.",
        "customer.systems.register": "Equipment register",
        "customerSettings.title": "Customer settings",
        "customerSettings.eyebrow": "Customers",
        "customerSettings.intro": "Manage company equipment and shipping types. Changes are available in existing customer, equipment and order workflows.",
        "customerSettings.systems": "Equipment types",
        "customerSettings.systems_hint": "Types used when creating and filtering equipment.",
        "customerSettings.shipping": "Shipping types",
        "customerSettings.shipping_hint": "Delivery options, prices and availability for orders and offers.",
        "customerSettings.add": "Add",
        "customerSettings.loading": "Loading settings…",
        "customerSettings.load_failed": "Could not load settings.",
        "customerSettings.empty": "No types created yet.",
        "customerSettings.name": "Name",
        "customerSettings.description": "Description",
        "customerSettings.active": "Active",
        "customerSettings.inactive": "Inactive",
        "customerSettings.public": "Publicly available",
        "customerSettings.free": "Free shipping",
        "customerSettings.flat": "Flat rate",
        "customerSettings.calculate": "Calculate shipping price",
        "customerSettings.price": "Price excl. VAT",
        "customerSettings.price_value": "{{value}} excl. VAT",
        "customerSettings.free_over_ordertotal": "Free shipping above order total",
        "customerSettings.shipping_help": "Inactive shipping types remain in settings and can be reactivated. Amounts exclude VAT.",
        "customerSettings.save": "Save",
        "customerSettings.saving": "Saving…",
        "customerSettings.saved": "Setting saved.",
        "customerSettings.save_failed": "Could not save. Check the fields and try again.",
        "customerSettings.title_required": "Enter a name.",
        "customerSettings.invalid_price": "Amounts must be numbers greater than or equal to 0.",
        "customerSettings.unknown": "The save was not confirmed. Close and refresh the overview to check the result before trying again.",
        "customerSettings.discard": "Discard unsaved changes?",
        "customerSettings.no_access": "You do not have access to customer settings.",
        "customer.systems.type_filter": "Equipment type",
        "customer.systems.previous": "Previous",
        "customer.systems.next": "Next",
        "customer.systems.register_intro": "Find equipment, customers and history in one place. Search by model, manufacturer, serial or item number.",
        "customer.systems.searching": "Searching for equipment…",
        "customer.systems.search_complete": "Search complete · {{count}} results on page {{page}}",
        "customer.systems.results": "{{count}} equipment records found",
        "customer.systems.page": "Page {{page}} of {{pages}}",
        "customer.systems.no_matches": "No equipment matches your search.",
        "customer.systems.search_help": "Try another search term or remove a filter.",
        "customer.systems.types_failed": "Equipment types could not be loaded. Search is still available.",
        "customer.systems.refresh": "Refresh",
        "customer.systems.serial_label": "Serial number",
        "customer.systems.not_set": "Not provided",
        "customer.systems.open_details": "Open equipment and history",
        "customer.systems.merge_intro": "Find the equipment record to keep. Search all company equipment and review your choice before merging.",
        "customer.systems.merge_from": "Record to remove",
        "customer.systems.merge_keep": "Record to keep",
        "customer.systems.clear_target": "Clear selected target",
        "customer.systems.merge_review": "Report and service agreement links move from “{{source}}” to “{{target}}”. The source is removed from the overview. Verify these represent the same physical equipment.",
        "customer.systems.duplicates_count": "Other facilities with this serial number: {{count}}",
        "customer.systems.duplicates_hint": "Possible duplicates. Check the customer, address and that these are the same physical facility. The retained facility’s details stay unchanged.",
        "customer.systems.duplicates_recommend": "Suggested to keep: {{title}} (#{{id}})",
        "customer.systems.duplicates_reason": "The suggestion has the most completed basic fields. Ties are resolved by the lowest ID.",
        "customer.systems.duplicates_review": "Review merge with #{{id}}",
        "customer.systems.duplicates_more": "{{count}} more matches. Search for the serial number in the dialog to see more.",
        "customer.systems.merge_unknown": "The result is not confirmed. Check status before proceeding; the merge may already be complete.",
        "customer.systems.check_merge": "Check status",
        "customer.systems.refresh_warning": "The change was saved, but the overview could not be refreshed. Reload the list.",
        "customer.systems.search": "Search serial number, model, article number or delivery address",
        "customer.systems.all_types": "All types",
        "customer.systems.history_action.create": "Created",
        "customer.systems.history_action.update": "Updated",
        "customer.systems.history_action.move": "Customer changed",
        "customer.systems.history_action.merge": "Facilities merged",
        "project.item_list.saving_quantity": "Saving quantity…",
        "statistics.date_from": "From date",
        "statistics.date_to": "To date",
        "statistics.apply": "Apply period",
        "statistics.all_time": "All time",
        "statistics.date_hint": "Filters by case creation date. Both dates are included.",
        "statistics.invalid_period": "From date must be on or before to date.",
        "statistics.load_error": "Could not load statistics.",
        "statistics.cases_by_label": "Cases by label",
        "statistics.no_labels_with_cases": "No labels with cases yet",
        "project.item_list.reopen": "Reopen for editing",
        "project.item_list.reopening": "Reopening item list…",
        "project.item_list.pdf_loading": "Generating PDF…",
        "offers.workspace.add_suggestions": "Add selected suggestions as offer lines",
        "offers.workspace.suggestions_added": "Suggestions added. Review quantities and enter prices.",

        "offers.workspace.check_calculation": "The calculation contains errors that must be resolved.",
        "offers.workspace.conversion": "From offer to project",
        "offers.workspace.conversion_hint": "A project is created with the offer customer and contacts. Activities and an order are created when supported by the source data. The agreed price and order use the accepted revision when available.",
        "offers.workspace.conversion_confirm": "Create project",

        "offers.workspace.conflict": "The offer was changed by someone else",
        "offers.workspace.conflict_hint": "Changes in different fields are merged. Choose a value when both edits affect the same field.",
        "offers.workspace.mine": "My value",
        "offers.workspace.theirs": "Latest saved value",
        "offers.workspace.merge": "Merge and save",
        "offers.workspace.conflict_use_server": "Use latest saved version",

        "offers.workspace.extract": "Read text from PDF",
        "offers.workspace.extracting": "Reading pages…",
        "offers.workspace.extract_failed": "Could not extract PDF text. Scanned documents need OCR; you can paste the text.",
        "offers.workspace.template_tests": "Test calculation template",
        "offers.workspace.template_tests_hint": "Save inputs with an expected price. Tests use the current calculation logic without changing the offer.",
        "offers.workspace.template_tests_empty": "No saved tests yet.",
        "offers.workspace.test_name": "Example name",
        "offers.workspace.expected": "Expected price",
        "offers.workspace.save_test": "Save test with these inputs",

        "offers.workspace.advanced": "Show more fields",
        "offers.workspace.purchase_price": "Unit cost",
        "offers.workspace.alternative_group": "Alternative group",
        "offers.workspace.price_source": "Price source",
        "offers.workspace.price_dated_at": "Price date",
        "offers.workspace.discard_draft": "Discard unsaved line",
        "offers.workspace.outgoing": "Customer attachments",
        "offers.workspace.outgoing_hint": "Choose files to send with the offer. Other files remain working material. Maximum 20 MB total.",
        "offers.workspace.outgoing_count": "Selected customer attachments: {{count}}",
        "offers.workspace.delivery_queued": "Offer queued for sending",
        "offers.workspace.delivery_processing": "Offer is being sent",
        "offers.workspace.delivery_sent": "Offer sent",
        "offers.workspace.delivery_failed": "Sending failed. Check delivery before sending again.",
        "offers.workspace.delivery_finalization_failed": "Email was sent, but archiving the revision failed. Do not send again.",
        "offers.workspace.delivery_draft_creation_failed": "The offer was sent. The next draft could not be created. Do not send again.",

        "offers.workspace.area_price": "Price and calculation",
        "offers.workspace.area_document": "Customer document",
        "offers.workspace.area_activity": "Activity",

        "offers.workspace.start": "Choose a starting point",
        "offers.workspace.start_quick": "Quick offer",
        "offers.workspace.start_quick_hint": "Enter lines and prices. Ready in a few steps.",
        "offers.workspace.start_quick_detail": "Opens customer view / offer lines. Best when you already know prices and don’t need a calculation with hours, materials and markups.",
        "offers.workspace.start_template": "Use a calculation template",
        "offers.workspace.start_template_hint": "Reuse expertise and adjust quantities.",
        "offers.workspace.start_template_detail": "Opens calculation and the template picker right away. You copy a company template (wizard if needed) and adjust quantities — the template itself is unchanged.",
        "offers.workspace.start_detailed": "Detailed calculation",
        "offers.workspace.start_detailed_hint": "Build trades, materials, hours and markups.",
        "offers.workspace.start_detailed_detail": "Opens an empty calculation workspace. Build lines, products, hours and structure from scratch — without a template.",
        "offers.workspace.start_selected_label": "Selected start",
        "offers.create.start_heading": "How do you want to start?",
        "offers.create.start_intro": "All three create the same kind of offer. The difference is where you begin — you can always switch tabs later.",
        "offers.workspace.add_line": "Add line",
        "offers.workspace.move_line": "Move line",
        "offers.workspace.add_product": "Add product",
        "offers.workspace.add_selected_products": "Add selected products",
        "offers.workspace.paste": "Paste from spreadsheet",
        "offers.workspace.paste_hint": "Three columns: description, quantity and unit price.",
        "offers.workspace.paste_error": "Each row needs a description, quantity and price, separated by tabs.",
        "offers.workspace.bulk_discount": "Discount on selected lines (%)",
        "offers.workspace.apply": "Apply changes",
        "offers.workspace.select": "Select line",
        "offers.workspace.duplicate": "Duplicate line",
        "offers.workspace.cancel": "Cancel",
        "offers.workspace.retry": "Retry saving",
        "offers.workspace.save_saved": "All changes saved",
        "offers.workspace.save_pending": "Changes waiting to save",
        "offers.workspace.save_saving": "Saving changes…",
        "offers.workspace.save_error": "Changes are not saved. Retry before continuing.",
        "offers.workspace.regenerate_hint": "Calculation lines will be updated. Manual lines are kept. Review customer adjustments before continuing.",
        "offers.workspace.empty_title": "What will you deliver?",
        "offers.workspace.empty_hint": "Add your first line or paste a price list. You can add a detailed calculation later.",
        "offers.workspace.customer_total": "Offer price excl. VAT · optional extras excluded",
        "offers.workspace.inclusion": "Offer inclusion",
        "offers.workspace.included": "Included",
        "offers.workspace.optional": "Optional extra",
        "offers.workspace.excluded": "Excluded",
        "offers.workspace.review": "Review and send",
        "offers.workspace.review_hint": "Review price, content and recipient before sending.",
        "offers.workspace.check_customer": "Choose a customer.",
        "offers.workspace.check_empty": "Add at least one included line.",
        "offers.workspace.check_description": "One or more lines need a description.",
        "offers.workspace.check_price": "One or more included lines have a zero price.",
        "offers.workspace.check_quantity": "Quantity must be greater than zero.",
        "offers.workspace.check_expired": "The offer validity date has passed.",
        "offers.workspace.check_margin": "Costs exceed the offer price.",
        "offers.workspace.check_alternatives": "An alternative group has more than one included choice.",
        "offers.send.missing_id": "Offer ID is missing. Save the offer before sending.",
        "offers.workspace.cover.title": "Cover page",
        "offers.workspace.cover.subtitle": "Configure the cover page for the offer PDF.",
        "offers.workspace.cover.active": "Active",
        "offers.workspace.cover.inactive": "Inactive",
        "offers.workspace.cover.field_title": "Title",
        "offers.workspace.cover.title_placeholder": "Enter cover page title…",
        "offers.workspace.cover.title_hint": "The title appears on the PDF cover page",
        "offers.workspace.cover.description": "Description",
        "offers.workspace.cover.description_placeholder": "Enter cover page description…",
        "offers.workspace.cover.image": "Cover image",
        "offers.workspace.cover.selected_image": "Selected cover image: {{title}}",
        "offers.workspace.cover.no_image_title": "No title",
        "offers.workspace.cover.image_first_hint": "The first image you upload will be used as the cover image",
        "offers.workspace.cover.image_pdf_hint": "The image fills the cover page in the PDF",
        "offers.workspace.cover.inactive_hint": "Enable the cover page to configure its content.",
        "offers.workspace.fix": "Open",
        "offers.workspace.ready": "No issues found in the line checks.",
        "offers.workspace.explain": "Why this price?",
        "offers.workspace.scenario": "What if?",
        "offers.workspace.scenario_hint": "Explore changes without modifying the offer. This scenario adjusts total sales and cost.",
        "offers.workspace.sales_change": "Sales price change (%)",
        "offers.workspace.cost_change": "Cost change (%)",
        "offers.workspace.cost": "Cost",
        "offers.workspace.margin": "Contribution",
        "offers.workspace.cost_unknown": "Cost basis is not available.",
        "offers.workspace.reset": "Reset scenario",
        "offers.workspace.preview": "Open PDF",
        "offers.workspace.send": "Send offer",
        "offers.workspace.layout": "Document format",
        "offers.workspace.layout_simple": "Simple offer sheet",
        "offers.workspace.layout_document": "Designed offer document",
        "offers.simpleDocument.info_title": "Offer info",
        "offers.simpleDocument.info_hint": "Simple offer sheet without cover, letter and block structure. Same content as PDF — simple.",
        "offers.simpleDocument.meta_customer": "Customer",
        "offers.simpleDocument.meta_project": "Project",
        "offers.simpleDocument.meta_reference": "Reference",
        "offers.simpleDocument.meta_offer_date": "Offer date",
        "offers.simpleDocument.meta_valid_to": "Valid until",
        "offers.simpleDocument.meta_contact": "Contact",
        "offers.simpleDocument.upgrade": "Build full offer document",
        "offers.simpleDocument.upgrading": "Switching…",
        "offers.simpleDocument.upgrade_success": "Document builder is ready",
        "offers.simpleDocument.upgrade_failed": "Could not switch to full document",
        "offers.documentBuilder.switch_to_simple": "Switch to simple offer sheet",
        "offers.documentBuilder.switching_to_simple": "Switching…",
        "offers.documentBuilder.switch_to_simple_confirm": "Switch to the simple offer sheet? The block structure (cover, letter and sections) will be deleted and cannot be undone.",
        "offers.documentBuilder.switch_to_simple_success": "Simple offer sheet is active",
        "offers.documentBuilder.switch_to_simple_failed": "Could not switch to simple sheet",
        "offers.workspace.undo": "Undo",
        "offers.workspace.redo": "Redo",
        "offers.workspace.density": "Density",
        "offers.workspace.normal": "Normal",
        "offers.workspace.compact": "Compact",
        "offers.workspace.ai_source": "Analysis requires document text. Selecting a file alone does not read its contents. Paste relevant text with page references.",
        "offers.workspace.title": "Description",
        "offers.workspace.description": "Detail description",
        "offers.workspace.quantity": "Quantity",
        "offers.workspace.sales_price": "Unit price",
        "offers.workspace.surcharge": "Surcharge",
        "offers.workspace.unit_id": "Unit",
        "offers.workspace.offer_group_id": "Group",
        "offers.workspace.pricing_role": "Pricing role",
        "offers.workspace.visible_to_customer": "Visible to customer",
        "offers.workspace.deleted": "Deleted line",
        "offers.workspace.unsaved_leave": "You have unsaved changes. Leave without saving?",
        "offers.workspace.discount": "Discount (%)",
        "offers.workspace.total": "Total",
        "offers.workspace.unit": "Unit",
        "offers.workspace.remove_line": "Remove line",
        "offers.workspace.customer_email_missing": "Customer email is missing",
        "offers.workspace.contact_email_missing": "Contact email is missing",

        "loading.boot.initializing": "Initializing workspace",
        "loading.boot.syncing": "Syncing your modules",
        "loading.boot.linking": "Establishing secure link",
        "loading.boot.finalizing": "Finalizing — almost there",
        "user_profile.title": "User profile",
        "user_profile.empty_value": "Not set",
        "user_profile.load_failed": "Could not load profile",
        "user_profile.load_failed_body": "Try reloading the page.",
        "user_profile.no_changes": "No changes to save",
        "user_profile.ignored_fields_notice": "Some fields were not saved because they are locked",
        "user_profile.email_locked_hint": "Login email cannot be changed here.",
        "user_profile.private_email_hint": "Optional private address. Shown in the email picker when sending documents.",
        "user_profile.field_locked_hint": "This field is locked and can only be changed by an administrator.",
        "user_profile.add_field": "Add {{field}}",
        "user_profile.validation.name_required": "Name is required",
        "user_profile.field.name": "Name",
        "user_profile.field.email": "Work email",
        "user_profile.field.private_email": "Private email",
        "user_profile.field.mobile": "Private mobile",
        "user_profile.field.mobile_work": "Work mobile",
        "user_profile.field.address": "Address",
        "user_profile.field.postal": "Postal code",
        "user_profile.field.place": "Place",
        "user_profile.field.birth_date": "Date of birth",
        "user_profile.field.social_security": "Social security number",
        "user_profile.field.account_number": "Account number",
        "user_profile.section.contact": "Contact information",
        "user_profile.section.address": "Address",
        "user_profile.section.personal_details": "Personal details",
        "user_profile.section.personal_details_hint": "Sensitive fields are governed by your permissions.",
        "user_profile.section.children": "Children",
        "user_profile.section.next_of_kin": "Next of kin",
        "user_profile.related_records.add": "Add",
        "user_profile.related_records.edit": "Edit",
        "user_profile.related_records.delete": "Delete",
        "user_profile.related_records.actions": "Actions",
        "user_profile.related_records.active_count": "active",
        "user_profile.related_records.deactivated": "Deactivated",
        "user_profile.related_records.deactivate_confirm": "Are you sure you want to deactivate this entry? It will remain visible but marked as deactivated.",
        "user_profile.related_records.validation.name_required": "Name is required",
        "user_profile.related_records.dialog.create_title": "Add entry",
        "user_profile.related_records.dialog.edit_title": "Edit entry",
        "user_profile.related_records.dialog.save": "Save",
        "user_profile.related_records.dialog.saving": "Saving…",
        "user_profile.related_records.dialog.cancel": "Cancel",
        "user_profile.related_records.save_success": "Entry saved",
        "user_profile.related_records.save_failed": "Could not save entry",
        "user_profile.related_records.deactivate_success": "Entry deactivated",
        "user_profile.related_records.deactivate_failed": "Could not deactivate entry",
        "user_profile.children.empty_title": "No children added",
        "user_profile.children.empty_desc": "Use the plus button to add a child.",
        "user_profile.children.field.name": "Name",
        "user_profile.children.field.birth_date": "Date of birth",
        "user_profile.children.field.sole_custody": "Sole custody",
        "user_profile.children.field.extended_rights": "Extended rights",
        "user_profile.children.validation.birth_date_required": "Date of birth is required",
        "user_profile.next_of_kin.empty_title": "No next of kin added",
        "user_profile.next_of_kin.empty_desc": "Use the plus button to add next of kin.",
        "user_profile.next_of_kin.field.name": "Name",
        "user_profile.next_of_kin.field.relationship_type": "Relationship",
        "user_profile.next_of_kin.field.phone_number": "Phone",
        "user_profile.next_of_kin.field.address": "Address",
        "user_profile.next_of_kin.validation.relationship_required": "Relationship is required",
        "user_profile.next_of_kin.relationship.placeholder": "Select relationship",
        "user_profile.next_of_kin.relationship.SPOUSE": "Spouse",
        "user_profile.next_of_kin.relationship.PARTNER": "Partner",
        "user_profile.next_of_kin.relationship.PARENT": "Parent",
        "user_profile.next_of_kin.relationship.CHILD": "Child",
        "user_profile.next_of_kin.relationship.SIBLING": "Sibling",
        "user_profile.banner.employee_title": "You are registered as an employee",
        "user_profile.banner.employee_body": "You have access to employment information and payslips.",
        "user_profile.banner.hired_title": "You are registered as hired",
        "user_profile.banner.hired_body": "You are hired and do not have employment in this company.",
        "user_profile.tab.profile": "Profile",
        "user_profile.tab.email": "Email",
        "user_profile.tab.employment": "Employment",
        "user_profile.email.signature_title": "Email signature",
        "user_profile.email.signature_help":
          "The signature is added when you send email to the customer — not while drafting.",
        "user_profile.email.signature_placeholder": "Kind regards …",
        "user_profile.email.save": "Save signature",
        "user_profile.employment.not_employee_title": "No employment",
        "user_profile.employment.not_employee_body": "Hired users do not have an employment record.",
        "user_profile.employment.none_title": "Employment missing",
        "user_profile.employment.none_body": "No employment record has been created for you yet.",
        "user_profile.employment.title": "Employment information",
        "user_profile.employment.read_only_hint": "This information is read-only.",
        "user_profile.employment.working_posistion": "Position",
        "user_profile.employment.employee_number": "Employee number",
        "user_profile.employment.employment_starts": "Employment start date",
        "user_profile.employment.agreement_type": "Agreement type",
        "user_profile.employment.workplace": "Workplace",
        "user_profile.employment.wages": "Wages",
        "user_profile.employment.worktime": "Working hours",
        "user_profile.employment.signed_at": "Signed date",
        "user_profile.employment.signed_place": "Signed place",
        "user_profile.employment.contract_title": "Employment contract",
        "user_profile.employment.contract_signed": "The employment contract is signed",
        "user_profile.employment.download_contract": "Download signed contract",
        "user_profile.employment.contract_unsigned_title": "Not signed",
        "user_profile.employment.contract_unsigned_body": "The employment contract has not been signed yet.",
        "user_profile.quicklinks.payslips_title": "Payslips",
        "user_profile.quicklinks.payslips_body": "View and download your payslips",
        "user_profile.quicklinks.handbook_title": "Employee handbook",
        "user_profile.quicklinks.handbook_body": "Routines, guidelines and documents",
        "user_profile.handbook.documents_hint": "KS/HSE documents to review",
        "user_profile.handbook.chapters_hint": "Chapters in the employee handbook",
        "user_profile.handbook.forms_hint": "Forms you can fill out",
        "user_profile.handbook.events_hint": "Registered events",
        "user_profile.confirm.title": "Confirm changes",
        "user_profile.confirm.intro": "Review the changes before saving.",
        "user_profile.confirm.children_changed": "Changes to children",
        "user_profile.confirm.kin_changed": "Changes to next of kin",
        "user_profile.confirm.confirm_button": "Confirm and save",
        "user_profile.history.title": "Change history",
        "user_profile.history.open": "History",
        "user_profile.history.no_changes": "No changes recorded",
        "user_profile.history.empty_title": "No history",
        "user_profile.history.empty_body": "There are no changes to show yet.",
        "user_profile.history.action_revert": "Reverted",
        "user_profile.history.action_update": "Updated",
        "user_profile.history.reverted_from": "Reverted from version #{{id}}",
        "user_profile.history.restore": "Restore this version",
        "loading.boot.secure_session": "secure session",
        "common.tabs.more": "More",
        "employeeSelector.hired_badge": "Hired",
        "company.users.user_type.label": "User type",
        "company.users.user_type.employee": "Employee",
        "company.users.user_type.hired": "Hired (external)",
        "company.users.user_type.supplier": "Supplier (hired from)",
        "company.users.user_type.select_supplier": "Select supplier",
        "company.users.user_type.supplier_required": "Select a supplier for hired users",
        "user_employment.hired_no_employment_title": "Hired user",
        "user_employment.hired_no_employment": "This user is hired (external) and cannot have an employment. Change the user type to Employee to create an employment.",
        "user_employment.tab": "Employment",
        "user_work_schedule.tab": "Work schedule",
        "user_work_schedule.label": "Work schedule (hours)",
        "user_work_schedule.none": "None selected",
        "user_work_schedule.assign_title": "Select work schedule",
        "user_work_schedule.assign_hint": "Used for time registration, planned hours and absence. For employees, hours are scaled by position percentage.",
        "user_work_schedule.manage_link": "Manage work schedules →",
        "user_work_schedule.overview_title": "Overview",
        "user_work_schedule.overview_subtitle": "Hours per weekday (adjusted for position percentage where applicable)",
        "user_work_schedule.overview_empty": "No work schedule selected yet.",
        "user_work_schedule.overview_empty_hint": "Select a schedule above to see the weekly overview and public holidays.",
        "user_work_schedule.info_title": "Work schedule per user",
        "user_work_schedule.info_employee": "For employees the schedule is stored on the employment. Position percentage from salary affects planned hours.",
        "user_work_schedule.info_hired": "For hired users the schedule is stored directly on the user in the company (100% of the plan).",
        "user_work_schedule.not_available_title": "Work schedule not available",
        "user_work_schedule.not_available_description": "The user must be employed or hired before a work schedule can be assigned. Create an employment or set the user type to Hired.",
        "user_work_schedule.saved": "Work schedule saved",
        "user_work_schedule.save_error": "Could not save work schedule",
        "company.users.visibility.tag": "Hidden in selectors",
        "company.users.visibility.tag_hint": "Missing setup that hides this user from selectors",
        "company.users.visibility.inactive": "Inactive",
        "company.users.visibility.not_in_dropdown": "Not shown in dropdowns (enable \"Show in dropdown\")",
        "company.users.visibility.missing_supplier": "Missing supplier (hired user)",
        "company.users.visibility.not_employed": "Not an employee or hired user",
        "company.users.visibility.no_roles": "No roles assigned",
        "company.users.visibility.notice_title": "This user is not fully visible",
        "company.users.visibility.notice_intro": "The following is missing or must be added before the user shows up everywhere (e.g. in the employee/resource selectors):",
        "company.users.visibility.inactive_hint": "Activate the user under Details.",
        "company.users.visibility.not_in_dropdown_hint": "Enable \"Show in dropdown\" under Details so the user appears in selectors.",
        "company.users.visibility.missing_supplier_hint": "Select the supplier the user is hired from under Details.",
        "company.users.visibility.not_employed_hint": "Create an employment (Employment tab) or set the user type to Hired with a supplier.",
        "company.users.visibility.no_roles_hint": "Assign at least one role under the Roles tab.",
        "company.users.visibility.missing_work_schedule": "Missing work schedule",
        "company.users.visibility.missing_work_schedule_hint": "Select a work schedule under the Work schedule tab.",
        "tripletex_sync.title_default": "Tripletex sync",
        "tripletex_sync.retry": "Retry Tripletex sync",
        "tripletex_sync.retrying": "Syncing…",
        "tripletex_sync.retry_queued": "Tripletex sync has been queued again.",
        "tripletex_sync.retry_failed": "Could not queue Tripletex sync.",
        "tripletex_sync.open_customer": "Open customer",
        "tripletex_sync.badge.column": "Tripletex",
        "tripletex_sync.badge.synced": "Synced",
        "tripletex_sync.badge.not_synced": "Not synced",
        "tripletex_sync.badge.blocked": "Blocked",
        "tripletex_sync.badge.error": "Sync failed",
        "tripletex_sync.badge.pending": "Pending",
        "tripletex_sync.dialog.open": "Open Tripletex sync",
        "tripletex_sync.dialog.synced_body": "The project is synced with Tripletex.",
        "table_view.no_value": "No value",
        "table_view.empty_title": "Nothing found",
        "table_view.empty_subtitle": "Try adjusting your filters or search query.",
        "table_view.loading_more": "Loading more…",
        "table_view.rows_shown": "{{count}} rows shown",
        "table_view.columns": "Columns",
        "table_view.show_reorder_columns": "Show & reorder columns",
        "table_view.locked": "locked",
        "table_view.view_name_prompt": "Name of view",
        "table_view.new_view": "New view",
        "table_view.unsaved_changes": "Unsaved changes",
        "table_view.update_view": "Update this view",
        "table_view.save_as_new": "Save as new view…",
        "table_view.delete_view": "Delete view",
        "table_view.view_tabs": "Views",
        "Assigned": "Assigned",
        "Delete": "Delete",
        "Priority": "Priority",
        "Number": "Number",
        "Case": "Case",
        "Details": "Details",
        "History": "History",
        "Due date": "Due date",
        "Saved": "Saved",
        "Could not save changes": "Could not save changes",
        "Mangler tittel": "No title",
        "Ikke tildelt": "Unassigned",
        "Overview": "Overview",
        "Customer / Project": "Customer / Project",
        "Deviation": "Deviation",
        "Deviations": "Deviations",
        "Statuses": "Statuses",
        "Deviation Types": "Deviation Types",
        "Priorities": "Priorities",
        "Checklist": "Checklist",
        "Sjekklister": "Checklists",
        "Uten tittel": "Untitled",
        "Type mangler": "Type missing",
        "Ikke knyttet": "Not linked",
        "Avvik": "Deviation",
        "Appointment": "Appointment",
        "project_selector.favorites": "Favorites",
        "project_selector.suggested": "Suggested projects",
        "project_selector.search_results": "Search results",
        "project_selector.projects": "Projects",
        "project_selector.no_projects_found": "No projects found",
        "project_selector.no_projects_to_show": "No projects to show",
        "project_selector.offer": "Offer",
        "project_selector.sub_of": "Under",
        "folder_selector.none": "None selected",
        "folder_selector.project_required": "Project ID is required",
        "folder_selector.scope_kind": "Project",
        "folder_selector.search_placeholder": "Search folders…",
        "folder_selector.new_folder": "New folder",
        "folder_selector.new_folder_default": "New folder",
        "folder_selector.new_subfolder": "New subfolder",
        "folder_selector.rename": "Rename",
        "folder_selector.delete": "Delete",
        "folder_selector.delete_title": "Delete “{{name}}”?",
        "folder_selector.delete_desc": "Files move to the parent folder (or project root) and are not deleted. This cannot be undone.",
        "folder_selector.delete_desc_children": "This also deletes {{count}} nested folder(s). Files move to the parent folder (or project root) and are not deleted.",
        "folder_selector.empty": "No folders yet — create one to get started.",
        "folder_selector.no_match": "No folders match “{{query}}”.",
        "folder_selector.select_hint": "Select a folder",
        "folder_selector.selected_count": "folder(s) selected",
        "folder_selector.clear": "Clear",
        "folder_selector.select": "Select",
        "folder_selector.expand": "Expand",
        "folder_selector.collapse": "Collapse",
        "folder_selector.deselect": "Deselect",
        "folder_selector.create_failed": "Could not create folder",
        "folder_selector.rename_failed": "Could not rename folder",
        "folder_selector.delete_failed": "Could not delete folder",
        "folder_selector.move_failed": "Could not move folder",
        "project_list.scope.projects": "Projects",
        "project_list.scope.offers": "Offers",
        "project_list.scope.all": "All",
        "project_list.filter.placeholder_status": "Status",
        "project_list.filter.placeholder_manager": "Project manager",
        "project_list.filter.placeholder_tags": "Status tags",
        "project_list.column.status_tags": "Status tag",
        "project_list.status_tags.save_error": "Could not save status tag",
        "project.status_tags.title": "Status tags",
        "project.status_tags.hint": "Add or change tags without opening edit.",
        "project.status_tags.empty": "No status tags",
        "project.status_tags.save_error": "Could not save status tag",
        "case_list.filter.tags": "Labels",
        "case_list.search_placeholder": "Search cases (e.g., case number)…",
        "case_list.filter_title": "Filter cases",
        "report_list.search_placeholder": "Search reports…",
        "report_list.filter_title": "Filter reports",
        "report_list.filter.placeholder_customer": "Customer",
        "report_list.filter.placeholder_project": "Project",
        "report_list.filter.placeholder_type": "Report type",
        "report_list.filter.placeholder_date": "Date range",
        "customer_list.search_placeholder": "Search customers…",
        "customer_list.filter_title": "Filter customers",
        "customer_list.filter.placeholder_email": "Email",
        "customer_list.filter.placeholder_address": "Address",
        "customer_list.filter.placeholder_sync": "Sync status",
        "customer_list.filter.placeholder_tags": "Tags",
        "customer_list.filter.placeholder_type": "Customer type",
        "customer_list.filter.placeholder_region": "Region",
        "contact_list.search_placeholder": "Search contacts…",
        "contact_list.filter_title": "Filter contacts",
        "contact_list.filter.placeholder_customer": "Customer",
        "contact_list.filter.placeholder_company": "Company",
        "contact_list.filter.placeholder_role": "Role",
        "contact_list.filter.placeholder_tags": "Tags",
        "contact_list.filter.placeholder_sync": "Sync status",
        "contact_list.filter.placeholder_status": "Status",
        "project_list.badge.offer": "Offer",
        "project_list.badge.subproject": "Subproject",
        "project_list.sub_of": "Part of",
        "project_list.financials.contract_sum": "Contract sum",
        "project_list.financials.invoiced": "Invoiced",
        "project_list.financials.costs": "Costs",
        "project_list.financials.result_margin": "Result / margin",
        "project_list.financials.remaining": "Remaining",
        "project.parent_project": "Parent project",
        "project.parent_project.none": "No parent project",
        "Case guide": "Case guide",
        "Guider": "Guides",
        "Guider tilgjengelig": "Guides available",
        "guider": "guides",
        "Velg hvilken guide du vil bruke for etterspurt info.": "Choose which guide to use for requested info.",
        "Velg hvilken guide du vil starte for denne saken.": "Choose which guide to start for this case.",
        "Dupliser guide": "Duplicate guide",
        "kopi": "copy",
        "Uten navn": "Untitled",
        "Rapportguide": "Report guide",
        "Rapportguider": "Report guides",
        "Opprett og rediger guidede flyter for rapportarbeid.": "Create and edit guided flows for report work.",
        "Guideomfang": "Guide scope",
        "Velg om du vil redigere generelle rapportguider eller guider for en spesifikk rapporttype.": "Choose whether to edit general report guides or guides for a specific report type.",
        "Tilbake til serviceinnstillinger": "Back to service settings",
        "Generelle rapportguider": "General report guides",
        "Opprett og rediger guidede flyter for rapportarbeid på egen side.": "Create and edit guided report flows on a dedicated page.",
        "Åpne rapportguider": "Open report guides",
        "Caseguider": "Case guides",
        "Opprett og rediger guidede flyter for saker.": "Create and edit guided flows for cases.",
        "Guideomfang case": "Guide scope (case type)",
        "Velg case type for å redigere guideflyten.": "Select a case type to edit its guide flow.",
        "Case guides scope intro":
          "Choose whether to edit general case guides (all types) or guides scoped to one case type — same pattern as report guides.",
        "Generelle caseguider": "General case guides",
        "Generell caseguide": "General",
        "Case guide scope general hint": "Configure flows that apply to every case type.",
        "Case guide scope type hint":
          "Type-specific guides are listed first, followed by general guides that apply to all types.",
        "Tilbake til caseinnstillinger": "Back to case settings",
        "Åpne caseguider": "Open case guides",
        "Opprett og rediger guidede flyter for saker på egen side.": "Create and edit guided case flows on a dedicated page.",
        "Ingen case typer er opprettet ennå.": "No case types have been created yet.",
        "Caseguide-bygger på egen side": "The case guide flow builder opens on a dedicated page.",
        "Åpne guidebygger": "Open guide builder",
        "Case guide options connect to effect nodes":
          "Answer options only store label and value. Use Connect on an option to link to an effect node on the canvas (labels, priority, due date, etc.).",
        "Velg rapportguide": "Select report guide",
        "Velg guiden som passer best med oppdraget.": "Select the guide that best fits the assignment.",
        "Velg guide": "Select guide",
        "Ny rapportguide": "New report guide",
        "Ny guide": "New guide",
        "Inaktiv": "Inactive",
        "Generell": "General",
        "Generell rapportguide": "General report guide",
        "Kan brukes på alle rapporttyper": "Can be used on all report types",
        "spørsmål": "questions",
        "Avslutt etter dette svaret": "End after this answer",
        "Guide builder": "Guide builder",
        "Effekter": "Effects",
        "Effekt": "Effect",
        "Effect-node": "Effect node",
        "Guide flow palette effect id line": "Adds a canvas node with this effect id:",
        "Guide flow effect editor palette link": "Same palette block / effect id",
        "Guide flow option connection": "This answer connects to",
        "Rapporttekst": "Report text",
        "Intern tekst": "Internal text",
        "Case oppfølging": "Case follow-up",
        "Sjekkliste": "Checklist",
        "Videre": "Continue",
        "Avslutt etter denne effekten": "End after this effect",
        "Rediger effekt": "Edit effect",
        "Opprett spørsmål som noder og koble svar til neste spørsmål.": "Create questions as nodes and connect answers to the next question.",
        "Dra inn eller klikk for å opprette.": "Drag in or click to create.",
        "Guide flow": "Guide flow",
        "guide.flow.json_dialog_title": "Guide flow — JSON & AI instructions",
        "guide.flow.json_tab": "JSON",
        "guide.flow.ai_guide_tab": "AI instructions",
        "guide.flow.json_hint":
          "Edges are rebuilt automatically from option `next_node_id` and effect `next_node_id`. Paste valid JSON or edit below, then apply.",
        "guide.flow.copy_json": "Copy JSON",
        "guide.flow.apply_json": "Apply to canvas",
        "guide.flow.reload_from_canvas": "Reload from canvas",
        "guide.flow.reload_from_canvas_success": "Editor synced from current canvas.",
        "guide.flow.copy_json_success": "JSON copied to clipboard.",
        "guide.flow.clipboard_failed": "Could not access clipboard.",
        "guide.flow.json_invalid": "Invalid JSON or flow: {{message}}",
        "guide.flow.json_applied": "Guide flow updated.",
        "guide.flow.copy_ai_guide": "Copy AI authoring guide",
        "guide.flow.ai_guide_copied": "AI authoring guide copied.",
        "guide.flow.ai_empty": "AI returned empty flow JSON.",
        "guide.flow.ai_applied": "Guide flow updated from AI.",
        "guide.flow.open_json": "JSON",
        "guide.flow.open_json_tooltip": "View, copy, paste, or edit the guide flow as JSON",
        "guide.flow.generate_with_ai": "Generate with AI",
        "guide.flow.ai_guide_intro":
          "Paste these instructions into external AI tools or use Promang's built-in generator. Technical keys match `settings.flow` in the API.",

        "Velg neste spørsmål for valgt svar.": "Select the next question for the selected answer.",
        "Koble svar til neste spørsmål ved å bruke Koble-knappen på et svar.": "Connect an answer to the next question by using the Connect button on an answer.",
        "Nytt spørsmål": "New question",
        "Koble": "Connect",
        "Koble om": "Reconnect",
        "Slett kobling": "Delete connection",
        "Sett som start": "Set as start",
        "Rediger spørsmål": "Edit question",
        "Svarvalg": "Answer options",
        "Velg en node for å redigere.": "Select a node to edit.",
        "Tid": "Time",
        "Guidet rapport": "Guided report",
        "Ingen rapportguide er tilgjengelig": "No report guide is available",
        "Rapportguide lagret": "Report guide saved",
        "Guiden kan fylle rapporttekst og lagrer svar for administrasjon.": "The guide can fill report text and saves answers for administration.",
        "Lagre rapporttypen før du konfigurerer guide.": "Save the report type before configuring a guide.",
        "Konfigurer spørsmål som kan fylle rapporttekst og lagre svar for administrasjon.": "Configure questions that can fill report text and save answers for administration.",
        "Ta med svar i rapporttekst": "Include answer in report text",
        "Rapporttekst ved valg": "Report text for option",
        "Intern tekst ved valg": "Internal text for option",
        "Case oppfølging tittel": "Case follow-up title",
        "Case oppfølging tekst": "Case follow-up text",
        "Krever tiltak": "Requires action",
        "Reklamasjon": "Complaint",
        "Ingen sjekkliste": "No checklist",
        "Opprett sjekkliste": "Create checklist",
        "Opprett oppfølger": "Create follow-up",
        "Oppfølger beskrivelse": "Follow-up description",
        "Oppfølger intern beskrivelse": "Follow-up internal description",
        "Ingen sjekkliste på oppfølger": "No checklist on follow-up",
        "Opprett avtale på oppfølger": "Create appointment on follow-up",
        "Bruk samme avtaledato og tid som nåværende rapport": "Use the same appointment date and time as the current report",
        "Guidet case-opprettelse": "Guided case creation",
        "Etterspørre info": "Request info",
        "Etterspurt info": "Requested info",
        "Guidet opprettelse": "Guided creation",
        "Spørsmål": "Question",
        "Steg": "Step",
        "Oppsummering": "Summary",
        "guide.case_view_summary": "Review summary",
        "guide.case_summary_review_intro": "Check your answers before applying the guide.",
        "guide.case_chain_effect_title": "Start another case guide",
        "guide.case_chain_effect_help":
          "After this guide is applied, the selected guide opens automatically on the same case (current guide finishes first).",
        "guide.case_chain_pick_guide": "Next guide",
        "guide.case_chain_none": "— none —",
        "guide.case_chain_started": "Opening the next guide…",
        "guide.case_chain_summary_hint":
          "After you apply this guide, another guide will start automatically on the same case.",
        "Ingen guide-spørsmål er konfigurert.": "No guide questions are configured.",
        "Guiden foreslår": "The guide suggests",
        "etiketter": "labels",
        "Bruk guide": "Apply guide",
        "Åpne guide": "Open guide",
        "Tilbake": "Back",
        "Besvart": "Answered",
        "Automatiske etiketter brukt": "Automatic labels applied",
        "Automatiske etiketter lagt til": "Automatic labels added",
        "Antall": "Count",
        "Denne case typen krever guide før opprettelse": "This case type requires the guide before creation",
        "Fyll ut guide": "Complete guide",
        "Fyll ut guiden før saken opprettes": "Complete the guide before creating the case",
        "besvarte etterspurt info": "answered requested info",
        "fullførte guide": "completed guide",
        "Konfigurer spørsmål, valg og automatiske etiketter for denne case typen.": "Configure questions, choices and automatic labels for this case type.",
        "Lagre case type før du konfigurerer guide.": "Save the case type before configuring a guide.",
        "Guide title": "Guide title",
        "Guide description": "Guide description",
        "Aktiv": "Active",
        "Legg til spørsmål": "Add question",
        "Lagre guide": "Save guide",
        "Spørsmålstekst": "Question text",
        "Påkrevd": "Required",
        "Valg": "Option",
        "Valg 1": "Option 1",
        "Valg label": "Option label",
        "Verdi": "Value",
        "Fjern valg": "Remove option",
        "Automatiske etiketter": "Automatic labels",
        "Legg til valg": "Add option",
        "Select case type": "Select case type",
        "Case Type": "Case type",
        "No results": "No results",
        "Select case type first": "Select case type first",
        "No guide configured for this case type": "No guide configured for this case type",
        "Ny case": "New case",
        "Velg case type først. Guiden hjelper deg å stille riktige spørsmål og foreslår etiketter automatisk.": "Select the case type first. The guide helps ask the right questions and suggests labels automatically.",
        "Title and case type are required": "Title and case type are required",
        "Case type is required": "Case type is required",
        "Velg case type først. Tittel genereres automatisk med AI etter opprettelse.": "Select the case type first. The title is generated automatically with AI after creation.",
        "Guide åpnes etter opprettelse": "Guide opens after creation",
        "Etter opprettelse": "After creation",
        "Velg case type først. Hvis typen har en guide kan du besvare den før saken opprettes.": "Select the case type first. If the type has a guide, you can answer it before the case is created.",
        "Valgfri guide for denne case typen": "Optional guide for this case type",
        "Type": "Type",
        "Detaljer": "Details",
        "Velg type": "Select type",
        "Saksdetaljer": "Case details",
        "Guide besvart": "Guide answered",
        "Klar til opprettelse": "Ready to create",
        "Se guide igjen": "Open guide again",
        "Start guide": "Start guide",
        "Hva slags case oppretter du?": "What kind of case are you creating?",
        "Case typen styrer hvilke spørsmål og automatiske forslag som vises.": "The case type controls which questions and automatic suggestions are shown.",
        "Guide": "Guide",
        "Ikke brukt": "Not used",
        "Ja": "Yes",
        "Nei": "No",
        "templates.title": "Templates",
        "templates.new": "New template",
        "templates.edit": "Edit template",
        "templates.empty": "No templates found.",
        "templates.search_placeholder": "Search templates...",
        "templates.editor_placeholder": "Write the template content...",
        "templates.editor_hint": "Create reusable rich text content and connect it to a category.",
        "templates.form.title": "Template details",
        "templates.form.subtitle": "Give the template a clear title, category and rich text content.",
        "templates.insert.append": "Paste together with existing text",
        "templates.insert.replace": "Replace the whole text",
        "templates.insert.use": "Use template",
        "templates.hero.kicker": "Content library",
        "templates.hero.subtitle": "Organize reusable text templates in categories and insert them from rich text editors.",
        "templates.filters.heading": "Search and filters",
        "templates.filters.description": "Search templates or filter by category.",
        "templates.categories.title": "Categories",
        "templates.categories.all": "All templates",
        "templates.categories.new": "New category",
        "templates.categories.edit": "Edit category",
        "templates.categories.name": "Name",
        "templates.categories.parent": "Parent category",
        "templates.categories.no_parent": "No parent category",
        "templates.categories.description": "Description",
        "templates.categories.uncategorized": "Uncategorized",
        "templates.section.kicker": "Templates",
        "templates.section.title": "All templates",
        "templates.section.subtitle": "Choose a category to see only templates connected to it.",
        "templates.section.category_title": "Category templates",
        "templates.section.category_subtitle": "Templates connected to the selected category.",
        "company.settings.tabs.company": "Company",
        "company.settings.tabs.employment_agreement": "Employment agreement",
        "company.settings.tabs.employee_positions": "Employee positions",
        "company.integrations.title": "Integrations",
        "company.integrations.subtitle": "Services, API apps and webhooks for the company",
        "company.integrations.tabs.services": "Services",
        "company.integrations.tabs.apps": "API apps",
        "company.integrations.tabs.webhooks": "Webhooks",
        "company.integrations.status.connected": "Connected",
        "company.integrations.status.missing": "Setup missing",
        "company.integrations.events": "Events",
        "company.integrations.show": "Show",
        "company.integrations.hide": "Hide",
        "company.integrations.copy": "Copy",
        "company.integrations.copied": "Copied",
        "company.integrations.sync_tripletex": "Sync Tripletex with Promang",
        "company.integrations.delete_tripletex_subscriptions": "Delete Tripletex subscriptions",
        "company.integrations.delete_tripletex_body": "Are you sure you want to delete Tripletex subscriptions?",
        "company.integrations.sync_products_title": "Product sync",
        "company.integrations.sync_products_body": "Are you sure you want to sync products now?",
        "company.integrations.sync_success": "Sync completed",
        "company.integrations.tripletex.title": "Tripletex API",
        "company.integrations.tripletex.description": "Connect Promang to Tripletex",
        "company.integrations.bring.title": "Bring API",
        "company.integrations.bring.description": "Connect Promang to Bring",
        "company.integrations.stripe.title": "Stripe API",
        "company.integrations.stripe.description": "Connect Promang to Stripe",
        "company.integrations.automile.title": "Automile API",
        "company.integrations.automile.description": "Connect Promang to Automile",
        "company.integrations.google_maps.title": "Google Maps API",
        "company.integrations.google_maps.description": "Connect Promang to Google Maps",
        "company.integrations.webshop.title": "Webshop",
        "company.integrations.webshop.description": "Connect Promang to the webshop",
        "company.integrations.phonero.title": "Phonero API",
        "company.integrations.phonero.description": "Connect Promang to Phonero for calls",
        "company.integrations.fields.tripletex_employee_token": "Tripletex employee token",
        "company.integrations.fields.tripletex_hour_sync_if_approved_only": "Sync only approved hours",
        "company.integrations.fields.bring_api_uid": "Bring API UID",
        "company.integrations.fields.bring_api_key": "Bring API key",
        "company.integrations.fields.bring_main_customer_number": "Bring main customer number",
        "company.integrations.fields.stripe_webhook_secret": "Stripe webhook secret",
        "company.integrations.fields.stripe_webhook_url": "Stripe webhook URL",
        "company.integrations.fields.stripe_secret_key": "Stripe secret key",
        "company.integrations.fields.automile_client_id": "Automile client ID",
        "company.integrations.fields.automile_client_secret": "Automile client secret",
        "company.integrations.fields.automile_username": "Automile username",
        "company.integrations.fields.automile_password": "Automile password",
        "company.integrations.fields.google_maps_api_key": "Google Maps API key",
        "company.integrations.fields.store_checkout_active": "Webshop checkout enabled",
        "company.integrations.fields.webshop_products_url": "Webshop products URL",
        "company.integrations.fields.webshop_order_cancel_url": "Order cancel URL",
        "company.integrations.fields.webshop_order_success_url": "Order success URL",
        "company.integrations.fields.phonero_username": "Phonero username",
        "company.integrations.fields.phonero_password": "Phonero password",
        "company.integrations.fields.phonero_customer_id": "Phonero customer ID",
        "company.oauth_apps.intro": "Create OAuth clients that external apps use to call the Promang API. The company owns the app and can roll keys.",
        "company.oauth_apps.new": "New API app",
        "company.oauth_apps.name": "Name",
        "company.oauth_apps.redirect": "Redirect URI",
        "company.oauth_apps.scopes": "Scopes",
        "company.oauth_apps.create": "Create app",
        "company.oauth_apps.created": "API app created",
        "company.oauth_apps.empty": "No API apps yet.",
        "company.oauth_apps.secret_once": "Save the uid and secret now. The secret is shown only this time.",
        "company.oauth_apps.roll": "Roll keys",
        "company.oauth_apps.rolled": "Keys rolled",
        "company.oauth_apps.delete": "Delete",
        "company.oauth_apps.deleted": "App deleted",
        "company.oauth_apps.deleted_badge": "Deleted",
        "company.oauth_apps.confirm_name": "Confirm name",
        "company.oauth_apps.load_failed": "Could not load API apps",
        "company.oauth_apps.create_failed": "Could not create API app",
        "company.oauth_apps.roll_failed": "Could not roll keys",
        "company.oauth_apps.delete_failed": "Could not delete app",
        "company.oauth_apps.delete_name_mismatch": "Type the app name to delete it",
        "cases.weply.type": "Weply",
        "cases.weply.other_fields": "Other fields",
        "cases.weply.session": "Conversation",
        "company.webhooks.weply_title": "Connect an external system",
        "company.webhooks.weply_step1": "Create an inbound webhook and choose which modules it may access.",
        "company.webhooks.weply_step2": "In the external system: turn on outbound webhooks or integrations.",
        "company.webhooks.weply_step3": "Paste the Promang URL as the destination.",
        "company.webhooks.weply_step4": "Set header X-Promang-Webhook-Secret to the key from Promang.",
        "company.webhooks.connect_title": "How to connect an external system",
        "company.webhooks.connect_step1": "Create an inbound webhook and choose which modules it may access.",
        "company.webhooks.connect_step2": "In the external system: turn on outbound webhooks or integrations.",
        "company.webhooks.connect_step3": "Paste the Promang URL as the destination.",
        "company.webhooks.connect_step4": "Set header X-Promang-Webhook-Secret to the key from Promang.",
        "company.webhooks.provider_lead": "Lead / chat",
        "company.webhooks.guide_title": "What can webhooks be used for?",
        "company.webhooks.guide_intro": "Webhooks connect Promang to other systems. Inbound receives data and creates records in the modules you grant. Outbound sends Promang events to a URL you own.",
        "company.webhooks.guide_inbound": "An external system POSTs to the Promang URL. With access, the webhook can create a customer, contact and case (the message appears as its own card on the case). The same conversation (session) is appended to the existing case.",
        "company.webhooks.guide_outbound": "When a customer or contact is created, updated or deleted, Promang sends a signed JSON request to the target URL.",
        "company.webhooks.supported_now": "Supported now",
        "company.webhooks.coming_soon": "Coming later",
        "company.webhooks.modules_label": "Modules this webhook can access",
        "company.webhooks.modules_help": "Choose what this webhook may create (in) or send (out). Case and contact require customer.",
        "company.webhooks.labels_label": "Labels on new cases",
        "company.webhooks.labels_help": "Choose the company case labels to apply automatically when this webhook creates a case. Create the label first, for example “Lead”.",
        "company.webhooks.custom_fields_help": "All fields except the transcript/message (name, email, phone, User Agent, Agent Name …) are stored as custom fields on the case.",
        "company.webhooks.labels_manage": "Manage labels",
        "company.webhooks.labels_pick": "Choose labels",
        "company.webhooks.modules_blank": "Select at least one module.",
        "company.webhooks.module.customer": "Customer",
        "company.webhooks.module.contact": "Contact",
        "company.webhooks.module.case": "Case",
        "company.webhooks.module.project": "Project",
        "company.webhooks.module.order": "Order",
        "company.webhooks.module.report": "Service report",
        "company.webhooks.new": "New webhook",
        "company.webhooks.name": "Name",
        "company.webhooks.provider": "Provider",
        "company.webhooks.generic": "Generic",
        "company.webhooks.direction": "Direction",
        "company.webhooks.inbound": "Inbound",
        "company.webhooks.outbound": "Outbound",
        "company.webhooks.target_url": "Target URL",
        "company.webhooks.create": "Create webhook",
        "company.webhooks.created": "Webhook created",
        "company.webhooks.empty": "No webhooks yet.",
        "company.webhooks.secret_once": "Save the URL and key now. The key is shown only this time.",
        "company.webhooks.header": "Header",
        "company.webhooks.roll": "Roll key",
        "company.webhooks.rolled": "Key rolled",
        "company.webhooks.enable": "Enable",
        "company.webhooks.disable": "Disable",
        "company.webhooks.test": "Test",
        "company.webhooks.log": "Log",
        "company.webhooks.delete": "Delete",
        "company.webhooks.deleted": "Webhook deleted",
        "company.webhooks.load_failed": "Could not load webhooks",
        "company.webhooks.create_failed": "Could not create webhook",
        "company.webhooks.update_failed": "Could not update webhook",
        "company.webhooks.roll_failed": "Could not roll key",
        "company.webhooks.delete_failed": "Could not delete webhook",
        "company.webhooks.test_queued": "Test queued",
        "company.webhooks.test_failed": "Test failed",
        "company.webhooks.deliveries_failed": "Could not load delivery log",
        "company.employee_positions.help": "Shared position catalog for the company. Used in task templates and employment records.",
        "company.employee_positions.saved": "Employee positions saved",
        "company.employee_positions.employment_link": "Link positions to employees under Users → Employment.",
        "company.employee_positions.employment_link_action": "Go to users",
        "company.employment_agreement.title": "Standard agreement text",
        "company.employment_agreement.description": "This text is included as shared agreement text in the employment contract PDF for employees.",
        "company.employment_agreement.placeholder": "Write standard employment agreement text...",
        "payslips.kicker": "Tripletex payroll",
        "payslips.title": "Payroll",
        "payslips.mine_title": "My payslips",
        "payslips.admin_title": "Payslips",
        "payslips.stats_title": "Statistics",
        "payslips.description": "View payslips made available from Tripletex without signing in to Tripletex.",
        "payslips.admin_description": "Manage and filter employee payslips. Requires the Payroll Admin role (company administrators only see their own payslips unless assigned Payroll Admin).",
        "payslips.stats_description": "Overview of payslips included in the totals below (your own slips unless you have Payroll Admin).",
            "payslips.admin_forbidden": "You need the Payroll Admin role to manage all payslips for the company. Ask an administrator to assign Payroll Admin for this company.",
            "payslips_admin": "Payroll Admin",
        "payslips.role_view_override_warning":
          "Role view simulation is active — it only changes menus/UI. The API still uses your real roles. Turn off role view (DevOps menu) to match permissions, or ignore this if you are testing intentionally.",
        "payslips.loading": "Loading payslips...",
        "payslips.empty": "No payslips are available yet.",
        "payslips.error": "Could not fetch payslips.",
        "payslips.period": "Period",
        "payslips.employee": "Employee",
        "payslips.voucher_date": "Voucher date",
        "payslips.available_date": "Available",
        "payslips.gross_amount": "Gross",
        "payslips.amount": "Net",
        "payslips.actions": "Actions",
        "payslips.open": "Open",
        "payslips.opening": "Opening...",
        "payslips.sync_now": "Sync now",
        "payslips.syncing": "Syncing...",
        "payslips.pdf_failed": "Could not open the payslip. Try again.",
        "payslips.sync_failed": "Could not start payslip sync. Try again.",
        "payslips.employee_filter": "Employee",
        "payslips.stats_count": "Payslips",
        "payslips.stats_gross": "Gross total",
        "payslips.stats_net": "Net total",
        "payslips.stats_average_net": "Average net",
        "listbox.none": "Not selected",
        "user_info.address": "Address",
        "user_info.address_hint": "Saved on the user profile and used as address basis in the employment flow.",
        "user_employment.option_not_selected": "Not selected",
        "user_employment.section_basic": "Employment basis",
        "user_employment.section_basic_hint": "Core data for the employment relationship and employment contract.",
        "user_employment.employee_number": "Employee number",
        "user_employment.employment_starts": "Employment starts",
        "user_employment.employment_ends": "End date",
        "report.previous_work.title": "Previous work",
        "report.previous_work.hint": "Short overview at this customer",
        "report.previous_work.empty": "No previous reports found.",
        "report.previous_work.fallback": "Report {{number}}",
        "report.previous_work.open": "View previous work",
        "report.previous_work.dialog_title": "Previous work",
        "report.previous_work.ai_title": "AI overview",
        "report.previous_work.ai_generating": "Updating…",
        "report.previous_work.ai_error": "Could not load the overview.",
        "report.previous_work.ai_empty": "No AI overview yet.",
        "report.previous_work.show_less": "Show less",
        "report.previous_work.show_more": "Show more",
        "report.previous_work.see_more": "Show more",
        "report.previous_work.see_report": "View report",
        "report.previous_work.see_checklist": "View checklist",
        "report.previous_work.images": "Images",
        "report.previous_work.report_label": "Report {{number}}",
        "report.previous_work.different_facility": "Other facility",
        "report.previous_work.different_facility_hint": "This work belongs to another facility at the customer.",
        "report.previous_work.jobs_heading": "Previous jobs",
        "report.previous_work.load_error": "Could not load previous work.",
        "report.previous_work.back_to_overview": "Back to overview",
        "report.previous_work.crumb_overview": "Overview",
        "report.previous_work.crumb_report": "Report {{number}}",
        "report.previous_work.crumb_checklist": "Checklist {{number}}",
        "report.previous_work.facility_history_title": "Facility history",
        "report.previous_work.facility_history_empty": "No previous reports for this facility.",
        "report.previous_work.panel_load_error": "Could not load this content.",
        "report.previous_work.open_full_report": "Open the full report",
        "report.previous_work.no_checklist": "No checklist on this report.",
        "report.previous_work.checklist_ok": "Approved",
        "report.previous_work.checklist_deviation": "Deviation",
        "report.active_agreement.chip": "Active service agreement {{number}}",
        "module_overview.tab.reports": "Reports",
        "module_overview.tab.agreements": "Service agreements",
        "module_overview.tab.orders": "Orders",
        "module_overview.tab.projects": "Projects",
        "module_overview.hide_details": "Hide details",
        "module_overview.show_details": "Show details",
        "module_overview.select_tab": "Select tab",
        "module_overview.go_to_customer": "Go to customer",
        "module_overview.filter_reports": "Filter reports",
        "module_overview.filter_agreements": "Filter agreements",
        "module_overview.filter_projects": "Filter projects",
        "module_overview.search_projects": "Search projects…",
        "customer.systems.tab": "Facilities",
        "customer.systems.overview_title": "Customer facilities",
        "customer.systems.overview_hint": "Facilities and systems linked to the customer.",
        "customer.systems.add": "Add facility",
        "customer.systems.add_from_case": "Add facility",
        "customer.systems.empty": "No facilities registered yet.",
        "customer.systems.no_meta": "No placement or serial number",
        "customer.systems.other_comment": "Other comment",
        "customer.systems.history": "History",
        "customer.systems.spare_parts": "Spare parts",
        "customer.systems.no_product_selected": "Select a product first.",
        "customer.systems.select_existing": "Select existing facility",
        "customer.systems.select_existing_hint": "Link a facility that already exists on this customer.",
        "customer.systems.create_new": "Create new facility",
        "customer.systems.choose": "Select",
        "customer.systems.detach": "Detach",
        "customer.systems.missing_customer": "Missing customer — cannot show facilities.",
        "customer.systems.dialog.view_title": "Facility",
        "customer.systems.dialog.edit_title": "Edit facility",
        "customer.systems.dialog.create_title": "New facility",
        "customer.systems.mode.existing": "Choose existing",
        "customer.systems.mode.create": "Create new",
        "customer.systems.search_existing": "Search facilities…",
        "customer.systems.no_existing_match": "No facilities match your search.",
        "customer.systems.existing_count": "{{count}} facilities registered on this customer",
        "customer.systems.open_product": "Open product",
        "customer.systems.form.equipment": "Equipment",
        "customer.systems.form.location": "Location",
        "customer.systems.form.dates": "Years",
        "customer.systems.form.notes": "Notes",
        "customer.systems.card_title": "Facility",
        "customer.systems.status.linked": "Linked",
        "customer.systems.status.missing": "Missing",
        "customer.systems.status.required": "Required",
        "customer.systems.status.not_required": "Not required",
        "customer.systems.address": "Address",
        "customer.systems.not_linked": "Not linked",
        "customer.systems.attach": "Link facility",
        "customer.systems.select_product": "Select a product",
        "customer.systems.none_selected": "None selected",
        "customer.systems.merge": "Merge duplicate",
        "customer.systems.merge_title": "Merge facility into another",
        "customer.systems.merge_hint": "Everything on “{{name}}” moves to the selected facility. This facility is removed.",
        "customer.systems.merge_choose_target": "Select the facility to keep",
        "customer.systems.merge_confirm": "Merge and remove",
        "customer.systems.merge_cancel": "Cancel",
        "customer.systems.merge_working": "Merging…",
        "customer.systems.merge_success": "Facilities merged",
        "customer.systems.merge_error": "Could not merge the facilities",
        "case.transfer.action": "Transfer case",
        "case.transfer.title": "Transfer case",
        "case.transfer.intro": "Move information to another case in the same company.",
        "case.transfer.same_customer_heading": "Open cases for the same customer",
        "case.transfer.no_same_customer": "No other open cases for this customer.",
        "case.transfer.no_customer_hint": "This case has no customer, so you must search the whole company.",
        "case.transfer.search_heading": "Search the company",
        "case.transfer.search_button": "Search for a case",
        "case.transfer.confirm_title": "Confirm transfer",
        "case.transfer.confirm_summary": "Transfer from {{source}} to {{target}}.",
        "case.transfer.confirm_effects": "The source case is closed and marked as transferred.",
        "case.transfer.different_customer_warning": "The target case belongs to another customer.",
        "case.transfer.note_label": "Note",
        "case.transfer.note_placeholder": "Optional note for the transfer…",
        "case.transfer.confirm_button": "Transfer",
        "case.transfer.success": "The case was transferred.",
        "case.transfer.error": "Could not transfer the case.",
        "case.transfer.banner_out": "Transferred to",
        "case.transfer.banner_in": "Received from",
        "case.transfer.tag_out": "Transferred",
        "case.transfer.tag_in": "Received transfer",
        "case.transfer.tag_in_count": "Received transfer ({{count}})",
        "case.siblings.title": "{{count}} other open cases for this customer",
        "case.siblings.hint": "Check whether this is already being followed up elsewhere.",
        "case.siblings.more": "{{count}} more cases",
        "case.siblings.tag": "{{count}} open cases",
        "case.relations.tags_label": "Related cases",
        "absence.overview.title": "Absence — overview",
        "absence.overview.employee": "Employee",
        "absence.stats.load_failed": "Something went wrong when trying to load the stats",
        "work_stats.loading": "Loading work stats…",
        "cases.create.dialog_title": "New case",
        "cases.create.dialog_hint": "Enter only what is needed to create. You edit the case afterwards on the case page.",
        "cases.create.type_required": "Case type is required",
        "cases.create.description_placeholder": "Short description…",
        "employment.end_date.badge": "Ends {{date}}",
        "employment.end_date.ended_badge": "Ended {{date}}",
        "employment.end_date.until": "until {{date}}",
        "employment.end_date.plan_blocked": "{{name}} ended on {{date}} and cannot be planned on or after that day.",
        "employment.end_date.hours_blocked": "Cannot register hours after the end date ({{date}}).",
        "user_employment.social_security": "National identity number",
        "user_employment.working_posistion": "Position",
        "user_employment.employee_position_none": "No position selected",
        "user_employment.workplace": "Workplace",
        "user_employment.agreement_type": "Agreement type",
        "user_employment.agreement_type_permanent": "Permanent",
        "user_employment.agreement_type_temporary": "Temporary",
        "user_employment.agreement_type_hourly": "On-call/hourly",
        "user_employment.agreement_type_seasonal": "Seasonal",
        "user_employment.agreement_type_other": "Other",
        "user_employment.section_worktime": "Working time",
        "user_employment.section_worktime_hint": "Time spans that can be used in the employment contract.",
        "user_employment.worktime_regular_from": "Regular from",
        "user_employment.worktime_regular_too": "Regular to",
        "user_employment.worktime_weekend_from": "Weekend from",
        "user_employment.worktime_weekend_too": "Weekend to",
        "user_employment.worktime_regular_range": "Regular working time",
        "user_employment.worktime_weekend_range": "Weekend work",
        "user_employment.section_wages": "Wages and additions",
        "user_employment.section_wages_hint": "Agreed wage terms. The salary table below remains available for history and time calculations.",
        "user_employment.wages": "Wages",
        "user_employment.wages_unit": "Wages per",
        "user_employment.wage_unit_hour": "Hour",
        "user_employment.wage_unit_month": "Month",
        "user_employment.wage_unit_year": "Year",
        "user_employment.wage_unit_fixed": "Fixed agreed",
        "user_employment.overtime_pay": "Overtime pay",
        "user_employment.dismissal": "Notice period",
        "user_employment.wage_other_addition": "Other additions",
        "user_employment.wage_weekend_and_night_addition": "Weekend/night addition",
        "user_employment.collective_agreement": "Collective agreement",
        "user_employment.section_contract_text": "Contract text",
        "user_employment.section_contract_text_hint": "Text fields used as basis for the employment contract and internal documentation.",
        "user_employment.employment_instructions": "Position instructions",
        "user_employment.employment_allowance": "Allowance",
        "user_employment.notes": "Notes",
        "user_employment.other": "Other",
        "user_employment.section_signature": "Signature and payment",
        "user_employment.section_signature_hint": "Signature and payment basis for the employment contract.",
        "user_employment.signed_place": "Signing place",
        "user_employment.signed_at": "Signing date",
        "user_employment.account_number": "Account number",
        "user_employment.hourly_costs_title": "Hourly rates and costs",
        "user_employment.section_contract_actions": "Employment contract",
        "user_employment.section_contract_actions_hint": "Printing and signing will use the contract basis once PDF/signing is available.",
        "user_employment.contract_actions_notice_title": "Ready for next phase",
        "user_employment.contract_actions_notice": "The data basis can now be filled in. Employment contract printing and Posten signing are connected in a separate implementation.",
        "user_employment.print_contract": "Print employment contract",
        "user_employment.print_contract_unavailable": "The PDF route for employment contracts is not connected yet.",
        "user_employment.send_to_signing": "Send for signing",
        "user_employment.signing_unavailable": "Posten signing is implemented by a separate agent.",
        "user_employment.contract_title": "Employment contract",
        "user_employment.contract_description": "Employment contract for digital signing",
        "user_employment.preview_contract_draft": "Preview employment contract draft",
        "user_employment.download_contract_draft_pdf": "Download draft PDF",
        "user_employment.draft_pdf_download_failed": "Could not download draft PDF.",
        "user_employment.contract_draft_label": "Draft",
        "user_employment.contract_draft_for": "For {{name}}",
        "user_employment.draft_notice_title": "Review before signing",
        "user_employment.draft_notice": "This is a preview based on saved and filled-in form fields. Save changes before sending for signing.",
        "user_employment.employee_name": "Employee",
        "signing.title": "Digital signing",
        "signing.description": "Send the document to Posten Signering and follow signer status.",
        "signing.new_request": "New signing request",
        "signing.empty": "No signing requests have been created yet.",
        "signing.sender_reference": "Reference",
        "signing.signer_name": "Signer name",
        "signing.national_identity_number": "National identity number / D-number",
        "signing.email": "Email",
        "signing.mobile": "Mobile",
        "signing.identity_warning": "Use national identity number/D-number when available. Email/SMS-only signing is valid, but Promang must verify that the right person signed.",
        "signing.send": "Send to signing",
        "signing.created": "Signing request created",
        "signing.refreshed": "Signing status refreshed",
        "signing.refresh_status": "Refresh status",
        "signing.download_signed": "Download signed PDF",
        "signing.errors.load_failed": "Could not load signing requests.",
        "signing.errors.create_failed": "Could not create signing request.",
        "signing.errors.poll_failed": "Could not refresh signing status.",
        "signing.errors.dispatch_unconfirmed": "Signing could not be confirmed. Start a new request.",
        "signing.errors.activation_failed": "The agreement could not be activated from the signed document.",
        "signing.errors.download_failed": "Could not download signed document.",
        "signing.status.draft": "Draft",
        "signing.status.queued": "Queued",
        "signing.status.sent": "Sent",
        "signing.status.in_progress": "In progress",
        "signing.status.completed": "Completed",
        "signing.status.failed": "Failed",
        "signing.status.rejected": "Rejected",
        "signing.status.expired": "Expired",
        "signing.status.cancelled": "Cancelled",
        "signing.status.waiting": "Waiting",
        "signing.status.available": "Available",
        "signing.status.signed": "Signed",
        "webpage.editor.open_live": "View live",
        "webpage.editor.open_live_title": "Open this page on the webshop (new tab)",
        "webpage.editor.open_live_title_unpublished":
          "Open the webshop URL. Publish the page so customers can see the content.",
        "webpage.editor.import_blocks": "JSON / AI",
        "webpage.editor.import_tooltip": "Paste JSON blocks or copy the AI prompt",
        "webpage.editor.import_dialog_title": "Import blocks or AI guide",
        "webpage.editor.import_tab_paste": "Paste JSON",
        "webpage.editor.import_tab_guide": "AI instructions (copy)",
        "webpage.editor.import_hint":
          "Paste JSON as { \"blocks\": [ ... ] }, a raw array, or exported shape with content.blocks. Wrapping in ```json ... ``` is OK.",
        "webpage.editor.import_replace": "Replace all blocks",
        "webpage.editor.import_append": "Append at bottom",
        "webpage.editor.import_sample": "Insert sample",
        "webpage.editor.import_apply": "Build blocks",
        "webpage.editor.import_success": "Imported {{count}} block(s). Remember to save the page.",
        "webpage.editor.import_error_empty": "Nothing to parse.",
        "webpage.editor.import_error_invalid_json": "Invalid JSON.",
        "webpage.editor.import_error_no_blocks_array": "Expected a blocks array, raw array, or content.blocks.",
        "webpage.editor.import_error_no_valid_blocks": "No valid blocks (type must be text, image, header, section, button, or columns).",
        "webpage.editor.import_error_unknown": "Import failed.",
        "webpage.editor.ai_guide_intro":
          "Copy the text below into your AI system prompt. The model should answer with plain JSON only (no markdown fences).",
        "webpage.editor.copy_ai_guide": "Copy AI instructions",
        "webpage.editor.ai_guide_copied": "Instructions copied to clipboard",
        "webpage.editor.ai_guide_copy_failed": "Could not copy (browser permissions)",
        "webpage.editor.generate_with_ai": "Generate with ChatGPT",
        "webpage.editor.ai_apply_success": "AI added {{count}} block(s) to the editor. Remember to save the page.",
        "webpage.editor.ai_parse_error": "AI did not return valid page JSON. Try again or paste JSON from the “Paste JSON” tab.",
        "Dashboard": "Dashboard",
        "Overview of your workspace": "Overview of your workspace",
        "Collapse": "Collapse",
        "Expand": "Expand",
        "Resource Hub": "Resource Hub",
        "resource_hub.faq.linked_records_title": "Related records",
        "resource_hub.faq.linked_records_help":
          "Link to other company records (HMS/KS document, vehicle, product, report, customer, project). Choose a type, then search and pick the record — you do not need to know its numeric ID. For HMS/KS documents, enter at least two characters in the search box to find matches.",
        "resource_hub.faq.linked_records_add": "Add link",
        "resource_hub.faq.linked_records_type": "Resource type",
        "resource_hub.faq.linked_records_id": "ID",
        "resource_hub.faq.linked_records_pick": "Search and select…",
        "resource_hub.faq.linked_records_existing": "Label (saved)",
        "resource_hub.faq.link_type.hse_document": "HMS / KS document",
        "resource_hub.faq.link_type.vehicle": "Vehicle",
        "resource_hub.faq.link_type.product": "Product",
        "resource_hub.faq.link_type.report": "Report",
        "resource_hub.faq.link_type.customer": "Customer",
        "resource_hub.faq.link_type.project": "Project",
        "resource_hub.faq.linked_records_placeholder_type": "Choose type",
        "product.add": "Add a product",
        "product.update": "Update product",
        "product.model_year": "Model year",
        "product.replaced_by_product": "Replaced by product",
        "product.replaced_by.banner_title": "This product has been replaced",
        "product.replaced_by.banner_description":
          "Use the replacement product for up-to-date details, pricing and stock.",
        "product.replaced_by.open_replacement": "Open replacement product",
        "product.selector.open_product": "Open product",
        "product.selector.replaced_label": "Replaced",
        "product.selector.search_placeholder": "Search products…",
        "product.selector.empty_flat_list":
          "Search or scroll the list. Use the funnel to narrow active, expired, or warehouse filters.",
        "customer.system.product_search_placeholder":
          "Search systems (products with spare parts)…",
        "product.selector.filter_system_products":
          "System (spare-part products)",
        "product.selector.toggle_filters": "Show filters",
        "title.required": "Tittel er krevd",
        "storage.edit": "Edit storage",
        "storage.create": "Create a storage",
        "service.report_types": "Service Report Types",
        "service.report_types.edit": "Edit Report Type",
        "service.report_types.create": "Create Report Type",
        "service.agreement_types": "Service Agreement Types",
        "service.variable_types": "Service Variable Types",
        "service.agreements.list.title": "Service agreements",
        "service.agreements.list.hero_kicker": "Service",
        "service.agreements.list.subtitle":
          "Search, filter by view, and manage recurring service agreements.",
        "service.agreements.list.meta.total": "Agreements",
        "service.agreements.list.meta.new": "New",
        "service.agreements.list.new": "New agreement",
        "service.agreements.list.filters_heading": "Filters",
        "service.agreements.list.filters_description":
          "Refine the list with search and view presets.",
        "service.agreements.list.search_placeholder": "Search agreements…",
        "service.agreements.list.sort_label": "Sort",
        "service.agreements.list.per_page": "Per page",
        "service.agreements.list.table_kicker": "List",
        "service.agreements.list.table_title": "Agreements",
        "service.agreements.list.table_description":
          "Select rows for bulk actions from the toolbar above.",
        "service.agreements.list.empty": "No service agreements found.",
        "service.agreements.list.empty_cancelled":
          "No cancelled agreements found.",
        "service.agreements.list.load_error":
          "Could not load service agreements.",
        "service.agreements.list.retry": "Try again",
        "service.agreements.filter.view": "View",
        "service.agreements.filter.kind": "Agreement type",
        "service.agreements.filter.kind_framework": "Framework agreement",
        "service.agreements.filter.kind_service": "Service agreement",
        "service.agreements.view.service_soon": "Service soon (5 days)",
        "service.agreements.view.active": "Active",
        "service.agreements.view.cancelled": "Cancelled",
        "service.agreements.view.cancelled_hint":
          "Open a cancelled agreement to reactivate it.",
        "service.agreements.form.errors_summary":
          "The form has errors — fix them before saving.",
        "service.agreements.create_reports.title":
          "Create jobs for {{count}} selected facilities",
        "service.agreements.create_reports.settings_heading":
          "Job creation settings",
        "service.agreements.create_reports.settings_body":
          "This creates {{count}} job(s) for the selected facilities with the settings below. If one facility fails, none are saved (all-or-nothing).",
        "service.agreements.create_reports.single_report_label":
          "Single report (checklist items per facility)",
        "service.agreements.create_reports.single_report_help":
          "On: one report with checklist items for each selected facility. Off: separate reports per facility.",
        "service.agreements.create_reports.checklist_type": "Checklist type",
        "service.agreements.create_reports.checklist_type_help":
          "Optional checklist type creates checklists automatically for the reports.",
        "service.agreements.create_reports.description_label":
          "Description template",
        "service.agreements.create_reports.description_placeholder":
          "Optional description for the jobs…",
        "service.agreements.create_reports.description_help":
          "This description is used for all created jobs.",
        "service.agreements.create_reports.single_mode_heading":
          "Single report mode",
        "service.agreements.create_reports.single_mode_body":
          "Checklist items are created per selected facility as “{{reportType}}: [Facility] - [Address]”.",
        "service.agreements.create_reports.report_type_fallback": "Report type",
        "service.agreements.create_reports.submit":
          "Create {{count}} job(s)",
        "service.agreements.sort.next_service_asc":
          "Next service — soonest first",
        "service.agreements.sort.next_service_desc":
          "Next service — latest first",
        "service.agreements.sort.created_desc": "Created — newest first",
        "service.agreements.sort.created_asc": "Created — oldest first",
        "service.agreements.table.col_title": "Title",
        "service.agreements.table.col_type": "Type",
        "service.agreements.table.col_project": "Project",
        "service.agreements.table.col_customer": "Customer",
        "service.agreements.table.col_delivery": "Delivery address",
        "service.agreements.table.col_next": "Next service",
        "service.agreements.table.col_interval": "Interval",
        "service.agreements.table.col_status": "Status",
        "service.agreements.table.col_days": "Days until service",
        "service.agreements.table.missing_address": "No delivery address",
        "service.agreements.table.col_next_job": "Next job",
        "service.agreements.next_job.section_title": "Next service job",
        "service.agreements.next_job.next_on": "The next job is scheduled for",
        "service.agreements.next_job.days_until":
          "There are {{count}} days until the next job.",
        "service.agreements.next_job.in_progress": "A job is in progress",
        "service.agreements.actions.missing_type":
          "Agreement type is missing; this agreement cannot be processed.",
        "service.agreements.actions.create_report": "Create new report",
        "service.agreements.actions.create_order": "Create order",
        "service.agreements.actions.go_to_report": "Open report",
        "service.agreements.actions.hint_create_report":
          "A new report is created. When the job is completed, the next service date is set from the completion date.",
        "service.agreements.actions.hint_create_order":
          "A new order is created; the next service date is set automatically.",
        "service.agreements.actions.prompt_report_title": "Create new report",
        "service.agreements.actions.prompt_report_body":
          "Are you sure you want to create a new report for this service agreement?",
        "service.agreements.actions.prompt_order_title": "Create new order",
        "service.agreements.actions.prompt_order_body":
          "Are you sure you want to create a new order for this service agreement?",
        "service.agreements.actions.err_no_agreement":
          "Cannot create without a service agreement.",
        "service.agreements.actions.err_active_report_report":
          "Cannot create a report while a report is already active.",
        "service.agreements.actions.err_active_report_order":
          "Cannot create an order while a report is already active.",
        "service.agreements.actions.err_no_customer_report":
          "Cannot create a report without a customer.",
        "service.agreements.actions.err_no_customer_order":
          "Cannot create an order without a customer.",
        "service.agreements.actions.err_invalid_address":
          "Cannot create an order or report without a valid delivery address including country.",
        "service.agreements.actions.err_cancelled":
          "Cancelled agreements cannot create jobs or orders.",
        "service.agreements.actions.err_no_orderlines":
          "Cannot create an order without order lines. Add lines on the order-lines tab.",
        "service.agreements.actions.creating": "Creating…",
        "service.agreements.actions.cancelled": "Cancelled",
        "service.agreements.actions.reactivated": "The agreement is active again.",
        "service.agreements.actions.cancel_failed": "Could not cancel the service agreement.",
        "service.agreements.actions.load_failed": "Could not load the service agreement.",
        "service.agreements.actions.reactivate_failed": "Could not reactivate the service agreement.",
        "service.agreements.actions.cancel": "Cancel",
        "service.agreements.actions.reactivate": "Reactivate",
        "service.agreements.actions.cancel_prompt_title": "Cancel service agreement",
        "service.agreements.actions.cancel_prompt_body":
          "Are you sure you want to cancel this service agreement?",
        "service.agreements.actions.reactivate_prompt_title": "Reactivate service agreement",
        "service.agreements.actions.reactivate_prompt_body":
          "Are you sure you want to reactivate this service agreement?",
        "service.agreements.header.status": "Status",
        "service.agreements.header.notes": "Notes",
        "service.agreements.header.history": "History",
        "service.agreements.actions.export_pdf": "Export PDF",
        "service.agreements.actions.pdf_exporting": "Creating PDF…",
        "service.agreements.actions.pdf_failed": "Could not generate PDF",
        "service.agreements.documents.pdf_only": "Only PDF files are allowed",
        "service.agreements.multi_edit.title":
          "Bulk edit {{count}} agreements",
        "service.agreements.multi_edit.subtitle":
          "Only agreement fields change. Reports and products are not touched.",
        "service.agreements.multi_edit.selected_heading": "Selected agreements",
        "service.agreements.multi_edit.fields_heading": "Fields that will change",
        "service.agreements.multi_edit.field.interval": "Service interval",
        "service.agreements.multi_edit.field.unchanged": "Unchanged",
        "service.agreements.multi_edit.unchanged_hint":
          "Empty fields stay unchanged on all selected agreements.",
        "service.agreements.multi_edit.confirm_title": "Confirm bulk edit",
        "service.agreements.multi_edit.confirm_body":
          "You are about to update {{count}} agreements. This cannot be undone automatically.",
        "service.agreements.multi_edit.back": "Back",
        "service.agreements.multi_edit.saving": "Saving agreements…",
        "service.agreements.multi_edit.success": "Agreements were updated.",
        "service.agreements.multi_edit.success_detail":
          "Updated {{ok}} of {{total}} (failed: {{fail}}).",
        "service.agreements.multi_edit.error.save":
          "Could not save the bulk edit. Selection is kept.",
        "service.agreements.multi_edit.error.empty_selection":
          "No agreements selected.",
        "service.agreements.multi_edit.error.no_fields":
          "Choose at least one field to change.",
        "service.agreements.tabs.details": "Details",
        "service.agreements.tabs.edit": "Edit",
        "service.agreements.tabs.documents": "Documents",
        "service.agreements.tabs.signing": "Signing",
        "service.agreements.tabs.orderlines": "Order lines",
        "service.agreements.tabs.reports": "Jobs",
        "service.agreements.tabs.orders": "Orders",
        "service.agreements.signing.document_title": "Service agreement {{number}}",
        "service.agreements.signing.non_sensitive_title": "Service agreement",
        "service.agreements.subs.designation_required": "Label is required",
        "service.agreements.badge.framework": "Framework agreement",
        "service.agreements.badge.service": "Service agreement",
        "service.agreements.address.incomplete_banner":
          "The delivery address is incomplete. Full address including country is required before creating orders or reports (Tripletex requires country on packing slips).",
        "service.agreements.table.incomplete_address": "Missing country",
        "delivery_address.country": "Country",
        "delivery_address.country_required": "Country is required",
        "delivery_address.country_hint":
          "Required for Tripletex packing slips and orders.",
        "delivery_address.edit": "Edit address",
        "delivery_address.edit_title": "Edit delivery address",
        "delivery_address.edit_load_error": "Could not load the delivery address.",
        "service.agreements.form.section_type": "Agreement type",
        "service.agreements.form.section_type_help":
          "A framework agreement can cover several included facilities.",
        "service.agreements.form.is_framework": "This is a framework agreement",
        "service.agreements.form.is_framework_help":
          "Use a framework agreement when several customer facilities are covered.",
        "service.agreements.form.vat_included": "Prices include VAT",
        "service.agreements.form.section_parties": "Parties",
        "service.agreements.form.invoice_to_project": "Invoice to project customer",
        "service.agreements.form.customer": "Customer",
        "service.agreements.form.invoice_customer": "Invoice customer",
        "service.agreements.form.project": "Project",
        "service.agreements.form.system": "Facility",
        "service.agreements.form.customer_required": "Customer is required",
        "service.agreements.form.order_date_required": "Order date is required",
        "service.agreements.form.type_required": "Type is required",
        "service.agreements.form.save_failed": "Could not save the agreement. Try again.",
        "service.agreements.modal.create": "Create service agreement",
        "service.agreements.modal.update": "Update service agreement",
        "service.reports.edit.actions": "Actions",
        "company.users.roles.has_access": "Has access",
        "service.agreements.form.section_period": "Agreement period",
        "service.agreements.form.section_period_help":
          "Start date with optional duration, notice period and auto-renewal.",
        "service.agreements.form.order_date": "Order date",
        "service.agreements.form.start_date": "Agreement starts",
        "service.agreements.form.duration_years": "Duration (years)",
        "service.agreements.form.notice_months": "Notice (months)",
        "service.agreements.form.period_end": "End date",
        "service.agreements.form.auto_renew": "Automatic 1-year renewal",
        "service.agreements.form.section_discount": "Discount agreement",
        "service.agreements.form.section_discount_help":
          "Agreement discount for spare parts, services or overall.",
        "service.agreements.form.discount_percent": "General discount %",
        "service.agreements.form.discount_parts": "Spare parts discount %",
        "service.agreements.form.discount_services": "Services discount %",
        "service.agreements.form.section_prices": "Prices",
        "service.agreements.form.offer_price": "Amount per interval",
        "service.agreements.form.hourly_rate": "Hourly rate",
        "service.agreements.form.callout_fee": "Call-out fee",
        "service.agreements.form.parts_markup": "Parts markup %",
        "service.agreements.form.subcontractor_markup": "Subcontractor markup %",
        "service.agreements.form.section_address": "Delivery address",
        "service.agreements.form.section_address_help":
          "Full address including country. Required before orders and reports.",
        "service.agreements.form.delivery_address": "Delivery address",
        "service.agreements.form.section_contacts": "Contacts",
        "service.agreements.form.section_contacts_help":
          "Multiple customer and supplier contacts. Mark one main contact for signing.",
        "service.agreements.form.section_text": "Agreement text",
        "service.agreements.form.short_description": "Short description",
        "service.agreements.form.agreement_text": "Agreement content",
        "service.agreements.form.agreement_text_placeholder":
          "Describe what the agreement covers …",
        "service.agreements.form.conditions": "Terms and conditions",
        "service.agreements.form.conditions_placeholder":
          "KPI adjustment, access, HSE, liability …",
        "service.agreements.contacts.empty": "No contacts added yet.",
        "service.agreements.contacts.contact_required": "Select a customer contact",
        "service.agreements.contacts.employee_required": "Select an employee",
        "service.agreements.contacts.party.customer": "Customer",
        "service.agreements.contacts.party.supplier": "Supplier",
        "service.agreements.contacts.primary": "Main contact",
        "service.agreements.contacts.employee": "Employee",
        "service.agreements.contacts.contact": "Contact",
        "service.agreements.contacts.role": "Role / title",
        "service.agreements.contacts.role_placeholder": "Managing director, chair …",
        "service.agreements.contacts.add_customer": "Add customer contact",
        "service.agreements.contacts.add_supplier": "Add supplier contact",
        "service.agreements.info.overview": "Overview",
        "service.agreements.info.overview_help": "Parties, type and framework flag.",
        "service.agreements.info.type": "Type",
        "service.agreements.info.contacts": "Contacts",
        "service.agreements.info.description": "Description",
        "service.agreements.info.agreement_text": "Agreement text",
        "service.agreements.info.discount": "Discount agreement",
        "service.agreements.info.interval": "Interval",
        "service.agreements.info.next_date": "Next service",
        "service.agreements.info.days_until": "Days until next",
        "service.agreements.info.last_service": "Last service",
        "service.agreements.info.vat_included": "Incl. VAT",
        "service.agreements.form.section_type_hint":
          "Agreement type also controls whether jobs are created as reports (mission).",
        "service.agreements.form.vat_included_hint":
          "Mark whether agreement amounts include VAT.",
        "service.agreements.form.interval_hint":
          "Drives the next service date. With per-line intervals it applies to lines that follow the agreement.",
        "service.agreements.form.duration_years_hint":
          "Agreement length in years, used with notice period and auto-renewal.",
        "service.agreements.form.notice_months_hint":
          "How many months before expiry the agreement must be cancelled.",
        "service.agreements.form.auto_renew_hint":
          "When the period ends the agreement is extended by one year unless cancelled.",
        "service.agreements.form.section_discount_hint":
          "Summary discounts at the top, plus specific rates per category, product or free text below.",
        "service.agreements.form.discount_percent_hint":
          "General discount for the agreement. Use the lines below for more specific rates.",
        "service.agreements.form.section_prices_help":
          "Contract prices with their own intervals. Order lines in the tab are still copied to reports and orders.",
        "service.agreements.form.section_prices_hint":
          "Price lines are contractual. They are not copied automatically onto orders.",
        "service.agreements.form.offer_price_hint":
          "Total amount per service interval. Use price lines if you have several amounts with different intervals.",
        "service.agreements.form.hourly_rate_hint": "Agreed hourly rate for service work.",
        "service.agreements.form.callout_fee_hint": "Fixed call-out / attendance fee.",
        "service.agreements.form.parts_markup_hint": "Markup percent on parts and materials.",
        "service.agreements.form.subcontractor_markup_hint":
          "Markup percent on subcontractors and purchased services.",
        "service.agreements.price_lines.help":
          "Several price lines with different intervals, e.g. yearly filter service and quarterly inspection.",
        "service.agreements.price_lines.hint":
          "These are contractual prices shown in the PDF. They do not replace order lines copied to report/order.",
        "service.agreements.price_lines.empty": "No price lines added yet.",
        "service.agreements.price_lines.line": "Price line",
        "service.agreements.price_lines.title": "Description",
        "service.agreements.price_lines.amount": "Amount",
        "service.agreements.price_lines.interval": "Interval",
        "service.agreements.price_lines.product": "Product (optional)",
        "service.agreements.price_lines.description": "Additional description",
        "service.agreements.form.interval_mode": "Interval applies to",
        "service.agreements.form.interval_mode_agreement": "Whole agreement",
        "service.agreements.form.interval_mode_per_line": "Per order line",
        "service.agreements.form.interval_mode_hint": "Whole agreement: one interval drives the next service date. Per line: each order line has its own next date, and one visit covers every line due within 30 days.",
        "service.agreements.info.line_next": "Next",
        "service.agreements.info.line_last": "Last",
        "service.agreements.info.line_next_visit": "Next visit",
        "service.agreements.info.line_in_active_report": "In active job",
        "service.agreements.lines.title": "Services and products",
        "service.agreements.lines.subtitle": "What the agreement covers. Lines show in the agreement and PDF, and are copied to jobs and orders when “Include in jobs/orders” is on.",
        "service.agreements.lines.product": "Product",
        "service.agreements.lines.pick_product": "Choose product …",
        "service.agreements.lines.item_number": "Item no.",
        "service.agreements.lines.change": "Change",
        "service.agreements.lines.choose": "Choose",
        "service.agreements.lines.service_placeholder": "E.g. Annual ventilation inspection",
        "service.agreements.lines.quantity": "Quantity",
        "service.agreements.lines.unit_price": "Unit price",
        "service.agreements.lines.discount": "Discount %",
        "service.agreements.lines.total": "Total",
        "service.agreements.lines.description": "Description",
        "service.agreements.lines.add_description": "Add description",
        "service.agreements.lines.add_service": "Add service",
        "service.agreements.lines.add_product": "Add product",
        "service.agreements.lines.move_up": "Move up",
        "service.agreements.lines.move_down": "Move down",
        "service.agreements.lines.remove": "Remove line",
        "service.agreements.lines.empty_title": "No lines yet",
        "service.agreements.lines.empty_body": "Add the services and products the agreement covers.",
        "service.agreements.lines.sum_jobs": "Included in jobs/orders",
        "service.agreements.lines.sum_all": "Agreement total excl. VAT",
        "service.agreements.lines.error_product": "Choose a product or switch to service.",
        "service.agreements.lines.error_title": "Describe the service.",
        "service.agreements.lines.error_quantity": "Quantity must be greater than 0.",
        "service.agreements.lines.error_price": "Price must be a number, 0 or more.",
        "service.agreements.lines.error_discount": "Discount must be between 0 and 100.",
        "service.agreements.lines.mode_agreement_hint": "One interval for the whole agreement. Lines can still show their own interval in the agreement.",
        "service.agreements.lines.mode_per_line_hint": "Each line has its own next date. One visit covers lines due within 30 days, and only those are copied to jobs and orders.",
        "Monthly": "Monthly",
        "Yearly (12 months)": "Yearly (12 months)",
        "Half Yearly (6 months)": "Half Yearly (6 months)",
        "Quarterly (3 months)": "Quarterly (3 months)",
        "Every 8 Months": "Every 8 Months",
        "Every 10 Months": "Every 10 Months",
        "Every 2 Years": "Every 2 Years",
        "Every 3 Years": "Every 3 Years",
        "Every 4 Years": "Every 4 Years",
        "Every 5 Years": "Every 5 Years",
        "service.agreements.lines.type": "Type",
        "service.agreements.lines.type_product": "Product",
        "service.agreements.lines.type_service": "Service",
        "service.agreements.lines.service_title": "Service",
        "service.agreements.lines.interval": "Interval",
        "service.agreements.lines.follows_agreement": "Follows agreement",
        "service.agreements.lines.next_service_date": "Next service",
        "service.agreements.lines.next_service_date_hint": "Calculated automatically. Change only to move this line.",
        "service.agreements.lines.next_service_date_new": "Empty: set from the agreement start date.",
        "service.agreements.lines.include_in_jobs": "Include in jobs/orders",
        "service.agreements.lines.include_in_jobs_hint": "Off: shown in the agreement and PDF, but not copied to jobs or invoices.",
        "service.agreements.lines.contract_only": "Agreement only",
        "service.agreements.lines.form_pointer": "Services, products and prices are added under the Order lines tab, where you also choose the interval per line.",
        "service.agreements.price_lines.add": "Add price line",
        "service.agreements.price_lines.title_required": "Description is required",
        "service.agreements.price_lines.amount_invalid": "Amount must be a number",
        "service.agreements.price_lines.quantity_invalid": "Quantity must be a number",
        "service.agreements.discount_lines.label_required": "Description is required",
        "service.agreements.discount_lines.percent_required": "Discount percent is required",
        "service.agreements.discount_lines.percent_invalid": "Discount percent must be a number",
        "service.agreements.discount_lines.category_required": "Select a product category",
        "service.agreements.discount_lines.product_required": "Select a product",
        "service.agreements.discount_lines.help":
          "Discount rate per product category, product, or as free text.",
        "service.agreements.discount_lines.hint":
          "Pick a category or product from the register, or type what the discount applies to.",
        "service.agreements.discount_lines.empty": "No discount rates added yet.",
        "service.agreements.discount_lines.label": "Applies to (free text)",
        "service.agreements.discount_lines.percent": "Discount %",
        "service.agreements.discount_lines.category": "Product category",
        "service.agreements.discount_lines.product": "Product",
        "service.agreements.discount_lines.add": "Add discount rate",
        "service.agreements.discount_lines.kind.manual": "Free text",
        "service.agreements.discount_lines.kind.category": "Category",
        "service.agreements.discount_lines.kind.product": "Product",
        "service.agreements.guide.title": "Service agreement guide",
        "service.agreements.guide.open": "Guide",
        "service.agreements.guide.tab": "How to use the agreement",
        "service.agreements.guide.items.kind.title": "Service or framework agreement",
        "service.agreements.guide.items.kind.body":
          "Use a framework agreement when several facilities at the customer are covered. Mark framework and add included facilities.",
        "service.agreements.guide.items.interval.title": "Interval and next service",
        "service.agreements.guide.items.interval.body":
          "The agreement interval drives the next service date and when jobs are created. Price lines can use other intervals without changing this.",
        "service.agreements.guide.items.price_lines.title": "Price lines",
        "service.agreements.guide.items.price_lines.body":
          "Agreed amounts with their own interval, e.g. yearly contract price and quarterly inspection. Shown in the PDF.",
        "service.agreements.guide.items.discount_lines.title": "Discount rates",
        "service.agreements.guide.items.discount_lines.body":
          "Set discount on a category, product or as free text. The summary fields are general discounts on parts and services.",
        "service.agreements.guide.items.address.title": "Delivery address",
        "service.agreements.guide.items.address.body":
          "A full address including country is required before orders and reports can be created.",
        "service.agreements.guide.items.contacts.title": "Contacts",
        "service.agreements.guide.items.contacts.body":
          "Add several customer and supplier contacts. The main contact is used for PDF signing.",
        "service.agreements.guide.items.orderlines.title": "Order lines",
        "service.agreements.guide.items.orderlines.body":
          "The Order lines tab is operational content copied to reports and orders. It is not the same as contractual prices.",
        "service.agreements.setup.tab": "Get started",
        "service.agreements.setup.blocked":
          "You cannot create an agreement until at least one agreement type exists under Service → Settings.",
        "service.agreements.setup.intro":
          "Check that settings are in place before creating agreements. Agreement types are required. Report types are recommended.",
        "service.agreements.setup.open_settings": "Open settings",
        "service.agreements.setup.open_guide": "Open setup guide",
        "service.agreements.setup.count": "{{count}} registered",
        "service.agreements.setup.steps.agreement_types.title": "Agreement types",
        "service.agreements.setup.steps.agreement_types.body":
          "At least one agreement type is required. The type is selected on the agreement and can control whether jobs are reports (mission).",
        "service.agreements.setup.steps.report_types.title": "Report types",
        "service.agreements.setup.steps.report_types.body":
          "Recommended: create report types used when service jobs are created from the agreement.",
        "service.agreements.setup.steps.linked_report_type.title": "Link report type to agreement type",
        "service.agreements.setup.steps.linked_report_type.body":
          "Agreement types marked as mission should have a report type, otherwise new jobs may lack a template.",
        "service.agreements.next_date.section_title": "Next service date",
        "service.agreements.next_date.section_help":
          "Move the date forwards or backwards, or change the interval used to calculate the next service.",
        "service.agreements.next_date.section_hint":
          "This affects the next job. Price-line intervals are not changed here.",
        "service.agreements.next_date.edit_date": "Edit date",
        "service.agreements.next_date.edit_interval": "Edit interval",
        "service.agreements.next_date.edit_date_title": "Edit next service date",
        "service.agreements.next_date.edit_interval_title": "Edit interval for next service",
        "service.agreements.next_job.section_hint":
          "Create a report or order for the next service. Requires a valid delivery address including country.",
        "service.agreements.subs.title": "Included facilities",
        "service.agreements.subs.help":
          "Facilities covered by the agreement, with location, type and filter.",
        "service.agreements.subs.add": "Add facility",
        "service.agreements.subs.adding": "Adding …",
        "service.agreements.subs.added": "Facility added",
        "service.agreements.subs.add_failed": "Could not add facility",
        "service.agreements.subs.fetch_failed": "Could not load included facilities",
        "service.agreements.subs.delete": "Remove facility",
        "service.agreements.subs.deleted": "Facility removed",
        "service.agreements.subs.delete_failed": "Could not remove facility",
        "service.agreements.subs.delete_confirm":
          "Remove this facility from the agreement?",
        "service.agreements.subs.select_all": "Select all",
        "service.agreements.subs.create_jobs": "Create jobs ({{count}})",
        "service.agreements.subs.reports_created": "Created {{count}} jobs",
        "service.agreements.subs.reports_failed": "Could not create jobs",
        "service.agreements.subs.empty":
          "No facilities included yet. Add facilities for the framework agreement.",
        "service.agreements.subs.col_location": "Location",
        "service.agreements.subs.col_equipment": "Facility",
        "service.agreements.subs.col_designation": "Label",
        "service.agreements.subs.col_filter": "Filter",
        "service.agreements.subs.name_optional": "Name (optional)",
        "service.agreements.subs.use_customer_address": "Use customer address",
        "service.agreements.subs.use_system_address": "Use facility address",
        "service.agreements.subs.use_system_address_named": "Use facility address ({{address}})",
        "service.agreements.subs.system_address_missing": "This facility does not have its own delivery address yet.",
        "service.report.order_dialog.title_create": "Create order from report",
        "service.report.order_dialog.title_additional": "Create additional order",
        "service.report.product_line_dialog.title": "Product line",
        "service.report.product_line_dialog.delete_line": "Delete line",
        "service.report.product_line_dialog.delete_tooltip": "Delete line",
        "service.report.product_line_dialog.delete_confirm_title":
          "Delete this line permanently?",
        "service.report.product_line_dialog.delete_confirm_hint":
          "This cannot be undone.",
        "service.report.product_line_dialog.delete_cancel": "Cancel",
        "service.report.product_line_dialog.delete_confirm": "Delete",
        "service.report.product_line_dialog.delete_working": "Deleting…",
        "service.report.product_line_dialog.back_tooltip": "Back to product line",
        "service.report.order_dialog.dialog_eyebrow": "Order",
        "service.report.order_dialog.section_invoice": "Customer & invoice",
        "service.report.order_dialog.section_km": "Mileage",
        "service.report.order_dialog.section_price_lines": "Agreed price lines",
        "service.report.order_dialog.section_order_group": "Order grouping",
        "service.report.order_dialog.price_lines_intro":
          "The following lines are added to the order automatically:",
        "service.report.order_dialog.price_lines_included_hours": "Included hours:",
        "service.report.order_dialog.price_lines_footer_note":
          "These lines include {{hours}} h billed via the price lines, not as separate hour lines.",
        "service.report.order_dialog.generate_invoice": "Generate with ChatGPT",
        "service.report.order_dialog.generating_invoice": "Generating…",
        "service.report.order_dialog.orders_heading": "Orders on this report",
        "service.report.order_dialog.open_order": "Open order {{number}}",
        "service.report.order_dialog.create": "Create order",
        "service.report.order_dialog.create_another": "Create another order",
        "service.report.order_dialog.follow_up_notice_title": "Additional order",
        "service.report.order_dialog.follow_up_notice_body":
          "Agreed price lines were included on the first order from this report and are not added again automatically. You can bill new hours, mileage, and order lines that are not already invoiced.",
        "service.report.order_dialog.hours_rounding_label": "Billable hours rounding",
        "service.report.order_dialog.hours_rounding_actual":
          "Actual registered time (no rounding)",
        "service.report.order_dialog.hours_rounding_ceil_half":
          "Round up to next half hour (0.5 h)",
        "service.report.order_dialog.hours_rounding_nearest_half": "Round to nearest half hour",
        "service.report.order_dialog.hours_rounding_ceil_hour": "Round up to whole hours",
        "service.report.order_dialog.hours_rounding_nearest_hour": "Round to nearest whole hour",
        "service.report.order_dialog.hours_rounding_hint":
          "Default is actual time. Use rounding only when your billing rules require it (round-up half hour matches the old checkbox).",
        "service.report.order_dialog.hour_lines_label": "Hour lines on the order",
        "service.report.order_dialog.hour_lines_each":
          "One line per time entry (recommended for detail)",
        "service.report.order_dialog.hour_lines_grouped":
          "Merge by activity (one line per activity)",
        "service.report.order_dialog.hour_lines_hint":
          "Multiple entries on the same activity become one line when merged. Flat activity fees (budget_fee) stay one line per activity.",
        "service.report.order_dialog.section_order_lines": "Order lines (consumption)",
        "service.report.order_dialog.section_order_lines_subtitle":
          "{{selected}} of {{total}} lines with usage",
        "service.report.order_dialog.section_hours_subtitle":
          "{{selected}} of {{total}} h",
        "service.report.order_dialog.section_hours_subtitle_manual":
          "Manual hours or pick entries below",
        "service.report.order_dialog.toggle_order_lines_aria": "Bill order lines",
        "service.report.order_dialog.toggle_hours_aria": "Bill hours",
        "service.report.order_dialog.invoice_order_lines_switch":
          "Bill order lines ({{selected}} of {{total}} with usage selected)",
        "service.report.order_dialog.pick_order_lines":
          "Select order lines to bill (products with usage only):",
        "service.report.order_dialog.no_consumption_lines":
          "No order lines with usage registered",
        "service.report.order_dialog.add_tilleggsarbeider_group_label":
          "Separate order group “Tilleggsarbeider” (additional work)",
        "service.report.order_dialog.add_tilleggsarbeider_group_hint":
          "Turn off to place hours and related lines in the main group (same as invoice title/text). Useful for orders that are only product lines without an extra group.",
        "service.report.order_dialog.section_hours": "Hours (additional work)",
        "service.report.order_dialog.invoice_hours_switch":
          "Bill hours ({{selected}} of {{total}} h selected)",
        "service.report.order_dialog.invoice_hours_switch_manual":
          "Bill hours (manual or from list)",
        "service.report.order_dialog.hours_manual_notice_title": "No billable hour entries",
        "service.report.order_dialog.hours_manual_notice_body":
          "All time may sit in agreed price lines, or no hours are registered. Keep billing enabled and enter manual hours below to add the default hour product to the order.",
        "service.report.order_dialog.pick_billable_hours":
          "Select hours to bill (additional work only):",
        "service.report.order_dialog.hours_settings_heading": "Hour settings",
        "service.report.order_dialog.manual_hours_label":
          "Manual hours (overrides selected hours when set)",
        "service.report.order_dialog.manual_hours_placeholder":
          "Required for manual-only billing — otherwise optional",
        "service.report.order_dialog.hours_discount_label": "Discount (%)",
        "service.report.order_dialog.hours_preview_heading": "Preview",
        "service.report.order_dialog.hours_preview_quantity": "Hours: {{hours}}",
        "service.report.order_dialog.hours_preview_discount": "Discount: {{pct}}%",
        "service.report.order_dialog.price_lines_select_hint":
          "Choose which agreed price lines to include on the order.",
        "service.report.analyzer.title": "Report analyzer",
        "service.report.analyzer.run": "Run analysis",
        "service.report.analyzer.running": "Analyzing…",
        "service.report.analyzer.run_success": "Analysis completed",
        "service.report.analyzer.run_failed": "Could not run analysis",
        "service.report.analyzer.create_order": "Create order from suggestion",
        "service.report.analyzer.creating_order": "Creating order…",
        "service.report.analyzer.order_created": "Order created from analysis",
        "service.report.analyzer.order_failed": "Could not create order",
        "service.report.analyzer.checks_heading": "Checks",
        "service.report.analyzer.fix_required": "Must be fixed",
        "service.report.analyzer.improvements_heading": "Improvements",
        "service.report.analyzer.suggested_invoice": "Suggested invoice text",
        "service.report.analyzer.suggested_process_note": "Suggested note for report processing",
        "service.report.analyzer.process_required_title": "Report processing required",
        "service.report.analyzer.process_required_body":
          "The analysis found serious issues. Use report processing below to reject the report with a note — the field worker will receive an email.",
        "service.report.analyzer.not_run_title": "No analysis yet",
        "service.report.analyzer.not_run_body":
          "Run analysis to verify checklist, images, customer description and get invoice and order suggestions.",
        "service.report.analyzer.status.none": "Not analyzed",
        "service.report.analyzer.status.pass": "Analysis passed — ready for report processing",
        "service.report.analyzer.status.warn": "Analysis found improvement points",
        "service.report.analyzer.status.fail": "Analysis found serious issues",
        "service.report.process.analysis_prefill_title": "Prefilled from analysis",
        "service.report.process.analysis_prefill_body":
          "Not approved and note are prefilled from analysis findings. Adjust if needed before saving — the field worker receives an email when not approved.",
        "service.report.process.process_note_required": "A note is required when the report is not approved",
        "service.report.correction.title": "Correction required",
        "service.report.correction.subtitle": "The report was not approved. Fix the items below and finish the report again.",
        "service.report.correction.items_heading": "Items to fix",
        "service.report.correction.fallback_body": "The report was not approved and must be corrected. Contact the office if you are unsure what to fix.",
        "service.report.correction.open_section": "Open section",
        "service.report.analyzer.check.checklist_complete": "Checklist",
        "service.report.analyzer.check.checklist_images": "Checklist images",
        "service.report.analyzer.check.work_documented": "Documented work",
        "service.report.analyzer.check.customer_issues_addressed": "Customer description",
        "service.report.analyzer.check.deviations_noted": "Deviations",
        "service.report.analyzer.check.item_consumption": "Item consumption",
        "service.report.analyzer.check.variables_complete": "Variables",
        "service.report.analyzer.check.must_be_rectified": "Rectification",
        "service.report.analyzer.check.complaint": "Complaint",
        "service.report.analyzer.details.checklist_complete_incomplete":
          "{{incomplete}} of {{total}} items are incomplete",
        "service.report.analyzer.details.checklist_images_missing":
          "Missing images: {{titles}}",
        "service.report.analyzer.details.customer_preview":
          "Customer description: \"{{preview}}\"",
        "service.report.analyzer.details.deviations_count": "{{count}} deviations",
        "service.report.analyzer.details.item_consumption_unhandled":
          "{{count}} items are not fully processed (must be “used on job” or “not used”)",
        "item_consumption_not_handled":
          "Item consumption must be “used on job” or “not used”. “Taken in vehicle” is only temporary.",
        "item_consumption_handled": "Item consumption is fully handled",
        "service.report.finish.item_consumption_not_handled":
          "Item consumption must be set to “used on job” or “not used” before the report can be finished. “Taken in vehicle” is only temporary.",
        "service.report.analyzer.details.variables_complete_incomplete":
          "{{count}} variables are incomplete",
        "service.report.analyzer.message_fallback.fail": "Serious issues found",
        "service.report.analyzer.message_fallback.warn": "Improvement point found",
        "service.report.analyzer.message_fallback.pass": "OK",
        "service.report.analyzer.message_fallback.none": "",
        "order.number": "Order number",
        "order.total": "Order sum total",
        "order.info": "Order Information",
        "order.save.success": "Order saved",
        "order.items.storage.automatic": "Automatic warehouse (highest stock)",
        "order.items.storage.automatic_help": "Empty warehouse is filled automatically on delivery date or invoice — warehouse with the highest stock for the product.",
        "order.items.storage.active": "Active warehouse: {{name}}",
        "order.items.pick_status.picked_delivered": "Picked/delivered {{qty}}",
        "order.items.pick_status.not_picked": "Not picked",
        "order.items.pick_status.line_label": "Line status",
        "order.items.qty.ordered": "Ordered: {{qty}}",
        "order.items.qty.ordered_label": "Ordered",
        "order.items.qty.picked_delivered": "Picked/delivered: {{qty}}",
        "order.items.qty.available": "Available: {{qty}}",
        "order.items.qty.tracked": "On hand: {{qty}}",
        "order.items.warehouse_pick.open": "Warehouse and pick",
        "status": "Status",
        "customer": "Customer",
        "customer.name": "Customer Name",
        "customer.number": "Customer Number",
        "customer.email": "Customer Email",
        "customer.mobile": "Customer Mobile",
        "customer.required": "Customer is required",
        "customer.address": "Customer address",
        "reference": "Reference",
        "customer.contact": "Contact Person",
        "customer.type": "Customer Type",
        "customer.name.required": "Customer name is required",
        "Contact information": "Contact Information",
        "company.outbound_mail.title": "Outbound email (Microsoft)",
        "company.outbound_mail.description": "Choose which shared company mailbox Promang should send from (Microsoft 365). If none is selected or Microsoft is unavailable, mail is sent via Promang’s default email.",
        "company.outbound_mail.mailbox_label": "Send system mail from shared mailbox",
        "company.outbound_mail.promang_default": "Promang default (not Microsoft)",
        "company.outbound_mail.case_email_hint": "Case update emails to employees are sent from the user’s own Microsoft account when linked under user settings — not from this shared mailbox.",
        "company.inbound_email.title": "Inbound post / customer service",
        "company.inbound_email.description":
          "When post@ or customer service receives email, Promang can create a case, customer and send a thank-you with the case number. Fine-tune each mailbox under Microsoft inboxes.",
        "company.inbound_email.enabled": "Process inbound email",
        "company.inbound_email.auto_create_case": "Create case automatically",
        "company.inbound_email.auto_create_customer": "Create customer if no match",
        "company.inbound_email.auto_reply": "Send auto-reply with case number",
        "company.inbound_email.reuse_open_case": "Reuse an open case for the same customer",
        "company.inbound_email.match_phone": "Match customer by mobile number",
        "company.inbound_email.match_name": "Match customer by name (unique hit only)",
        "company.inbound_email.ignore_own_domain": "Skip email from your own company domain",
        "company.inbound_email.from_domains_ignore": "Ignore sender domains (comma-separated)",
        "company.inbound_email.subject_contains_ignore": "Ignore subject words (comma-separated)",
        "company.inbound_email.mailbox_hint": "Connect shared mailboxes and enable background processing here:",
        "company.inbound_email.mailbox_link": "Shared inboxes",
        "company.inbound_email.fallback_heading": "When email cannot be handled automatically",
        "company.inbound_email.fallback_description":
          "Choose where unclassified inbound mail should go, and what happens to copies of mail Promang sent to the customer (for example assignment confirmation).",
        "company.inbound_email.unknown_fallback_to": "Forward unknown mail to",
        "company.inbound_email.unknown_fallback_placeholder": "handler@company.com",
        "company.inbound_email.unknown_fallback_hint":
          "Used when Promang cannot classify, link to a case, or otherwise handle the message. Leave empty to keep it in the inbox (nothing is deleted).",
        "company.inbound_email.system_copy_action": "Mail Promang sent (copy in the mailbox)",
        "company.inbound_email.system_copy_action_none": "Do nothing (do not create a case)",
        "company.inbound_email.system_copy_action_archive": "Archive immediately",
        "company.inbound_email.system_copy_action_forward": "Forward to a chosen address",
        "company.inbound_email.system_copy_hint":
          "Recognized as Promang outbound mail (header, sender and known templates). Auto-reply is not sent. Default is not to create a case.",
        "company.inbound_email.system_copy_forward_to": "Forward Promang copy to",
        "company.inbound_email.system_copy_forward_placeholder": "manager@company.com",
  "case.mail_thread.missing_thread_title": "Previous email thread unavailable",
  "case.mail_thread.missing_thread_choice": "The email has not been sent. Send to {{to}} as a new thread? The old thread will remain on the case.",
  "case.mail_thread.send_new_thread": "Send as new thread",
  "case.mail_thread.thread_number": "Thread {{number}}",
  "case.mail_thread.active_thread": "Active thread",
  "case.mail_thread.previous_send_confirmed": "A previous email is confirmed sent. This draft has not been sent.",
  "case.mail_thread.send_blocked": "Another send from this case is unresolved. This email was not sent. Check the status before trying again.",
  "case.mail_thread.send_storage_failed": "Cannot save send status in the browser. Allow local storage before sending.",
  "case.mail_thread.send_unknown": "It is unclear whether the email was sent. Check its status before sending again. If it remains unknown, check Sent Items in Outlook and contact an administrator.",
  "case.mail_thread.check_send_status": "Check send status",
  "case.mail_thread.sent_refresh_failed": "The email was sent, but the view could not be refreshed. Reload the case.",
        "case.mail_thread.open": "Mail thread",
        "case.mail_thread.dialog_title": "Mail thread",
        "case.mail_thread.empty": "No emails in the thread yet.",
        "case.mail_thread.load_failed": "Could not load the email thread.",
        "case.mail_thread.candidates_failed": "Could not load emails from the inbox.",
        "case.mail_thread.link_title": "Link email thread",
        "case.mail_thread.link_action": "Link to case",
        "case.mail_thread.linked": "The email thread is linked to the case.",
        "case.mail_thread.link_failed": "Could not link the email thread.",
        "case.mail_thread.no_candidates": "No emails found in the shared inbox.",
        "case.mail_thread.reply_title": "Reply to customer by email",
        "case.mail_thread.compose_title": "New email to customer",
        "case.mail_thread.to": "To",
        "case.mail_thread.subject": "Subject",
        "case.mail_thread.body_placeholder": "Write the email here. Templates and formatting are available.",
        "case.mail_thread.pick_template": "Choose template",
        "case.mail_thread.format_ai": "Format text",
        "case.mail_thread.ai_working": "Formatting …",
        "case.mail_thread.ai_needs_text": "Write some text before formatting.",
        "case.mail_thread.ai_failed": "Could not format the text.",
        "case.mail_thread.send": "Send",
        "case.mail_thread.sending": "Sending …",
        "case.mail_thread.sent": "The email was sent.",
        "case.mail_thread.send_failed": "Could not send the email.",
        "case.mail_thread.send_failed_http": "Could not send the email ({{status}}).",
        "case.mail_thread.open_message": "Open email",
        "case.mail_thread.html_iframe_title": "Email content",
        "case.mail_thread.latest_first": "Newest email on top",
        "case.mail_thread.body_loading": "Loading email content …",
        "case.quick_tools.title": "Quick tools",
        "case.mail_thread.missing_recipient": "Enter the customer's email address.",
        "case.mail_thread.missing_body": "Write the email before sending.",
        "case.mail_thread.default_subject": "Inquiry",
        "case.mail_thread.signature_hint":
          "Your signature is added when you click Send, not in the draft.",
        "case.mail_thread.signature_banner_title": "Add an email signature",
        "case.mail_thread.signature_banner_body":
          "Add your signature under Profile → Email so customer emails look complete.",
        "case.mail_thread.signature_banner_cta": "Open Email tab",
        "case.unread_mail.tag": "Unread reply from customer",
        "case.labels.clear_all": "Clear all",
        "case.labels.add": "Add",
        "case.labels.add_label": "Add label",
        "case.labels.remove": "Remove {{name}}",
        "case.labels.search_or_create": "Search or create label…",
        "case.labels.search": "Search labels…",
        "case.labels.create": "Create «{{name}}»",
        "case.labels.create_failed": "Could not create the label",
        "case.labels.no_matches": "No matches",
        "case.labels.selected_count": "{{count}} selected",
        "case.labels.none_selected": "None selected",
        "case.labels.keyboard_hint": "↑↓ select · Enter · Esc",
        "case.unread_mail.item_label": "New email",
        "case.unread_mail.glow_aria": "Latest inbound email",
        "company.userRoles.helpLabel.scope": "Includes:",
        "company.userRoles.helpLabel.admin": "Admins should consider:",
        "company.userRoles.sections.actions": "Actions",
        "company.userRoles.sections.submodules": "Sub-modules",
        "company.userRoles.accessIntro":
          "Role descriptions explain what access is granted and what to watch for when assigning permissions.",
        "company.userRoles.tab": "Roles",
        "company.userRoles.searchPlaceholder": "Search modules and roles …",
        "company.userRoles.templates.title": "Role templates",
        "company.userRoles.templates.intro":
          "Pick a template to quickly assign a set of roles to a new employee. You can fine-tune afterwards.",
        "company.userRoles.templates.applied": "Template applied. Remember to save.",
        "company.userRoles.projectsAccess.title": "Project access",
        "company.userRoles.projectsAccess.intro":
          "Control whether the user has full access to all projects, or only to selected projects.",
        "company.userRoles.projectsAccess.adminToggle":
          "Projects administrator – all projects",
        "company.userRoles.projectsAccess.adminHelp":
          "Full access to all company projects, including work orders and planning. Does not grant company administration, users, or roles.",
        "company.userRoles.projectsAccess.selectedLabel":
          "Full access on selected projects",
        "company.userRoles.projectsAccess.selectedHelp":
          "The user gets full access only on the projects you select here (in addition to projects where the user is a participant).",
        "company.userRoles.projectsAccess.searchPlaceholder":
          "Search by project or project number …",
        "company.userRoles.projectsAccess.noProjects": "No projects found.",
        "company.userRoles.projectsAccess.saveMissingRole":
          "Could not save projects administrator access because the role catalog is not ready. Try again in a moment.",
        "company.userRoles.noMatches": "No modules or roles match your search.",
        "company.userRoles.summary.none": "No access",
        "company.userRoles.summary.on": "Enabled",
        "company.userRoles.summary.selected": "{{count}} selected",
        "company.userRoles.categories.admin": "Administration",
        "company.userRoles.categories.projects": "Projects & work orders",
        "company.userRoles.categories.time": "Hours, absence & calendar",
        "company.userRoles.categories.service": "Service",
        "company.userRoles.categories.quality": "Quality & HSE",
        "company.userRoles.categories.fleet": "Vehicles & driving",
        "company.userRoles.categories.drawings": "Drawings & BIM",
        "company.userRoles.categories.customers": "Customers & communication",
        "company.userRoles.categories.sales": "Sales, inventory & products",
        "company.userRoles.categories.other": "Other modules",
        "company.users.page_title": "Users",
        "company.users.subtitle_selected": "{{count}} selected",
        "company.users.hero.kicker": "Company",
        "company.users.hero.title": "Users & access",
        "company.users.hero.subtitle":
          "Manage people, roles, invitations, and filters in one place — aligned with your dashboard overview.",
        "company.users.stats.total": "Total",
        "company.users.stats.on_page": "On this page",
        "company.users.stats.selected": "Selected",
        "company.users.section.kicker": "Directory",
        "company.users.section.title": "User list",
        "company.users.section.subtitle":
          "Search, refine with filters, and open a profile to edit details.",
        "company.users.section.meta_line": "{{total}} users · page {{page}}",
        "company.users.search_placeholder": "Search users…",
        "company.users.filters_heading": "Filters",
        "company.users.filters_description":
          "Search and narrow the list with the options below.",
        "company.users.filter_title": "Filter users",
        "company.users.filter.active": "Active users",
        "company.users.filter.employee": "Employees",
        "company.users.filter.show_in_dropdown": "Show in dropdown",
        "company.users.new_user": "New user",
        "company.users.calendar": "Calendar",
        "company.users.loading": "Loading users…",
        "company.users.table.status_inactive": "Inactive",
        "company.users.table.status_pending": "Pending",
        "company.users.table.status_active": "Active",
        "company.users.table.empty_title": "No users found",
        "company.users.table.empty_hint":
          "Try adjusting search or filters to see more results.",
        "company.users.table.row_kicker": "User",
        "company.users.table.unnamed": "Unnamed user",
        "company.users.table.calendar": "Calendar",
        "company.users.profile.read_only_title": "User information is read-only",
        "company.users.profile.read_only_multi_company":
          "This user is linked to several companies. Their profile (name, photo, contact details, etc.) can only be edited from their primary company to avoid conflicting changes. Switch to that company in the workspace, or set the correct primary company on the user.",
        "company.users.table.edit": "Edit",
        "company.users.table.settings": "Profile",
        "company.users.table.view": "Open",
        "company.users.table.selected_of_total":
          "{{selected}} of {{total}} selected",
        "company.users.table.user_count": "{{count}} users",
        "company.users.table.n_selected": "{{count}} selected",
        "company.users.invitation.expired":
          "This user has an expired invitation link.",
        "company.users.invitation.resend_button": "Send invitation again",
        "company.users.invitation.resending": "Sending invitation...",
        "company.users.invitation.resend_success":
          "Invitation resent successfully.",
        "company.users.invitation.resend_error":
          "Could not resend invitation.",
        "company.users.password.section_title": "Password and invitation",
        "company.users.password.section_subtitle":
          "Send a password setup link, or set a password directly. History is shown below.",
        "company.users.password.send_link": "Send password setup link",
        "company.users.password.sending": "Sending link…",
        "company.users.password.send_success": "Password setup link has been sent.",
        "company.users.password.send_error": "Could not send password setup link.",
        "company.users.password.set_password": "Set password",
        "company.users.password.set_subtitle":
          "Set a temporary password for the user. Share it securely outside Promang.",
        "company.users.password.new_password": "New password",
        "company.users.password.confirm_password": "Confirm password",
        "company.users.password.cancel": "Cancel",
        "company.users.password.save": "Save password",
        "company.users.password.saving": "Saving…",
        "company.users.password.set_success": "Password has been updated.",
        "company.users.password.set_error": "Could not update password.",
        "company.users.password.too_short": "Password must be at least 8 characters.",
        "company.users.password.mismatch": "Passwords do not match.",
        "company.users.password.last_sent": "Last email sent: {{at}}",
        "company.users.password.never_sent": "No password or invitation email logged yet.",
        "company.users.password.history_title": "History",
        "company.users.password.history_empty": "No events recorded.",
        "company.users.password.source_create": "Invitation on create",
        "company.users.password.source_resend": "Invitation resent",
        "company.users.password.source_admin_send": "Password link sent by admin",
        "company.users.password.source_tripletex_sync": "Password link from Tripletex sync",
        "company.users.password.source_admin_password_set": "Password set by admin",
        "company.users.password.source_unknown": "Unknown event",
        "driving": "Driving (fleet)",
        "driving_trips": "Trips & checked-in vehicle",
        "driving_drivers": "Drivers",
        "driving_vehicles": "Vehicles (driving module)",
        "vehicles": "Vehicles",
        "Postal Address": "Postal Address",
        "Physical Address": "Physical Address",
        "Edit": "Edit",
        "Back": "Back",
        "Customer Number": "Customer Number",
        "Name": "Name",
        "Email": "Email",
        "pmField.email.invalid": "Enter a valid email address.",
        "pmField.email.sameAsName": "Email and name must not be the same. Use the name field for the name and the email field for the email.",
        "pmField.email.nameLooksLikeEmail": "This looks like an email address. Use the email field for email.",
        "Mobile": "Mobile",
        "Inactive": "Inactive",
        "All": "All",
        "Contact": "Contact",
        "Kontakter": "Contacts",
        "Contact info": "Contact info",
        "Sync": "Sync",
        "Date": "Date",
        "Confirmed": "Confirmed",
        "Confirmed date": "Confirmed date",
        "Via SMS": "Via SMS",
        "Manually": "Manually",
        "Ikke avtalt": "Not scheduled",
        "Products": "Products",
        "Purchase Price": "Purchase Price",
        "Sales Price": "Sales Price",
        "Leverandør": "Supplier",
        "Lager status": "Stock status",
        "Org. Nummer": "Org. Number",
        "Short Description": "Short Description",
        "New": "New",
        "More": "More",
        "Address": "Address",
        "Address 2": "Address 2",
        "Postal": "Postal",
        "Place": "Place",
        "Active": "Active",
        "Yes": "Yes",
        "No": "No",
        "Copied to clipboard": "Copied to clipboard",
        "Agreement Start Date": "Agreement Start Date",
        "Agreement Type": "Agreement Type",
        "Checklist created successfully": "Checklist created successfully",
        "Choose who should own this deviation": "Choose who should own this deviation",
        "Consequence": "Consequence",
        "Could not save": "Could not save",
        "Create Deviation": "Create Deviation",
        "Deleted": "Deleted",
        "Deviation Type": "Deviation Type",
        "Edit Deviation": "Edit Deviation",
        "Edit Mode": "Edit Mode",
        "Edit Vehicle": "Edit Vehicle",
        "Failed to create checklist": "Failed to create checklist",
        "Interval": "Interval",
        "Interval is required": "Interval is required",
        "service.agreement.validation.interval_required": "Interval is required",
        "Last Ride": "Last Ride",
        "No email": "No email",
        "Norwegian": "Norwegian",
        "Print Label": "Print Label",
        "Report Type": "Report Type",
        "Responsible User": "Responsible User",
        "Responsible for follow-up": "Responsible for follow-up",
        "Search employees": "Search employees",
        "Select Deviation Type": "Select Deviation Type",
        "Select Responsible User": "Select Responsible User",
        "Select Severity": "Select Severity",
        "Selected": "Selected",
        "Title is required": "Title is required",
        "View Mode": "View Mode",
        "meeting_minutes.view_mode": "View Mode",
        "meeting_minutes.edit_mode": "Edit Mode",
        "Work Order": "Work Order",
        "Failed to copy": "Failed to copy",
        "Copy to clipboard": "Copy to clipboard",
        "our_contact": "Our Contact",
        "order.lines": "Order Lines",
        "report.create": "Create report",
        "report.update": "Update report",
        "report.type": "Report type",
        "report.date": "Report date",
        "report.description": "Report Description",
        "report.agreement.update": "Update Report Agreement",
        "report.agreement.new": "New Report Agreement",
        "report.agreement.modal_intro":
          "Fill in when the work is planned and whether the customer should receive a message.",
        "report.agreement.title": "Appointment agreement",
        "report.agreement.subtitle": "Schedule, executor, and customer notification",
        "report.agreement.setup_title": "No appointment saved yet",
        "report.agreement.setup_body": "Add date, time, who performs the work, and optionally send SMS or email to the customer.",
        "report.agreement.setup_cta": "Set up agreement",
        "report.agreement.section.schedule": "Schedule",
        "report.agreement.section.schedule_help":
          "Who performs the work, appointment date and time window.",
        "report.agreement.section.notify": "Customer notification",
        "report.agreement.section.notify_help":
          "Choose whether to send the agreement by SMS or email and who receives it.",
        "report.agreement.send_to_customer": "Send agreement to customer",
        "report.agreement.send_to_customer_hint_on": "SMS and/or email can be used when enabled below.",
        "report.agreement.send_to_customer_hint_off": "The appointment is saved in Promang only; the customer is not notified.",
        "report.agreement.executing_you": "You (logged-in user)",
        "report.agreement.select_executing": "Choose employee",
        "report.agreement.change_executing": "Change…",
        "report.agreement.confirm_hint_required":
          "The agreement is sent to the customer, who must confirm via SMS or email.",
        "report.agreement.confirm_hint_optional":
          "Appointment details are sent to the customer; no confirmation is required and the agreement is confirmed automatically.",
        "report.agreement.validation.date_required": "Date is required",
        "report.agreement.validation.executing_required": "Executing employee is required",
        "report.agreement.validation.phone_for_sms": "Phone number is required when SMS is enabled",
        "report.agreement.validation.email_for_email": "Valid email is required when email is enabled",
        "report.agreement.status.confirmed": "Agreement confirmed",
        "report.agreement.status.not_confirmed": "Agreement not confirmed",
        "report.agreement.status.sms_sent": "SMS sent",
        "report.agreement.status.sms_not_sent": "SMS not sent",
        "report.agreement.status.sms_confirmed": "Confirmed via SMS",
        "report.agreement.status.email_sent": "Email sent",
        "report.agreement.status.email_not_sent": "Email not sent",
        "report.agreement.status.none": "No agreement",
        "report.view.mobileNav.ariaLabel": "Quick links to report sections",
        "report.view.backToReport": "Back to report",
        "report.view.mobileNav.details": "Details",
        "report.view.mobileNav.items": "Item consumption",
        "report.view.mobileNav.variables": "Variables",
        "report.view.mobileNav.checklist": "Checklist",
        "report.view.mobileNav.report": "Report",
        "report.view.mobileNav.timeRegistration": "Time tracking",
        "generalNavMenu.ariaLabel": "Main navigation",
        "generalNavMenu.home": "Home",
        "generalNavMenu.timesheet": "Timesheet",
        "generalNavMenu.calendar": "My calendar",
        "generalNavMenu.handbook": "Employee handbook",
        "generalNavMenu.newEvent": "New event",
        "generalNavMenu.newHour": "New hour",
        "generalNavMenu.newAbsence": "Add absence",
        "generalNavMenu.actionsTitle": "Quick actions",
        "generalNavMenu.openActions": "Open quick actions",
        "generalNavMenu.closeActions": "Close quick actions",
        "pmLinkCard.actionsTitle": "Actions",
        "report.edit.menu_title": "Edit information",
        "report.edit.unsaved": "Unsaved changes",
        "report.edit.all_saved": "Everything is saved",
        "report.edit.autosaved": "Changes are saved automatically",
        "report.edit.section.info": "Information",
        "report.edit.section.info_desc": "Title, type, description",
        "report.edit.section.checklist": "Checklist",
        "report.edit.section.checklist_desc": "Items, order, type",
        "report.edit.section.price": "Price lines",
        "report.edit.section.price_desc": "Goods, hours and prices",
        "report.edit.section.team": "Assignees",
        "report.edit.section.team_desc": "Performers and roles",
        "report.edit.section.status": "Status & settings",
        "report.edit.section.status_desc": "Status, notification, visibility",
        "report.edit.info.heading": "Basic information",
        "report.edit.info.subheading": "Type and descriptions control what the technician and the customer see.",
        "report.edit.info.type": "Report type",
        "report.edit.info.executor": "Main performer",
        "report.edit.info.order_date": "Order date",
        "report.edit.info.address": "Address",
        "report.edit.info.site": "Customer's facility",
        "report.edit.info.description": "Job description",
        "report.edit.info.description_hint": "visible to customer · supports formatting",
        "report.edit.info.internal": "Internal description",
        "report.edit.info.internal_hint": "internal only",
        "report.edit.info.customer": "Customer",
        "report.edit.info.contact": "Contact person",
        "report.edit.info.project": "Project",
        "report.edit.info.folder": "Project folder",
        "report.edit.info.report_number": "Report number",
        "report.edit.info.use_customer_address": "Use customer's address",
        "report.edit.info.documents": "Documents",
        "report.edit.info.view_documents": "View documents",
        "report.edit.info.economy": "Economy and invoicing",
        "report.edit.info.invoice_to_project_customer": "Invoice to project customer",
        "report.edit.info.invoice_to_project_customer_desc": "Invoice is sent to the project's customer",
        "report.edit.info.other_invoice_customer": "Other invoice customer",
        "report.edit.info.other_invoice_customer_desc": "Choose a different customer for invoicing",
        "report.edit.info.invoice_customer": "Invoice customer",
        "report.edit.info.cost_included_in_project": "Cost included in project",
        "report.edit.info.cost_included_in_project_desc": "Costs are counted into the project",
        "report.edit.info.sales_income_included_in_project": "Sales income included in project",
        "report.edit.info.sales_income_included_in_project_desc": "Income is counted into the project",
        "report.edit.info.do_not_expect_income": "Do not expect income",
        "report.edit.info.do_not_expect_income_desc": "Mark the report as not expecting income",
        "report.edit.confirm_close.title": "Save changes?",
        "report.edit.confirm_close.text": "You have unsaved changes. Do you want to save before closing?",
        "report.edit.confirm_close.keep_editing": "Keep editing",
        "report.edit.confirm_close.discard": "Discard",
        "report.edit.confirm_close.save": "Save",
        "report.edit.checklist.hint": "Drag the handle to reorder. Set type and mark what is required.",
        "report.edit.checklist.none": "This report is not linked to a checklist yet.",
        "report.edit.checklist.open": "Open checklist",
        "report.edit.checklist.select": "Select checklist",
        "report.edit.checklist.created": "Checklist created",
        "report.edit.checklist.create_error": "Could not create checklist",
        "report.edit.checklist.delete": "Delete checklist",
        "report.edit.checklist.delete_confirm":
          "This cannot be undone. Are you sure you want to delete the checklist?",
        "report.edit.checklist.deleted": "Checklist deleted",
        "report.edit.checklist.delete_error": "Could not delete checklist",
        "report.edit.price.hint": "Goods, hours and services billed to the customer. Totals update automatically.",
        "report.edit.team.hint": "Who is responsible and who performs the job. Roles control access.",
        "report.edit.status.heading": "Report status",
        "report.edit.status.subheading": "Control the progress of the job.",
        "report.edit.status.under_process": "Under process",
        "report.edit.status.processed": "Processed",
        "report.edit.status.closed": "Closed",
        "report.edit.status.finished": "Finalized",
        "report.edit.status.finished_desc": "The report is finalized on save.",
        "report.edit.status.finished_date": "Finalized date",
        "report.edit.status.invoiced": "Invoiced",
        "report.edit.status.invoiced_desc": "Mark the report as invoiced.",
        "report.edit.status.settings": "Settings",
        "report.view.summary.customer": "Customer",
        "report.view.sectionReport.title": "Report",
        "report.view.sectionReport.description": "All service reports must include a description that can be used as the basis for invoice text.",
        "report.view.sectionReport.cardSubtitle": "invoice text",
        "report.view.sectionReport.unit": "report",
        "report.view.sectionReport.statusFinished": "Done",
        "report.view.sectionReport.statusNotRequired": "Not required",
        "report.view.sectionReport.statusMissing": "Missing",
        "report.view.sectionGuide.title": "Guides",
        "report.view.sectionGuide.description": "Structured guides and completed runs for this report",
        "report.view.sectionGuide.unitRuns": "runs",
        "report.view.sectionGuide.statusNone": "Not started",
        "report.view.sectionGuide.statusHasRuns": "{{count}} completed",
        "report.view.guideHistory.title": "Guide history",
        "report.view.guideHistory.empty": "No guides have been completed on this report yet.",
        "report.view.guideHistory.startGuide": "Start guide",
        "report.view.guideHistory.close": "Close",
        "report.view.guideHistory.completedAt": "Completed",
        "report.view.guideHistory.by": "By",
        "report.view.guideHistory.unknownUser": "Unknown user",
        "report.view.guideHistory.answers": "Answers",
        "report.view.guideHistory.tagsApplied": "Tags applied ({{count}})",
        "report.view.mobileNav.guide": "Guide",
        "report.view.priceCalculated.title": "A price has been calculated for this job",
        "report.view.priceCalculated.subtitle": "The latest saved estimate shows what the customer should pay for the full job (fixed price + extras).",
        "report.view.priceCalculated.open": "Open calculator",
        "report.view.priceCalculated.exVat": "Ex. VAT",
        "report.view.priceCalculated.incVat": "Inc. VAT",
        "report.redesign.project": "Project",
        "report.redesign.active": "Active",
        "report.redesign.executor": "Executor",
        "report.redesign.technician": "Service technician",
        "report.redesign.report_type": "Report type",
        "report.redesign.oppdrag": "Job",
        "report.redesign.edit": "Edit",
        "report.redesign.description": "Job description",
        "report.redesign.no_description": "No description added",
        "report.redesign.internal": "Internal description",
        "report.redesign.internal_hint": "not visible to customer",
        "report.redesign.no_internal": "No internal description",
        "report.redesign.appointment.title": "Customer appointment",
        "report.redesign.appointment.confirmed": "Scheduled",
        "report.redesign.appointment.not_confirmed": "Not scheduled",
        "report.redesign.appointment.empty": "Set time, executor and customer notification",
        "report.redesign.appointment.set": "Schedule time",
        "report.redesign.finalize.title": "Finalize report",
        "report.redesign.finalize.done_title": "Report finalized",
        "report.redesign.finalize.desc": "Complete all required steps to send the report to the customer.",
        "report.redesign.finalize.done_desc": "The report is finalized and sent to the customer.",
        "report.redesign.finalize.progress": "Progress",
        "report.redesign.finalize.done_short": "Finalized",
        "report.redesign.finalize.view": "View finalized report",
        "report.redesign.price.title": "Calculated price for the job",
        "report.redesign.price.ex_vat": "Excl. VAT",
        "report.redesign.price.inc_vat": "Incl. VAT",
        "report.redesign.price.open": "Open price calculator",
        "report.redesign.address.title": "Delivery address",
        "report.redesign.address.none": "No address registered",
        "report.redesign.address.open_maps": "Show delivery address on map",
        "report.redesign.module.optional": "Optional",
        "report.redesign.module.items_sub": "materials",
        "report.redesign.module.variables_sub": "registered",
        "report.redesign.module.checklist_sub": "items",
        "report.redesign.module.guide_sub": "completed",
        "report.redesign.module.report_sub": "attachments",
        "report.redesign.badge.confirmed": "Confirmed",
        "report.redesign.badge.not_confirmed": "Not confirmed",
        "report.redesign.badge.not_agreed": "No appointment",
        "report.redesign.badge.must_rectify": "Must be rectified",
        "report.redesign.badge.invoiced": "Invoiced",
        "report.redesign.economy.title": "Financial overview",
        "report.redesign.economy.sub_expected": "Costs and expected income for the job",
        "report.redesign.economy.sub_actual": "Costs and actual income for the job",
        "report.redesign.economy.costs": "Costs",
        "report.redesign.economy.income_expected": "Expected income",
        "report.redesign.economy.income_actual": "Actual income",
        "report.redesign.economy.order_items_cost": "Order lines (cost price)",
        "report.redesign.economy.order_items_income": "Order lines (sales price)",
        "report.redesign.economy.item_consumption": "Material consumption",
        "report.redesign.economy.item_sales": "Material sales price (excl. discount)",
        "report.redesign.economy.hours_cost": "Hour cost",
        "report.redesign.economy.hours_income": "Standard hourly rate",
        "report.redesign.economy.car_allowance": "Car allowance",
        "report.redesign.economy.agreed_price": "Agreed price",
        "report.redesign.economy.additional_hours": "Additional work (hours)",
        "report.redesign.economy.total_cost": "Total costs",
        "report.redesign.economy.total_income": "Total income",
        "report.redesign.economy.profit": "Profit",
        "report.redesign.economy.margin": "Profit margin",
        "report.redesign.economy.hours": "Total hours",
        "report.redesign.economy.distance": "Distance",
        "report.redesign.economy.items_count": "Item count",
        "report.redesign.economy.in_project_title": "Costs and income are included in project",
        "report.redesign.economy.in_project_body": "This report's costs and income are included in the project summary and are not shown separately here.",
        "report.additional_work_calculator.sectionTitle": "Calculate additional work",
        "report.additional_work_calculator.sectionSubtitle": "Estimate extras beyond fixed price — simple view for the customer total",
        "report.additional_work_calculator.sectionBody": "Open the calculator to adjust hours, materials and a new visit. The headline shows what the customer pays with and without VAT.",
        "report.additional_work_calculator.open": "Open calculator",
        "report.additional_work_calculator.dialogTitle": "Estimate — what should the customer pay?",
        "report.additional_work_calculator.loading": "Loading price estimate…",
        "report.additional_work_calculator.heroLabel": "What the customer pays (full job)",
        "report.additional_work_calculator.exVat": "Excluding VAT",
        "report.additional_work_calculator.incVat": "Including VAT",
        "report.additional_work_calculator.exVatShort": "ex.",
        "report.additional_work_calculator.incVatShort": "inc.",
        "report.additional_work_calculator.extraHours": "Extra hours",
        "report.additional_work_calculator.hoursLabel": "Hours",
        "report.additional_work_calculator.newVisit": "New visit / travel",
        "report.additional_work_calculator.newVisitHelp": "Distance and rates follow the same basis as the price estimate (delivery address, etc.). You can use system km, custom km or a flat minimum charge.",
        "report.additional_work_calculator.includeVisit": "Include cost for a new visit",
        "report.additional_work_calculator.estimateKm": "Distance from estimate: {{km}} km (approx.)",
        "report.additional_work_calculator.estimateKmPrice": "Customer km rate: {{price}} /km ex. VAT",
        "report.additional_work_calculator.estimateMin": "Minimum travel charge: {{min}} — below that, flat rate {{fixed}} applies",
        "report.additional_work_calculator.underMinHint": "With system distance below the minimum, the flat rate is used in the calculation.",
        "report.additional_work_calculator.modeSystem": "Use system km",
        "report.additional_work_calculator.modeCustom": "Custom km",
        "report.additional_work_calculator.modeMinimum": "Minimum / flat rate only",
        "report.additional_work_calculator.customKm": "Kilometres",
        "report.additional_work_calculator.productsTitle": "Materials (non fixed-price lines)",
        "report.additional_work_calculator.noProducts": "No non–fixed-price lines are registered on this report.",
        "report.additional_work_calculator.lineHint": "Changes here affect only the calculator — not report lines.",
        "report.additional_work_calculator.qty": "Qty",
        "report.additional_work_calculator.unitPrice": "Unit price (ex.)",
        "report.additional_work_calculator.exclude": "Exclude from calculation",
        "report.additional_work_calculator.includeAgain": "Include again",
        "report.additional_work_calculator.detailsToggle": "More for your company (cost, margin, fixed price)",
        "report.additional_work_calculator.hourlyCustomer": "Customer hourly rate (ex.)",
        "report.additional_work_calculator.hourlyCustomerHelp": "Hourly rate charged to the customer. Default comes from the company hour product.",
        "report.additional_work_calculator.hourlyCost": "Cost hourly rate (ex.)",
        "report.additional_work_calculator.hourlyCostHelp": "Internal cost rate per hour.",
        "report.additional_work_calculator.fallbackHourly": "Default rate used — actual customer rate not found.",
        "report.additional_work_calculator.fallbackCost": "Default rate used — actual cost rate not found.",
        "report.additional_work_calculator.rowLaborCust": "Labour (customer)",
        "report.additional_work_calculator.rowLaborCost": "Labour (cost)",
        "report.additional_work_calculator.rowMaterialCust": "Materials (customer)",
        "report.additional_work_calculator.rowMaterialCost": "Materials (cost)",
        "report.additional_work_calculator.rowVisitCust": "Visit (customer)",
        "report.additional_work_calculator.rowVisitCost": "Visit (cost)",
        "report.additional_work_calculator.rowFixed": "Fixed-price lines (customer, ex.)",
        "report.additional_work_calculator.rowTotalCost": "Total company cost (ex.)",
        "report.additional_work_calculator.rowMargin": "Margin (ex.)",
        "report.additional_work_calculator.historyToggle": "Saved estimates ({{count}})",
        "report.additional_work_calculator.restore": "Restore",
        "report.additional_work_calculator.close": "Close",
        "report.additional_work_calculator.save": "Save estimate",
        "report.additional_work_calculator.saveAsNew": "Save as new estimate",
        "report.additional_work_calculator.saveOverwrite": "Overwrite latest",
        "report.additional_work_calculator.saveOverwriteHint":
          "Replaces the most recently saved estimate. Older history is kept.",
        "report.additional_work_calculator.newCalculation": "New estimate",
        "report.additional_work_calculator.newCalculationHint":
          "Resets the form from the report and price estimate (last save is not applied).",
        "report.additional_work_calculator.saving": "Saving…",
        "report.additional_work_calculator.toastSaved": "Estimate saved",
        "report.additional_work_calculator.toastSavedNew": "New estimate saved",
        "report.additional_work_calculator.toastSavedOverwrite": "Latest estimate updated",
        "report.additional_work_calculator.toastSaveError": "Could not save estimate",
        "report.additional_work_calculator.toastRestored": "Values from saved estimate loaded",
        "report.additional_work_calculator.addFromCatalog": "Add product",
        "report.additional_work_calculator.addManualLine": "Blank line",
        "report.additional_work_calculator.addProductsTitle": "Choose products for the estimate",
        "report.additional_work_calculator.addSelectedProducts": "Add to estimate",
        "report.additional_work_calculator.toastProductsAdded": "{{count}} product(s) added to the estimate",
        "report.additional_work_calculator.lineTitle": "Description / item",
        "report.additional_work_calculator.lineHintCustom": "Estimate only — does not create a report line.",
        "report.additional_work_calculator.unitCost": "Unit cost (ex. VAT)",
        "report.additional_work_calculator.removeLine": "Remove line",
        "report.additional_work_calculator.loadFromReport": "Load estimate from report",
        "report.additional_work_calculator.loadFromReportHint":
          "The list only shows reports with a saved price estimate. Pick a report — the latest saved estimate is applied. Lines from the source report are not linked to this report.",
        "report.additional_work_calculator.reportSelectorLabel": "Report with price estimate",
        "report.additional_work_calculator.selectorCalcSummary": "Latest saved: {{ex}} ex. VAT / {{inc}} inc. VAT",
        "report.additional_work_calculator.loadFromReportDialogTitle": "Load estimate from another report",
        "report.additional_work_calculator.loadFromReportBody":
          "Enter the report ID (same as in the URL or report card). Lines from that report are not linked here — they are only included in this estimate.",
        "report.additional_work_calculator.reportIdLabel": "Report ID",
        "report.additional_work_calculator.loadFromReportApply": "Load",
        "report.additional_work_calculator.loadFromReportCancel": "Cancel",
        "report.additional_work_calculator.loadFromReportLoading": "Loading…",
        "report.additional_work_calculator.loadFromReportIdRequired": "Enter a report ID",
        "report.additional_work_calculator.loadFromReportIdInvalid": "Invalid report ID",
        "report.additional_work_calculator.loadFromReportSame": "Choose a different report than this one",
        "report.additional_work_calculator.toastLoadedFromReport": "Estimate loaded from report {{number}}",
        "report.additional_work_calculator.toastNoCalculatorOnReport": "That report has no saved estimate",
        "report.additional_work_calculator.toastLoadReportError": "Could not load report or estimate",
        "report.additional_work_calculator.addToConsumption": "Add to consumption",
        "report.additional_work_calculator.addToConsumptionWorking": "Adding…",
        "report.additional_work_calculator.addToConsumptionHint":
          "Creates or updates a line on the report (same as consumption). Calculator prices are written to the line when they differ from defaults.",
        "report.additional_work_calculator.toastAddedToConsumption": "Added to consumption",
        "report.additional_work_calculator.toastAddToConsumptionNeedQty": "Enter a quantity greater than zero",
        "report.additional_work_calculator.toastAddToConsumptionNeedTitle": "Enter a description for a manual line",
        "report.additional_work_calculator.toastAddToConsumptionUnlinked":
          "The item was added, but the calculator could not link to the line automatically — refresh or adjust from consumption.",
        "report.additional_work_calculator.toastAddToConsumptionPriceSyncError":
          "Line created, but calculator prices could not be synced",
        "report.additional_work_calculator.toastAddToConsumptionError": "Could not add to consumption",
        "report.additional_work_calculator.discountLabel": "Discount — hours & travel",
        "report.additional_work_calculator.discountHint":
          "Amount ex. VAT deducted from extra hours and new visit/travel only (not materials or fixed-price lines). Cannot exceed the sum of those charges.",
        "report.additional_work_calculator.discountFieldLabel": "Hours/travel discount (ex. VAT)",
        "report.additional_work_calculator.lineDiscountLabel": "Line discount (ex.)",
        "report.additional_work_calculator.lineDiscountHint":
          "Discount ex. VAT on this material line. Cannot exceed the line amount (qty × unit price).",
        "report.additional_work_calculator.rowSubtotal": "Subtotal before discounts (ex.)",
        "report.additional_work_calculator.rowDiscount": "Discount (ex.)",
        "report.additional_work_calculator.rowDiscountMaterials": "Materials discount (ex.)",
        "report.additional_work_calculator.rowDiscountHoursVisit": "Hours/travel discount (ex.)",
        "report.additional_work_calculator.rowMaterialCustGross": "Materials before discount (customer, ex.)",
        "report.additional_work_calculator.detailsToggleCustomer": "Price details (customer, ex.)",
        "report.additional_work_calculator.rowTotalCustomerExVat": "Customer total (ex.)",
        "report.additional_work_calculator.excludeShort": "Exclude",
        "report.additional_work_calculator.includeShort": "Include",
        "report.additional_work_calculator.addToConsumptionShort": "Consumption",
        "report.additional_work_calculator.addPriceLines": "Add price line",
        "report.additional_work_calculator.addPriceLinesHint":
          "Creates one agreed price line titled agreed work incl. visit/travel: sum of extra hours and visit (excl. VAT, before hours/visit discount). Links the first project activity with an activity item when available. Edit under Price lines.",
        "report.additional_work_calculator.priceLineWorkIncludingVisitTitle":
          "Agreed work incl. visit/travel (calculator)",
        "report.additional_work_calculator.toastPriceLinesNothing":
          "Enter extra hours and/or enable a new visit with a charge greater than zero.",
        "report.additional_work_calculator.toastPriceLinesAdded": "Added {{count}} price line(s)",
        "report.additional_work_calculator.toastPriceLinesError": "Could not create price line",
        "report.sectionCard.viewOnlyHint": "View only (click to view)",
        "report.sectionCard.progress": "Progress",
        "report.sectionDialog.reportTitle": "Report content",
        "report.sectionDialog.reportDescription": "Write report content",
        "report.sectionDialog.reportContentLabel": "Report",
        "report.sectionDialog.reportContentHint": "All service reports must include a description that can be used as the basis for invoice text.",
        "report.sectionDialog.internalReportLabel": "Internal report",
        "report.sectionDialog.internalReportHint": "Only visible to internal employees — not shared with the customer.",
        "report.sectionDialog.placeholderReport": "Write report content here…",
        "report.sectionDialog.placeholderInternal": "Write internal report here…",
        "report.sectionDialog.formatting": "Formatting…",
        "report.sectionDialog.formatWithAi": "Format with ChatGPT",
        "report.sectionDialog.autoSaveHint": "Changes are saved automatically.",
        "report.sectionDialog.saving": "Saving…",
        "report.sectionDialog.saved": "Saved",
        "report.sectionDialog.autoSaveError": "Could not save report text",
        "report.sectionDialog.close": "Close",
        "report.agreement.section.followup": "Follow-up messages",
        "report.agreement.section.followup_help":
          "Send a reminder, resend the agreement (SMS), or send an updated agreement after it is confirmed.",
        "report.agreement.section.manual_confirm": "Manually confirm agreement",
        "report.agreement.section.manual_confirm_help":
          "Use when the customer has already confirmed outside Promang. You will be asked to confirm before it is saved.",
        "report.agreement.section.cancel_agreement": "Cancel agreement",
        "report.agreement.section.cancel_agreement_help":
          "Choose a cancellation type or reason. “Assignment cancelled” ends the agreement with no stated cause and no message about rescheduling. SMS to the customer can be toggled below before you confirm.",
        "report.agreement.cancel_sms_hint":
          "If enabled, an SMS may be sent when the cancellation is submitted (depending on your setup).",
        "report.agreement.prompt.reminder_title": "Send confirmation reminder?",
        "report.agreement.prompt.reminder_body":
          "Make sure you have not already sent a reminder for this agreement.",
        "report.agreement.prompt.resend_title": "Resend agreement?",
        "report.agreement.prompt.resend_body":
          "Make sure you have not already sent a new message to the customer.",
        "report.agreement.prompt.updated_appointment_title":
          "Send updated agreement?",
        "report.agreement.prompt.updated_appointment_body":
          "The same date and time are sent as before; description and other details may have been updated.",
        "report.agreement.prompt.confirm_manual_title":
          "Register manual confirmation?",
        "report.agreement.prompt.confirm_manual_body":
          "This will mark the agreement as confirmed ({{method}}). Continue?",
        "report.agreement.prompt.cancel_agreement_title":
          "Cancel this agreement?",
        "report.agreement.prompt.cancel_agreement_body":
          "Reason: {{reason}}. This cancels the appointment agreement in Promang. Continue?",
        "report.agreement.edit": "Edit agreement",
        "report.agreement.time_range": "Time window",
        "report.agreement.redesign.executing_section": "Executing employee",
        "report.agreement.redesign.executing_help": "Choose who will perform the work.",
        "report.agreement.redesign.search_employee": "Search for person…",
        "report.agreement.redesign.avail_free": "Available",
        "report.agreement.redesign.avail_partial": "Partial",
        "report.agreement.redesign.avail_busy": "Busy",
        "report.agreement.redesign.avail_absence": "Absent",
        "report.agreement.redesign.no_employees": "No matches.",
        "report.agreement.redesign.executing_locked_hint": "You are assigned as the executing employee.",
        "report.agreement.redesign.schedule_section": "Date and time",
        "report.agreement.redesign.schedule_help": "Drag a time block in the calendar on the right, or adjust by dragging the appointment.",
        "report.agreement.redesign.drag_hint": "Drag in the calendar on the right to set a time.",
        "report.agreement.redesign.drag_hint_bold": "Drag and drop",
        "report.agreement.redesign.drag_hint_suffix": "to create the appointment.",
        "report.agreement.redesign.drag_tip": "Tip: Drag the block to move it, or drag the bottom edge to change duration.",
        "report.agreement.redesign.settings_section": "Settings",
        "report.agreement.redesign.fixed_time_on_hint": "On: arrival at the selected time.",
        "report.agreement.redesign.fixed_time_off_hint": "Off: arrival within the selected time window.",
        "report.agreement.redesign.clear_time": "Clear",
        "report.agreement.redesign.jobs_this_week": "{{count}} jobs this week",
        "report.agreement.redesign.prev_week": "Previous week",
        "report.agreement.redesign.next_week": "Next week",
        "report.agreement.redesign.today": "Today",
        "report.agreement.redesign.legend_existing": "Existing",
        "report.agreement.redesign.legend_absence": "Absence",
        "report.agreement.redesign.legend_new": "New appointment",
        "report.agreement.redesign.absence_short": "Absent",
        "report.agreement.redesign.channels": "Channels",
        "report.agreement.redesign.preview": "Preview",
        "report.agreement.redesign.preview_empty": "Could not load preview.",
        "report.agreement.redesign.skip_notify": "Save without notification",
        "report.agreement.redesign.send_agreement": "Send agreement",
        "report.agreement.redesign.pick_time_hint": "Pick a time in the calendar →",
        "report.agreement.redesign.conflict_hint": "Conflict with an existing appointment — you can still continue.",
        "report.agreement.redesign.next_notify": "Next: Notification",
        "report.agreement.redesign.step_schedule": "Schedule",
        "report.agreement.redesign.step_notify": "Customer notification",
        "report.variables.update": "Update Variables",
        "report.price_lines.title": "Price Lines",
        "report.price_lines.description": "Manage price lines and agreed prices",
        "report.price_lines.add": "Add Price Line",
        "report.price_lines.empty": "No price lines added",
        "report.price_lines.line": "Price Line",
        "report.price_lines.title_field": "Title",
        "report.price_lines.activity_item": "Activity",
        "report.price_lines.no_activity": "No activity",
        "report.price_lines.description_field": "Description",
        "report.price_lines.is_agreed_price": "Agreed Price Line",
        "report.price_lines.agreed_price": "Agreed Price",
        "report.price_lines.agreed_price_excl_vat": "Agreed Price (excl. VAT)",
        "report.price_lines.agreed_price_incl_vat": "Agreed Price (incl. VAT)",
        "report.price_lines.vat_type": "VAT Type",
        "report.price_lines.no_vat_type": "No VAT Type",
        "report.price_lines.select_vat_type": "Select VAT Type",
        "report.price_lines.select_vat_type_description": "Select a VAT type for this price line",
        "report.price_lines.search_vat_types": "Search VAT types...",
        "report.price_lines.no_vat_types_found": "No VAT types found",
        "report.price_lines.no_vat_types_available": "No VAT types available",
        "report.price_lines.select_activity": "Select Activity",
        "report.price_lines.project_activity": "Project activity",
        "report.price_lines.select_project_activity": "Select project activity",
        "report.price_lines.select_project_first": "Select a project first",
        "report.price_lines.remove_activity": "Remove Activity",
        "report.price_lines.agreed_hours": "Agreed Hours",
        "project_activity.label": "Project activity",
        "project_activity.select": "Select project activity",
        "project_activity.dialog_title": "Select project activity",
        "project_activity.search_placeholder": "Search project activities…",
        "project_activity.empty": "No project activities found",
        "project_activity.select_project_first": "Select a project first",
        "project_activity.load_error": "Could not load project activities",
        "project_activity.clear_selection": "Clear selection",
        "project_activity.none": "No project activity",
        "project_activity.missing": "No project line",
        "hours.period_table.project_and_line": "Project / project line",
        "Loading": "Loading",
        "hours.registration_warning.title": "Warning: Hours Exceed Estimated",
        "hours.registration_warning.message": "You are about to register {newHours} hours on activity \"{activityTitle}\". This will bring the total registered hours to {totalAfterRegistration} hours, which exceeds the estimated {estimatedHours} hours. Currently registered: {registeredHours} hours.",
        "hours.registration_warning.question": "Are you sure you want to register these hours on this activity?",
        "hours.registration_warning.confirm": "Yes, I'm sure",
        "hours.registration_warning.cancel": "No, correct",
        "hours.registration_warning.this_activity": "this activity",
        "hours.form_tab_details": "Details",
        "hours.form.public_holiday_title": "Public holiday",
        "hours.form.public_holiday_body": "{{name}} is a public holiday. Expected working hours are 0 on this day, but you can still register hours if needed.",
        "absence.form.public_holiday_title": "Public holiday",
        "absence.form.public_holiday_body": "Absence cannot be registered on public holidays. The selected period includes: {{names}}.",
        "absence.form.public_holiday_blocked": "Absence cannot be registered on public holidays ({{names}}).",
        "absence.edit.title_new": "New absence",
        "absence.edit.title_edit": "Edit absence",
        "absence.edit.close": "Close",
        "absence.edit.employee": "Employee",
        "absence.edit.select_employee": "Select employee",
        "absence.edit.employee_admin_only": "Visible to administrators only",
        "absence.edit.absence_type": "Absence type",
        "absence.edit.select_absence_type": "Select absence type",
        "absence.edit.type_search": "Search absence type",
        "absence.edit.type_empty": "No absence types found",
        "absence.edit.loading": "Loading …",
        "absence.edit.type_balance": "Used {{used}} · {{remaining}} days left",
        "absence.edit.type_hours_left": "{{hours}} hours left",
        "absence.edit.select_employee_first": "Select an employee first",
        "absence.edit.select_absence_type_first": "Select an absence type first",
        "absence.edit.period": "Period",
        "absence.edit.description": "Description",
        "absence.edit.max_days_hint_one": "Maximum 1 day for this absence type",
        "absence.edit.max_days_hint_other": "Maximum {{count}} days for this absence type",
        "absence.edit.comp_time_hint": "Time off in lieu is based on actual accrued hours, not a maximum number of days",
        "absence.edit.sick_leave_hint": "Sick leave is based on a doctor's certificate and has no limit on the number of days",
        "absence.edit.read_only_title": "Approved absence",
        "absence.edit.read_only_body": "This absence has been approved and cannot be edited.",
        "absence.edit.documents_title": "Attachments",
        "absence.edit.documents_subtitle": "Only PDF files are allowed",
        "absence.edit.documents_add": "Add file",
        "absence.edit.documents_remove": "Remove file",
        "absence.edit.documents_uploaded": "Attachments uploaded",
        "absence.edit.documents_upload_failed": "Could not upload attachments",
        "absence.edit.export_pdf": "Export PDF",
        "absence.edit.exporting": "Exporting …",
        "absence.edit.approve": "Approve",
        "absence.edit.delete": "Delete",
        "absence.edit.cancel": "Cancel",
        "absence.edit.save": "Save",
        "absence.edit.saving": "Saving …",
        "absence.edit.create": "Create absence",
        "absence.edit.update": "Save changes",
        "absence.edit.error_title": "Error saving absence",
        "absence.edit.saved": "Absence was saved",
        "absence.edit.saved_title": "Absence registered",
        "absence.edit.saved_body": "The absence has been registered and will be sent for approval.",
        "absence.edit.saved_body_with_documents": "The absence has been registered and will be sent for approval. Attachments have been uploaded.",
        "absence.edit.register_new": "Register new absence",
        "absence.edit.status": "Status",
        "absence.edit.pending_approval": "Pending approval",
        "absence.edit.load_failed": "Could not load absence",
        "absence.edit.load_error": "Something went wrong while loading the absence",
        "absence.edit.user_required": "An employee must be selected",
        "absence.edit.user_required_save": "You must select an employee before you can save the absence",
        "absence.edit.user_id_required": "user_id is required to create/update an absence",
        "absence.edit.unknown_save_error": "Unknown error while saving the absence",
        "absence.edit.pdf_must_save": "The absence must be saved before the PDF can be exported",
        "absence.edit.pdf_must_approve": "The absence must be approved before the PDF can be exported",
        "absence.edit.pdf_invalid": "The PDF file is too small or invalid",
        "absence.edit.pdf_exported": "PDF was exported",
        "absence.edit.pdf_failed": "Could not export PDF",
        "absence.edit.delete_failed": "Something went wrong while deleting the absence",
        "absence.edit.delete_confirm": "Are you sure you want to delete the absence?",
        "absence.edit.approve_title": "Approve absence",
        "absence.edit.approved_label": "Approved",
        "absence.edit.denied_label": "Not approved",
        "absence.edit.note": "Note",
        "absence.edit.approved_by": "Approved by {{name}}",
        "hours.approved_edit_notice_title": "Approved hour",
        "hours.approved_edit_notice_body":
          "This hour is approved. You can still edit it as a company administrator; approval status is kept. Payroll or Tripletex may need a manual check after changes.",
        "hours.bulk_reassign.project_field": "Project",
        "hours.bulk_reassign.title": "Move hours to another project / activity",
        "hours.bulk_reassign.intro": "You are editing {{count}} hour(s). Pick the target project, then the project activity line.",
        "hours.bulk_reassign.project_required": "Project is required",
        "hours.bulk_reassign.activity_required": "Project activity is required",
        "hours.bulk_reassign.submit": "Apply to selected hours",
        "hours.bulk_reassign.saving": "Saving…",
        "hours.bulk_reassign.success": "Updated {{count}} hour(s).",
        "hours.bulk_reassign.partial": "Updated {{updated}}; {{failed}} failed — see details in the list.",
        "hours.bulk_reassign.error": "Could not move hours",
        "hours.bulk_reassign.open": "Move selected…",
        "hours.split.open": "Split hours",
        "hours.split.open_hint": "Distribute this registration across multiple project activities. The sum must match the total.",
        "hours.split.title": "Split hours",
        "hours.split.intro": "Distribute the hours across multiple activities. The sum of the rows must equal the total hours.",
        "hours.split.total_label": "Total",
        "hours.split.unit": "h",
        "hours.split.sum_live": "Allocated {{allocated}} / Total {{total}}",
        "hours.split.remaining": "{{hours}} h remaining",
        "hours.split.over_allocated": "{{hours}} h over",
        "hours.split.mismatch_hint": "The sum must equal the total before you can save.",
        "hours.split.col_project": "Project",
        "hours.split.col_activity": "Activity",
        "hours.split.col_time": "Hours",
        "hours.split.col_description": "Description",
        "hours.split.description_placeholder": "Optional",
        "hours.split.add_row": "Add row",
        "hours.split.remove_row": "Remove row",
        "hours.split.row_n": "Row {{n}}",
        "hours.split.submit": "Save split",
        "hours.split.saving": "Saving…",
        "hours.split.success": "Hours were split into {{count}} rows.",
        "hours.split.error": "Could not split hours",
        "hours.approval.filter_project": "Project",
        "hours.approval.all_projects": "All projects",
        "hours.approval.clear_project_filter": "Clear project",
        "hours.approval.selection_summary.title": "Selection summary",
        "hours.approval.selection_summary.subtitle":
          "\"Registered\" and period totals come from the loaded list for the selected date range and filters (same rows as the table).",
        "hours.approval.selection_summary.total_selected": "Selected: {{hours}} h · {{entries}} entries",
        "hours.approval.selection_summary.period_totals": "In period (loaded): {{hours}} h · {{entries}} entries",
        "hours.approval.selection_summary.by_date": "By date",
        "hours.approval.selection_summary.day_row": "{{date}}: {{selected}} h selected of {{registered}} h registered",
        "hours.approval.selection_summary.other_days": "Other days with registrations: {{days}} days · {{hours}} h",
        "hours.approval.selection_summary.clear": "Clear selection",
        "hours.approval.selection_summary.unknown_user": "Unknown user",
        "hours.approval.bulk.select_required": "Select hours to process",
        "hours.approval.bulk.approve_note": "Bulk approved",
        "hours.approval.bulk.reject_note": "Bulk not approved",
        "hours.approval.bulk.success_approved": "{{count}} hour(s) approved",
        "hours.approval.bulk.success_rejected": "{{count}} hour(s) not approved",
        "hours.approval.bulk.partial": "{{done}} confirmed processed. {{remaining}} remaining — check status before retrying.",
        "hours.approval.bulk_unapprove.action": "Revoke approval for selected",
        "hours.approval.bulk_unapprove.no_approved": "None of the selected hours are approved — nothing to revoke.",
        "hours.approval.bulk_unapprove.success": "Approval revoked for {{count}} hour(s).",
        "hours.approval.bulk_unapprove.error": "Could not revoke approval for all selected hours",
        "hours.approval.bulk_unapprove.partial": "{{done}} revoked. {{remaining}} remaining — check status before retrying.",
        "hours.approval.bulk_unapprove.process_note": "Bulk approval revoked",
        "project.time_registration.bulk_reassign": "Move selected hours…",
        "project.time_registration.select_hour": "Select hour for bulk move",
        "hours.sheet.add_hour": "Add hour",
        "hours.sheet.edit_hour": "Edit hour",
        "hours.sheet.new_hour": "New hour",
        "hours.sheet.stats_title": "Summary",
        "hours.sheet.stats_selected_period": "Selected period (list)",
        "hours.sheet.stats_calendar_month": "Calendar month",
        "hours.sheet.stats_weeks_heading": "Weeks",
        "hours.sheet.stats_this_week": "This week",
        "hours.sheet.stats_prev_week": "Previous week",
        "hours.sheet.stats_normal_suffix": "normal (schedule)",
        "hours.sheet.stats_no_schedule": "No work schedule is linked to this employment — normal hours and percentages are not shown.",
        "hours.sheet.stats_loading_extra": "Loading month and week totals…",
        "hours.sheet.stats_compact_month": "Month",
        "hours.sheet.stats_show_more": "More",
        "hours.sheet.stats_show_less": "Less",
        "hours.sheet.stats_overview_title": "Overview",
        "hours.sheet.stats_close": "Close",
        "hours.sheet.eyebrow": "Time entry",
        "hours.sheet.scope_aria": "Choose view",
        "hours.sheet.employee_search": "Search employee…",
        "hours.sheet.employee_empty": "No matches",
        "hours.sheet.employee_none": "None selected",
        "hours.sheet.employee_role_fallback": "Employee",
        "hours.sheet.week_label": "Week {{week}}",
        "hours.sheet.day_none": "no hours",
        "hours.sheet.day_partial": "partial",
        "hours.sheet.day_complete": "complete",
        "hours.sheet.entry_count": "{{count}} entries · {{projects}} projects",
        "hours.sheet.export_aria": "Export timesheet",
        "hours.sheet.export_pdf": "PDF",
        "hours.sheet.export_excel": "Excel",
        "hours.sheet.export_pdf_loading": "Creating PDF…",
        "hours.sheet.export_excel_loading": "Creating Excel…",
        "hours.sheet.export_pdf_success": "Timesheet downloaded as PDF",
        "hours.sheet.export_excel_success": "Timesheet downloaded as Excel",
        "hours.sheet.export_error": "Could not export the timesheet",
        "outbound_communications.title": "Email log",
        "outbound_communications.search": "Search",
        "outbound_communications.search_placeholder": "Search subject, recipient or body",
        "outbound_communications.load_error": "Could not load the email log",
        "outbound_communications.not_found": "Email not found",
        "outbound_communications.no_subject": "(no subject)",
        "outbound_communications.system": "System",
        "outbound_communications.col_sent": "Sent",
        "outbound_communications.col_subject": "Subject",
        "outbound_communications.col_from": "From",
        "outbound_communications.col_to": "To",
        "outbound_communications.col_sent_by": "Sent by",
        "outbound_communications.col_type": "Type",
        "outbound_communications.col_customer": "Customer",
        "outbound_communications.export_pdf": "Export PDF",
        "outbound_communications.pdf_loading": "Creating PDF…",
        "outbound_communications.pdf_failed": "Could not export PDF",
        "outbound_communications.export_success": "PDF opened",
        "outbound_communications.select_all": "Select all",
        "outbound_communications.back": "Back to email log",
        "outbound_communications.attachments": "Attachments",
        "hours.sheet.of_normal": "of {{hours}}h normal",
        "hours.sheet.of_normal_short": "of {{hours}}h",
        "hours.sheet.new_entry_day": "New entry for this day",
        "hours.sheet.week_matrix_sub": "{{projects}} projects · {{activities}} activities",
        "hours.sheet.sum_day": "Day total",
        "hours.sheet.period_sub": "{{entries}} entries · {{days}} days with hours",
        "hours.sheet.period_avg": "avg {{hours}}h per active day",
        "hours.sheet.preset_this_month": "This month",
        "hours.sheet.preset_last_month": "Last month",
        "hours.sheet.preset_quarter": "Quarter",
        "hours.sheet.period_meta": "{{days}} days · {{count}} with entries",
        "hours.sheet.hours_left": "{{hours}}h left",
        "hours.sheet.prev_week_short": "Previous week {{hours}}h",
        "hours.sheet.stats_list_hint": "List below",
        "hours.sheet.project_split": "Project split",
        "hours.sheet.unsynced_title": "{{count}} entries not synced",
        "hours.sheet.unsynced_body": "Some hours have not been sent to payroll. Process them before the week closes.",
        "hours.sheet.unsynced_see": "View entry",
        "hours.sheet.unsynced_process": "Process now",
        "hours.sheet.week_progress_title": "Week {{week}} — progress toward normal hours",
        "hours.sheet.week_progress_body": "{{hours}} hours remaining before normal hours are reached.",
        "hours.sheet.hide_banner": "Hide",
        "hours.quick.title": "Quick time entry",
        "hours.quick.week_subtitle": "Week {{week}} · {{range}}",
        "hours.quick.mode_aria": "Choose time entry mode",
        "hours.quick.mode_form": "Form",
        "hours.quick.mode_quick": "Quick",
        "hours.quick.prev_week": "Previous week",
        "hours.quick.next_week": "Next week",
        "hours.quick.copy_last_week": "Copy last week",
        "hours.quick.saving": "Saving…",
        "hours.quick.saved": "✓ Saved",
        "hours.quick.save_idle": "Ready",
        "hours.quick.save_error": "Could not save hours",
        "quality.checklist.type.fieldResponseRules": "Field behavior for each response",
        "quality.checklist.type.fieldMode.hidden": "Hidden, not required",
        "quality.checklist.type.fieldMode.optional": "Visible, optional",
        "quality.checklist.type.fieldMode.required": "Visible, required",
        "quality.checklist.gaps.fields": "Required fields missing",
        "project.billing_plan.retention_completed_explanation": "Retention is calculated from completed work on the billing-plan row.",
        "project.billing_plan.retention_enable": "Apply percentage retention",
        "project.billing_plan.retention_percentage": "Percentage (%)",
        "project.billing_plan.retention_percentage_hint": "Enter a percentage from 0 to 100.",
        "hours.quick.outcome_unknown": "The save could not be confirmed. Reload saved hours before trying again. This replaces the draft in the grid.",
        "hours.quick.reload_saved": "Reload saved hours",
        "hours.quick.save_error_short": "Save error",
        "hours.quick.batch_fallback": "Batch save is temporarily unavailable — saving cells one by one.",
        "hours.quick.loading": "Loading week…",
        "hours.quick.col_project": "Project",
        "hours.quick.col_activity": "Activity",
        "hours.quick.col_sum": "Sum",
        "hours.quick.no_project": "Select project",
        "hours.quick.pick_activity": "Select activity",
        "hours.quick.description": "Description",
        "hours.quick.description_placeholder": "What did you work on?",
        "hours.quick.description_done": "Done",
        "hours.quick.fill_handle": "Drag to fill",
        "hours.quick.remove_row": "Remove row",
        "hours.quick.new_row": "New row",
        "hours.quick.search_placeholder": "Search project or activity…",
        "hours.quick.suggestions_hits": "Matches",
        "hours.quick.suggestions_recent": "Favorites and recently used",
        "hours.quick.no_suggestions": "No suggestions",
        "hours.quick.add_via_selectors": "Or pick a project",
        "hours.quick.browse_projects": "Browse projects",
        "hours.quick.pick_project": "Select project",
        "hours.quick.pick_activity_for_project": "Select activity…",
        "hours.quick.search_projects": "Search projects…",
        "hours.quick.search_activities": "Search activities…",
        "hours.quick.picker_search": "Search…",
        "hours.quick.no_projects": "No projects",
        "hours.quick.no_activities": "No activities",
        "hours.quick.tag_in_grid": "In grid",
        "hours.quick.row_already_exists": "Row already exists — focused it in the grid",
        "hours.quick.add_row_hint": "Same project with a different activity becomes a new row.",
        "hours.quick.tag_recent": "Recent",
        "hours.quick.tag_project": "Project",
        "hours.quick.norm_title": "Week vs normal hours",
        "hours.quick.norm_of": "of {{hours}} h",
        "hours.quick.norm_unknown": "no schedule",
        "hours.quick.norm_on_target": "On target",
        "hours.quick.norm_over": "+{{hours}} h over",
        "hours.quick.norm_left": "{{hours}} h left",
        "hours.quick.keyboard_hint": "Tab / Shift+Tab: next / previous cell · F2: note · Arrow keys to move · Enter down · Shift+PageUp/Down change week · drag corner to fill",
        "hours.quick.flush_now": "Save now",
        "hours.quick.cancel": "Cancel",
        "hours.quick.conflict_hint": "Multiple hours same day — double-click to open form",
        "hours.mobile.add": "Add hour",
        "hours.mobile.stats": "Statistics",
        "hours.mobile.navAriaLabel": "Hours navigation",
        "report.price_lines.updated": "Price line updated successfully",
        "report.price_lines.created": "Price line created successfully",
        "report.price_lines.deleted": "Price line deleted successfully",
        "report.price_lines.save_error": "Failed to save price line",
        "report.price_lines.delete_error": "Failed to delete price line",
        "report.price_lines.edit": "Edit Price Line",
        "report.copy.price_lines_option": "Price lines",
        "report.copy.variables_option": "Variables",
        "report.sequel.copy_variables_switch": "Copy from main report",
        "report.sequel.copy_variables_hint_on":
          "Variables will be copied from the main report, including groups, type groups, values, and measurements.",
        "report.sequel.copy_variables_hint_off": "No variables will be copied.",
        "report.sequel.copy_variables_none_available":
          "No variable rows or groups on the main report — nothing to copy.",
        "report.sequel.copy_price_lines_switch": "Copy from main report",
        "report.sequel.copy_price_lines_hint_on":
          "Price lines will be copied from the main report ({{count}} lines).",
        "report.sequel.copy_price_lines_hint_off": "No price lines will be copied.",
        "report.sequel.copy_price_lines_none_available": "No price lines on the main report.",
        "report.price_lines.updating": "Updating...",
        "report.price_lines.adding": "Adding...",
        "report.price_lines.delete_confirm": "Are you sure you want to delete this price line?",
        "report.price_lines.delete": "Delete Price Line",
        "report.price_lines.error_loading": "Error Loading Price Lines",
        "report.price_lines.add_first": "Add First Price Line",
        "report.price_lines.title_required": "Title is required",
        "report.price_lines.validation.agreed_price_or_hours":
            "Enter an agreed price (excl. or incl. VAT) or agreed hours, or turn off «Agreed price line».",
        "report.price_lines.server_errors_title": "Could not save — check the messages below",
        "report.price_lines.field_errors_hint": "Fields with problems are highlighted.",
        "report.details.description": "Basic report information",
        "report.items.description": "Manage items and consumption",
        "report.activities.description": "Manage activities and hours",
        "report.checklist.description": "Complete checklist items",
        "report.checklist.loading": "Loading checklist…",
        "report.checklist.load_error": "Could not load checklist",
        "report.checklist.load_error_title": "Checklist could not be loaded",
        "report.checklist.load_error_hint":
          "Go to another step and back, or close and reopen the dialog. If the problem continues, try again later.",
        "quality.checklist.view.completionTitle": "Checklist completion",
        "quality.checklist.field.house": "House",
        "quality.checklist.field.apartment": "Apartment number",
        "quality.checklist.view.completionDescription":
          "When all lines are approved or marked as a deviation, you can finalize the checklist. Unsaved changes are saved when you continue.",
        "quality.checklist.view.completionButton": "Finalize checklist",
        "quality.checklist.view.completionSaving": "Saving…",
        "quality.checklist.view.completionDoneTitle": "Checklist finalized",
        "quality.checklist.view.completionDoneDescription":
          "This checklist is marked as finished.",
        "quality.checklist.type.titleLabel": "Title",
        "quality.checklist.type.activeLabel": "Active",
        "quality.checklist.type.introLabel": "Introduction for this checklist type",
        "quality.checklist.type.defaultActions": "Available responses",
        "quality.checklist.type.defaultActionsHint":
          "Choose which outcome buttons should appear on checklist lines. Points can narrow this list further.",
        "quality.checklist.type.pointsHeading": "Checklist points",
        "quality.checklist.type.pointsSubheading":
          "Add titles, customer-facing guidance, and which response buttons apply to each point.",
        "quality.checklist.type.documentsRequired": "Documents required",
        "quality.checklist.type.pointLabel": "Point {{n}}",
        "quality.checklist.type.pointTitle": "Point title",
        "quality.checklist.type.guidanceLabel": "Customer guidance",
        "quality.checklist.type.guidanceHint":
          "Shown to the person filling the checklist so they understand what to verify. Freetext answers are captured separately per line.",
        "quality.checklist.type.pointActions": "Responses for this point",
        "quality.checklist.type.pointActionsHint":
          "Turn off responses that should not appear for only this point. Defaults follow the checklist type.",
        "quality.checklist.type.addRow": "Add point",
        "quality.checklist.type.deleteRowConfirm": "Delete this point?",
        "quality.checklist.type.customFieldsTitle": "Custom fields",
        "quality.checklist.type.customFieldsHint":
            "Add input fields the technician must fill in when executing this point (e.g. measured current, recovery rate).",
        "quality.checklist.type.customFieldLabel": "Label",
        "quality.checklist.type.customFieldType": "Type",
        "quality.checklist.type.customFieldUnit": "Unit",
        "quality.checklist.type.customFieldPlaceholder": "Placeholder",
        "quality.checklist.type.customFieldRequired": "Required",
        "quality.checklist.type.customFieldAdd": "Add field",
        "quality.checklist.type.customFieldTypes.text": "Text",
        "quality.checklist.type.customFieldTypes.number": "Number",
        "quality.checklist.type.customFieldTypes.textarea": "Long text",
        "quality.checklist.type.print": "Print template (PDF)",
        "quality.checklist.type.print_failed": "Could not generate PDF",
        "quality.checklist.type.json.open_dialog": "JSON / AI",
        "quality.checklist.type.json.dialog_title": "JSON and AI for checklist type",
        "quality.checklist.type.json.tab_json": "Paste JSON",
        "quality.checklist.type.json.tab_ai_guide": "AI instructions",
        "quality.checklist.type.json.hint": "Paste JSON from ChatGPT or another AI, or edit the current type. Supports { \"items\": [...] } or full type with title, description and default_response_actions.",
        "quality.checklist.type.json.replace_items": "Replace all points",
        "quality.checklist.type.json.append_items": "Append at bottom",
        "quality.checklist.type.json.copy_json": "Copy JSON",
        "quality.checklist.type.json.reload_from_editor": "Reload from editor",
        "quality.checklist.type.json.insert_sample": "Insert sample",
        "quality.checklist.type.json.apply": "Apply JSON",
        "quality.checklist.type.json.applied": "{{count}} points imported",
        "quality.checklist.type.json.copy_success": "JSON copied",
        "quality.checklist.type.json.reload_success": "JSON reloaded from editor",
        "quality.checklist.type.json.clipboard_failed": "Could not copy to clipboard",
        "quality.checklist.type.json.ai_guide_intro": "Copy the instructions below into ChatGPT, Claude or another AI. Then paste the JSON response in the Paste JSON tab.",
        "quality.checklist.type.json.copy_ai_guide": "Copy AI instructions",
        "quality.checklist.type.json.ai_guide_copied": "AI instructions copied",
        "quality.checklist.type.json.generate_with_ai": "Generate with AI",
        "quality.checklist.type.json.ai_parse_error": "Could not parse AI response as JSON",
        "quality.checklist.type.json.ai_apply_success": "{{count}} points applied from AI",
        "quality.checklist.type.json.error_empty": "JSON field is empty",
        "quality.checklist.type.json.error_invalid_json": "Invalid JSON — check syntax",
        "quality.checklist.type.json.error_no_items_array": "No items array found in JSON",
        "quality.checklist.type.json.error_no_valid_items": "No valid points after import",
        "quality.checklist.type.hse.title": "HSE document register",
        "quality.checklist.type.hse.description":
          "Register the checklist type as a controlled form (SKJ) in HSE documents under the selected chapter and discipline.",
        "quality.checklist.type.hse.register": "Add as HSE document",
        "quality.checklist.type.hse.registered": "Registered in HSE documents",
        "quality.checklist.type.hse.update_placement": "Update placement",
        "quality.checklist.type.hse.open_document": "Open HSE document",
        "quality.checklist.type.hse.save_type_first": "Save the checklist type first",
        "quality.checklist.type.hse.category_required": "Category is required",
        "quality.checklist.type.hse.register_failed": "Could not register in HSE documents",
        "quality.checklist.type.hse.settings_hint":
          "Register checklist types as HSE documents and choose where they belong in the document structure. Use the document icon in the list to configure placement.",
        "quality.checklist.type.hse.column": "HSE document",
        "quality.checklist.type.hse.configure": "Configure HSE document placement",
        "quality.checklist.type.hse.configure_short": "HSE placement",
        "quality.checklist.type.hse.registered_short": "Registered",
        "quality.checklist.type.hse.not_registered": "Not registered",
        "quality.checklist.type.hse.create_checklist": "Create checklist",
        "quality.checklist.type.hse.checklist_template_title": "Checklist template",
        "quality.checklist.type.hse.checklist_template_description": "This document is linked to a checklist type. Create and fill out a new checklist from the template.",
        "quality.checklist.type.hse.checklist_created": "Checklist created",
        "quality.checklist.type.hse.create_failed": "Could not create checklist",
        "quality.checklist.type.hse.preview_label": "Checklist template (preview)",
        "quality.checklist.type.hse.preview_draft_version": "Preview of draft revision {{version}}",
        "quality.checklist.type.hse.preview_empty": "No checklist items in template",
        "quality.checklist.type.hse.source_hse": "HSE checklist",
        "quality.checklist.type.hse.updated_checklist_available": "Updated checklist available",
        "quality.checklist.type.hse.updated_checklist_available_hint": "The checklist type has changed since the last approved revision. Create a new revision to publish the changes in the HSE document.",
        "quality.checklist.type.hse.create_revision": "Create revision",
        "quality.checklist.type.hse.document_needs_update": "Document must be updated",
        "quality.checklist.type.hse.document_needs_update_hint": "Changes to the checklist type are not shown in the HSE document until you create a new revision.",
        "quality.checklist.type.hse.document_needs_update_create_hint": "Create a revision to publish the changes in the HSE document. You can edit the checklist here afterwards.",
        "quality.checklist.type.hse.document_needs_update_open_hint": "The checklist has changed since the last approved HSE revision. Open the document to update the draft revision and submit for approval.",
        "quality.checklist.type.hse.edit_checklist": "Edit checklist",
        "quality.checklist.type.hse.create_revision_and_edit_checklist": "Create revision and edit checklist",
        "quality.checklist.type.hse.revision_in_progress_title": "Revision in progress",
        "quality.checklist.type.hse.revision_in_progress_hint": "Edit the checklist and submit the revision for approval when you are done.",
        "quality.checklist.type.hse.revision_in_progress_stale_hint": "The checklist has changed since the revision was created. Refresh the revision to include the changes.",
        "quality.checklist.type.hse.revision_in_progress_edit_hint": "Edit the checklist below. Return to the HSE document to submit the revision for approval.",
        "quality.checklist.type.hse.view_draft_revision": "View draft revision",
        "quality.checklist.type.hse.refresh_draft_revision": "Refresh revision",
        "quality.checklist.type.hse.back_to_document": "Back to HSE document",
        "quality.checklist.type.hse.revision_created": "Revision created",
        "quality.checklist.type.hse.revision_create_failed": "Could not create revision",
        "quality.checklist.type.hse.draft_snapshot_refreshed": "Draft revision updated with current checklist",
        "quality.checklist.type.hse.draft_snapshot_refresh_failed": "Could not refresh draft revision",
        "quality.checklist.type.hse.checklist_revision_summary": "Updated checklist template",
        "quality.checklist.gaps.complete": "{{resolved}} of {{total}} items completed",
        "quality.checklist.gaps.remaining": "{{count}} items remaining",
        "quality.checklist.gaps.toggle": "Show remaining items",
        "quality.checklist.gaps.untitled": "Untitled",
        "quality.checklist.gaps.unanswered": "Unanswered",
        "quality.checklist.gaps.documents": "Missing documents",
        "quality.checklist.gaps.missing": "Missing",
        "quality.checklist.gaps.statusDone": "Done",
        "quality.checklist.gaps.statusOpen": "Open",
        "quality.checklist.selector.title": "Select checklist",
        "quality.checklist.selector.confirm": "Confirm",
        "quality.checklist.selector.mode_heading": "Choose checklist source",
        "quality.checklist.selector.mode_empty": "New empty checklist",
        "quality.checklist.selector.mode_empty_hint": "Create a completely new empty checklist",
        "quality.checklist.selector.mode_copy": "Copy from existing",
        "quality.checklist.selector.mode_copy_hint": "Copy items from {{source}}",
        "quality.checklist.selector.mode_type": "From checklist type",
        "quality.checklist.selector.mode_type_hint": "Pick a checklist type and which items to include",
        "quality.checklist.selector.title_label": "Checklist title",
        "quality.checklist.selector.title_placeholder": "Title is set automatically when you pick a type",
        "quality.checklist.selector.copy_from": "Copying from: {{source}}",
        "quality.checklist.selector.copy_source": "source",
        "quality.checklist.selector.copy_all": "All items ({{count}})",
        "quality.checklist.selector.copy_non_approved": "Non-approved items only ({{count}})",
        "quality.checklist.selector.type_guidance": "Recommended: checklist types linked to an approved HSE document. Other types can still be used but are not part of an approved revision.",
        "quality.checklist.selector.search_placeholder": "Search checklist types…",
        "quality.checklist.selector.choose_type": "Choose checklist type",
        "quality.checklist.selector.choose_type_first": "Select a checklist type on the left",
        "quality.checklist.selector.choose_type_first_hint": "Checklist points will appear here for selection.",
        "quality.checklist.selector.choose_items": "Choose items from \"{{title}}\"",
        "quality.checklist.selector.no_types": "No checklist types available",
        "quality.checklist.selector.no_search_results": "No search results",
        "quality.checklist.selector.no_items_in_type": "No items in this checklist type",
        "quality.checklist.selector.points": "items",
        "quality.checklist.selector.select_all": "Select all",
        "quality.checklist.selector.deselect_all": "Clear all",
        "quality.checklist.selector.items_selected": "{{selected}} of {{total}} items selected",
        "quality.checklist.selector.status_unlinked": "Not an HSE document",
        "quality.checklist.selector.status_hse_linked": "HSE document",
        "quality.checklist.selector.status_hse_approved": "Approved – rev. {{version}}",
        "quality.checklist.selector.status_hse_pending": "HSE pending approval (rev. {{version}})",
        "quality.checklist.selector.status_hse_pending_short": "HSE pending approval",
        "quality.checklist.selector.status_hse_draft": "HSE draft (rev. {{version}})",
        "quality.checklist.selector.status_hse_draft_short": "HSE draft",
        "quality.checklist.selector.load_error": "Could not load checklist types",
        "quality.checklist.selector.items_load_error": "Could not load checklist items",
        "quality.checklist.selector.select_one_item": "Select at least one checklist item",
        "quality.checklist.selector.copy_no_items": "No items to copy",
        "quality.checklist.selector.context_heading": "Checklist details",
        "quality.checklist.selector.context_date_required": "Date is required",
        "quality.checklist.selector.context_customer_required": "Customer is required",
        "quality.checklist.selector.context_project_required": "Project is required",
        "quality.checklist.selector.context_responsible_required": "Responsible person is required",
        "quality.checklist.actions.performed": "Performed",
        "quality.checklist.actions.approved": "Approved",
        "quality.checklist.actions.na": "Not applicable",
        "quality.checklist.actions.deviation": "Deviation",
        "quality.checklist.item.title": "Title",
        "quality.checklist.item.guidanceTitle": "Guidance",
        "quality.checklist.item.completionNote": "Notes / what was observed",
        "quality.checklist.item.deviationNoteRequired": "Add a short explanation for the deviation.",
        "quality.checklist.item.responseLabel": "Outcome",
        "quality.checklist.item.customFieldsTitle": "Measurements / data",
        "quality.checklist.item.customFieldRequired": "This field is required",
        "quality.checklist.item.customFieldsRequiredBeforeOutcome":
            "Fill in required fields before selecting an outcome.",
        "quality.checklist.item.uploadImageDirect": "Upload photos",
        "quality.checklist.item.uploadImageDirectShort": "Camera",
        "quality.checklist.item.uploadImageDestination": "Checklist item: {{title}}",
        "quality.checklist.item.uploadImagesOnly": "Only image files can be uploaded here.",
        "quality.checklist.item.uploadImagePreviewTitle": "Preview before upload",
        "quality.checklist.item.uploadImagePreviewHint":
            "{{count}} image(s) ready. Remove any you do not want, then confirm to upload in the background.",
        "quality.checklist.item.uploadImageRemove": "Remove image",
        "quality.checklist.item.uploadImageAddMore": "Add more",
        "quality.checklist.item.uploadImageConfirm": "Upload {{count}} image(s)",
        "quality.checklist.item.saving": "Saving…",
        "quality.checklist.item.savePending": "Changes pending…",
        "quality.checklist.item.saved": "Saved",
        "quality.checklist.item.saveError": "Save failed",
        "quality.checklist.item.saveFailed": "Could not save change",
        "quality.checklist.item.close": "Close",
        "quality.checklist.item.savingClose": "Saving…",
        "report.type.required": "Report type is required",
  
        // Report admin menu
        "report.admin.title": "Admin",
        "report.admin.status": "Report status",
        "report.admin.status_desc": "Under process, processed, invoiced",
        "report.admin.reset": "Reset",
        "report.admin.reset_desc": "Reset report modules",
        "report.admin.view_main_report": "View main report",
        "report.admin.view_sequel": "Go to follow-up",
        "report.admin.view_case": "View case",
        "report.admin.create_case": "Create case",
        "report.admin.create_case_desc": "Create or link case for report follow-up",
        "report.admin.case_dialog_title": "Report follow-up",
        "report.admin.create_sequel": "Create follow-up",
        "report.admin.create_sequel_desc": "Create new report as follow-up",
        "report.admin.create_order": "Create order",
        "report.admin.create_order_desc": "Create an order from this report (hours, mileage, lines)",
        "report.admin.open_mentions": "Open case where report is mentioned",
        "report.admin.open_mentions_desc": "View cases and notes that mention this report",
        "report.admin.mentions_dialog_title": "Report mentioned in",
        "report.admin.mentioned_at": "Mentioned",
        "report.admin.no_mentions": "Report is not mentioned elsewhere",

        "report.dev.title": "Dev",
        "report.dev.variables_v2": "Variables V2",
        "report.dev.variables_v2_desc": "Edit report variables (grouped editor)",

        "report.variables.legacy.headingOnly": "Variables",
        "report.variables.legacy.headingTagged": "Variables (legacy)",
        "report.variables.legacy.saving": "Saving…",
        "report.variables.legacy.save": "Save variables",
        "report.variables.orphaned.title": "Incomplete main variables",
        "report.variables.orphaned.body":
          "These are flagged as main variables but lack a type group. Link them to a type group or delete them.",
        "report.variables.ungrouped.heading": "Variables without a group",
        "report.variables.groups.heading": "Groups",
        "report.variables.newSystem.title": "Variables",
        "report.variables.createTypeGroup": "Create type group",
        "report.variables.createGroup": "Create group",
        "report.variables.sketch.tablist": "Variables (sketch)",
        "report.variables.sketch.groupTablist": "Groups and overview",
        "report.variables.sketch.navGroupLabel": "Group",
        "report.variables.sketch.navVariableTypeLabel": "Variable type",
        "report.variables.sketch.typeTablist": "Variable types",
        "report.variables.sketch.noTypesInGroup": "No variable types here yet.",
        "report.variables.sketch.ungroupedTab": "Ungrouped",
        "report.variables.sketch.ungroupedTabSub": "{{count}} variable types",
        "report.variables.sketch.pickVariableType": "Select a variable type in the tab row above.",
        "report.variables.sketch.addGroup": "Add group",
        "report.variables.sketch.groupNoTypes": "No type groups",
        "report.variables.sketch.unitsNotSet": "Measurement unit not set",
        "report.variables.sketch.untitledGroup": "Untitled",
        "report.variables.sketch.measureLabel": "Meas.",
        "report.variables.sketch.projectedShort": "Proj.",
        "report.variables.sketch.variableTypeFallback": "Variable type",
        "report.variables.sketch.tabOrphaned": "Incomplete",
        "report.variables.sketch.tabOrphanedSub": "{{count}} main variables",
        "report.variables.sketch.tabLegacySub": "Legacy format",
        "report.variables.sketchTab.legacy": "Legacy",
        "report.variables.sketch.emptyAll":
          "No groups or ungrouped variable types yet. Use the buttons above to create.",
        "report.variables.sketch.groupTabEmpty":
          "No type groups in this tab yet. Add a main variable.",
        "report.variables.sketch.editGroup": "Edit group",
        "report.variables.sketch.addMainVariable": "Main variable",
        "report.variables.sketch.addAnotherMainVariable": "Add another main variable to this group",
        "report.variables.sketch.typeGroupUngrouped": "Type group (ungrouped)",
        "report.variables.sketch.deleteGroupAria": "Delete group",
        "report.variables.sketch.structureMenuTrigger": "Group & structure",
        "report.variables.sketch.structureMenuAria": "Group and structure — more actions",
        "report.variables.sketch.deleteGroupMenu": "Delete group",
        "report.variables.sketch.addVariable": "Add variable",
        "report.variables.sketch.addBulkVariables": "Bulk add variables",
        "report.variables.sketch.editTypeGroupAria": "Edit variable type",
        "report.variables.sketch.deleteTypeGroupAria": "Delete variable type",
        "report.variables.sketch.typeGroupMoreAria": "More actions for this variable type",
        "report.variables.sketch.editTypeGroupMenu": "Edit variable type",
        "report.variables.sketch.deleteTypeGroupMenu": "Delete variable type",
        "report.variables.sketch.measurements": "Measurements",
        "report.variables.sketch.editVariable": "Edit",
        "report.variables.sketch.editVariableAria": "Edit variable",
        "report.variables.sketch.deleteVariable": "Delete",
        "report.variables.sketch.deleteVariableAria": "Delete variable",
        "report.variables.sketch.variableRowMenuAria": "Variable actions",
        "report.variables.sketch.noSubvariablesYet": "No variables yet",
        "report.variables.sketch.actionSheetClose": "Close",
        "report.variables.sketch.openVariableActionsAria": "Show actions for variable",
        "report.variables.sketch.variableActionsTitle": "Variable",
        "report.variables.sketch.variableActionsHint": "Choose an action below.",
        "report.variables.sketch.rowProjected": "Projected:",
        "report.variables.sketch.rowPreMeasurement": "Pre-measurement:",
        "report.variables.sketch.rowMeasured": "Measured:",
        "report.variables.sketch.globalTotalsHeading": "Total per variable type (all groups)",
        "report.variables.sketch.globalStatTotalLabel": "Total",
        "report.variables.sketch.globalSumProjected": "Proj. (total)",
        "report.variables.sketch.globalSumPre": "Pre (total)",
        "report.variables.sketch.globalSumMeasured": "Measured (total)",
        "report.variables.sketch.tabSumProjected": "Σ Proj.",
        "report.variables.sketch.tabSumPre": "Σ Pre",
        "report.variables.sketch.tabSumMeasured": "Σ Meas.",
        "report.variables.sketch.cardTotalPrefix": "TOTAL",
        "report.variables.sketch.totalsProjRow": "Proj. total",
        "report.variables.sketch.totalsPreRow": "Pre total",
        "report.variables.sketch.totalsMeasRow": "Measured total",
        "report.variables.sketch.newGroup": "New group",
        "report.variables.sketch.typeGroupShort": "Type group",
        "report.variables.sketch.tableColVariable": "Variable",
        "report.variables.sketch.tableColProj": "Proj.",
        "report.variables.sketch.tableColPre": "Pre",
        "report.variables.sketch.tableColMeas": "Meas.",
        "report.variables.sketch.tableColLsSuffix": "(l/s)",
        "report.variables.sketch.bulkAddShort": "Bulk-add",
        "report.variables.sketch.fabNoType": "Create a type group before adding variables.",
        "report.variables.sketch.statusMeasuredOnly": "Measured",
        "report.variables.sketch.statusGood": "Good",
        "report.variables.sketch.statusCheck": "Check",
        "report.variables.sketchEditor.statusMeasured": "Measured",
        "report.variables.sketchEditor.statusGood": "Good match",
        "report.variables.sketchEditor.statusGoodSub": "Measured value is within an acceptable range",
        "report.variables.sketchEditor.statusCheck": "Check deviation",
        "report.variables.sketchEditor.statusCheckSub": "Measured differs more than 15% from projected",
        "report.variables.sketchEditor.refRequired": "Reference is required",
        "report.variables.sketchEditor.saveError": "Could not save",
        "report.variables.sketchEditor.measureError": "Could not save measurement",
        "report.variables.sketchEditor.saved": "Saved",
        "report.variables.sketchEditor.noGroup": "Ungrouped",
        "report.variables.sketchEditor.measuredActual": "Measured (actual)",
        "report.variables.sketchEditor.cancel": "Cancel",
        "report.variables.sketchEditor.saving": "Saving…",
        "report.variables.sketchEditor.saveChanges": "Save changes",
        "report.variables.sketchEditor.deleteSubvariable": "Delete sub-variable",
        "report.variables.sketchEditor.deleteSubvariableHint":
          "This only removes this sub-variable. The main variable and type group stay.",
        "report.variables.sketchEditor.deleteSubvariableConfirm":
          "Delete sub-variable «{{reference}}»? Measurements and values are permanently removed.",
        "report.variables.sketchEditor.subvariableDeleted": "Sub-variable deleted",
        "report.variables.sketchEditor.subvariableDeleteError": "Could not delete variable",
        "report.variables.sketchEditor.deleteSubvariableCancel": "Cancel",
        "report.variables.sketchEditor.deleteSubvariableWorking": "Deleting…",
        "report.variables.sketchEditor.deleteSubvariableConfirmAction": "Delete permanently",
        "report.variables.sketchEditor.measuredHint":
          "Updates the latest measurement on save. Use “Add measurement” below to register additional readings.",
        "report.variables.sketchEditor.addMeasurementHeading": "Add new measurement",
        "report.variables.sketchEditor.addMeasurementValue": "Measurement value",
        "report.variables.sketchEditor.addMeasurementButton": "Add",
        "report.variables.sketchEditor.addingMeasurement": "Adding…",
        "report.variables.sketchEditor.measurementAdded": "Measurement added",
        "report.variables.sketchEditor.measurementInvalid": "Enter a valid measurement value",
        "report.variables.sketchEditor.historyHeading": "Measurement history ({{count}})",
        "report.variables.sketchEditor.historyLoading": "Loading measurements…",
        "report.variables.sketchEditor.historyEmpty": "No measurements recorded",
        "report.variables.sketchEditor.historyLoadError": "Could not load measurements",
        "report.variables.sketchEditor.historyColValue": "Value",
        "report.variables.sketchEditor.historyColDate": "Date/time",
        "report.variables.sketchEditor.tabMeasurements": "Measurements",
        "report.variables.sketchEditor.tabDetails": "Values",
        "report.variables.sketchEditor.tabsAria": "Variable editor sections",
        "report.variables.sketchEditor.measurementsIntro": "Add a reading or browse history.",
        "report.variables.sketchEditor.detailsIntro": "Reference and fields saved together.",
        "report.variables.sketchEditor.goToDetails": "Edit reference and other values →",
        "report.variables.sketchEditor.close": "Close",
        "report.variables.sketchEditor.addMeasurementPlaceholder": "Value",
        "report.variables.sketchEditor.measuredHintDetails":
          "Updates the latest reading if you save a new value here. Add new measurement points on the Measurements tab.",
        "report.variables.measurementDialog.title": "Measurements",
        "report.variables.measurementDialog.variableFallback": "Variable",
        "report.variables.measurementDialog.contextHeading": "Basis",
        "report.variables.measurementDialog.reference": "Reference",
        "report.variables.measurementDialog.measurementUnit": "Measurement unit",
        "report.variables.measurementDialog.projectedUnit": "Projected unit",
        "report.variables.measurementDialog.projectedLabel": "Projected",
        "report.variables.measurementDialog.preMeasurementLabel": "Pre-measurement",
        "report.variables.measurementDialog.latestHeading": "Latest measurement",

        "project": "Project",
        "project_plan": "Project plan",
        "projects_plan": "Project plan",
        "projects_accounting": "Project accounting",
        "project.details": "Project Details",
        "project.manager": "Project manager",
        "project.view.customer": "Customer",
        "project.view.copy_title": "Copy to clipboard",
        "project.view.mobileActions.ariaLabel": "Quick project actions",
        "project.view.mobileNav.ariaLabel": "Project navigation",
        "project.view.mobileNav.project": "Project",
        "project.view.mobileNav.tabs": "Tabs",
        "project.view.mobileNav.workOrders": "Work orders",
        "project.view.mobileNav.drawings": "Drawings",
        "project.view.mobileNav.folders": "Folders",
        "project.view.mobileNav.takePhoto": "Take photo",
        "project.view.mobileNav.contactsTitle": "Project contacts",
        "project.view.mobileNav.more": "More",
        "project.view.quickActions.title": "Quick actions",
        "project.view.quickActions.ariaLabel": "Project quick actions",
        "project.view.mobileActions.openActions": "Open quick actions",
        "project.view.mobileActions.closeActions": "Close quick actions",
        "project.view.mobileActions.actionsTitle": "Quick actions",
        "project.view.mobileActions.tabsTitle": "Project tabs",
        "project.actions.new_deviation": "New deviation",
        "project.actions.new_deviation_short": "Deviation",
        "project.actions.new_deviation_description": "Create a new deviation for this project",
        "project.actions.new_checklist_short": "Checklist",
        "project.actions.print_label": "Print label",
        "project.actions.service_report": "Service report",
        "project.actions.service_report_short": "Report",
        "project.checklist.create": "Create checklist",
        "project.checklist.create_description":
          "Create a new checklist for this project",
        "project.checklist.default_title":
          "Project checklist #{{number}}{{suffix}}",
        "project.checklist.generic_title": "Checklist #{{number}} ({{date}})",
        "project.checklist.title_required": "Title is required",
        "project.checklist.create_failed": "Failed to create checklist",
        "project.checklist.create_success": "Checklist created successfully",
        "project.checklist.id_missing": "Checklist ID not found",
        "project.tabs.updates": "Updates",
        "project.actions.service_report_description": "Create a service report",
        "project.actions.work_order": "Work order",
        "project.actions.work_order_short": "Work order",
        "project.actions.work_order_description": "Create a new work order",
        "project.actions.new_folder": "New folder",
        "project.actions.new_folder_short": "Folder",
        "project.actions.new_folder_description": "Create a new folder for this project",
        "project.actions.register_hours": "Register hours",
        "project.actions.register_hours_short": "Hours",
        "project.actions.register_hours_description": "Go to time registration for this project",
        "document_archive.tab": "Archive",
        "document_archive.brand": "Archive",
        "document_archive.project": "Project",
        "document_archive.project_archive": "Project archive",
        "document_archive.all_files": "All files",
        "document_archive.recent": "Recent",
        "document_archive.folders": "Folders",
        "document_archive.files": "Files",
        "document_archive.upload": "Upload",
        "document_archive.new_folder": "New folder",
        "document_archive.search_placeholder": "Search files and folders",
        "document_archive.modified": "Modified",
        "document_archive.grid": "Grid",
        "document_archive.list": "List",
        "document_archive.col_name": "Name",
        "document_archive.col_modified": "Modified",
        "document_archive.col_size": "Size",
        "document_archive.open": "Open",
        "document_archive.share": "Share",
        "document_archive.location": "Location",
        "document_archive.status": "Status",
        "document_archive.select_file": "Select a file to see details",
        "document_archive.file_details": "File details",
        "document_archive.empty_files": "No files in this folder yet.",
        "document_archive.no_folders": "No folders yet",
        "document_archive.files_count": "{{count}} files",
        "document_archive.result_line": "{{files}} files · {{folders}} folders",
        "document_archive.storage_hint": "{{files}} files in {{folders}} folders",
        "document_archive.load_error": "Could not load documents",
        "document_archive.missing_file": "This file has no download URL",
        "document_archive.link_copied": "Link copied",
        "document_archive.copy_failed": "Could not copy link",
        "document_archive.download": "Download",
        "document_archive.download_failed": "Could not download the file",
        "document_archive.delete": "Delete",
        "document_archive.delete_title": "Delete file?",
        "document_archive.delete_confirm": "Delete «{{name}}»? This cannot be undone.",
        "document_archive.deleted": "File deleted",
        "document_archive.delete_failed": "Could not delete the file",
        "document_archive.deleting": "Deleting…",
        "document_archive.share_unavailable": "Sharing is not implemented yet",
        "document_archive.edit_title": "Edit title",
        "document_archive.title_required": "Title is required",
        "document_archive.title_saved": "Title saved",
        "document_archive.title_save_failed": "Could not save the title",
        "document_archive.save": "Save",
        "document_archive.saving": "Saving…",
        "document_archive.cancel": "Cancel",
        "document_archive.folder_title": "Name",
        "document_archive.folder_title_placeholder": "Folder name",
        "document_archive.folder_title_required": "Name is required",
        "document_archive.folder_description": "Description",
        "document_archive.folder_description_placeholder": "Optional",
        "document_archive.folder_create_root": "Creates a folder in the project archive",
        "document_archive.folder_create_subfolder": "Creates a subfolder in the current folder",
        "document_archive.create_folder": "Create folder",
        "document_archive.creating": "Creating…",
        "document_archive.folder_create_error": "Could not create the folder",
        "document_archive.folder_menu": "Folder actions",
        "document_archive.rename_folder": "Rename",
        "document_archive.folder_access": "Access",
        "document_archive.folder_renamed": "Folder name saved",
        "document_archive.folder_rename_failed": "Could not rename the folder",
        "document_archive.delete_folder": "Delete folder",
        "document_archive.delete_folder_title": "Delete folder?",
        "document_archive.delete_folder_confirm": "Delete “{{name}}”? Files move to {{destination}} and are not deleted.",
        "document_archive.delete_folder_confirm_children": "Delete “{{name}}” and {{count}} subfolders? Files move to {{destination}} and are not deleted.",
        "document_archive.folder_delete_root": "the project root",
        "document_archive.folder_deleted": "Folder deleted",
        "document_archive.folder_delete_failed": "Could not delete the folder",
        "document_archive.access": "Access",
        "document_archive.access_project": "Everyone with project access",
        "document_archive.access_project_hint": "Anyone who can open the project can see this folder and its files.",
        "document_archive.access_admins": "Project admin and system admin only",
        "document_archive.access_admins_hint": "Only the project admin and system admin can see this folder and its files.",
        "document_archive.access_inherited": "Subfolders inherit access from a locked parent folder.",
        "document_archive.access_saved": "Folder access saved",
        "document_archive.access_save_failed": "Could not save folder access",
        "document_archive.page_kicker": "Archive",
        "document_archive.page_title": "Archive",
        "document_archive.back_to_project": "Back to project",
        "document_archive.no_access": "You do not have access to this archive",
        "document_archive.not_found": "Could not load the project",
        "document_archive.upload_dialog_title": "Upload",
        "document_archive.upload_add_more": "Add more files",
        "document_archive.upload_remove": "Remove",
        "document_archive.upload_title_placeholder": "Title (optional)",
        "document_archive.upload_overall": "Total",
        "document_archive.upload_status": "Uploading {{current}} of {{total}}",
        "document_archive.upload_done": "Upload complete",
        "document_archive.upload_start": "Upload",
        "document_archive.upload_uploading": "Uploading…",
        "document_archive.upload_close": "Close",
        "project.edit": "Edit Project",
        "project.switcher.search": "Search by name, number or customer",
        "project.switcher.recent": "Recent",
        "project.switcher.all": "All projects",
        "project.switcher.projects": "Projects",
        "project.switcher.results": "{{count}} results",
        "project.switcher.empty": "No projects match “{{query}}”",
        "project.switcher.current": "Current",
        "project.switcher.navigate": "↑↓ navigate",
        "project.switcher.open_key": "↵ open",
        "project.switcher.all_projects": "All projects →",
        "project.switcher.switch": "Switch project",
        "project.switcher.loading": "Loading projects…",
        "project.create_guide.title": "Create project",
        "project.create_guide.subtitle": "Follow the steps to set up a new project with the most important details.",
        "project.create_guide.badge": "Guided project creation",
        "project.create_guide.progress.step_label": "Step",
        "project.create_guide.summary.step_label": "Summary",
        "project.create_guide.step.basics": "Basics",
        "project.create_guide.step.customer": "Customer & org",
        "project.create_guide.step.schedule": "Schedule & team",
        "project.create_guide.step.description": "Description",
        "project.create_guide.basics.title": "What is the project called?",
        "project.create_guide.basics.help": "Give the project a clear name. Project number can be assigned automatically.",
        "project.create_guide.customer.title": "Who is the project for?",
        "project.create_guide.customer.help": "Link customer, department and delivery address when relevant.",
        "project.create_guide.schedule.title": "When and who leads the project?",
        "project.create_guide.schedule.help": "Choose a project manager and set the start date. End date is optional.",
        "project.create_guide.description.title": "Add a short description",
        "project.create_guide.description.help": "Optional context for the team. You can always edit this later.",
        "project.create_guide.field.name": "Project name",
        "project.create_guide.field.use_next_number": "Use next available project number",
        "project.create_guide.field.project_number": "Project number",
        "project.create_guide.field.customer": "Customer",
        "project.create_guide.field.department": "Department",
        "project.create_guide.field.delivery_address": "Delivery address",
        "project.create_guide.field.project_manager": "Project manager",
        "project.create_guide.field.start_date": "Start date",
        "project.create_guide.field.end_date": "End date",
        "project.create_guide.field.description": "Description",
        "project.create_guide.validation.name_required": "Project name is required",
        "project.create_guide.validation.start_date_required": "Start date is required",
        "project.create_guide.validation.project_manager_required": "Project manager is required",
        "project.create_guide.validation.end_before_start": "End date must be on or after start date",
        "project.create_guide.summary.title": "Review and create",
        "project.create_guide.summary.help": "Check the details below before creating the project.",
        "project.create_guide.summary.auto_number": "Assigned automatically",
        "project.create_guide.summary.not_set": "Not set",
        "project.create_guide.summary.selected": "Selected",
        "project.create_guide.cancel": "Cancel",
        "project.create_guide.back": "Back",
        "project.create_guide.next": "Next",
        "project.create_guide.review": "Review",
        "project.create_guide.create": "Create project",
        "project.create_guide.creating": "Creating…",
        "project.create_guide.success": "Project created",
        "project.create_guide.error": "Could not create project",
        "project.overview.export_pdf": "Export PDF",
        "project.overview.export_pdf_loading": "Exporting…",
        "project.overview.export_pdf_success": "PDF exported",
        "project.overview.export_pdf_error": "Could not export PDF",
        "project.overview.details_subtitle": "Facts and specifications",
        "project.overview.fact.start": "Start",
        "project.overview.fact.end": "End",
        "project.overview.fact.department": "Department",
        "project.overview.fact.category": "Category",
        "project.overview.fact.description": "Description",
        "project.overview.fact.number": "Project no.",
        "project.overview.fact.customer": "Customer",
        "project.overview.fact.manager": "Project manager",
        "project.overview.facts.title": "Project details",
        "project.overview.start_missing": "Start date missing",
        "project.overview.end_unset": "Not set",
        "project.overview.hours_progress": "Hours progress",
        "project.overview.hours_unit": "hours",
        "project.overview.no_budget_hours": "No budget hours set",
        "project.overview.stats.hours": "Hours",
        "project.overview.stats.view_time_overview": "View hours overview",
        "project.overview.stats.load_error": "Could not load the project figures.",
        "project.overview.stats.deviations": "Deviations",
        "project.overview.stats.open_deviations": "Open deviations",
        "project.overview.stats.work_orders": "Work orders",
        "project.overview.stats.checklists": "Checklists",
        "project.overview.stats.note.critical": "{{count}} critical",
        "project.overview.stats.note.ongoing": "{{count}} ongoing",
        "project.overview.stats.note.checklist_pct": "{{pct}}% completed",
        "project.overview.stats.note.budget_pct": "{{pct}}% of budget",
        "project.overview.stats.note.no_budget": "No budget",
        "project.overview.stats.note.none": "None recorded",
        "project.overview.activity.title": "Latest activity",
        "project.overview.activity.see_all": "See all →",
        "project.overview.activity.empty": "No activity yet",
        "project.overview.activity.fallback": "Update",
        "project.overview.address.title": "Delivery address",
        "project.overview.address.subtitle": "Project delivery location",
        "project.overview.address.view_map": "Open in maps",
        "project.overview.address.map": "Map",
        "project.overview.address.edit": "Edit address",
        "project.overview.address.address": "Address",
        "project.overview.address.city": "City",
        "project.overview.address.postal": "Postal code",
        "project.overview.address.country": "Country",
        "project.overview.address.contact": "Contact person",
        "project.overview.address.missing": "Address not set",
        "project.overview.address.missing_city": "City not set",
        "project.overview.team.title": "Team",
        "project.overview.team.manage": "Manage",
        "project.overview.team.project_manager": "Project manager",
        "project.overview.team.empty": "No participants yet",
        "project.palette.trigger": "Search",
        "project.palette.placeholder": "Search this project or run an action…",
        "project.palette.actions_heading": "Actions",
        "project.palette.searching": "Searching…",
        "project.palette.no_results": "No results for “{{query}}”",
        "project.palette.module.document": "Documents",
        "project.palette.module.folder": "Folders",
        "project.palette.module.deviation": "Deviations",
        "project.palette.module.checklist": "Checklists",
        "project.palette.module.report": "Reports",
        "project.palette.module.work_order": "Work orders",
        "project.palette.module.action": "Actions",
        "project.fab.open": "New",
        "project.fab.close": "Close",
        "project.item_list": "Item List",
        "project.item_list.create": "Create item list",
        "project.item_list.edit": "Edit item list",
        "project.item_list.delete": "Delete item list",
        "project.item_list.type": "Item list type",
        "project.item_list.type.consumption": "Consumption",
        "project.item_list.type.return": "Return",
        "project.item_list.warehouse": "Warehouse",
        "project.item_list.select_warehouse": "Select warehouse",
        "project.item_list.save": "Save item list",
        "project.item_list.deliver": "Deliver item list",

        "project.billing_plan": "Billing plan",
        "project.billing_plan.overview": "Delivered / executed overview",
        "project.billing_plan.create_invoice": "Create A‑account invoice line",
        "project.billing_plan.final_invoice": "Final invoice",
        "project.billing_plan.progress": "Progress",
        "project.billing_plan.completed": "Executed",
        "project.billing_plan.remaining": "Retention",
        "project.billing_plan.contract_sum": "Contract sum",
        "project.billing_plan.completed_amount": "Executed amount",
        "project.billing_plan.billed_amount": "Invoiced amount",
        "project.billing_plan.remaining_amount": "Retention held",
        "project.billing_plan.completed_sum": "Executed amount",
        "project.billing_plan.billable_sum": "Billable amount",
        "project.billing_plan.items.title": "Billing plan",
        "project.billing_plan.items.empty": "No billing plan rows yet",
        "project.billing_plan.type": "Type",
        "project.billing_plan.planned_date": "Planned date",
        "project.billing_plan.amount": "Amount",
        "project.billing_plan.status.title": "Status",
        "project.billing_plan.status.planned": "Planned",
        "project.billing_plan.status.billed": "Invoiced",
        "project.billing_plan.status.cancelled": "Cancelled",
        "project.billing_plan.actions": "Actions",
        "project.billing_plan.edit": "Edit",
        "project.billing_plan.delete": "Delete",
        "project.billing_plan.edit_item": "Edit billing row",
        "project.billing_plan.no_description": "No description",
        "project.billing_plan.deleting": "Deleting billing row…",
        "project.billing_plan.updating": "Updating billing row…",
        "project.billing_plan.creating": "Creating billing row…",
        "project.billing_plan.delete_confirmation": "Delete this billing plan row?",
        "project.billing_plan.invoice_selected": "Invoice selected",
        "project.billing_plan.invoicing": "Invoicing…",
        "project.billing_plan.a_account": "A‑account",
        "project.billing_plan.invoice_number": "Invoice no.",
        "project.billing_plan.settings": "Settings",
        "project.billing_plan.remaining_settings_title": "Retention settings",
        "project.billing_plan.amount_to_invoice": "Amount to invoice",
        "project.billing_plan.amount_to_invoice_hint": "Suggestion: executed for this billing row or period minus retention when enabled on the project. Same as executed when retention is off. Earlier invoices do not affect the amount. Updated automatically.",
        "project.billing_plan.retention_helper_disabled": "Retention is 0 when project retention settings are disabled.",
        "project.billing_plan.retention_helper_enabled": "Retention is {{pct}}% of {{base}}.",
        "project.billing_plan.retention_base_contract": "contract sum",
        "project.billing_plan.retention_base_completed": "executed amount",
        "project.billing_plan.completed_helper": "Executed for this period or billing row (draft). Contract-line total shown for reference only: {{suggested}}.",
        "project.billing_plan.footer_suggested_line": "Suggested amount to invoice: {{amount}}. With retention enabled: {{pct}}% of {{base}}. Earlier invoices do not reduce the suggestion.",
        "project.billing_plan.summary_title": "Amount summary",
        "project.billing_plan.summary_contract_lines_completed": "Contract lines total (reference only)",
        "project.billing_plan.summary_billed_to_date": "Invoiced via plan to date",
        "project.billing_plan.summary_retention_for_period": "Retention (preview for entered executed amount)",
        "project.billing_plan.invoice_edit_hint": "Change amounts in the billing plan before invoicing.",
        "project.billing_plan.invoice_type_label": "Invoicing type",
        "project.billing_plan.invoice_auto": "Automatic (create invoice and order for sync)",
        "project.billing_plan.invoice_manual": "Manual / external invoicing",
        "project.billing_plan.external_invoice_checkbox": "External invoice (issued outside Promang)",
        "project.billing_plan.link_invoice": "Link existing invoice (optional)",
        "project.billing_plan.link_invoice_none": "No link",
        "project.billing_plan.invoice_a_account_title": "Invoice A‑account",
        "project.billing_plan.invoice_confirm": "Invoice",
        "project.billing_plan.invoice_loading": "Invoicing…",
        "project.billing_plan.invoice_created": "Invoice created",
        "project.billing_plan.invoice_created_tripletex_ok": "Invoice created and order confirmed in Tripletex.",
        "project.billing_plan.tripletex_queued_hint": "Tripletex session unavailable — the order was queued for sync (check integration and background jobs if something is missing).",
        "project.billing_plan.invoice_failed": "Could not create invoice",

        "project.summary": "Project summary",
        "project.summary.overview": "Accounting overview",
        "project.summary.labor_costs": "Labour cost",
        "project.summary.material_costs": "Materials / consumption",
        "project.summary.material_costs_hint": "Not only the item list purchase sum — see info for sources.",
        "project.summary.material_costs_info_aria": "How material consumption is calculated",
        "project.summary.invoiced_amount": "Invoiced amount",
        "project.summary.supplier_invoices": "Supplier invoices",
        "project.summary.total_costs": "Total costs",
        "project.summary.profit": "Operating result",
        "project.summary.margin": "Margin",
        "project.summary.provisional_result": "Provisional result",
        "project.summary.profit_vs_contract": "Result vs contract",
        "project.summary.profit_vs_invoiced": "Result vs invoiced",
        "project.summary.margin_vs_contract": "Margin vs contract",
        "project.summary.margin_vs_invoiced": "Margin vs invoiced",
        "project.summary.not_invoiced": "Not invoiced",
        "project.summary.invoiced_ex_vat": "Sum of customer invoices, excl. VAT",
        "project.summary.margin_on_contract_hint": "Calculated from contract sum",
        "project.summary.module_breakdown": "Module breakdown",
        "project.summary.module_breakdown_description": "Modules affecting this project summary",
        "project.summary.module_type.report": "Report",
        "project.summary.module_type.work_order": "Work order",
        "project.summary.module_type.item_list": "Item list",
        "project.summary.invoiced": "Invoiced",
        "project.summary.has_order": "Has order",
        "project.summary.costs": "Costs",
        "project.summary.income": "Income",
        "project.summary.hours": "Hours",
        "project.summary.hours_short": "h",
        "project.summary.material": "Materials",
        "project.summary.agreed_price": "Agreed price",
        "project.summary.price_lines": "price lines",
        "project.summary.expected_module_income": "Expected income from modules",
        "project.summary.expected_module_costs": "Expected module costs",
        "project.summary.not_included_in_total": "not included in total",
        "project.summary.invoiced_ex_vat_basis": "invoiced (ex. VAT)",
        "project.summary.margin_on_invoiced_hint": "Based on invoiced ex. VAT",
        "project.summary.of": "of",
        "project.summary.invoicing_rate": "Invoicing rate",
        "project.summary.cost_rate": "Cost ratio",
        "project.summary.invoicing_rate_no_contract": "Not defined without contract sum",
        "project.summary.cost_rate_on_invoiced_hint": "vs invoiced ex. VAT",
        "project.summary.contract_sum": "Contract sum",
        "project.summary.remaining": "Remaining",
        "project.summary.cost_breakdown": "Cost breakdown",
        "project.summary.no_costs": "No costs recorded yet",
        "project.summary.last_updated": "Last updated",
        "project.summary.export_pdf": "Export PDF",
        "project.summary.error.title": "Could not load summary",
        "project.summary.no_data.title": "No data",
        "project.summary.no_data.description": "Summary will appear when data exists",

        "project.invoices": "Invoices",
        "project.invoices.overview": "Invoice overview",
        "project.invoices.create": "Create invoice",
        "project.invoices.status": "Status",
        "project.invoices.status.paid": "Paid",
        "project.invoices.status.pending": "Outstanding",
        "project.invoices.status.overdue": "Overdue",
        "project.invoices.amount": "Amount",
        "project.invoices.due_date": "Due date",
        "project.invoices.totals.invoiced_ex_vat": "Total invoiced (ex. VAT)",
        "project.invoices.pagination.showing": "Showing {{from}}–{{to}} of {{total}}",
        "project.invoices.pagination.load_more": "Load more invoices",
        "project.invoices.pagination.loading_more": "Loading…",
        "project.invoices.pagination.loaded_of_total": "{{loaded}} of {{total}} invoices shown",
        "project.invoices.pagination.all_loaded": "All {{total}} invoices loaded",
        "project.invoices.create_disabled_hint": "Creating invoices from here is not available yet",
        "project.invoices.pagination.prev": "Previous",
        "project.invoices.pagination.next": "Next",
        "project.invoices.error.title": "Could not load",
        "project.invoices.no_invoices.title": "No invoices",
        "project.invoices.no_invoices.description": "No invoices for this project yet",

        "project.item_list.approve": "Approve item list",
        "project.item_list.reject": "Reject item list",
        "project.item_list.submit_for_approval": "Submit for approval",
        "project.item_list.status": "Status",
        "project.item_list.status.label": "Status",
        "project.item_list.status.draft": "Draft",
        "project.item_list.status.pending_approval": "Pending approval",
        "project.item_list.status.delivered": "Delivered",
        "project.item_list.status.approved": "Approved",
        "project.item_list.status.rejected": "Rejected",
        "project.item_list.status.invoiced_manually": "Invoiced (manual)",
        "project.item_list.mark_invoiced_manually": "Mark as manually invoiced",
        "project.item_list.print": "Print",
        "project.item_list.total_purchase": "Total purchase",
        "project.item_list.merge.select": "Select",
        "project.item_list.merge.select_list": "Select list {{title}}",
        "project.item_list.merge.select_all_eligible": "Select all",
        "project.item_list.merge.deselect_all": "Clear selection",
        "project.item_list.merge.create_order": "Create order from lists",
        "project.item_list.merge.dialog_title": "Create order from item lists",
        "project.item_list.merge.dialog_hint": "{{count}} list(s) selected. Choose how lines are built and optional price adjustments.",
        "project.item_list.merge.mode_label": "Line structure",
        "project.item_list.merge.mode.grouped_by_list": "One group per list (list name = group), all product lines",
        "project.item_list.merge.mode.one_line_per_list": "One aggregated line per list (weighted unit prices)",
        "project.item_list.merge.mode.flat_by_product": "Single list: one line per product (quantities summed)",
        "project.item_list.merge.purchase_markup": "Purchase + %",
        "project.item_list.merge.sales_discount": "Sales discount %",
        "project.item_list.merge.sales_surcharge": "Sales surcharge %",
        "project.item_list.merge.mark_invoiced_after": "Mark selected lists as manually invoiced after creating the order",
        "project.item_list.merge.submit": "Create order",
        "project.item_list.merge.submitting": "Creating order…",
        "project.item_list.merge.error_generic": "Could not create order. Check permissions and that lists contain items.",
        "project.item_list.add_product": "Add product",
        "project.item_list.products": "Items",
        "project.item_list.product": "Product",
        "project.item_list.quantity": "Quantity",
        "project.item_list.price": "Price",
        "project.item_list.total": "Total",
        "project.item_list.actions": "Actions",
        "project.item_list.remove": "Remove",
        "project.item_list.no_items": "No items",
        "project.item_list.no_items_description": "This item list has no items yet.",
        "project.item_list.scan_qr": "Scan QR code",
        "project.item_list.manual_search": "Manual search",
        "project.item_list.scan_or_enter": "Scan QR code or enter product number",
        "project.item_list.selected_product": "Selected product",
        "project.item_list.add": "Add",
        "project.item_list.back": "Back",
        "project.item_list.cancel": "Cancel",
        "project.item_list.created_by": "Created by",
        "project.website_settings": "Website Settings",
        "project.show_on_website": "Show project on website",
        "project.show_on_website_description": "Enable to show the project publicly on the website",
        "project.public_title": "Visible Title",
        "project.public_title_placeholder": "Title shown on the website",
        "project.public_description": "Visible Description",
        "project.public_description_placeholder": "Description shown on the website",
        "project.public_contract_sum": "Public Contract Sum",
        "project.public_contract_sum_placeholder": "E.g. 2 500 000 NOK",
        "project.public_contract_sum_description": "Contract sum shown publicly on the website",
        "project.public_main_image": "Public Main Image",
        "project.public_main_image_description": "Image shown on the website",
        "project.select_image": "Select Image",
        "project.change_image": "Change Image",
        "project.search_images": "Search for images...",
        "project.searching": "Searching...",
        "project.search": "Search",
        "project.no_images_found": "No images found",
        "project.website_content_lines": "Content (statistics/info)",
        "project.content_line_title": "Title",
        "project.content_line_value": "Value",
        "project.line_type_info": "Info",
        "project.line_type_statistics": "Statistics",
        "project.add_line": "Add",
        "project.update_line": "Update",
        "project.cancel": "Cancel",
        "project.no_content_lines": "No content lines added",
        "project.saving": "Saving...",
        "project.save_settings": "Save Settings",
        "project.item_list.approved_by": "Approved by",
        "project.item_list.approval_comment": "Approval comment",
        "project.item_list.total_items": "Total items",
        "project.item_list.total_quantity": "Total quantity",
        "project.item_list.total_value": "Total value",
        "project.item_list.summary_title": "Item lists — summary",
        "project.item_list.summary_total_quantity": "Total quantity (net)",
        "project.item_list.summary_total_purchase": "Total purchase",
        "project.item_list.summary_total_sales": "Total sales",
        "project.item_list.view_items_summary": "View items summary",
        "project.item_list.items_summary_page_title": "Project item lists — summary",
        "project.item_list.items_summary_subtitle": "Quantities and prices across all lists on this project",
        "project.item_list.items_summary_intro":
          "Lines are combined by product item number (products without a number are grouped per product). Return lists reduce net quantity and amounts.",
        "project.item_list.items_summary_table_item_number": "Item no.",
        "project.time_overview.tab": "Hours overview",
        "project.time_overview.list_title": "Hours overview — {{title}}",
        "project.time_overview.loading": "Loading hours overview…",
        "project.time_overview.load_error": "Could not load hours for this period.",
        "project.time_overview.ui.search_filter": "Search {{label}}",
        "project.time_overview.ui.no_matches": "No matches",
        "project.time_overview.ui.reset": "Reset",
        "project.time_overview.ui.search_chip": "Search: {{query}}",
        "project.time_overview.ui.status_pending": "Awaiting approval",
        "project.time_overview.ui.status_approved": "Approved",
        "project.time_overview.ui.status_rejected": "Rejected",
        "project.time_overview.ui.status_processed": "Processed",
        "project.time_overview.ui.supplier": "Subcontractor",
        "project.time_overview.ui.employees": "Employees",
        "project.time_overview.ui.project": "Project",
        "project.time_overview.ui.department": "Department",
        "project.time_overview.ui.without_project": "Without project",
        "project.time_overview.ui.without_department": "Without department",
        "project.time_overview.ui.estimated_sales": "Estimated sales",
        "project.time_overview.ui.estimated_cost": "Estimated cost",
        "project.time_overview.ui.unknown_user": "Unknown user",
        "project.time_overview.ui.show_calculation": "Show calculation",
        "project.time_overview.ui.hide_calculation": "Hide calculation",
        "project.time_overview.ui.total_hours": "Total hours",
        "project.time_overview.ui.missing_hour_cost_count": "Missing hourly cost",
        "project.time_overview.ui.detailed_per_employee": "Detailed calculation per employee",
        "project.time_overview.ui.estimated_cost_upper": "ESTIMATED COST",
        "project.time_overview.ui.estimated_sales_upper": "ESTIMATED SALES",
        "project.time_overview.ui.estimated_from_rates": "Hour cost × hours in selection",
        "project.time_overview.ui.estimated_from_sales_rates": "Hourly rate × hours in selection",
        "hours.company_overview": "Hours overview",
        "hours.company_overview.subtitle":
          "All hours in the selected month. Filter by project, activity, employees and department. Estimated cost and sales.",
        "project.time_overview.ui.with_order": "With order",
        "project.time_overview.ui.without_order": "Without order",
        "project.time_overview.ui.with_invoice": "With supplier invoice",
        "project.time_overview.ui.without_full_invoice": "Without full invoice coverage",
        "project.time_overview.ui.eyebrow": "// PROJECT · TIME REVIEW",
        "project.time_overview.ui.description": "Approve hours, link them to orders and supplier invoices, and review project usage.",
        "project.time_overview.ui.switch_project": "Switch project",
        "project.time_overview.ui.export_csv": "Export CSV",
        "project.time_overview.ui.export_pdf": "Export PDF",
        "project.time_overview.ui.export_pdf_busy": "Creating PDF…",
        "project.time_overview.ui.pdf_selection_changed": "The hours list has changed since it was loaded. Refresh the list and try again.",
        "project.time_overview.ui.pdf_refresh_list": "Refresh list",
        "project.time_overview.ui.pdf_too_many": "The selection is too large for PDF (max {{max}} entries). Choose a smaller selection.",
        "project.time_overview.ui.pdf_invalid": "The server did not return a valid PDF. Please try again.",
        "project.time_overview.ui.pdf_forbidden": "You do not have access to export the hours in this project.",
        "project.time_overview.ui.pdf_failed": "Could not create the PDF. Please try again.",
        "project.time_overview.ui.pdf_empty": "No hours to export in the current selection.",
        "project.time_overview.ui.pdf_filename_prefix": "hours",
        "project.time_overview.ui.new_entry": "New entry",
        "project.time_overview.ui.time_budget": "TIME BUDGET",
        "project.time_overview.ui.budget_used": "Time budget used",
        "project.time_overview.ui.percent_used": "{{percent}}% used",
        "project.time_overview.ui.budget_remaining": "BUDGET REMAINING",
        "project.time_overview.ui.over_budget": "{{hours}} h over budget",
        "project.time_overview.ui.available_budget": "Available budget hours",
        "project.time_overview.ui.registered_selected": "RECORDED IN SELECTION",
        "project.time_overview.ui.entry_people_count": "{{entries}} entries · {{people}} people",
        "project.time_overview.ui.team": "TEAM",
        "project.time_overview.ui.active_members": "active project members",
        "project.time_overview.ui.awaiting_approval": "AWAITING APPROVAL",
        "project.time_overview.ui.entries_waiting": "{{count}} entries waiting",
        "project.time_overview.ui.without_order_upper": "WITHOUT ORDER",
        "project.time_overview.ui.entries_count": "{{count}} entries",
        "project.time_overview.ui.supplier_upper": "SUBCONTRACTOR",
        "project.time_overview.ui.hours_without_full_invoice": "{{hours}} h without full invoice coverage",
        "project.time_overview.ui.hours_per_order": "HOURS PER ORDER · SELECTED PERIOD",
        "project.time_overview.ui.select_order_hint": "Select an order to filter entries",
        "project.time_overview.ui.in_period": "in period",
        "project.time_overview.ui.hours_waiting": "{{hours}} h awaiting approval",
        "project.time_overview.ui.order_budget_used": "Budget used for {{order}}",
        "project.time_overview.ui.order_budget_total": "{{used}} of {{budget}} h total · {{percent}}%",
        "project.time_overview.ui.search_hours": "Search hours",
        "project.time_overview.ui.search_placeholder": "Search comments, orders, employees",
        "project.time_overview.ui.filters": "Filters",
        "project.time_overview.ui.activity": "Activity",
        "project.time_overview.ui.order": "Order",
        "project.time_overview.ui.employee": "Employee",
        "project.time_overview.ui.status": "Status",
        "project.time_overview.ui.type": "Type",
        "project.time_overview.ui.link": "Link",
        "project.time_overview.ui.remove_filter": "Remove filter: {{label}}",
        "project.time_overview.ui.reset_all": "Reset all · {{filtered}} of {{total}} entries",
        "project.time_overview.ui.unknown_employee": "Unknown employee",
        "project.time_overview.ui.without_activity": "No activity",
        "project.time_overview.ui.without_date": "No date",
        "project.time_overview.ui.not_linked": "Not linked",
        "project.time_overview.ui.select_group": "Select group {{title}}",
        "project.time_overview.ui.show_more": "Show {{count}} more entries",
        "project.time_overview.ui.time_view": "Time view",
        "project.time_overview.ui.entries": "Entries",
        "project.time_overview.ui.matrix": "Matrix",
        "project.time_overview.ui.supplier_invoice": "Supplier invoice",
        "project.time_overview.ui.groups": "GROUPS",
        "project.time_overview.ui.date": "Date",
        "project.time_overview.ui.none": "None",
        "project.time_overview.ui.expand_all": "Expand all",
        "project.time_overview.ui.collapse_all": "Collapse all",
        "project.time_overview.ui.normal_rows": "Normal rows",
        "project.time_overview.ui.compact_rows": "Compact rows",
        "project.time_overview.ui.selected_hours": "{{count}} selected · {{hours}} h",
        "project.time_overview.ui.select_for_bulk": "Select entries for bulk actions",
        "project.time_overview.ui.approve_selected": "Approve selected ({{count}})",
        "project.time_overview.ui.reject_selected": "Reject selected ({{count}})",
        "project.time_overview.ui.select_all": "Select all entries in the result",
        "project.time_overview.ui.date_upper": "DATE",
        "project.time_overview.ui.employee_upper": "EMPLOYEE",
        "project.time_overview.ui.project_upper": "PROJECT",
        "project.time_overview.ui.activity_upper": "ACTIVITY",
        "project.time_overview.ui.order_upper": "ORDER",
        "project.time_overview.ui.invoice_upper": "SUPPLIER INVOICE",
        "project.time_overview.ui.hours_upper": "HOURS",
        "project.time_overview.ui.status_upper": "STATUS",
        "project.time_overview.ui.actions_upper": "ACTIONS",
        "project.time_overview.ui.sum_entries": "TOTAL · {{count}} ENTRIES",
        "project.time_overview.ui.rows": "ROWS",
        "project.time_overview.ui.hide_weekends": "Hide weekends",
        "project.time_overview.ui.show_weekends": "Show weekends",
        "project.time_overview.ui.weeks": "Weeks",
        "project.time_overview.ui.days": "Days",
        "project.time_overview.ui.matrix_hint": "{{period}} · click a cell to view entries",
        "project.time_overview.ui.sum": "TOTAL",
        "project.time_overview.ui.no_hours_period": "No hours in this period.",
        "project.time_overview.ui.invoice_intro": "The project's recorded supplier invoices and invoice coverage for hours in the selected period. Select hours in Entries to link or reconcile them.",
        "project.time_overview.ui.invoice_intro_readonly": "The project's recorded supplier invoices. Viewing hour links requires access to hour reconciliation.",
        "project.time_overview.ui.project_invoice_amount": "Project amount excl. VAT: {{amount}}",
        "project.time_overview.ui.no_linked_hours_period": "No linked hours in the selected period",
        "project.time_overview.ui.hour_links_restricted": "Viewing hour links requires access to hour reconciliation",
        "project.time_overview.ui.no_supplier_invoices": "No supplier invoices or subcontractor hours in this selection.",
        "project.time_overview.ui.no_supplier_invoices_readonly": "No supplier invoices recorded for this project.",
        "project.time_overview.ui.invoice_readonly_error": "Could not load the supplier invoices. Try again.",
        "project.time_overview.ui.costs_load_error": "Hourly costs could not be calculated. Try again in the time overview.",
        "project.time_overview.ui.loading_invoices": "Loading project supplier invoices…",
        "project.time_overview.ui.invoice_approved_local": "Approved in Promang",
        "project.time_overview.ui.invoice_rejected_local": "Rejected in Promang",
        "project.time_overview.ui.invoice_no_local_approval": "No internal approval recorded",
        "project.time_overview.ui.invoice_details_error": "Invoice details could not be loaded. Hour links and coverage are still shown.",
        "project.time_overview.ui.not_linked_invoice": "Not linked to a supplier invoice",
        "project.time_overview.ui.invoice_number": "Invoice {{number}}",
        "project.time_overview.ui.supplier_invoice_number": "Supplier invoice #{{number}}",
        "project.time_overview.ui.invoice_date": "Date {{date}}",
        "project.time_overview.ui.hours_logged": "{{hours}} h recorded",
        "project.time_overview.ui.hours_covered": "{{hours}} h covered by invoice",
        "project.time_overview.ui.hours_uncovered": "{{hours}} h without invoice coverage",
        "project.time_overview.ui.show_hours_by_employee_order": "Show hours by employee and order",
        "project.time_overview.ui.logged_upper": "RECORDED",
        "project.time_overview.ui.covered_upper": "COVERED",
        "project.time_overview.ui.view_invoice": "View invoice",
        "project.time_overview.ui.no_supplier_hours": "No subcontractor hours in this period.",
        "project.time_overview.ui.bulk_unknown_outcome": "The outcome of the last entry is unknown. Check its status before trying again.",
        "project.time_overview.ui.bulk_remaining": "{{done}} confirmed processed. {{remaining}} remain. {{error}}",
        "project.time_overview.ui.bulk_approved": "{{count}} entries approved.",
        "project.time_overview.ui.bulk_rejected": "{{count}} entries rejected.",
        "project.time_overview.ui.approve_selected_hours": "Approve selected hours",
        "project.time_overview.ui.reject_selected_hours": "Reject selected hours",
        "project.time_overview.ui.bulk_processing": "{{count}} entries will be processed. Approved or rejected entries are excluded.",
        "project.time_overview.ui.rejection_reason": "Reason for rejection",
        "project.time_overview.ui.close": "Close",
        "project.time_overview.ui.cancel": "Cancel",
        "project.time_overview.ui.processing": "Processing…",
        "project.time_overview.ui.reject_hours": "Reject hours",
        "project.time_overview.ui.approve_hours": "Approve hours",
        "project.time_overview.ui.week_number": "Week {{number}}",
        "project.time_overview.ui.filter_dialog": "{{label}} filter",
        "project.time_overview.ui.hour_unit": "h",
        "project.time_overview.ui.hours": "Hours",
        "project.time_overview.ui.description_column": "Description",
        "project.time_overview.empty": "No time entries found for this project",
        "project.time_overview.total_hours": "Total",
        "project.time_overview.summary_total": "Total",
        "project.time_overview.ungrouped": "Ungrouped",
        "project.time_overview.unapproved_secondary":
          "{{count}} not approved ({{hours}} h)",
        "project.time_registration.loading": "Loading time entries…",
        "project.time_registration.list_title": "Time registration — {{title}}",
        "project.time_registration.filter": "Filter",
        "project.time_registration.all_hours": "All hours",
        "project.time_registration.date_from": "From date",
        "project.time_registration.date_to": "To date",
        "project.time_registration.empty": "No time entries found for this project",
        "project.time_registration.registrations": "entries",
        "project.time_registration.no_activity": "No activity",
        "project.time_registration.approved_section": "Approved hours",
        "project.time_registration.approved_section_hint":
          "These hours are approved and included in totals and hourly costs above.",
        "project.time_registration.excluded_section":
          "Not approved or pending approval",
        "project.time_registration.excluded_section_hint":
          "Hours that are not approved are excluded from totals and hourly costs.",
        "project.time_registration.no_approved_in_range":
          "No approved hours in the selected period.",
        "project.time_registration.total_approved_hours": "Approved (in totals)",
        "project.time_registration.total_excluded_hours": "Excluded from totals",
        "project.time_registration.summary_approved_label": "Total approved hours (summed)",
        "project.time_registration.summary_excluded_note":
          "{{hours}} hours are not approved and are not included.",
        "project.time_registration.badge_approved": "Approved",
        "project.time_registration.badge_rejected": "Not approved",
        "project.time_registration.badge_pending": "Pending approval",
        "project.time_registration.approve": "Approve",
        "project.time_registration.reject": "Reject",
        "project.time_registration.open_hour": "Edit hour",
        "project.time_registration.process_dialog": "Process hour",
        "order.date": "Order Date",
        "use_customer_address": "Use Customer Address",
        "report": "Report",
        "send-sms.customer": "Send SMS to Customer",
        "cancel.reason": "Reason for canceling",
        "cancel.reason.required": "Reason for canceling is required",
        "cancel.reason.employee_sickness": "Employee is sick",
        "cancel.reason.customer_sickness": "Customer is sick",
        "cancel.reason.not_confirmed": "Ikke bekreftet av kunde",
        "cancel.reason.not_suited": "Date/ time is not suited for customer",
        "cancel.reason.assignment_cancelled": "Assignment cancelled",
        "cancel.reason.not_chosen": "Not chosen",
        "not_chosen": "Not chosen",
        "product.brands": "Brands",
        "product.brands.create": "Create a New Brand",
        "product.brand": "Product Brand",
        "image.change": "Change Image",
        "delete": "delete",
        "confirmation.sure": "Are you sure you want to",
        "library": "Library",
        "order_date": "Order Date",
        "order_number": "Order Number",
        "RESPONSIBLE": "Responsible",
        "RESPONSIBLE_EXECUTOR": "Responsible executor",
        "EXECUTOR": "Executor",
        "OBSERVER": "Observer",
        "note": "Note",
        "work_order": "Work Order",
        "contact": "Contact",
        "service_agreement": "Service Agreement",
        "order": "Order",
        "product": "Product",
        "folder": "Folder",
        "number.to": "To",
        "number.from": "From",
  
        // Control Panel / Sentralbord translations
        "control.panel": "Control Panel",
        "control.panel.overview":
          "Dashboard for system integrations and monitoring",
        "overview": "Overview",
        "queues": "Queues",
        "calls": "Call Log",
        "persons": "Persons",
        "settings": "Settings",
        "Bruker som håndterer egenmelding": "User who handles absences",
        "Velg administrator": "Select administrator",
        "Velg en administrator som skal håndtere egenmeldinger": "Select an administrator who will handle absences",
        "control.panel.overview.title": "Control Panel Overview",
        "control.panel.overview.description":
          "Dashboard for all integrations and systems",
        "current.phone.status": "Current Phone Status",
        "phone.status": "Phone Status",
        "phone.details.status": "Phone Status Details",
        "connected.to.phonero": "Connected to Phonero",
        "not.connected.to.phonero": "Not connected to Phonero system",
        "change.status": "Change Status",
        "not.connected.to.phone.system": "Not connected to phone system",
        "phonero.status": "Phonero Status",
        "active": "Active",
        "not.configured": "Not configured",
        "view.details": "View details",
        "system.status": "System Status",
        "all.systems.operational": "All systems operational",
        "last.updated": "Last updated",
        "quick.actions": "Quick Actions",
        "configure": "Configure",
        "phonero.queues": "Phonero Queues",
        "monitor.manage.queues": "Monitor and manage call queues",
        "call.log": "Call Log",
        "view.call.history": "View call history and details",
        "phonero.persons": "Phonero Persons",
        "manage.persons.phone": "Manage persons and their phone settings",
        "control.panel.settings": "Control Panel Settings",
        "configure.control.panel": "Configure control panel and integrations",
        "integrations": "Integrations",
        "manage.all.integrations": "Manage all system integrations",
        "phone.integration": "Phone integration",
  
        // Pagination
        "pagination.previous": "Previous",
        "pagination.next": "Next",
        "pagination.showing": "Showing {{current}} of {{total}}",
        "pagination.loadMore": "Load more",
        "histories.title": "History",
        "histories.subtitle": "Activity and changes",
        "histories.last_updated": "Last updated",
        "histories.last_edited": "Last edited",
        "histories.by_prefix": "by",
        "histories.no_data": "No data yet",
        "histories.filter_action": "Filter by action",
        "histories.filter_all": "All",
        "histories.empty_filter": "No events for this filter.",
        "histories.load_more": "Load more",
        "histories.loading_more": "Loading…",
        "histories.close": "Close",
        "histories.system_user": "System",
        "histories.unknown_user": "Unknown",
        "histories.sync_changes_heading": "Sync metadata",
        "histories.action.tripletex_retry": "queued another Tripletex sync for",
        "histories.tripletex_retry_pending": "A new sync attempt was queued. This does not confirm that synchronization has completed.",
        "histories.action.tripletex_sync_attempt": "attempted Tripletex sync on",
        "histories.action.tripletex_sync": "completed Tripletex sync for",
        "histories.action.tripletex_sync_skipped": "skipped Tripletex sync for",
        "histories.action.request_agreed_overtime": "requested agreed overtime on",
        "histories.action.confirm_agreed_overtime": "confirmed agreed overtime on",
        "histories.action.reject_agreed_overtime": "rejected agreed overtime on",
        "histories.action.lock": "locked",
        "histories.action.unlock": "unlocked",
        "histories.action.not_approved_notification": "sent email: not approved for",
        "histories.action.approved_notification": "sent email: approved for",
        "histories.action.send_email": "sent meeting minutes to",
        "histories.outbound.not_approved": "Sent email: not approved",
        "histories.outbound.approved": "Sent email: approved",
        "histories.deviation_scope.deviation": "Deviation timeline",
        "histories.deviation_scope.project": "Linked to project timeline",
        "histories.deviation_scope.customer": "Linked to customer timeline",
        "deviation.work_order.label": "Work order",
        "deviation.work_order.link_dialog_title": "Link work order",
        "deviation.work_order.section_title": "Linked work order",
        "deviation.work_order.link_submit": "Save",
        "deviation.work_order.link_open": "Link work order",
        "deviation.work_order.open_linked": "Open work order",
        "deviation.work_order.unlink": "Remove link",
        "deviation.work_order.change": "Change",
        "deviation.work_order.mode_existing": "Choose existing",
        "deviation.work_order.mode_create": "Create new",
        "deviation.work_order.existing_intro":
          "Only work orders without another deviation linked are listed. The work order already linked to this deviation stays available.",
        "deviation.work_order.create_intro":
          "Create a new work order — it will be linked to this deviation when you save.",
        "deviation.work_order.create_button": "Create work order",
        "deviation.work_order.linked_after_create":
          "Work order created and linked to the deviation",
        "deviation.work_order.link_failed_after_create":
          "The work order was created, but it could not be linked to the deviation. Open the deviation and link the work order manually.",
        "deviation.work_order.suggested_wo_title_full":
          "Deviation {{number}} · {{title}}",
        "deviation.work_order.suggested_wo_title_number_only":
          "Deviation {{number}}",
        "deviation.work_order.toast_saved": "Work order link updated",
        "deviation.toast.save_failed": "Could not save",
        "deviation.toast.load_failed": "Could not load the deviation",
        "deviation.toast.item_deleted": "The entry was deleted",
        "deviation.form.description_required": "Description is required",
        "deviation.form.consequence_required": "Consequence is required",
        "deviation.form.date": "Deviation date",
        "deviation.form.reference": "Reference",
        "deviation.form.severity": "Severity",
        "deviation.print.report": "Print report",
        "deviation.print.download": "Download",
        "deviation.status_updates_title": "Updates",
        "deviation.drawing_documents_description":
          "Photos and drawing snapshots linked to this deviation (same pin groups as in Drawings).",
        "deviation.perform_work.title": "Perform work",
        "deviation.perform_work.intro":
          "Create a work order linked to this deviation. Choose when the work should be done — minimal admin.",
        "deviation.perform_work.deviation_label": "Deviation",
        "deviation.perform_work.date_label": "Execution date",
        "deviation.perform_work.date_today": "Today",
        "deviation.perform_work.date_tomorrow": "Tomorrow",
        "deviation.perform_work.date_custom": "Selected date",
        "deviation.perform_work.date_pick": "Date",
        "deviation.perform_work.date_preview": "The work order will be set to {{date}}.",
        "deviation.perform_work.submit": "Perform work",
        "deviation.perform_work.submitting": "Creating…",
        "deviation.perform_work.success": "Work order created and linked to the deviation",
        "deviation.perform_work.error": "Could not create a work order from the deviation",
        "deviation.form.work_order_heading": "Work order from deviation",
        "deviation.form.work_order_mode_none": "Not linked",
        "deviation.form.work_order_mode_existing": "Choose existing",
        "deviation.form.work_order_mode_create": "Create new",
        "deviation.form.work_order_create_timing_intro": "How should the assignment start?",
        "deviation.form.work_order_perform_now": "Work is happening now",
        "deviation.form.work_order_plan_later": "Work will be planned",
        "deviation.form.work_order_perform_now_help":
          "A work order is created from this deviation's title and description, linked to the deviation, and a calendar event is created for the selected assignee starting now with a 2-hour duration.",
        "deviation.form.work_order_plan_later_help":
          "The deviation is saved. You continue to create a work order; it links to the deviation when you save the new order.",
        "deviation.form.executor_label": "Assignee executing the job",
        "deviation.form.executor_pick": "Choose assignee",
        "deviation.form.executor_hint": "The calendar event will be tied to this person.",
        "deviation.form.executor_dialog_help":
          "The person who should appear as the assignee when the job happens now.",
        "deviation.form.need_project_customer_for_work_order":
          "Select project and customer (on the deviation) before creating or deferring the work order from here.",
        "deviation.form.work_order_create_failed": "Could not create the work order.",
        "deviation.form.event_creation_failed":
          "The work order was created, but the event could not be created automatically — add one on the work order.",
        "deviation.form.work_order_and_event_saved":
          "Work order and event were created and linked to the deviation.",
        "deviation.form.saved": "Saved",
        "deviation.form.save_failed": "Something went wrong while saving.",
        "deviation.form.default_wo_title": "Deviation work order",
        "deviation.settings.hub_tab": "Deviation notifications",
        "deviation.settings.title": "Deviation notifications",
        "deviation.settings.hub_intro":
          "Choose whether deviation emails are sent immediately or collected into one daily digest. You can also control whether the sender receives a copy.",
        "deviation.settings.load_failed": "Could not load deviation notification settings",
        "deviation.settings.saved": "Settings saved",
        "deviation.settings.save_failed": "Could not save deviation notification settings",
        "deviation.settings.send_mode.title": "Delivery",
        "deviation.settings.send_mode.description": "Choose when deviation emails are sent to recipients.",
        "deviation.settings.send_mode.immediate": "Send immediately",
        "deviation.settings.send_mode.immediate_help": "Recipients get an email as soon as the deviation is sent.",
        "deviation.settings.send_mode.digest": "Daily digest",
        "deviation.settings.send_mode.digest_help":
          "Deviations are collected per recipient and sent once per day after the selected time (Europe/Oslo). New deviations after today’s send wait until the next day.",
        "deviation.settings.digest_hour": "Send digest at (Europe/Oslo)",
        "deviation.settings.copy_sender.title": "Copy to sender",
        "deviation.settings.copy_sender.description": "Choose whether the person sending the deviation also receives the email.",
        "deviation.settings.copy_sender.toggle": "Send a copy to the sender",
        "deviations.list.notified_none": "No notifications sent",
        "deviations.list.notified_compact_suffix": " (+{{count}})",

        // Cases list - new view
        "Use list view": "Use list view",
        "Use new view": "Use new view",
        "Switch to classic list view": "Switch to classic list view",
        "Switch to compact editable table view": "Switch to compact editable table view",
        "Status updated": "Status updated",
        "Could not update status": "Could not update status",
        "Due date updated": "Due date updated",
        "Could not update due date": "Could not update due date",
        "Priority updated": "Priority updated",
        "Could not update priority": "Could not update priority",
        "Last update": "Last update",
        "No updates yet": "No updates yet",
        "Add update": "Add update",
        "Write an update...": "Write an update...",
        "Gå til bruker": "Go to user",
        "Bruker": "User",
        "Ansatt": "Employee",
        "Update added": "Update added",
        "Could not add update": "Could not add update",
        "Title (optional)": "Title (optional)",
        "Add title": "Add title",
        "Link": "Link",
        "Add link": "Add link",
        "Link text (optional)": "Link text (optional)",
        "URL": "URL",
        "Send": "Send",
        "Open case": "Open case",
        "View full": "View full",
        "No title": "No title",
        "Case type": "Case type",
        "Labels": "Labels",
        "No labels defined": "No labels defined",
        "Remove": "Remove",
        "Statistics": "Statistics",
        "Cases by label": "Cases by label",
        "No labels with cases yet": "No labels with cases yet",
        "Label administration": "Label administration",
        "All modules": "All modules",
        "Cases": "Cases",
        "Projects": "Projects",
        "Customers": "Customers",
        "Customer List": "Customer List",
        "Tasks": "Tasks",
        "Add label": "Add label",
        "Scope module": "Scope module",
        "Sort order": "Sort order",
        "Name is required": "Name is required",
        "Are you sure you want to delete this label?": "Are you sure you want to delete this label?",
        "No employees found": "No employees found",
        "Prioritering": "Priority",
  
        // Phonero presence statuses
        "presence.available": "Available",
        "presence.busy": "Busy",
        "presence.away": "Away",
        "presence.unknown": "Unknown",
        "presence.connected": "Connected to Phonero",
        "presence.not.available": "Presence status not available",
        "presence.failed.to.load": "Failed to load presence data",
        "presence.updated.successfully": "Presence updated successfully",
        "presence.failed.to.update": "Failed to update presence",
        "presence.cannot.update":
          "Cannot update presence - user not found in Phonero",
  
        // Phonero presence descriptions
        "Free": "Free",
        "Meeting": "Meeting",
        "Lunch": "Lunch",
        "Vacation": "Vacation",
        "Busy": "Busy",
        "Way": "Way",
        "Gone for the day": "Gone for the day",
  
        // Live Calls translations
        "Live Calls (Not synched yet)": "Live Calls (Not synched yet)",
        "Latest calls from Phonero API (not yet synced to database)":
          "Latest calls from Phonero API (not yet synced to database)",
        "Refreshing...": "Refreshing...",
        "Refresh": "Refresh",
        "Loading live calls...": "Loading live calls...",
        "No unsynced live calls found": "No unsynced live calls found",
  
        // Manual Call translations
        "Add Manual Call": "Add Manual Call",
        "From Number (Customer)": "From Number (Customer)",
        "Date & Time": "Date & Time",
        "Duration (seconds)": "Duration (seconds)",
        "Note": "Note",
        "Cancel": "Cancel",
        "Create Call": "Create Call",
        "Creating...": "Creating...",
        "Manual call created successfully": "Manual call created successfully",
        "Manual call added successfully": "Manual call added successfully",
        "Manual": "Manual",
        "Select Date": "Select Date",
        "Choose date": "Choose date",
        "Report": "Report",
        "Order": "Order",
        "Work Order": "Work Order",
        "Work Orders": "Work Orders",
        "Work Order List": "Work Order List",
        "New Work Order": "New Work Order",
        "Search work orders...": "Search work orders...",
        "Filter Work Orders by Status": "Filter Work Orders by Status",
        "Invoiced": "Invoiced",
        "Ready to be invoiced": "Ready for invoicing",
        "Finished": "Finished",
        "Order Date": "Order Date",
        "Due Date": "Due Date",
        "Event Period": "Event Period",
        "Responsible": "Responsible",
        "Executor": "Executor",
        "Work Order #": "Work Order #",
        "work_orders.pagination_summary":
          "Page {{page}} of {{totalPages}} ({{total}} total)",
        "work_orders.delete_confirm":
          "This permanently deletes the work order. Hours linked to it will be unlinked. This cannot be undone.",
        "work_orders.delete_success": "Work order deleted",
        "work_orders.delete_failed": "Could not delete the work order",
        "work_orders.back_to_view": "Back to view",
        "work_orders.details_section_title": "Details",
        "work_orders.edit_details": "Edit",
        "work_order.redesign.status.draft": "Draft",
        "work_order.redesign.status.scheduled": "Scheduled",
        "work_order.redesign.status.progress": "In progress",
        "work_order.redesign.status.done": "Completed",
        "work_order.redesign.urgent": "Urgent",
        "work_order.redesign.print": "Print",
        "work_order.redesign.finish": "Complete",
        "work_order.redesign.field_log": "Field log",
        "work_order.redesign.field_log_sub": "Open a dialog to register",
        "work_order.redesign.hours": "Hours",
        "work_order.redesign.materials": "Materials",
        "work_order.redesign.material_lines": "lines",
        "work_order.redesign.notes": "Notes & photos",
        "work_order.redesign.notes_meta": "Work notes and documentation",
        "work_order.redesign.open": "Open",
        "work_order.redesign.budget_hours_unit": "h budget",
        "work_order.redesign.what_to_do": "What to do",
        "work_order.redesign.no_description": "No description added.",
        "work_order.redesign.ready_title": "Ready to complete?",
        "work_order.redesign.all_met": "All requirements met.",
        "work_order.redesign.items_left": "{{count}} left.",
        "work_order.redesign.req_crew": "Crew assigned",
        "work_order.redesign.req_hours": "Hours registered",
        "work_order.redesign.req_desc": "Description added",
        "work_order.redesign.req_items": "Materials registered",
        "work_order.redesign.mark_complete": "Mark complete",
        "work_order.redesign.completed": "Completed",
        "work_order.redesign.details": "Details",
        "work_order.redesign.detail_project": "Project",
        "work_order.redesign.detail_customer": "Customer",
        "work_order.redesign.due": "Due",
        "work_order.redesign.crew": "Crew",
        "work_order.redesign.assigned_count": "{{count}} assigned",
        "work_order.redesign.no_crew": "No crew yet",
        "work_orders.calendar_filter": "Work orders",
        "work_orders.project_activity.section_title": "Project activity",
        "work_orders.project_activity.help":
          "Link a project activity that is not already tied to another record, or create a new one on this project. Saving the work order connects the activity to this order.",
        "work_orders.project_activity.new_title_label": "New activity title",
        "work_orders.project_activity.copy_from_title": "Copy from title",
        "work_orders.project_activity.new_title_placeholder":
          "e.g. Installation phase 2",
        "work_orders.project_activity.create_button": "Create and select",
        "work_orders.project_activity.creating": "Creating…",
        "work_orders.project_activity.created_toast": "Project activity created",
        "work_orders.project_activity.create_error":
          "Could not create project activity",
        "work_orders.project_activity.linked_label": "Project activity",
        "work_orders.billing_ready.action": "Ready for invoicing",
        "work_orders.billing_ready.eyebrow": "Invoicing draft",
        "work_orders.billing_ready.title": "Prepare billing information",
        "work_orders.billing_ready.title_edit": "Update billing draft",
        "work_orders.billing_ready.intro":
          "Save invoice text and what to bill (hours and consumption lines). You can mark the work order ready for invoicing only, or create a sales order immediately to continue invoicing on the order.",
        "work_orders.billing_ready.section_invoice": "Invoice draft",
        "work_orders.billing_ready.section_hours": "Billable hours",
        "work_orders.billing_ready.section_hours_subtitle":
          "Selected {{selected}} h of {{total}} h (billable)",
        "work_orders.billing_ready.section_items": "Material lines (consumption)",
        "work_orders.billing_ready.section_items_subtitle":
          "{{selected}} of {{total}} lines selected",
        "work_orders.billing_ready.section_group": "Order grouping (later)",
        "work_orders.billing_ready.add_tilleggsarbeider_hint":
          "When orders are generated from this work order later, hours and materials can be placed in a separate group on the sales order.",
        "work_orders.billing_ready.toggle_hours_aria": "Include hours on invoice draft",
        "work_orders.billing_ready.toggle_items_aria": "Include material lines on invoice draft",
        "work_orders.billing_ready.no_billable_hours": "No billable hours linked to this work order.",
        "work_orders.billing_ready.no_usage_items": "No consumption lines with used quantity.",
        "work_orders.billing_ready.submit": "Save and mark ready for invoicing",
        "work_orders.billing_ready.success": "Marked ready for invoicing and reminder sent where applicable",
        "work_orders.billing_ready.failed": "Could not save billing draft",
        "work_orders.billing_ready.submit_create_order": "Create sales order",
        "work_orders.billing_ready.success_order": "Sales order created",
        "work_orders.billing_ready.failed_order": "Could not create sales order",
        "work_orders.billing_ready.open_order": "Open sales order",
        "work_orders.billing_ready.sales_income_in_project_notice_title":
          "Invoicing via sales order disabled",
        "work_orders.billing_ready.sales_income_in_project_notice":
          "This work order is marked as having sales income included in the project. Use project billing instead; marking ready for invoicing and creating a sales order from this work order are not available.",
        "work_orders.filter_executor": "Executor",
        "work_orders.bulk_create.toolbar": "{{count}} selected",
        "work_orders.bulk_create.open": "Create sales orders…",
        "work_orders.bulk_create.clear": "Clear selection",
        "work_orders.bulk_create.title": "Create sales orders from work orders",
        "work_orders.bulk_create.summary": "You are about to create one or more sales orders from {{count}} work order(s).",
        "work_orders.bulk_create.hint":
          "Default billing rules apply: all billable hours and consumption lines on each work order are included. For full control (rounding, manual hours, line picks), use the billing dialog on each work order.",
        "work_orders.bulk_create.strategy_label": "How should orders be grouped?",
        "work_orders.bulk_create.strategy_per_wo": "One sales order per work order",
        "work_orders.bulk_create.strategy_customer": "Combine per customer (one order per customer)",
        "work_orders.bulk_create.strategy_project": "Combine per project (one order per project)",
        "work_orders.bulk_create.submit": "Create orders",
        "work_orders.bulk_create.success": "Created {{count}} sales order(s)",
        "work_orders.bulk_create.failed": "Could not create sales orders",
        "work_orders.bulk_create.select_row": "Select work order for bulk invoicing",
        "work_orders.bulk_create.select_page": "Select all work orders on this page that can be invoiced",
        "work_orders.checklist.enable_switch": "Use checklist on this work order",
        "work_orders.checklist.section_title": "Checklist",
        "work_orders.checklist.save_to_enable_title": "Save the work order",
        "work_orders.checklist.save_to_enable_body":
          "Save your changes to activate the checklist section and create or edit checklist lines.",
        "work_orders.checklist.missing_title": "No checklist yet",
        "work_orders.checklist.missing_body":
          "Create a checklist by choosing a template or starting empty.",
        "work_orders.checklist.choose": "Choose checklist",
        "work_orders.checklist.delete": "Delete checklist",
        "work_orders.checklist.delete_confirm_title": "Delete checklist?",
        "work_orders.checklist.delete_confirm_body":
          "This cannot be undone. The checklist and its answers will be removed.",
        "work_orders.checklist.loading": "Loading checklist…",
        "work_orders.checklist.load_error": "Could not load checklist.",
        "work_orders.checklist.load_error_title": "Checklist could not be loaded",
        "work_orders.checklist.load_error_hint":
          "Try again or open the work order from the project overview.",
        "work_orders.checklist.created": "Checklist created",
        "work_orders.checklist.create_error": "Could not create checklist",
        "work_orders.checklist.deleted": "Checklist removed",
        "work_orders.checklist.delete_error": "Could not delete checklist",
        "work_orders.checklist.save_error": "Could not save checklist",
        "work_orders.checklist.read_only_hint":
          "You can view the work order checklist in read mode on the checklist page.",
        "work_orders.checklist.page_subtitle": "Checklist",
        "work_orders.checklist.page_heading": "Work order checklist",
        "work_orders.checklist.back_to_work_order": "Back to work order",
        "work_orders.checklist.disabled_title": "Checklist is not enabled",
        "work_orders.checklist.disabled_body":
          "Enable «Use checklist» on the work order edit page to use this section.",
        "work_orders.checklist.read_only_banner":
          "View only: you do not have permission to edit this checklist.",
        "work_orders.checklist.create_from_edit":
          "Create a checklist from the work order edit page.",
        "work_orders.checklist.load_work_order_error": "Could not load work order",
        "work_orders.checklist.card_title": "Checklist",
        "work_orders.checklist.card_desc_with_checklist":
          "View and complete checklist items on the checklist page.",
        "work_orders.checklist.card_desc_no_checklist":
          "Create a checklist from the work order edit page (choose a template or start empty).",
        "work_orders.checklist.unit": "items",
        "work_orders.checklist.mobile_nav": "Checklist",
        "work_orders.list_meta_total": "Total: {{count}}",
        "work_orders.table_no_title": "No title",
        "work_order.view.mobileNav.ariaLabel":
          "Quick links for work order time and item consumption",
        "work_order.admin.title": "Admin",
        "work_order.admin.edit": "Edit work order",
        "work_order.admin.edit_desc": "Open the full edit form",
        "work_order.admin.approve": "Approve work order",
        "work_order.admin.approve_desc": "Approve or reject (coordinator)",
        "work_order.admin.open_project": "Open project",
        "work_order.admin.open_customer": "Open customer",
        "work_order.admin.item_consumption": "Item consumption",
        "work_order.admin.item_consumption_desc": "Register materials and quantity used",
        "work_order.admin.billing_desc": "Prepare invoicing or create a sales order",
        "work_order.admin.finish": "Finish work order",
        "work_order.admin.finish_desc": "Complete checklist and mark as finished",
        "work_order.admin.mentions": "@mentions",
        "work_order.admin.mentions_desc": "Notes and resources that reference this work order",
        "work_order.admin.mentions_dialog_title": "Mentions of this work order",
        "work_order.admin.no_mentions": "No mentions found.",
        "work_order.admin.set_status": "Set status (admin)",
        "work_order.admin.set_status_desc":
          "Correct status for legacy cases, for example already invoiced outside Promang.",
        "work_order.admin_set_status.title": "Set work order status",
        "work_order.admin_set_status.intro":
          "Use when the order was invoiced or completed outside the normal flow. This does not create a sales order.",
        "work_order.admin_set_status.status_label": "Status",
        "work_order.admin_set_status.mark_completed": "Mark as completed",
        "work_order.admin_set_status.submit": "Save",
        "work_order.admin_set_status.success": "Status updated.",
        "work_order.admin_set_status.error": "Could not update status.",
        "work_order.status.draft": "Draft",
        "work_order.status.ongoing": "In progress",
        "work_order.status.finished": "Completed",
        "work_order.status.processing": "Processing",
        "work_order.status.processed": "Processed",
        "work_order.status.cancelled": "Cancelled",
        "work_order.status.ready_invoice": "Ready to invoice",
        "work_order.status.invoiced": "Invoiced",
        "work_order.status.rejected": "Rejected",
        "work_order.status.approved": "Approved",
        "work_order.status.updated": "Updated",
        "work_order.completion.check_participant_notes":
          "Update / participant notes",
        "work_order.completion.title": "Completion",
        "work_order.completion.status_not_applicable":
          "Finishing is not available for this status.",
        "work_order.completion.heading_done": "Work order completed",
        "work_order.completion.heading_pending": "Finish work order",
        "work_order.completion.sub_done":
          "The work order has been marked as finished.",
        "work_order.completion.sub_blocked":
          "Some requirements must be met before you can finish.",
        "work_order.completion.sub_ready":
          "All required checks are satisfied; you can finish when ready.",
        "work_order.completion.label_status": "Status",
        "work_order.completion.label_progress": "Readiness",
        "work_order.completion.value_done": "Completed",
        "work_order.completion.no_checks": "—",
        "work_order.completion.cta_view": "View completion details",
        "work_order.completion.cta_finish": "Finish work order",
        "work_order.event.dialog_create": "Create event",
        "work_order.event.dialog_edit": "Edit event",
        "work_order.event.toast_created": "Event created",
        "work_order.event.toast_updated": "Event updated",
        "work_order.event.toast_deleted": "Event deleted",
        "work_order.event.delete_failed": "Could not delete event",
        "work_order.event.delete_event": "Delete",
        "work_order.event.saving": "Saving…",
        "work_order.event.submit_create": "Create",
        "work_order.event.submit_update": "Update",
        "work_order.event.field_title": "Title",
        "work_order.event.field_title_placeholder": "Event title",
        "work_order.event.field_description": "Description",
        "work_order.event.field_description_placeholder": "Describe the event…",
        "work_order.event.field_start": "Start",
        "work_order.event.field_end": "End",
        "work_order.event.field_location": "Location",
        "work_order.event.field_location_placeholder": "Where will the event take place?",
        "work_order.event.location_prefilled":
          "Delivery address from the work order is pre-filled (you can edit it).",
        "work_order.event.all_day": "All day",
        "work_order.event.attendees_title": "Event attendees",
        "work_order.event.attendees_hint":
          "Everyone on the work order is suggested. Uncheck anyone who should not attend. You can add more below.",
        "work_order.event.add_attendee": "Add attendee",
        "work_order.event.add_confirm": "Add",
        "work_order.event.select_user": "Select user",
        "work_order.event.loading_users": "Loading users…",
        "work_order.event.no_attendees_from_wo":
          "No participants on the work order. Use “Add attendee” to invite someone.",
        "work_order.event.from_work_order": "From work order",
        "work_order.event.remove_attendee": "Remove",
        "work_order.event.role_participant": "Participant",
        "work_order.event.error_need_event_owner":
          "The work order must have someone who can own the calendar event (responsible executor, work order responsible, or creator) before you can create an event.",
        "work_order.event.notice_no_event_owner_title": "No event owner on work order",
        "work_order.event.notice_no_event_owner_description":
          "Add a responsible executor or work order responsible, or ensure the order has a creator, so the event can be tied to a user. You can still edit an existing event.",
        "work_order.participants.title": "Participants",
        "work_order.participants.description":
          "Who is on the work order (roles and status).",
        "work_order.participants.draft_hint":
          "Save the work order first to manage participants like on a project (dedicated dialogs).",
        "work_order.participants.add": "Add participant",
        "work_order.participants.add_first": "Add first participant",
        "work_order.participants.none": "No participants yet.",
        "work_order.participants.user": "User",
        "work_order.participants.role": "Role",
        "work_order.participants.status": "Status",
        "work_order.participants.edit": "Edit",
        "work_order.participants.delete": "Delete",
        "work_order.participants.delete_confirm":
          "Remove this participant from the work order?",
        "work_order.participants.delete_error": "Could not remove participant",
        "work_order.participants.error_loading":
          "Could not load participants",
        "work_order.participants.save_error": "Could not save participant",
        "work_order.participants.created": "Participant added",
        "work_order.participants.updated": "Participant updated",
        "work_order.participants.updating": "Updating…",
        "work_order.participants.adding": "Adding…",
        "work_order.plan_modal.section_title": "Scheduling",
        "work_order.plan_modal.section_subtitle":
          "Schedule executors and time slots for this work order in the project plan.",
        "work_order.plan_modal.schedule_new": "Schedule",
        "work_order.plan_modal.schedule_edit": "Edit scheduling",
        "work_order.plan_modal.empty": "Nothing scheduled yet. Create a plan with executor and time.",
        "work_order.plan_modal.title_create": "Schedule work order",
        "work_order.plan_modal.title_edit": "Edit scheduling",
        "work_order.plan_modal.work_order": "Work order",
        "work_order.plan_modal.plan_title": "Plan title",
        "work_order.plan_modal.plan_title_placeholder": "Task title in the plan",
        "work_order.plan_modal.planning_type_section": "Planning type",
        "work_order.plan_modal.planning_type_resources": "Assign resources",
        "work_order.plan_modal.planning_type_dates_only": "Dates only",
        "work_order.plan_modal.planning_type_resources_help":
          "Pick executors and time per day. Resources show up in the resource plan.",
        "work_order.plan_modal.planning_type_dates_only_help":
          "Only set start and end dates for now – resources can be attached to the plan later.",
        "work_order.plan_modal.dates_only_remove_warning":
          "This plan already has resources. Saving as \"Dates only\" removes them from the plan.",
        "work_order.plan_modal.validation_missing_dates": "Select at least one day for the plan",
        "work_order.plan_modal.pick_days_hint": "Select days for the plan",
        "work_order.plan_modal.executing_section": "Executor",
        "work_order.plan_modal.executing_help":
          "Choose who will perform the work.",
        "work_order.plan_modal.executing_help_multi":
          "Choose one or more executors. Each gets assignments on selected days.",
        "work_order.plan_modal.select_all_participants": "Select all WO participants",
        "work_order.plan_modal.select_all_employees": "Applies to all employees",
        "work_order.plan_modal.clear_employees": "Clear all",
        "work_order.plan_modal.tab_all": "All",
        "work_order.plan_modal.mode_shared": "Same plan for all",
        "work_order.plan_modal.mode_per_user": "Plan per user",
        "work_order.plan_modal.apply_days_to_all": "Apply selected days to all",
        "work_order.plan_modal.apply_days_to_all_help":
          "Copies the visible selected days to every selected resource and switches to \"Same plan for all\".",
        "work_order.plan_modal.apply_days_to_all_toast":
          "Selected days now apply to all resources",
        "work_order.plan_modal.remove_day": "Remove day from plan",
        "work_order.plan_modal.all_employees_hint":
          "\"Same plan for all\" is used only when resources share the same days — or when you explicitly choose it / \"Apply selected days to all\". When days differ per resource, new people start with empty days.",
        "work_order.plan_modal.selected_employees_count": "{{count}} executors selected",
        "work_order.plan_modal.new_resource_pick_days":
          "New resource added — pick days for this person",
        "work_order.plan_modal.new_resources_pick_days":
          "New resources added — pick days for these people",
        "work_order.plan_modal.conflicts_title": "Resource conflicts ({{count}})",
        "work_order.plan_modal.conflicts_help":
          "Click a conflict to jump to that date and adjust or remove the day.",
        "work_order.plan_modal.conflicts_jump": "Go to date",
        "work_order.plan_modal.days_section": "Days",
        "work_order.plan_modal.days_help":
          "Pick days in the week view. Existing scheduled days stay when you change weeks — you can add more days in another week.",
        "work_order.plan_modal.multi_week_nav_hint":
          "Use the calendar arrows to add days in other weeks. Hours per day lists every selected date.",
        "work_order.plan_modal.per_day_other_weeks": "Other weeks ({{count}})",
        "work_order.plan_modal.per_day_this_week": "This week",
        "work_order.plan_modal.other_week_badge": "other week",
        "work_order.plan_modal.selected_days_count": "{{count}} day(s) selected",
        "work_order.plan_modal.per_day_section": "Time per day",
        "work_order.plan_modal.per_day_help": "Set from/to and hours for each selected day.",
        "work_order.plan_modal.time_from": "From",
        "work_order.plan_modal.time_to": "To",
        "work_order.plan_modal.hours_short": "h",
        "work_order.plan_modal.default_hours_label": "Default hours (new days)",
        "work_order.plan_modal.apply_hours_all_days": "Apply default hours to all selected days",
        "work_order.plan_modal.schedule_help_calendar":
          "You can also drag a time range in the calendar — only the day you drag on is updated.",
        "work_order.plan_modal.schedule_help_multi":
          "Drag a time range in the calendar, or adjust from/to per day below.",
        "work_order.plan_modal.drag_days_hint": "on a day in the calendar to set time for that day.",
        "work_order.plan_modal.clear_days": "Clear days",
        "work_order.plan_modal.clear_time": "Clear time",
        "work_order.plan_modal.same_time_all_days": "same time all days",
        "work_order.plan_modal.varied_times": "Varied times per day",
        "work_order.plan_modal.assignment_count": "{{count}} assignments",
        "work_order.plan_modal.days_short": "days",
        "work_order.plan_modal.participant": "WO participant",
        "work_order.plan_modal.estimated_hours_section": "Estimated time",
        "work_order.plan_modal.estimated_hours_help":
          "Used as the default duration when you add new days.",
        "work_order.plan_modal.estimated_hours_from_wo":
          "Suggested from work order: {{hours}} hours",
        "work_order.plan_modal.schedule_section": "Calendar",
        "work_order.plan_modal.schedule_help":
          "Drag in the calendar to pick a time slot.",
        "work_order.plan_modal.pick_time_hint": "Select days and set from/to per day",
        "work_order.plan_modal.validation_missing":
          "Select executors, at least one day, and from/to for each day",
        "work_order.plan_modal.validation_missing_user_days":
          "Every selected executor needs at least one day — or use \"Apply selected days to all\"",
        "work_order.plan_modal.toast_created": "Scheduling created",
        "work_order.plan_modal.toast_updated": "Scheduling updated",
        "work_order.plan_modal.saving": "Loading…",
        "work_order.plan_modal.add_plan": "Add new plan",
        "work_order.plan_modal.plans_section_subtitle":
          "Add one or more plans \u2013 e.g. one plan this week and another further ahead. Each plan can apply to specific employees or all of them.",
        "work_order.plan_modal.plan_index": "Plan {{number}}",
        "work_order.plan_modal.plans_count": "{{count}} plans",
        "work_order.plan_modal.empty_multi":
          "No plans yet. Add a plan with executors and time \u2013 you can add several plans for different weeks.",
        "work_order.project_plan.open_project_plan": "Open project plan",
        "work_order.project_plan.untitled": "Untitled",
        "work_order.project_plan.badge_draft": "Draft",
        "work_order.project_plan.status_draft": "Draft",
        "report.participants.title": "Additional assignees",
        "report.participants.subtitle":
          "Extra field staff and observers (calendar shows everyone). The responsible technician is set on the agreement.",
        "report.participants.add": "Add assignee",
        "report.participants.add_first": "Add first assignee",
        "report.participants.none": "No additional assignees.",
        "report.participants.user": "User",
        "report.participants.role": "Role",
        "report.participants.status": "Status",
        "report.participants.choose_role": "Select role",
        "report.participants.choose_status": "Select status",
        "report.participants.edit": "Edit",
        "report.participants.delete": "Remove",
        "report.participants.delete_confirm":
          "Remove this person from the report assignees?",
        "report.participants.delete_error": "Could not remove assignee",
        "report.participants.save_error": "Could not save assignee",
        "report.participants.created": "Assignee added",
        "report.participants.updated": "Assignee updated",
        "report.participants.updating": "Updating…",
        "report.participants.adding": "Adding…",
        "report.participants.error_is_executing_employee":
          "This person is already set as the responsible technician on the agreement. Remove them from the agreement first, or pick another colleague.",
        "Use card view": "Use card view",
        "Switch to card overview layout": "Switch to card overview layout",
        "Switch to compact table layout": "Switch to compact table layout",
        "Service Agreement": "Service Agreement",
        "Project": "Project",
        "Absence": "Absence",
        "Week": "Week",
        "Day": "Day",
        "Period": "Period",
        "Filters": "Filters",
        "Project Filter": "Project Filter",
        "Activity Filter": "Activity Filter",
        "All Projects": "All Projects",
        "All Activities": "All Activities",
        "Clear Filters": "Clear Filters",
        "No hours recorded for this day": "No hours recorded for this day",
        "entries": "entries",
        "Loading hours...": "Loading hours...",
        "already_registered_hours_for_event": "Already registered hours for this event",
        "dashboard_report.status.planned": "Planned",
        "dashboard.stats.eyebrow": "Dashboard",
        "dashboard.stats.title": "Status overview",
        "dashboard.stats.tap_hint": "Tap to see all numbers and details",
        "dashboard.stats.detail_title": "Status overview",
        "dashboard.stats.detail_intro": "Overview of open tasks and key figures. Tap a card to go to the module.",
        "dashboard.stats.reports": "Reports",
        "dashboard.stats.report_agreements": "Report agreements",
        "dashboard.stats.cases": "Cases",
        "dashboard.stats.deviations": "Deviations",
        "dashboard.stats.projects": "Projects",
        "dashboard.stats.kilometers": "Kilometres",
        "dashboard.stats.reports_not_finished": "Not completed",
        "dashboard.stats.reports_finished": "Completed",
        "dashboard.stats.reports_agreement_not_confirmed": "Not confirmed",
        "dashboard.stats.reports_not_approved": "Not approved",
        "dashboard.stats.cases_open": "Open",
        "dashboard.stats.deviations_open": "Awaiting handling",
        "dashboard.stats.deviations_assigned": "Assigned to you",
        "dashboard.stats.projects_open": "In progress",
        "dashboard.stats.this_month": "This month",

        "company_guide.badge": "Company guide",
        "company_guide.hours.title": "Time tracking, absence and work schedule",
        "company_guide.hours.subtitle":
          "Checklist for admins with the Hours module (shown on the hours user guide).",
        "company_guide.hours.progress_label": "Status",
        "company_guide.hours.progress_loading": "Loading…",
        "company_guide.hours.progress_error": "Could not load status. Try refreshing the page.",
        "company_guide.hours.progress_summary_ok": "{{done}} of {{total}} recommended steps are complete.",
        "company_guide.hours.progress_summary_warnings":
          "{{done}} of {{total}} recommended steps are complete. {{warnings}} item(s) still need attention.",
        "company_guide.hours.footer_hint":
          "Legacy Activity/ActivityItem is mainly for Tripletex sync, not primary time entry in Promang.",
        "company_guide.hours.footer_link_settings": "Open Hours → Settings",
        "company_guide.hours.link.scroll_to_explanation": "Read the explanation below",
        "company_guide.hours.link.settings_section": "Open in settings",
        "company_guide.hours.link.work_schedule": "Open schedule",
        "company_guide.hours.task.registration_model.title": "Time entry and project lines",
        "company_guide.hours.task.registration_model.info":
          "Project hours need project_activity on the project. Activity/ActivityItem is legacy in the UI and used for Tripletex sync.",
        "company_guide.hours.task.absence_types.title": "Absence types",
        "company_guide.hours.task.absence_types.ok": "{{count}} absence type(s) defined.",
        "company_guide.hours.task.absence_types.warn":
          "Create absence types that match how you work (vacation, sick leave, time off in lieu, …).",
        "company_guide.hours.task.absence_types.unknown": "Could not verify absence types automatically.",
        "company_guide.hours.task.handlers.title": "Hours and absence ownership",
        "company_guide.hours.task.handlers.ok": "Hours and absence handlers are set.",
        "company_guide.hours.task.handlers.warn":
          "Assign who processes timesheets and self-reported absence so employees know who follows up.",
        "company_guide.hours.task.work_schedule.title": "Work schedule and FTE",
        "company_guide.hours.task.work_schedule.info":
          "Ensure each employee has a work schedule that matches their position; it affects planned hours and absence.",
        "company_guide.hours.task.work_schedule.ok": "Work schedules exist and employees are assigned.",
        "company_guide.hours.task.work_schedule.warn_none": "Create at least one company work schedule.",
        "company_guide.hours.task.work_schedule.warn_unassigned":
          "{{count}} active employee(s) have no work schedule assigned.",
        "company_guide.hours.link.work_schedule_admin": "Manage work schedules",

        "company_guide.company.badge": "Company guide",
        "company_guide.company.heading": "Core company profile",
        "company_guide.company.subtitle":
          "Logo, contact details, addresses and terms links build trust in customer-facing flows.",
        "company_guide.company.progress_label": "Status",
        "company_guide.company.progress_loading": "Loading…",
        "company_guide.company.progress_error": "Could not load company data. Try refreshing.",
        "company_guide.company.progress_ok": "{{done}} of {{total}} recommended items are complete.",
        "company_guide.company.progress_warnings":
          "{{done}} of {{total}} recommended items are complete. {{warnings}} still need attention.",
        "company_guide.company.footer_hint":
          "Update everything under Company → Settings. This checklist refreshes after you save.",
        "company_guide.company.link.settings": "Open company settings",
        "company_guide.company.task.name.title": "Company name",
        "company_guide.company.task.name.warn": "Company name should be filled in.",
        "company_guide.company.task.name.ok": "Company name looks set.",
        "company_guide.company.task.logo.title": "Logo",
        "company_guide.company.task.logo.warn": "Add a logo for documents, offers and customer views.",
        "company_guide.company.task.logo.ok": "Logo is set.",
        "company_guide.company.task.contact.title": "Contact information",
        "company_guide.company.task.contact.warn": "Provide at least one of email, phone or mobile.",
        "company_guide.company.task.contact.ok": "At least one contact channel is set.",
        "company_guide.company.task.address.title": "Address",
        "company_guide.company.task.address.warn": "Add a business or postal address.",
        "company_guide.company.task.address.ok": "An address is registered.",
        "company_guide.company.task.sales_conditions_url.title": "Sales terms (URL)",
        "company_guide.company.task.sales_conditions_url.warn":
          "A link to sales/terms is missing — important for offers and webshop.",
        "company_guide.company.task.sales_conditions_url.ok": "Sales/terms link is set.",
        "company_guide.company.task.vat.title": "VAT / org. number",
        "company_guide.company.task.vat.warn": "Organization / VAT number should be filled in.",
        "company_guide.company.task.vat.ok": "Organization / VAT number is set.",

        "dashboard.company_guide.alert_company_title": "Company profile needs attention",
        "dashboard.company_guide.alert_company_subtitle":
          "{{count}} item(s) in the company guide should be fixed.",
        "dashboard.company_guide.alert_hours_title": "Hours setup needs attention",
        "dashboard.company_guide.alert_hours_subtitle":
          "{{count}} item(s) in the hours guide should be fixed.",
        "dashboard.company_guide.alert_hse_title": "HSE setup needs attention",
        "dashboard.company_guide.alert_hse_subtitle":
          "{{count}} item(s) in the HSE guide should be fixed.",
        "dashboard.company_guide.alert_offers_title": "Offer setup needs attention",
        "dashboard.company_guide.alert_offers_subtitle":
          "{{count}} recommended offer feature(s) are turned off.",
        "dashboard.company_guide.alert_cta": "Open guide and checklist",

        "user_guide.hub.card.company.title": "Company and settings",
        "user_guide.hub.card.company.description":
          "Logo, contact, addresses, sales terms and other basics that should be in place.",

        "user_guide.company.back_to_hub": "Back to user guide",
        "user_guide.company.badge": "Company",
        "user_guide.company.title": "Company settings and profile",
        "user_guide.company.intro":
          "Correct company information matters for customers, offers and integrations. As an admin, work through the checklist below and fill any gaps.",
        "user_guide.company.section.why.title": "Why this matters",
        "user_guide.company.section.why.p1":
          "Logo and contact details are expected wherever you meet customers and suppliers.",
        "user_guide.company.section.why.p2":
          "Address and sales terms are often required in agreements, webshop and document exports.",
        "user_guide.company.section.where.title": "Where to change this",
        "user_guide.company.section.where.p1":
          "Go to Company → Settings. Use the checklist links to jump to the right section.",

        "user_guide.hub.card.profile.title": "My profile and personal details",
        "user_guide.hub.card.profile.description":
          "Mobile number, next of kin, national ID, account number and children — what should be in place.",

        "user_guide.profile.back_to_hub": "Back to user guide",
        "user_guide.profile.badge": "My profile",
        "user_guide.profile.title": "Personal details and profile",
        "user_guide.profile.intro":
          "Some features require you to fill in personal details. A correct mobile number, next of kin, national ID and account number keep payroll, absence, HSE and contact working as expected. Work through the checklist below and fill any gaps.",
        "user_guide.profile.heading": "Your personal details",
        "user_guide.profile.subtitle":
          "Applies to both employees and hired staff. Fill in the fields below so Promang works optimally for you.",
        "user_guide.profile.progress_label": "Status",
        "user_guide.profile.progress_loading": "Loading…",
        "user_guide.profile.progress_error": "Could not load profile data. Try refreshing.",
        "user_guide.profile.progress_ok": "{{done}} of {{total}} required items are complete.",
        "user_guide.profile.progress_warnings":
          "{{done}} of {{total}} required items are complete. {{warnings}} still need attention.",
        "user_guide.profile.footer_hint":
          "Update everything under My profile. This checklist refreshes after you save.",
        "user_guide.profile.link.profile": "Open my profile",
        "user_guide.profile.task.mobile.title": "Mobile number",
        "user_guide.profile.task.mobile.warn": "Add a mobile number so colleagues and systems can reach you.",
        "user_guide.profile.task.mobile.ok": "Mobile number is set.",
        "user_guide.profile.task.next_of_kin.title": "Next of kin",
        "user_guide.profile.task.next_of_kin.warn":
          "Add at least one next of kin — important for incidents and emergencies.",
        "user_guide.profile.task.next_of_kin.ok": "Next of kin is registered.",
        "user_guide.profile.task.social_security.title": "National ID number",
        "user_guide.profile.task.social_security.warn":
          "A national ID number is required for employment contract, payroll and reporting.",
        "user_guide.profile.task.social_security.ok": "National ID number is registered.",
        "user_guide.profile.task.account_number.title": "Account number",
        "user_guide.profile.task.account_number.warn":
          "Add an account number for payout of salary and expenses.",
        "user_guide.profile.task.account_number.ok": "Account number is registered.",
        "user_guide.profile.task.email_signature.title": "Email signature",
        "user_guide.profile.task.email_signature.warn":
          "Add a signature under Profile → Email. It is inserted when you send email to the customer.",
        "user_guide.profile.task.email_signature.ok": "Email signature is registered.",
        "user_guide.profile.task.children.title": "Children (optional)",
        "user_guide.profile.task.children.info":
          "Optional. Add children if you want them registered (e.g. for care days).",
        "user_guide.profile.task.children.ok": "Children are registered.",
        "user_guide.profile.section.why.title": "Why this matters",
        "user_guide.profile.section.why.p1":
          "Mobile number and next of kin let us reach you or your closest contacts quickly if something happens at work.",
        "user_guide.profile.section.why.p2":
          "National ID and account number are required for employment contract, payroll and payouts.",
        "user_guide.profile.section.where.title": "Where to change this",
        "user_guide.profile.section.where.p1":
          "Go to My profile. Use the checklist links to jump to the right place.",

        "dashboard.user_guide.alert_profile_title": "Your profile is missing details",
        "dashboard.user_guide.alert_profile_subtitle":
          "{{count}} item(s) in your profile should be filled in.",
        "dashboard.user_guide.alert_cta": "Open guide and checklist",

        "user_employment.work_schedule_label": "Work schedule (hours)",
        "user_employment.work_schedule_hint":
          "Used for time tracking, planned time and absence. Create schedules under Hours → Work schedules.",
        "user_employment.work_schedule_none": "None selected",

        "work_schedules_admin.title": "Work schedules",
        "work_schedules_admin.intro":
          "Create and maintain schedules (hours per weekday). New employees get the latest schedule by default unless you assign another.",
        "work_schedules_admin.summary_title": "Summary",
        "work_schedules_admin.summary_plans": "{{count}} work schedule(s) in the company.",
        "work_schedules_admin.summary_unassigned_ok": "All active employees have a work schedule.",
        "work_schedules_admin.summary_unassigned_warn":
          "{{count}} active employee(s) have no work schedule — assign under the user/employee profile.",
        "work_schedules_admin.assign_hint": "Assign on employee:",
        "work_schedules_admin.assign_link": "Users / employees",
        "work_schedules_admin.new": "New work schedule",
        "work_schedules_admin.edit": "Edit",
        "work_schedules_admin.delete": "Delete",
        "work_schedules_admin.save": "Save",
        "work_schedules_admin.saving": "Saving…",
        "work_schedules_admin.cancel": "Cancel",
        "work_schedules_admin.field_name": "Name (optional)",
        "work_schedules_admin.field_name_placeholder": "e.g. Office 7.5h",
        "work_schedules_admin.empty": "No work schedules yet — create one to get started.",
        "work_schedules_admin.unnamed": "Untitled",
        "work_schedules_admin.confirm_delete": "Delete “{{name}}”? Cannot delete if in use.",
        "work_schedules_admin.created": "Work schedule created",
        "work_schedules_admin.saved": "Work schedule saved",
        "work_schedules_admin.deleted": "Work schedule deleted",
        "work_schedules_admin.load_error": "Could not load work schedules",
        "work_schedules_admin.save_error": "Could not save",
        "work_schedules_admin.delete_error": "Could not delete",
        "work_schedules_admin.back_guide": "Back to user guide (hours)",
        "work_schedules_admin.day.monday": "Monday",
        "work_schedules_admin.day.tuesday": "Tuesday",
        "work_schedules_admin.day.wednesday": "Wednesday",
        "work_schedules_admin.day.thursday": "Thursday",
        "work_schedules_admin.day.friday": "Friday",
        "work_schedules_admin.day.saturday": "Saturday",
        "work_schedules_admin.day.sunday": "Sunday",

        "work_schedule_view.page_title": "Schedule",
        "work_schedule_view.fallback_title": "Work schedule",
        "work_schedule_view.subtitle": "Hours per weekday adjusted for position percentage",
        "work_schedule_view.empty": "No work schedule is linked to your employment yet.",
        "work_schedule_view.empty_hint":
          "Ask an administrator to create a schedule and assign it on your user/employee profile.",
        "work_schedule_view.link_users": "Go to users",
        "work_schedule_view.day_off": "Off",
        "work_schedule_view.hours_value": "{{hours}} hours",
        "work_schedule_view.day.monday": "Monday",
        "work_schedule_view.day.tuesday": "Tuesday",
        "work_schedule_view.day.wednesday": "Wednesday",
        "work_schedule_view.day.thursday": "Thursday",
        "work_schedule_view.day.friday": "Friday",
        "work_schedule_view.day.saturday": "Saturday",
        "work_schedule_view.day.sunday": "Sunday",
        "work_schedule_view.holidays_title": "Public holidays",
        "work_schedule_view.holidays_subtitle": "Norwegian public holidays that reduce expected working hours",
        "work_schedule_view.holidays_empty": "No public holidays in the selected period.",
        "hours.monthly_overview.gross_normal": "Gross normal hours",
        "hours.monthly_overview.holiday_deduction": "Public holiday deduction",
        "hours.monthly_overview.absence_deduction": "Absence deduction",
        "Lønnsgrunnlag": "Payroll basis",
        "hours.payroll_basis.title": "Payroll basis",
        "hours.payroll_basis.subtitle":
          "Payroll basis per employee for the selected month. Only approved hours are included in totals and export.",
        "hours.payroll_basis.period": "Period",
        "hours.payroll_basis.export_pdf": "Export PDF",
        "hours.payroll_basis.export_zip": "Export ZIP",
        "hours.payroll_basis.export_redownload": "Download again",
        "hours.payroll_basis.export_coming_soon": "Export coming in a later step",
        "hours.payroll_basis.export_started": "Export started — waiting for ZIP…",
        "hours.payroll_basis.export_running": "Exporting…",
        "hours.payroll_basis.export_status": "Export status: {{status}}",
        "hours.payroll_basis.export_ready": "ZIP is ready and downloading.",
        "hours.payroll_basis.export_done_no_url": "Export finished, but download link is missing.",
        "hours.payroll_basis.export_failed": "Could not export payroll basis.",
        "hours.payroll_basis.export_timeout": "Export timed out. Please try again.",
        "hours.payroll_basis.export_dialog_title": "Export payroll basis",
        "hours.payroll_basis.export_dialog_body":
          "This is a draft. Choose whether to finalize before export, or download a ZIP without locking the period.",
        "hours.payroll_basis.export_dialog_finalize": "Finalize and export",
        "hours.payroll_basis.export_dialog_finalize_hint":
          "Sets status to finalized, then exported when the ZIP is ready. Notes and totals are locked.",
        "hours.payroll_basis.export_dialog_draft": "Export draft",
        "hours.payroll_basis.export_dialog_draft_hint":
          "Downloads a ZIP marked DRAFT. Status stays draft — you can keep editing.",
        "hours.payroll_basis.export_dialog_cancel": "Cancel",
        "hours.payroll_basis.action_create": "Create draft",
        "hours.payroll_basis.action_refresh": "Refresh draft",
        "hours.payroll_basis.action_finalize": "Finalize",
        "hours.payroll_basis.action_reopen": "Reopen for editing",
        "hours.payroll_basis.reopen_dialog_title": "Undo finalization?",
        "hours.payroll_basis.reopen_dialog_body":
          "The period becomes a draft again and can be changed. You can update notes, refresh totals and finalize again when ready.",
        "hours.payroll_basis.reopen_dialog_confirm": "Reopen for editing",
        "hours.payroll_basis.reopen_dialog_cancel": "Cancel",
        "hours.payroll_basis.reopen_running": "Reopening…",
        "hours.payroll_basis.status.draft": "Draft",
        "hours.payroll_basis.status.finalized": "Finalized",
        "hours.payroll_basis.status.exported": "Exported",
        "hours.payroll_basis.read_only_title": "Read-only",
        "hours.payroll_basis.read_only_body":
          "This basis is finalized or exported. You can view totals, employees and notes, and download the ZIP again. To add more info: reopen for editing.",
        "hours.payroll_basis.history_title": "Previous periods",
        "hours.payroll_basis.toast_created": "Payroll basis created.",
        "hours.payroll_basis.toast_refreshed": "Payroll basis refreshed.",
        "hours.payroll_basis.toast_note_saved": "Note saved.",
        "hours.payroll_basis.toast_general_notes_saved": "General notes saved.",
        "hours.payroll_basis.toast_finalized": "Payroll basis finalized.",
        "hours.payroll_basis.toast_reopened":
          "Payroll basis reopened as a draft and can be edited.",
        "hours.payroll_basis.error_title": "Something went wrong",
        "hours.payroll_basis.error_generic":
          "An unexpected error occurred. Try again, or contact support if the problem persists.",
        "hours.payroll_basis.error_load": "Could not load payroll basis.",
        "hours.payroll_basis.error_load_title": "Could not load payroll basis",
        "hours.payroll_basis.error_refresh": "Could not create/refresh draft.",
        "hours.payroll_basis.error_refresh_locked":
          "The period is locked or cannot be updated.",
        "hours.payroll_basis.error_note": "Could not save note.",
        "hours.payroll_basis.error_general_notes": "Could not save general notes.",
        "hours.payroll_basis.error_finalize": "Could not finalize.",
        "hours.payroll_basis.error_reopen": "Could not reopen the payroll basis.",
        "hours.payroll_basis.error_forbidden": "You do not have access to payroll basis.",
        "hours.payroll_basis.error_dismiss": "Dismiss error",
        "hours.payroll_basis.error_retry": "Try again",
        "hours.payroll_basis.api_unavailable_title": "API not available",
        "hours.payroll_basis.api_unavailable_body":
          "The payroll-basis endpoint is not available (404/501). This page is ready — try again when the API is deployed.",
        "hours.payroll_basis.api_unavailable_toast":
          "Payroll-basis API is not available.",
        "hours.payroll_basis.empty_draft_title": "No draft for this period",
        "hours.payroll_basis.empty_draft_body":
          "Select year and month, then press “Create draft” to load approved hours, overtime and absence per employee.",
        "hours.payroll_basis.scaffold_title": "Under construction",
        "hours.payroll_basis.scaffold_body":
          "This page is ready for further payroll-basis work (employee table, totals and export). The period selector is active; full functionality will follow soon.",
        "hours.payroll_basis.table_title": "Employees",
        "hours.payroll_basis.table_subtitle": "Period: {{period}}",
        "hours.payroll_basis.table_subtitle_empty": "Select year and month",
        "hours.payroll_basis.empty_title": "No employees in draft",
        "hours.payroll_basis.empty_body":
          "Create or refresh the draft to fill the table with hours for the period.",
        "hours.payroll_basis.col_employee": "Employee",
        "hours.payroll_basis.col_department": "Department",
        "hours.payroll_basis.col_normal": "Normal hours",
        "hours.payroll_basis.col_registered": "Registered",
        "hours.payroll_basis.col_approved": "Approved",
        "hours.payroll_basis.col_unapproved": "Unapproved",
        "hours.payroll_basis.col_absence": "Absence",
        "hours.payroll_basis.col_overtime": "Overtime",
        "hours.payroll_basis.col_docs": "Documentation",
        "hours.payroll_basis.col_note": "Note",
        "hours.payroll_basis.note_placeholder":
          "E.g. Hourly rate change from … · Holiday pay paid for week …",
        "hours.payroll_basis.note_empty_preview": "No note yet",
        "hours.payroll_basis.note_add": "Write note",
        "hours.payroll_basis.note_edit": "Edit note",
        "hours.payroll_basis.note_save": "Save note",
        "hours.payroll_basis.note_saving": "Saving…",
        "hours.payroll_basis.note_cancel": "Cancel",
        "hours.payroll_basis.note_dialog_title": "Employee note",
        "hours.payroll_basis.note_dialog_employee": "Employee: {{name}}",
        "hours.payroll_basis.general_notes_title": "General notes",
        "hours.payroll_basis.general_notes_subtitle":
          "Notes for the whole period / all employees / payroll in general. Supports formatting (bold, lists, headings).",
        "hours.payroll_basis.general_notes_placeholder":
          "E.g. Hourly rate change from … · Holiday pay paid for week … · General payroll adjustments for the period…",
        "hours.payroll_basis.general_notes_empty": "No general notes for this period.",
        "hours.payroll_basis.general_notes_save": "Save notes",
        "hours.payroll_basis.docs_yes": "Yes",
        "hours.payroll_basis.docs_no": "No",
        "hours.payroll_basis.unapproved_badge": "{{count}} unapproved",
        "hours.payroll_basis.summary_approved": "Approved hours",
        "hours.payroll_basis.summary_overtime": "Confirmed OT",
        "hours.payroll_basis.summary_absence": "Absence",
        "hours.payroll_basis.summary_unapproved": "Unapproved",
        "hours.payroll_basis.summary_unapproved_hint":
          "Visible for follow-up — not included in payroll totals.",
        "hours.payroll_basis.footer_totals": "Total (approved only in payroll)",
        "hours.payroll_basis.footer_docs": "{{count}} with documentation",
        "hours.payroll_basis.legend":
          "Red rows have unapproved hours. They are shown, but not included in payroll totals or ZIP export.",
        "project.plan.holidays.title": "Public holidays",

        "hours.resource_plan.title": "Resource plan and availability",
        "hours.resource_plan.subtitle": "See who is scheduled, available, absent or clocked in on the actual days.",
        "hours.resource_plan.date_from": "From date",
        "hours.resource_plan.date_to": "To date",
        "hours.resource_plan.access_title": "Employee access",
        "hours.resource_plan.access_body": "Users with Hours access can see operational colleague status without admin rights.",
        "hours.resource_plan.load_error": "Could not load resource plan",
        "hours.resource_plan.stats.employees": "Employees",
        "hours.resource_plan.stats.available_days": "Available day rows",
        "hours.resource_plan.stats.clocked_in": "Clocked in",
        "hours.resource_plan.stats.scheduled_hours": "Scheduled hours",
        "hours.resource_plan.days_title": "Days in period",
        "hours.resource_plan.days_subtitle": "Select a day for a detailed employee overview.",
        "hours.resource_plan.day_stats": "{{available}} of {{employees}} available",
        "hours.resource_plan.no_day": "No day selected",
        "hours.resource_plan.employee_overview": "Employees, planned time and status for the selected day.",
        "hours.resource_plan.empty": "No employees found for the selected period.",
        "hours.resource_plan.unknown_employee": "Unknown employee",
        "hours.resource_plan.table.employee": "Employee",
        "hours.resource_plan.table.status": "Status",
        "hours.resource_plan.table.department": "Department",
        "hours.resource_plan.table.scheduled": "Work schedule",
        "hours.resource_plan.table.shift": "Shift",
        "hours.resource_plan.table.note": "Note",
        "hours.resource_plan.status.clocked_in": "At work now",
        "hours.resource_plan.status.available": "Available",
        "hours.resource_plan.status.planned": "Planned",
        "hours.resource_plan.status.absent": "Absent",
        "hours.resource_plan.status.unavailable": "Unavailable",
        "hours.resource_plan.status.off": "Off",

        "hour_settings.page.subtitle":
          "Absence, approval flow, payroll locking and other time settings (project hours use project_activity on the project).",
        "hour_settings.guide.title": "Getting started with hours",
        "hour_settings.guide.intro":
          "These are the same steps as on the dashboard. Time tracking is built on projects and project_activity; the general activity lists here are optional admin maintenance, not an onboarding requirement.",
        "hour_settings.guide.step.project_activity":
          "Project hours: ensure project_activity (and project) exists where people log time — this is what current Promang requires for project registration.",
        "hour_settings.guide.step.absence_types": "Absence types: create and maintain the types you use.",
        "hour_settings.guide.step.handlers":
          "Set administrators for hours and for self-reported absence.",
        "hour_settings.guide.step.payroll_lock":
          "Consider payroll period locking and payout day once routines are in place.",
        "hour_settings.guide.step.time_documents":
          "Optional — attach files to standalone hours without a linked service report or work order.",
        "hour_settings.guide.step.work_schedule":
          "Create schedules under Hours → Work schedules and assign them to employees (user profiles).",
        "hour_settings.guide.back_dashboard": "Back to home",
        "hour_settings.guide.open_user_guide": "User guide: hours and absence",
        "hour_settings.time_documents.section_title": "Time entry attachments",
        "hour_settings.time_documents.section_description":
          "Allow attaching photos/files to standalone hours when the hour is not linked to a service report or work order.",
        "hour_settings.time_documents.enabled": "Allow documentation uploads on hours",

        "hour_settings.agreed_overtime.section_title": "Agreed overtime",
        "hour_settings.agreed_overtime.section_description":
          "Let employees request agreed overtime when registering hours. An admin or the hours handler must confirm before it counts as OT.",
        "hour_settings.agreed_overtime.enabled": "Allow agreed overtime",
        "hour_settings.agreed_overtime.enabled_help":
          "When enabled, employees can tick agreed overtime and enter OT hours (full amount or a partial amount).",

        "hours.agreed_overtime.section_title": "Agreed overtime",
        "hours.agreed_overtime.checkbox_label": "Agreed overtime",
        "hours.agreed_overtime.checkbox_help":
          "Tick if all or part of this entry is agreed overtime. Confirmation is required before it counts.",
        "hours.agreed_overtime.hours_label": "OT hours",
        "hours.agreed_overtime.hours_hint": "Can be the full amount or a partial amount (max equal to registered time).",
        "hours.agreed_overtime.hours_required": "Enter OT hours",
        "hours.agreed_overtime.hours_invalid": "OT hours must be greater than 0 and not exceed registered time",
        "hours.agreed_overtime.badge_pending": "Agreed OT — pending",
        "hours.agreed_overtime.badge_confirmed": "Agreed OT — confirmed",
        "hours.agreed_overtime.process_dialog_title": "Process hour",
        "hours.agreed_overtime.process_help": "Requested OT: {{hours}} h of {{time}} h registered.",
        "hours.agreed_overtime.note_label": "Note for OT review",
        "hours.agreed_overtime.note_placeholder": "Optional note…",
        "hours.agreed_overtime.confirm": "Confirm OT",
        "hours.agreed_overtime.reject": "Reject OT",
        "hours.agreed_overtime.confirm_success": "Agreed overtime confirmed",
        "hours.agreed_overtime.confirm_failed": "Could not confirm agreed overtime",
        "hours.agreed_overtime.reject_success": "Agreed overtime rejected",
        "hours.agreed_overtime.reject_failed": "Could not reject agreed overtime",
        "hours.agreed_overtime.waiting_for_handler":
          "Waiting for confirmation from an administrator or the hours handler.",

        "hour.time_documents.title": "Documentation",
        "hour.time_documents.subtitle": "Pictures and files tied to this time entry.",
        "hour.time_documents.help_save_first": "Save the hour before you can attach files.",
        "hour.time_documents.pending_hint":
          "Add files below. They upload automatically right after you save (you do not need a separate upload step).",
        "hour.time_documents.pending_add": "Add files",
        "hour.time_documents.pending_count": "{{count}} file(s) queued for upload",
        "hour.time_documents.pending_remove": "Remove",
        "hour.time_documents.pending_file_type_denied": "That file type is not allowed.",
        "hour.time_documents.pending_upload_done": "Attachments uploaded",
        "hour.time_documents.pending_upload_failed":
          "The hour was saved, but uploads failed or were skipped. Close and reopen the hour to try again.",
        "hour.time_documents.blocked_linked":
          "Documentation is disabled when this hour is linked to a service report or work order.",
        "hour.time_documents.blocked_lock": "This period is locked; attachments cannot be changed.",

        "documentUpload.bar.ariaLabel": "Document upload progress",
        "documentUpload.bar.uploading": "Uploading documents",
        "documentUpload.bar.failed": "Upload failed",
        "documentUpload.bar.destination": "To",
        "documentUpload.bar.fileOf": "{{current}} of {{total}}",
        "documentUpload.bar.dismiss": "Hide upload status",
        "documentUpload.bar.minimize": "Minimize",
        "documentUpload.bar.expand": "Show upload progress",
        "documentUpload.bar.close": "Close",
        "documentUpload.bar.uploadingShort": "Uploading",
        "documentUpload.bar.jobSingular": "job",
        "documentUpload.bar.jobPlural": "jobs",
        "documentUpload.viewer.showing": "Showing {{from}}–{{to}} of {{total}}",
        "documentUpload.bar.continueHint":
          "Upload continues at the top of the page — you can close this window and keep working.",
        "documentUpload.preview.title": "Preview and upload",
        "documentUpload.preview.addMore": "Add more photos",
        "documentUpload.preview.close": "Close",
        "documentUpload.preview.confirm": "Upload",
        "documentUpload.preview.uploading": "Uploading…",
        "documentUpload.preview.removeFile": "Remove file",
        "documentUpload.preview.folderLabel": "Folder",
        "documentUpload.preview.folderSelectedHint": "Documents will be uploaded to the selected folder.",
        "documentUpload.preview.drawingLabel": "Drawing (optional)",
        "documentUpload.preview.linkedDrawing": "Linked drawing #{{id}}",
        "documentUpload.preview.linkedDrawingHint": "This checklist is linked to this drawing — just place the pin.",
        "documentUpload.preview.enableSketch": "Markup / sketch on drawing",
        "documentUpload.preview.enableSketchHint": "Optional: draw markup on the drawing after placing the pin.",
        "documentUpload.preview.enableSketchHintFullCanvas": "Optional: after you click the drawing, a sketch dialog opens.",
        "documentUpload.preview.fullCanvasPlacementHint": "The pin is placed on the actual drawing (full Drawings viewer).",
        "documentUpload.preview.selectDrawingFirst": "Select a drawing before placing the pin.",
        "documentUpload.preview.positionPlacedOnDrawing": "Position set on the drawing",
        "documentUpload.preview.sketchAttached": "Sketch attached",
        "documentUpload.preview.sketchCaptureFailed": "Could not start sketch — pin saved without markup.",
        "documentUpload.preview.drawingPlaceholder": "Select drawing…",
        "documentUpload.preview.drawingPositionLabel": "Position on drawing",
        "documentUpload.preview.drawingPosition": "Position: X: {{x}}, Y: {{y}}",
        "documentUpload.preview.pickDrawingPosition": "Pick position on drawing",
        "documentUpload.preview.changeDrawingPosition": "Change position",
        "documentUpload.preview.drawingPositionDialogTitle": "Pick position on drawing",
        "documentUpload.preview.drawingClickHint": "Click on the drawing to pick a position",
        "documentUpload.preview.drawingLoading": "Loading drawing…",
        "documentUpload.preview.drawingLoadFailed": "Could not load drawing",
        "documentUpload.preview.confirmDrawingPosition": "Confirm position",
        "documentUpload.preview.drawingDialogTitle": "Select drawing",
        "documentUpload.preview.drawingSearchPlaceholder": "Search drawings…",
        "documentUpload.preview.drawingEmpty": "No drawings found",
        "documentUpload.direct.buttonShort": "Camera",
        "documentUpload.direct.tooltip": "Upload photos",
        "documentUpload.direct.imagesOnly": "Only image files can be uploaded here.",
        "documentUpload.dropzone.viewImages": "View images",
        "documentUpload.dropzone.viewImagesCount": "View images ({{count}})",
        "documentUpload.dropzone.loading": "Loading…",
        "documentUpload.dropzone.ariaLabel": "View or manage images",
        "documentUpload.destination.checklist_item": "Checklist item",
        "documentUpload.destination.report": "Service report",
        "documentUpload.destination.project": "Project",
        "documentUpload.destination.hour": "Time entry",
        "documentUpload.destination.meeting_minute": "Meeting minutes",
        "documentUpload.destination.vehicle_service": "Vehicle service",

        "user_guide.hub.title": "How to use Promang",
        "user_guide.hub.subtitle":
          "Step-by-step guides for admins and staff. Content is maintained inside the app — technical developer docs are separate.",
        "user_guide.hub.card.hours.title": "Hours, absence and work schedule",
        "user_guide.hub.card.hours.description":
          "Getting started: absence types, owners, payroll lock, reminders and work schedules.",
        "user_guide.hub.card.hse.title": "HSE, goals and safety representative",
        "user_guide.hub.card.hse.description":
          "Set the HSE owner, safety representative, risk handling and this year’s goals.",
        "user_guide.hse.title": "HSE setup",
        "user_guide.hse.badge": "Company",
        "user_guide.hse.back_to_hub": "Back to guides",
        "user_guide.hse.purpose": "Make sure the company has a safety representative, HSE owner and goals for the year. Then alerts and approval work as intended.",
        "user_guide.hse.section.roles.title": "Roles",
        "user_guide.hse.section.roles.p1": "The HSE owner owns actions and review. The safety representative is the statutory contact for the work environment.",
        "user_guide.hse.section.roles.p2": "Set both under HSE & QA → Settings. Deputies are optional.",
        "user_guide.hse.section.goals.title": "Goals",
        "user_guide.hse.section.goals.p1": "Use templates and chips instead of long tables. Approve when management agrees.",
        "user_guide.hse.section.goals.p2": "An action can be linked to a focus area, but it is optional.",
        "user_guide.hse.section.risk.title": "Risk",
        "user_guide.hse.section.risk.p1": "Start with an overall assessment for the year. Then assess each risk and link actions. The register lists all risks across assessments.",
        "user_guide.hse.section.related.title": "Related pages",
        "user_guide.hse.section.related.settings": "HSE settings",
        "user_guide.hse.section.related.goals": "Goals",
        "user_guide.hse.section.related.risk": "Risk assessments",
        "company_guide.hse.title": "HSE status",
        "company_guide.hse.subtitle": "Recommended steps before the module is used fully.",
        "company_guide.hse.progress_error": "Could not load HSE status. Try refreshing the page.",
        "company_guide.hse.link.settings": "Open settings",
        "company_guide.hse.link.goals": "Open goals",
        "company_guide.hse.task.responsible.title": "HSE owner",
        "company_guide.hse.task.responsible.warn": "Set who owns HSE in the company.",
        "company_guide.hse.task.responsible.ok": "HSE owner is set.",
        "company_guide.hse.task.safety_rep.title": "Safety representative",
        "company_guide.hse.task.safety_rep.warn": "Set a safety representative (deputies are optional).",
        "company_guide.hse.task.safety_rep.ok": "Safety representative is set.",
        "company_guide.hse.task.verneombud.title": "Safety representative",
        "company_guide.hse.task.verneombud.warn": "Set a safety representative (deputies are optional).",
        "company_guide.hse.task.verneombud.ok": "Safety representative is set.",
        "company_guide.hse.task.risk.title": "Risk ownership",
        "company_guide.hse.task.risk.warn": "Set who owns risk, or use the HSE owner.",
        "company_guide.hse.task.risk.ok": "Risk ownership is in place.",
        "company_guide.hse.task.categories.title": "Risk categories",
        "company_guide.hse.task.categories.info": "Activate at least one risk category.",
        "company_guide.hse.task.categories.ok": "Risk categories are ready.",
        "company_guide.hse.task.goals.title": "This year’s goals",
        "company_guide.hse.task.goals.warn": "Add at least one goal for the current year.",
        "company_guide.hse.task.goals.ok": "This year’s goals are in place.",
        "company_guide.hse.task.goals.info": "Create and approve goals for the year when you are ready.",
        "company_guide.hse.task.ai.title": "AI suggestions",
        "company_guide.hse.task.ai.info": "Optional: enable suggestions when a key is configured.",
        "company_guide.hse.task.ai.warn": "AI is on, but the key is missing.",
        "user_guide.hub.card.offers.title": "Offers and calculation",
        "user_guide.hub.card.offers.description":
          "Turn on checklist, approval, calculation and document builder for the company.",

        "user_guide.offers.back_to_hub": "Back to user guide",
        "user_guide.offers.badge": "Offers",
        "user_guide.offers.title": "Offers, calculation and document",
        "user_guide.offers.purpose":
          "How to set up the offer module: which tabs are shown, how the calculation totals, and how the offer document is built. Recommended options are marked in settings.",
        "user_guide.offers.checklist.badge": "Setup",
        "user_guide.offers.checklist.heading": "Setup status (offers)",
        "user_guide.offers.checklist.subtitle":
          "Recommended features that should be on so checklist, approval and calculation appear on the offer.",
        "user_guide.offers.checklist.open_settings": "Open settings",
        "user_guide.offers.checklist.flag_on": "On",
        "user_guide.offers.checklist.flag_off": "Off — recommended to turn on",
        "user_guide.offers.checklist.all_ok": "Recommended offer settings are in place.",
        "user_guide.offers.checklist.load_error.title": "Could not load settings",
        "user_guide.offers.checklist.load_error.description": "Try again from offer settings.",
        "user_guide.offers.section.workflow.title": "Workflow",
        "user_guide.offers.section.workflow.p1":
          "Revisions add internal review and approval before sending. Checklist is a separate tab for quality control.",
        "user_guide.offers.section.workflow.p2":
          "“Require checklist before send” should only be turned on once checklists are actually in use, or sending will be blocked.",
        "user_guide.offers.section.calculation.title": "Calculation",
        "user_guide.offers.section.calculation.p1":
          "The calculation is internal estimating (cost, hours, markup and margin). Offer lines are what the customer sees.",
        "user_guide.offers.section.calculation.li1":
          "Calculation v2 gives more accurate totals in overview and the header.",
        "user_guide.offers.section.calculation.li2":
          "Hours lines: fill in hours and hourly rate (not only quantity) so total hours and labour cost are correct.",
        "user_guide.offers.section.calculation.li3":
          "Structure groups on the left are chapters. Hover a name to see the full title.",
        "user_guide.offers.section.document.title": "Document and reservations",
        "user_guide.offers.section.document.p1":
          "The document builder is used for text blocks in the offer itself. Reservations belong as a text block under Document — that is the recommended customer-facing placement.",
        "user_guide.offers.section.related.title": "Useful shortcuts",
        "user_guide.offers.section.related.link_list": "Offer list",
        "user_guide.offers.section.related.link_settings": "Offer settings",
        "user_guide.hub.card.drawings.title": "Drawings, houses and floors",
        "user_guide.hub.card.drawings.description":
          "Pick a project, create houses and floors, and upload PDF drawings.",
        "user_guide.hub.footer_note": "Need more answers? Try the Resource hub FAQ.",


        "user_guide.drawings.back_to_hub": "Back to user guide",
        "user_guide.drawings.badge": "Drawings",
        "user_guide.drawings.title": "Drawings, houses and floors",
        "user_guide.drawings.purpose":
          "How to set up houses and floors in a project and upload PDF drawings. Drawings always belong to a project. One drawing is one PDF page.",
        "user_guide.drawings.open_module": "Open Drawings",
        "user_guide.drawings.section.project.title": "1. Open Drawings and pick a project",
        "user_guide.drawings.section.project.li1": "Go to Drawings in the left menu.",
        "user_guide.drawings.section.project.li2":
          "Select the project you will work on (search by number, name or client if the list is long).",
        "user_guide.drawings.section.project.li3":
          "The selected project is remembered for the session. Use Switch in the header to change project.",
        "user_guide.drawings.section.project.shot": "Pick a project before working with drawings",
        "user_guide.drawings.section.list.title": "2. The drawings list",
        "user_guide.drawings.section.list.p1":
          "When a project is selected, structure (houses and floors) is on the left and drawings on the right.",
        "user_guide.drawings.section.list.li1": "Manage structure — show delete and add controls in the tree",
        "user_guide.drawings.section.list.li2": "+ New drawing — open the upload drawer",
        "user_guide.drawings.section.list.li3": "+ House in the structure panel — create a house",
        "user_guide.drawings.section.list.shot": "Drawings list with structure panel",
        "user_guide.drawings.section.house.title": "3. Add a house",
        "user_guide.drawings.section.house.li1": "Click + House at the top of the structure panel.",
        "user_guide.drawings.section.house.li2": "Enter a house name, for example House A or Building 2.",
        "user_guide.drawings.section.house.li3": "Click Add.",
        "user_guide.drawings.section.house.shot": "Field for adding a house",
        "user_guide.drawings.section.floor.title": "4. Add floors",
        "user_guide.drawings.section.floor.li1": "Click the house in the tree to expand it.",
        "user_guide.drawings.section.floor.li2": "Click + Floor under the house.",
        "user_guide.drawings.section.floor.li3": "Enter a floor name, for example 1st floor or 2.",
        "user_guide.drawings.section.floor.li4": "Click Add.",
        "user_guide.drawings.section.floor.li5": "Repeat for more floors.",
        "user_guide.drawings.section.floor.p1":
          "Colour dots in the tree show drawing type (architecture, ventilation, kitchen, other).",
        "user_guide.drawings.section.floor.shot": "Field for adding a floor under a house",
        "user_guide.drawings.section.floor.shot_tree": "Structure with houses and floors",
        "user_guide.drawings.section.upload.title": "5. Upload a drawing",
        "user_guide.drawings.section.upload.li1": "Select the floor in the structure (house and floor are then prefilled).",
        "user_guide.drawings.section.upload.li2": "Click + New drawing (or Add drawing here).",
        "user_guide.drawings.section.upload.li3": "Drop the PDF on the field, or click Choose file.",
        "user_guide.drawings.section.upload.li4":
          "If the PDF has several pages: go to the correct page and confirm Use page N. Promang stores one page per drawing.",
        "user_guide.drawings.section.upload.li5": "Check Title (may be read from the file name).",
        "user_guide.drawings.section.upload.li6":
          "Choose Drawing type (architecture, ventilation, kitchen or other).",
        "user_guide.drawings.section.upload.li7":
          "Check Location (house and floor). Use Other if the drawing does not belong to a floor.",
        "user_guide.drawings.section.upload.li8": "Click Create drawing.",
        "user_guide.drawings.section.upload.shot_empty": "New drawing drawer before upload",
        "user_guide.drawings.section.upload.shot_filled": "New drawing with PDF, type and floor filled in",
        "user_guide.drawings.section.done.title": "6. Done",
        "user_guide.drawings.section.done.p1":
          "The drawing appears as a card in the list, linked to house and floor. Click the card to open the viewer (measure, markup, deviations and checklists).",
        "user_guide.drawings.section.done.shot": "Drawings list with an uploaded drawing",
        "user_guide.drawings.section.rules.title": "Rules to remember",
        "user_guide.drawings.section.rules.li1": "Drawings always belong to a project.",
        "user_guide.drawings.section.rules.li2": "One drawing = one PDF page.",
        "user_guide.drawings.section.rules.li3":
          "The same floor and same type can only have one drawing. Uploading a duplicate asks for confirmation before replace.",
        "user_guide.drawings.section.rules.li4": "Drawings without a floor go under Other.",

        "ai_skills.badge": "AI",
        "ai_skills.page_title": "AI skills",
        "ai_skills.subtitle":
          "Training and guidelines for using AI in Promang — available to all signed-in users.",
        "ai_skills.back_to_user_guide": "Back to user guide",
        "ai_skills.nav_label": "AI skills",
        "ai_skills.skill_badge": "Skill",
        "ai_skills.skill_badge_hint": "Structured playbook for AI and people",
        "ai_skills.loading": "Loading…",
        "ai_skills.load_error": "Could not load document",
        "ai_skills.nav.overview": "Overview",
        "ai_skills.nav.prompting_basics": "Prompting basics",
        "ai_skills.nav.promang_ai_generator": "In-app AI generator",
        "ai_skills.nav.microsoft_mail_ai": "Microsoft mail AI",
        "ai_skills.nav.guide_flow_ai": "Guide flow & AI",
        "ai_skills.nav.cursor_for_promang": "Cursor for developers",
        "ai_skills.hub_card.title": "AI skills — training",
        "ai_skills.hub_card.description":
          "How to use AI safely in Promang: prompting, generator, mail, and guides.",
        "ai_skills.nav.agent_integrations": "Agent — data models (overview)",
        "ai_skills.nav.agent_product": "Agent — product",
        "ai_skills.nav.agent_customer": "Agent — customer",
        "ai_skills.nav.agent_project": "Agent — project",
        "ai_skills.nav.agent_case": "Agent — case & timeline",
        "ai_skills.nav.agent_tasks": "Agent — tasks (todos)",
        "ai_skills.nav.agent_hse_document": "Agent — HSE document",
        "ai_skills.nav.agent_meeting_minutes": "Meeting minutes — AI",

        "dashboard.company_guide.hours_teaser_title": "Hours and absence",
        "dashboard.company_guide.hours_teaser_subtitle":
          "Setup status and the full guide are on the user guide — not on the home page.",
        "dashboard.company_guide.hours_teaser_cta": "Open status and guide",

        "user_guide.hours.back_to_hub": "Back to user guide",
        "user_guide.hours.checklist.badge": "Getting started",
        "user_guide.hours.checklist.heading": "Setup status (Hours module)",
        "user_guide.hours.checklist.subtitle":
          "Visible to admins only. Each row links to settings or to more detail further down this page.",
        "user_guide.hours.badge": "Hours and absence",
        "user_guide.hours.title": "Hours, absence and work schedule",
        "user_guide.hours.purpose":
          "This guide helps new companies and admins set up absence, ownership and work schedules. The checklist on the home page (admins only) links here for detail.",

        "user_guide.hours.section.registration.title": "Time entry in Promang",
        "user_guide.hours.section.registration.p1":
          "Project hours should be linked to a project and a project activity line. That is what drives time entry in the product.",
        "user_guide.hours.section.registration.p2":
          "Legacy Activity and ActivityItem are used in the background for accounting systems (for example Tripletex sync). They are not what you normally pick when logging hours in the UI.",
        "user_guide.hours.section.registration.p3":
          "“General activity” lists under Hours → Settings can be used for admin maintenance, but they are not a separate onboarding requirement on the dashboard checklist.",

        "user_guide.hours.section.visibility.title": "Who sees what?",
        "user_guide.hours.section.visibility.li1":
          "On the home page, only a short link is shown to admins when Hours is on. Full status and the checklist live here on the user guide.",
        "user_guide.hours.section.visibility.li2":
          "Everyone who can open Hours → Settings sees the short help panel at the top of that page.",

        "user_guide.hours.section.steps.title": "Recommended order",
        "user_guide.hours.section.steps.s1.title": "1. Absence types",
        "user_guide.hours.section.steps.s1.where": "Go to Hours → Settings → Absence types.",
        "user_guide.hours.section.steps.s1.b1":
          "Create types that fit your company: vacation, sick leave, self-reported absence, time off in lieu, leave, and so on.",
        "user_guide.hours.section.steps.s1.b2":
          "Absence is registered against these types. Who approves self-reported absence depends on roles and who you set as absence handler.",

        "user_guide.hours.section.steps.s2.title": "2. Hours and absence ownership",
        "user_guide.hours.section.steps.s2.where": "Go to Hours → Settings → Hours and absence handling.",
        "user_guide.hours.section.steps.s2.b1":
          "Hours: choose who should approve timesheets and follow up discrepancies.",
        "user_guide.hours.section.steps.s2.b2":
          "Self-reported absence: choose who processes self-reported absence (often HR or the line manager).",
        "user_guide.hours.section.steps.s2.b3": "Set both early so employees know who follows up.",

        "user_guide.hours.section.steps.s3.title": "3. Payroll period lock (optional)",
        "user_guide.hours.section.steps.s3.where": "Go to Hours → Settings → Payroll period lock.",
        "user_guide.hours.section.steps.s3.b1":
          "When routines are in place you can lock the month at period end and set payout day to match payroll.",
        "user_guide.hours.section.steps.s3.b2":
          "Locked periods limit backdated changes; exceptions are handled by users with unlock rights where enabled.",

        "user_guide.hours.section.steps.s4.title": "4. Hour reminders (optional)",
        "user_guide.hours.section.steps.s4.where": "Go to Hours → Settings → Hour reminders.",
        "user_guide.hours.section.steps.s4.b1": "Turn on daily reminders and set times if you want nudges to log hours.",
        "user_guide.hours.section.steps.s4.b2":
          "Outgoing email must be configured in operations (scheduled jobs) — check with your admin or vendor whether this is active.",

        "user_guide.hours.section.steps.s5.title": "5. Work schedule and FTE",
        "user_guide.hours.section.steps.s5.where": "Use Schedule and user profiles under Users.",
        "user_guide.hours.section.steps.s5.b1":
          "Each employee should have a work schedule that matches their position — it affects expected time and planning.",
        "user_guide.hours.section.steps.s5.b2": "Calendar views and absence follow-up assume this is in place.",

        "user_guide.hours.section.public_holidays.title": "Public holidays and normal time",
        "user_guide.hours.section.public_holidays.p1":
          "Promang automatically recognises Norwegian public holidays (e.g. 1 May, 17 May, Easter). On those days, expected working hours are normally 0 for employees with a Mon–Fri work schedule.",
        "user_guide.hours.section.public_holidays.p2":
          "You can still register hours on a public holiday when work was actually performed — the form shows an informational notice but does not block saving.",
        "user_guide.hours.section.public_holidays.li1":
          "Hour registration: blue notice with the holiday name when the date is a public holiday.",
        "user_guide.hours.section.public_holidays.li2":
          "Monthly overview: normal time is shown net of public holidays and registered absence.",
        "user_guide.hours.section.public_holidays.li3":
          "Absence: cannot be registered on public holidays (the form blocks those dates).",
        "user_guide.hours.section.public_holidays.li4":
          "Work schedule and calendar show which days are public holidays in the year.",

        "user_guide.hours.section.related.title": "Useful shortcuts",
        "user_guide.hours.section.related.link_hours": "Hour list",
        "user_guide.hours.section.related.link_approval": "Hours approval",
        "user_guide.hours.section.related.link_absence": "Absence overview",
        "user_guide.hours.section.related.link_monthly": "Monthly hours overview",
        "user_guide.hours.section.related.link_work_schedule": "My work schedule (public holidays)",
        "user_guide.hours.section.related.link_settings": "Hours settings",

        "user_guide.hours.section.more_help.title": "More help",
        "user_guide.hours.section.more_help.p1":
          "If something is not covered here, the Resource hub FAQ or support can help further.",
        "user_guide.hours.section.more_help.faq_link": "Open FAQ in the Resource hub",

        "Time Registration": "Time Registration",
        "Registered hours": "Registered hours",
        "Close": "Close",
        "Saving": "Saving",
        "Save": "Save",
        "Error saving changes": "Error saving changes",
        "Changes saved successfully": "Changes saved successfully",
        "You have unsaved changes": "You have unsaved changes",
        "Could not save": "Could not save",
        "Hours Overview": "Hours Overview",
        "Track and manage work hours": "Track and manage work hours",
        "Select Employee": "Select Employee",
  
        // Work Statistics translations
        "Work Statistics": "Work Statistics",
        "Overview of your work hours and performance":
          "Overview of your work hours and performance",
        "Something went wrong while loading work stats":
          "Something went wrong while loading work stats",
        "Could not load work statistics": "Could not load work statistics",
        "No data available": "No data available",
        "No work statistics found for this user.":
          "No work statistics found for this user.",
        "Expected This Week": "Expected This Week",
        "Worked This Week": "Worked This Week",
        "Worked This Month": "Worked This Month",
        "Earned Time Off": "Earned Time Off",
        "Weekly Progress": "Weekly Progress",
        "Hours worked this week": "Hours worked this week",
        "Remaining": "Remaining",
        "Overtime": "Overtime",
        "Weekly Goal": "Weekly Goal",
        "Completed": "Completed",
        "In Progress": "In Progress",
        "Status": "Status",
        "Under Target": "Under Target",
        "On Track": "On Track",
        "Efficiency": "Efficiency",
  
        // Vehicle translations
        "Vehicle handbook": "Vehicle handbook",
        "Check in to a vehicle to open its handbook from this menu.":
          "Check in to a vehicle to open its handbook from this menu.",
        "Vehicle handbook could not be opened. Try again or contact an administrator.":
          "Vehicle handbook could not be opened. Try again or contact an administrator.",
        "Go to trips": "Go to trips",
        "Vehicle handbook entry subtitle":
          "Check in, then open the handbook for your current vehicle.",
        "Vehicle handbook check in": "Check in to vehicle",
        "Vehicle handbook check in hint":
          "Choose a vehicle to check in; you are then taken to its handbook.",
        "Vehicle handbook not a driver":
          "You are not registered as a driver in this company. Ask an administrator if you need driving access.",
        "Vehicle handbook no vehicles permission":
          "You need permission to use the vehicle list to check in from here. You may still check in from Trips or the dashboard if available.",
        "Vehicle Information": "Vehicle Information",
        "Number Plate": "Number Plate",
        "VIN (Chassis Number)": "VIN (Chassis Number)",
        "Make": "Make",
        "Model": "Model",
        "Model Year": "Model Year",
        "Body Style": "Body Style",
        "Nickname": "Nickname",
        "Current Odometer (km)": "Current Odometer (km)",
        "Description": "Description",
        "Statens Vegvesen Information": "Statens Vegvesen Information",
        "Norwegian Vehicle Authority Information":
          "Norwegian Vehicle Authority Information",
        "Registration Date": "Registration Date",
        "First Registration": "First Registration",
        "Vehicle Type": "Vehicle Type",
        "Fuel Type": "Fuel Type",
        "Engine Size (cc)": "Engine Size (cc)",
        "Power (kW)": "Power (kW)",
        "Inspection Information": "Inspection Information",
        "EU-kontroll / Periodic Vehicle Inspection":
          "EU-kontroll / Periodic Vehicle Inspection",
        "Last Inspection Date": "Last Inspection Date",
        "Next Inspection Date": "Next Inspection Date",
        "Inspection Result": "Inspection Result",
        "Inspection Station": "Inspection Station",
        "Insurance Information": "Insurance Information",
        "Vehicle Insurance Details": "Vehicle Insurance Details",
        "Insurance Company": "Insurance Company",
        "Policy Number": "Policy Number",
        "Insurance Start Date": "Insurance Start Date",
        "Insurance End Date": "Insurance End Date",
        "Insurance Type": "Insurance Type",
        "Annual Premium (NOK)": "Annual Premium (NOK)",
        "Service Information": "Service Information",
        "Maintenance and Service Details": "Maintenance and Service Details",
        "Last Service Date": "Last Service Date",
        "Next Service Date": "Next Service Date",
        "Service Interval (km)": "Service Interval (km)",
        "Service Provider": "Service Provider",
        "Warranty End Date": "Warranty End Date",
        "Warranty Type": "Warranty Type",
        "Damage Reports": "Damage Reports",
        "Vehicle Damage History": "Vehicle Damage History",
        "Damage reports will be implemented in the future":
          "Damage reports will be implemented in the future",
        "Internal Controls": "Internal Controls",
        "Company Internal Vehicle Controls": "Company Internal Vehicle Controls",
        "Last Internal Check": "Last Internal Check",
        "Next Internal Check": "Next Internal Check",
        "Safety Equipment Status": "Safety Equipment Status",
        "Vehicle Status": "Vehicle Status",
        "Trips": "Trips",
        "Service": "Service",
        "Documents": "Documents",
        "Vehicle": "Vehicle",
        "Vehicle Documents": "Vehicle Documents",
        "Manage vehicle documents and files":
          "Manage vehicle documents and files",
        "Vehicle Trips": "Vehicle Trips",
        "vehicle.trips_stats.title": "Trip & mileage statistics",
        "vehicle.trips_stats.subtitle": "Distance driven based on registered trips for this vehicle",
        "vehicle.trips_stats.trip_count": "Number of trips",
        "vehicle.trips_stats.total_distance": "Total distance driven",
        "vehicle.trips_stats.this_month": "Mileage this month",
        "vehicle.trips_stats.this_year": "Mileage this year",
        "vehicle.trips_stats.last_year": "Mileage last year",
        "vehicle.trips_stats.estimated_this_year": "Estimated mileage this year",
        "vehicle.trips_stats.today": "Today",
        "vehicle.trips_stats.this_week": "This week",
        "trips found": "trips found",
        "No trips found for this vehicle": "No trips found for this vehicle",
        "Vehicle safety and maintenance checklists":
          "Vehicle safety and maintenance checklists",
        "Create Checklist": "Create Checklist",
        "Last Internal Control": "Last Internal Control",
        "Checklist Number": "Checklist Number",
        "Items Approved": "Items Approved",
        "Checklist Items": "Checklist Items",
        "Approved": "Approved",
        "Not Approved": "Not Approved",
        "No checklists found": "No checklists found",
        "Get started by creating a new checklist":
          "Get started by creating a new checklist",
        "Select Checklist Type": "Select Checklist Type",
        "Choose the type of checklist you want to create for this vehicle":
          "Choose the type of checklist you want to create for this vehicle",
        "Create a new checklist for this project":
          "Create a new checklist for this project",
        "Choose the type of checklist you want to create for this project":
          "Choose the type of checklist you want to create for this project",
        "Project checklist title": "Project checklist #{{number}}{{suffix}}",
        "Customer checklist title": "Customer checklist #{{number}}{{suffix}}",
        "Folder checklist title": "Folder checklist #{{number}}{{suffix}}",
        "Generic new checklist title": "Checklist #{{number}} ({{date}})",
        "Report checklist default title": "Report {{number}} - {{address}}",
        "Choose the type of checklist you want to create for this report":
          "Choose the type of checklist you want to create for this report",
        "Choose the type of checklist you want to create for this folder":
          "Choose the type of checklist you want to create for this folder",
        "Choose the type of checklist you want to create for this customer":
          "Choose the type of checklist you want to create for this customer",
        "Choose the type of checklist you want to create":
          "Choose the type of checklist you want to create",
        "Checklist title placeholder": "Enter a title for the checklist",
        "Checklist title edit hint":
          "Suggested automatically — change the title if you want before choosing a type.",
        "Title": "Title",
        "Enter checklist title": "Enter checklist title",
        "No checklist types available": "No checklist types available",
        "items": "items",
        "Basic Information": "Basic Information",
        "Enter checklist basic details": "Enter checklist basic details",
        "Define checklist items and requirements":
          "Define checklist items and requirements",
        "Upload required documents": "Upload required documents",
        "Review & Create": "Review & Create",
        "Review and create the checklist": "Review and create the checklist",
        "Title is required": "Title is required",
        "Description is required": "Description is required",
        "Date is required": "Date is required",
        "Item title is required": "Item title is required",
        "At least one item is required": "At least one item is required",
        "Please fix the errors before continuing":
          "Please fix the errors before continuing",
        "Create New Checklist": "Create New Checklist",
        "Checklist Summary": "Checklist Summary",
        "Items Count": "Items Count",
        "Not specified": "Not specified",
        "Mark as finished": "Mark as finished",
        "Mark as approved": "Mark as approved",
        "Previous": "Previous",
        "Show all": "Show all",
        "Show in new tab": "Show in new tab",
  
        // Journal translations
        "journal": "Journal",
        "journal.title": "Journal Title",
        "journal.description": "Journal Description",
        "journal.date": "Journal Date",
        "journal.next_follow_up": "Next Follow-up Date",
        "journal.status": "Journal Status",
        "journal.create": "Create Journal Entry",
        "journal.update": "Update Journal Entry",
        "journal.delete": "Delete Journal Entry",
        "journal.entries": "Journal Entries",
        "journal.no_entries": "No journal entries found",
        "journal.add_entry": "Add Journal Entry",
        "journal.edit_entry": "Edit Journal Entry",
        "journal.entry_created": "Journal entry created successfully",
        "journal.entry_updated": "Journal entry updated successfully",
        "journal.entry_deleted": "Journal entry deleted successfully",
        "journal.follow_up_reminder": "Follow-up Reminder",
        "journal.service_documentation": "Service Documentation",
        "journal.calibration_record": "Calibration Record",
        "journal.repair_record": "Repair Record",
        "journal.maintenance_record": "Maintenance Record",
  
        // Tool translations
        "tool": "Tool",
        "tools": "Tools",
        "tool.title": "Tool Title",
        "tool.number": "Tool Number",
        "tool.description": "Tool Description",
        "tool.status": "Tool Status",
        "tool.category": "Tool Category",
        "tool.brand": "Tool Brand",
        "tool.model": "Tool Model",
        "tool.serial_number": "Serial Number",
        "tool.purchase_date": "Purchase Date",
        "tool.purchase_price": "Purchase Price",
        "tool.supplier.label": "Purchased from (supplier)",
        "tool.supplier.placeholder": "Select supplier",
        "tool.supplier.select_one": "Select supplier",
        "tool.supplier.select_multiple": "Select suppliers",
        "tool.supplier.search_placeholder": "Search suppliers…",
        "tool.supplier.empty": "No suppliers found. Try another search.",
        "tool.supplier.load_more": "Load more",
        "tool.supplier.clear": "Clear selection",
        "tool.supplier.load_error": "Could not load suppliers",
        "tool.supplier.selected_count": "{{count}} selected",
        "tool.service_interval": "Service Interval (days)",
        "tool.last_service": "Last Service",
        "tool.next_service": "Next Service",
        "tool.service_overdue": "Service Overdue",
        "tool.service_due_soon": "Service Due Soon",
        "tool.create": "Create Tool",
        "tool.update": "Update Tool",
        "tool.delete": "Delete Tool",
        "tool.overview": "Tool Overview",
        "tool.manage_tools": "Manage Tools",
        "tool.no_tools": "No tools found",
        "tool.add_tool": "Add Tool",
        "tool.edit_tool": "Edit Tool",
        "tool.tool_created": "Tool created successfully",
        "tool.tool_updated": "Tool updated successfully",
        "tool.tool_deleted": "Tool deleted successfully",
        "tool.service_overview": "Service Overview",
        "tool.upcoming_services": "Upcoming Services",
        "tool.overdue_services": "Overdue Services",
        "tool.total_tools": "Total Tools",
        "tool.active_tools": "Active Tools",
        "tool.quick_row_label": "—",
        "tool.quick_new": "New",
        "tool.quick_add_placeholder": "Title — press Tab or Enter to save",
        "tool.next_number_hint_title": "Next suggested tool number for new rows",
        "tool.quick_add_tab_hint": "Tab / Enter",
        "tool.active_column": "Active",
        "tool.assign_short": "Assign",
        "tool.duplicate": "Copy",
        "tool.duplicate_created": "Tool copied",
        "tool.number_auto_placeholder": "Next: {{next}} (leave empty to auto-assign)",
  
        // Tool Category translations
        "tool.categories": "Tool Categories",
        "tool.category.name": "Category Name",
        "tool.category.description": "Category Description",
        "tool.category.create": "Create Tool Category",
        "tool.category.update": "Update Tool Category",
        "tool.category.delete": "Delete Tool Category",
        "tool.category.no_categories": "No tool categories found",
        "tool.category.add_category": "Add Tool Category",
        "tool.category.edit_category": "Edit Tool Category",
        "tool.category.created": "Tool category created successfully",
        "tool.category.updated": "Tool category updated successfully",
        "tool.category.deleted": "Tool category deleted successfully",
        "tool.category.manage_title": "Tool categories",
        "tool.category.all_categories": "All categories",
        "tool.category.new_category": "New",
        "tool.category.delete_confirm": "Delete this category?",
        "tool.category.delete_confirm_with_tools":
          "This category is linked to {{count}} tool(s). Delete anyway?",
        "tool.category.delete_failed": "Could not delete the category",
        "tool.category.tools_count": "{{count}} tools",
  
        // Tool Brand translations
        "tool.brands": "Tool Brands",
        "tool.brand.name": "Brand Name",
        "tool.brand.description": "Brand Description",
        "tool.brand.create": "Create Tool Brand",
        "tool.brand.update": "Update Tool Brand",
        "tool.brand.delete": "Delete Tool Brand",
        "tool.brand.no_brands": "No tool brands found",
        "tool.brand.add_brand": "Add Tool Brand",
        "tool.brand.edit_brand": "Edit Tool Brand",
        "tool.brand.created": "Tool brand created successfully",
        "tool.brand.updated": "Tool brand updated successfully",
        "tool.brand.deleted": "Tool brand deleted successfully",
        "tool.brand.manage_title": "Tool brands",
        "tool.brand.all_brands": "All brands",
        "tool.brand.new_brand": "New",
        "tool.brand.delete_confirm": "Delete this brand?",
        "tool.brand.delete_confirm_with_tools":
          "This brand is linked to {{count}} tool(s). Delete anyway?",
        "tool.brand.delete_failed": "Could not delete the brand",
        "tool.brand.tools_count": "{{count}} tools",
        "tool.open": "Open",
        "tool.back_to_overview": "Back to tools",
        "tool.assigned_user_column": "Assigned to",
        "tool.assignment_heading": "Assignment",
        "tool.assignment_hint":
          "Assign this tool to an employee, or return it to stock (unassign).",
        "tool.assigned_to": "Assigned to",
        "tool.not_assigned": "Not assigned",
        "tool.assign_user": "Assign to user",
        "tool.reassign_user": "Change assignee",
        "tool.return_from_user": "Return (unassign)",
        "tool.assign_saved": "Assignment updated",
        "tool.return_saved": "Tool returned (unassigned)",
        "tool.notes_heading": "Tool notes",
        "tool.notes_hint":
          "Internal notes about this tool (not shown on journal/service list).",
        "tool.notes_placeholder": "Write notes…",
        "tool.save_notes": "Save notes",
        "tool.notes_saved": "Notes saved",
        "tool.completed_service_intervals": "Completed service intervals",
        "tool.completed_service_intervals_hint":
          "Journal entries marked completed with “service” in the title (same rule as next service calculation).",
        "tool.no_completed_service_intervals":
          "No completed service intervals recorded yet.",
        "tool.journal_other_hint":
          "Other journal entries (active, planned follow-ups, non-service, etc.).",
        "tool.journal_empty_hint": "Add a journal entry for service or notes.",
        "tool.journal_no_other_entries": "No other journal entries.",
        "tool.print_label": "Print sign / label",
        "tool.usage_history_heading": "Assignment history",
        "tool.usage_history_hint":
          "Who had the tool, for how many days (calendar days, inclusive), and whether the period ended with a return or a handover to another user.",
        "tool.usage_history_empty": "No history yet. History is recorded when you assign, reassign, or return the tool.",
        "tool.usage_user": "User",
        "tool.usage_from": "From",
        "tool.usage_to": "To",
        "tool.usage_days": "Days",
        "tool.usage_outcome": "How it ended",
        "tool.usage_status": "Status",
        "tool.usage_status_active": "Active loan",
        "tool.usage_status_ended": "Ended",
        "tool.usage_reason.return": "Returned (unassigned)",
        "tool.usage_reason.reassign": "Handed to another user",
        "tool.employee_tools_title": "Tools",
        "tool.employee_tools_intro_title": "Your assigned tools",
        "tool.employee_tools_intro":
          "A simple overview of tools registered to you, including assignment date and key details.",
        "tool.employee_tools_short": "Your assigned tools.",
        "tool.employee_tools_loading": "Loading tools...",
        "tool.employee_tools_load_error": "Could not load tools.",
        "tool.employee_tools_empty_title": "No assigned tools",
        "tool.employee_tools_empty": "No tools are registered to you.",
        "tool.employee_tools_assigned_on": "Taken into use",
        "tool.employee_tools_unknown_date": "Unknown date",
        "tool.employee_tools_no_service": "No planned service",
        "tool.employee_tools_days_held": "{{count}} days in use",
  
        // Tool Status translations
        "tool.status.active": "Active",
        "tool.status.inactive": "Inactive",
        "tool.status.maintenance": "Under Maintenance",
        "tool.status.retired": "Retired",
  
        // Journal Status translations
        "journal.status.active": "Active",
        "journal.status.completed": "Completed",
        "journal.status.archived": "Archived",

        // Standalone documentation journals
        "journal.page_title": "Journals",
        "journal.journals": "Journals",
        "journal.hero_subtitle":
          "Create multiple journals to document employees, customers, projects or standalone.",
        "journal.all_journals": "All journals",
        "journal.all_journals_subtitle": "All journals in the company.",
        "journal.section_subtitle": "Documentation with text and images.",
        "journal.new_journal": "New journal",
        "journal.no_journals": "No journals yet",
        "journal.no_journals_hint": "Create a journal to start documenting.",
        "journal.color": "Color",
        "journal.new_entry": "New entry",
        "journal.entry_placeholder": "Write an entry… (text and images)",
        "journal.entry_added": "Entry added",
        "journal.entry_save_failed": "Could not save the entry",
        "journal.entry_delete_confirm": "Delete this entry?",
        "journal.unknown_author": "Unknown",
        "journal.pin": "Pin",
        "journal.unpin": "Unpin",
        "journal.save_failed": "Could not save the journal",
        "journal.print": "Print",
        "journal.printing": "Generating…",
        "journal.print_failed": "Could not generate PDF",
        "journal.search_placeholder": "Search journals…",
        "journal.documentation.no_entries": "No entries.",

        // Text documents (letters / agreements)
        "textDocuments.title": "Documents",
        "textDocuments.new": "New document",
        "textDocuments.create": "Create",
        "textDocuments.edit": "Edit document",
        "textDocuments.untitled": "Untitled",
        "textDocuments.title_placeholder": "E.g. Termination, Agreement, Information letter…",
        "textDocuments.template": "Template",
        "textDocuments.template_hint": "Pick an existing template as a starting point (optional).",
        "textDocuments.choose_template": "Choose template",
        "textDocuments.change_template": "Change",
        "textDocuments.remove_template": "Remove template",
        "textDocuments.hero_subtitle":
          "Create letters, agreements and termination notices. Configure signers for printing and Posten digital signing.",
        "textDocuments.search_placeholder": "Search documents…",
        "textDocuments.empty": "No documents yet.",
        "textDocuments.standalone": "Standalone",
        "textDocuments.section_subtitle": "Letters, agreements and other documents.",
        "textDocuments.status.draft": "Draft",
        "textDocuments.status.final": "Final",
        "textDocuments.include_signature": "Include signature fields when printing",
        "textDocuments.editor_placeholder": "Write the document here…",
        "textDocuments.print": "Print",
        "textDocuments.save_failed": "Could not save the document",
        "textDocuments.save_before_print": "Save the document before printing",
        "textDocuments.print_failed": "Could not generate PDF",
        "textDocuments.signing": "Digital signing",
        "textDocuments.signature.signers": "Signers",
        "textDocuments.signature.signers_hint":
          "Add who should sign. Pick an employee to auto-fill name, job title and national ID for Posten signing. Otherwise enter national ID or both email and mobile.",
        "textDocuments.signature.select_employee": "Select employee",
        "textDocuments.signature.manual_entry": "Enter manually",
        "textDocuments.signature.loading_employee": "Loading employee details…",
        "textDocuments.signature.employee_posten_hint":
          "National ID, email and mobile are read from employment when sending to Posten Signering.",
        "textDocuments.signature.employee_linked": "Employee selected – identity is resolved from employment",
        "textDocuments.signature.signing_requires_signers":
          "Enable “Include signature fields when printing” and add at least one signer to send via Posten.",
        "textDocuments.signature.signing_uses_configured_signers":
          "The following signers from the document will be sent to Posten Signering:",
        "textDocuments.signature.signing_missing_identity":
          "Each signer must be a selected employee, have a national ID, or have both email and mobile.",
        "textDocuments.signature.name": "Name",
        "textDocuments.signature.name_placeholder": "E.g. John Smith",
        "textDocuments.signature.job_title": "Job title",
        "textDocuments.signature.job_title_placeholder": "E.g. Managing director",
        "textDocuments.signature.field_label": "Field label",
        "textDocuments.signature.field_label_placeholder": "E.g. Signature / Place and date",
        "textDocuments.signature.national_identity_number": "National ID / D-number",
        "textDocuments.signature.national_identity_number_placeholder": "11 digits",
        "textDocuments.signature.email": "Email",
        "textDocuments.signature.email_placeholder": "name@company.com",
        "textDocuments.signature.mobile": "Mobile",
        "textDocuments.signature.mobile_placeholder": "+47 900 00 000",
        "textDocuments.signature.add_signer": "Add signer",
        "textDocuments.signature.remove_signer": "Remove signer",

        // Subject link filters (journals + text documents)
        "subjectLinkFilter.module": "Module",
        "subjectLinkFilter.all_modules": "All modules",
        "subjectLinkFilter.all_statuses": "All statuses",
        "subjectLinkFilter.clear_entity": "Clear selection",
        "subjectLinkFilter.search_placeholder": "Search…",
        "subjectLinkFilter.select_user": "Select employee",
        "subjectLinkFilter.select_customer": "Select customer",
        "subjectLinkFilter.select_project": "Select project",
        "subjectLinkFilter.types.standalone": "Standalone",
        "subjectLinkFilter.types.user": "Employees",
        "subjectLinkFilter.types.customer": "Customers",
        "subjectLinkFilter.types.project": "Projects",
        "subjectLinkFilter.types.vehicle": "Vehicles",
        "subjectLinkFilter.types.tool": "Tools",

        // Documentation send (text documents + journals)
        "documentationSend.send_document": "Send document",
        "documentationSend.send_journal": "Send journal",
        "documentationSend.intro": "Send \"{{title}}\" as a PDF by email.",
        "documentationSend.send_to": "Send to",
        "documentationSend.message": "Message",
        "documentationSend.message_placeholder": "Optional message to the recipient…",
        "documentationSend.email_required": "Email is required",
        "documentationSend.invalid_email": "Invalid email address",
        "documentationSend.success_document": "Document sent successfully",
        "documentationSend.success_journal": "Journal sent successfully",
        "documentationSend.failed": "Could not send",
        "documentationSend.history_persist_failed":
          "The email was sent, but the send log could not be saved. Refresh and check history before sending again.",
        "documentationSend.sent_badge": "Sent {{date}}",
        "documentationSend.sent_short": "Sent",
        "documentationSend.not_sent_yet": "Not sent yet.",
        "documentationSend.history_title": "Send log",
        "documentationSend.export_title": "Export PDF",
        "documentationSend.export_intro": "Choose what to include when exporting \"{{title}}\".",
        "documentationSend.export_include_signature": "Include signature fields",
        "documentationSend.export_include_send_log": "Include send log",
        "documentationSend.export_download": "Download PDF",
        "documentationSend.export_send_log_only": "Export send log only",
        "documentationSend.export_send_log": "Export send log",
        "documentationSend.export_failed": "Could not export PDF",
        "documentationSend.export_empty_log": "No deliveries to export yet.",
        "documentationSend.exporting": "Creating PDF…",
        "documentationSend.view_email": "Open in email log",

        "documentForms.templates.title": "Document templates",
        "documentForms.templates.subtitle": "Build fillable document templates with fields, checklists and tables",
        "documentForms.templates.new": "New template",
        "documentForms.templates.edit": "Edit template",
        "documentForms.templates.empty": "No templates found",
        "documentForms.templates.meta": "Template details",
        "documentForms.templates.number_prefix": "Archive prefix",
        "documentForms.templates.number_prefix_placeholder": "e.g. SJA",
        "documentForms.templates.number_prefix_hint": "Used for archive numbering: SJA #1, SJA #2 … Leave empty to use the first word of the title.",
        "documentForms.created_with_reference": "Created {{reference}}",
        "documentForms.templates.editor_hint": "Add blocks and configure fillable fields for users",
        "documentForms.templates.print": "Print template",
        "documentForms.templates.save_before_print": "Save the template before printing",
        "documentForms.forms.title": "Filled documents",
        "documentForms.forms.subtitle": "Documents created from templates",
        "documentForms.forms.empty": "No documents found",
        "documentForms.new": "New document",
        "documentForms.edit": "Edit document",
        "documentForms.create": "Create",
        "documentForms.created": "Document created",
        "documentForms.save_failed": "Could not save document",
        "documentForms.template": "Template",
        "documentForms.choose_template": "Choose template",
        "documentForms.form_title": "Document title",
        "documentForms.search_placeholder": "Search...",
        "documentForms.include_signature": "Include signature block in PDF",
        "documentForms.mark_final": "Mark as final",
        "documentForms.print": "Print / PDF",
        "documentForms.save_before_print": "Save the document before printing",
        "documentForms.print_failed": "Could not generate PDF",
        "documentForms.status.draft": "Draft",
        "documentForms.status.final": "Final",
        "documentForms.table.add_row": "Add row",
        "documentForms.categories.all": "All categories",
        "documentForms.categories.new": "New category",
        "documentForms.categories.name": "Category name",
        "documentForms.categories.description": "Description",
        "documentForms.categories.label": "Category",
        "documentForms.categories.uncategorized": "Uncategorized",
        "documentForms.builder.blocks": "Blocks",
        "documentForms.builder.empty": "No blocks yet",
        "documentForms.builder.empty_hint": "Add blocks from the palette on the left",
        "documentForms.builder.select_block": "Select a block to edit its properties",
        "documentForms.blocks.heading": "Heading",
        "documentForms.blocks.paragraph": "Paragraph",
        "documentForms.blocks.callout": "Callout",
        "documentForms.blocks.divider": "Divider",
        "documentForms.blocks.text_field": "Text field",
        "documentForms.blocks.textarea": "Long text",
        "documentForms.blocks.number": "Number",
        "documentForms.blocks.date": "Date",
        "documentForms.blocks.checkbox": "Checkbox",
        "documentForms.blocks.select": "Dropdown",
        "documentForms.blocks.checklist": "Checklist",
        "documentForms.blocks.table": "Table",
        "documentForms.blocks.signature": "Signature",
        "documentForms.props.level": "Level",
        "documentForms.props.label": "Label",
        "documentForms.props.placeholder": "Placeholder",
        "documentForms.props.required": "Required",
        "documentForms.props.variant": "Variant",
        "documentForms.props.info": "Info",
        "documentForms.props.warning": "Warning",
        "documentForms.props.options": "Options (one per line)",
        "documentForms.props.items": "Checklist items",
        "documentForms.props.add_item": "Add item",
        "documentForms.props.column_label": "Column label",
        "documentForms.props.add_column": "Add column",
        "documentForms.props.allow_add_rows": "Allow adding rows when filling",

        "documentForms.archive.title": "Form archive",
        "documentForms.archive.subtitle": "Submitted and draft forms — grouped by template",
        "documentForms.archive.empty": "No submitted forms in the archive yet",
        "documentForms.archive.stats": "{{forms}} forms in {{templates}} templates",
        "documentForms.archive.count": "{{count}} documents",
        "documentForms.archive.view_for_template": "View archive ({{count}})",
        "documentForms.archive.hse_link": "HMS document",
        "documentForms.archive.clear_filter": "Show all templates",
        "documentForms.archive.unknown_template": "Unknown template",
        "documentForms.hse.title": "HMS document register",
        "documentForms.hse.description": "Register the template as a controlled form (SKJ) in HMS documents. Filled instances stay in the archive.",
        "documentForms.hse.register": "Register in HMS documents",
        "documentForms.hse.registered": "Registered in HMS documents",
        "documentForms.hse.register_failed": "Could not register in HMS",
        "documentForms.hse.save_template_first": "Save the template before registering in HMS",
        "documentForms.hse.open_document": "Open HMS document",
        "documentForms.hse.system_category": "System category (HMS/KS/REG …)",
        "documentForms.hse.category_required": "Select category and chapter for HMS placement",
        "documentForms.hse.update_placement": "Update HMS placement",
        "documentForms.hse.fill_form": "Fill out form",
        "documentForms.hse.fillable_template_title": "Fillable form template",
        "documentForms.hse.fillable_template_description": "This document is linked to a template. Create and fill out a new form — it is saved in the archive.",
        "documentForms.hse.fillable_badge": "Fillable form",
        "documentForms.json.open_dialog": "JSON / AI",
        "documentForms.json.dialog_title": "JSON and AI for document template",
        "documentForms.json.tab_json": "Paste JSON",
        "documentForms.json.tab_ai_guide": "AI instructions",
        "documentForms.json.hint": "Paste JSON from ChatGPT or another AI, or edit the current template. Supports { \"blocks\": [...] } or full template with title and description.",
        "documentForms.json.replace_blocks": "Replace all blocks",
        "documentForms.json.append_blocks": "Append at bottom",
        "documentForms.json.copy_json": "Copy JSON",
        "documentForms.json.reload_from_builder": "Reload from builder",
        "documentForms.json.insert_sample": "Insert sample",
        "documentForms.json.apply": "Apply JSON",
        "documentForms.json.applied": "{{count}} blocks imported",
        "documentForms.json.copy_success": "JSON copied",
        "documentForms.json.reload_success": "JSON reloaded from builder",
        "documentForms.json.clipboard_failed": "Could not copy to clipboard",
        "documentForms.json.ai_guide_intro": "Copy the instructions below into ChatGPT, Claude or another AI. Then paste the JSON response in the Paste JSON tab.",
        "documentForms.json.copy_ai_guide": "Copy AI instructions",
        "documentForms.json.ai_guide_copied": "AI instructions copied",
        "documentForms.json.generate_with_ai": "Generate with AI",
        "documentForms.json.ai_parse_error": "Could not parse AI response as JSON",
        "documentForms.json.ai_apply_success": "{{count}} blocks applied from AI",
        "documentForms.json.error_empty": "JSON field is empty",
        "documentForms.json.error_invalid_json": "Invalid JSON — check syntax",
        "documentForms.json.error_no_blocks_array": "No blocks array found in JSON",
        "documentForms.json.error_no_valid_blocks": "No valid blocks after import",
  
        // Personalhåndbok translations
        "Personalhåndbok": "Personalhåndbok",
        "personalhåndbok.description":
          "Access to company guidelines, safety procedures, and employee information",
        "Open": "Open",
        "HMS Guidelines": "Rutiner",
        "Safety procedures and guidelines": "Safety procedures and guidelines",
        "Instructions": "Retningslinjer",
        "Company policies and procedures": "Company policies and procedures",
        "Instruction Chapters": "Retningslinjer - Kapitler",
        "Chapter": "Kapittel",
        "Create Chapter": "Opprett kapittel",
        "Update Chapter": "Oppdater kapittel",
        "Chapter Number": "Kapittel nummer",
        "Parent Chapter": "Overordnet kapittel",
        "Sub Chapters": "Underkapitler",
        "No chapter number": "Ingen kapittel nummer",
        "Colleagues": "Colleagues",
        "colleague_dialog.subtitle": "Colleague",
        "colleague_dialog.contact_title": "Contact information",
        "colleague_dialog.contact_missing": "No mobile number or email is registered.",
        "colleague_dialog.mobile_work": "Work mobile",
        "colleague_dialog.mobile": "Private mobile",
        "colleague_dialog.email": "Email",
        "colleague_dialog.call": "Call",
        "colleague_dialog.send_email": "Send email",
        "colleague_dialog.department": "Department",
        "colleague_dialog.next_of_kin": "Next of kin",
        "colleague_dialog.employee_number": "Employee number",
        "colleague_dialog.close": "Close",
        "colleague_dialog.relationship.spouse": "Spouse",
        "colleague_dialog.relationship.partner": "Partner",
        "colleague_dialog.relationship.parent": "Parent",
        "colleague_dialog.relationship.child": "Child",
        "colleague_dialog.relationship.sibling": "Sibling",
        "Hei": "Hi",
        "Team overview and contacts": "Team overview and contacts",
        "Recent HMS Guidelines": "Recent HMS Guidelines",
        "Recent Instructions": "Recent Instructions",
        "Recent KS/HMS Documents": "Recent KS/HMS Documents",
        "KS/HMS Documents": "KS/HMS Documents",
        "employee_handbook.pending_read_ack_title":
          "KS/HMS: documents awaiting your confirmation",
        "employee_handbook.pending_read_ack_body":
          "You have {count} document(s) not yet confirmed as read and understood. Open each document to confirm, or use the full HSE/KS view.",
        "employee_handbook.all_documents_acknowledged":
          "You have confirmed all KS/HMS documents available to you (read and understood).",
        "employee_handbook.read_status_acknowledged": "Read and confirmed",
        "employee_handbook.read_status_pending": "Confirmation missing",
        "employee_handbook.read_status_creator_exempt": "Author (exempt)",
        "employee_handbook.go_to_documents_tab": "Go to KS/HMS documents",
        "employee_handbook.forms_tab": "Forms & templates",
        "employee_handbook.forms_tab_mobile": "Forms",
        "employee_handbook.forms_tab_subtitle": "Fillable HMS forms — create and fill out directly without browsing the document tree.",
        "employee_handbook.forms_tab_search": "Search forms or templates…",
        "employee_handbook.forms_tab_empty": "No fillable forms are registered in the employee handbook yet.",
        "employee_handbook.forms_tab_no_results": "No forms match your search.",
        "employee_handbook.forms_tab_info": "More info",
        "employee_handbook.forms_tab_overview_hint": "Tap for quick access",
        "employee_handbook.open_full_document": "Open full page (HSE/KS)",
        "employee_handbook.other_chapter_documents": "Other documents in chapter",
        "employee_handbook.other_chapter_documents_hint":
          "Related routines, customer information or other attachments in the same chapter.",
        "dashboard_report.handbook_read_incomplete":
          "{pending} of {total} KS/HMS documents still need read/understood confirmation.",
        "dashboard_report.handbook_register_absence_subtitle":
          "Register absence and submit for approval.",
        "employee_handbook.stat_line_pending":
          "{count} document(s) still need read/understood confirmation.",
        "Kapitler": "Chapters",
        "Dokumenter uten kapittel": "Documents without chapter",
        "Dokumenter som ikke er tilknyttet noe kapittel": "Documents that are not linked to any chapter",
        "Søk etter dokumenter...": "Search for documents...",
        "Fant {count} dokumenter": "Found {count} documents",
        "Ingen dokumenter funnet": "No documents found",
        "Prøv å endre søkeordene dine": "Try changing your search terms",
        "Laster dokument...": "Loading document...",
        "Ingen innhold tilgjengelig": "No content available",
        "Dokumenter uten bransje": "Documents without discipline",
        "Dokumenter uten kategori": "Documents without category",
        "Dokumenter uten bransje og kategori": "Documents without discipline and category",
        "No chapter": "No chapter",
        "Employee Handbook": "Employee Handbook",
  
        // Action creation dialog
        "deviation.create_action": "Create Action",
        "deviation.saving": "Saving...",
  
        // Action creation dialog
        "deviation.action.create.question": "Do you want to create actions?",
        "deviation.action.create.description":
          "You can create concrete actions with deadline, responsible person and description.",
        "deviation.action.create.yes": "Yes, create action",
        "deviation.action.create.no": "No, not now",
        "deviation.action.notes": "Action notes (optional)",
        "deviation.action.notes.placeholder":
          "Add notes about actions if necessary...",
        "chemical.inventory": "Chemical inventory",
        "chemical.inventory.description": "Manage chemicals and safety data sheets",
        "chemical.inventory.new": "New substance",
        "chemical.inventory.create_with_ai": "Create with AI",
        "chemical.inventory.create_manual": "Fill in manually",
        "chemical.inventory.create_manual_lead": "Enter name, CAS and the other fields yourself.",
        "chemical.inventory.ai_choose_lead": "Upload an FDV or data sheet and AI fills the inventory. You confirm before it is saved.",
        "chemical.inventory.ai_upload_lead": "Drop or choose a PDF (safety data sheet, FDV or product data sheet). Analysis starts automatically.",
        "chemical.inventory.ai_drop_title": "Drop the file here, or click to browse",
        "chemical.inventory.ai_file_too_large": "The file is too large. Maximum size is 20 MB.",
        "chemical.inventory.ai_file_invalid": "Invalid file type. Choose a PDF or image (JPG, PNG).",
        "chemical.inventory.ai_analyzing": "Analysing the document…",
        "chemical.inventory.ai_ready": "Draft from the data sheet is ready. Review the fields before creating.",
        "chemical.inventory.ai_ready_partial": "Analysis succeeded, but name or CAS is missing. Fill those in and review before saving.",
        "chemical.inventory.ai_empty": "Analysis finished, but we could not derive form data from the document. Fill in manually, or try a data sheet with readable text.",
        "chemical.inventory.ai_empty_unreadable": "Analysis finished, but the extracted text was too short or unreadable (often a scanned PDF without OCR). Fill in manually, or upload a data sheet with readable text.",
        "chemical.inventory.ai_failed": "Could not analyse the document. Try another PDF or fill in manually.",
        "chemical.inventory.ai_back": "Back",
        "chemical.inventory.ai_review_hint": "Fields were filled from the uploaded data sheet. Review and save.",
        "chemical.inventory.edit": "Edit substance",
        "chemical.inventory.delete": "Delete substance",
        "chemical.inventory.create": "Create chemical inventory",
        "chemical.inventory.update": "Update chemical inventory",
        "chemical.inventory.search": "Search chemical inventory…",
        "chemical.inventory.no_results": "No substances found",
        "chemical.inventory.add_from_product": "Add from product",
        "chemical.inventory.basic_info": "Basic information",
        "chemical.inventory.safety_info": "Safety information",
        "chemical.inventory.supplier_info": "Supplier information",
        "chemical.inventory.documents": "Documents",
        "chemical.inventory.notes": "Notes",
        "chemical.inventory.history": "History",
        "chemical.inventory.hazard_symbols": "Hazard symbols",
        "chemical.inventory.hms_level": "HSE level",
        "chemical.inventory.cas_number": "CAS number",
        "chemical.inventory.chemical_formula": "Chemical formula",
        "chemical.inventory.molecular_weight": "Molecular weight",
        "chemical.inventory.purity": "Purity",
        "chemical.inventory.physical_state": "Physical state",
        "chemical.inventory.color": "Colour",
        "chemical.inventory.odor": "Odour",
        "chemical.inventory.hazard_statements": "Hazard statements",
        "chemical.inventory.precautionary_statements": "Precautionary statements",
        "chemical.inventory.signal_word": "Signal word",
        "chemical.inventory.first_aid": "First aid",
        "chemical.inventory.personal_protection": "Personal protective equipment",
        "chemical.inventory.version": "Version",
        "chemical.inventory.status": "Status",
        "chemical.inventory.last_review_date": "Last review date",
        "chemical.inventory.next_review_date": "Next review date",
        "chemical.inventory.hms_level.1": "Low risk",
        "chemical.inventory.hms_level.2": "Medium risk",
        "chemical.inventory.hms_level.3": "High risk",
        "chemical.inventory.hms_level.4": "Critical risk",
        "chemical.inventory.status.active": "Active",
        "chemical.inventory.status.inactive": "Inactive",
        "chemical.inventory.status.archived": "Archived",
        "chemical.inventory.document_type.safety_data_sheet": "Safety data sheet",
        "chemical.inventory.load_error": "Could not load chemical inventory",
        "chemical.inventory.sds_attach_error": "The substance was created, but the safety data sheet was not attached. Open it and upload the SDS.",
        "chemical.inventory.deleted": "Chemical inventory was deleted",
        "chemical.inventory.delete_error": "Could not delete chemical inventory",
        "chemical.inventory.delete_confirm": "Are you sure you want to delete this substance?",
        "chemical.inventory.list_subtitle": "Overview of chemicals and substances (ISO 14001, ISO 45001)",
        "chemical.inventory.filters": "Filters",
        "chemical.inventory.filter_by_status": "Filter by status",
        "chemical.inventory.no_brand": "No brand",
        "chemical.inventory.view": "View",
        "chemical.inventory.showing": "Showing",
        "chemical.inventory.of": "of",
        "chemical.inventory.results": "results",
        "chemical.inventory.previous": "Previous",
        "chemical.inventory.next": "Next",
        "chemical.inventory.not_specified": "Not specified",
        "chemical.inventory.review_state.overdue": "Overdue",
        "chemical.inventory.review_state.due_soon": "Due soon",
        "chemical.inventory.review_state.ok": "On track",
        "chemical.inventory.reviewed_by": "Reviewed by",
        "chemical.inventory.open": "Open",
        "chemical.inventory.actions": "Actions",
        "chemical.inventory.pdf": "Download PDF",
        "chemical.inventory.pdf_ready": "PDF downloaded",
        "chemical.inventory.pdf_failed": "Could not download the PDF",
        "chemical.inventory.revisions": "Revisions",
        "chemical.inventory.new_revision": "New revision",
        "chemical.inventory.publish_review": "Publish review",
        "chemical.inventory.change_summary": "Change summary",
        "chemical.inventory.change_summary_required": "Change summary is required",
        "chemical.inventory.revision_created": "New revision created",
        "chemical.inventory.revision_create_error": "Could not create revision",
        "chemical.inventory.review_published": "Review published",
        "chemical.inventory.review_publish_error": "Could not publish review",
        "chemical.inventory.history_empty": "No history yet",
        "chemical.inventory.revision": "Revision",
        "chemical.inventory.revision_line": "Revision {{version}} · next review {{date}}",
        "chemical.inventory.next_review_missing": "not set",
        "chemical.inventory.added_from_product": "Product was added to the chemical inventory",
        "chemical.inventory.add_from_product_error": "Could not add to chemical inventory",
        "chemical.inventory.adding": "Adding…",
        "chemical.inventory.created_for_product": "Chemical inventory created",
        "chemical.inventory.view_details": "View details",
        "chemical.inventory.handbook_card": "Chemicals, hazard symbols and SDS",
        "chemical.inventory.sds_download": "Download safety data sheet",
        "chemical.inventory.sds_missing": "No SDS available",
        "chemical.inventory.risk_tab.register": "Risk register",
        "chemical.inventory.risk_tab.matrix": "Risk matrix",
        "chemical.inventory.risk_tab.sja": "JSA",
        "chemical.inventory.risk_tab.climate": "Climate risk",
        "chemical.inventory.risk_tab.protective": "Safety rounds",
        "chemical.inventory.hazard.category.physical": "Physical hazards",
        "chemical.inventory.hazard.category.health": "Health hazards",
        "chemical.inventory.hazard.category.environmental": "Environmental hazards",
        "chemical.inventory.hazard.explosive": "Explosive",
        "chemical.inventory.hazard.explosive_desc": "May explode from heat, shock, friction or contact with other substances",
        "chemical.inventory.hazard.flammable": "Flammable",
        "chemical.inventory.hazard.flammable_desc": "May ignite from flame, spark, heat or other ignition",
        "chemical.inventory.hazard.oxidizing": "Oxidizing",
        "chemical.inventory.hazard.oxidizing_desc": "May cause or intensify fire in contact with combustible materials",
        "chemical.inventory.hazard.corrosive": "Corrosive",
        "chemical.inventory.hazard.corrosive_desc": "May cause severe burns to skin and eyes",
        "chemical.inventory.hazard.toxic": "Toxic",
        "chemical.inventory.hazard.toxic_desc": "May cause serious harm or death if swallowed, inhaled or in contact with skin",
        "chemical.inventory.hazard.harmful": "Harmful",
        "chemical.inventory.hazard.harmful_desc": "May cause harm if swallowed, inhaled or in contact with skin",
        "chemical.inventory.hazard.irritant": "Irritant",
        "chemical.inventory.hazard.irritant_desc": "May cause skin irritation or eye damage",
        "chemical.inventory.hazard.environmental": "Hazardous to the environment",
        "chemical.inventory.hazard.environmental_desc": "May cause damage to aquatic or other environments",
        "chemical.inventory.settings.title": "Chemical inventory settings",
        "chemical.inventory.settings.intro": "Control who can see the inventory, who is responsible, and the review interval.",
        "chemical.inventory.settings.visibility": "Employee visibility",
        "chemical.inventory.settings.visibility_choose": "Choose visibility",
        "chemical.inventory.settings.visibility_all_active": "All active employees",
        "chemical.inventory.settings.visibility_hse_roles_only": "HSE roles only",
        "chemical.inventory.settings.responsible": "Responsible users",
        "chemical.inventory.settings.responsible_empty": "No responsible user selected",
        "chemical.inventory.settings.choose_responsible": "Choose responsible users",
        "chemical.inventory.settings.review_interval": "Default review interval (months)",
        "chemical.inventory.settings.sds_stale": "SDS stale after (months)",
        "chemical.inventory.settings.require_sds": "Require safety data sheet",
        "chemical.inventory.settings.auto_create": "Create automatically from products",
        "chemical.inventory.settings.review_reminder": "Review reminder",
        "chemical.inventory.settings.saved": "Chemical inventory settings saved",
        "chemical.inventory.settings.save_error": "Could not save chemical inventory settings",
        "chemical.inventory.settings.load_error": "Could not load chemical inventory settings",
        "company_guide.chemical_inventory.heading": "Chemical inventory setup",
        "company_guide.chemical_inventory.subtitle": "Set responsible users, visibility and review interval before using the inventory.",
        "company_guide.chemical_inventory.loading": "Loading…",
        "company_guide.chemical_inventory.load_error": "Could not load chemical inventory settings.",
        "company_guide.chemical_inventory.link.settings": "Open settings",
        "company_guide.chemical_inventory.task.responsible.title": "Responsible",
        "company_guide.chemical_inventory.task.responsible.warn": "No responsible user is selected",
        "company_guide.chemical_inventory.task.responsible.ok": "Responsible user is set",
        "company_guide.chemical_inventory.task.visibility.title": "Visibility",
        "company_guide.chemical_inventory.task.visibility.warn": "Employee visibility is not selected",
        "company_guide.chemical_inventory.task.visibility.ok": "Visibility is set",
        "company_guide.chemical_inventory.task.interval.title": "Review interval",
        "company_guide.chemical_inventory.task.interval.warn": "Review interval is missing",
        "company_guide.chemical_inventory.task.interval.ok": "Review interval is set",
        "dashboard.company_guide.alert_chemical_title": "Chemical inventory setup is incomplete",
        "dashboard.company_guide.alert_chemical_subtitle": "{{count}} tasks remaining",
        "user_guide.chemical_inventory.title": "Chemical inventory",
        "user_guide.chemical_inventory.badge": "Company setup",
        "user_guide.chemical_inventory.back_to_hub": "Back to user guide",
        "user_guide.chemical_inventory.purpose": "Checklist for responsibility, visibility and chemical reviews.",
        "user_guide.chemical_inventory.section.why.title": "Why this matters",
        "user_guide.chemical_inventory.section.why.p1": "The chemical inventory gives employees hazard symbols, first aid and SDS access. Set a responsible owner and visibility so the list stays current.",
        "user_guide.hub.card.chemical_inventory.title": "Chemical inventory",
        "user_guide.hub.card.chemical_inventory.description": "Responsibility, visibility and review interval for chemicals.",
        "deviation.form.type_category_hint":
          "Choose the category that best describes this deviation.",
        "deviation.form.search_types": "Search deviation types…",
        "deviation.form.no_matching_types": "No matching types",
  
        // HSE Events translations
        "HSE-hendelser": "HSE Events",
        "Håndter helse-, sikkerhets- og miljøhendelser":
          "Manage health, safety and environment events",
        "Ny HSE-hendelse": "New HSE Event",
        "Søk i HSE-hendelser...": "Search HSE events...",
        "Filtre": "Filters",
        "Ingen HSE-hendelser funnet": "No HSE events found",
        "Viser": "Showing",
        "av": "of",
        "resultater": "results",
        "Forrige": "Previous",
        "Neste": "Next",
        "Rediger HSE-hendelse": "Edit HSE Event",
        "HSE-statistikk": "HSE Statistics",
        "Er du sikker på at du vil slette denne HSE-hendelsen?":
          "Are you sure you want to delete this HSE event?",
        "HSE-hendelse ble slettet": "HSE event was deleted",
        "Kunne ikke slette HSE-hendelse": "Could not delete HSE event",
        "HSE-hendelse ble opprettet": "HSE event was created",
        "HSE-hendelse ble oppdatert": "HSE event was updated",
        "Kunne ikke opprette HSE-hendelse": "Could not create HSE event",
        "Kunne ikke lagre HSE-hendelse": "Could not save HSE event",
        "Kunne ikke laste HSE-hendelser": "Could not load HSE events",

        // Checklist types (HSE/KS settings)
        "Sjekklistetyper": "Checklist types",
        "Søk sjekklistetyper...": "Search checklist types...",
        "Inaktive sjekklistetyper": "Inactive checklist types",
        "Kunne ikke laste sjekklistetyper": "Could not load checklist types",
        "Ingen sjekklistetyper funnet": "No checklist types found",
        "Ny sjekklistetype": "New checklist type",
        "Opprettet": "Created",
  
        // HSE Event Form translations
        "Grunnleggende informasjon": "Basic Information",
        "Tittel": "Title",
        "Angi tittel for hendelsen": "Enter title for the event",
        "Dato": "Date",
        "Tidspunkt": "Time",
        "Hendelsestype": "Event Type",
        "Velg hendelsestype": "Select event type",
        "Alvorlighetsgrad": "Severity Level",
        "Velg alvorlighetsgrad": "Select severity level",
        "Beskrivelse": "Description",
        "Beskriv hendelsen detaljert...": "Describe the event in detail...",
        "Sted og avdeling": "Location and Department",
        "Sted": "Location",
        "Avdeling": "Department",
        "Bygg/Område": "Building/Area",
        "Rom/Område": "Room/Area",
        "Detaljert beskrivelse av stedet": "Detailed description of location",
        "Beskriv stedet mer detaljert...":
          "Describe the location in more detail...",
        "Involverte personer": "People Involved",
        "Ansvarlig person": "Responsible Person",
        "Velg ansvarlig person": "Select responsible person",
        "Vitner": "Witnesses",
        "Kategorisering": "Categorization",
        "Kategori": "Category",
        "Velg kategori": "Select category",
        "Umiddelbar årsak": "Immediate Cause",
        "Underliggende årsak": "Underlying Cause",
        "Detaljert kategorisering": "Detailed categorization",
        "Beskriv kategoriseringen mer detaljert...":
          "Describe the categorization in more detail...",
        "Analyse og tiltak": "Analysis and Actions",
        "Årsakanalyse påkrevd": "Root cause analysis required",
        "Strakstiltak påkrevd": "Immediate actions required",
        "Årsakanalyse": "Root Cause Analysis",
        "Beskriv årsakanalysen...": "Describe the root cause analysis...",
        "Strakstiltak": "Immediate Actions",
        "Beskriv strakstiltakene...": "Describe the immediate actions...",
        "Forslag til tiltak": "Suggested Actions",
        "Beskriv forslag til tiltak...": "Describe suggested actions...",
        "Tilknyttede elementer": "Related Elements",
        "Dokumenter": "Documents",
        "Avbryt": "Cancel",
        "Oppdater": "Update",
        "Opprett": "Create",
        "Create": "Create",
        "Update": "Update",
        "Lagrer...": "Saving...",
        "Laster...": "Loading...",
  
        // HSE Event Types
        "Skade": "Injury",
        "Nærhendelse": "Near Miss",
        "Materiellskade": "Property Damage",
        "Miljøhendelse": "Environmental Event",
        "Annet": "Other",
  
        // HSE Severity Levels
        "Lav": "Low",
        "Medium": "Medium",
        "Høy": "High",
        "Kritisk": "Critical",
  
        // HSE Event Categories
        "Avvik lov": "Law Violation",
        "Avvik forskrift": "Regulation Violation",
        "Brudd på prosedyre": "Procedure Violation",
        "Brudd på opplæring": "Training Violation",
        "Informasjon": "Information",
  
        // HSE Status
        "Kladd": "Draft",
        "Innsendt": "Submitted",
        "Under vurdering": "Under Review",
        "Lukket": "Closed",
  
        // Form validation
        "Tittel er påkrevd": "Title is required",
        "Dato er påkrevd": "Date is required",
        "Hendelsestype er påkrevd": "Event type is required",
        "Sted er påkrevd": "Location is required",
  
        // HSE Filters and Statistics
        "Alle typer": "All types",
        "Alle statuser": "All statuses",
        "Fra dato": "From date",
        "Til dato": "To date",
        "Nullstill": "Reset",
        "Bruk filtre": "Apply filters",
        "Kunne ikke laste statistikk": "Could not load statistics",
        "Totale hendelser": "Total events",
        "Nylige hendelser": "Recent events",
        "Forfalte tiltak": "Overdue actions",
        "Kritiske hendelser": "Critical events",
        "Hendelser etter type": "Events by type",
        "Hendelser etter status": "Events by status",
  
        // HSE Event Form - Additional translations
        "Hendelsesdato": "Event Date",
        "Hendelsestid": "Event Time",
        "Involverte personer beskrivelse":
          "List all persons involved in the event",
        "Vitner beskrivelse": "List any witnesses to the event",
        "Umiddelbar årsak beskrivelse":
          "Describe the immediate cause of the event",
        "Underliggende årsak beskrivelse":
          "Describe the underlying cause of the event",
        "Kategorisering beskrivelse":
          "Describe the categorization in more detail",
        "Årsakanalyse beskrivelse": "Describe the root cause analysis",
        "Strakstiltak beskrivelse": "Describe the immediate actions taken",
        "Forslag til tiltak beskrivelse":
          "Describe suggested actions to prevent recurrence",
        "Tilknyttede elementer beskrivelse":
          "Link related customers, projects, employees, and folders",
        "Dokumenter beskrivelse": "Upload relevant documents and files",
        "Velg avdeling": "Select Department",
        "Velg involverte personer": "Select Involved Persons",
        "Andre involverte personer": "Other Persons Involved",
        "Andre involverte personer beskrivelse":
          "Describe other persons involved in the event",
        "Beskriv andre involverte personer...":
          "Describe other involved persons...",
        "Søk etter personer...": "Search for persons...",
        "Ingen personer funnet": "No persons found",
        "Valgte personer": "Selected Persons",
        "Ingen personer tilgjengelig": "No persons available",
        "Fjern alle": "Remove All",
        "Legg til person": "Add Person",
        "Personer": "Persons",
        "Søk i personer...": "Search persons...",
        "Velg personer": "Select Persons",
        "Ingen personer valgt": "No persons selected",
        "Personer valgt": "Persons selected",
        "Bekreft": "Confirm",
        "personer valgt": "persons selected",
        "Nytt system": "New System",
        
        // Project Participants translations (English)
        "project.participants.title": "Participants",
        "project.participants.description": "Project participants and their roles",
        "project.participants.add": "Add Participant",
        "project.participants.add_first": "Add First Participant",
        "project.participants.edit": "Edit Participant",
        "project.participants.delete": "Delete Participant",
        "project.participants.delete_confirm": "Are you sure you want to remove this participant?",
        "project.participants.none": "No participants added yet.",
        "project.participants.user": "User",
        "project.participants.role": "Role",
        "project.participants.status": "Status",
        "project.participants.admin": "Admin",
        "project.participants.error_loading": "Error Loading Participants",

        // Project tasks (English)
        "project.tasks.tab_title": "Tasks",
        "project.tasks.title": "Project tasks",
        "project.tasks.subtitle":
          "Tasks linked to this project. They also appear in your Todo inbox.",
        "project.tasks.new_task": "New task",
        "project.tasks.load_template": "Load template",
        "project.tasks.show_finished": "Show finished",
        "project.tasks.empty": "No tasks on this project yet.",
        "project.tasks.no_open": "No open tasks.",
        "project.tasks.finished_heading": "Finished",
        "project.tasks.filter_by_due": "Filter by due date",
        "project.tasks.bucket_all": "All",
        "project.tasks.bucket_overdue": "Overdue",
        "project.tasks.bucket_today": "Today",
        "project.tasks.bucket_soon": "Upcoming",
        "project.tasks.bucket_later": "Later",
        "project.tasks.bucket_no_due": "No due date",
        "project.tasks.due": "Due",
        "project.tasks.shared": "Shared",
        "project.tasks.blocked": "Blocked",
        "project.tasks.blocked_hint":
          "The linked checklist must be completed before this task can be finished.",
        "project.tasks.finish": "Finish",
        "project.tasks.finished": "Finished",
        "project.tasks.mark_finished": "Mark as finished",
        "project.tasks.reopen": "Reopen",
        "project.tasks.finish_failed": "Could not change the task status.",
        "project.tasks.bulk_apply": "Update selected",
        "project.tasks.bulk_need_change": "Choose a new due date or assignee before updating.",
        "project.tasks.bulk_done": "The tasks were updated.",
        "project.tasks.bulk_failed": "Could not update the tasks.",
        "project.tasks.selected_count": "{{count}} selected",
        "project.tasks.load_failed": "Could not load tasks.",
        "project.tasks.created": "Task created.",
        "project.tasks.create_failed": "Could not create task.",
        "project.tasks.title_required": "Title is required.",
        "project.tasks.create": "Create",
        "project.tasks.edit": "Edit",
        "project.tasks.edit_task": "Edit task",
        "project.tasks.save": "Save",
        "project.tasks.updated": "Task updated.",
        "project.tasks.update_failed": "Could not update task.",
        "project.tasks.field_recurrence": "Recurrence",
        "project.tasks.field_title": "Title",
        "project.tasks.field_description": "Description",
        "project.tasks.field_due_date": "Due date",
        "project.tasks.field_priority": "Priority",
        "project.tasks.priority_none": "None",
        "project.tasks.priority_low": "Low",
        "project.tasks.priority_medium": "Medium",
        "project.tasks.priority_high": "High",
        "project.tasks.field_checklist": "Link to checklist",
        "project.tasks.checklist_none": "No checklist",
        "project.tasks.checklist_gate_hint":
          "The task can only be finished once the checklist is finished or approved.",
        "project.tasks.field_assignees": "Assignees",
        "project.tasks.add_assignees": "Add assignees",
        "project.tasks.on_today_plan": "Add to today's plan",
        "project.tasks.no_templates": "No active task templates.",
        "project.tasks.apply": "Load",
        "project.tasks.template_applied": "Loaded {{count}} task(s) from template.",
        "project.tasks.template_failed": "Could not load template.",
        "project.tasks.template_item_count": "{{count}} tasks",
        "task.referenceBlocked.checklist":
          "The task cannot be finished until the linked checklist is finished or approved.",
        "projectTaskTemplate.title": "Project task templates",
        "projectTaskTemplate.subtitle":
          "Reusable sets of tasks that can be loaded onto projects.",
        "projectTaskTemplate.new_set": "New template set",
        "projectTaskTemplate.set_title": "Title",
        "projectTaskTemplate.set_description": "Description",
        "projectTaskTemplate.set_category": "Category",
        "projectTaskTemplate.set_active": "Active",
        "projectTaskTemplate.items": "Tasks in set",
        "projectTaskTemplate.add_item": "Add task",
        "projectTaskTemplate.item_title": "Title",
        "projectTaskTemplate.item_due_offset": "Due (days from project start)",
        "projectTaskTemplate.item_recurrence": "Recurrence",
        "projectTaskTemplate.item_shared": "Shared",
        "projectTaskTemplate.spawn_checklist": "Create checklist",
        "projectTaskTemplate.select_checklist_type": "Select checklist type",
        "projectTaskTemplate.edit": "Edit",
        "projectTaskTemplate.edit_set": "Edit template set",
        "projectTaskTemplate.save": "Save",
        "projectTaskTemplate.saved": "Template set saved.",
        "projectTaskTemplate.save_failed": "Could not save template set.",
        "projectTaskTemplate.delete": "Delete",
        "projectTaskTemplate.delete_confirm": "Delete this template set?",
        "projectTaskTemplate.deleted": "Template set deleted.",
        "projectTaskTemplate.empty": "No template sets yet.",
        "projectTaskTemplate.load_failed": "Could not load template sets.",
        "projectTaskTemplate.json.open_dialog": "JSON / AI",
        "projectTaskTemplate.json.dialog_title": "Template JSON and AI instructions",
        "projectTaskTemplate.json.tab_json": "Paste JSON",
        "projectTaskTemplate.json.tab_ai_guide": "AI instructions",
        "projectTaskTemplate.json.hint": "Paste JSON from an AI or copy the current template set. Use Replace or Append.",
        "projectTaskTemplate.json.copy_json": "Copy JSON",
        "projectTaskTemplate.json.copy_success": "JSON copied",
        "projectTaskTemplate.json.reload_from_editor": "Reload from editor",
        "projectTaskTemplate.json.reload_success": "JSON reloaded from editor",
        "projectTaskTemplate.json.insert_sample": "Insert sample",
        "projectTaskTemplate.json.apply": "Apply in editor",
        "projectTaskTemplate.json.applied": "{{count}} tasks applied",
        "projectTaskTemplate.json.replace_items": "Replace all tasks",
        "projectTaskTemplate.json.append_items": "Append at the bottom",
        "projectTaskTemplate.json.clipboard_failed": "Could not copy to clipboard",
        "projectTaskTemplate.json.ai_guide_intro": "Copy the instructions below into ChatGPT, Claude or another AI. Then paste the JSON response in the Paste JSON tab.",
        "projectTaskTemplate.json.copy_ai_guide": "Copy AI instructions",
        "projectTaskTemplate.json.ai_guide_copied": "AI instructions copied",
        "projectTaskTemplate.json.generate_with_ai": "Generate with AI",
        "projectTaskTemplate.json.ai_parse_error": "Could not parse AI response as JSON",
        "projectTaskTemplate.json.ai_apply_success": "{{count}} tasks applied from AI",
        "projectTaskTemplate.json.error_empty": "JSON is empty",
        "projectTaskTemplate.json.error_invalid_json": "Invalid JSON",
        "projectTaskTemplate.json.error_no_items_array": "JSON is missing an items array",
        "projectTaskTemplate.json.error_no_valid_items": "No valid tasks in JSON",

        // Project HSE handbook (English)
        "project.hse_handbook.tab_title": "HSE Handbook",
        "project.hse_handbook.title": "HSE Handbook for project",
        "project.hse_handbook.subtitle":
          "Pull in HSE documents, checklists and forms for this project.",
        "project.hse_handbook.section_documents": "Documents",
        "project.hse_handbook.section_checklists": "Checklists",
        "project.hse_handbook.section_forms": "Forms",
        "project.hse_handbook.section_crew": "Crew list",
        "project.hse_handbook.add_document": "Add document",
        "project.hse_handbook.import_template": "Import template",
        "project.hse_handbook.print": "Print handbook",
        "project.hse_handbook.printing": "Printing handbook …",
        "project.hse_handbook.print_failed": "Could not print the handbook",
        "project.hse_handbook.open_personal_handbook": "Employee handbook",
        "project.hse_handbook.view": "View",
        "project.hse_handbook.remove": "Remove",
        "project.hse_handbook.remove_confirm": "Remove this document from the handbook?",
        "project.hse_handbook.removed": "Document removed from the handbook",
        "project.hse_handbook.remove_failed": "Could not remove the document",
        "project.hse_handbook.create_copy": "Create project copy",
        "project.hse_handbook.create_checklist": "Create checklist",
        "project.hse_handbook.checklist_created": "Checklist created",
        "project.hse_handbook.checklist_failed": "Could not create checklist",
        "project.hse_handbook.fill_form": "Fill out form",
        "project.hse_handbook.form_created": "Form created",
        "project.hse_handbook.form_failed": "Could not create form",
        "project.hse_handbook.override_created": "Project copy created",
        "project.hse_handbook.override_failed": "Could not create project copy",
        "project.hse_handbook.project_copy": "Project copy",
        "project.hse_handbook.added": "{{count}} document(s) added",
        "project.hse_handbook.add_failed": "Could not add documents",
        "project.hse_handbook.add_selected": "Add ({{count}})",
        "project.hse_handbook.imported": "{{count}} document(s) imported",
        "project.hse_handbook.import_failed": "Could not import documents",
        "project.hse_handbook.import_all_confirm":
          "Import all approved HSE documents, checklists and forms to the project?",
        "project.hse_handbook.load_failed": "Could not load the handbook",
        "project.hse_handbook.empty_section": "No documents in this section yet.",
        "project.hse_handbook.no_content": "No content registered.",
        "project.hse_handbook.no_available_documents": "No available documents.",
        "project.hse_handbook.already_added": "Already added",
        "project.hse_handbook.no_crew": "No crew registered on the project.",
        "project.hse_handbook.crew_name": "Name",
        "project.hse_handbook.crew_role": "Role",
        "project.hse_handbook.crew_email": "Email",
        "project.hse_handbook.crew_status": "Status",
        "project.hse_handbook.crew_on_site": "On site",
        "project.hse_handbook.crew_planned": "Planned",
        "project.hse_handbook.crew_scheduled": "Scheduled",
        "project.hse_handbook.crew_assigned": "Assigned",

        // Project Activities translations (English)
        "project.activities.tab_title": "Activities",
        "project.activities.tab_hint":
          "Leave the title field (Tab or click outside) to save a new line. The next number is set automatically; Tripletex lines are handled in the background.",
        "project.activities.search_label": "Search",
        "project.activities.search_placeholder": "Search title, number, description…",
        "project.activities.filter_label": "Filter",
        "project.activities.filter_all": "All",
        "project.activities.filter_standard": "Standard only",
        "project.activities.filter_additional": "Additional work only",
        "project.activities.add_quick": "New row",
        "project.activities.draft_title_placeholder": "Title — Tab to save and add next",
        "project.activities.deleted": "Activity removed",
        "project.activities.title": "Activities",
        "project.activities.description":
          "Lines used for hours and price estimates. Manage them in the Activities tab on the project.",
        "project.activities.description_field": "Description",
        "project.activities.activity_line": "Tripletex activity line",
        "project.activities.activity_line_hint":
          "Optional. Links this row to a project activity line for Tripletex.",
        "project.activities.is_additional": "Additional",
        "project.activities.title_required": "Title is required",
        "project.activities.delete_error": "Could not delete activity",
        "project.activities.add": "Add Activity",
        "project.activities.add_first": "Add First Activity",
        "project.activities.edit": "Edit Activity",
        "project.activities.delete": "Delete Activity",
        "project.activities.delete_confirm": "Are you sure you want to remove this activity?",
        "project.activities.none": "No activities added yet.",
        "project.activities.activity": "Activity",
        "project.activities.number": "Number",
        "project.activities.budget_hours": "Budget Hours",
        "project.activities.budget_fee": "Budget Fee",
        "project.activities.invoiceable": "Invoiceable",
        "project.activities.error_loading": "Error Loading Activities",
  
        // Project sync status (English)
        "project.synced": "Synced",
        "project.not_synced": "Not Synced",
        
        // Additional project translations (English)
        "project.participants.updated": "Participant updated successfully",
        "project.participants.created": "Participant added successfully",
        "project.participants.save_error": "Failed to save participant",
        "project.participants.delete_error": "Failed to remove participant",
        "project.participants.user_required": "User is required",
        "project.participants.role_required": "Role is required",
        "project.participants.admin_access": "Admin Access",
        "project.participants.updating": "Updating...",
        "project.participants.adding": "Adding...",

        "project.required.banner_title": "This project is missing required fields",
        "project.required.banner_description": "These fields must be filled in before you can save changes or add participants:",
        "project.required.edit_here": "Edit here",
        "project.required.field.name": "Project name",
        "project.required.field.project_manager": "Project manager",
        "project.required.field.start_date": "Start date",
        
        "project.activities.updated": "Activity updated successfully",
        "project.activities.created": "Activity added successfully",
        "project.activities.save_error": "Failed to save activity",
        "project.activities.activity_required": "Activity is required",
        "project.activities.title_field": "Title",
        "project.activities.start_date": "Start Date",
        "project.activities.end_date": "End Date",
        "project.activities.budget_fee_rate": "Budget Fee Rate",
        "project.activities.inactive": "Inactive",
        "project.activities.updating": "Updating...",
        "project.activities.adding": "Adding...",
        "project.activities.summary_title": "Overview",
        "project.activities.summary_hours": "Hours (logged / budget)",
        "project.activities.summary_activities_done": "Activities completed",
        "project.activities.summary_budget_fee": "Total budget fee",
        "project.activities.summary_budget_fee_hint": "Sum of budget fee on all activities (for reference).",
        "project.activities.hours_unit": "h",
        "project.activities.hours_unit_short": "h",
        "project.activities.of_total_budget_hours": "of budgeted hours (project)",
        "project.activities.completed_label": "completed",
        "project.activities.currency_nok": "NOK",
        "project.activities.mode_view": "View mode",
        "project.activities.mode_edit": "Edit mode",
        "project.activities.status_label": "Status",
        "project.activities.status.open": "Open",
        "project.activities.status.in_progress": "In progress",
        "project.activities.status.completed": "Completed",
        "project.activities.status.on_hold": "On hold",
        "project.activities.edit_dialog_title": "Activity details",
        "project.activities.progress_section": "Progress",
        "project.activities.logged_vs_budget": "{{logged}} h logged · {{budget}} h budget",
        "project.activities.of_budget_hours": "of this activity’s budget hours",
        "project.activities.linked_work_orders": "{{count}} linked work order(s)",
        "project.activities.linked_work_orders_label": "Work orders on this activity",
        "project.activities.no_description": "No description.",
        "project.activities.period": "Period",
        "project.activities.new_work_order": "New work order",
        "project.activities.open_work_orders_tab": "Open work orders tab",
        "project.activities.open_time_tab": "Open time registration",
        "project.activities.logged_short": "Logged",
        "project.activities.status_progress_title": "Status and progress",
        "project.activities.save": "Save",
        "project.activities.saving": "Saving…",
        "project.activities.actions": "Actions",
        "project.activities.deleted_toast": "Deleted",
        
        // Project Plan translations (English)
        "project.plan.title": "Project Plan",
        "project.plan.subtitle": "Plan and manage project events",
        "project.plan.select_project": "Select Project",
        "project.plan.select_project_first": "Please select a project first",
        "project.plan.pick_project_title": "Select project",
        "project.plan.pick_project_hint": "Select a project to continue",
        "project.plan.project": "Project",
        "project.plan.no_events": "No events in this period",
        "project.plan.drop_lane_hint": "Drop plan here",
        "project.plan.total": "Total",
        "project.plan.loading": "Loading events...",
        "project.plan.week": "Week",
        "project.plan.resource_capacity": "Resource capacity",
        "project.plan.resource_capacity_subtitle":
          "Compares the Hours resource plan with planned project events and work orders in the selected period.",
        "project.plan.loading_resource_plan": "Loading resource plan...",
        "project.plan.capacity.events": "Events",
        "project.plan.capacity.available": "Available",
        "project.plan.capacity.assigned": "Assigned",
        "project.plan.capacity.scheduled_hours": "Work schedule hours",
        "project.plan.capacity.free_hours": "Free hours",
        "project.plan.capacity.assigned_of_available": "{{assigned}} of {{available}} resources used",
        "project.plan.capacity.free_hours_value": "{{hours}}h free",
        "project.plan.capacity.events_value": "{{count}} event(s)",
        "No project": "No project",
        "No activity": "No activity",
        
        // Project Plan Preview translations (English)
        "project.plan.preview.title": "Project plan",
        "project.plan.preview.subtitle": "Upcoming events",
        "project.plan.preview.go_to_full_plan": "Full plan →",
        "project.plan.preview.time_prefix": "At",
        "project.plan.preview.loading": "Loading events...",
        "project.plan.preview.error": "Error loading events",
        "project.plan.preview.no_events": "No upcoming events",
        "project.plan.preview.untitled_event": "Untitled Event",
        "project.plan.preview.resource": "resource",
        "project.plan.preview.resources": "resources",
        "project.plan.preview.view_all": "View all {{count}} events",

        "crew.panel.title": "Crew & shifts",
        "crew.panel.subtitle": "Today’s roster, absence and time punches (requires «Crew scheduling» company module)",
        "crew.panel.loading": "Loading crew…",
        "crew.panel.error": "Could not load crew data",
        "crew.panel.no_project": "Select a project to view crew",
        "crew.panel.shifts": "Shifts",
        "crew.panel.absences": "Absence today",
        "crew.panel.open_punches": "Open punches",
        "crew.panel.clock_in": "Clock in",
        "crew.panel.clock_out": "Clock out",
        "crew.panel.checklists": "Checklists",
        "crew.panel.seed_checklists": "Create default checklist types",
        "crew.panel.hours": "Hours",
        "crew.panel.open_full": "Open module",
        "crew.page.kicker": "Planning",
        "crew.page.title": "Crew and shifts",
        "crew.page.subtitle": "Plan shifts, manage availability, time punches, kiosk and leader overview",
        "crew.tabs.shifts": "Shift plan",
        "crew.tabs.mine": "My shifts",
        "crew.tabs.availability": "Availability",
        "crew.tabs.punch": "Time punch",
        "crew.tabs.kiosk": "Kiosk",
        "crew.tabs.leader": "Leader",
        "crew.tabs.leader_alerts": "Compliance and alerts",
        "crew.tabs.payroll": "Payroll basis",
        "crew.stats.shifts": "Shifts",
        "crew.stats.assignments": "Assignments",
        "crew.stats.open_punches": "Open punches",
        "crew.stats.alerts": "Alerts",
        "crew.filters.title": "Planning filters",
        "crew.filters.subtitle": "Choose project, period and active day for the week view.",
        "crew.filters.project": "Project",
        "crew.filters.date": "Date",
        "crew.filters.period": "Period",
        "crew.filters.period_from": "Period from",
        "crew.filters.period_to": "Period to",
        "crew.filters.active_day": "Active day",
        "crew.filters.density": "View",
        "crew.filters.days": "days",
        "crew.filters.this_week": "This week",
        "crew.filters.next_week": "Next week",
        "crew.filters.this_month": "This month",
        "crew.density.cozy": "Cozy",
        "crew.density.compact": "Compact",
        "crew.shift.new": "New shift",
        "crew.shift.edit": "Edit shift",
        "crew.shift.copy": "Copy shift",
        "crew.shift.copy_short": "Copy",
        "crew.shift.new_short": "New shift",
        "crew.shift.step_info": "Info",
        "crew.shift.step_days_time": "Days and time",
        "crew.shift.next_days_time": "Next: days and time",
        "crew.shift.back_info": "Back to info",
        "crew.shift.title": "Title",
        "crew.shift.title_hint": "Short name that makes the shift easy to recognize, e.g. “Saturday evening food truck”.",
        "crew.shift.title_placeholder": "E.g. Saturday evening food truck",
        "crew.shift.role": "Role",
        "crew.shift.role_hint": "What the person will do on the shift, e.g. shift lead, kitchen, register, service or cleanup. Use “shift lead” when the person should also follow start/end checklists.",
        "crew.shift.role_placeholder": "E.g. Shift lead",
        "crew.shift.role_suggestions": "Choose a role suggestion or type manually",
        "crew.shift.roles.shift_lead": "Shift lead",
        "crew.shift.roles.cashier": "Register",
        "crew.shift.roles.kitchen": "Kitchen",
        "crew.shift.roles.service": "Service",
        "crew.shift.roles.runner": "Runner",
        "crew.shift.roles.cleanup": "Cleanup",
        "crew.shift.roles.closing": "Closing",
        "crew.shift.starts_at": "Start",
        "crew.shift.ends_at": "End",
        "crew.shift.project": "Project",
        "crew.shift.project_hint": "Links the shift to the correct project. This is used later for time punches and time registration so hours land on the right project.",
        "crew.shift.location": "Location",
        "crew.shift.location_hint": "Where the shift is performed, e.g. food truck name, address, event or department.",
        "crew.shift.location_placeholder": "E.g. Food truck downtown",
        "crew.shift.break_minutes": "Break (min)",
        "crew.shift.break_minutes_hint": "Planned break deducted from planned hours.",
        "crew.shift.slots": "Slots",
        "crew.shift.slots_hint": "How many people are needed on this shift.",
        "crew.shift.assignment_mode": "Assignment",
        "crew.shift.assignment_mode_hint": "Direct assignment gives the shift to the selected employee. Open shift offer lets employees respond to the offer.",
        "crew.shift.assignment_direct": "Direct assignment",
        "crew.shift.assignment_open": "Open shift offer",
        "crew.shift.response_deadline": "Response deadline",
        "crew.shift.response_deadline_hint": "Optional. Unanswered offers are hidden from employees after the deadline.",
        "crew.shift.leader_checklist_required": "Require leader checklists",
        "crew.shift.leader_checklist_required_hint": "Creates required startup and shutdown checklists for this shift. Useful for shift leads in food trucks, catering units and service teams.",
        "crew.shift.handover_note": "Handover note",
        "crew.shift.handover_note_hint": "Important information the next leader or shift should see.",
        "crew.shift.assigned_employee": "Employee on shift",
        "crew.shift.assigned_employee_hint": "Optional. Select an employee here to add the person directly to all selected days.",
        "crew.shift.month": "Month",
        "crew.shift.month_hint": "Choose the month to plan. Tick the days in the calendar below.",
        "crew.shift.from_time": "From time",
        "crew.shift.from_time_hint": "Start time used for all selected days.",
        "crew.shift.to_time": "To time",
        "crew.shift.to_time_hint": "End time used for all selected days. If the end is before the start, it is treated as an overnight shift ending the next day.",
        "crew.shift.single_day": "One day",
        "crew.shift.period_days": "Multiple days",
        "crew.shift.period_from": "Period from",
        "crew.shift.period_to": "Period to",
        "crew.shift.weekdays": "Select weekdays",
        "crew.shift.create_plan": "Create shift plan",
        "crew.shift.copy_plan": "Copy shift plan",
        "crew.shift.copy_assignments_hint": "{{count}} crew member(s) will be copied from the original shift unless you select another employee.",
        "crew.shift.overview_month": "Month",
        "crew.shift.overview_period": "Period",
        "crew.shift.days_with_shifts": "Days with shifts",
        "crew.shift.missing_days": "Days without plan",
        "crew.shift.planned_hours": "Planned hours",
        "crew.shift.month_overview": "Month overview",
        "crew.shift.month_overview_hint": "Green days have a shift plan. Light days are missing a plan.",
        "crew.shift.day_has_shifts": "{{count}} shift(s)",
        "crew.shift.day_missing": "Missing plan",
        "crew.shift.day_by_day": "Day by day",
        "crew.shift.day_shift_count": "{{count}} shift(s)",
        "crew.shift.selected_day_timeline": "Timeline for selected day",
        "crew.shift.no_shifts_selected_day": "No shifts on the selected day.",
        "crew.shift.add_shift_hint": "Select a day in the week or create a new shift to complete the plan.",
        "crew.shift.no_role": "No role",
        "crew.shift.no_days_selected": "No days selected in period",
        "crew.shift.ends_after_start": "End must be after start",
        "crew.shift.no_crew_added": "No crew added / shift offer sent",
        "crew.shift.publish": "Publish",
        "crew.shift.cancel": "Cancel",
        "crew.shift.cancel_reason": "Cancellation reason",
        "crew.assignment.add": "Add crew",
        "crew.assignment.add_short": "Add crew",
        "crew.assignment.accept": "Accept",
        "crew.assignment.decline": "Decline",
        "crew.availability.starts_at": "From",
        "crew.availability.ends_at": "To",
        "crew.availability.add_day": "Select day",
        "crew.availability.add_day_button": "Add day",
        "crew.availability.add_weekdays": "Add weekdays",
        "crew.availability.month": "Month",
        "crew.availability.remove_day": "Remove day",
        "crew.availability.no_days_selected": "No days selected",
        "crew.availability.selected_days": "Selected days",
        "crew.availability.selected_short": "Selected",
        "crew.availability.saved_short": "Saved",
        "crew.availability.from_time": "From time",
        "crew.availability.to_time": "To time",
        "crew.availability.status": "Status",
        "crew.availability.available": "Available",
        "crew.availability.unavailable": "Unavailable",
        "crew.availability.monthly_overview": "Availability by month",
        "crew.availability.month_stats": "{{days}} days · {{hours}} hours available",
        "crew.availability.loading": "Loading…",
        "crew.availability.no_entries": "No availability saved for the selected period.",
        "crew.punch.clocked_in": "You are clocked in",
        "crew.punch.choose_shift": "Choose a shift to clock in, or clock in without a shift.",
        "crew.punch.clock_in_without_shift": "Clock in without shift",
        "crew.punch.history": "Time punch history",
        "crew.punch.history_date": "Date",
        "crew.punch.history_in": "In",
        "crew.punch.history_out": "Out",
        "crew.punch.history_hours": "Hours",
        "crew.punch.history_status": "Status",
        "crew.punch.deviation_note": "Deviation / note",
        "crew.punch.deviation_note_placeholder": "Deviation, missing checklist item or note for the next leader...",
        "crew.punch.open": "Open",
        "crew.punch.closed": "Closed",
        "crew.punch.no_history": "No time punches in this period.",
        "crew.kiosk.title": "Kiosk / PIN",
        "crew.kiosk.help": "Use a shared signed-in device and personal PIN for employees.",
        "crew.kiosk.open": "Open PIN verification",
        "crew.kiosk.employee_number": "Employee number",
        "crew.kiosk.pin": "PIN",
        "crew.kiosk.verify": "Verify",
        "crew.kiosk.verify_title": "Verify PIN",
        "crew.kiosk.pin_admin_title": "Manage employee PIN",
        "crew.kiosk.save_pin": "Save PIN",
        "crew.kiosk.clear_pin": "Clear PIN",
        "crew.payroll.planned": "Planned",
        "crew.payroll.actual": "Actual",
        "crew.empty.shifts": "No shifts in the selected period.",
        "crew.empty.assignments": "No shift offers or assignments.",
        "crew.empty.alerts": "No alerts.",
        "crew.empty.payroll": "No payroll basis in this period.",
        "crew.checklists.handover_title": "Checklist handover",
        "crew.checklists.mark_completed": "Mark completed",
        "crew.checklists.no_runs": "No required shift checklists in this period.",
        "crew.checklists.kind.start": "Startup",
        "crew.checklists.kind.end": "Shutdown",
        "crew.checklists.status.pending": "Pending",
        "crew.checklists.status.in_progress": "In progress",
        "crew.checklists.status.completed": "Completed",
        "crew.alerts.time_punch_deviation_note": "Time punch deviation/note",
        "crew.alerts.required_shift_checklist_pending": "Required checklist is not completed",
        "crew.alerts.long_open_punch": "Long open time punch",
        "crew.alerts.planned_shift_missing_break": "Planned shift is missing break",
        "crew.alerts.high_hours_last_12_months": "High actual hours last 12 months",
        "crew.toast.saved": "Saved",
        "crew.toast.assignment_saved": "Crew added",
        "crew.toast.pin_verified": "PIN verified",
        "crew.toast.pin_saved": "PIN saved",
        "crew.toast.pin_cleared": "PIN cleared",
        "crew.toast.published": "Shift published",
        "crew.toast.cancelled": "Shift cancelled",
        "crew.toast.accepted": "Shift accepted",
        "crew.toast.declined": "Shift declined",
        "crew.toast.availability_saved": "Availability saved",
        "crew.toast.clocked_in": "Clocked in",
        "crew.toast.clocked_out": "Clocked out",
        "crew.toast.checklists_seeded": "Checklist types created",
        "crew.toast.checklist_completed": "Checklist marked completed",
        "crew.weekdays.monday": "Mon",
        "crew.weekdays.tuesday": "Tue",
        "crew.weekdays.wednesday": "Wed",
        "crew.weekdays.thursday": "Thu",
        "crew.weekdays.friday": "Fri",
        "crew.weekdays.saturday": "Sat",
        "crew.weekdays.sunday": "Sun",
        
        // Project Event translations (English)
        "project.event.create": "Create Event",
        "project.event.edit": "Edit Event",
        "project.event.title": "Title",
        "project.event.title_required": "Title is required",
        "project.event.title_placeholder": "Enter event title",
        "project.event.description": "Description",
        "project.event.description_placeholder": "Enter event description",
        "project.event.start_date": "Start Date",
        "project.event.start_date_required": "Start date is required",
        "project.event.end_date": "End Date",
        "project.event.end_date_invalid": "End date must be after start date",
        "project.event.days": "Days",
        "project.event.days_placeholder": "Number of days",
        "project.event.project": "Project",
        "project.event.work_order": "Work Order",
        "project.event.resources": "Resources (Employees)",
        "project.event.add_resource": "Add Resource",
        "project.event.add_resource_one_day": "Add employee (start date)",
        "project.event.no_resources": "No resources added. Add employees who will work on this event.",
        "project.event.resource": "Resource",
        "project.event.resource_employee": "Employee",
        "project.event.resource_start_time": "Start Time",
        "project.event.resource_end_time": "End Time",
        "project.event.save_error": "An error occurred while saving the event. Please try again.",
        "project.event.work_orders_linked": "Linked work orders",
        "project.event.select_work_orders": "Select work orders",
        "project.event.activities_linked": "Linked activities",
        "project.event.select_activities": "Select activities",
        "project.event.sync_resource_dates": "Sync resource dates with event",
        "project.event.conflict_warning": "Resource conflict — check times",
        "project.event.conflict_plan": "Plan: {{title}} ({{time}})",
        "project.event.conflict_calendar": "Calendar: {{title}} ({{time}})",
        "project.event.resource_hours": "Hours",
        "project.event.resource_hours_unit": "h",
        "project.event.resource_hours_manual": "Manual hour count",
        "project.event.resource_hours_pick_start": "Pick start time to calculate hours",

        "project.plan.crew.title": "Resources",
        "project.plan.crew.subtitle": "{{count}} people in period",
        "project.plan.crew.empty": "No resources in selected period",
        "project.plan.crew.absent_days": "Absent {{days}} day(s)",
        "project.plan.crew.absent_with_type": "{{type}} · {{days}} day(s)",
        "project.plan.crew.not_counted_summary": "Not included in scheduled hours: {{names}}",
        "project.plan.crew.not_counted_badge": "Not counted",
        "project.plan.crew.not_counted_no_schedule": "0 h — no work schedule, not counted",
        "project.plan.crew.not_counted_sick": "0 h — sick leave is not counted",
        "project.plan.crew.open_user_short": "Open user",
        "project.plan.crew.open_user": "Open {{name}} in a new tab",
        "project.plan.crew.open_user": "Open {{name}} in a new tab",
        "project.plan.absences.title": "Absence",
        "project.plan.resource_bar.clear_selection": "Clear filter",
        "project.plan.create_plan": "New plan",
        "project.plan.edit_plan": "Edit plan",
        "project.plan.schedule_plan": "Place on calendar",
        "project.plan.draft_drop_missing":
          "Could not find the draft. Refresh the page and try again.",
        "project.plan.toolbar.breadcrumb": "Project plan",
        "project.plan.toolbar.new_task": "New task",
        "project.plan.toolbar.new_absence": "+ Absence",
        "project.plan.toolbar.schedule_activity": "Schedule activity",
        "project.plan.day_action.title": "Add",
        "project.plan.day_action.subtitle": "{{date}}",
        "project.plan.day_action.add_aria": "Add on {{date}}",
        "project.plan.day_action.new_plan": "New plan",
        "project.plan.day_action.activity": "Activity",
        "project.plan.day_action.task": "Task",
        "project.plan.day_action.absence": "Absence",
        "project.plan.absence.title": "Register absence",
        "project.plan.absence.help":
          "Choose employee, absence type and period. Only administrators can register absence from here.",
        "project.plan.absence.employee": "Employee",
        "project.plan.absence.pick_employee": "Select employee",
        "project.plan.absence.type": "Absence type",
        "project.plan.absence.pick_type": "Select absence type",
        "project.plan.absence.date_from": "From date",
        "project.plan.absence.date_to": "To date",
        "project.plan.absence.approve_now": "Approve absence immediately",
        "project.plan.absence.approve_now_help":
          "The absence is marked as approved right after saving.",
        "project.plan.absence.save": "Register absence",
        "project.plan.absence.date_order_error": "To date cannot be before from date",
        "project.plan.absence.save_error": "Could not register absence",
        "project.plan.absence.approve_error": "Absence was saved, but approval failed",
        "project.plan.absence.toast_created": "Absence registered",
        "project.plan.absence.toast_created_approved": "Absence registered and approved",
        "project.plan.resource_day.title": "Resource",
        "project.plan.resource_day.untitled": "Untitled",
        "project.plan.resource_day.employee": "Employee",
        "project.plan.resource_day.edit": "Edit",
        "project.plan.resource_day.delete": "Delete this day",
        "project.plan.resource_day.delete_confirm":
          "Remove {{name}} from {{date}}? Only this day is deleted.",
        "project.plan.resource_day.delete_toast": "Resource day removed",
        "project.plan.resource_day.delete_error": "Could not delete resource day",
        "project.plan.resource_row.add_day_hint": "Click to add this day for the resource",
        "project.plan.schedule_confirm": "Place on calendar",
        "project.plan.schedule_activity.pick_title": "Choose project activity",
        "project.plan.schedule_activity.pick_help":
          "Pick the activity to schedule. Description is optional — the title comes from the activity.",
        "project.plan.schedule_activity.pick_required": "Select an activity",
        "project.plan.schedule_activity.continue": "Continue to scheduling",
        "project.plan.schedule_activity.crew_section": "People",
        "project.plan.schedule_activity.days_section": "Days",
        "project.plan.schedule_activity.budget_hours_hint": "Budget: {{hours}} h (default)",
        "project.plan.schedule_activity.save": "Save schedule",
        "project.plan.schedule_activity.toast_created": "Activity placed on the calendar",
        "project.plan.schedule_activity.toast_updated": "Schedule updated",
        "project.plan.toolbar.week": "Week",
        "project.plan.toolbar.fortnight": "2 weeks",
        "project.plan.toolbar.month": "Month",
        "project.plan.toolbar.today": "Today",
        "project.plan.toolbar.density": "Density",
        "project.plan.toolbar.density_compact": "Compact",
        "project.plan.toolbar.density_comfortable": "Comfortable",
        "project.plan.toolbar.density_spacious": "Spacious",
        "project.plan.stats.events": "Events",
        "project.plan.stats.scheduled_hours": "Scheduled hours",
        "project.plan.stats.crew": "Crew",
        "project.plan.stats.unscheduled": "Unscheduled",
        "project.plan.schedule.title_create": "Schedule plan on calendar",
        "project.plan.schedule.title_edit": "Edit calendar schedule",
        "project.plan.schedule.open_work_order_edit": "Open work order (edit)",
        "project.plan.schedule.open_project_activity": "Open project activity",
        "project.plan.schedule.create_work_order_later": "Create work order later",
        "project.plan.schedule.edit_project_event": "Edit plan event",
        "project.plan.schedule.edit_project_event_hint":
          "Title, description, links, and resources outside the week scheduler.",
        "project.plan.schedule.activity_title_create": "Schedule project activity",
        "project.plan.schedule.activity_title_edit": "Edit scheduling (activity)",
        "project.plan.schedule.activity_plan_hint":
          "Simpler scheduling without a work order. You can add a WO when needed.",
        "project.plan.toolbar.project_task": "Task / project",
        "project.plan.toolbar.prev": "Previous period",
        "project.plan.toolbar.next": "Next period",
        "project.plan.toolbar.week_range": "Week {{week}} · {{range}}",
        "project.plan.toolbar.fortnight_range": "Week {{weekFrom}}–{{weekTo}} · {{range}}",
        "project.plan.schedule.week_short": "Wk {{week}}",
        "project.plan.sidebar.title": "Projects",
        "project.plan.sidebar.active": "active",
        "project.plan.sidebar.search_placeholder": "Search project, client, or code…",
        "project.plan.sidebar.all_projects": "All projects",
        "project.plan.unscheduled.title": "Unscheduled",
        "project.plan.no_draft_plans": "No drafts to schedule",
        "project.plan.unscheduled.drag_hint": "Drag onto the calendar to schedule",
        "project.plan.multi_link_hint": "You can link several. One is marked as primary.",
        "project.plan.primary_link": "Primary",
        "project.plan.set_primary": "Set as primary",
        "project.plan.no_work_orders_yet": "No work orders linked yet",
        "project.plan.include_work_order_description": "Include description from work order",
        "project.plan.no_activities_yet": "No activities linked yet",
        "project.plan.save_plan": "Save plan",
        "project.plan.multi_select_selected": "{{count}} selected",
        "project.plan.add_selected": "Add selected ({{count}})",
        "project.plan.view_period": "Period view",
        "project.plan.view_day": "Day view",
        "project.plan.settings.display": "Display",
        "project.plan.settings.display_subtitle": "Choose how the project plan is shown",
        "project.plan.settings.resource_plan": "Resource plan",
        "project.plan.settings.resource_plan_subtitle": "Open resource plan and capacity for the selected project",
        "project.plan.settings.open_resource_plan": "Open resource plan",
        "project.plan.settings.select_project": "Select a project to open the resource plan",
        "project.plan.resource_bar.title": "Resources this day",
        "project.plan.resource_bar.subtitle": "Click to filter the calendar",
        "project.plan.resource_bar.subtitle_date": "{{date}} — click to filter",
        "project.plan.resource_bar.empty": "No resources this day",
        "project.plan.resource_bar.planned_hours": "{{hours}} h scheduled",
        "project.plan.day_view.employee": "Employee",
        "project.plan.day_view.empty": "No scheduled tasks this day",
        "project.plan.day_view.hint": "Drag resources from the crew list to assign",
        "nav.documentation": "Documentation",
        "calendar.quick_views.aria": "Quick views",
        "calendar.quick_views.calendar": "Calendar",
        "calendar.quick_views.project_plan": "Project plan",
        "calendar.quick_views.crew": "Crew",
        "calendar.quick_views.resource_plan": "Resource plan",
        "calendar.search_placeholder": "Search events…",
        "calendar.filter": "Filter",
        "calendar.filter_title": "Filter calendar",
        "calendar.outlook_view": "Outlook view",
        "calendar.nav.previous_day": "Previous day",
        "calendar.nav.next_day": "Next day",
        "calendar.plan_event.title": "Plan task",
        "calendar.plan_event.status_completed": "Completed",
        "calendar.plan_event.status_assigned": "Scheduled",
        "calendar.plan_event.project_context_title": "Project",
        "calendar.plan_event.project_no_description": "No project description",
        "calendar.plan_event.task_description": "Task / activity",
        "calendar.plan_event.open_project": "Open project",
        "calendar.plan_event.open_work_order": "Open work order",
        "calendar.plan_event.open_project_activity": "Open activity in project",
        "calendar.plan_event.related_report": "Related report",
        "calendar.plan_event.mark_my_task_complete": "Mark my assignment complete",
        "calendar.plan_event.register_hours": "Register hours",
        "calendar.plan_event.open_project_plan": "Open project plan",
        "calendar.plan_event.load_error": "Could not load plan events",
        "calendar.plan_event.complete_validation.activity_status": "Select status for all activities",
        "calendar.plan_event.complete_validation.description": "Description is required",
        "calendar.plan_event.complete_validation.photos": "Upload at least one photo per work order",
        "calendar.plan_event.completed": "Task marked as complete",
        "calendar.plan_event.complete_error": "Could not complete the task",
        "calendar.plan_event.complete_dialog.title": "Complete plan task",
        "calendar.plan_event.complete_dialog.simple_confirm": "Confirm you have completed your part of the task.",
        "calendar.plan_event.complete_dialog.intro": "Update status, description, and documentation before completing.",
        "calendar.plan_event.complete_dialog.activities": "Activities",
        "calendar.plan_event.complete_dialog.work_orders": "Work orders",
        "calendar.plan_event.complete_dialog.work_order_outcome.ongoing": "Ongoing",
        "calendar.plan_event.complete_dialog.work_order_outcome.finished": "Finished",
        "calendar.plan_event.photos": "Photos",
        "calendar.plan_event.complete_dialog.photos_count": "photos",
        "calendar.plan_event.complete_dialog.work_description": "Work description",
        "calendar.plan_event.complete_dialog.work_description_placeholder": "Describe work performed…",
        "calendar.plan_event.complete_dialog.work_description_hint": "Describe what was done — visible in reports and history.",
        "calendar.plan_event.complete_dialog.submit": "Complete and save",
        
        // Meeting Minutes translations
        "meeting_minutes": "Meeting Minutes",
        "meeting_minutes.list": "Meeting Minutes",
        "meeting_minutes.hero_subtitle": "Minutes for employee interviews, project meetings and other meetings. Use templates, send to participants and export PDF.",
        "meeting_minutes.editor_subtitle": "Choose type, participants and an optional template. The first meeting is created automatically.",
        "meeting_minutes.filter.all_types": "All types",
        "meeting_minutes.copy_suffix": "Copy",
        "meeting_minutes.status.draft": "In progress",
        "meeting_minutes.date.today": "Today",
        "meeting_minutes.send_to_participants": "Send to employees and participants",
        "meeting_minutes.export_pdf": "Export PDF",
        "meeting_minutes.new": "New meeting minutes",
        "meeting_minutes.edit": "Edit Meeting Minutes",
        "meeting_minutes.create": "Create Meeting Minutes",
        "meeting_minutes.update": "Update Meeting Minutes",
        "meeting_minutes.delete": "Delete Meeting Minutes",
        "meeting_minutes.search": "Search meeting minutes...",
        "meeting_minutes.no_results": "No meeting minutes found",
        "meeting_minutes.meeting_date": "Meeting Date",
        "meeting_minutes.meeting_type": "Meeting Type",
        "meeting_minutes.select_type": "Select meeting type",
        "meeting_minutes.type.employee_interview": "Employee Interview",
        "meeting_minutes.type.project_meeting": "Project Meeting",
        "meeting_minutes.type.other": "Other Meeting",
        "meeting_minutes.employee": "Employee",
        "meeting_minutes.select_employee": "Select employee",
        "meeting_minutes.participants": "Participants",
        "meeting_minutes.select_participants": "Select participants",
        "meeting_minutes.manual_participants": "Manual participants",
        "meeting_minutes.manual_participants.description": "Enter participants manually (comma separated)",
        "meeting_minutes.project": "Project",
        "meeting_minutes.select_project": "Select project",
        "meeting_minutes.title": "Title",
        "meeting_minutes.title.required": "Title is required",
        "meeting_minutes.description": "Description",
        "meeting_minutes.groups": "Groups",
        "meeting_minutes.add_group": "Add Group",
        "meeting_minutes.group.title": "Group Title",
        "meeting_minutes.group.title.required": "Group title is required",
        "meeting_minutes.group.description": "Group Description",
        "meeting_minutes.group.entries": "Entries",
        "meeting_minutes.group.add_entry": "Add Entry",
        "meeting_minutes.entry.description": "Description",
        "meeting_minutes.entry.description.required": "Description is required",
        "meeting_minutes.entry.deadline": "Deadline",
        "meeting_minutes.entry.responsible": "Responsible",
        "meeting_minutes.entry.select_responsible": "Select responsible person",
        "meeting_minutes.meeting_number": "Meeting #",
        "meeting_minutes.continue_meeting": "Continue Meeting",
        "meeting_minutes.continue_meeting.description": "Continue on the same meeting minutes (creates a new meeting entry)",
        "meeting_minutes.continue_success": "Meeting continued successfully",
        "meeting_minutes.continue_error": "Could not continue meeting",
        "meeting_minutes.basic_info": "Basic Information",
        "meeting_minutes.templates": "Templates",
        "meeting_minutes.templates.list": "Templates",
        "meeting_minutes.templates.hero_subtitle": "Reuse agendas for interviews, project meetings and stand-ups.",
        "meeting_minutes.templates.editor_subtitle": "Add agenda points and entries that load when you create a meeting.",
        "meeting_minutes.templates.empty_start": "Start with an empty agenda",
        "meeting_minutes.templates.no_points": "No points in this template",
        "meeting_minutes.templates.will_load": "Will load {{count}} points from the template",
        "meeting_minutes.templates.agenda": "Template agenda",
        "meeting_minutes.templates.save_from_meeting": "Save as template",
        "meeting_minutes.templates.saved_from_meeting": "Meeting saved as a template",
        "meeting_minutes.templates.save_from_meeting_error": "Could not save template",
        "meeting_minutes.templates.new": "New template",
        "meeting_minutes.templates.edit": "Edit template",
        "meeting_minutes.templates.create": "Create Template",
        "meeting_minutes.templates.update": "Update Template",
        "meeting_minutes.templates.delete": "Delete Template",
        "meeting_minutes.templates.search": "Search templates...",
        "meeting_minutes.templates.no_results": "No templates found",
        "meeting_minutes.templates.use_template": "Use Template",
        "meeting_minutes.templates.copy_from": "Copy from previous meeting",
        "meeting_minutes.templates.select_template": "Select Template",
        "meeting_minutes.created": "Meeting minutes created successfully",
        "meeting_minutes.updated": "Meeting minutes updated successfully",
        "meeting_minutes.deleted": "Meeting minutes deleted successfully",
        "meeting_minutes.delete_confirm": "Are you sure you want to delete this meeting minutes?",
        "meeting_minutes.meetings": "Meetings",
        "meeting_minutes.create_error": "Could not create meeting minutes",
        "meeting_minutes.update_error": "Could not update meeting minutes",
        "meeting_minutes.delete_error": "Could not delete meeting minutes",
        "meeting_minutes.load_error": "Could not load meeting minutes",
        "meeting_minutes.template.created": "Template created successfully",
        "meeting_minutes.template.updated": "Template updated successfully",
        "meeting_minutes.template.deleted": "Template deleted successfully",
        "meeting_minutes.template.create_error": "Could not create template",
        "meeting_minutes.template.update_error": "Could not update template",
        "meeting_minutes.template.delete_error": "Could not delete template",
        "meeting_minutes.template.delete_confirm": "Are you sure you want to delete this template?",
        "meeting_minutes.template.load_error": "Could not load template",
        "meeting_minutes.json.open_dialog": "JSON / AI instructions",
        "meeting_minutes.json.generate_with_ai": "Generate agenda with AI",
        "meeting_minutes.json.dialog_title": "Meeting minutes JSON",
        "meeting_minutes.json.tab_json": "JSON",
        "meeting_minutes.json.tab_ai_guide": "AI instructions",
        "meeting_minutes.json.hint": "Paste or edit agenda JSON. Replace or append points.",
        "meeting_minutes.json.replace_groups": "Replace all points",
        "meeting_minutes.json.append_groups": "Append at the bottom",
        "meeting_minutes.json.copy_json": "Copy JSON",
        "meeting_minutes.json.reload_from_editor": "Reload from editor",
        "meeting_minutes.json.insert_sample": "Insert sample",
        "meeting_minutes.json.apply": "Apply to editor",
        "meeting_minutes.json.copy_success": "JSON copied",
        "meeting_minutes.json.reload_success": "JSON reloaded from editor",
        "meeting_minutes.json.clipboard_failed": "Could not copy",
        "meeting_minutes.json.applied": "Applied {{count}} points",
        "meeting_minutes.json.ai_guide_intro": "Copy the instructions and paste them into ChatGPT, Cursor, or another model.",
        "meeting_minutes.json.copy_ai_guide": "Copy AI instructions",
        "meeting_minutes.json.ai_guide_copied": "AI instructions copied",
        "meeting_minutes.json.ai_parse_error": "Could not parse AI JSON",
        "meeting_minutes.json.ai_apply_success": "Applied {{count}} AI points",
        "meeting_minutes.json.error_empty": "Empty JSON",
        "meeting_minutes.json.error_invalid_json": "Invalid JSON",
        "meeting_minutes.json.error_no_groups_array": "Missing groups array",
        "meeting_minutes.json.error_no_valid_groups": "No valid points in JSON",
        "meeting_minutes.json.error_create_group_failed": "Could not create point from JSON",
        "meeting_minutes.json.error_create_entry_failed": "Could not create entry from JSON",
        "meeting_minutes.add_meeting": "Add Meeting",
        "meeting_minutes.add_first_meeting": "Add First Meeting",
        "meeting_minutes.no_meetings": "No meetings yet",
        "meeting_minutes.points": "points",
        "meeting_minutes.add_point": "Add Point",
        "meeting_minutes.point.title": "Point Title",
        "meeting_minutes.point.description": "Point Description",
        "meeting_minutes.point.untitled": "Untitled Point",
        "meeting_minutes.point.create_error": "Could not create point",
        "meeting_minutes.errors.stale": "The meeting was changed by someone else. Your draft is kept. Reload the latest version before saving again.",
        "meeting_minutes.point.update_error": "Could not update point",
        "meeting_minutes.point.delete_error": "Could not delete point",
        "meeting_minutes.point.delete_confirm": "Are you sure you want to delete this point?",
        "meeting_minutes.entry.add": "Add Entry",
        "meeting_minutes.entry.remove": "Remove",
        "meeting_minutes.entry.create_error": "Could not create entry",
        "meeting_minutes.entry.update_error": "Could not update entry",
        "meeting_minutes.entry.delete_error": "Could not delete entry",
        "meeting_minutes.entry.delete_confirm": "Are you sure you want to delete this entry?",
        "meeting_minutes.meeting.created": "Meeting created successfully",
        "meeting_minutes.meeting.create_error": "Could not create meeting",
        "meeting_minutes.meeting.load_error": "Could not load meeting",
        "meeting_minutes.meeting.finished": "Finished",
        "meeting_minutes.meeting.mark_finished": "Mark as Finished",
        "meeting_minutes.meeting.marked_finished": "Meeting marked as finished",
        "meeting_minutes.meeting.mark_finished_error": "Could not mark meeting as finished",
        "meeting_minutes.meeting.mark_finished_title": "Mark this meeting as finished?",
        "meeting_minutes.meeting.mark_finished_body": "The meeting is marked as finished and can no longer be edited. Edit mode turns off, and points and entries cannot be changed from this page afterwards.",
        "meeting_minutes.actions.open": "Actions",
        "meeting_minutes.meeting.no_points": "No points added yet",
        "meeting_minutes.meeting.no_points_add_first": "No points added yet. Add your first point to get started.",
        "meeting_minutes.meeting.copy_options": "Copy Options",
        "meeting_minutes.meeting.copy_from_previous": "Copy from Previous Meeting",
        "meeting_minutes.meeting.no_copy": "Don't copy",
        "meeting_minutes.meeting.or": "OR",
        "meeting_minutes.meeting.no_template": "Don't use template",
        "meeting_minutes.employee.add_manual": "Add Manual Participant",
        "meeting_minutes.employee.manual_name": "Name",
        "meeting_minutes.employee.manual_email": "Email",
        "meeting_minutes.employee.manual_mobile": "Mobile",
        "meeting_minutes.employee.remove": "Remove",
        "meeting_minutes.meetings_created_separately": "Meetings are created separately. Go to the meetings list to add new meetings.",
        "meeting_minutes.group.update_error": "Could not update group",
        "meeting_minutes.group.delete_confirm": "Are you sure you want to delete this group?",
        "meeting_minutes.group.deleted": "Group deleted successfully",
        "meeting_minutes.group.delete_error": "Could not delete group",
        "meeting_minutes.group.delete": "Delete Group",
        "meeting_minutes.group.documents": "Group Documents",
        "meeting_minutes.entry.deleted": "Entry deleted successfully",
        "meeting_minutes.entry.documents": "Entry Documents",
        "meeting_minutes.changes_saved": "Changes saved",
        "meeting_minutes.print": "Print",
        "meeting_minutes.printing": "Printing…",
        "meeting_minutes.print_failed": "Could not generate PDF",
        "meeting_minutes.send": "Send meeting minutes",
        "meeting_minutes.send_success": "Meeting minutes sent",
        "meeting_minutes.send_partial": "Sent to {{sent}} recipient(s). {{failed}} failed.",
        "meeting_minutes.from_previous_meeting": "From Previous Meeting",
        "meeting_minutes.read_only_reference": "Read-only reference",
        "meeting_minutes.collapse": "Collapse",
        "meeting_minutes.expand": "Expand",
        "meeting_minutes.entry.singular": "entry",
        "meeting_minutes.entry.plural": "entries",
        "meeting_minutes.image.uploaded": "{{count}} image(s) uploaded successfully",
        "meeting_minutes.others_editing": "Others are editing this meeting. Changes may be overwritten.",
        "meeting_minutes.point.edit": "Edit Point",
        "meeting_minutes.group.created": "Group created successfully",
        "meeting_minutes.group.updated": "Group updated successfully",
        "Saving...": "Saving...",
        
        // Drawings translations
        "drawings": "Drawings",
        "drawings_edit": "Drawings – editing",
        "drawings.list": "Drawings",
        "drawings.list.projects": "Projects",
        "drawings.list_ui.add": "Add",
        "drawings.list_ui.all_drawings": "All drawings",
        "drawings.list_ui.legend": "Legend",
        "drawings.list_ui.pick_project_title": "Which project are you working on?",
        "drawings.list_ui.pick_project_help": "Drawings always belong to a project. Pick one once and it stays selected for the rest of your session.",
        "drawings.list_ui.pick_project_search": "Search projects by number, name or client",
        "drawings.list_ui.pick_project_empty": "No projects found",
        "drawings.list_ui.pick_project_footer": "Recently opened projects appear first. You can switch projects any time from the header.",
        "drawings.list_ui.cancel_switch": "Cancel switch",
        "drawings.list_ui.switch_project": "Switch",
        "drawings.list_ui.go_to_project": "Go to project",
        "drawings.list_ui.summary": "{{count}} drawings in this project",
        "drawings.list_ui.manage_structure": "Manage structure",
        "drawings.list_ui.open_user_guide": "User guide",
        "drawings.list_ui.open_structure": "Houses and floors",
        "drawings.list_ui.tab_all": "All drawings",
        "drawings.list_ui.tab_needs_review": "Needs review",
        "drawings.list_ui.tab_revisions": "Revisions",
        "drawings.list_ui.tab_archive": "Archive",
        "drawings.list_ui.tab_coming_soon": "Coming soon",
        "drawings.list_ui.search_placeholder": "Search drawings, houses, floors",
        "drawings.list_ui.filter_all_types": "All",
        "drawings.list_ui.scope_floor": "Selected floor",
        "drawings.list_ui.scope_house": "Selected house",
        "drawings.list_ui.result_count": "{{count}} results",
        "drawings.list_ui.empty_title": "No drawings here yet",
        "drawings.list_ui.empty_hint": "Add a drawing for this filter, or pick another floor.",
        "drawings.list_ui.empty_cta": "Add drawing here",
        "drawings.list_ui.updated_unknown": "Updated unknown",
        "drawings.list_ui.updated_today": "Updated today",
        "drawings.list_ui.updated_yesterday": "Updated yesterday",
        "drawings.list_ui.updated_days": "Updated {{count}} days ago",
        "drawings.create_drawer.create": "Create drawing",
        "drawings.create_drawer.create_another": "Create and add another",
        "drawings.create_drawer.context_fallback": "New drawing",
        "drawings.create_drawer.pdf_hint": "Title, house and floor are read from the file name when possible",
        "drawings.create_drawer.title_placeholder": "e.g. House 1 — Floor 2 ventilation",
        "drawings.create_drawer.location": "Location",
        "drawings.create_drawer.location_hint": "Prefilled from your current selection",
        "drawings.create_drawer.floor_required": "Choose a floor, or use Other for drawings without a floor",
        "drawings.structure.new_house_placeholder_short": "House name",
        "drawings.structure.new_floor_placeholder_short": "Floor name",
        "drawings.new": "New drawing",
        "drawings.edit": "Edit Drawing",
        "drawings.create": "Create Drawing",
        "drawings.update": "Update Drawing",
        "drawings.delete": "Delete Drawing",
        "drawings.search": "Search drawings...",
        "drawings.no_results": "No drawings found",
        "drawings.title": "Title",
        "drawings.title.required": "Title is required",
        "drawings.description": "Description",
        "drawings.project": "Project",
        "drawings.select_project": "Select project",
        "drawings.floor": "Floor",
        "drawings.floor.placeholder": "Enter floor number or name",
        "drawings.house": "House",
        "drawings.house.placeholder": "Enter house number or identifier",
        "drawings.document": "Drawing Document",
        "drawings.document.required": "Drawing document is required",
        "drawings.document.replace": "Replace PDF",
        "drawings.document.upload_pdf": "Upload drawing PDF",
        "drawings.document.pdf_only_hint": "Drop a file here or choose a PDF",
        "drawings.document.choose_file": "Choose file",
        "drawings.document.pdf_required": "Only PDF files can be used as a drawing",
        "drawings.document.pdf_read_error": "Could not read the PDF. Try another file.",
        "drawings.document.checking_pages": "Checking page count…",
        "drawings.document.multi_page_warning":
          "This PDF has {{count}} pages. Only 1 page per drawing is supported — choose which page to use.",
        "drawings.document.use_this_page": "Use page {{page}}",
        "drawings.document.single_page_hint":
          "Only the selected page is uploaded. Other pages from the original PDF are not used.",
        "drawings.document.extracting_page": "Extracting page…",
        "drawings.document.extract_error": "Could not extract the page from the PDF",
        "drawings.document.uploading": "Uploading…",
        "drawings.document.uploaded": "PDF uploaded",
        "drawings.document.upload_error": "Could not upload PDF",
        "drawings.created": "Drawing created successfully",
        "drawings.replaced": "Drawing was replaced",
        "drawings.floor_replace_hint":
          "The same floor and type can only have one drawing. You must confirm before an existing drawing is replaced.",
        "drawings.floor_kind_hint":
          "The same floor can have multiple drawings (e.g. architecture and ventilation). Same floor + same type requires confirmation before replace.",
        "drawings.andre_hint":
          "“Other” is for drawings without a floor (e.g. kitchen). They appear in a dedicated group in the structure.",
        "drawings.floor_kind_conflict":
          "A drawing already exists for this floor and type. Choose another type, or open the existing drawing.",
        "drawings.kind": "Drawing type",
        "drawings.kind_hint": "Choose the drawing type. Type is used with floor to prevent duplicates.",
        "drawings.kind.arkitekt": "Architecture",
        "drawings.kind.ventilasjon": "Ventilation",
        "drawings.kind.kjokken": "Kitchen",
        "drawings.kind.annet": "Other",
        "drawings.replace_confirm.title": "Replace existing drawing?",
        "drawings.replace_confirm.message":
          "You are about to replace “{{title}}” ({{house}} · floor {{floor}} · {{kind}}).\n\nThe PDF/document will be replaced. This cannot easily be undone.",
        "drawings.replace_confirm.confirm": "Replace drawing",
        "drawings.replace_confirm.cancel": "Cancel",
        "drawings.replace_confirm.invalid_target":
          "Could not replace drawing because the existing drawing reference is missing.",
        "drawings.updated": "Drawing updated successfully",
        "drawings.save_changes": "Save Changes",
        "drawings.no_changes": "No changes to save",
        "drawings.deleted": "Drawing deleted successfully",
        "drawings.delete_confirm": "Are you sure you want to delete this drawing?",
        "drawings.create_error": "Could not create drawing",
        "drawings.update_error": "Could not update drawing",
        "drawings.update_partial": "{{done}} saved. {{remaining}} remaining — check before retrying.",
        "drawings.delete_error": "Could not delete drawing",
        "drawings.load_error": "Could not load drawing",
        "drawings.module.add": "Add Module",
        "drawings.module.arrow": "Arrow",
        "drawings.module.circle": "Circle",
        "drawings.module.rectangular": "Rectangular",
        "drawings.module.pen": "Freehand",
        "drawings.module.measure": "Measurement",
        "drawings.module.photo": "Photo",
        "drawings.module.note": "Note",
        "drawings.module.delete": "Delete Module",
        "drawings.module.delete_confirm": "Are you sure you want to delete this module?",
        "drawings.module.color": "Color",
        "drawings.module.filled": "Filled",
        "drawings.module.not_filled": "Not Filled",
        "drawings.module.move": "Move Module",
        "drawings.viewer.details": "Drawing details",
        "drawings.viewer.details_short": "Details",
        "drawings.viewer.modules": "Modules",
        "drawings.viewer.modules_short": "Modules",
        "drawings.viewer.deviations_short": "Devs",
        "drawings.viewer.checklists_short": "Checks",
        "drawings.viewer.structure_short": "Struct",
        "drawings.viewer.no_modules": "No modules yet. Right-click on the drawing to add one.",
        "drawings.viewer.context_hint": "Right-click on the drawing to add arrows, circles, or rectangles.",
        "drawings.viewer.unsaved": "Unsaved",
        "drawings.viewer.toggle_sidebar": "Toggle sidebar",
        "drawings.viewer.zoom_in": "Zoom in",
        "drawings.viewer.zoom_out": "Zoom out",
        "drawings.viewer.reset_zoom": "Reset zoom",
        "drawings.viewer.fit_to_screen": "Fit to screen",
        "drawings.viewer.loading_pdf": "Loading drawing...",
        "drawings.viewer.pdf_error": "Could not load drawing PDF",
        "drawings.viewer.tool.select": "Select",
        "drawings.viewer.tool.pan": "Pan",
        "drawings.viewer.tool.pen": "Pen",
        "drawings.viewer.tool.measure": "Measure",
        "drawings.viewer.tool_hint": "Use Select (V) to move modules. Pick Pen (P) to draw freehand, Measure (M) to drag a dimension, or shape tools to place markers.",
        "drawings.viewer.no_description": "No description provided.",
        "drawings.viewer.location": "Location",
        "drawings.viewer.prev_page": "Previous page",
        "drawings.viewer.next_page": "Next page",
        "drawings.viewer.deviations": "Deviations",
        "drawings.viewer.checklists": "Checklists",
        "drawings.viewer.no_project_linked": "Link a project to this drawing to show deviations and checklists.",
        "drawings.viewer.no_deviations": "No deviations found for this project.",
        "drawings.viewer.no_checklists": "No checklists found for this project.",
        "drawings.viewer.pin_deviation": "Pin on drawing",
        "drawings.viewer.repin_deviation": "Move pin",
        "drawings.viewer.pin_deviation_hint": "Click on the drawing to place the deviation marker.",
        "drawings.viewer.show_on_drawing": "Show on drawing",
        "drawings.viewer.checklist_items": "items",
        "drawings.viewer.open_checklist": "Open checklist",
        "drawings.viewer.checklist_fill": "Fill out",
        "drawings.viewer.checklist_attach_photo": "Attach photo",
        "drawings.viewer.checklist_upload_new_photo": "Upload new photo",
        "drawings.viewer.checklist_attach_existing": "Attach photo",
        "drawings.viewer.checklist_existing_photos": "Existing photos",
        "drawings.viewer.checklist_existing_photos_empty": "No photos on this drawing or project yet.",
        "drawings.viewer.checklist_photo_linked": "The photo is attached to the checklist",
        "drawings.viewer.checklist_fill_subtitle": "Fill checklist items directly from the drawing",
        "drawings.viewer.checklist_fill_load_error": "Could not load the checklist",
        "drawings.viewer.checklist_item_docs": "Document / pin",
        "drawings.viewer.checklist_item_doc": "Document",
        "drawings.viewer.checklist_item_docs_empty": "No documents yet — use the camera to place a pin on the drawing.",
        "drawings.viewer.checklist_item_pinned": "Pinned on drawing",
        "drawings.viewer.checklist_pin_group": "Pin {{n}}",
        "drawings.viewer.checklist_unpinned_docs": "Not pinned",
        "drawings.viewer.checklist_pin_completed": "Completed",
        "drawings.viewer.checklist_pin_approved_count": "{{count}} approved",
        "drawings.viewer.checklist_pin_deviation_count": "{{count}} deviations",
        "drawings.viewer.checklist_pin_item_label": "Checklist item",
        "drawings.viewer.checklist_pin_checklist_label": "Checklist",
        "drawings.viewer.deviation_pin_label": "Deviation",
        "drawings.viewer.deviation_pin_short": "Dev",
        "drawings.viewer.deviation_pin_number": "Deviation {{number}}",
        "drawings.viewer.checklist_item_fallback": "Checklist item",
        "drawings.viewer.checklist_status.approved": "Approved",
        "drawings.viewer.checklist_status.deviation": "Deviation",
        "drawings.viewer.checklist_status.na": "Not applicable",
        "drawings.viewer.checklist_status.pending": "Pending",
        "drawings.viewer.checklist_status.not_approved": "Not approved",
        "drawings.viewer.reopen_checklist": "Open checklist again",
        "drawings.viewer.reopen_deviation": "Open deviation again",
        "drawings.viewer.dismiss_pin_focus": "Dismiss",
        "drawings.viewer.show_pin_on_drawing": "Show on drawing",
        "drawings.viewer.deviation_status.open": "Open",
        "drawings.viewer.deviation_status.in_progress": "In progress",
        "drawings.viewer.deviation_status.closed": "Closed",
        "drawings.viewer.deviation_status.unknown": "Unknown",
        "drawings.viewer.measure_scale": "Measurement scale",
        "drawings.viewer.calibrate": "Calibrate",
        "drawings.viewer.calibrate_title": "Calibrate measurements",
        "drawings.viewer.calibrate_help": "Draw a reference line on the drawing with a known real-world length, then enter the length in millimeters. If you already measured, the latest measure line is used automatically.",
        "drawings.viewer.calibrate_draw_line": "Draw a reference line on the drawing using the measure tool.",
        "drawings.viewer.calibrate_using_existing": "Using existing measure line as reference.",
        "drawings.viewer.calibrate_line_length": "Reference line",
        "drawings.viewer.calibrate_known_mm": "Known length (mm)",
        "drawings.viewer.calibrate_current_scale": "Current scale",
        "drawings.viewer.calibrate_new_scale": "New scale",
        "drawings.viewer.calibrate_save": "Save calibration",
        "drawings.viewer.calibrate_saved": "Measurement scale saved",
        "drawings.viewer.calibrate_error_no_line": "Draw a reference line with the measure tool before saving.",
        "drawings.viewer.calibrate_error_no_length": "Enter the known length in millimeters.",
        "drawings.viewer.calibrate_error_invalid": "Invalid calibration. Check the line and length.",
        "drawings.viewer.versions": "Drawing versions",
        "drawings.viewer.live_drawing": "Live",
        "drawings.viewer.revision": "Rev. {{name}}",
        "drawings.viewer.updated_on": "updated {{date}}",
        "drawings.viewer.create_version": "New markup version",
        "drawings.viewer.version_name_prompt": "Name for this markup version",
        "drawings.viewer.version_created": "Markup version created",
        "drawings.viewer.editing_version": "Editing version",
        "drawings.viewer.save_location": "Save location",
        "drawings.viewer.location_saved": "House and floor saved",
        "drawings.viewer.location_hint": "Select a house and floor from the Structure tab, or manage the project structure there.",
        "drawings.viewer.all_houses": "All houses",
        "drawings.viewer.all_floors": "All floors",
        "drawings.viewer.mobile.nav_aria": "Drawing menu",
        "drawings.viewer.mobile.tools": "Tools",
        "drawings.viewer.mobile.more": "More",
        "drawings.viewer.mobile.switch_drawing": "Switch drawing",
        "drawings.viewer.mobile.no_sibling_drawings": "No other drawings in this project.",
        "drawings.viewer.mobile.no_project_drawings": "This drawing is not linked to a project, and no other drawings were found. Go to the drawings list to switch.",
        "drawings.viewer.mobile.no_project_switch_hint": "This drawing is not linked to a project. Pick another available drawing, or open the drawings list.",
        "drawings.viewer.mobile.to_drawings_list": "To drawings list",
        "drawings.viewer.mobile.select_pan_toggle": "Toggle between Select and Pan",
        "drawings.viewer.mobile.close": "Close",
        "drawings.viewer.mobile.zoom": "Zoom",
        "drawings.viewer.mobile.pinch_hint": "Pinch the drawing to zoom, or use the − / + buttons.",
        "drawings.viewer.mobile.menu": "Drawings",
        "drawings.viewer.mobile.search_placeholder": "Search drawing, house or floor",
        "drawings.viewer.mobile.no_search_results": "No drawings match this search.",
        "drawings.viewer.mobile.select_short": "Select",
        "drawings.viewer.mobile.pan_short": "Pan",
        "drawings.viewer.mobile.add_short": "New",
        "drawings.structure.title": "Structure",
        "drawings.structure.andre": "Other",
        "drawings.structure.andre_hint_short": "No floor",
        "drawings.structure.filter_andre": "Filtered to Other (no floor)",
        "drawings.structure.help": "Create houses and floors for this project. Assign drawings to a floor, or use Other for drawings without a floor.",
        "drawings.structure.add_house": "Add house",
        "drawings.structure.add_floor": "Add floor",
        "drawings.structure.new_house_placeholder": "House name (e.g. House A)",
        "drawings.structure.new_floor_placeholder": "Floor name (e.g. 1)",
        "drawings.structure.empty": "No houses yet. Add a house, then add floors under it.",
        "drawings.structure.project_required": "Select a project to manage houses and floors.",
        "drawings.structure.assign_hint": "Click a floor to assign this drawing. Save when the selection changes.",
        "drawings.structure.house_created": "House created",
        "drawings.structure.floor_created": "Floor created",
        "drawings.structure.house_deleted": "House deleted",
        "drawings.structure.floor_deleted": "Floor deleted",
        "drawings.structure.delete_house": "Delete house",
        "drawings.structure.delete_floor": "Delete floor",
        "drawings.structure.delete_house_confirm": "Delete this house and all its floors? Drawings will be unassigned from floors.",
        "drawings.structure.delete_floor_confirm": "Delete this floor? Drawings on this floor will be unassigned.",
        "drawings.structure.load_error": "Could not load drawing structure",
        "drawings.structure.save_error": "Could not save drawing structure",
        "drawings.structure.delete_error": "Could not delete",
        "drawings.structure.filter_active": "Filtered by house or floor",
        "drawings.structure.clear_filter": "Clear filter",

        "drawings.viewer.see_3d": "View in 3D",
        "drawings.viewer.see_3d_short": "3D",
        "drawings.viewer.see_3d_no_project": "The drawing must belong to a project to open it in 3D.",
        "drawings.viewer.open_place_in_3d": "Open this spot in 3D",
        "drawings.viewer.open_place_in_3d_error": "Could not open the spot in 3D.",
        "drawings.viewer.open_place_in_3d_no_alignment": "This drawing is not aligned with the model yet. Use “Align 3D” first.",
        "drawings.viewer.align_3d": "Link drawing",
        "drawings.viewer.align_3d_title": "Link drawing to model",
        "drawings.viewer.align_3d_help": "Pick two points on the drawing where you know the IFC coordinates. Promang derives scale, rotation and offset from that pair.",
        "drawings.viewer.align_3d_pick_hint": "Opens the 3D view. Pick a storey, then click the sheet and the matching point in the model.",
        "drawings.viewer.align_3d_pick_second": "Click point 2 on the drawing.",
        "drawings.viewer.align_3d_point": "Point {{number}}",
        "drawings.viewer.align_3d_ifc_x": "IFC X",
        "drawings.viewer.align_3d_ifc_y": "IFC Y",
        "drawings.viewer.align_3d_z_offset": "Z offset",
        "drawings.viewer.align_3d_storey": "Storey name in the model",
        "drawings.viewer.align_3d_save": "Save alignment",
        "drawings.viewer.align_3d_saved": "3D alignment saved",
        "drawings.viewer.align_3d_error": "Could not save the 3D alignment.",

        "ifc_viewer.models": "Models",
        "ifc_viewer.upload": "Upload IFC",
        "ifc_viewer.uploading": "Uploading…",
        "ifc_viewer.no_models": "No IFC models yet. Upload an .ifc file to get started.",
        "ifc_viewer.toggle_visibility": "Show or hide {{name}} in this view",
        "ifc_viewer.visible_for_everyone": "Visible to everyone",
        "ifc_viewer.hidden_badge": "Hidden",
        "ifc_viewer.show_for_everyone": "Show {{name}} to everyone",
        "ifc_viewer.hide_for_everyone": "Hide {{name}} from others",
        "ifc_viewer.model_shown": "The model is visible to everyone.",
        "ifc_viewer.model_hidden": "The model is hidden from others.",
        "ifc_viewer.model_hide_error": "Could not save visibility.",
        "ifc_viewer.link_drawing": "Link drawing",
        "ifc_viewer.link_drawing_hint": "Pick a drawing and storey. The sheet appears in 3D — drag it over the floor.",
        "ifc_viewer.link_drawing_title": "Link drawing to model",
        "ifc_viewer.link_drawing_pick_help": "Pick a drawing and a storey with geometry from the house (ARK). Empty storeys are hidden. The sheet then appears in the 3D viewer — drag, rotate and scale it over the floor.",
        "ifc_viewer.link_drawing_drawing": "Drawing",
        "ifc_viewer.link_drawing_pick_drawing": "Choose drawing…",
        "ifc_viewer.link_drawing_storey": "Storey in ARK",
        "ifc_viewer.link_drawing_no_storeys": "No storeys with geometry in the house yet. Load the models first.",
        "ifc_viewer.link_drawing_continue": "Show drawing in 3D",
        "ifc_viewer.link_drawing_overlay_help": "Drag the drawing over the floor. Blue corners scale, the amber handle rotates. The model stays put.",
        "ifc_viewer.link_drawing_overlay_note": "The camera is in bird’s-eye view on that storey. Right-drag / wheel moves and zooms the camera. Save uses the same similarity transform as See 3D.",
        "ifc_viewer.link_drawing_opacity": "Opacity",
        "ifc_viewer.link_drawing_rotate_left": "Rotate 90° left",
        "ifc_viewer.link_drawing_rotate_right": "Rotate 90° right",
        "ifc_viewer.link_drawing_reset": "Reset placement",
        "ifc_viewer.link_drawing_advanced": "Advanced: two click pairs instead",
        "ifc_viewer.link_drawing_back_overlay": "Back to dragging the drawing in 3D",
        "ifc_viewer.link_drawing_click_pdf": "Click point {{number}} on the drawing.",
        "ifc_viewer.link_drawing_click_ifc": "Click the same place in the 3D model (point {{number}}).",
        "ifc_viewer.link_drawing_v1_note": "Advanced: two click pairs (PDF + 3D). The default is to drag the sheet in the viewer.",
        "ifc_viewer.link_drawing_pdf_error": "Could not load the drawing.",
        "ifc_viewer.link_drawing_pdf_missing": "This drawing has no PDF. Upload a PDF on the drawing first.",
        "ifc_viewer.link_drawing_pdf_fetch_error": "Could not fetch the PDF. Check that the drawing has a file and that you are signed in.",
        "ifc_viewer.link_drawing_pdf_raster_error": "Could not read the PDF page. Try another drawing or upload the PDF again.",
        "ifc_viewer.link_drawing_pair": "Point {{number}}: PDF {{pdfX}}/{{pdfY}} → IFC {{ifcX}} / {{ifcY}}",
        "ifc_viewer.link_drawing_pdf_pending": "Point {{number}} on the drawing ({{x}}/{{y}}) — click in 3D.",
        "ifc_viewer.link_drawing_save": "Save link",
        "ifc_viewer.link_drawing_saved": "The drawing is linked to the model.",
        "ifc_viewer.link_drawing_error": "Could not save the link.",
        "ifc_viewer.delete_model": "Delete {{name}}",
        "ifc_viewer.axis.x": "X",
        "ifc_viewer.axis.y": "Y",
        "ifc_viewer.axis.z": "Z",
        "ifc_viewer.axis.rotX": "Rot X",
        "ifc_viewer.axis.rotY": "Rot Y",
        "ifc_viewer.axis.rotZ": "Rot Z",
        "ifc_viewer.transform_aria": "Adjust {{axis}} for {{name}}",
        "ifc_viewer.fit_view": "Fit view",
        "ifc_viewer.iframe_title": "Promang IFC Viewer",
        "ifc_viewer.back_to_drawing": "Back to drawing",
        "ifc_viewer.loading": "Loading…",
        "ifc_viewer.empty_viewer": "Upload at least one IFC model to view in 3D.",
        "ifc_viewer.selected_element": "Selected element",
        "ifc_viewer.close_selection": "Close",
        "ifc_viewer.selection.name": "Name",
        "ifc_viewer.selection.type": "Type",
        "ifc_viewer.selection.global_id": "GlobalId",
        "ifc_viewer.discipline_label": "Discipline",
        "ifc_viewer.discipline.ARK": "ARK – architect",
        "ifc_viewer.discipline.RIB": "RIB – structural",
        "ifc_viewer.discipline.RIV": "RIV – HVAC",
        "ifc_viewer.discipline.RIE": "RIE – electrical",
        "ifc_viewer.discipline.LAND": "LAND – landscape",
        "ifc_viewer.discipline.OTHER": "Other",
        "ifc_viewer.house_label": "House",
        "ifc_viewer.no_house": "No house",
        "ifc_viewer.filter_house": "Filter by house",
        "ifc_viewer.all_houses": "All houses",
        "ifc_viewer.focus_from_drawing": "Spot from drawing",
        "ifc_viewer.no_access": "You do not have access to the IFC Viewer.",
        "ifc_viewer.error_viewer_unavailable": "The IFC Viewer service is currently unavailable.",
        "ifc_viewer.error_no_ready_models": "None of the uploaded IFC models could be opened. Check that the upload finished processing, or try uploading again.",
        "ifc_viewer.error_session": "Could not start the 3D view.",
        "ifc_viewer.error_load": "Could not load IFC models.",
        "ifc_viewer.error_viewer_generic": "Something went wrong in the 3D view.",
        "ifc_viewer.error_viewer_down": "The IFC Viewer is down. Could not reach the 3D view.",
        "ifc_viewer.error_viewer_timeout": "Could not start the 3D view. Try again.",
        "ifc_viewer.error_model_failed": "The IFC file could not be loaded. Check the file, or upload it again.",
        "ifc_viewer.retry": "Try again",
        "ifc_viewer.error_upload": "IFC file upload failed.",
        "ifc_viewer.error_delete": "Could not delete model.",
        "ifc_viewer.tools": "Tools",
        "ifc_viewer.tools_open": "Open tools",
        "ifc_viewer.tools_close": "Close tools",
        "ifc_viewer.upload_dialog_title": "Upload IFC model",
        "ifc_viewer.upload_drop_hint": "Drag and drop .ifc files here",
        "ifc_viewer.upload_choose_files": "Choose files",
        "ifc_viewer.upload_selected": "Selected files ({{count}})",
        "ifc_viewer.upload_remove_file": "Remove {{name}}",
        "ifc_viewer.upload_name_label": "Display name (optional)",
        "ifc_viewer.upload_confirm": "Upload",
        "ifc_viewer.confirm_replace_model": "There is already a model \"{{name}}\" for this house and discipline. Replace it with the new upload?",
        "ifc_viewer.model_replaced": "The model was replaced.",
        "ifc_viewer.placement_kept": "The placement from the previous {{discipline}} was kept.",
        "ifc_viewer.discipline_required": "Select discipline…",
        "ifc_viewer.house_optional": "optional",
        "ifc_viewer.house_whole_project": "No house / whole project",
        "ifc_viewer.auto_align": "Auto-align",
        "ifc_viewer.auto_align_hint":
          "Shifts later models in X/Y so they sit on ARK (or the first model if ARK is missing).",
        "ifc_viewer.auto_align_done": "{{count}} models aligned to the first",
        "ifc_viewer.auto_align_unavailable":
          "Auto-align needs at least two models in the view.",
        "ifc_viewer.auto_align_on_upload":
          "{{count}} new models were placed on the first model",
        "ifc_viewer.remerge": "Rematch models",
        "ifc_viewer.remerge_hint":
          "Reads IFC coordinates and places every model on ARK (or the first model if ARK is missing).",
        "ifc_viewer.remerge_done": "{{count}} models were rematched to the first",
        "ifc_viewer.remerge_saved": "Rematch saved",
        "ifc_viewer.remerge_save_failed":
          "Could not save the rematch. Try again before reloading the page.",
        "ifc_viewer.remerge_house": "Rematch to the house",
        "ifc_viewer.remerge_house_hint":
          "Moves RIV and other trades so their footprint sits on the house (ARK). No coordinates to type.",
        "ifc_viewer.place_model": "Place model",
        "ifc_viewer.place_model_hint":
          "Click a point on the misplaced model, then the same spot on the house.",
        "ifc_viewer.place_include_z": "Include height",
        "ifc_viewer.place_unavailable":
          "Placing a model needs at least two models in the view.",
        "ifc_viewer.place_done": "The model was placed",
        "ifc_viewer.reload_models": "Reload models",
        "ifc_viewer.reload_models_done": "Models reloaded",
        "ifc_viewer.open_models": "Open model list",
        "ifc_viewer.close_models": "Close model list",
        "ifc_viewer.confirm_delete_model": "Delete {{name}}? This cannot be undone.",
        "ifc_viewer.nudge_minus": "Nudge {{axis}} down",
        "ifc_viewer.nudge_plus": "Nudge {{axis}} up",
        "ifc_viewer.rotate_left": "Rotate −90°",
        "ifc_viewer.rotate_right": "Rotate +90°",
        "ifc_viewer.reset_transform": "Reset",
        "ifc_viewer.reset_transform_hint": "Back to the model's own coordinates",
        "ifc_viewer.save_transforms": "Save alignment",
        "ifc_viewer.saving_transforms": "Saving…",
        "ifc_viewer.transforms_saved": "Alignment saved",
        "ifc_viewer.error_save_transforms": "Could not save the alignment.",
        "ifc_viewer.storey_filter": "Storey",
        "ifc_viewer.all_storeys": "All storeys",
        "ifc_viewer.empty_storey": "empty",
        "ifc_viewer.link_storeys": "Link storeys",
        "ifc_viewer.link_storeys_title": "Link storeys to {{name}}",
        "ifc_viewer.link_storeys_hint":
          "The system proposes links to the house storeys (same name, otherwise nearest elevation). You can change any row. The 3D view shows a section at the selected storey — slide or type meters.",
        "ifc_viewer.link_storeys_col_model": "Storey in {{name}}",
        "ifc_viewer.link_storeys_col_proposal": "Proposal",
        "ifc_viewer.link_storeys_col_datum": "Choose {{name}} storey",
        "ifc_viewer.link_storeys_unlink": "Do not link",
        "ifc_viewer.link_storeys_save": "Save",
        "ifc_viewer.link_storeys_skip": "Skip",
        "ifc_viewer.link_storeys_saved": "Storey links saved",
        "ifc_viewer.link_storeys_proposal_name": "Same name",
        "ifc_viewer.link_storeys_proposal_elevation": "Nearest elevation",
        "ifc_viewer.link_storeys_proposal_none": "No match",
        "ifc_viewer.link_storeys_empty_target": "{{name}} (empty)",
        "ifc_viewer.link_storeys_align": "Nudge against the house",
        "ifc_viewer.link_storeys_align_hint":
          "The main view shows the house and this model from above, with a horizontal section at the selected storey. Drag the sliders or type meters (e.g. 12.4) — not millimetres. Height is ±80 m.",
        "ifc_viewer.link_storeys_nudge_x": "Sideways",
        "ifc_viewer.link_storeys_nudge_y": "Depth",
        "ifc_viewer.link_storeys_nudge_z": "Height",
        "ifc_viewer.link_storeys_nudge_meters": "{{axis}} in meters",
        "ifc_viewer.link_storeys_reset_nudge": "Reset",
        "ifc_viewer.link_storeys_unavailable": "Load the models first",
        "ifc_viewer.apply_upright": "Stand upright",
        "ifc_viewer.upright_saved": "Upright orientation saved",
        "ifc_viewer.upright_save_failed":
          "Could not save the upright orientation. Try again before reloading.",
        "ifc_viewer.nav_hint":
          "Left: orbit · Right: pan · Wheel: zoom · G: walk · M: measure · L: laser · B: box · X: x-ray · Ctrl+Z: undo",
        "ifc_viewer.undo": "Undo",
        "ifc_viewer.redo": "Redo",
        "ifc_viewer.undo_hint": "Undo hide / isolate (Ctrl+Z)",
        "ifc_viewer.redo_hint": "Redo hide / isolate (Ctrl+Y)",
        "ifc_viewer.view_iso": "Iso",
        "ifc_viewer.view_top": "Top",
        "ifc_viewer.view_front": "Front",
        "ifc_viewer.view_side": "Side",
        "ifc_viewer.section": "Section",
        "ifc_viewer.section_on": "On",
        "ifc_viewer.section_off": "Off",
        "ifc_viewer.section_invert": "Flip side",
        "ifc_viewer.section_axis.x": "X",
        "ifc_viewer.section_axis.y": "Y",
        "ifc_viewer.section_axis.z": "Height",
        "ifc_viewer.isolate_model": "Isolate {{name}}",
        "ifc_viewer.isolate_model_hint":
          "Keep {{name}} fully opaque with real colors; other models become a ghost",
        "ifc_viewer.isolate_model_action": "Isolate model",
        "ifc_viewer.isolate_model_action_hint":
          "Full color; other models become ~20% transparent",
        "ifc_viewer.isolated": "Isolated",
        "ifc_viewer.section_model": "Section",
        "ifc_viewer.section_model_hint": "Activate a section through this model",
        "ifc_viewer.hide_model": "Hide model",
        "ifc_viewer.show_model": "Show model",
        "ifc_viewer.fit_this_model": "Fit this model",
        "ifc_viewer.clear_isolate": "Clear isolate",
        "ifc_viewer.menu_isolate": "Isolate",
        "ifc_viewer.menu_section": "Section",
        "ifc_viewer.menu_section_hint": "Cut through this model's mid-height",
        "ifc_viewer.menu_hide": "Hide",
        "ifc_viewer.menu_show": "Show",
        "ifc_viewer.menu_fit": "Center",
        "ifc_viewer.menu_clear_isolate": "Clear isolate",
        "ifc_viewer.menu_close": "Close",
        "ifc_viewer.menu_close_hint": "Close the menu",
        "ifc_viewer.show_all_models": "Show all models",
        "ifc_viewer.isolate_element": "Isolate",
        "ifc_viewer.hide_element": "Hide",
        "ifc_viewer.show_all_elements": "Show all",
        "ifc_viewer.walk": "Walk",
        "ifc_viewer.walk_hint": "First person: WASD, mouse to look, Q/E up and down",
        "ifc_viewer.measure": "Measure",
        "ifc_viewer.measure_point": "Point to point",
        "ifc_viewer.measure_point_hint": "Distance between two clicks",
        "ifc_viewer.measure_planar": "2D section",
        "ifc_viewer.measure_planar_hint": "Measure in the horizontal or current section plane",
        "ifc_viewer.laser": "Laser",
        "ifc_viewer.laser_hint": "3-axis laser (X/Y/Z) from one point",
        "ifc_viewer.clear_measures": "Clear measures",
        "ifc_viewer.clear_measures_title": "Remove all measures and lasers",
        "ifc_viewer.clear_last_measure": "Clear last",
        "ifc_viewer.cut_box": "Box",
        "ifc_viewer.xray": "X-ray",
        "ifc_viewer.isolate_type": "Isolate type",
        "ifc_viewer.hide_type": "Hide type",
        "ifc_viewer.selection.object_type": "ObjectType",
        "ifc_viewer.selection.tag": "Tag",

        "drawings.observation.add": "Add",
        "drawings.observation.dialog_title": "Add observation",
        "drawings.observation.place_on_drawing": "Place on drawing",
        "drawings.observation.place_hint": "Click the drawing to drop the pin",
        "drawings.observation.placement_banner": "Click the drawing to place",
        "drawings.observation.page": "Page",
        "drawings.observation.optional": "optional",
        "drawings.observation.photo_default_title": "Site photo",
        "drawings.observation.photo_drop": "Drop an image here or click to browse",
        "drawings.observation.photo_drop_hint": "JPG, PNG, WEBP",
        "drawings.observation.photo_caption_placeholder": "Short caption for this photo",
        "drawings.observation.note_placeholder": "Write your note…",
        "drawings.observation.deviation_title_placeholder": "Brief description of the issue",
        "drawings.observation.deviation_desc_placeholder": "Additional details, location on site, etc.",
        "drawings.observation.project_required": "Link a project to this drawing to create deviations.",
        "drawings.observation.create_error": "Could not create observation",
        "drawings.observation.capture_bind_error":
          "Could not bind the snapshot to the deviation. The observation was not placed.",
        "drawings.observation.deviation_placed": "Deviation placed on drawing",
        "drawings.observation.photo_placed": "Photo placed on drawing",
        "drawings.observation.note_placed": "Note placed on drawing",
        "drawings.observation.field.title": "Title",
        "drawings.observation.field.category": "Category",
        "drawings.observation.field.severity": "Severity",
        "drawings.observation.field.description": "Description",
        "drawings.observation.field.status": "Status",
        "drawings.observation.field.project": "Project",
        "drawings.observation.field.place": "Location",
        "drawings.observation.field.created_by": "Created by",
        "drawings.observation.field.created_at": "Date",
        "drawings.observation.field.photo": "Photo",
        "drawings.observation.field.caption": "Caption",
        "drawings.observation.field.note": "Note",
        "drawings.observation.field.pin_color": "Pin colour",
        "drawings.observation.field.drawing": "Drawing sheet",
        "drawings.observation.type.photo": "Photo",
        "drawings.observation.type.photo_desc": "Attach a site photo",
        "drawings.observation.type.deviation": "Deviation",
        "drawings.observation.type.deviation_desc": "Log a non-conformance",
        "drawings.observation.type.note": "Note",
        "drawings.observation.type.note_desc": "Pin a free text note",
        "drawings.observation.type.checklist": "Checklist",
        "drawings.observation.type.checklist_desc": "New from template or link existing",
        "drawings.observation.checklist_project_required": "Link a project to the drawing to add a checklist.",
        "drawings.observation.checklist_project_copy": "Checklists belong to the project. You can pin them on this drawing, or leave them as project checklists without a pin.",
        "drawings.observation.checklist_placed": "Checklist placed on drawing",
        "drawings.observation.checklist_mode.new": "New from template",
        "drawings.observation.checklist_mode.link": "Link existing",
        "drawings.observation.checklist_type_placeholder": "Select checklist type",
        "drawings.observation.checklist_types_loading": "Loading types…",
        "drawings.observation.checklist_items_selected": "{{count}} items selected",
        "drawings.observation.checklist_title_placeholder": "Optional checklist title",
        "drawings.observation.checklist_search_placeholder": "Search project checklists",
        "drawings.observation.checklist_link_empty": "No available checklists to link (all are already pinned, or the list is empty).",
        "drawings.observation.field.checklist_type": "Checklist type",
        "drawings.observation.field.house": "House",
        "drawings.observation.field.apartment": "Apartment number",
        "drawings.observation.checklist_house_placeholder": "e.g. House A",
        "drawings.observation.checklist_apartment_placeholder": "e.g. H0101",
        "drawings.observation.field.existing_checklist": "Existing checklist",
        "drawings.observation.field.link_checklist": "Link to checklist",
        "drawings.observation.checklist_none": "No checklist",
        "drawings.observation.field.search": "Search",
        "drawings.observation.field.marker_shape": "Marker shape",
        "drawings.observation.marker.arrow": "Arrow",
        "drawings.observation.marker.circle": "Circle",
        "drawings.observation.marker.rectangular": "Rectangle",
        "drawings.observation.current_drawing_hint": "Placed on current drawing: {{title}} (page {{page}})",
        "drawings.observation.sketch.toggle": "Markup / sketch on snapshot",
        "drawings.observation.sketch.toggle_hint": "After you click the drawing you can draw freehand, arrow, circle, rectangle or text on the snapshot area.",
        "drawings.observation.sketch.title": "Sketch on snapshot",
        "drawings.observation.sketch.help": "Draw markups on the crop. Select text to move it, or double-click to edit. Marks stay until you press Done, Skip or Cancel.",
        "drawings.observation.sketch.pen": "Freehand",
        "drawings.observation.sketch.arrow": "Arrow",
        "drawings.observation.sketch.circle": "Circle",
        "drawings.observation.sketch.rectangular": "Rectangle",
        "drawings.observation.sketch.text": "Text",
        "drawings.observation.sketch.text_prompt": "Enter text markup",
        "drawings.observation.sketch.undo": "Undo",
        "drawings.observation.sketch.redo": "Redo",
        "drawings.observation.sketch.clear": "Clear",
        "drawings.observation.sketch.skip": "Skip",
        "drawings.observation.sketch.done": "Use sketch",
        "drawings.observation.relocate": "Move",
        "drawings.observation.relocate_hint": "Click the drawing to set a new position.",
        "drawings.observation.relocate_saved": "New position set — remember to save changes.",
        "drawings.observation.sync_pending_badge": "Saving",
        "drawings.observation.sync_error_badge": "Not saved",
        "drawings.observation.retry_save": "Retry save",
        "drawings.observation.retry_needs_photo": "The photo is missing locally. Add the photo again to save.",
        "drawings.viewer.checklist_add": "Add checklist",
        "drawings.viewer.checklist_link": "Link to drawing",
        "drawings.viewer.checklists_project_copy": "Checklists belong to the project. Pin them on the drawing when needed — or create a new one.",
        "drawings.module.checklist": "Checklist",
        "drawings.observation.severity.minor": "Minor",
        "drawings.observation.severity.major": "Major",
        "drawings.observation.severity.critical": "Critical",
        "drawings.observation.view_details": "View details",
        "drawings.observation.snapshot_title": "Drawing snapshot",
        "drawings.observation.deviation_docs": "Documents on drawing",
        "drawings.observation.deviation_docs_empty":
          "No documents yet. Use the camera to add a photo with pin and snapshot.",
        "drawings.observation.include_snapshot_in_print": "Include drawing snapshot when printing checklists",
        "drawings.observation.snapshot_print_saved": "Print setting saved",
        "drawings.observation.open_deviation": "Open deviation",
        "drawings.observation.go_to_deviation": "Go to deviation",
        "drawings.observation.open_deviation_page": "Open deviation page",
        "drawings.observation.tab.details": "Details",
        "drawings.observation.tab.comments": "Comments",
        "drawings.observation.field.consequence_type": "Consequence type",
        "drawings.observation.consequence_type_placeholder": "Select consequence type",
        "drawings.observation.consequence_type.Economic": "Economic",
        "drawings.observation.consequence_type.Progress": "Progress",
        "drawings.observation.consequence_type.Safety": "Safety",
        "drawings.observation.consequence_type.Environment": "Environment",
        "drawings.observation.consequence_type.Quality": "Quality",
        "drawings.observation.consequence_type.Authority": "Authority",
        "drawings.observation.consequence_type.Other": "Other",
        "drawings.observation.sketch.select": "Select",
        "drawings.viewer.open_deviation_dialog": "View details",
        "drawings.observation.document_missing": "Photo document could not be loaded",
        "drawings.observation.note_empty": "No note text",
        
        // Events sidebar and scheduling
        "Events": "Events",
        "Your schedule for the selected day": "Your schedule for the selected day",
        "Loading events...": "Loading events...",
        "No events to show": "No events to show",
        "Event": "Event",
        "Conflict": "Conflict",
        "item_list_handling.pick_progress_short": "{{picked}}/{{total}} picked",
        "item_list_handling.pick_progress_tooltip": "Handling list: {{picked}} of {{total}} lines picked. List status: {{status}}.",
        "Planned time": "Planned time",
        "Start": "Start",
        "End": "End",
        "Location": "Location",
        "Assumed 60 min duration for conflict check": "Assumed 60 min duration for conflict check",
        "Executing Employee": "Executing Employee",
        "Agreement date": "Agreement date",
        "Fixed time": "Fixed time",
        "Timeframe from": "Timeframe from",
        "Timeframe to": "Timeframe to",
        "Appointment confirmation required": "Appointment confirmation required",
        "Send email to customer": "Send email to customer",
        "Phone number": "Phone number",
        "Email address": "Email address",
        "Manually confirm agreement": "Manually confirm agreement",
        "Send confirmation reminder": "Send confirmation reminder",
  
        // Customer Handler translations
        "customer.handler": "Customer Handler",
        "customer.handler.description": "Search for customers, create conversations and manage customer communications",
        "customer.handler.selected.section": "Selected customer",
        "customer.handler.related.information": "Related information",
        "customer.handler.open.customer.profile": "Open customer profile",
        "customer.handler.open.customer.profile.hint": "Opens the customer profile in a new tab",
        "customer.handler.no.contact.info": "No address, email or mobile on file",
        "customer.handler.edit.customer": "Edit customer",
        "customer.handler.edit.communication": "Edit",
        "customer.handler.communication.subject": "Subject",
        "customer.handler.communication.body": "Content",
        "customer.handler.communication.update.success": "Communication updated",
        "search.customer": "Search customer",
        "search.by.mobile.or.address": "Search by mobile number or address",
        "search.by.mobile.or.address.hint": "Enter mobile number or address to search",
        "searching": "Searching...",
        "search": "Search",
        "search.results": "Search results",
        "search.failed": "Search failed",
        "search.failed.server.error": "Server error occurred",
        "search.failed.server.error.message": "An error occurred while searching. Please try again. Do not create a new customer if you believe the customer already exists.",
        "search.failed.unexpected.response": "Unexpected response from server",
        "search.error.title": "Search Error",
        "search.error.hint": "Please try searching again. If the problem persists, contact support. Do not create a duplicate customer.",
        "create.conversation": "Create conversation",
        "name.or.mobile.required": "Name or mobile number is required",
        "unknown.customer": "Unknown customer",
        "conversation.saved": "Conversation saved",
        "conversation.saved.and.handled": "Conversation saved and handled",
        "failed.to.create.customer": "Failed to create customer",
        "communication.added": "Communication added",
        "failed.to.add.communication": "Failed to add communication",
        "communication.marked.processed": "Communication marked as processed",
        "communication.marked.unprocessed": "Communication marked as unprocessed",
        "failed.to.update.communication": "Failed to update communication",
        "no.communications.selected": "No communications selected",
        "communications.linked.to.case": "Communications linked to case",
        "failed.to.link.communications": "Failed to link communications",
        "selected.communications": "Selected communications",
        "link.to.case": "Link to case",
        "see.more": "See more",
        "mark.as.processed": "Mark as processed",
        "channel": "Channel",
        "direction": "Direction",
        "sent.at": "Sent",
        "start.time": "Start time",
        "end.time": "End time",
        "related": "Related",
        "processed": "Processed",
        "unprocessed": "Unprocessed",
        "created.by": "Created by",
        "street.address": "Gateadresse",
        "postal.code": "Postnummer",
        "city": "By",
        "conversation.date": "Samtaledato",
        "conversation.time": "Samtaletid",
        "conversation.note.placeholder": "Legg til notat om samtalen...",
        "save": "Lagre",
        "handle": "Behandle",
        "selected.customer": "Valgt kunde",
        "loading": "Laster...",
        "loading.customer": "Laster kunde...",
        "communications": "Kommunikasjoner",
        "inbound": "Innkommende",
        "outbound": "Utgående",
        "no.communications": "Ingen kommunikasjoner funnet",
        "no.cases": "Ingen saker funnet",
        "upcoming.events": "Kommende hendelser",
        "no.events": "Ingen hendelser funnet",
        "add.communication": "Legg til kommunikasjon",
        "pending": "Venter",
        "handled": "Behandlet",
        "Communication": "Communication",
        "Message": "Message",
        "Channel": "Channel",
        "Direction": "Direction",
        "Customer": "Customer",
        "link.to.case.choice.description": "Do you want to link to an existing case or create a new one?",
        "link.to.existing.case": "Link to existing case",
        "link.to.existing.case.description": "Search and select an existing case",
        "create.new.case": "Create new case",
        "create.new.case.description": "Create a new case and link communications",
        "search.case": "Search case",
        "search.case.placeholder": "Search by case number, title, or customer...",
        "no.cases.found": "No cases found",
        "cases": "Cases",
        "customer.cases": "Customer's cases",
        "case.empty.updates": "No updates yet",
        "case.empty.hint": "Write an update below to get started",
        "case.load.error_title": "Could not load the case",
        "case.load.error_hint": "Something went wrong while loading the case. Check your connection and try again.",
        "case.load.retry": "Try again",
        "case.feed.error_title": "Could not load updates",
        "case.finish_after_prompt": "Do you want to finish the case afterwards?",
        "linking.communications": "Linking communications...",
        "treatment.section": "Treatment Section",
        "treatment.section.description": "All communications requiring treatment",
        "search.communications": "Search communications...",
        "all.statuses": "All statuses",
        "all.channels": "All channels",
        "phone": "Phone",
        "email": "Email",
        "sms": "SMS",
        "showing": "Showing",
        "of": "of",
        "customer.lock.badge": "Locked",
        "customer.lock.banner_title": "{{name}} is locked",
        "customer.lock.banner_reason": "Reason: {{reason}}",
        "customer.lock.banner_meta": "Locked by {{who}} {{when}}",
        "customer.lock.no_reason": "No reason given",
        "customer.lock.unknown_user": "Unknown",
        "customer.lock.open_profile": "Open customer profile",
        "customer.lock.lock_title": "Lock customer",
        "customer.lock.unlock_title": "Unlock customer",
        "customer.lock.lock_action": "Lock customer",
        "customer.lock.unlock_action": "Unlock",
        "customer.lock.reason_label": "Why is the customer locked?",
        "customer.lock.reason_required": "A reason is required",
        "customer.lock.unlock_help": "The customer can be used for new reports, projects and orders again.",
        "customer.lock.unlock_note": "Note (optional)",
        "customer.lock.current_reason": "Current reason: {{reason}}",
        "customer.lock.lock_success": "Customer locked",
        "customer.lock.unlock_success": "Customer unlocked",
        "customer.lock.save_failed": "Could not update lock",
        "customer.lock.create_blocked": "This customer is locked. You cannot create new records or move existing ones here.",
        "customer.lock.reason_too_long": "The reason cannot be longer than {{max}} characters",
        "customer.lock.note_too_long": "The note cannot be longer than {{max}} characters",
        "customer.communication.export_pdf": "Export PDF",
        "customer.communication.pdf_loading": "Creating PDF…",
        "customer.communication.pdf_failed": "Could not create PDF",
        "customer.loaded": "Customer loaded",
        "customer.not.found": "Customer not found",
        "failed.to.load.communications": "Failed to load communications",
        "failed.to.load.customer": "Failed to load customer",
  
        // Inventory Count translations (English)
        "inventory.counts.title": "Inventory Counts",
        "inventory.counts.description": "Manage inventory counts and stocktaking",
        "inventory.count.title": "Inventory Count",
        "inventory.count.create": "New Count",
        "inventory.count.count_number": "Count Number",
        "inventory.count.date": "Date",
        "inventory.count.status": "Status",
        "inventory.count.status.draft": "Draft",
        "inventory.count.status.pending_approval": "Pending Approval",
        "inventory.count.status.approved": "Approved",
        "inventory.count.status.completed": "Completed",
        "inventory.count.add_item": "Add Item",
        "inventory.count.select_product": "Select Product",
        "inventory.count.scan_qr": "Scan QR Code",
        "inventory.count.import_csv": "Import CSV/Excel",
        "inventory.count.selected_products": "Selected Products",
        "inventory.count.item_number": "Item Number",
        "inventory.count.remove": "Remove",
        "inventory.count.note_optional": "Note (optional)",
        "inventory.count.note_placeholder": "Add note...",
        "inventory.count.reset": "Reset",
        "inventory.count.add_products": "Add Products",
        "inventory.count.add_product": "Add Product",
        "inventory.count.add_scanned_product": "Add Scanned Product",
        "inventory.count.scan_another": "Scan Another",
        "inventory.count.select_products": "Select Products",
        "inventory.count.products_selected": "{{count}} product(s) selected",
        "inventory.count.qr.required": "Enter or scan a QR code",
        "inventory.count.qr.placeholder": "Enter product number or scan QR code",
        "inventory.count.product.already_selected": "Product already selected",
        "inventory.count.product.added": "Product added",
        "inventory.count.product.not_found": "Product not found. Try manual search.",
        "inventory.count.product.search_error": "Could not search for product",
        "inventory.count.product.select_required": "Select at least one product",
        "inventory.count.items": "Items",
        "inventory.count.product": "Product",
        "inventory.count.quantity": "Quantity",
        "inventory.count.purchase_price": "Purchase Price",
        "inventory.count.total": "Total",
        "inventory.count.note": "Note",
        "inventory.count.total_items": "Total Items",
        "inventory.count.total_quantity": "Total Quantity",
        "inventory.count.no_items": "No Items",
        "inventory.count.no_items_description": "Add items to start the count",
        "inventory.count.item.added": "Item added successfully",
        "inventory.count.item.add_error": "Could not add item",
        "inventory.count.item.updated": "Item updated successfully",
        "inventory.count.item.update_error": "Could not update item",
        "inventory.count.item.deleted": "Item deleted successfully",
        "inventory.count.item.delete_error": "Could not delete item",
        "inventory.count.item.delete_confirm": "Are you sure you want to remove this item?",
        "inventory.count.quantity_required": "Quantity must be greater than 0",
        "inventory.count.csv.import_title": "Import Items from CSV/Excel",
        "inventory.count.csv.drop_here": "Drop file here",
        "inventory.count.csv.drop_or_select": "Drag and drop a file here, or click to select",
        "inventory.count.csv.supported_formats": "CSV, XLS, XLSX",
        "inventory.count.csv.file_selected": "File selected",
        "inventory.count.csv.change_file": "Change File",
        "inventory.count.csv.column_mapping": "Column Mapping",
        "inventory.count.csv.field.product_id": "Product ID",
        "inventory.count.csv.field.item_number": "Item Number",
        "inventory.count.csv.field.title": "Title",
        "inventory.count.csv.field.quantity": "Quantity",
        "inventory.count.csv.field.purchase_price": "Purchase Price",
        "inventory.count.csv.field.note": "Note",
        "inventory.count.csv.not_mapped": "Not mapped",
        "inventory.count.csv.preview": "Preview",
        "inventory.count.csv.first_rows": "first rows",
        "inventory.count.csv.import": "Import",
        "inventory.count.csv.importing": "Importing...",
        "inventory.count.csv.import_success": "Successfully imported {{count}} items",
        "inventory.count.csv.import_error": "Could not import items",
        "inventory.count.csv.bulk_create_error": "Could not create products in bulk",
        "inventory.count.csv.mapping_required": "Please map at least Product ID or Item Number",
        "inventory.count.csv.no_headers": "Could not detect CSV headers",
        "inventory.count.csv.read_error": "Error reading file",
        "inventory.count.csv.processing_error": "Error processing file",
        "inventory.count.csv.product_not_found": "Product not found",
        "inventory.count.csv.product_search_error": "Error searching for product",
        "inventory.count.csv.product_id_required": "Product ID or Item Number required",
        "inventory.count.csv.no_valid_items": "No valid items found in file",
        "inventory.count.csv.missing_products_title": "Products Not Found",
        "inventory.count.csv.missing_products_message": "{{count}} product(s) were not found in the system. Choose an action for each:",
        "inventory.count.csv.action": "Action",
        "inventory.count.csv.add_as_new": "Add as New Product",
        "inventory.count.csv.skip": "Skip",
        "inventory.count.csv.continue_import": "Continue Import",
        "inventory.count.csv.processing_items": "Processing {{current}} of {{total}} products",
        "inventory.count.csv.processing": "Processing...",
        "inventory.count.csv.partial_import_success": "Imported {{imported}} items, {{missing}} products not found",
        "inventory.count.csv.no_items_to_import": "No items to import",
        "inventory.count.duplicate.title": "Product Already in List",
        "inventory.count.duplicate.message": "This product is already in the count list. Do you want to add another line?",
        "inventory.count.duplicate.added_at": "Added at",
        "inventory.count.duplicate.confirm": "Add Another Line",
        "inventory.counts.search_placeholder": "Search inventory counts...",
        "inventory.counts.filter_title": "Filter by Status",
        "inventory.count.new_title": "New Inventory Count",
        "inventory.count.title_required": "Title is required",
        "inventory.count.date_required": "Date is required",
        "inventory.count.storage_required": "Storage is required",
        "inventory.count.storage": "Storage",
        "inventory.count.coverage": "Coverage",
        "inventory.count.coverage_full": "Full storage count",
        "inventory.count.coverage_partial": "Partial count",
        "inventory.count.coverage_help": "A full count is required for opening inventory value. New counts with a storage default to full. Approved partial counts can be marked full here.",
        "inventory.count.mark_coverage_full": "Mark as full count",
        "inventory.count.mark_coverage_partial": "Mark as partial",
        "inventory.count.coverage_set_full": "Count marked as full coverage",
        "inventory.count.coverage_set_partial": "Count marked as partial",
        "inventory.count.coverage_update_error": "Could not update coverage",
        "inventory.count.missing_cost_warning_title": "Cost price missing on count",
        "inventory.count.missing_cost_warning_body": "{{count}} line(s) with quantity are missing a cost price. Enter a purchase price or pick from price history before approving inventory valuation.",
        "inventory.count.missing_cost_line": "Cost price missing",
        "inventory.count.load_price_history": "Load price history",
        "inventory.count.retry_price_history": "Retry price history",
        "inventory.count.price_history": "Historical cost",
        "inventory.count.use_history_for_count_date": "Use price for count date",
        "inventory.count.price_history_load_error": "Could not load price history",
        "inventory.count.price_history_empty": "No historical cost found for the count date",
        "inventory.count.select_storage": "Select storage",
        "inventory.count.create_success": "Inventory count created successfully",
        "inventory.count.create_error": "Could not create inventory count",
        "inventory.count.approve": "Approve",
        "inventory.count.unapprove": "Unapprove",
        "inventory.count.approve_all": "Approve All",
        "inventory.count.unapprove_all": "Unapprove All",
        "inventory.count.approve_all_success": "{{count}} items approved successfully",
        "inventory.count.approve_all_error": "Could not approve all items",
        "inventory.count.all_items_already_approved": "All items are already approved",
        "inventory.count.approved": "Approved",
        "inventory.count.approved_at": "Approved at",
        "inventory.count.approved_by": "Approved by",
        "inventory.count.approve_success": "Count approved successfully",
        "inventory.count.approve_error": "Could not approve count",
        "inventory.count.unapprove_success": "Count unapproved successfully",
        "inventory.count.unapprove_error": "Could not unapprove count",
        "inventory.count.copy": "Copy Count",
        "inventory.count.no_title": "No title",
        "inventory.count.could_not_load": "Could not load inventory counts",
        "inventory.count.no_counts_found": "No inventory counts found",
        "inventory.count.create_new": "Create a new inventory count",
        "selected": "selected",
        "Select": "Select",
        "Select all": "Select all",
        "Updated": "Updated",
        "Created": "Created",
        "inventory.count.copy_from_previous": "Copy from Previous Count",
        "inventory.count.copy_all_products": "Copy All Products from Stock",
        "inventory.count.select_count_to_copy": "Select Count to Copy",
        "inventory.count.copy_success": "Count copied successfully",
        "inventory.count.copy_error": "Could not copy count",
        "inventory.count.copy_products_success": "Products copied successfully",
        "inventory.count.copy_products_error": "Could not copy products",
        "inventory.count.approved_items": "Approved Items",
        "inventory.count.approve_count": "Approve Count",
        "inventory.count.date_updated": "Date updated successfully",
        "inventory.count.date_update_error": "Could not update date",
        "inventory.count.storage_updated": "Storage updated successfully",
        "inventory.count.storage_update_error": "Could not update storage",
        "inventory.count.no_storage": "No storage",
        "inventory.count.export_pdf": "Export PDF",
        "inventory.count.export_csv": "Export CSV/Excel",
        "inventory.count.export_pdf_success": "PDF exported successfully",
        "inventory.count.export_pdf_error": "Could not export PDF",
        "inventory.count.export_csv_success": "CSV exported successfully",
        "inventory.count.export_csv_error": "Could not export CSV",
        "inventory.count.product_stock": "Product Stock",
        "product.stock_report.title": "Stock Report",
        "product.stock_report.description": "Complete overview of all stock transactions (in/out) and where the product is registered (counts, corrections, orders, reports, etc.)",
        "product.stock_report.count_sets_hint": "An approved stock count sets a new balance for the product in that storage. The counted quantity is not added on top of the previous balance.",
        "product.stock_report.quantity_set": "Set to {{quantity}}",
        "product.stock_report.quantity_set_delta": "Adjustment {{quantity}}",
        "product.stock_report.quantity_not_counted": "Not counted",
        "product.stock_report.date": "Date",
        "product.stock_report.type": "Type",
        "product.stock_report.transaction_title": "Title",
        "product.stock_report.quantity": "Quantity",
        "product.stock_report.storage": "Storage",
        "product.stock_report.status": "Status",
        "product.stock_report.approved": "Approved",
        "product.stock_report.pending": "Pending",
        "product.stock_report.no_transactions": "No transactions",
        "product.stock_report.no_transactions_description": "No stock transactions found for this product",
        "inventory.count.tracked_quantity": "Tracked Quantity",
        "inventory.count.available_quantity": "Available Quantity",
        "inventory.count.incoming_quantity": "Incoming Quantity",
        "inventory.count.outgoing_quantity": "Outgoing Quantity",
        "inventory.count.sales_price": "Sales Price",

        "inventory.settings.title": "Inventory settings",
        "inventory.settings.subtitle": "Manage storages and picking list options",
        "inventory.settings.new_storage": "New storage",
        "inventory.settings.storages": "Storages",

        "inventory.picking.title": "Picking list",
        "inventory.picking.subtitle": "Orders, work orders and service reports — lines that need picking",
        "inventory.picking.hero_kicker": "Inventory",
        "inventory.picking.filters_heading": "Filters & search",
        "inventory.picking.filters_description": "Narrow which document types and lines appear. Orders are off by default — select Order to include them.",
        "inventory.picking.list_kicker": "Picking",
        "inventory.picking.list_title": "Documents & lines",
        "inventory.picking.list_description": "Expand each document to see product lines, choose warehouse, and record picks.",
        "inventory.picking.loading": "Loading…",
        "inventory.picking.empty_title": "Nothing to show",
        "inventory.picking.picked_label": "Picked",
        "inventory.picking.meta.groups": "Groups",
        "inventory.picking.meta.lines": "Lines",
        "inventory.picking.search_placeholder": "Search order, product, item number…",
        "inventory.picking.filter.unpicked_only": "Only unpicked / partial",
        "inventory.picking.filter.warehouse_only": "Warehouse products only",
        "inventory.picking.filter.warehouse_only_help": "When on, only lines whose product is marked for warehouse tracking are shown — if every product is warehouse-tracked, the list looks the same as when this is off. When off, all lines appear; non-warehouse products get an amber row and the “Not warehouse-tracked” badge.",
        "inventory.picking.filter.include_skipped": "Show “do not pick” lines",
        "inventory.picking.filter.include_skipped_help": "Lines marked as not to be picked are hidden by default so the list stays focused. Turn this on to see them again (e.g. to clear the flag).",
        "inventory.picking.non_warehouse_badge": "Not warehouse-tracked",
        "inventory.picking.non_warehouse_hint": "This product is not marked for warehouse/inventory tracking. You can still pick it and choose storage if needed.",
        "inventory.picking.refresh": "Refresh",
        "inventory.picking.empty": "Nothing to pick with the current filters.",
        "inventory.picking.load_error": "Could not load picking list",
        "inventory.picking.open_source": "Open document",
        "inventory.picking.open_document_short": "Open",
        "inventory.picking.open_item_list": "Item list",
        "inventory.picking.qty": "Qty",
        "inventory.picking.qty_picked": "Picked",
        "inventory.picking.storage": "Storage",
        "inventory.picking.pick_storage": "Warehouse",
        "inventory.picking.storage_placeholder": "Select warehouse…",
        "inventory.picking.storage_required": "Select a warehouse before marking as picked",
        "inventory.picking.toggle_picked": "Mark picked",
        "inventory.picking.marked_picked": "Marked as picked",
        "inventory.picking.marked_unpicked": "Picking cleared",
        "inventory.picking.toggle_error": "Could not update line",
        "inventory.picking.skip.label": "Do not pick",
        "inventory.picking.skip.badge": "Not for picking",
        "inventory.picking.skip.row_hint": "This line is excluded from warehouse picking. Clear “Do not pick” to require a pick again.",
        "inventory.picking.skip.blocks_pick": "Clear “Do not pick” before marking as picked.",
        "inventory.picking.skip.on": "Marked as not for picking",
        "inventory.picking.skip.off": "Line is pickable again",
        "inventory.picking.skip.error": "Could not update “do not pick”",
        "inventory.picking.send_reminder": "Send reminder",
        "inventory.picking.reminder_sent": "Reminder queued",
        "inventory.picking.reminder_error": "Could not send reminder",
        "inventory.picking.delivery_note.tooltip": "Print delivery note (følgeseddel, PDF)",
        "inventory.picking.delivery_note.opened": "Delivery note opened in a new tab",
        "inventory.picking.delivery_note.failed": "Could not create delivery note PDF",
        "inventory.picking.delivery_note.missing_id": "Missing document id",
        "inventory.picking.delivery_note.unsupported": "Delivery note is not available for this document type yet",
        "inventory.picking.module.order": "Order",
        "inventory.picking.module.work_order": "Work order",
        "inventory.picking.module.report": "Report",
        "inventory.picking.execution_on": "Execution date",
        "inventory.picking.status.invoiced": "Invoiced",
        "inventory.picking.status.used_job": "Used on job",
        "inventory.picking.status.in_vehicle": "Taken in vehicle",
        "inventory.picking.status.not_used": "Not used",
        "inventory.picking.status.returned": "Returned to storage",
        "inventory.picking.status.left_vehicle": "Left in vehicle",
        "inventory.picking.status.picked": "Picked",
        "inventory.picking.status.not_picked": "Not picked",
        "inventory.picking.settings.title": "Picking list reminders",
        "inventory.picking.settings.description": "Users who receive email when you use “Send reminder” on the picking list.",
        "inventory.picking.settings.recipients": "Recipients",
        "inventory.picking.settings.recipients_placeholder": "Select users…",
        "inventory.picking.settings.save": "Save",
        "inventory.picking.settings.saving": "Saving…",
        "inventory.picking.settings.saved": "Settings saved",
        "inventory.picking.settings.save_error": "Could not save settings",
        "inventory.picking.settings.load_error": "Could not load picking settings",

        "Exporting...": "Exporting...",
        "Processing...": "Processing...",
        
        // Offer Calculation translations (English)
        "offer.calculation.title": "Calculations / Offer Items",
        "offer.calculation.subtitle": "Manage calculations and offer items",
        "offer.calculation.new": "New Calculation",
        "offer.calculation.create.dialog_title": "New calculation",
        "offer.calculation.create.dialog_hint": "Choose the calculation setup and enter a title before opening the builder. The setup is locked after creation.",
        "offer.calculation.create.mode_subtitle": "Choose whether this calculation should use lines or the module builder.",
        "offer.calculation.create.title_label": "Title",
        "offer.calculation.create.title_required": "Title is required",
        "offer.calculation.create.description_label": "Description",
        "offer.calculation.create.cancel": "Cancel",
        "offer.calculation.create.submit": "Create and open",
        "offer.calculation.create.use_template": "Use an existing template",
        "offer.calculation.create.use_template_hint": "Copy content from a company template into a new calculation. The optional TPL wizard runs when the template requires it.",
        "offer.calculation.search_placeholder": "Search calculations...",
        "offer.calculation.name": "Name",
        "offer.calculation.type": "Type",
        "offer.calculation.status": "Status",
        "offer.calculation.total": "Total",
        "offer.calculation.actions": "Actions",
        "offer.calculation.view": "View",
        "offer.calculation.edit": "Edit",
        "offer.calculation.delete": "Delete",
        "offer.calculation.delete_confirm": "Are you sure you want to delete this calculation?",
        "offer.calculation.no_results": "No calculations found",
        "offer.calculation.active": "Active",
        "offer.calculation.inactive": "Inactive",
        "offer.calculation.type.standard": "Standard",
        "offer.calculation.type.product": "Product",
        "offer.calculation.type.hours": "Hours",
        "offer.calculation.type.car_allowance": "Car Allowance",
        "offer.calculation.type.nested": "Nested",
        "offer.calculation.line": "line",
        "offer.calculation.lines": "lines",
        "offer.calculation.delete_success": "Calculation deleted successfully",
        "offer.calculation.delete_error": "Could not delete calculation",
        "offer.calculation.untitled": "Untitled",
        "offer.calculation.mode.title": "Choose calculation setup",
        "offer.calculation.mode.subtitle": "Choose whether this calculation should use regular lines or the module builder. This is locked after the calculation is saved.",
        "offer.calculation.mode.lines_title": "Line calculation",
        "offer.calculation.mode.lines_hint": "Use the existing line-based calculation with products, hours and manual rows.",
        "offer.calculation.mode.modules_title": "Module builder",
        "offer.calculation.mode.modules_hint": "Build a visual flow with products, hours, formulas and arrows.",
        "offer.calculation.mode.locked_hint": "Calculation setup is locked after creation to avoid mixing lines and the module builder.",
        "offer.calculation.settings.open": "Settings",
        "offer.calculation.settings.title": "Calculation settings",
        "offer.calculation.settings.subtitle": "Title, calculation setup and display.",
        "offer.calculation.settings.done": "Done",
        "offer.calculation.settings.unsaved": "Unsaved changes",
        "offer.calculation.settings.save_hint": "Save with the save bar at the bottom of the page.",
        "offer.calculation.builder.section_title": "Calculation builder",
        "offer.calculation.builder.section_hint": "Keep the existing lines, or build a visual module-based calculation that can connect to the backend later.",
        "offer.calculation.builder.section_hint_lines": "This calculation is line-based. Use lines, products, hours and manual rows.",
        "offer.calculation.builder.section_hint_modules": "This calculation uses the module builder. Build the flow visually and test it in user insert view.",
        "offer.calculation.builder.tab_lines": "Lines",
        "offer.calculation.builder.tab_modules": "Module builder",
        "offer.calculation.builder.tab_insert": "Insert view",
        "offer.calculation.builder.tab_history": "History",
        "offer.calculation.builder.history_hint": "Open template versions to review previous saves and restore if needed.",
        "offer.calculation.page.kicker": "Offer calculation",
        "offer.calculation.page.subtitle": "Build, test and use calculations in a full-width workspace with lines, modules and a dedicated insert view.",
        "offer.calculation.insert.title": "Insert view",
        "offer.calculation.insert.subtitle": "This is how the calculation feels when pasted into offers, modules or other flows.",
        "offer.calculation.insert.inputs_title": "Adjustable fields",
        "offer.calculation.insert.inputs_hint": "Only unlocked fields can be changed here, for example kilometers, percent and distribution.",
        "offer.calculation.insert.flow_title": "How the calculation connects",
        "offer.calculation.insert.flow_hint": "Boxes and connections are shown as a readonly map while numbers update live.",
        "offer.calculation.insert.fields_tab": "Adjust fields",
        "offer.calculation.insert.map_tab": "Map",
        "offer.calculation.insert.offer_dialog_title": "Adjust calculation before adding it to the offer",
        "offer.calculation.insert.offer_cancel": "Cancel",
        "offer.calculation.insert.offer_add": "Add to offer",
        "offer.calculation.insert.adjust_fields": "Adjust fields",
        "offer.calculation.insert.edit_lines": "Edit calculation",
        "offer.calculation.insert.adjustable_fields": "Adjustable fields",
        "offer.calculation.insert.adjustable_fields_hint": "This calculation uses the module builder. Open adjustments to change quantity, kilometers, percent and other open fields.",
        "offer.calculation.module.palette_title": "Modules",
        "offer.calculation.module.globals.title": "Global parameters",
        "offer.calculation.module.globals.hint": "Values for the whole module. Check “Ask on use” for the template wizard.",
        "offer.calculation.module.globals.ask_on_use": "Ask on use",
        "offer.calculation.module.globals.value": "Value",
        "offer.calculation.module.globals.add": "Add parameter",
        "offer.calculation.module.globals.remove": "Remove",
        "offer.calculation.module.globals.key_placeholder": "key (e.g. unit_count)",
        "offer.calculation.module.globals.label_placeholder": "Display name",
        "offer.calculation.module.tabs.label": "Module builder tabs",
        "offer.calculation.module.tabs.content": "Content",
        "offer.calculation.module.tabs.questions": "Questions",
        "offer.calculation.module.tabs.rules": "Rules",
        "offer.calculation.module.tabs.offer_text": "Offer text",
        "offer.calculation.module.tabs.test": "Test",
        "offer.calculation.module.offer_text.hint": "Text that travels with the template. Customer wording can also be driven by presentation rules.",
        "offer.calculation.module.offer_text.customer_note": "Customer note (module)",
        "offer.calculation.module.offer_text.title_field": "Calculation title",
        "offer.calculation.module.offer_text.description_field": "Calculation description",
        "offer.calculation.module.rules.title": "Rules",
        "offer.calculation.module.rules.hint": "Simple if/then rules: when a global has a value, enable or disable nodes.",
        "offer.calculation.module.rules.add": "Add rule",
        "offer.calculation.module.rules.pick_global": "Pick parameter…",
        "offer.calculation.module.rules.pick_node": "Pick node…",
        "offer.calculation.module.rules.equals_placeholder": "equals…",
        "offer.calculation.module.rules.disable_node": "Disable node",
        "offer.calculation.module.rules.enable_node": "Enable node",
        "offer.calculation.module.rules.summary": "If {{global}} = “{{equals}}” → {{action}} ({{node}})",
        "offer.calculation.module.palette_hint": "Click to add a module to the canvas.",
        "offer.calculation.module.add": "Add",
        "offer.calculation.module.canvas_title": "Module map",
        "offer.calculation.module.canvas_hint": "Drag the map. Double-click a card to open settings.",
        "offer.calculation.module.connecting_hint": "Choose the next box to create a connection.",
        "offer.calculation.module.reset_example": "Reset to example",
        "offer.calculation.module.zoom_out": "Zoom out",
        "offer.calculation.module.zoom_in": "Zoom in",
        "offer.calculation.module.reset_view": "Reset view",
        "offer.calculation.module.json.open_dialog": "JSON / AI",
        "offer.calculation.module.json.dialog_title": "JSON and AI for module builder",
        "offer.calculation.module.json.tab_json": "Paste JSON",
        "offer.calculation.module.json.tab_ai_guide": "AI instructions",
        "offer.calculation.module.json.hint": "Paste JSON from ChatGPT or another AI, or edit the current module graph. Accepts a full module_graph or { \"nodes\": [...], \"edges\": [...] }. Applying JSON only updates the editor — you still need to save the calculation.",
        "offer.calculation.module.json.replace": "Replace the whole graph",
        "offer.calculation.module.json.append": "Add to the canvas",
        "offer.calculation.module.json.copy_json": "Copy JSON",
        "offer.calculation.module.json.reload_from_editor": "Reload from editor",
        "offer.calculation.module.json.insert_sample": "Insert sample",
        "offer.calculation.module.json.apply": "Apply JSON",
        "offer.calculation.module.json.applied": "{{count}} nodes imported",
        "offer.calculation.module.json.copy_success": "JSON copied",
        "offer.calculation.module.json.reload_success": "JSON reloaded from the editor",
        "offer.calculation.module.json.clipboard_failed": "Could not copy to the clipboard",
        "offer.calculation.module.json.ai_guide_intro": "Copy the instructions below into ChatGPT, Claude or another AI. Then paste the JSON reply into the “Paste JSON” tab.",
        "offer.calculation.module.json.copy_ai_guide": "Copy AI instructions",
        "offer.calculation.module.json.ai_guide_copied": "AI instructions copied",
        "offer.calculation.module.json.generate_with_ai": "Generate with AI",
        "offer.calculation.module.json.ai_parse_error": "Could not read the AI reply as module-graph JSON",
        "offer.calculation.module.json.ai_apply_success": "{{count}} nodes added from AI",
        "offer.calculation.module.json.error_empty": "The JSON field is empty",
        "offer.calculation.module.json.error_invalid_json": "Invalid JSON — check the syntax",
        "offer.calculation.module.json.error_invalid_graph": "No valid module graph found in the JSON",
        "offer.calculation.module.json.error_no_nodes": "No nodes found in the JSON",
        "offer.calculation.module.json.error_missing_id": "One or more nodes are missing an id",
        "offer.calculation.module.json.error_unknown_type": "Unknown node type in the JSON",
        "offer.calculation.module.json.error_missing_edge_target": "An edge points to a node that does not exist",
        "offer.calculation.module.json.error_unsafe_formula": "The formula is invalid or uses unsupported functions",
        "offer.calculation.module.json.error_circular": "The graph has a circular reference",
        "offer.calculation.module.result_title": "Result",
        "offer.calculation.module.result_hint": "Total excl. VAT. Preview updates as you edit; save for the server total.",
        "offer.calculation.module.editor_title": "Edit selected module",
        "offer.calculation.module.selected_title": "Selected module",
        "offer.calculation.module.settings.values": "Values",
        "offer.calculation.module.selected_empty": "Click a module on the map to edit title, amount and connections.",
        "offer.calculation.module.editor_hint_computed": "Calculated automatically from modules that point in.",
        "offer.calculation.module.editor_hint_editable": "Changes update the subtotal and total immediately.",
        "offer.calculation.module.editor_mode.simple": "Simple",
        "offer.calculation.module.editor_mode.advanced": "Advanced",
        "offer.calculation.module.duplicate": "Duplicate",
        "offer.calculation.module.copy_suffix": "(copy)",
        "offer.calculation.module.auto": "auto",
        "offer.calculation.module.meta.percent": "Markup {{percent}} %",
        "offer.calculation.module.meta.divisor": "Split by {{divisor}}",
        "offer.calculation.module.meta.fixed": "Fixed amount",
        "offer.calculation.module.meta.service_hours": "Fixed amount · {{hours}} h × {{rate}}",
        "offer.calculation.module.meta.product_lines": "{{count}} lines",
        "offer.calculation.module.meta.formula": "Custom",
        "offer.calculation.module.meta.subtotal": "Subtotal",
        "offer.calculation.module.meta.total": "Endpoint",
        "offer.calculation.module.meta.note": "No amount",
        "offer.calculation.module.edge_title": "Edit arrow",
        "offer.calculation.module.breakdown_title": "Breakdown",
        "offer.calculation.module.connect": "Connect",
        "offer.calculation.module.connect_here": "Connect here",
        "offer.calculation.module.remove": "Remove",
        "offer.calculation.module.remove_edge": "Remove arrow",
        "offer.calculation.module.locked": "Locked",
        "offer.calculation.module.unlocked": "Open",
        "offer.calculation.module.enabled": "Active",
        "offer.calculation.module.disabled": "Inactive",
        "offer.calculation.module.operation.add": "Add",
        "offer.calculation.module.operation.subtract": "Subtract",
        "offer.calculation.module.scope.all": "Whole job",
        "offer.calculation.module.scope.work": "Work only",
        "offer.calculation.module.scope.driving": "Driving only",
        "offer.calculation.module.scope.selected": "Selected modules",
        "offer.calculation.module.field.title": "Title",
        "offer.calculation.module.field.insert_order": "Order in customize-template",
        "offer.calculation.module.field.insert_order_hint": "Leave empty for automatic order (hierarchy top → down). Lower numbers appear first.",
        "offer.calculation.module.field.amount": "Amount",
        "offer.calculation.module.field.enabled": "Status",
        "offer.calculation.module.field.quantity": "Quantity",
        "offer.calculation.module.field.unit_price": "Unit price",
        "offer.calculation.module.field.product_name": "Product name",
        "offer.calculation.module.field.hours": "Hours",
        "offer.calculation.module.field.estimated_hours": "Estimated hours",
        "offer.calculation.module.field.hourly_rate": "Hourly rate",
        "offer.calculation.module.field.cost_hourly_rate": "Cost hourly rate",
        "offer.calculation.module.field.percent": "Percent",
        "offer.calculation.module.field.percent_mode": "Type",
        "offer.calculation.module.percent_mode.markup": "Markup",
        "offer.calculation.module.percent_mode.discount": "Discount",
        "offer.calculation.module.field.scope": "Applies to",
        "offer.calculation.module.field.divisor": "Distribute by",
        "offer.calculation.module.field.expression": "Formula",
        "offer.calculation.module.field.note": "Note",
        "offer.calculation.module.field.operation": "Operation",
        "offer.calculation.module.formula.assistant_title": "Formula help",
        "offer.calculation.module.formula.assistant_subtitle": "Choose a ready-made template, or click variables and functions. You do not need to remember Excel syntax.",
        "offer.calculation.module.formula.templates": "Ready-made templates",
        "offer.calculation.module.formula.variables": "Insert value",
        "offer.calculation.module.formula.functions": "Smart functions",
        "offer.calculation.module.formula.example_title": "Tip",
        "offer.calculation.module.formula.example_text": "`input` is the sum from arrows going into {{title}}. Start with a template and adjust the numbers.",
        "offer.calculation.module.formula.variable.input": "Sum from incoming arrows",
        "offer.calculation.module.formula.variable.quantity": "Own quantity",
        "offer.calculation.module.formula.variable.price": "Own price",
        "offer.calculation.module.formula.variable.percent": "Own percent",
        "offer.calculation.module.formula.function.sum": "Sum several numbers",
        "offer.calculation.module.formula.function.round": "Round to whole number",
        "offer.calculation.module.formula.function.min": "Maximum price cap",
        "offer.calculation.module.formula.function.max": "Minimum price",
        "offer.calculation.module.formula.function.if": "If-then-else",
        "offer.calculation.module.formula.template.same": "Use the sum as-is",
        "offer.calculation.module.formula.template.fixed_add": "Add fixed amount",
        "offer.calculation.module.formula.template.fixed_subtract": "Subtract fixed amount",
        "offer.calculation.module.formula.template.ten_percent": "Add 10%",
        "offer.calculation.module.formula.template.custom_percent": "Add custom %",
        "offer.calculation.module.formula.template.input_times_quantity": "Multiply incoming by quantity",
        "offer.calculation.module.formula.template.quantity_price": "Quantity times price",
        "offer.calculation.module.formula.template.split_two": "Split by 2",
        "offer.calculation.module.formula.template.round": "Round the total",
        "offer.calculation.module.formula.template.if": "If amount is above 0",
        "offer.calculation.module.formula.node_refs": "Other modules",
        "offer.calculation.module.formula.globals": "Global values",
        "offer.calculation.module.node.service": "Service",
        "offer.calculation.module.node.service_hint": "Fixed amount that can be locked, e.g. apartment. Estimated hours and hourly rate count toward total hours.",
        "offer.calculation.module.node.quantity": "Quantity x price",
        "offer.calculation.module.node.quantity_hint": "Quantity multiplied by unit price, e.g. kilometers.",
        "offer.calculation.module.node.product_price": "Product price",
        "offer.calculation.module.node.product_price_hint": "Product name, quantity and price in one module.",
        "offer.calculation.module.node.product_catalog": "Product list",
        "offer.calculation.module.node.product_catalog_hint": "Add products from the product register or manual product lines.",
        "offer.calculation.module.node.labor_hours": "Hours field",
        "offer.calculation.module.node.labor_hours_hint": "Hours multiplied by hourly rate, e.g. additional work or service work.",
        "offer.calculation.module.node.percentage": "Percentage",
        "offer.calculation.module.node.percentage_hint": "Markup or discount on incoming modules.",
        "offer.calculation.module.node.distribution": "Distribution",
        "offer.calculation.module.node.distribution_hint": "Distribute incoming amount by X.",
        "offer.calculation.module.node.formula": "Special formula",
        "offer.calculation.module.node.formula_hint": "E.g. multiply a subtotal by quantity: connect in → set quantity. Formula: input × quantity.",
        "offer.calculation.module.node.subtotal": "Subtotal",
        "offer.calculation.module.node.subtotal_hint": "Collects several incoming modules.",
        "offer.calculation.module.node.total": "Total",
        "offer.calculation.module.node.total_hint": "End point for the calculation.",
        "offer.calculation.module.node.note": "Note",
        "offer.calculation.module.node.note_hint": "Explanation box without amount.",
        "offer.calculation.module.product.title": "Products",
        "offer.calculation.module.product.hint": "Choose products from the register or add your own product lines.",
        "offer.calculation.module.product.add_from_catalog": "Add from product register",
        "offer.calculation.module.product.add_manual": "Manual line",
        "offer.calculation.module.product.empty": "No products added yet.",
        "offer.calculation.module.product.manual_title": "Manual product",
        "offer.calculation.module.product.include": "Include",
        "offer.calculation.module.product.exclude": "Exclude",
        "offer.calculation.module.product.total": "Product total",
        "offer.calculation.module.product.cancel": "Cancel",
        "offer.calculation.module.product.add_selected": "Add selected",
        "offer.calculation.product_list.title": "Product list",
        "offer.calculation.product_list.hint": "Add catalog products, or manual lines you then link to a product. When the template is used, the user picks which ones to include.",
        "offer.calculation.product_list.label": "List name",
        "offer.calculation.product_list.mode_single": "Pick one (e.g. aggregate)",
        "offer.calculation.product_list.mode_multi": "Pick several (e.g. accessories)",
        "offer.calculation.product_list.ask_on_use": "Ask when using template",
        "offer.calculation.product_list.module_ask_hint": "When enabled, the template wizard asks which catalog products to include.",
        "offer.calculation.product_list.add_products": "Add products",
        "offer.calculation.product_list.add_manual": "Manual line",
        "offer.calculation.product_list.manual_title": "New product line",
        "offer.calculation.product_list.line_title": "Line title",
        "offer.calculation.product_list.unlinked": "Not linked to a product — use “Link to product” to load price.",
        "offer.calculation.product_list.link_product": "Link to product",
        "offer.calculation.product_list.relink_product": "Change linked product",
        "offer.calculation.product_list.relink_product_short": "Change product",
        "offer.calculation.product_list.link_confirm": "Link",
        "offer.calculation.product_list.update_prices": "Update prices from product",
        "offer.calculation.product_list.update_price": "Update price from product",
        "offer.calculation.product_list.price_dated": "Price fetched",
        "offer.calculation.product_list.empty": "No products in the list yet. Add from the catalog or as a manual line.",
        "offer.calculation.product_list.default_selected": "Default",
        "offer.calculation.product_list.required": "Required",
        "offer.calculation.product_list.remove": "Remove",
        "offer.calculation.product_list.wizard_single_hint": "Choose one product for this line.",
        "offer.calculation.product_list.wizard_multi_hint": "Select the products to include.",
        
        // Accounting Summary translations
        "accounting.summary.title": "Accounting Summary",
        "accounting.summary.eyebrow": "Accounting",
        "accounting.summary.tap_hint": "Tap to see more numbers and select period",
        "accounting.summary.profit_explanation": "Profit = income − costs. The margin shows profit as a share of income.",
        "accounting.summary.income_explanation": "Income is invoiced turnover from customer invoices in the selected period.",
        "accounting.summary.costs": "Costs",
        "accounting.summary.income": "Income",
        "accounting.summary.profit": "Profit",
        "accounting.summary.profit_margin": "margin",
        "accounting.summary.projects": "Projects",
        "accounting.summary.labor": "Labor Costs",
        "accounting.summary.labor_source_voucher": "Posted payroll (salary vouchers)",
        "accounting.summary.labor_source_hours": "Estimated from hours",
        "accounting.summary.labor_paid_via_voucher": "Paid via salary voucher",
        "accounting.summary.labor_estimated_unpaid": "Estimated from hours (not yet paid)",
        "accounting.summary.labor_unpaid_badge": "{{hours}} hours — estimated {{amount}} (not yet paid)",
        "accounting.summary.labor_paid_badge": "Posted payroll — {{amount}}",
        "accounting.summary.labor_source_label": "Labor in total: {{source}}",
        "accounting.summary.costs_detail_title": "Cost details",
        "accounting.summary.costs_detail_hint": "Click to view cost breakdown and calculation",
        "accounting.summary.costs_detail_intro": "Cost breakdown for {{year}} with the basis for each line.",
        "accounting.summary.calculation_method_title": "How this is calculated",
        "accounting.summary.labor_voucher_explanation": "Salary vouchers = payroll posted in the general ledger (accounts 5000–5999). Hour estimates are used when vouchers are not available yet.",
        "accounting.summary.labor_methodology_voucher": "Total comes from synced salary vouchers in Tripletex (accounts 5000–5999).",
        "accounting.summary.labor_methodology_hours": "Total is an estimate based on registered hours and hourly rates, because salary vouchers have not been posted yet.",
        "accounting.summary.supplier_invoices_methodology": "Posted supplier invoices on operating cost accounts (4000–4999 and 6000–7999) in the selected period. Skipped when ledger vouchers already exist for the year (avoids double counting).",
        "accounting.summary.item_lists_methodology": "Materials and consumption from approved item lists marked include-in-calculation in the selected year. Shown at company level but not included in the cost total (stock purchases already appear in supplier invoices / the ledger).",
        "accounting.summary.item_lists_excluded_hint": "Item lists are not included in the company cost total — avoids double-counting against supplier invoices/ledger. Project view still includes them.",
        "accounting.summary.voucher_expenses_methodology": "Tripletex voucher postings on operating cost accounts 4000–4999 and 6000–7999 (ex. VAT). Balance sheet, income and salary (5000–5999) accounts are excluded.",
        "accounting.summary.labor_hours_count": "Registered hours: {{hours}}",
        "accounting.summary.labor_hours_estimate": "Hours estimate",
        "accounting.summary.labor_voucher": "Salary vouchers",
        "accounting.summary.voucher_expenses": "Tripletex costs (operating)",
        "accounting.summary.calc_guide.json.download": "Download JSON guide",
        "accounting.summary.calc_guide.json.copy": "Copy JSON guide",
        "accounting.summary.calc_guide.json.downloaded": "Calculation guide downloaded.",
        "accounting.summary.calc_guide.json.copied": "Calculation guide copied to clipboard.",
        "accounting.summary.calc_guide.json.error": "Could not fetch calculation guide.",
        "accounting.summary.calc_guide.profit.title": "How profit is calculated",
        "accounting.summary.calc_guide.profit.body": "Profit = total income − total costs.\n\nMargin is profit as a percentage of income.\n\nIncome comes from customer invoices (ex. VAT). Costs are salary + Tripletex operating costs + supplier invoices (when the ledger is not synced). Item lists are not included in the company cost total.",
        "accounting.summary.calc_guide.profit.info_aria": "Information about profit",
        "accounting.summary.calc_guide.income.title": "How income is calculated",
        "accounting.summary.calc_guide.income.body": "Total income = sum of customer invoices in the selected year, amount ex. VAT (amount − vat).\n\nDate: invoice_date if set, otherwise created_at.\n\nNote: The result report may instead use Tripletex accounts 3000–3999 when the ledger is synced. The accounting overview still uses customer invoices.",
        "accounting.summary.calc_guide.income.info_aria": "Information about income",
        "accounting.summary.calc_guide.costs.title": "How total costs are calculated",
        "accounting.summary.calc_guide.costs.body": "Total costs =\n• Salary (accounts 5000–5999, or hour estimate)\n• Tripletex costs (accounts 4000–4999 + 6000–7999)\n• Supplier invoices (only months without operating-cost ledger vouchers)\n\nApproved item lists are shown separately and are not included here — stock purchases are already covered by supplier invoices/ledger.\n\nBalance sheet accounts (e.g. 1xxx/2xxx) are not included. That is why the overview should match operating costs in the result report, not the entire general ledger.",
        "accounting.summary.calc_guide.costs.info_aria": "Information about costs",
        "accounting.summary.calc_guide.labor.title": "How salary is calculated",
        "accounting.summary.calc_guide.labor.body": "When salary vouchers are synced from Tripletex, postings on accounts 5000–5999 in the selected year are summed (ex. VAT).\n\nIf no such vouchers exist, an estimate is used: approved and processed hours × effective hourly rate / company rate.",
        "accounting.summary.calc_guide.labor.info_aria": "Information about salary",
        "accounting.summary.calc_guide.supplier_invoices.title": "How supplier invoices are calculated",
        "accounting.summary.calc_guide.supplier_invoices.body": "Sum of supplier invoice postings on operating cost accounts (4000–4999 and 6000–7999) in the selected year.\n\nWhen the Tripletex ledger is already synced for the period, this line is 0 — those costs appear under Tripletex costs (supplier vouchers in the ledger).",
        "accounting.summary.calc_guide.supplier_invoices.info_aria": "Information about supplier invoices",
        "accounting.summary.calc_guide.item_lists.title": "How item lists are calculated",
        "accounting.summary.calc_guide.item_lists.body": "Sum of quantity × purchase price for approved item lists with include-in-calculation, approved in the selected year.\n\nConsumption lists increase the amount; return/handling reduce it.\n\nAt company level, item lists are not included in the cost total (double-count vs stock purchases). Project view still includes them in material costs.",
        "accounting.summary.calc_guide.item_lists.info_aria": "Information about item lists",
        "accounting.summary.calc_guide.voucher_expenses.title": "How Tripletex costs are calculated",
        "accounting.summary.calc_guide.voucher_expenses.body": "Sum of synced voucher postings in the selected year on accounts:\n• 4000–4999 (cost of goods)\n• 6000–7999 (other operating expenses)\n\nAmounts are ex. VAT. Credits (negative amounts) reduce the total.\n\nExcluded: salary (5000–5999), income (3000–3999), VAT (27*), bank/payables (1920*/2400) and balance sheet accounts. Incorrectly summing the entire ledger previously produced far too high figures.",
        "accounting.summary.calc_guide.voucher_expenses.info_aria": "Information about Tripletex costs",
        "accounting.summary.calc_guide.expected_report_income.title": "How expected assignment income is calculated",
        "accounting.summary.calc_guide.expected_report_income.body": "Expected income/cost from service reports and work orders that are not processed or invoiced in the selected year.\n\nThis is not part of the main profit figure, but is shown separately as potential.",
        "accounting.summary.calc_guide.expected_report_income.info_aria": "Information about expected assignment income",
        "accounting.summary.material": "Material Costs",
        "accounting.summary.supplier_invoices": "Supplier Invoices",
        "accounting.summary.item_lists": "Item Lists",
        "accounting.summary.customer_invoices": "Customer Invoices",
        "accounting.summary.reports": "Reports",
        "accounting.summary.total": "Total",
        "accounting.summary.calculated_at": "Calculated",
        "accounting.summary.cached": "Cached",
        "accounting.summary.load_error": "Failed to load accounting summary",
        "accounting.summary.monthly_overview": "Monthly Overview",
        "accounting.summary.chart_description": "Bars: income & costs · Line: monthly profit (income − costs)",
        "accounting.summary.no_monthly_data": "No monthly data available",
        "accounting.summary.months.january": "Jan",
        "accounting.summary.months.february": "Feb",
        "accounting.summary.months.march": "Mar",
        "accounting.summary.months.april": "Apr",
        "accounting.summary.months.may": "May",
        "accounting.summary.months.june": "Jun",
        "accounting.summary.months.july": "Jul",
        "accounting.summary.months.august": "Aug",
        "accounting.summary.months.september": "Sep",
        "accounting.summary.months.october": "Oct",
        "accounting.summary.months.november": "Nov",
        "accounting.summary.months.december": "Dec",
        "accounting.summary.expected_report_income": "Expected Assignment Income",
        "accounting.summary.expected_report_income_hint": "From unprocessed, uninvoiced reports (same basis as the accounting overview)",
        "accounting.summary.expected_income": "Expected Income",
        "accounting.summary.expected_costs": "Expected Costs",
        "accounting.summary.expected_profit": "Expected Profit",
        "accounting.summary.view_projects": "View by project →",
        "accounting.menu.projects_expected": "Expected Assignment Income",

        "accounting.menu.overview": "Accounting overview",
        "accounting.menu.ledger": "Ledger & vouchers",
        "accounting.menu.result_report": "Income statement",
        "accounting.menu.result_report_hint": "Operating income and costs grouped by chart of accounts from synced vouchers",
        "accounting.menu.tripletex_import": "Import hours from Tripletex",
        "accounting.menu.title": "Accounting",
        "accounting.menu.subtitle": "Company financial overview and Tripletex integration",
        "accounting.menu.sections": "Sections",
        "accounting.menu.supplier_invoices": "Supplier invoices",
        "accounting.menu.supplier_invoices_hint": "Booked supplier costs with voucher postings",
        "accounting.menu.customer_invoices": "Customer invoices",
        "accounting.menu.customer_invoices_hint": "Outgoing sales and invoiced revenue",
        "accounting.menu.ledger_hint": "Ledger types, voucher types, and salary calculations from Tripletex",
        "accounting.menu.tripletex_import_hint": "One-time import of historical timesheets from Tripletex",
        "accounting.menu.project_summary": "Project accounting",
        "accounting.menu.project_summary_hint": "Full financial overview per project with contract sum, salary and costs",
        "accounting.project_summary.title": "Project accounting",
        "accounting.project_summary.subtitle": "Complete financial overview for one project",
        "accounting.project_summary.description": "Select a project to view contract sum, income, salary costs (vouchers or hours), materials, supplier invoices and profit.",
        "accounting.project_summary.select_project": "Project",
        "accounting.project_summary.select_project_placeholder": "Select project…",
        "accounting.project_summary.select_project_hint": "Select a project to view the accounting summary",
        "accounting.project_summary.load_error": "Failed to load project accounting",
        "accounting.project_summary.last_updated": "Last updated",
        "accounting.project_summary.open_project": "Open project",
        "accounting.project_summary.contract_sum": "Contract sum",
        "accounting.project_summary.contract_agreement_price": "Contract agreement price",
        "accounting.project_summary.contract_sum_source_lines": "From contract lines in Promang",
        "accounting.project_summary.contract_sum_source_agreement": "From contract agreement price",
        "accounting.project_summary.contract_sum_source_both": "Contract lines + agreement price",
        "accounting.project_summary.contract_sum_source_none": "No contract sum recorded",
        "accounting.project_summary.invoiced": "Invoiced",
        "accounting.project_summary.not_invoiced": "Not invoiced",
        "accounting.project_summary.invoiced_ex_vat": "Sum of customer invoices, excl. VAT",
        "accounting.project_summary.profit": "Profit",
        "accounting.project_summary.profit_vs_contract": "Result vs contract",
        "accounting.project_summary.profit_vs_invoiced": "Result vs invoiced",
        "accounting.project_summary.margin": "Margin",
        "accounting.project_summary.margin_vs_contract": "Margin vs contract",
        "accounting.project_summary.margin_vs_invoiced": "Margin vs invoiced",
        "accounting.project_summary.income_section": "Income",
        "accounting.project_summary.expected_module_income": "Expected income from modules",
        "accounting.project_summary.income_total": "Invoiced + expected",
        "accounting.project_summary.costs_section": "Costs",
        "accounting.project_summary.labor_costs": "Salary",
        "accounting.project_summary.labor_source_voucher": "Based on salary vouchers",
        "accounting.project_summary.labor_source_hours": "Estimated from registered hours",
        "accounting.project_summary.labor_hours_estimate": "Hours estimate",
        "accounting.project_summary.labor_voucher": "Salary vouchers",
        "accounting.project_summary.labor_unpaid_badge": "{{hours}} hours — estimated {{amount}} (not yet paid)",
        "accounting.project_summary.labor_paid_badge": "Posted payroll — {{amount}}",
        "accounting.project_summary.labor_source_label": "Labor in total: {{source}}",
        "accounting.project_summary.labor_hours_count": "Registered hours: {{hours}}",
        "accounting.project_summary.material_costs": "Materials / item lists",
        "accounting.project_summary.supplier_invoices": "Supplier invoices",
        "accounting.project_summary.voucher_expenses": "Other voucher expenses",
        "accounting.project_summary.total_costs": "Total costs",
        "accounting.project_summary.modules_section": "Modules",
        "accounting.project_summary.print.button": "Print overview",
        "accounting.project_summary.debug_export.button": "Export debug data",
        "accounting.project_summary.debug_export.loading": "Exporting…",
        "accounting.project_summary.debug_export.error": "Failed to export debug data",
        "accounting.project_summary.print.document_title": "Project accounting",
        "accounting.project_summary.print.project_number": "Project number",
        "accounting.project_summary.print.customer": "Customer",
        "accounting.project_summary.print.year": "Year",
        "accounting.project_summary.print.printed_at": "Printed",
        "accounting.project_summary.print.result_section": "Result",
        "accounting.project_summary.print.margin_on_contract": "Margin based on contract sum",
        "accounting.project_summary.print.margin_on_invoiced": "Margin based on invoiced amount",
        "accounting.project_summary.print.minus_total_costs": "Minus total costs",
        "accounting.project_summary.print.methodology_title": "How the totals are calculated",
        "accounting.project_summary.print.methodology_intro": "Each item below describes the data sources used for the figures above.",
        "accounting.project_summary.methodology.contract_sum_lines": "Contract sum is the total of contract lines (total_contract_price) on the project.",
        "accounting.project_summary.methodology.contract_sum_agreement": "Contract sum is the contract agreement price (contract_agreement_price) synced from the accounting integration.",
        "accounting.project_summary.methodology.contract_sum_lines_primary": "Contract sum uses contract lines when present; agreement price is shown as supplementary information.",
        "accounting.project_summary.methodology.contract_sum_none": "No contract sum is recorded — profit and margin are based on invoiced amount.",
        "accounting.project_summary.methodology.contract_agreement_price": "Agreement price comes from the project (contract_agreement_price) and may sync with external accounting.",
        "accounting.project_summary.methodology.income_invoiced": "Invoiced income is the sum of customer invoices on the project, excluding VAT.",
        "accounting.project_summary.methodology.income_expected": "Expected income is the sum of uninvoiced reports and work orders via Service::Report::Summary and Service::WorkOrder::Summary (not invoiced, no order).",
        "accounting.project_summary.methodology.labor_primary_hours": "Salary in the total uses the hours estimate because no salary vouchers exist on the project. This value is used in total costs.",
        "accounting.project_summary.methodology.labor_primary_voucher": "Salary in the total uses salary vouchers because synced voucher postings exist on the project. This value is used in total costs.",
        "accounting.project_summary.methodology.labor_hours": "Hours estimate: approved and processed project hours × effective cost rate (effective_hour_cost_rate or company hour rate).",
        "accounting.project_summary.methodology.labor_voucher": "Salary vouchers: postings on accounts 5000–5999 from synced vouchers linked to the project (PostingRules).",
        "accounting.project_summary.methodology.material_costs": "Materials (consumption) combine several sources: approved item lists, other order lines on invoiced orders, inventory withdrawals (picked/used), report items and work-order items (not invoiced). Billing copies from item-list→order (inventory_billing_copy) are not counted again when the list is already included. Do not compare this total directly to the purchase sum on a single item list alone.",
        "accounting.project_summary.methodology.supplier_invoices": "Supplier invoices: cost postings from supplier invoices on the project, excluding payments and VAT accounts.",
        "accounting.project_summary.methodology.voucher_expenses": "Other voucher expenses: expense postings on the project that are not salary (PostingRules.expense_posting, not salary).",
        "accounting.project_summary.methodology.total_costs": "Total costs = salary + materials + supplier invoices + other voucher expenses.",
        "accounting.project_summary.methodology.profit_contract": "Profit versus contract = contract sum minus total costs.",
        "accounting.project_summary.methodology.profit_invoiced": "Profit versus invoiced = customer invoice total (excl. VAT) minus total costs. Independent of contract sum.",
        "accounting.project_summary.methodology.margin_contract": "Margin versus contract = profit versus contract divided by contract sum × 100.",
        "accounting.project_summary.methodology.margin_invoiced": "Margin versus invoiced = profit versus invoiced divided by invoiced amount × 100.",
        "project.summary.labor_source_voucher": "Based on salary vouchers",
        "project.summary.labor_source_hours": "Estimated from registered hours",
        "project.summary.labor_hours_estimate": "Hours estimate",
        "project.summary.labor_voucher": "Salary vouchers",
        "project.summary.labor_unpaid_badge": "{{hours}} hours — estimated {{amount}} (not yet paid)",
        "project.summary.labor_paid_badge": "Posted payroll — {{amount}}",
        "project.summary.labor_source_label": "Labor in total: {{source}}",
        "project.summary.labor_hours_count": "Registered hours: {{hours}}",
        "project.summary.contract_agreement_price": "Contract agreement price",
        "project.summary.voucher_expenses": "Other voucher expenses",
        "accounting.ledger.load_error": "Failed to load ledger data",
        "accounting.ledger.loading": "Loading ledger data…",
        "accounting.ledger.search_placeholder": "Search voucher number or description…",
        "accounting.ledger.last_synced": "Last synced {{date}}",
        "accounting.ledger.vouchers_truncated":
          "The latest ledger sync stopped at the page cap. Figures may be incomplete until you sync a shorter period.",
        "accounting.ledger.source_local": "Stored locally (not live Tripletex)",
        "accounting.ledger.sync_required_hint": "Ledger data has not been synced yet. Ask an administrator to run the Tripletex ledger sync job.",
        "accounting.ledger.vouchers_table": "Vouchers",
        "accounting.ledger.no_vouchers": "No vouchers match the current filters.",
        "accounting.ledger.page_of": "Page {{page}} of {{total}}",
        "accounting.ledger.prev_page": "Previous",
        "accounting.ledger.next_page": "Next",
        "accounting.ledger.calculations": "Calculations",
        "accounting.ledger.tripletex_expenses": "Tripletex expenses (ex. VAT)",
        "accounting.ledger.tripletex_salary": "Tripletex salary (ex. VAT)",
        "accounting.ledger.promang_supplier_invoices": "Promang supplier invoices",
        "accounting.ledger.ledger_types": "Ledger types",
        "accounting.ledger.voucher_types": "Voucher types",
        "accounting.ledger.count": "{{count}} rows",
        "accounting.ledger.recent_vouchers": "Recent vouchers",
        "accounting.ledger.voucher_number": "Voucher no.",
        "accounting.ledger.voucher_date": "Date",
        "accounting.ledger.voucher_type": "Type",
        "accounting.ledger.postings": "Postings",
        "accounting.ledger.expense_total": "Expense total",
        "accounting.ledger.salary_total": "Salary total",
        "accounting.ledger.last_sync_attempt": "Last sync attempt: {{date}}",
        "accounting.ledger.sync_via_integrations": "Enable «Ledger & vouchers» in Company settings → Integrations → Sync with Tripletex, or run rake api:jobs:run_company_ledger_sync[company_id,year].",
        "accounting.result_report.load_error": "Failed to load income statement",
        "accounting.result_report.loading": "Loading income statement…",
        "accounting.result_report.total_income": "Total operating income",
        "accounting.result_report.total_costs": "Total operating costs",
        "accounting.result_report.operating_result": "Operating result (EBIT)",
        "accounting.result_report.result_before_tax": "Result before tax",
        "accounting.result_report.table_title": "Income statement {{year}}",
        "accounting.result_report.debug_export.button": "Export debug data",
        "accounting.result_report.debug_export.loading": "Exporting…",
        "accounting.result_report.debug_export.error": "Failed to export debug data",
        "accounting.result_report.account_number": "Account",
        "accounting.result_report.account_name": "Name",
        "accounting.result_report.amount": "Amount",
        "accounting.result_report.no_rows": "No account postings in the selected period.",
        "accounting.result_report.methodology_link": "Read methodology and account mapping",
        "accounting.result_report.account_detail.title": "{{account}} ({{number}})",
        "accounting.result_report.account_detail.click_hint": "Click to see vouchers and postings behind this amount",
        "accounting.result_report.account_detail.load_error": "Failed to load account details",
        "accounting.result_report.account_detail.no_rows": "No postings or invoices for this account in the period.",
        "accounting.result_report.account_detail.posting_count": "{{count}} postings",
        "accounting.result_report.account_detail.voucher_number": "Voucher no.",
        "accounting.result_report.account_detail.date": "Date",
        "accounting.result_report.account_detail.description": "Description",
        "accounting.result_report.account_detail.project": "Project",
        "accounting.result_report.account_detail.source": "Source",
        "accounting.result_report.account_detail.source_voucher": "Voucher",
        "accounting.result_report.account_detail.source_supplier": "Supplier invoice",
        "accounting.result_report.account_detail.source_customer_invoice": "Customer invoice",
        "accounting.result_report.account_detail.reconciliation_title": "Possible reasons for differences vs Tripletex",
        "accounting.projects_expected.title": "Expected Assignment Income",
        "accounting.projects_expected.subtitle": "Expected income from unprocessed reports and work orders, grouped by project or assignment",
        "accounting.projects_expected.description": "Expected income and costs come from reports and work orders that are not processed or invoiced. Materials count only for picked lines (or skip-picking lines). Choose a project view or a per-report/work-order view. Labor and supplier costs are actual costs recorded on the project (project view only).",
        "accounting.projects_expected.search_placeholder": "Search project name or number…",
        "accounting.projects_expected.search_placeholder_assignment": "Search report, work order, project…",
        "accounting.projects_expected.view_by_project": "By project",
        "accounting.projects_expected.view_by_assignment": "By report/assignment",
        "accounting.projects_expected.table_title_assignment": "By report and work order",
        "accounting.projects_expected.assignment": "Report / work order",
        "accounting.projects_expected.type_report": "Report",
        "accounting.projects_expected.type_work_order": "Work order",
        "accounting.projects_expected.expected_income_short": "Income",
        "accounting.projects_expected.expected_costs_short": "Costs",
        "accounting.projects_expected.date": "Date",
        "accounting.projects_expected.no_assignments": "No unprocessed reports or work orders match the current filters.",
        "accounting.projects_expected.loading": "Loading overview…",
        "accounting.projects_expected.load_error": "Failed to load overview",
        "accounting.projects_expected.table_title": "By project",
        "accounting.projects_expected.project": "Project",
        "accounting.projects_expected.assignments": "Assignments",
        "accounting.projects_expected.reports_count": "{{count}} report",
        "accounting.projects_expected.reports_count_plural": "{{count}} reports",
        "accounting.projects_expected.work_orders_count": "{{count}} work order",
        "accounting.projects_expected.work_orders_count_plural": "{{count}} work orders",
        "accounting.projects_expected.expected_income": "Expected income (reports/work orders)",
        "accounting.projects_expected.expected_income_hint": "Sum from unprocessed reports and work orders on the project. Materials only for picked goods (not unpicked inventory).",
        "accounting.projects_expected.expected_costs": "Expected costs (reports/work orders)",
        "accounting.projects_expected.expected_profit": "Expected profit",
        "accounting.projects_expected.labor_costs": "Labor costs (actual)",
        "accounting.projects_expected.supplier_costs": "Supplier costs (actual)",
        "accounting.projects_expected.hours": "Hours",
        "accounting.projects_expected.net": "Net",
        "accounting.projects_expected.no_projects": "No projects with unprocessed reports or work orders match the current filters.",
        "accounting.projects_expected.totals_reports": "Reports",
        "accounting.projects_expected.totals_work_orders": "Work orders",
        "integrations.sync.ledger": "Ledger & vouchers",
        "integrations.sync.ledger_hint": "Sync ledger types, voucher types and vouchers for the current year from Tripletex",
        "accounting.import.description": "One-time import of timesheet entries from Tripletex into Promang. Ongoing export Promang → Tripletex is unchanged.",
        "accounting.import.from_date": "From date",
        "accounting.import.to_date": "To date",
        "accounting.import.run": "Run import",
        "accounting.import.running": "Importing…",
        "accounting.import.success": "Import completed",
        "accounting.import.error": "Import failed",
        "accounting.import.found": "Found in Tripletex",
        "accounting.import.created": "Created",
        "accounting.import.updated": "Updated",
        "accounting.import.skipped": "Skipped",

        "integrations.sync.hours": "Hours / Timers",
        "integrations.sync.hours_hint": "Import timesheet entries from Tripletex (last 30 days). For a custom date range, use Accounting → Import hours from Tripletex.",

        // Microsoft / Outlook
        "microsoft.explain.title": "What does connecting mean?",
        "microsoft.explain.company.1":
          "Connects your company’s primary email (e.g. post@company.com) to Microsoft so Promang can read and handle incoming email for cases.",
        "microsoft.explain.company.2":
          "Provides a basis for creating and updating cases from email threads.",
        "microsoft.explain.company.3":
          "Requires admin rights and Microsoft consent for the selected mailbox.",
        "microsoft.explain.company.4":
          "Secrets and token exchange happen only in the Promang API — not in the browser.",
        "microsoft.explain.company.5":
          "Sending email and AI features for company mail will arrive when server-side token storage is complete.",
        "microsoft.explain.user.1":
          "Connects your own Microsoft / Outlook account to the Promang user you’re signed in as.",
        "microsoft.explain.user.2":
          "Lets you send email from your address where enabled in Promang, and use AI/context from your mail.",
        "microsoft.explain.user.3":
          "You must be signed in to Promang before you click «Connect Microsoft».",
        "microsoft.explain.user.4":
          "The email address in Microsoft should match your user wherever practical.",
        "microsoft.explain.user.5":
          "You can disconnect anytime under Settings or on the Microsoft / Outlook page.",
        "microsoft.company.page_title": "Microsoft — company mail",
        "microsoft.company.page_subtitle": "Connect the company’s primary email (admin).",
        "microsoft.company.card_title": "Company mail (Microsoft 365)",
        "microsoft.company.subtitle": "For shared inbox and cases on behalf of the business.",
        "microsoft.user.page_title": "Microsoft / Outlook",
        "microsoft.user.page_subtitle": "Connect your Microsoft account to this Promang user.",
        "microsoft.user.card_title": "Your Outlook account",
        "microsoft.user.subtitle":
          "Email is sent from your account where supported; also provides context to AI and cases.",
        "user.settings.calendar.section_title": "Calendar",
        "user.settings.calendar.show_week_numbers": "Show week numbers",
        "user.settings.signature.section_title": "Signature",
        "user.settings.signature.section_hint":
          "Used when you sign offers, agreements and other documents.",
        "user.settings.signature.empty": "No signature uploaded",
        "user.settings.signature.preview_alt": "Your signature",
        "user.settings.signature.remove": "Remove signature",
        "user.settings.signature.saved": "Signature saved",
        "user.settings.signature.save_error": "Could not save signature",
        "offers.setup_prompt.dismiss": "Do later",
        "offers.setup_prompt.signature.title": "Upload your signature",
        "offers.setup_prompt.signature.body":
          "Recommended for offers: upload a signature under user settings so it can be used on documents and PDFs.",
        "offers.setup_prompt.signature.body_force":
          "Signature is missing. Upload it before signing or exporting PDF.",
        "offers.setup_prompt.signature.cta": "Open settings",
        "offers.setup_prompt.admin.title": "Company offer settings",
        "offers.setup_prompt.admin.body":
          "{{count}} recommended offer setting(s) are missing or turned off.",
        "offers.setup_prompt.admin.cta": "Open offer settings",
        "microsoft.user.settings_section_title": "Microsoft / Outlook",
        "microsoft.user.settings_section_intro":
          "Connect Microsoft to the account you’re signed in with. This is not the same as «Sign in with Microsoft» on the login page — you stay in Promang and grant access to email for dashboard features.",
        "microsoft.user.open_full_page": "Open dedicated connection page",
        "microsoft.user.calendar_heading": "Calendar for events",
        "microsoft.user.calendar_intro":
          "All calendars you can open in Outlook for this account are listed (your own and shared). Pick where Promang should create events. Use search if you have many calendars.",
        "microsoft.user.calendar_refresh": "Load calendars",
        "microsoft.user.calendar_need_refresh":
          "Connect Microsoft with a refresh token (full link) to load calendars.",
        "microsoft.user.calendar_select_label": "Calendar",
        "microsoft.user.calendar_none": "None selected",
        "microsoft.user.calendar_choose": "Search…",
        "microsoft.user.calendar_modal_title": "Choose calendar",
        "microsoft.user.calendar_modal_close": "Close",
        "microsoft.user.calendar_modal_hint":
          "Search by name or owner email. Shared calendars show a badge; read-only calendars cannot be saved for event sync.",
        "microsoft.user.calendar_search_placeholder": "Search calendars…",
        "microsoft.user.calendar_search_empty": "No calendars match your search.",
        "microsoft.user.calendar_modal_empty": "No calendars returned from Microsoft.",
        "microsoft.user.calendar_badge_own": "Yours",
        "microsoft.user.calendar_badge_shared": "Shared",
        "microsoft.user.calendar_badge_readonly": "Read-only",
        "microsoft.user.calendar_readonly_hint":
          "This calendar is read-only in Microsoft. Choose one you can edit to sync events.",
        "microsoft.user.calendar_readonly_save":
          "Cannot save a read-only calendar for events. Pick a calendar you can edit.",
        "microsoft.user.calendar_current": "Previously selected: {{name}}{{email}}",
        "microsoft.user.calendar_save": "Save calendar",
        "microsoft.user.calendar_saved": "Calendar saved.",
        "microsoft.user.calendar_save_failed": "Could not save calendar.",
        "microsoft.user.calendar_load_failed": "Could not load calendars.",
        "microsoft.user.personal_mail_ai.title": "Your mailbox — AI rules and processing",
        "microsoft.user.personal_mail_ai.intro":
          "Configure sorting, manual rules, AI routing, and run processing on your linked Microsoft mailbox — same options as shared company inboxes. Cases and customers are created in the current company.",
        "microsoft.user.personal_mail_ai.no_permission":
          "Your role does not include personal inbox AI. Ask an administrator to assign the «microsoft_personal_mail_ai» role for this company or give you admin access.",
        "microsoft.user.personal_mail_ai.forbidden_toast": "You are not allowed to open these settings.",
        "microsoft.user.personal_mail_ai.load_failed": "Could not load mail AI settings.",
        "microsoft.user.personal_mail_ai.no_refresh":
          "Connect Microsoft with a refresh token (full mail link) to load messages and run processing.",
        "microsoft.user.personal_mail_ai.connect_first":
          "Connect Microsoft above to configure inbox rules, AI routing, and processing for your own mailbox.",
        "microsoft.status.loading": "Loading status…",
        "microsoft.status.api_pending":
          "The API for saving tokens is still rolling out. You can still complete sign-in at Microsoft; contact an admin if something fails.",
        "microsoft.status.connected": "Connected",
        "microsoft.action.disconnect": "Disconnect",
        "microsoft.action.connect_microsoft": "Connect Microsoft",
        "microsoft.action.redirect_hint":
          "You’ll be sent to Microsoft to approve access, then back to Promang.",
        "microsoft.toast.login_required": "You must be signed in to Promang to connect.",
        "microsoft.toast.missing_env": "Microsoft is not configured on the server.",
        "microsoft.toast.start_failed": "Could not start Microsoft connection.",
        "microsoft.toast.disconnected": "Disconnected.",
        "microsoft.toast.disconnect_failed": "Could not disconnect.",
        "microsoft.callback.working": "Completing connection…",
        "microsoft.callback.error_microsoft": "Microsoft cancelled or failed.",
        "microsoft.callback.missing_params": "Missing code or state from Microsoft.",
        "microsoft.callback.success_login": "Signed in with Microsoft.",
        "microsoft.callback.success_link": "Microsoft account is connected.",
        "microsoft.callback.api_not_ready": "The API is not ready for this step yet.",
        "microsoft.callback.exchange_failed": "Could not complete the connection.",
        "microsoft.callback.unknown_intent": "Unknown connection type.",
        "microsoft.callback.title": "Microsoft & Promang",
        "microsoft.callback.subtitle_loading":
          "Completing a secure connection. This usually takes a few seconds.",
        "microsoft.callback.success_title": "Connection complete",
        "microsoft.callback.error_title": "Something went wrong",
        "microsoft.callback.redirecting_note": "Taking you back to Promang…",
        "microsoft.callback.continue_now": "Go to Promang now",
        "microsoft.callback.back_to_promang": "Back to Promang",
        "microsoft.callback.back_to_login": "Back to sign in",
        "microsoft.callback.debug_heading": "Technical detail (troubleshooting)",
        "microsoft.callback.wait_hint": "Do not close this tab while we finish.",
        "microsoft.login.or": "or",
        "microsoft.login.redirecting": "Redirecting…",
        "microsoft.login.with_microsoft": "Sign in with Microsoft",
        // Login page (split-screen design + loading system)
        "auth.login.title": "Sign in",
        "auth.login.subtitle": "Use your work account to continue.",
        "auth.login.email_label": "Email",
        "auth.login.email_placeholder": "name@company.com",
        "auth.login.password_label": "Password",
        "auth.login.show_password": "Show password",
        "auth.login.hide_password": "Hide password",
        "auth.login.remember_me": "Remember me",
        "auth.login.forgot_password": "Forgot password?",
        "auth.login.submit": "Sign in",
        "auth.login.submitting": "Signing in …",
        "auth.login.success": "Signed in",
        "auth.login.email_required": "Email is required",
        "auth.login.email_invalid": "Must be a valid email",
        "auth.login.password_required": "Password is required",
        "auth.login.brand_heading": "Projects, plans and teams — together.",
        "auth.login.brand_subtitle": "The platform that keeps your whole organization in sync.",
        "auth.login.brought_by": "Brought to you by",
        "auth.boot.initializing": "Initializing workspace",
        "auth.boot.syncing": "Syncing your modules",
        "auth.boot.securing": "Establishing secure link",
        "auth.boot.finalizing": "Finalizing — almost there",
        "auth.boot.secure_session": "secure session",
        "auth.session_expired.title": "Session expired",
        "auth.session_expired.message":
          "For your security you were signed out. Sign in again to pick up where you left off.",
        "auth.session_expired.login": "Sign in again",
        "auth.session_expired.cancel": "Cancel",
        "auth.login.invalid_credentials":
          "Could not sign you in. Check email and password, or use Sign in with Microsoft.",
        "auth.login.network_error":
          "Could not reach the sign-in service. Check your network and try again.",
        "auth.login.server_error":
          "Sign-in failed on the server. Please try again shortly.",
        "auth.login.bootstrap_failed":
          "Sign-in succeeded but your profile could not be loaded. Try again or contact support.",
        "auth.login.token_missing":
          "Could not sign you in. The server did not return an access token. Try again or contact support.",
        "auth.login.not_approved":
          "Your account is not approved yet. Contact your company administrator.",
        "auth.login.inactive":
          "Your account is deactivated. Contact your company administrator.",
        "auth.login.company_required":
          "No company is linked to your account. Contact your company administrator.",
        "users.login.no_password_use_microsoft":
          "This account has no Promang password. Sign in with Microsoft, or ask your administrator to send a password setup link.",
        "microsoft.test_mail.button": "Send test email to myself",
        "microsoft.test_mail.hint":
          "Sends one message from your linked mailbox to the same address, to verify Mail.Send and tokens.",
        "microsoft.test_mail.success": "Test email sent. Check your inbox.",
        "microsoft.test_mail.failed": "Could not send test email.",
        "microsoft.callback.promang_session_required": "Your Promang session could not be verified. Sign in to Promang and restart the Microsoft connection.",
    "microsoft.ai_mailboxes.connection.checking": "Checking Microsoft access …",
    "microsoft.ai_mailboxes.connection.available": "Microsoft access checked. Send permissions are checked when sending.",
    "microsoft.ai_mailboxes.connection.reauth_required": "Microsoft access has expired or was revoked. Reconnect this mailbox.",
    "microsoft.ai_mailboxes.connection.access_denied": "No access to this mailbox. Check permissions in Microsoft 365 and reconnect with the correct account.",
    "microsoft.ai_mailboxes.connection.unavailable": "Could not check access. Please try again later.",
    "microsoft.ai_mailboxes.connection.disconnected": "Microsoft is disconnected.",
    "microsoft.ai_mailboxes.connection.reconnect": "Reconnect Microsoft",
    "microsoft.ai_mailboxes.connection.check": "Check access",
    "microsoft.ai_mailboxes.connection.test_accepted": "Microsoft accepted the test email for sending. Delivery has not been confirmed.",
    "microsoft.ai_mailboxes.connection.unknown": "The result is unknown. Check the mailbox before sending another test. No automatic retry will be made.",
    "microsoft.ai_mailboxes.title": "Shared inboxes for AI",
        "microsoft.ai_mailboxes.admin_page_title": "Shared inboxes (Microsoft 365)",
        "microsoft.ai_mailboxes.admin_page_subtitle":
          "Register shared addresses, connect Microsoft, view the inbox, and configure how mail should be handled (sorting, cases, archive, auto-reply, signature, rules). Processing and optional move to Archive/Arkiv run when the job is on or you use “Run processing” (not simulation).",
        "microsoft.ai_mailboxes.intro":
          "Register shared addresses (e.g. post@, service@). Each mailbox must be linked with Microsoft so Promang can read the inbox and send tests via Graph.",
        "microsoft.ai_mailboxes.how_link_works":
          "Sign in as yourself (e.g. you@company.com) — not as the shared address. Shared mailboxes (e.g. post@…) usually have no password login. Use an account that can already open that shared mailbox in Outlook (full access / delegate). Promang stores a refresh token for the account you sign in with; Graph reads/sends for the address on this row.",
        "microsoft.ai_mailboxes.mail_safety_dev_notice":
          "We do not auto-archive, delete, or move mail in Microsoft. We read the inbox for display. “Run processing”, the scheduled job, and test mail can send **new** messages (e.g. notification forwards to addresses in rules) via Graph — use “Simulate job” to test without sending.",
        "microsoft.ai_mailboxes.linked_as": "Microsoft linked as {{email}}",
        "microsoft.ai_mailboxes.not_linked": "Not linked to Microsoft — connect to load inbox and send tests.",
        "microsoft.ai_mailboxes.connect_microsoft": "Connect Microsoft",
        "microsoft.ai_mailboxes.disconnect_microsoft": "Disconnect Microsoft",
        "microsoft.ai_mailboxes.send_test": "Send test email",
        "microsoft.ai_mailboxes.go_to_mailbox": "Go to mailbox",
        "microsoft.ai_mailboxes.go_to_mailbox_hint":
          "Opens Outlook on the web for this address in a new tab (folder tree: Inbox, Archive, etc.). Sign in to Microsoft in the browser with an account that can open this mailbox.",
        "microsoft.ai_mailboxes.go_to_mailbox_missing_email": "No mailbox address to open.",
        "microsoft.ai_mailboxes.multi_inbox_hint":
          "You can expand several mailboxes at the same time. Open a message in Promang to read it and view processing logs side by side.",
        "microsoft.ai_mailboxes.reader.title": "Message (Promang)",
        "microsoft.ai_mailboxes.reader.close": "Close",
        "microsoft.ai_mailboxes.reader.tab_message": "Content",
        "microsoft.ai_mailboxes.reader.tab_reply_draft": "AI reply draft",
        "microsoft.ai_mailboxes.reader.tab_logs": "Processing log",
        "microsoft.ai_mailboxes.reader.reply_draft_hint":
          "Edits the Outlook draft body (HTML). Sending from Outlook keeps the thread below your text.",
        "microsoft.ai_mailboxes.reader.reply_draft_load_failed": "Could not load reply draft.",
        "microsoft.ai_mailboxes.reader.reply_draft_saved": "Draft saved.",
        "microsoft.ai_mailboxes.reader.reply_draft_save": "Save draft",
        "microsoft.ai_mailboxes.reader.reply_draft_saving": "Saving…",
        "microsoft.ai_mailboxes.reader.reply_draft_none": "No AI reply draft for this message.",
        "microsoft.ai_mailboxes.reader.field_from": "From",
        "microsoft.ai_mailboxes.reader.field_to": "To",
        "microsoft.ai_mailboxes.reader.field_cc": "Cc",
        "microsoft.ai_mailboxes.reader.field_date": "Received",
        "microsoft.ai_mailboxes.reader.attachments_notice":
          "This message has attachments. Files are not shown here — use Outlook on the web if you need to download them.",
        "microsoft.ai_mailboxes.reader.body_iframe_title": "Email body",
        "microsoft.ai_mailboxes.reader.no_body": "No body content.",
        "microsoft.ai_mailboxes.reader.load_failed": "Could not load message.",
        "microsoft.ai_mailboxes.reader.inbox_only_hint":
          "The list above is inbox only. For Archive, Junk, and other folders, use Outlook on the web (link below) if needed.",
        "microsoft.ai_mailboxes.reader.folder_hint":
          "You can pick Archive, Sent, and other folders in the mailbox list above. Use Outlook on the web (link below) for full folder management if needed.",
        "microsoft.ai_mailboxes.reader.open_in_owa": "Open mailbox in Outlook on the web…",
        "microsoft.ai_mailboxes.reader.open_short": "Open",
        "microsoft.ai_mailboxes.reader.open_tooltip":
          "Open in Promang: read the email and view processing logs (tabs).",
        "microsoft.ai_mailboxes.show_inbox": "Mail folders",
        "microsoft.ai_mailboxes.inbox_requires_link": "Connect Microsoft for this address first.",
        "microsoft.ai_mailboxes.no_messages": "No messages in this folder (or folder is empty).",
        "microsoft.ai_mailboxes.messages_failed": "Could not load messages for this folder.",
        "microsoft.ai_mailboxes.process_folder_hint":
          "Select messages below, then simulate or run processing. The scheduled job still processes the Inbox only unless you change that separately.",
        "microsoft.ai_mailboxes.folder.select_label": "Folder",
        "microsoft.ai_mailboxes.folder.group_shortcuts": "Shortcuts",
        "microsoft.ai_mailboxes.folder.group_tree": "All folders",
        "microsoft.ai_mailboxes.folder.loading_tree": "Loading folder list…",
        "microsoft.ai_mailboxes.folder.folders_failed": "Could not load folder list.",
        "microsoft.ai_mailboxes.folder.seg_inbox": "Inbox",
        "microsoft.ai_mailboxes.folder.seg_archive": "Archive",
        "microsoft.ai_mailboxes.folder.seg_sentitems": "Sent",
        "microsoft.ai_mailboxes.folder.seg_deleteditems": "Deleted",
        "microsoft.ai_mailboxes.folder.seg_junkemail": "Junk email",
        "microsoft.ai_mailboxes.folder.seg_drafts": "Drafts",
        "microsoft.ai_mailboxes.folder.seg_outbox": "Outbox",
        "microsoft.ai_mailboxes.col.received": "Received",
        "microsoft.ai_mailboxes.col.from": "From",
        "microsoft.ai_mailboxes.col.subject": "Subject",
        "microsoft.ai_mailboxes.microsoft_disconnected": "Microsoft disconnected for this mailbox.",
        "microsoft.ai_mailboxes.microsoft_disconnect_failed": "Could not disconnect Microsoft.",
        "microsoft.ai_mailboxes.shared_test_ok": "Test email sent.",
        "microsoft.ai_mailboxes.shared_test_failed": "Could not send test email.",
        "microsoft.ai_mailboxes.email_label": "Email address",
        "microsoft.ai_mailboxes.email_placeholder": "post@company.com",
        "microsoft.ai_mailboxes.add": "Add",
        "microsoft.ai_mailboxes.empty": "No addresses added yet.",
        "microsoft.ai_mailboxes.remove": "Remove",
        "microsoft.ai_mailboxes.added": "Address added.",
        "microsoft.ai_mailboxes.add_failed": "Could not add address.",
        "microsoft.ai_mailboxes.removed": "Address removed.",
        "microsoft.ai_mailboxes.remove_failed": "Could not remove address.",
        "microsoft.ai_mailboxes.load_failed": "Could not load addresses.",
        "microsoft.ai_mailboxes.email_required": "Enter an email address.",
        "microsoft.ai_mailboxes.settings.toggle": "Settings",
        "microsoft.ai_mailboxes.settings.heading": "Mail handling",
        "microsoft.ai_mailboxes.settings.intro":
          "These options apply to this mailbox only. The inbox list uses Microsoft Graph ordering immediately after save.",
        "microsoft.ai_mailboxes.settings.processing_job_title": "Job: process inbox",
        "microsoft.ai_mailboxes.settings.processing_job_hint":
          "When “On” is saved, a scheduled task (e.g. Heroku Scheduler + `rake microsoft:enqueue_ai_mailbox_processing`) can process up to 50 recent messages and apply rules (including forward as a text notification). Use “Simulate job” on the inbox list to test safely.",
        "microsoft.ai_mailboxes.settings.processing_job_off": "Off",
        "microsoft.ai_mailboxes.settings.processing_job_on": "On",
        "microsoft.ai_mailboxes.settings.mail_sort": "Inbox sort order",
        "microsoft.ai_mailboxes.settings.sort_received_desc": "Newest first",
        "microsoft.ai_mailboxes.settings.sort_received_asc": "Oldest first",
        "microsoft.ai_mailboxes.settings.sort_subject_asc": "Subject A–Z",
        "microsoft.ai_mailboxes.settings.auto_create_case": "Create a case for new mail (when enabled in Promang)",
        "microsoft.ai_mailboxes.settings.auto_create_case_hint":
          "When the feature ships, exclusions below avoid cases from ads, newsletters, etc.",
        "microsoft.ai_mailboxes.settings.skip_promotional_hint": "Treat likely promo/newsletter mail as non-case (recommended)",
        "microsoft.ai_mailboxes.settings.ignore_subject_keywords": "Do not create a case if subject contains (comma or newline)",
        "microsoft.ai_mailboxes.settings.ignore_subject_placeholder": "e.g. promo, unsubscribe, newsletter",
        "microsoft.ai_mailboxes.settings.ignore_from_domains": "Do not create a case if sender domain is (comma or newline)",
        "microsoft.ai_mailboxes.settings.ignore_domains_placeholder": "e.g. mailchimp.com, sendgrid.net",
        "microsoft.ai_mailboxes.settings.archive_after_processing": "Archive after processing",
        "microsoft.ai_mailboxes.settings.archive_hint":
          "Moves processed mail from Inbox to **Archive** or **Arkiv** via Microsoft Graph after successful processing (manual rule or AI). Applies in development too — requires running processing with real actions, not “Simulate job”.",
        "microsoft.ai_mailboxes.settings.auto_reply_enabled": "Automatic reply after a new case is created (customer inquiry)",
        "microsoft.ai_mailboxes.settings.auto_reply_body_ph":
          "HTML body (optional). Placeholders: %{case_number}, %{sak}. If empty, a default text with the case number is used.",
        "microsoft.ai_mailboxes.settings.auto_reply_note":
          "When auto-reply is on, Promang replies in the same email thread (Graph reply), not as a separate new message. The reply subject line gets [SAK-<number>]. Signature HTML is appended when set.",
        "microsoft.ai_mailboxes.settings.signature_html": "Signature (HTML)",
        "microsoft.ai_mailboxes.settings.signature_ph": "<p>Kind regards<br/>…</p>",
        "microsoft.ai_mailboxes.settings.rules_heading": "Rules",
        "microsoft.ai_mailboxes.settings.rules_intro":
          "Match on subject or email address, then choose Archive or Forward (to a configured address). Rules run before AI routing and case creation. Legacy match types (contains / domain) remain available.",
        "microsoft.ai_mailboxes.settings.rules_forward_hint":
          "Forward sends the message to the configured address (same pattern as “Forward unknown mail”).",
        "microsoft.ai_mailboxes.settings.add_rule": "Add rule",
        "microsoft.ai_mailboxes.settings.no_rules": "No custom rules yet.",
        "microsoft.ai_mailboxes.settings.rule_name": "Name",
        "microsoft.ai_mailboxes.settings.rule_match": "Match",
        "microsoft.ai_mailboxes.settings.rule_value": "Value",
        "microsoft.ai_mailboxes.settings.rule_action": "Action",
        "microsoft.ai_mailboxes.settings.rule_on": "On",
        "microsoft.ai_mailboxes.settings.remove_rule": "Remove rule",
        "microsoft.ai_mailboxes.settings.match_subject": "Subject (contains)",
        "microsoft.ai_mailboxes.settings.match_email": "Email (from address)",
        "microsoft.ai_mailboxes.settings.match_subject_contains": "Subject contains",
        "microsoft.ai_mailboxes.settings.match_subject_equals": "Subject equals (exact)",
        "microsoft.ai_mailboxes.settings.match_from_domain": "From domain",
        "microsoft.ai_mailboxes.settings.match_from_contains": "From address contains",
        "microsoft.ai_mailboxes.settings.action_archive": "Archive",
        "microsoft.ai_mailboxes.settings.action_skip_case": "Do not create case",
        "microsoft.ai_mailboxes.settings.action_forward_to": "Forward",
        "microsoft.ai_mailboxes.settings.rule_forward_to_email": "Forward to (email)",
        "microsoft.ai_mailboxes.settings.rule_forward_to_placeholder": "e.g. orders@company.com",
        "microsoft.ai_mailboxes.settings.save": "Save settings",
        "microsoft.ai_mailboxes.settings.saved": "Settings saved.",
        "microsoft.ai_mailboxes.settings.save_failed": "Could not save settings.",
        "microsoft.ai_mailboxes.settings.ai_routing_heading": "AI routing",
        "microsoft.ai_mailboxes.settings.ai_routing_hint":
          "Choose what happens for each mail type. Settings are stored as JSON behind the scenes. When routing is on, OpenAI/Grok (env vars) classifies when available — otherwise heuristics. Manual rules override AI actions.",
        "microsoft.ai_mailboxes.settings.ai_routing_invalid_json": "Invalid JSON in AI routing.",
        "microsoft.ai_mailboxes.settings.ai_routing_raw_json": "Edit as raw JSON (advanced)",
        "microsoft.ai_mailboxes.settings.ai_routing_raw_json_hint":
          "The form and JSON are equivalent. When you turn raw JSON off, the text is parsed back into the form (must be valid JSON).",
        "microsoft.ai_mailboxes.ai_routing.master_enable": "Enable AI routing and automatic actions",
        "microsoft.ai_mailboxes.ai_routing.master_hint":
          "When off, messages are still classified for display, but no automatic AI actions run.",
        "microsoft.ai_mailboxes.ai_routing.reply_draft_title": "AI reply draft (Outlook)",
        "microsoft.ai_mailboxes.ai_routing.reply_draft_desc":
          "After a successful customer inquiry or case-reply handling, a reply draft is created in your Microsoft mailbox. You send when ready.",
        "microsoft.ai_mailboxes.ai_routing.reply_draft_enable": "Create AI-generated reply draft when processing",
        "microsoft.ai_mailboxes.ai_routing.reply_draft_requires_ai":
          "Turn on “Enable AI routing” above to use this (classification and case steps must run first).",
        "microsoft.ai_mailboxes.ai_routing.provider_label": "Classification provider",
        "microsoft.ai_mailboxes.ai_routing.provider_chatgpt": "ChatGPT (OpenAI)",
        "microsoft.ai_mailboxes.ai_routing.provider_grok": "Grok (xAI)",
        "microsoft.ai_mailboxes.ai_routing.model_label": "Model (optional)",
        "microsoft.ai_mailboxes.ai_routing.model_placeholder": "e.g. gpt-4o-mini",
        "microsoft.ai_mailboxes.ai_routing.model_hint": "Empty = server/environment default.",
        "microsoft.ai_mailboxes.ai_routing.action_label": "Action",
        "microsoft.ai_mailboxes.ai_routing.action_none": "Nothing (classify only)",
        "microsoft.ai_mailboxes.ai_routing.action_forward": "Forward to email",
        "microsoft.ai_mailboxes.ai_routing.action_move_archive": "Move to archive folder",
        "microsoft.ai_mailboxes.ai_routing.action_move_junk": "Move to junk email",
        "microsoft.ai_mailboxes.ai_routing.action_delete_graph": "Delete in Microsoft (Graph)",
        "microsoft.ai_mailboxes.ai_routing.action_move_folder": "Move to a folder",
        "microsoft.ai_mailboxes.ai_routing.action_create_case": "Create case in Promang",
        "microsoft.ai_mailboxes.ai_routing.action_append_case_note": "Add case line (CAS / case no.)",
        "microsoft.ai_mailboxes.ai_routing.action_customer_communication": "Log as customer communication on case",
        "microsoft.ai_mailboxes.ai_routing.action_reply_draft_only": "Log communication only (and AI reply draft if enabled)",
        "microsoft.ai_mailboxes.ai_routing.forward_to_label": "Forward to (email)",
        "microsoft.ai_mailboxes.ai_routing.folder_optional_label": "Folder name (optional)",
        "microsoft.ai_mailboxes.ai_routing.folder_optional_hint": "Empty uses default (Archive / Junk Email).",
        "microsoft.ai_mailboxes.ai_routing.folder_placeholder_archive": "Archive",
        "microsoft.ai_mailboxes.ai_routing.folder_placeholder_junk": "Junk Email",
        "microsoft.ai_mailboxes.ai_routing.folder_name_label": "Folder display name",
        "microsoft.ai_mailboxes.ai_routing.folder_placeholder_order": "Orders",
        "microsoft.ai_mailboxes.ai_routing.folder_order_hint": "The folder must exist in the Microsoft mailbox.",
        "microsoft.ai_mailboxes.ai_routing.cat_promotional_title": "Promotional / newsletter",
        "microsoft.ai_mailboxes.ai_routing.cat_promotional_desc": "Typical bulk marketing mail.",
        "microsoft.ai_mailboxes.ai_routing.cat_order_title": "Order confirmation",
        "microsoft.ai_mailboxes.ai_routing.cat_order_desc": "Orders and order documents.",
        "microsoft.ai_mailboxes.ai_routing.cat_inquiry_title": "New customer inquiry",
        "microsoft.ai_mailboxes.ai_routing.cat_inquiry_desc": "General inquiry without an existing case id in the thread.",
        "microsoft.ai_mailboxes.ai_routing.cat_inquiry_auto_reply_note":
          "Auto-reply and signature are configured in the sections further up on this page.",
        "microsoft.ai_mailboxes.ai_routing.cat_supplier_cas_title": "Supplier (CAS reference)",
        "microsoft.ai_mailboxes.ai_routing.cat_supplier_cas_desc":
          "Matches a case by CAS token or Promang case number in content. Fill “if no match” to avoid orphan mail.",
        "microsoft.ai_mailboxes.ai_routing.forward_unmatched_label": "If no match — forward to (email)",
        "microsoft.ai_mailboxes.ai_routing.forward_unmatched_hint": "Recommended so mail is not left without a case.",
        "microsoft.ai_mailboxes.ai_routing.cas_reference_label": "Fixed CAS reference (optional)",
        "microsoft.ai_mailboxes.ai_routing.cas_reference_hint": "Only if the reference is not in the email.",
        "microsoft.ai_mailboxes.ai_routing.case_number_fallback_label": "Fixed case number (optional)",
        "microsoft.ai_mailboxes.ai_routing.case_number_fallback_hint": "Numeric part, e.g. 1234, if not found in text.",
        "microsoft.ai_mailboxes.ai_routing.cat_case_reply_title": "Reply on existing case",
        "microsoft.ai_mailboxes.ai_routing.cat_case_reply_desc": "Mail that appears to relate to an open case (SAK id in thread).",
        "microsoft.ai_mailboxes.ai_routing.cat_project_title": "Project correspondence",
        "microsoft.ai_mailboxes.ai_routing.cat_project_desc":
          "Mail from a known customer / site contact about progress, deviations, site management, etc. — not a new generic customer inquiry.",
        "microsoft.ai_mailboxes.ai_routing.cat_project_reply_draft_note":
          "Requires the sender to match a Promang customer. Enable “AI reply draft” above for an Outlook draft.",
        "microsoft.ai_mailboxes.ai_routing.json_preview_toggle": "Show JSON to be saved (read-only)",
        "microsoft.ai_mailboxes.process_inbox_hint":
          "Select one or more messages and run processing (simulate sends no mail; Run may send forwards when a rule matches).",
        "microsoft.ai_mailboxes.process_select_all": "Select all",
        "microsoft.ai_mailboxes.process_clear_selection": "Clear selection",
        "microsoft.ai_mailboxes.process_select_column": "Select",
        "microsoft.ai_mailboxes.process_select_row": "Select message",
        "microsoft.ai_mailboxes.process_simulate": "Simulate job",
        "microsoft.ai_mailboxes.process_run": "Run processing",
        "microsoft.ai_mailboxes.process_need_selection": "Select at least one message in the list.",
        "microsoft.ai_mailboxes.process_run_confirm":
          "This may send real email (forwards) when rules match. Continue?",
        "microsoft.ai_mailboxes.process_ok_simulated":
          "Simulation done for {{count}} message(s). Forward rules that would fire: {{sim}}. Skip-case matches: {{skips}}.",
        "microsoft.ai_mailboxes.process_ok_executed":
          "Processing done for {{count}} message(s). Forwards sent: {{sent}}. Skip-case matches: {{skips}}.",
        "microsoft.ai_mailboxes.process_failed": "Could not process selected messages.",
        "microsoft.ai_mailboxes.processing_log.open_tooltip": "View processing log (dev tools)",
        "microsoft.ai_mailboxes.processing_log.title": "Processing log",
        "microsoft.ai_mailboxes.processing_log.close": "Close",
        "microsoft.ai_mailboxes.processing_log.load_failed": "Could not load processing logs.",
        "microsoft.ai_mailboxes.processing_log.empty":
          "No saved runs for this message yet. Use Simulate / Run processing, or wait for the scheduled job.",
        "microsoft.ai_mailboxes.processing_log.dry_run": "Dry run",
        "microsoft.ai_mailboxes.processing_log.live_run": "Live",
        "microsoft.ai_mailboxes.processing_log.failed": "Failed",
        "microsoft.ai_mailboxes.processing_log.ok": "OK",
        "microsoft.ai_mailboxes.processing_log.ai_category": "Classification",
        "microsoft.ai_mailboxes.processing_log.confidence": "confidence",
        "microsoft.ai_mailboxes.processing_log.actions": "Actions",
        "microsoft.ai_mailboxes.processing_log.raw_json": "Raw payload (JSON)",
        "microsoft.ai_mailboxes.processing_log.col_dev": "Log",
        "microsoft.ai_mailboxes.processing_log.sum.ai_classification":
          "AI: {{category}} ({{source}}, confidence {{confidence}})",
        "microsoft.ai_mailboxes.processing_log.sum.forward_dry": "Forward (dry run) → {{to}}",
        "microsoft.ai_mailboxes.processing_log.sum.forward_sent": "Forwarded → {{to}}",
        "microsoft.ai_mailboxes.processing_log.sum.forward_failed": "Forward failed → {{to}}: {{error}}",
        "microsoft.ai_mailboxes.processing_log.sum.move_dry": "Move (dry run){{target}}",
        "microsoft.ai_mailboxes.processing_log.sum.move_ok": "Moved → {{folder}}",
        "microsoft.ai_mailboxes.processing_log.sum.move_failed": "Move failed: {{error}}",
        "microsoft.ai_mailboxes.processing_log.sum.skip_case": "Rule: do not create case",
        "microsoft.ai_mailboxes.processing_log.sum.skip_case_unused": "skip_case (not applied)",
        "microsoft.ai_mailboxes.processing_log.sum.archive_dry": "Rule: archive (dry run)",
        "microsoft.ai_mailboxes.processing_log.sum.archive_ok": "Rule: archived{{folder}}",
        "microsoft.ai_mailboxes.processing_log.sum.archive_failed": "Rule: archive failed: {{error}}",
        "microsoft.ai_mailboxes.processing_log.sum.ai_routing_skipped": "AI routing skipped: {{reason}}",
        "microsoft.ai_mailboxes.processing_log.sum.unknown_fallback_sent": "Unknown mail forwarded → {{to}}",
        "microsoft.ai_mailboxes.processing_log.sum.unknown_fallback_dry": "Unknown mail forward (dry run) → {{to}}",
        "microsoft.ai_mailboxes.processing_log.sum.unknown_fallback_failed": "Unknown mail: forward failed ({{error}})",
        "microsoft.ai_mailboxes.processing_log.sum.system_copy_forward": "Promang copy forwarded → {{to}}",
        "microsoft.ai_mailboxes.processing_log.sum.system_copy_archive": "Promang copy archived{{folder}}",
        "microsoft.ai_mailboxes.processing_log.sum.system_copy_none": "Promang copy: no action (no new case)",
        "microsoft.ai_mailboxes.processing_log.sum.system_copy_already": "Promang copy: already handled",
        "microsoft.ai_mailboxes.processing_log.sum.generic_error": "{{type}}: {{error}}",
        "microsoft.ai_mailboxes.processing_log.sum.generic_not_applied": "{{type}}: not applied",
        "subscription.ai_usage.loading": "Loading…",
        "subscription.ai_usage.title": "AI usage & estimates",
        "subscription.ai_usage.subtitle":
          "Token usage, indicative cost and estimated time saved for your company (successful AI calls only).",
        "subscription.ai_usage.period.this_month": "This month",
        "subscription.ai_usage.period.this_year": "This year",
        "subscription.ai_usage.period.last_30_days": "Last 30 days",
        "subscription.ai_usage.period.last_12_months": "Last 12 months",
        "subscription.ai_usage.load_failed": "Could not load AI usage statistics.",
        "subscription.ai_usage.forbidden": "You do not have access to AI usage for this company.",
        "subscription.ai_usage.empty": "No AI usage recorded in this period.",
        "subscription.ai_usage.tokens": "Tokens (total)",
        "subscription.ai_usage.calls_ok": "Successful calls",
        "subscription.ai_usage.calls_fail": "Failed calls",
        "subscription.ai_usage.estimated_cost": "Estimated cost (NOK)",
        "subscription.ai_usage.cost_hint":
          "Internal estimate: {{rate}} NOK per 1M tokens. Not an invoice — actual provider pricing may differ.",
        "subscription.ai_usage.time_saved": "Estimated time saved",
        "subscription.ai_usage.time_hint":
          "Rough manual-equivalent minutes per successful call, by feature type. For planning only.",
        "subscription.ai_usage.minutes_only": "{{minutes}} min",
        "subscription.ai_usage.hours_minutes": "{{hours}} h {{minutes}} min",
        "subscription.ai_usage.by_feature": "By feature",
        "subscription.ai_usage.col_feature": "Feature",
        "subscription.ai_usage.col_calls": "Calls",
        "subscription.ai_usage.col_tokens": "Tokens",
        "subscription.ai_usage.col_cost": "Est. NOK",
        "subscription.ai_usage.col_time": "Est. time saved",
        "subscription.ai_usage.monthly_overview": "Per month (in period)",
        "subscription.ai_usage.feature.microsoft_ai_mailbox_classify": "AI inbox — classify",
        "subscription.ai_usage.feature.microsoft_ai_mailbox_case_title": "AI inbox — case title",
        "subscription.ai_usage.feature.service_report_invoice_description_generate":
          "Service report — invoice bullets",
        "subscription.ai_usage.feature.service_report_invoice_description_format_report":
          "Service report — HTML format",
        "subscription.ai_usage.feature.ai_generator_todo": "Tasks — AI assistant",
        "subscription.ai_usage.feature.ai_generator_hse_document": "HSE/KS — AI document fields",
        "subscription.ai_usage.feature.ai_generator_meeting_minutes": "Meeting minutes — AI agenda",
        "subscription.ai_usage.feature.other": "{{feature}}",

        "todo.pageTitle": "Tasks",
        "todo.sidebarTitle": "Todo",
        "todo.settingsTitle": "Task settings",
        "todo.backToTasks": "Back to tasks",
        "todo.settingsTemplatesTitle": "Shared company task templates",
        "todo.settingsTemplatesHelp": "Create recurring tasks for job positions or selected users. When one assignee marks the task done, it closes for everyone. Optional HSE/KS document link for routines.",
        "todo.settingsTemplatesHelpCompact": "Create templates with a title and HSE document. Expand for positions, assignees, and recurrence.",
        "todo.settingsManagePositions": "Manage employee positions",
        "todo.settingsTitlePlaceholder": "E.g. Review safety round",
        "todo.settingsAddDescription": "Add description",
        "todo.settingsShowDetails": "Show details",
        "todo.settingsHideDetails": "Hide details",
        "todo.settingsListHint": "Click a template to edit. Sorted by category and position.",
        "todo.settingsUntitled": "Untitled",
        "todo.settingsNoSummary": "No details set yet",
        "todo.settingsEditTemplate": "Edit template",
        "todo.settingsNewTemplate": "New template",
        "todo.settingsCompactSummary": "Summary",
        "todo.settingsNotSet": "Not set",
        "todo.settingsAssigneeCount": "{{count}} assignee(s)",
        "todo.settingsDueOffsetSummary": "+{{days}} days due",
        "todo.settingsNoPositionsHint": "No employee positions yet. Add them under Company settings.",
        "todo.settingsDueOffsetDays": "Due (days after creation)",
        "todo.settingsWorkingPositions": "Job positions",
        "todo.settingsAssignees": "Assignees",
        "todo.settingsAddAssignees": "Add users",
        "todo.settingsHseDocument": "HSE/KS document (optional)",
        "todo.settingsTemplateActive": "Template active",
        "todo.settingsTemplateInactive": "Inactive",
        "todo.settingsTemplateInactiveHint": "This template no longer spawns new tasks.",
        "todo.settingsSpawnNow": "Create tasks now",
        "todo.settingsSpawning": "Creating…",
        "todo.settingsRemoveTemplate": "Remove template",
        "todo.settingsAddTemplate": "Add template",
        "todo.settingsSave": "Save settings",
        "todo.settingsSaving": "Saving…",
        "todo.settingsSaved": "Task settings saved",
        "todo.settingsLoadError": "Could not load task settings",
        "todo.settingsSaveError": "Could not save task settings",
        "todo.confirmClose.title": "Save changes?",
        "todo.confirmClose.text": "You have unsaved changes. Do you want to save before closing?",
        "todo.confirmClose.keepEditing": "Keep editing",
        "todo.confirmClose.closeWithoutSaving": "Close without saving",
        "todo.confirmClose.saveAndClose": "Save and close",
        "todo.settingsSpawnSuccess": "Shared tasks created",
        "todo.settingsSpawnError": "Could not create tasks from template",
        "todo.sharedTaskLabel": "Shared company task",
        "todo.sharedTaskBadge": "Shared",
        "todo.sharedTaskEnabled": "Shared task",
        "todo.sharedTaskDisabled": "Personal task",
        "todo.sharedTaskActiveBadge": "Shared mode on",
        "todo.sharedTaskActiveHint": "Shared mode is enabled. The task is assigned to selected users and saved as a company template.",
        "todo.sharedFromTemplateInfo": "Shared company task from a template. Status is set automatically and cannot be changed manually.",
        "todo.sharedFromAssigneesInfo": "Shared company task because the task has multiple assignees (at least two). Status is set automatically.",
        "todo.taskAssigneesLabel": "Assignees",
        "todo.taskAssigneesHint": "Add employees who should see the task in their inbox. With two or more assignees the task becomes a shared company task automatically (admin).",
        "todo.propertyInfoAria": "More information about {{label}}",
        "todo.createAddAssignees": "Add assignees",
        "todo.moduleTagsLabel": "Modules",
        "todo.moduleTagsAdd": "Add module",
        "todo.systemLinksLabel": "System links",
        "todo.mobileNav.ariaLabel": "Task menu",
        "todo.mobileNav.todo": "Todo",
        "todo.mobileNav.today": "Today",
        "todo.mobileNav.priority": "Priority",
        "todo.mobileNav.newTask": "New task",
        "todo.mobileNav.mine": "Mine",
        "todo.mobileNav.journal": "Journal",
        "todo.mobileNav.settings": "Settings",
        "todo.sharedTaskDuplicateError": "A similar shared task already exists. Change the title, HSE document, or assignees.",
        "todo.sharedTaskDeleteAdminOnly": "Only company administrators can delete shared tasks.",
        "todo.sharedCompletionAny": "Done when any assignee completes",
        "todo.sharedAssigneeCount": "{{count}} assignees",
        "todo.settingsPositionsTitle": "Positions and assignees",
        "todo.settingsPositionsHelp": "Save job positions (e.g. Administrator) and pick one user who receives all tasks for that position. Without a routed user, all employees with that position are matched.",
        "todo.settingsPositionNamePlaceholder": "Position name, e.g. Administrator",
        "todo.settingsCategoryPlaceholder": "Category, e.g. HSE",
        "todo.settingsAddPosition": "Save position",
        "todo.settingsPositionExists": "This position already exists",
        "todo.settingsRouteAllTasks": "All tasks → choose user",
        "todo.settingsRouteToUser": "All tasks → {{name}}",
        "todo.settingsClearRoute": "Clear routing",
        "todo.settingsCategory": "Category",
        "todo.settingsCopyCategoryPositions": "Apply positions from category",
        "todo.settingsCopyCategoryPositionsHint": "Choose category…",
        "todo.employeePositionsTitle": "Company employee positions",
        "todo.employeePositionsHelp": "Manage employee positions under Company settings. They are used in task templates and employment records.",
        "todo.employeePositionName": "Position",
        "todo.employeePositionAdd": "Add position",
        "todo.employeePositionRemove": "Remove position",
        "todo.employeePositionCount": "{{count}} employees with this position",
        "todo.tabTasks": "Tasks",
        "todo.filterTodayPlan": "Today's plan",
        "todo.loadingMoreTodos": "Loading more tasks…",
        "todo.loadMoreError": "Could not load more tasks.",
        "todo.filterAll": "All",
        "todo.filterActive": "Active",
        "todo.filterFinished": "Done",
        "todo.filterMine": "My tasks",
        "todo.newTask": "New task",
        "todo.emptyState": "No tasks yet. Press",
        "todo.loadError": "Could not load tasks.",
        "todo.loadingTasks": "Loading tasks…",
        "todo.groupBy": "Group by",
        "todo.taskCountOne": "task",
        "todo.taskCountOther": "tasks",
        "todo.due": "Due",
        "todo.todayPlanBadge": "Today’s plan",
        "todo.taskDetails": "Task details",
        "todo.createTitle": "New task",
        "todo.createTitlePlaceholder": "Title",
        "todo.titleMaxLength": "Maximum {{max}} characters (2 lines in the list)",
        "todo.createSubmit": "Create task",
        "todo.createSubmitHint": "to create",
        "todo.descriptionLabel": "Description",
        "todo.addDescription": "Add description",
        "todo.descriptionAdded": "Description added",
        "todo.hideDescription": "Hide",
        "todo.descriptionPlaceholder": "Add a description…",
        "todo.propertiesLabel": "Properties",
        "todo.statusLabel": "Status",
        "todo.priorityLabel": "Priority",
        "todo.moduleLabel": "Module",
        "todo.moduleKind.project": "Project",
        "todo.moduleKind.customer": "Customer",
        "todo.moduleKind.tag": "Label",
        "todo.moduleKind.shared": "Shared",
        "todo.peopleLabel": "People",
        "todo.linksLabel": "Links",
        "todo.statusTimeline": "Status timeline",
        "todo.activityLabel": "Activity",
        "todo.deleteTask": "Delete task",
        "todo.priorityUrgent": "Urgent",
        "todo.priorityHigh": "High",
        "todo.priorityMed": "Medium",
        "todo.priorityLow": "Low",
        "todo.statusDoing": "In progress",
        "todo.statusTodo": "To do",
        "todo.statusDone": "Done",
        "todo.reopen": "Reopen",
        "todo.markDone": "Mark done",
        "todo.setDate": "Set date",
        "todo.remindMe": "Remind me",
        "todo.toggleOn": "On",
        "todo.toggleOff": "Off",
        "todo.untitledTask": "Untitled task",
        "todo.hasDescription": "Has description",
        "todo.hasReminder": "Has reminder",
        "todo.lockedAbsence": "This task is linked to absence that must be approved or denied first.",
        "todo.lockedItemList": "This item list task must be completed in inventory handling.",
        "todo.customerLink": "Customer",
        "todo.projectLink": "Project",
        "todo.absenceLink": "Absence",
        "todo.itemListLink": "Item list",
        "todo.activityWhoUser": "User",
        "todo.activityEmpty": "No activity yet.",
        "todo.activityCreated": "created this task",
        "todo.activityFinished": "completed this task",
        "todo.activityUpdated": "updated this task",
        "todo.toastCreated": "Task created",
        "todo.toastCreateFailed": "Could not create task",
        "todo.toastUpdateFailed": "Could not save changes",
        "todo.toastDeleted": "Task deleted",
        "todo.toastDeleteFailed": "Could not delete task",
        "todo.toastStatusFailed": "Could not update status",
        "todo.nextDueTitle": "This task is overdue",
        "todo.nextDueHint": "The next due date is counted from today, not from the old overdue date. Change the date if you want.",
        "todo.nextDueLabel": "Next due date",
        "todo.nextDueConfirm": "Complete and set due date",
        "todo.confirmDelete": "Delete this task?",
        "todo.dateToday": "Today",
        "todo.dateTomorrow": "Tomorrow",
        "todo.dateNextWeek": "Next week",
        "todo.dateInThreeDays": "In 3 days",
        "todo.reminderInOneHour": "In 1 hour",
        "todo.reminderThisEvening": "This evening",
        "todo.reminderTomorrowMorning": "Tomorrow morning",
        "todo.reminderNextWeekMorning": "Next week (Mon 9:00)",
        "todo.dateCustom": "Custom",
        "todo.clear": "Clear",
        "todo.dateTimeToday": "Today, {{time}}",
        "todo.dateTimeDaysAgo": "{{count}}d ago",
        "todo.dueDate": "Due date",
        "todo.reminder": "Reminder",
        "todo.onTodayPlan": "On today’s plan",
        "todo.recurrence": "Repeat when completed",
        "todo.recurrenceNone": "None",
        "todo.recurrenceDaily": "Daily",
        "todo.recurrenceWeekdays": "Weekdays",
        "todo.recurrenceWeekly": "Weekly",
        "todo.recurrenceMonthly": "Monthly",
        "todo.estimatedHours": "Estimated hours",
        "todo.labels": "Labels",
        "todo.aiAssistant": "AI assistant",
        "todo.hoursAvailable": "Hours available today (for day plan)",
        "todo.aiSuggestions": "Suggestions",
        "todo.aiEstimate": "Time estimate",
        "todo.aiPlan": "Day plan",
        "todo.aiResultTitle": "AI result",
        "todo.aiLoading": "Generating…",
        "todo.aiError": "Could not get AI suggestions.",
        "todo.hseDocumentTaskManualFinish":
          "HSE/KS document tasks are completed by confirming that the document has been read and understood.",
        "todo.hseDocumentTaskComplete":
          "Complete here to confirm that you have read and understood the document.",
        "todo.hseDocumentTaskCannotReopen":
          "HSE/KS document tasks cannot be reopened from the to-do list.",
        "todo.hseDocumentOpenLink": "Open HSE/KS document",
        "hse.document.acknowledge_read": "I confirm that I have read and understood",
        "hse.document.acknowledge_read_submitting": "Saving…",
        "hse.document.acknowledge_read_success": "Recorded as read/understood",
        "hse.document.acknowledge_read_error": "Could not record read/understood",
        "hse.document.acknowledge_read_hint":
          "After you have reviewed the content, confirm here. The task in your to-do list is completed automatically.",
        "hse.document.acknowledge_read_done": "You are recorded as having read and understood this version.",
        "hse.document.approval_stuck_retry_hint":
          "Approval may not have finished publishing the version. Click Approve again to complete the step.",
        "hse.document.file_missing": "Attached file could not be found.",
        "hse.document.file_processing": "The file is still being processed. Please try again in a moment.",
        "hse.document.file_failed": "The file upload failed. Please upload the document again.",
        "hse.document.open_file": "Open file",
        "hse.document.download_file": "Download file",
        "hse.document.attached_file": "Attached file",
        "hse.upload.save_first": "Save first to upload documents.",
        "hse.documents.json.open_dialog": "JSON / AI",
        "hse.documents.json.dialog_title": "HSE/KS documents — JSON and AI",
        "hse.documents.json.tab_json": "Paste JSON",
        "hse.documents.json.tab_ai_guide": "AI instructions",
        "hse.documents.json.hint":
          "Paste JSON from AI or edit manually. Creates draft documents and can create new Discipline, Category and Chapter when needed.",
        "hse.documents.json.current_structure": "Current Discipline / Category / Chapter",
        "hse.documents.json.existing_documents": "Existing documents (do not duplicate)",
        "hse.documents.json.loading_documents": "loading…",
        "hse.documents.json.copy_json": "Copy JSON",
        "hse.documents.json.copy_success": "JSON copied",
        "hse.documents.json.reload_blank": "Clear template",
        "hse.documents.json.reload_success": "Blank template loaded",
        "hse.documents.json.insert_sample": "Insert sample",
        "hse.documents.json.apply": "Import into Promang",
        "hse.documents.json.importing": "Importing…",
        "hse.documents.json.imported":
          "Imported: {{documents}} document(s), {{chapters}} chapter(s), {{categories}} categor(y/ies), {{disciplines}} discipline(s)",
        "hse.documents.json.import_failed": "Import failed",
        "hse.documents.json.clipboard_failed": "Could not copy to clipboard",
        "hse.documents.json.ai_guide_intro":
          "Copy the instructions below into ChatGPT, Claude or another AI. Then paste the JSON reply under Paste JSON. The guide lists the company's current chapters.",
        "hse.documents.json.copy_ai_guide": "Copy AI instructions",
        "hse.documents.json.ai_guide_copied": "AI instructions copied",
        "hse.documents.json.generate_with_ai": "Generate with AI",
        "hse.documents.json.ai_parse_error": "Could not parse AI response as JSON",
        "hse.documents.json.ai_apply_success": "{{count}} document(s) loaded from AI — review and import",
        "hse.documents.json.error_empty": "JSON is empty",
        "hse.documents.json.error_invalid_json": "Invalid JSON",
        "hse.documents.json.error_invalid_shape": "Invalid JSON shape",
        "hse.documents.json.error_no_valid_items": "No valid documents or structure in JSON",
        "hse.documents.json.error_too_many_documents": "Too many documents (max 50)",
        "hse.documents.json.create_missing": "Create missing Discipline/Category/Chapter",
        "hse.documents.json.create_missing_hint":
          "Off by default — reuse existing structure. Enable only when you need new taxonomy.",
        "hse.documents.json.atomic": "Atomic import (rollback documents on failure)",
        "hse.documents.json.dropped_rows":
          "{{count}} row(s) skipped before import: {{detail}}",
        "hse.documents.json.result_title": "Import result",
        "hse.documents.json.result_hint":
          "Drafts may not appear in the list for non-admins — open via the links below.",
        "hse.documents.json.result_no_docs": "No documents created (structure only or errors).",
        "hse.digest.hub_tab": "Weekly HSE email",
        "hse.digest.title": "Weekly HSE email",
        "hse.digest.hub_intro":
          "Send a weekly overview of new events, new HSE/KS documents and unread documents. Off by default.",
        "hse.digest.load_failed": "Could not load HSE email settings",
        "hse.digest.saved": "Settings saved",
        "hse.digest.save_failed": "Could not save HSE email settings",
        "hse.digest.enabled.title": "Weekly delivery",
        "hse.digest.enabled.description":
          "When this is on, relevant users receive an email on the selected weekday and time (Europe/Oslo).",
        "hse.digest.enabled.toggle": "Send weekly HSE email",
        "hse.digest.schedule.title": "Schedule",
        "hse.digest.schedule.description": "The email is sent once per week on the selected day and hour.",
        "hse.digest.weekday": "Weekday",
        "hse.digest.weekday.sunday": "Sunday",
        "hse.digest.weekday.monday": "Monday",
        "hse.digest.weekday.tuesday": "Tuesday",
        "hse.digest.weekday.wednesday": "Wednesday",
        "hse.digest.weekday.thursday": "Thursday",
        "hse.digest.weekday.friday": "Friday",
        "hse.digest.weekday.saturday": "Saturday",
        "hse.digest.hour": "Time",
        "hse.digest.timezone": "Timezone",
        "hse.digest.timezone_value": "Europe/Oslo",
        "hse.digest.last_sent": "Last sent {{date}}",
        "hse.digest.last_sent_never": "Not sent yet",
        "hse.digest.content.title": "Contents",
        "hse.digest.content.intro": "The email may include these sections. Empty sections are omitted.",
        "hse.digest.content.events": "New events",
        "hse.digest.content.documents": "New documents",
        "hse.digest.content.unread": "Documents you have not read",
        "hse.document_read_overview.title": "Read / understood",
        "hse.document_read_overview.subtitle":
          "Overview of who has confirmed that they have read and understood HSE/KS documents.",
        "hse.document_read_overview.back_to_documents": "Back to documents",
        "hse.document_read_overview.summary_pending": "Confirmation missing",
        "hse.document_read_overview.summary_acknowledged": "Read and confirmed",
        "hse.document_read_overview.summary_documents": "Documents",
        "hse.document_read_overview.summary_employees": "Employees",
        "hse.document_read_overview.search": "Search",
        "hse.document_read_overview.search_placeholder": "Search employee, email or document…",
        "hse.document_read_overview.filter_document": "Document",
        "hse.document_read_overview.all_documents": "All documents",
        "hse.document_read_overview.filter_all": "All",
        "hse.document_read_overview.filter_pending": "Confirmation missing",
        "hse.document_read_overview.filter_acknowledged": "Read and confirmed",
        "hse.document_read_overview.filter_exempt": "Exempt",
        "hse.document_read_overview.view_employees": "Employees",
        "hse.document_read_overview.view_documents": "Documents",
        "hse.document_read_overview.empty": "No matches",
        "hse.document_read_overview.col_employee": "Employee",
        "hse.document_read_overview.col_pending": "Pending",
        "hse.document_read_overview.col_acknowledged": "Confirmed",
        "hse.document_read_overview.unknown_user": "Unknown user",
        "hse.document_read_overview.former_employee": "Former employee",
        "hse.document_read_overview.unknown_document": "Unknown document",
        "hse.document_read_overview.col_document": "Document",
        "hse.document_read_overview.status_acknowledged": "Read and confirmed",
        "hse.document_read_overview.status_exempt": "Author (exempt)",
        "hse.document_read_overview.status_pending": "Confirmation missing",
        "hse.document_read_overview.filter_employee": "Employee",
        "hse.document_read_overview.filter_status": "Status",
        "hse.document_read_overview.filter_acknowledged_from": "Confirmed from",
        "hse.document_read_overview.filter_acknowledged_to": "Confirmed to",
        "hse.document_read_overview.print_action": "Export PDF",
        "hse.document_read_overview.print_title": "Read / understood by employee",
        "hse.document_read_overview.print_dialog_title": "Export overview by employee",
        "hse.document_read_overview.print_dialog_intro":
          "Choose which rows to include. The list is grouped by employee and downloaded as a PDF.",
        "hse.document_read_overview.print_scope": "Scope",
        "hse.document_read_overview.print_scope_pending": "Unread / not confirmed only",
        "hse.document_read_overview.print_scope_acknowledged": "Read and confirmed only",
        "hse.document_read_overview.print_scope_all": "All",
        "hse.document_read_overview.print_submit": "Download PDF",
        "hse.document_read_overview.print_cancel": "Cancel",
        "hse.document_read_overview.print_empty": "No rows to export with the selected filter.",
        "hse.document_read_overview.print_generated_at": "Generated {{date}}",
        "hse.document_read_overview.print_col_date": "Date",
        "hse.dashboard.title": "HSE & QA",
        "hse.dashboard.subtitle": "Overview of KPIs, tasks, alerts and recent events",
        "hse.dashboard.kpi.title": "KPI overview",
        "hse.dashboard.kpi.events": "Events",
        "hse.dashboard.kpi.deviations": "Deviations",
        "hse.dashboard.kpi.unread_docs": "Unread documents",
        "hse.dashboard.kpi.unread_docs.info":
          "Approved HSE/QA documents you have not confirmed as read and understood. Authors are exempt.",
        "hse.dashboard.kpi.unread_docs.info_aria": "How unread documents are counted",
        "hse.dashboard.kpi.open_actions": "Open actions",
        "hse.dashboard.kpi.open_actions.info":
          "Actions that are not completed or cancelled. Open the event to follow up.",
        "hse.dashboard.kpi.open_actions.info_aria": "How open actions are counted",
        "hse.dashboard.kpi.overdue": "Overdue",
        "hse.dashboard.kpi.overdue.info":
          "Actions with a deadline before today that are not completed.",
        "hse.dashboard.kpi.overdue.info_aria": "How overdue actions are counted",
        "hse.dashboard.tasks.title": "My tasks",
        "hse.dashboard.tasks.empty": "No open tasks right now.",
        "hse.dashboard.tasks.kind.action": "Action",
        "hse.dashboard.tasks.kind.acknowledgement": "Read acknowledgement",
        "hse.dashboard.tasks.kind.task": "Task",
        "hse.dashboard.tasks.overdue": "Overdue",
        "hse.dashboard.tasks.due": "Due {{date}}",
        "hse.dashboard.alerts.title": "Alerts",
        "hse.dashboard.alerts.empty": "No alerts.",
        "hse.dashboard.alerts.overdue_actions": "{{count}} overdue actions",
        "hse.dashboard.alerts.unread_docs": "{{count}} documents awaiting acknowledgement",
        "hse.dashboard.alerts.due_soon": "{{count}} actions due soon",
        "hse.dashboard.alerts.critical_events": "{{count}} critical events",
        "hse.dashboard.events.title": "Recent events",
        "hse.dashboard.events.empty": "No events to show.",
        "hse.dashboard.events.view_all": "View all",
        "hse.dashboard.org_charts.title": "Organisation chart",
        "hse.dashboard.org_charts.view_all": "View all",
        "hse.dashboard.org_charts.empty": "No organisation charts found",
        "hse.dashboard.org_charts.revision": "Revision {{number}}",
        "hse.dashboard.org_charts.approved": "Approved {{date}}",
        "hse.dashboard.org_charts.view": "View",
        "hse.dashboard.org_charts.pdf": "PDF",
        "hse.dashboard.org_charts.pdf_success": "PDF exported",
        "hse.dashboard.org_charts.pdf_error": "Could not export PDF",
        "hse.dashboard.error": "Could not load the HSE overview.",
        "hse.dashboard.error_toast": "Something went wrong while loading the HSE overview.",
        "hse.dashboard.retry": "Try again",
        "hse.dashboard.see_all": "View all",
        "hse.document_read_overview.export_loading": "Creating PDF…",
        "hse.document_read_overview.export_error": "Could not create the PDF. Try again.",
        "hse.tiltak.title": "Actions",
        "hse.tiltak.subtitle": "Follow-ups, new routines and document actions in HSE",
        "hse.tiltak.form_subtitle": "Title, owner and due date matter most. The rest can wait.",
        "hse.tiltak.view_subtitle": "HSE follow-up action",
        "hse.tiltak.new": "New action",
        "hse.tiltak.open": "Open",
        "hse.tiltak.edit": "Edit action",
        "hse.tiltak.export_pdf": "Download PDF",
        "hse.tiltak.col_actions": "Actions",
        "hse.tiltak.create": "Create action",
        "hse.tiltak.save": "Save action",
        "hse.tiltak.cancel": "Cancel",
        "hse.tiltak.start": "Start",
        "hse.tiltak.complete": "Complete",
        "hse.tiltak.created": "Action created",
        "hse.tiltak.updated": "Action updated",
        "hse.tiltak.started": "Action started",
        "hse.tiltak.completed": "Action completed",
        "hse.tiltak.save_failed": "Could not save the action",
        "hse.tiltak.load_failed": "Could not load actions",
        "hse.tiltak.empty": "No actions yet. Create the first one.",
        "hse.tiltak.search": "Search",
        "hse.tiltak.search_placeholder": "Search title or description…",
        "hse.tiltak.filter_all": "All",
        "hse.tiltak.col_title": "Title",
        "hse.tiltak.col_type": "Type",
        "hse.tiltak.col_assignee": "Owner",
        "hse.tiltak.col_deadline": "Due date",
        "hse.tiltak.col_status": "Status",
        "hse.tiltak.status_overdue": "Overdue",
        "hse.tiltak.field.title": "Title",
        "hse.tiltak.field.description": "Description",
        "hse.tiltak.field.action_type": "Action type",
        "hse.tiltak.field.category": "Category",
        "hse.tiltak.field.priority": "Priority",
        "hse.tiltak.field.status": "Status",
        "hse.tiltak.field.deadline": "Due date",
        "hse.tiltak.field.assignee": "Owner",
        "hse.tiltak.field.event": "Linked event",
        "hse.tiltak.field.document": "Linked document",
        "hse.tiltak.event_none": "No event",
        "hse.tiltak.linked_event": "Open event",
        "hse.tiltak.linked_document": "Open document",
        "hse.tiltak.view_for_event": "View actions for this event",
        "hse.tiltak.error_title": "Add a short title",
        "hse.tiltak.error_deadline": "Choose a due date",
        "hse.tiltak.error_assignee": "Choose who owns the action",
        "hse.tiltak.error_document": "Choose the related document",
        "hse.tiltak.type.generic": "Follow-up",
        "hse.tiltak.type.new_routine": "New routine",
        "hse.tiltak.type.linked_document": "Document action",
        "hse.tiltak.category.safety": "Safety",
        "hse.tiltak.category.quality": "Quality",
        "hse.tiltak.category.environment": "Environment",
        "hse.tiltak.category.procedure": "Routine / procedure",
        "hse.tiltak.category.training": "Training",
        "hse.tiltak.category.maintenance": "Maintenance",
        "hse.tiltak.category.equipment": "Equipment",
        "hse.tiltak.category.communication": "Communication",
        "hse.tiltak.category.other": "Other",
        "hse.tiltak.priority.low": "Low",
        "hse.tiltak.priority.medium": "Medium",
        "hse.tiltak.priority.high": "High",
        "hse.tiltak.priority.critical": "Critical",
        "hse.tiltak.status.planned": "Planned",
        "hse.tiltak.status.started": "Started",
        "hse.tiltak.status.in_progress": "In progress",
        "hse.tiltak.status.completed": "Completed",
        "hse.tiltak.status.cancelled": "Cancelled",
        "hse.tiltak.status.on_hold": "On hold",
        "hse.tiltak.info.title.title": "Title",
        "hse.tiltak.info.title.body": "A short sentence describing the work, for example “Update fire routine” or “Follow up warehouse near miss”.",
        "hse.tiltak.info.description.title": "Description",
        "hse.tiltak.info.description.body": "What should be done, why, and what done looks like. Keep it concrete so the owner knows the next step.",
        "hse.tiltak.info.action_type.title": "Action type",
        "hse.tiltak.info.action_type.body": "Follow-up is a normal action after an event. New routine creates or changes a standard way of working. Document action ties the work to an HSE document.",
        "hse.tiltak.info.category.title": "Category",
        "hse.tiltak.info.category.body": "Helps you sort actions by theme (safety, quality, environment, routine, training).",
        "hse.tiltak.info.priority.title": "Priority",
        "hse.tiltak.info.priority.body": "Critical and high should have a short due date. Medium and low can wait if more serious actions are open.",
        "hse.tiltak.info.status.title": "Status",
        "hse.tiltak.info.status.body": "Planned = not started. Started/in progress = someone is working on it. Completed = done. On hold = paused.",
        "hse.tiltak.info.deadline.title": "Due date",
        "hse.tiltak.info.deadline.body": "The date the action should be finished. Overdue items are highlighted in the list.",
        "hse.tiltak.info.assignee.title": "Owner",
        "hse.tiltak.info.assignee.body": "The person who owns the action. The company can set a default owner in HSE settings.",
        "hse.tiltak.info.event.title": "Linked event",
        "hse.tiltak.info.event.body": "Optional. Use when the action comes from an accident, near miss, deviation or observation.",
        "hse.tiltak.info.document.title": "Linked document",
        "hse.tiltak.info.document.body": "Optional, but required for document actions. Choose the routine or document to create or update.",
        "hse.tiltak.print_action": "Print",
        "hse.tiltak.print_title": "Action list",
        "hse.tiltak.print_dialog_title": "Print actions",
        "hse.tiltak.print_dialog_intro": "Choose which actions to include. The list follows the filters you already set.",
        "hse.tiltak.print_scope": "Scope",
        "hse.tiltak.print_scope_open": "Open actions",
        "hse.tiltak.print_scope_overdue": "Overdue actions",
        "hse.tiltak.print_scope_completed": "Completed actions",
        "hse.tiltak.print_scope_all": "All actions in the list",
        "hse.tiltak.print_submit": "Print",
        "hse.tiltak.print_cancel": "Cancel",
        "hse.tiltak.print_empty": "No actions to print with the selected filter.",
        "hse.tiltak.print_generated_at": "Generated {{date}}",
        "hse.tiltak.pdf_failed": "Could not download the action PDF",
        "hse.settings.hub_tab": "HSE module",
        "hse.settings.title": "Company HSE settings",
        "hse.settings.hub_intro": "Tailor which HSE parts the company uses, who is responsible, and how often the system is reviewed.",
        "hse.settings.load_failed": "Could not load HSE settings",
        "hse.settings.saved": "HSE settings saved",
        "hse.settings.save_failed": "Could not save HSE settings",
        "hse.settings.print_action": "Print / PDF",
        "hse.settings.modules.title": "Modules in use",
        "hse.settings.modules.description": "Turn off what the company does not use. Existing data stays, you only mark what is active.",
        "hse.settings.modules.tiltak": "Actions",
        "hse.settings.modules.tiltak_help": "Follow-ups, new routines and document actions.",
        "hse.settings.modules.events": "Events",
        "hse.settings.modules.events_help": "Deviations, near misses, accidents and observations.",
        "hse.settings.modules.documents": "Documents",
        "hse.settings.modules.documents_help": "Handbook, routines and read/understood.",
        "hse.settings.modules.competency": "Competency",
        "hse.settings.modules.competency_help": "Requirements, courses and training plan.",
        "hse.settings.modules.evaluation": "Evaluation",
        "hse.settings.modules.evaluation_help": "Internal audit and management review.",
        "hse.settings.modules.risk": "Risk and JSA",
        "hse.settings.modules.risk_help": "Risk register, JSA and chemical inventory.",
        "hse.settings.modules.sja": "JSA",
        "hse.settings.modules.sja_help": "Job safety analysis before work starts.",
        "hse.settings.modules.goals": "Goals",
        "hse.settings.modules.goals_help": "Annual HSE goals, focus areas and approval.",
        "hse.settings.responsible.title": "HSE owner",
        "hse.settings.responsible.description": "Default person suggested on new actions.",
        "hse.settings.responsible.info_title": "HSE owner",
        "hse.settings.responsible.info_body": "The company’s standing HSE contact. New actions suggest this person as owner, but you can change it per action.",
        "hse.settings.cadence.title": "Review cadence",
        "hse.settings.cadence.description": "How often management should review the HSE system.",
        "hse.settings.cadence.info_title": "Review cadence",
        "hse.settings.cadence.info_body": "ISO 9001/45001 expects regular review. 12 months is common. Choose 3 or 6 months if you have high risk or frequent change.",
        "hse.settings.cadence.3": "Every 3 months",
        "hse.settings.cadence.6": "Every 6 months",
        "hse.settings.cadence.12": "Every 12 months",
        "hse.settings.tiltak_defaults.title": "Action defaults",
        "hse.settings.tiltak_defaults.description": "Used when someone creates an action without filling every field.",
        "hse.settings.tiltak_defaults.info_title": "Action defaults",
        "hse.settings.tiltak_defaults.info_body": "Default due date counts days from today. Approval means someone must confirm the action before it is closed.",
        "hse.settings.tiltak_defaults.due_days": "Default due date (days)",
        "hse.settings.tiltak_defaults.require_approval": "Require approval before closing an action",
        "hse.settings.pdf_failed": "Could not download the PDF",
        "hse.settings.safety_rep.hub_tab": "Safety representative",
        "hse.settings.safety_rep.title": "Safety representative",
        "hse.settings.safety_rep.hub_intro": "Who is the safety representative and any deputies. Required for internal control.",
        "hse.settings.safety_rep.description": "Choose the company’s safety representative. This person is notified when HSE setup is incomplete.",
        "hse.settings.safety_rep.who": "Safety representative",
        "hse.settings.safety_rep.info_title": "Safety representative",
        "hse.settings.safety_rep.info_body": "The Working Environment Act requires a safety representative. Set the main person here, and add deputies if needed.",
        "hse.settings.safety_rep.deputies_title": "Deputies",
        "hse.settings.safety_rep.deputies_description": "Deputies step in when the safety representative is away.",
        "hse.settings.safety_rep.deputies_empty": "No deputies set.",
        "hse.settings.safety_rep.add_deputy": "Add deputy",
        "hse.settings.safety_rep.remove_deputy": "Remove deputy",
        "hse.settings.risk.hub_tab": "Risk",
        "hse.settings.risk.title": "Risk handling",
        "hse.settings.risk.hub_intro": "How the company handles risk, default categories and who is responsible.",
        "hse.settings.risk.handling_title": "How risks are handled",
        "hse.settings.risk.handling_description": "Choose the working method. This guides the risk register and JSA.",
        "hse.settings.risk.handling_info_title": "Risk handling",
        "hse.settings.risk.handling_info_body": "Register + JSA is the usual setup. Choose JSA first for short jobs, or register only for high-level risks.",
        "hse.settings.risk.handling.register_and_sja": "Register and JSA",
        "hse.settings.risk.handling.sja_first": "JSA first",
        "hse.settings.risk.handling.register_only": "Register only",
        "hse.settings.risk.handling.custom": "Custom description",
        "hse.settings.risk.handling_notes_placeholder": "Describe how you assess and follow up risk…",
        "hse.settings.risk.categories_title": "Risk categories",
        "hse.settings.risk.categories_description": "Default categories come from the API. Turn off unused ones, or add your own.",
        "hse.settings.risk.categories_loading": "Loading categories…",
        "hse.settings.risk.categories_load_failed": "Could not load risk categories",
        "hse.settings.risk.categories_save_failed": "Could not save the risk category",
        "hse.settings.risk.category_add": "Add",
        "hse.settings.risk.category_name": "New category name",
        "hse.settings.risk.category_system": "Default",
        "hse.settings.risk.category_delete": "Delete category",
        "hse.settings.risk.category_added": "Category added",
        "hse.settings.risk.category_deleted": "Category deleted",
        "hse.settings.risk.assessors_title": "Risk assessors",
        "hse.settings.risk.assessors_description": "People who can assess risk in addition to the HSE owner.",
        "hse.settings.risk.assessors_empty": "No assessors are set.",
        "hse.settings.risk.add_assessor": "Add assessor",
        "hse.settings.risk.remove_assessor": "Remove assessor",
        "hse.settings.risk.category.health_safety": "Health and safety",
        "hse.settings.risk.category.environmental": "Environment",
        "hse.settings.risk.category.quality": "Quality",
        "hse.settings.risk.category.financial": "Financial",
        "hse.settings.risk.category.operational": "Operational",
        "hse.settings.risk.category.reputational": "Reputation",
        "hse.settings.risk.category.legal_compliance": "Compliance",
        "hse.settings.risk.category.climate_related": "Climate",
        "hse.settings.risk.skip_requires_reason": "Require a reason when risk is skipped",
        "hse.settings.risk.skip_requires_reason_help": "Applies to JSA and risk assessment when someone chooses not to fill it in.",
        "hse.settings.risk.responsible_title": "Risk owner",
        "hse.settings.risk.responsible_description": "The person who owns the risk register and JSA follow-up.",
        "hse.settings.ai.hub_tab": "AI",
        "hse.settings.ai.title": "AI suggestions",
        "hse.settings.ai.hub_intro": "Enable suggestions and pick a default discipline for HSE content.",
        "hse.settings.ai.description": "Suggestions can help with goals, documents and actions. Nothing is sent unless someone asks.",
        "hse.settings.ai.info_title": "AI in HSE",
        "hse.settings.ai.info_body": "When enabled, Promang can suggest text based on the selected discipline. The company decides if it is used.",
        "hse.settings.ai.enable": "Allow AI suggestions in HSE",
        "hse.settings.ai.enable_help": "Applies to goals, document drafts and similar help.",
        "hse.settings.ai.discipline_title": "Default discipline",
        "hse.settings.ai.discipline_description": "Used as the starting point when AI suggests HSE content.",
        "hse.settings.ai.discipline_none": "No default",
        "hse.settings.ai.configured_ok": "An AI key is configured.",
        "hse.settings.ai.configured_missing": "AI is on, but the environment key is missing.",
        "hse.setup.banner.title": "HSE setup is incomplete",
        "hse.setup.banner.subtitle": "{{count}} item(s) should be filled in (owner or safety representative).",
        "hse.setup.banner.settings": "Open settings",
        "hse.setup.banner.guide": "Open guide",
        "hse.goals.title": "Goals",
        "hse.goals.subtitle": "Goals for {{year}}",
        "hse.goals.filter.year": "Year",
        "hse.goals.load_failed": "Could not load goals",
        "hse.goals.saved": "Goal saved",
        "hse.goals.save_failed": "Could not save the goal",
        "hse.goals.created": "Goal created",
        "hse.goals.deleted": "Goal deleted",
        "hse.goals.delete_failed": "Could not delete the goal",
        "hse.goals.title_required": "The goal needs a title.",
        "hse.goals.print": "Print",
        "hse.goals.open": "Open",
        "hse.goals.export_pdf": "Download PDF",
        "hse.goals.exporting": "Downloading PDF…",
        "hse.goals.export_failed": "Could not download PDF",
        "hse.goals.status.draft": "Draft",
        "hse.goals.status.proposed": "Proposed",
        "hse.goals.status.approved": "Approved",
        "hse.goals.status.active": "Active",
        "hse.goals.status.completed": "Completed",
        "hse.goals.status.cancelled": "Cancelled",
        "hse.goals.purpose.title": "Purpose of goal setting",
        "hse.goals.purpose.help": "Tap a chip to create a goal. Edit it in place afterwards.",
        "hse.goals.purpose.placeholder": "Optional extra wording…",
        "hse.goals.purpose.chips.health_safety": "Protect health and safety",
        "hse.goals.purpose.chips.prevent_harm": "Prevent injury and environmental harm",
        "hse.goals.purpose.chips.systematic": "Systematic improvement",
        "hse.goals.purpose.chips.training": "Training and participation",
        "hse.goals.purpose.chips.environment": "Protect the environment",
        "hse.goals.focus.title": "Focus areas",
        "hse.goals.focus.help": "Agree the goals for the year. Use templates and edit in place.",
        "hse.goals.focus.add": "Custom goal",
        "hse.goals.focus.empty": "No focus areas yet. Tap a template to start.",
        "hse.goals.focus.untitled": "Untitled",
        "hse.goals.focus.title_placeholder": "Title",
        "hse.goals.focus.description_placeholder": "What should be achieved?",
        "hse.goals.focus.tiltak": "Link action (optional)",
        "hse.goals.focus.tiltak_none": "No action",
        "hse.goals.focus.tiltak_link": "Open action",
        "hse.goals.focus.done": "Save",
        "hse.goals.focus.cancel": "Cancel",
        "hse.goals.focus.edit": "Edit",
        "hse.goals.focus.remove": "Remove",
        "hse.goals.focus.templates.physical.title": "Physical work environment",
        "hse.goals.focus.templates.physical.description": "No personal injuries or material damage. Clean and safe workplaces.",
        "hse.goals.focus.templates.hse_work.title": "HSE work",
        "hse.goals.focus.templates.hse_work.description": "Follow internal control, training and systematic improvement.",
        "hse.goals.focus.templates.absence.title": "Absence and presence",
        "hse.goals.focus.templates.absence.description": "Keep sick leave below the agreed level and follow up early.",
        "hse.goals.focus.templates.vision.title": "Overall vision",
        "hse.goals.focus.templates.vision.description": "Connect departmental goals to risk assessment and daily work.",
        "hse.goals.focus.templates.psychosocial.title": "Psychosocial environment",
        "hse.goals.focus.templates.psychosocial.description": "Safe speaking-up climate, clear leadership and zero tolerance for harassment.",
        "hse.goals.focus.templates.environment.title": "External environment",
        "hse.goals.focus.templates.environment.description": "Reduce waste, emissions and unnecessary resource use.",
        "hse.goals.focus.templates.competency.title": "Competency",
        "hse.goals.focus.templates.competency.description": "The right competence is in place before work starts.",
        "hse.goals.approve.title": "Approve and sign",
        "hse.goals.approve.help": "Approve and sign each goal when management agrees.",
        "hse.goals.approve.place": "Place",
        "hse.goals.approve.place_placeholder": "e.g. Oslo",
        "hse.goals.approve.place_required": "Fill in place before approval.",
        "hse.goals.approve.status": "Status",
        "hse.goals.approve.draft": "Not approved yet",
        "hse.goals.approve.approved_on": "Approved {{date}}",
        "hse.goals.approve.action": "Approve",
        "hse.goals.approve.saved": "Goal approved",
        "hse.goals.sign.action": "Sign",
        "hse.goals.sign.saved": "Goal signed",
        "hse.goals.sign.signed_on": "Signed {{date}}",
        "hse.risk.title": "Risk and JSA",
        "hse.risk.subtitle": "Register, matrix, JSA and climate risk — short fields, not an ISO essay.",
        "hse.risk.new": "New risk",
        "hse.risk.more": "More options",
        "hse.risk.more_header": "Choose action",
        "hse.risk.delete": "Delete risk",
        "hse.risk.deleted": "Risk deleted",
        "hse.risk.delete_confirm": "Delete “{{title}}”?",
        "hse.risk.nav.campaigns": "Risk assessments",
        "hse.risk.campaigns.title": "Risk assessments",
        "hse.risk.campaigns.subtitle": "Overall per year — then the risks.",
        "hse.risk.campaigns.search": "Search assessments…",
        "hse.risk.campaigns.empty": "No assessments yet. Create 2027 or a named one.",
        "hse.risk.campaigns.col.name": "Assessment",
        "hse.risk.campaigns.col.year": "Year",
        "hse.risk.campaigns.col.updated": "Last changed",
        "hse.risk.campaigns.col.progress": "Risks assessed",
        "hse.risk.campaigns.col.department": "Department",
        "hse.risk.campaigns.unspecified": "Unspecified",
        "hse.risk.campaign.new": "New risk assessment",
        "hse.risk.campaign.year": "Year",
        "hse.risk.campaign.title_optional": "Title (optional)",
        "hse.risk.campaign.title_placeholder": "Overall risk assessment {{year}}",
        "hse.risk.campaign.created": "Risk assessment created",
        "hse.risk.campaign.deleted": "Risk assessment deleted",
        "hse.risk.campaign.delete": "Delete assessment",
        "hse.risk.campaign.delete_confirm": "Delete “{{title}}”? Risks stay in the register.",
        "hse.risk.campaign.save_failed": "Could not save the assessment",
        "hse.risk.campaign.load_failed": "Could not load assessments",
        "hse.risk.campaign.add_risk": "Add risk",
        "hse.risk.campaign.risks_title": "Risks and challenges",
        "hse.risk.campaign.progress_label": "{{done}}/{{total}} assessed",
        "hse.risk.fields.description_placeholder": "What makes this a challenge for you?",
        "hse.risk.suggest.campaign_hint": "Suggestions are saved as drafts in this assessment.",
        "hse.risk.suggest.created": "{{count}} drafts added",
        "hse.guide.see": "See guidance",
        "hse.guide.badge": "Guidance",
        "hse.guide.open_full": "Open full HSE guide",
        "hse.guide.risk.title": "Risk assessment",
        "hse.guide.risk.lead": "Start with an overall assessment for the year. Then add risks and actions.",
        "hse.guide.risk.step1": "Create an assessment for the year, for example 2027.",
        "hse.guide.risk.step2": "Assess each risk: title, consequence and level.",
        "hse.guide.risk.step3": "For moderate or higher: link or create an action.",
        "hse.guide.sja.title": "JSA",
        "hse.guide.sja.lead": "Job safety analysis for a concrete task — short and before work starts.",
        "hse.guide.sja.step1": "Create a JSA with title and work location.",
        "hse.guide.sja.step2": "Add steps and hazards, or apply a template.",
        "hse.guide.sja.step3": "Submit and get approval before the job.",
        "hse.guide.chemical.title": "Chemical inventory",
        "hse.guide.chemical.lead": "Keep chemicals, data sheets and reviews in one place.",
        "hse.guide.chemical.step1": "Register a substance and upload the data sheet.",
        "hse.guide.chemical.step2": "Link location and protective equipment.",
        "hse.guide.chemical.step3": "Review and publish when something changes.",
        "hse.guide.protective.title": "Safety rounds",
        "hse.guide.protective.lead": "Plan rounds, note findings and follow up actions.",
        "hse.guide.protective.step1": "Create a round with area and participants.",
        "hse.guide.protective.step2": "Walk the checkpoints on site.",
        "hse.guide.protective.step3": "Create actions on findings and download PDF.",
        "hse.guide.evaluation.title": "Evaluation",
        "hse.guide.evaluation.lead": "Audit, management review and KPIs — short status, not an essay.",
        "hse.guide.evaluation.step1": "Pick type: internal audit or management review.",
        "hse.guide.evaluation.step2": "Record findings and link actions.",
        "hse.guide.evaluation.step3": "Follow KPIs and close when management agrees.",
        "hse.guide.tiltak.title": "Actions",
        "hse.guide.tiltak.lead": "One action, one owner, one deadline. Link to risk, event or evaluation.",
        "hse.guide.tiltak.step1": "Write what should be done and who owns it.",
        "hse.guide.tiltak.step2": "Set a deadline and start when work begins.",
        "hse.guide.tiltak.step3": "Mark complete when the risk is reduced.",
        "hse.guide.goals.title": "Goals",
        "hse.guide.goals.lead": "This year’s HSE goals. Short wording, approval and an optional action link.",
        "hse.guide.goals.step1": "Pick a year and use templates or your own goals.",
        "hse.guide.goals.step2": "Approve when management agrees.",
        "hse.guide.goals.step3": "Link actions where needed.",
        "hse.risk.edit": "Edit risk",
        "hse.risk.save": "Save",
        "hse.risk.saving": "Saving…",
        "hse.risk.cancel": "Cancel",
        "hse.risk.exclude": "Do not assess",
        "hse.risk.created": "Risk saved",
        "hse.risk.updated": "Risk updated",
        "hse.risk.excluded_saved": "Marked as do not assess",
        "hse.risk.save_failed": "Could not save the risk",
        "hse.risk.load_failed": "Could not load risks",
        "hse.risk.empty": "No risks yet. Start from common challenges or a custom one.",
        "hse.risk.search": "Search risks…",
        "hse.risk.error_title": "Enter a short title",
        "hse.risk.error_level": "Choose a risk level",
        "hse.risk.form_subtitle": "Title, consequence and level. Extended assessment and files are optional.",
        "hse.risk.pdf": "Download PDF",
        "hse.risk.pdf_loading": "Creating PDF…",
        "hse.risk.pdf_ready": "PDF downloaded",
        "hse.risk.pdf_failed": "Could not download the PDF",
        "hse.risk.open": "Open",
        "hse.risk.actions": "Actions",
        "hse.risk.pdf_empty": "No risk to export",
        "hse.risk.nav.aria": "Risk pages",
        "hse.risk.nav.register": "Register",
        "hse.risk.nav.matrix": "Matrix",
        "hse.risk.nav.sja": "JSA",
        "hse.risk.nav.climate": "Climate risk",
        "hse.risk.nav.chemical": "Chemicals",
        "hse.risk.nav.protective": "Safety rounds",
        "hse.risk.hub.register": "Risk register",
        "hse.risk.hub.register_hint": "Assessed and excluded risks.",
        "hse.risk.hub.matrix": "Risk matrix",
        "hse.risk.hub.matrix_hint": "5×5 view of likelihood and consequence.",
        "hse.risk.hub.sja": "JSA",
        "hse.risk.hub.sja_hint": "{{count}} JSAs in the list.",
        "hse.risk.hub.climate": "Climate risk",
        "hse.risk.hub.climate_hint": "Physical and transition risks.",
        "hse.risk.hub.chemical": "Chemical inventory",
        "hse.risk.hub.chemical_hint": "Chemicals and safety data sheets.",
        "hse.risk.hub.protective": "Safety rounds",
        "hse.risk.hub.protective_hint": "Rounds and protective equipment.",
        "hse.risk.hub.recent": "Recently updated",
        "hse.risk.hub.see_all": "Open register",
        "hse.risk.register.title": "Risk register",
        "hse.risk.register.subtitle": "All assessed risks. “Do not assess” is listed below.",
        "hse.risk.excluded.title": "Do not assess",
        "hse.risk.excluded.hint": "Challenges you chose not to assess now.",
        "hse.risk.view.title": "Risk",
        "hse.risk.view.subtitle": "Short assessment and linked actions",
        "hse.risk.view.updated": "Last changed {{date}}",
        "hse.risk.add.common": "Common challenges",
        "hse.risk.add.common_hint": "Pick a theme and a relevant challenge, then assess in the dialog.",
        "hse.risk.add.custom": "Custom",
        "hse.risk.add.custom_hint": "Pick a category and write your own title.",
        "hse.risk.add.pick_theme": "Choose theme",
        "hse.risk.add.pick_category": "Choose category",
        "hse.risk.assess.title": "Assess risk",
        "hse.risk.assess.required_hint": "Fields marked with * are required",
        "hse.risk.assess.how_to": "Low = rare and minor harm. Moderate = possible and may cause absence. High = likely or severe.",
        "hse.risk.assess.tiltak_prompt": "Moderate or higher risk should have a risk-reducing action.",
        "hse.risk.assess.extended": "Extended assessment",
        "hse.risk.assess.files": "Files",
        "hse.risk.assess.files_empty": "No files attached.",
        "hse.risk.fields.title": "Title",
        "hse.risk.fields.category": "Category",
        "hse.risk.fields.description": "Description",
        "hse.risk.fields.consequence": "Consequence",
        "hse.risk.fields.consequence_placeholder": "What could this lead to for you?",
        "hse.risk.fields.level": "How large is the risk?",
        "hse.risk.fields.level_placeholder": "Select level",
        "hse.risk.fields.status": "Status",
        "hse.risk.fields.work_task": "Work task",
        "hse.risk.fields.cause": "Triggering cause",
        "hse.risk.fields.existing": "Existing measures",
        "hse.risk.fields.history": "History",
        "hse.risk.fields.likelihood": "Likelihood",
        "hse.risk.fields.consequence_score": "Consequence (1–5)",
        "hse.risk.fields.choose": "Select",
        "hse.risk.level.unset": "Not assessed",
        "hse.risk.level.very_low": "Very low",
        "hse.risk.level.low": "Low",
        "hse.risk.level.moderate": "Moderate",
        "hse.risk.level.high": "High",
        "hse.risk.level.very_high": "Very high",
        "hse.risk.status.draft": "Draft",
        "hse.risk.status.assessed": "Assessed",
        "hse.risk.status.excluded": "Do not assess",
        "hse.risk.status.closed": "Closed",
        "hse.risk.category.safety": "Safety",
        "hse.risk.category.physical": "Physical",
        "hse.risk.category.psychosocial": "Psychosocial",
        "hse.risk.category.organizational": "Organizational",
        "hse.risk.category.environmental": "Environment",
        "hse.risk.category.chemical": "Chemical",
        "hse.risk.category.climate": "Climate",
        "hse.risk.theme.electrical": "Electrical",
        "hse.risk.theme.fire": "Fire",
        "hse.risk.theme.fall": "Falls",
        "hse.risk.theme.tools": "Tools",
        "hse.risk.theme.chemical": "Chemicals",
        "hse.risk.theme.psychosocial": "Psychosocial",
        "hse.risk.theme.organizational": "Organization",
        "hse.risk.theme.climate": "Climate",
        "hse.risk.catalog.electric_shock": "Electric shock and current passage",
        "hse.risk.catalog.electric_shock_consequence": "Burns, cardiac arrest or absence after work on installations.",
        "hse.risk.catalog.live_work": "Work near live parts",
        "hse.risk.catalog.live_work_consequence": "Shock or arc flash if distance and isolation fail.",
        "hse.risk.catalog.fire_hot_work": "Fire and hot work",
        "hse.risk.catalog.fire_hot_work_consequence": "Fire in buildings or materials, smoke injury.",
        "hse.risk.catalog.flammable": "Flammable liquids and gas",
        "hse.risk.catalog.flammable_consequence": "Explosion or fire from leak and ignition.",
        "hse.risk.catalog.fall_from_height": "Fall from height",
        "hse.risk.catalog.fall_from_height_consequence": "Serious injury during work at height.",
        "hse.risk.catalog.slip_trip": "Slips, trips and wet floors",
        "hse.risk.catalog.slip_trip_consequence": "Fractures, sprains or absence.",
        "hse.risk.catalog.cuts": "Cuts and punctures",
        "hse.risk.catalog.cuts_consequence": "Cuts, infection or loss of function.",
        "hse.risk.catalog.machinery": "Machinery and moving parts",
        "hse.risk.catalog.machinery_consequence": "Crushing, cuts or amputation.",
        "hse.risk.catalog.chemical_exposure": "Chemical exposure",
        "hse.risk.catalog.chemical_exposure_consequence": "Burns, allergy or long-term harm.",
        "hse.risk.catalog.dust_fume": "Dust and fumes",
        "hse.risk.catalog.dust_fume_consequence": "Respiratory issues and reduced capacity.",
        "hse.risk.catalog.conflicts": "Conflicts",
        "hse.risk.catalog.conflicts_consequence": "Absence, poor cooperation and work errors.",
        "hse.risk.catalog.workload": "High workload",
        "hse.risk.catalog.workload_consequence": "Fatigue and more mistakes.",
        "hse.risk.catalog.human_error": "Human error",
        "hse.risk.catalog.human_error_consequence": "A mistake that causes injury or deviation.",
        "hse.risk.catalog.communication": "Communication",
        "hse.risk.catalog.communication_consequence": "Misunderstandings that cause accidents or quality issues.",
        "hse.risk.catalog.competence": "Missing competence",
        "hse.risk.catalog.competence_consequence": "Incorrect work because training is missing.",
        "hse.risk.catalog.extreme_weather": "Extreme weather",
        "hse.risk.catalog.extreme_weather_consequence": "Work stoppage, damage to materials or people.",
        "hse.risk.catalog.heat_cold": "Heat and cold",
        "hse.risk.catalog.heat_cold_consequence": "Heat stroke, frostbite or reduced ability.",
        "hse.risk.scale.likelihood.1": "Very rare",
        "hse.risk.scale.likelihood.2": "Rare",
        "hse.risk.scale.likelihood.3": "Possible",
        "hse.risk.scale.likelihood.4": "Likely",
        "hse.risk.scale.likelihood.5": "Almost certain",
        "hse.risk.scale.consequence.1": "Negligible",
        "hse.risk.scale.consequence.2": "Minor",
        "hse.risk.scale.consequence.3": "Moderate",
        "hse.risk.scale.consequence.4": "Severe",
        "hse.risk.scale.consequence.5": "Catastrophic",
        "hse.risk.info.title.title": "Title",
        "hse.risk.info.title.body": "A short name for the challenge, for example “Electric shock”.",
        "hse.risk.info.description.title": "Description",
        "hse.risk.info.description.body": "What makes this a challenge for you?",
        "hse.risk.info.category.title": "Category",
        "hse.risk.info.category.body": "Helps you sort: safety, physical, psychosocial, organizational, environment, chemical or climate.",
        "hse.risk.info.consequence.title": "Consequence",
        "hse.risk.info.consequence.body": "What could happen for you — injury, absence, fire or stoppage. Keep it short.",
        "hse.risk.info.level.title": "Risk level",
        "hse.risk.info.level.body": "Overall judgement. Moderate and higher should have an action. Use extended assessment for 1–5 scores in the matrix.",
        "hse.risk.info.matrix.title": "Likelihood and consequence",
        "hse.risk.info.matrix.body": "Optional. 1–5 for each. The product places the risk in the 5×5 matrix.",
        "hse.risk.info.tiltak.title": "Actions",
        "hse.risk.info.tiltak.body": "Link an existing action or create a new one. New actions POST to /hse/tiltak with the risk as source.",
        "hse.risk.info.climate.title": "Climate risk",
        "hse.risk.info.climate.body": "A short title for a physical or transition risk, for example extreme weather on site.",
        "hse.risk.info.sja.title": "JSA",
        "hse.risk.info.sja.body": "Job safety analysis for a specific job. Steps and hazards can be filled after the title.",
        "hse.risk.tiltak.how": "How are you working on this?",
        "hse.risk.tiltak.new": "New action",
        "hse.risk.tiltak.create": "Create action",
        "hse.risk.tiltak.link_existing": "Add existing action",
        "hse.risk.tiltak.link": "Link",
        "hse.risk.tiltak.linked": "Action linked",
        "hse.risk.tiltak.empty": "No actions linked yet.",
        "hse.risk.tiltak.count": "{{count}} actions",
        "hse.risk.tiltak.save_first": "Save the risk before linking actions.",
        "hse.risk.tiltak.choose_assignee": "Choose owner",
        "hse.risk.tiltak.title_from_risk": "Reduce risk: {{title}}",
        "hse.risk.matrix.title": "Risk matrix",
        "hse.risk.matrix.subtitle": "Likelihood (row) × consequence (column).",
        "hse.risk.matrix.likelihood": "Likelihood",
        "hse.risk.matrix.legend": "Green = low, yellow = moderate, orange/red = high. Click a title for details.",
        "hse.risk.sja.title": "Job safety analysis",
        "hse.risk.sja.subtitle": "Create, list and view JSAs.",
        "hse.risk.sja.new": "New JSA",
        "hse.risk.sja.edit": "Edit JSA",
        "hse.risk.sja.form_subtitle": "Title and work type first. Steps and hazards can follow.",
        "hse.risk.sja.view_title": "JSA",
        "hse.risk.sja.view_subtitle": "Steps and hazards for the job",
        "hse.risk.sja.empty": "No JSAs yet.",
        "hse.risk.sja.load_failed": "Could not load JSAs",
        "hse.risk.sja.created": "JSA created",
        "hse.risk.sja.updated": "JSA updated",
        "hse.risk.sja.work_type": "Work type",
        "hse.risk.sja.work_type.routine": "Routine work",
        "hse.risk.sja.work_type.non_routine": "Non-routine",
        "hse.risk.sja.work_type.maintenance": "Maintenance",
        "hse.risk.sja.work_type.construction": "Construction",
        "hse.risk.sja.work_type.emergency": "Emergency",
        "hse.risk.sja.work_type.special": "Special",
        "hse.risk.sja.status.draft": "Draft",
        "hse.risk.sja.status.pending_approval": "Pending approval",
        "hse.risk.sja.status.approved": "Approved",
        "hse.risk.sja.status.in_use": "In use",
        "hse.risk.sja.status.archived": "Archived",
        "hse.risk.sja.location": "Location",
        "hse.risk.sja.steps": "Steps",
        "hse.risk.sja.add_step": "Add step",
        "hse.risk.sja.step_n": "Step {{n}}",
        "hse.risk.sja.step_placeholder": "What happens in this step?",
        "hse.risk.sja.hazards_placeholder": "Hazards, one per line",
        "hse.risk.sja.hazards": "Hazards",
        "hse.risk.climate.title": "Climate risk",
        "hse.risk.climate.subtitle": "Short assessments of climate and transition.",
        "hse.risk.climate.new": "New climate risk",
        "hse.risk.climate.empty": "No climate risks yet.",
        "hse.risk.climate.load_failed": "Could not load climate risks",
        "hse.risk.climate.created": "Climate risk created",
        "hse.risk.climate.updated": "Climate risk updated",
        "hse.risk.climate.edit": "Edit climate risk",
        "hse.risk.climate.horizon_label": "Time horizon",
        "hse.risk.climate.category.physical_risks": "Physical risks",
        "hse.risk.climate.category.transition_risks": "Transition risks",
        "hse.risk.climate.category.regulatory_risks": "Regulatory",
        "hse.risk.climate.category.market_risks": "Market",
        "hse.risk.climate.category.reputational_risks": "Reputation",
        "hse.risk.climate.horizon.short_term": "Short term (0–2 years)",
        "hse.risk.climate.horizon.medium_term": "Medium term (3–5 years)",
        "hse.risk.climate.horizon.long_term": "Long term (6–10 years)",
        "hse.risk.climate.horizon.very_long_term": "Very long term (10+ years)",
        "hse.risk.level.lav": "Low",
        "hse.risk.level.moderat": "Moderate",
        "hse.risk.level.hoy": "High",
        "hse.risk.level.kritisk": "Critical",
        "hse.risk.status.suggested": "Suggested",
        "hse.risk.status.in_progress": "In progress",
        "hse.risk.status.skipped": "Not to be assessed",
        "hse.risk.category.sikkerhet": "Safety",
        "hse.risk.category.organisatorisk": "Organizational",
        "hse.risk.category.psykososialt": "Psychosocial",
        "hse.risk.category.fysisk": "Physical",
        "hse.risk.category.kjemisk": "Chemical",
        "hse.risk.category.ergonomisk": "Ergonomic",
        "hse.risk.category.miljo": "Environment",
        "hse.risk.add.suggest": "Suggest from industry",
        "hse.risk.add.suggest_hint": "AI suggests common challenges for your industry or trade.",
        "hse.risk.suggest.hint": "Enter industry and/or trade. Suggestions are saved as drafts you can assess.",
        "hse.risk.suggest.industry": "Industry",
        "hse.risk.suggest.fag": "Trade",
        "hse.risk.suggest.run": "Suggest risks",
        "hse.risk.suggest.working": "Suggesting…",
        "hse.risk.suggest.error_industry": "Enter industry or trade",
        "hse.risk.suggest.empty": "No suggestions this time",
        "hse.risk.suggest.failed": "Could not suggest risks",
        "hse.risk.setup.title": "HSE setup incomplete",
        "hse.risk.setup.responsible": "HSE responsible is not set",
        "hse.risk.setup.verneombud": "Safety representative is not set",
        "hse.risk.setup.categories": "Risk categories are missing",
        "hse.risk.setup.ai_key": "AI is on, but the key is missing",
        "hse.risk.sja.submit": "Submit for approval",
        "hse.risk.sja.approve": "Approve",
        "hse.risk.sja.submitted": "SJA submitted for approval",
        "hse.risk.sja.approved": "SJA approved",
        "hse.sja.submit": "Submit for approval",
        "hse.sja.approve": "Approve",
        "hse.sja.approve_verneombud": "Approve as safety representative",
        "hse.sja.approve_leader": "Approve as manager",
        "hse.sja.submitted": "SJA submitted for approval",
        "hse.sja.approved": "SJA approved",
        "hse.sja.status_follows_approval": "Status is set when the safety representative or a manager approves. It cannot be chosen freely.",
        "hse.sja.template.pick": "Step template",
        "hse.sja.template.hint": "Pick a saved template or an existing SJA instead of writing every step.",
        "hse.sja.template.placeholder": "Choose a step template",
        "hse.sja.template.apply": "Apply template",
        "hse.sja.template.applying": "Applying…",
        "hse.sja.template.applied": "Steps from the template were added",
        "hse.sja.template.loading": "Loading templates…",
        "hse.sja.template.empty": "No step templates yet. Write the steps, or reuse an earlier SJA when one exists.",
        "hse.sja.template.empty_steps": "This template has no steps to apply.",
        "hse.sja.template.load_failed": "Could not load the step template",
        "hse.sja.template.untitled": "Untitled",
        "hse.sja.approve_daglig_leder": "Approve as managing director",
        "hse.sja.approve_annen_leder": "Approve as other manager",
        "hse.sja.role.verneombud": "Safety representative",
        "hse.sja.role.daglig_leder": "Managing director",
        "hse.sja.role.annen_leder": "Other manager",
        "hse.sja.approval.title": "Approval",
        "hse.sja.approval.pending": "Waiting for",
        "hse.sja.approval.empty": "No approvals are pending.",
        "hse.sja.not_editable": "The SJA can only be edited while it is a draft.",
        "hse.settings.other_manager.title": "Other manager",
        "hse.settings.other_manager.description": "The person who approves SJA as other manager. Empty = HSE responsible is used.",
        "todo.journalTitle": "Journal",
        "todo.journalDate": "Date",
        "todo.journalHint": "Notes for the selected day (HTML). Auto-saved.",
        "todo.journalHintRich":
          "Select text to format (Notion-style). You can paste HTML from the web or OneNote — unsafe markup is stripped on save.",
        "todo.journalPlaceholder": "Write notes for this day…",
        "todo.journalFullscreen": "Full screen",
        "todo.journalExitFullscreen": "Exit full screen",
        "todo.journalOpenInFullscreen": "You’re editing in full screen. Close that window when you’re done.",
        "todo.journalSaveError": "Could not save journal.",
        "todo.journalImageTitle": "Image",
        "todo.journalImageWidth": "Width",
        "todo.journalImageWidthHint": "Pixels (320) or percent (50%).",
        "todo.journalImageHeight": "Height",
        "todo.journalImageHeightPlaceholder": "Optional (auto if empty)",
        "todo.journalImageAlt": "Description (alt text)",
        "todo.journalImageSizePresets": "Quick size",
        "todo.journalImageOriginal": "Reset size",
        "todo.journalImageAlign": "Alignment",
        "todo.journalImageAlignLeft": "Left",
        "todo.journalImageAlignCenter": "Center",
        "todo.journalImageAlignRight": "Right",
        "todo.journalImageApply": "Apply",
        "todo.journalImageRemove": "Remove image",
        "todo.digestTitle": "Email reminders",
        "todo.digestMorning": "Morning (approx. 07:00, your timezone)",
        "todo.digestEvening": "Evening (approx. 17:00)",
        "todo.digestTimezone": "Timezone",
        "todo.digestSaved": "Settings saved",
        "todo.digestSaveError": "Could not save email settings.",
        "todo.prevDay": "Previous day",
        "todo.nextDay": "Next day",
        "todo.today": "Today",
        "richTextEditor.contextMenu.ariaLabel": "Rich text actions",
        "richTextEditor.contextMenu.cut": "Cut",
        "richTextEditor.contextMenu.copy": "Copy",
        "richTextEditor.contextMenu.paste": "Paste",
        "richTextEditor.contextMenu.insertImage": "Insert image…",
        "richTextEditor.contextMenu.moveSelectionToPage": "Move selection to page…",
        "richTextEditor.contextMenu.createPageWithSelection": "New page from selection…",
        "richTextEditor.contextMenu.handlerMissing": "Connect a handler in the parent component to enable this action.",
        "richTextEditor.table.insert": "Insert table",
        "richTextEditor.table.hint": "Adds a 3 x 3 editable table.",
        "richTextEditor.table.defaultHeader": "Column",
        "automile.checkoutConfirmTitle": "Check out of vehicle?",
        "automile.checkoutConfirmMessage": "Are you sure you want to check out? The vehicle will be available for other drivers.",
        "automile.checkoutConfirm": "Yes, check out",
        "automile.checkoutCancel": "Cancel",
        "automile.checkInDriver": "Check in driver",
        "automile.checkOutVehicle": "Check out driver",
        "automile.linkUser": "Link user",
        "automile.selectEmployee": "Select employee",
        "automile.noVehiclesAvailable": "No available vehicles (active and no driver checked in).",
        "automile.settingsHint": "Complete Automile under Company → Integrations.",
        "automile.driverNeedsSync": "The driver must be synced with Automile before check-in.",
        "automile.onlyAvailableVehiclesSubtitle": "Only active vehicles with no driver checked in are shown.",
        "automile.noDriversFreeForCheckin": "No drivers available without a checked-in vehicle (with a linked user).",
        "automile.adminVehiclePickerSubtitle":
          "All active vehicles are listed. If a vehicle is checked in to someone else, assigning it here will move it to this driver (fleet managers).",
        "automile.noActiveVehiclesForFleet": "No active vehicles found.",
        "automile.vehicleOccupiedBadge": "Checked in — reassign will check out the current driver first",
        "automile.userName": "User / Name",
        "automile.checkedIntoVehicle": "Checked into vehicle",
        "automile.distanceDriven": "Distance driven",
        "automile.notCheckedIn": "Not checked in",
        "automile.noUserLinked": "No user linked",
        "automile.from": "From",
        "automile.to": "To",
        "Drivers": "Drivers",
        "Driver": "Driver",
        "Module": "Module",
        "Distance": "Distance",

        "platformBroadcast.scheduledLabel": "Scheduled update",
        "platformBroadcast.countdownPrefix": "In {{time}}",
        "platformBroadcast.scheduledOverdue": "Start time reached — please save your work",
        "platformBroadcast.activeNoticesRegion": "Active Promang notices",
        "platformBroadcast.noticeWarningTag": "Warning",
        "platformBroadcast.noticeInfoTag": "Info",
        "platformBroadcast.updatingTitle": "Promang is updating",
        "platformBroadcast.updatingHint": "We will be back as soon as the update finishes. Thank you for your patience.",
        "platformBroadcast.updatingAdminHint":
          "Administrator: When the deployment is finished, use the wrench button (bottom right) and choose «Confirm Promang has been updated».",
        "platformBroadcast.dev.menuAria": "Platform dev menu",
        "platformBroadcast.dev.noActiveUpdate": "No active maintenance session.",
        "platformBroadcast.dev.statusLine": "{{phase}}: {{title}}",
        "platformBroadcast.dev.scheduleUpdate": "Schedule update",
        "platformBroadcast.dev.startMaintenance": "Start maintenance (updating)",
        "platformBroadcast.dev.confirmComplete": "Confirm Promang has been updated",
        "platformBroadcast.dev.addNotice": "Add notice (info / warning)",
        "platformBroadcast.dev.manageNotices": "Manage notices",
        "platformBroadcast.dev.fieldTitle": "Title",
        "platformBroadcast.dev.fieldDescription": "Description",
        "platformBroadcast.dev.fieldScheduledAt": "Update time",
        "platformBroadcast.dev.fieldExpectedEnd": "Expected finished around",
        "platformBroadcast.dev.fieldKind": "Type",
        "platformBroadcast.dev.kindInfo": "Info",
        "platformBroadcast.dev.kindWarning": "Warning",
        "platformBroadcast.dev.cancel": "Cancel",
        "platformBroadcast.dev.save": "Save",
        "platformBroadcast.dev.start": "Start",
        "platformBroadcast.dev.close": "Close",
        "platformBroadcast.dev.maintenanceHint": "Users will see a full-screen “Promang is updating” view with a countdown to the expected end.",
        "platformBroadcast.dev.validationTitleTime": "Enter title and time.",
        "platformBroadcast.dev.validationTitle": "Enter a title.",
        "platformBroadcast.dev.invalidTime": "Invalid date or time.",
        "platformBroadcast.dev.saved": "Scheduled update saved.",
        "platformBroadcast.dev.maintenanceStarted": "Maintenance started.",
        "platformBroadcast.dev.confirmCompletePrompt": "Confirm the update is finished and clear this maintenance round for everyone?",
        "platformBroadcast.dev.confirmed": "Confirmed.",
        "platformBroadcast.dev.noticeCreated": "Notice created.",
        "platformBroadcast.dev.noticeHidden": "Notice hidden.",
        "platformBroadcast.dev.noticeShown": "Notice shown again.",
        "platformBroadcast.dev.requestFailed": "Request failed.",
        "platformBroadcast.dev.historyHint": "Hide notices when an issue is resolved. Update history is kept in the database.",
        "platformBroadcast.dev.recentUpdates": "Recent scheduled updates",
        "platformBroadcast.dev.allNotices": "All notices",
        "platformBroadcast.dev.hidden": "hidden",
        "platformBroadcast.dev.hide": "Hide",
        "platformBroadcast.dev.show": "Show",
        "platformBroadcast.dev.roleViewMenu": "Simulate role view (UI only)",
        "platformBroadcast.dev.sentryReporting": "Send errors to Sentry",
        "platformBroadcast.dev.sentryReportingHint":
          "Off by default in development. Mutes this browser and API errors from your requests.",
        "platformBroadcast.dev.sentryReportingOn": "Sentry reporting enabled.",
        "platformBroadcast.dev.sentryReportingOff": "Sentry reporting disabled.",
        "platformBroadcast.dev.roleViewTitle": "How Promang looks for you",
        "platformBroadcast.dev.roleViewTabPresets": "Presets",
        "platformBroadcast.dev.roleViewTabCustom": "Custom (like user admin)",
        "platformBroadcast.dev.roleViewHintCustom":
          "Same switches as under Company → Users. Use «Apply simulation» at the bottom when you are done.",
        "platformBroadcast.dev.roleViewCustomApply": "Apply simulation",
        "platformBroadcast.dev.roleViewHint":
          "Only affects this browser: sidebar, route guards, RoleOnly, and related hooks. The API still uses your real permissions.",
        "platformBroadcast.dev.roleViewApply": "Apply",
        "platformBroadcast.dev.roleViewReset": "Clear simulation",
        "platformBroadcast.dev.roleViewResetNow": "Clear simulation",
        "platformBroadcast.dev.roleViewActiveBanner":
          "Role simulation is on — the UI does not reflect your real access.",
        "platformBroadcast.dev.roleViewToastApplied": "Role simulation updated.",
        "platformBroadcast.dev.roleViewToastReset": "Role simulation cleared.",
        "platformBroadcast.dev.roleViewPreset.off.label": "Real permissions",
        "platformBroadcast.dev.roleViewPreset.off.description":
          "Use roles from the server (default).",
        "platformBroadcast.dev.roleViewPreset.none.label": "No roles",
        "platformBroadcast.dev.roleViewPreset.none.description":
          "Empty role list — almost no modules in the menu.",
        "platformBroadcast.dev.roleViewPreset.hours_time_only.label":
          "Time registration only",
        "platformBroadcast.dev.roleViewPreset.hours_time_only.description":
          "Hours module with register/edit own time — no approval, settings, or absence extras.",
        "platformBroadcast.dev.roleViewPreset.hours_extended.label":
          "Hours + approval & absence",
        "platformBroadcast.dev.roleViewPreset.hours_extended.description":
          "Broad hours persona: lists, approval, settings read, absence registration.",
        "platformBroadcast.dev.roleViewPreset.service_field.label":
          "Service field staff",
        "platformBroadcast.dev.roleViewPreset.service_field.description":
          "Service overview and reports focus; limited agreements access.",
        "platformBroadcast.dev.roleViewPreset.projects_participant.label":
          "Project participant",
        "platformBroadcast.dev.roleViewPreset.projects_participant.description":
          "Projects and work orders with typical executor-style actions.",
        "platformBroadcast.dev.roleViewPreset.project_leader_all.label":
          "Project leader (all projects)",
        "platformBroadcast.dev.roleViewPreset.project_leader_all.description":
          "Projects administrator with full access to all projects and work orders.",
        "platformBroadcast.dev.roleViewPreset.project_leader_selected.label":
          "Project leader (selected projects)",
        "platformBroadcast.dev.roleViewPreset.project_leader_selected.description":
          "Project roles without full company administration; full access granted per project.",
        "Send Offer": "Send offer",
        "Choose recipient, offer PDF version and customer message before sending.":
          "Choose recipient, offer PDF version and customer message before sending.",
        "Offer sending has been queued. You will be notified when it's complete.":
          "Offer sending has been queued. You will be notified when it's complete.",
        "Something went wrong. Could not send offer.":
          "Something went wrong. Could not send offer.",
        "Offer Type": "Offer type",
        "Internal offer": "Internal offer",
        "Customer offer": "Customer offer",
        "Open selected offer PDF": "Open selected offer PDF",
        "PDF preview will be available when the selected offer type is generated.":
          "PDF preview will be available when the selected offer type is generated.",
        "Message to customer": "Message to customer",
        "Offer sent successfully!": "Offer sent successfully!",
        "Offer sending queued...": "Offer sending queued...",
        "Generating PDF and sending offer...":
          "Generating PDF and sending offer...",
        "Failed to send offer": "Failed to send offer",
        "Failed to send offer. Please try again.":
          "Failed to send offer. Please try again.",
        "Request timed out. Please check the offer status manually.":
          "Request timed out. Please check the offer status manually.",
        "publicAppointment.title": "Confirm appointment",
        "publicAppointment.subtitle": "Review the details and confirm that the appointment still suits you.",
        "publicAppointment.sectionAppointment": "Appointment",
        "publicAppointment.sectionWork": "What we will do",
        "publicAppointment.reportType": "Job type",
        "publicAppointment.serviceAddress": "Service address",
        "publicAppointment.workDescription": "Description of work",
        "publicAppointment.timeExactHint": "We aim to arrive close to this time.",
        "publicAppointment.timeWindowHint": "We will arrive somewhere within this time window.",
        "publicAppointment.reportNumber": "Job / report no.",
        "publicAppointment.date": "Date",
        "publicAppointment.time": "Time",
        "publicAppointment.companyFallback": "Service provider",
        "publicAppointment.confirmHint":
          "When you confirm, we register the appointment as agreed. If something is wrong, please contact us by phone or email.",
        "publicAppointment.termsAcceptPlain":
          "By confirming this appointment, you accept our terms for use of services, sales and service agreements.",
        "publicAppointment.termsAcceptPrefix": "By confirming this appointment, you accept our ",
        "publicAppointment.termsAcceptLink": "terms for use of services, sales and service agreements",
        "publicAppointment.termsAcceptSuffix": ".",
        "publicAppointment.confirmButton": "Confirm appointment",
        "publicAppointment.submitting": "Confirming…",
        "publicAppointment.successTitle": "Thank you — the appointment is confirmed",
        "publicAppointment.successBody": "You can close this page. If you need to make changes, contact the company directly.",
        "publicAppointment.alreadyConfirmed": "This appointment is already confirmed.",
        "publicAppointment.loadFailed": "We could not load this appointment. The link may be invalid or expired.",
        "publicAppointment.confirmFailed": "We could not register your confirmation. Please try again or contact us.",
        "publicAppointment.missingToken": "This confirmation link is missing required information.",

        "community.title": "Feedback & ideas",
        "community.subtitle": "Report bugs, suggest improvements, and vote on what we should build next.",
        "community.tab.feed": "Ideas & votes",
        "community.tab.mine": "My submissions",
        "community.tab.report": "Submit",
        "community.feed.section.accepted": "Accepted by Promang",
        "community.feed.section.accepted_help": "These ideas were approved and stay visible here after admin review.",
        "community.feed.section.open": "Open for voting",
        "community.kind.bug": "Bug report",
        "community.kind.feature": "Feature request",
        "community.kind.improvement": "Improvement",
        "community.form.title": "Title",
        "community.form.description": "Description",
        "community.form.kind": "Type",
        "community.form.submit": "Submit",
        "community.form.submitting": "Submitting…",
        "community.form.success": "Thank you! AI and our team will review your submission.",
        "community.form.error": "Could not submit report",
        "community.form.screenshot": "Screenshot (optional)",
        "community.form.screenshot_help": "Attach a screenshot to help us reproduce bugs or illustrate your idea.",
        "community.form.screenshot_add": "Add image",
        "community.form.screenshot_preview": "Screenshot preview",
        "community.form.screenshot_remove": "Remove screenshot",
        "community.form.image_invalid": "Please choose an image file (PNG, JPG, GIF, or WebP).",
        "community.fab_label": "Ideas & feedback",
        "community.votes": "votes",
        "community.vote": "Vote",
        "community.unvote": "Remove vote",
        "community.status.submitted": "Submitted",
        "community.status.triaging": "AI review",
        "community.status.pending_approval": "Awaiting admin",
        "community.status.approved": "Approved",
        "community.status.in_progress": "Fix in progress",
        "community.status.resolved": "Resolved",
        "community.status.declined": "Declined",
        "community.status.spam": "Rejected",
        "community.triage_summary": "AI review",
        "community.empty_feed": "No ideas yet — be the first to suggest something.",
        "community.empty_mine": "You have not submitted anything yet.",

        "globalSearch.trigger_label": "Search Promang",
        "globalSearch.trigger_short": "Search …",
        "globalSearch.input_label": "Search Promang",
        "globalSearch.input_placeholder": "Search customers, projects, reports, cases, HSE documents, contacts …",
        "globalSearch.searching": "Searching…",
        "globalSearch.error": "Something went wrong while searching. Please try again.",
        "globalSearch.empty_title": "Search all of Promang",
        "globalSearch.empty_hint": "Type to find customers, projects, reports, cases, HSE documents, and contacts. Try a suggestion below, or type in Norwegian or English.",
        "globalSearch.footer_navigate": "↑↓ to navigate",
        "globalSearch.footer_open": "Enter to open",
        "globalSearch.footer_shortcut": "{{shortcut}} to search",
        "globalSearch.suggestion.latest_project": "Latest project",
        "globalSearch.suggestion.latest_report": "Latest report for customer …",
        "globalSearch.suggestion.find_customer": "Find customer …",
        "globalSearch.suggestion.find_project": "Find project …",
        "globalSearch.suggestion.find_hse_document": "Find HSE document …",
        "globalSearch.suggestion.report_status": "Report status …",
        "globalSearch.no_customer": "No customer found matching «{{name}}».",
        "globalSearch.multiple_customers": "Multiple customers match «{{name}}». Pick the right one:",
        "globalSearch.no_results_for_customer": "No {{entity}} found for {{customer}}.",
        "globalSearch.no_results": "No results for «{{query}}».",
        "globalSearch.latest_for_customer": "Latest {{entity}} for {{customer}}:",
        "globalSearch.latest_entity": "Latest {{entity}} in Promang:",
        "globalSearch.no_latest_entity": "No {{entity}} found in Promang.",
        "globalSearch.found_count": "Found {{count}} results",
        "globalSearch.status_result": "{{title}} — status: {{status}}",
        "globalSearch.status.unknown": "Unknown",
        "globalSearch.status.customer.active": "Active customer",
        "globalSearch.status.customer.inactive": "Inactive customer",
        "globalSearch.status.project.active": "Active project",
        "globalSearch.status.project.inactive": "Inactive project",
        "globalSearch.status.project.finished": "Finished project",
        "globalSearch.module.hse_document": "HSE documents",
        "globalSearch.entity.hse_document": "HSE document",

        "dashboard.header.open_menu": "Open menu",
        "dashboard.header.close_sidebar": "Close sidebar",
        "dashboard.header.more_actions": "More actions",
        "dashboard.header.view_notifications": "View notifications",
        "dashboard.header.view_tasks": "View tasks",
        "dashboard.header.tasks": "Tasks",
        "dashboard.header.loading_tasks": "Loading tasks…",
        "dashboard.header.unfinished": "Unfinished",
        "dashboard.header.due_today": "Due today",
        "dashboard.header.overdue": "Overdue",
        "dashboard.header.go_to_tasks": "Go to tasks",
        "dashboard.header.companies": "Companies",
        "dashboard.header.switch_company": "Switch company",
        "dashboard.header.loading_companies": "Loading companies…",
        "dashboard.header.no_companies": "No companies available",
        "dashboard.header.open_user_menu": "Open user menu",
        "dashboard.header.your_profile": "Your profile",
        "dashboard.header.settings": "Settings",
        "dashboard.header.microsoft_outlook": "Microsoft / Outlook",
        "dashboard.header.sign_out": "Sign out",
        "dashboard.header.company_switched": "Company switched",
        "dashboard.header.company_switch_failed": "Could not switch company",
        "Oppdatering": "Update",
        "Innlegg": "Update",
        "status_update.mine_title": "My updates",
        "status_update.mine_search_placeholder": "Search my updates…",
        "status_update.mine_empty": "You have no updates yet.",
        "status_update.mine_empty_search": "No matches for your search.",
        "status_update.mine_load_more": "Load more",
        "status_update.mine_untitled": "Untitled",
        "status_update.mine_no_subject_link": "Could not open the linked item.",
        "status_update.mine_company_scope": "Company",
        "status_update.subject_project": "Project",
        "status_update.subject_customer": "Customer",
        "status_update.subject_work_order": "Work order",
        "status_update.subject_project_activity": "Project activity",
        "status_update.unavailable_title": "Updates are unavailable",
        "status_update.unavailable_description": "The module or API has not been deployed yet, or is temporarily unavailable. Please try again later.",
        "status_update.unavailable_nav_hint": "Updates are unavailable right now",
        "status_update.load_error": "Could not load updates.",
        "status_update.load_more_error": "Could not load more updates.",
        "status_update.delete_failed": "Could not delete the update.",
        "status_update.save_failed": "Could not save the update.",
        "status_update.saved": "Update saved",
        "status_update.edit": "Edit",
        "status_update.save": "Save",
        "status_update.cancel": "Cancel",
        "status_update.edited": "edited",
        "status_update.mentioned_here": "Mentioned here",
        "status_update.search_placeholder": "Search updates…",
        "status_update.search_empty": "No matches for your search.",
        "status_update.retry": "Try again",
        "work_order.redesign.status_updates_title": "Update",
        "work_order.redesign.status_updates_meta": "Status, photos and follow-up",
        "notes.legacy_title": "Previous notes",
        "notes.legacy_hint": "Older notes and photos (read-only). Write new updates under Update.",
        "project.activities.status_updates_title": "Update",
        "Skriv oppdatering": "Write an update",
        "Skriv innlegg": "Write an update",
        "Skriv en oppdatering… bruk @ for å nevne, / for å koble modul": "Write a status update… use @ to mention, / to link a module",
        "Skriv et innlegg… bruk @ for å nevne, / for å koble modul": "Write a status update… use @ to mention, / to link a module",
        "Tittel (valgfritt)": "Title (optional)",
        "Legg til tittel": "Add title",
        "Alle med tilgang": "Everyone with access",
        "Kun admin": "Admins only",
        "Kun meg": "Only me",
        "Publiser": "Publish",
        "Sender…": "Sending…",
        "Publisert": "Published",
        "Ingen oppdateringer ennå. Skriv den første!": "No updates yet. Write the first one!",
        "Ingen innlegg ennå. Skriv det første!": "No updates yet. Write the first one!",
        "Slette denne oppdateringen?": "Delete this update?",
        "Slette dette innlegget?": "Delete this update?",
        "Slett": "Delete",
        "Clear": "Clear",
        "Velg…": "Select…",
        "Skriv litt tekst eller legg til vedlegg for å publisere": "Write some text or add an attachment to publish",
        "Kunne ikke publisere oppdateringen": "Could not publish the update",
        "Kunne ikke publisere innlegget": "Could not publish the update",
        "oppdatering.subject_optional_hint": "Project or customer is optional. AI may suggest a project from your text.",
        "Dikter": "Dictate",
        "Tekst": "Text",
        "Dikter oppdatering": "Dictate update",
        "Dikter innlegg": "Dictate update",
        "Hvordan vil du legge inn oppdateringen?": "How do you want to add the update?",
        "Trykk for å stoppe opptaket. Teksten vises etterpå.": "Tap to stop recording. The text appears afterwards.",
        "Bytt metode": "Change method",
        "Foreslå": "Suggest",
        "Foreslå oppgaver": "Suggest tasks",
        "Foreslåtte oppgaver": "Suggested tasks",
        "Velg hvilke som skal opprettes": "Choose which ones to create",
        "Hopp over": "Skip",
        "Opprett valgte": "Create selected",
        "Oppretter…": "Creating…",
        "AI-forslag": "AI suggestions",
        "oppdatering.suggestion_add": "Add",
        "oppdatering.suggestion_dismiss": "Dismiss suggestion",
        "oppdatering.todos_created": "{{count}} task(s) created",
        "oppdatering.todos_create_failed": "Could not create {{count}} task(s)",
        "oppdatering.todos_publish_first": "You can create tasks before publishing.",
        "oppdatering.todo_created_badge": "Created",
        "oppdatering.todos_created_section": "Created tasks",
        "oppdatering.hours_title": "Suggested hours",
        "oppdatering.hours_hint": "Choose which entries to register",
        "oppdatering.hours_created": "{{count}} hour entry(ies) created",
        "oppdatering.hours_create_failed": "Could not register {{count}} hour entry(ies)",
        "oppdatering.hours_created_section": "Registered hours",
        "oppdatering.hours_created_badge": "Registered",
        "oppdatering.hours_col_project": "Project",
        "oppdatering.hours_col_activity": "Activity",
        "oppdatering.hours_col_description": "Description",
        "oppdatering.hours_col_time": "Hours",
        "oppdatering.hours_col_date": "Date",
        "oppdatering.hours_missing_project": "Select project",
        "oppdatering.hours_missing_activity": "Select activity",
        "oppdatering.hours_open": "Open timesheet",
        "oppdatering.new_draft": "New update",
        "oppdatering.already_published": "Already published — start a new update",
        "Lukk": "Close",
        "Stopp": "Stop",
        "Stopp opptak": "Stop recording",
        "Tolker…": "Transcribing…",
        "Opptak støttes ikke i denne nettleseren.": "Recording is not supported in this browser.",
        "Kunne ikke transkribere lyden.": "Could not transcribe the audio.",
        "Fikk ikke tilgang til mikrofonen.": "Could not access the microphone.",
        "Fjern vedlegg": "Remove attachment",
        // --- offer sidebar / route titles (exact t(title) keys) ---
        "Tilbud": "Offers",
        "Oversikt": "Overview",
        "Nytt tilbud": "New offer",
        "Offer": "Offer",
        "Offers": "Offers",
        "Kalkyler": "Calculations",
        "Kalkyle": "Calculation",
        "Ny Kalkyle": "New calculation",
        "Timesatser": "Hour rates",
        "Timesats": "Hour rate",
        "Ny Timesats": "New hour rate",
        "Maler": "Templates",
        "Innstillinger": "Settings",
        "Templates": "Templates",
        "Settings": "Settings",
        // --- offer redesign recovery keys ---
        "offers.list.title": "Offers",
        "offers.list.subtitle": "Overview of all offers and calculations",
        "offers.list.new": "New offer",
        "offers.list.import_quantity_list": "Import quantity list",
        "offers.list.import_coming_soon": "Import quantity list is coming soon.",
        "offers.list.search_placeholder": "Search offers...",
        "offers.list.active_only": "Active offers",
        "offers.list.offer_fallback": "Offer #{{id}}",
        "offers.list.valid_to": "Valid to",
        "offers.list.columns.offer": "Offer",
        "offers.list.columns.customer": "Customer",
        "offers.list.columns.responsible": "Responsible",
        "offers.list.columns.project": "Project",
        "offers.list.columns.status": "Status",
        "offers.list.columns.revision": "Rev.",
        "offers.list.columns.sum": "Sum",
        "offers.list.columns.margin": "GM%",
        "offers.list.columns.updated": "Last updated",
        "offers.list.empty": "No offers found",
        "offers.list.error": "Could not load offers",
        "offers.stats.total_sales": "Total sales",
        "offers.stats.count": "Count",
        "offers.stats.sent": "Sent",
        "offers.stats.accepted": "Accepted",
        "offers.stats.margin": "GM%",
        "offers.status.none": "None",
        "offers.status.new": "New",
        "offers.status.sent": "Sent",
        "offers.status.accepted": "Accepted",
        "offers.status.rejected": "Rejected",
        "offers.status.expired": "Expired",
        "offers.status.cancelled": "Cancelled",
        "offers.info.title": "Title",
        "offers.info.offer_number": "Offer number",
        "offers.info.offer_date": "Offer date",
        "offers.info.not_set": "Not set",
        "offers.info.not_assigned": "Not assigned",
        "offers.info.copy": "Copy",
        "offers.info.valid_from": "Valid from",
        "offers.info.valid_to": "Valid to",
        "offers.info.currency": "Currency",
        "offers.info.draft_revision": "Draft revision",
        "offers.info.accepted_revision": "Accepted revision",
        "offers.info.none": "None",
        "offers.convert.to_project": "Convert to project",
        "offers.convert.open_project": "Open project",
        "offers.convert.converting": "Converting…",
        "offers.convert.success": "Offer was converted to a project.",
        "offers.convert.already_linked": "Offer is already linked to a project.",
        "offers.convert.order_created": "Order {{order_number}} was created from the offer.",
        "offers.convert.failed": "Could not convert offer to project.",
        "offers.errors.not_authorized": "You are not authorized to perform this action on the offer.",
        "offers.errors.revision_locked": "The offer is approved and locked. Create a new revision to edit the calculation.",
        "offers.send.failed": "Something went wrong. Could not send the offer.",
        "offers.send.success": "Offer sent successfully",
        "offers.send.timeout": "The request timed out. Please check the offer status manually.",
        "offers.send.status_unconfirmed": "Sending is not confirmed yet. Do not start a new delivery.",
        "offers.send.status_unconfirmed_hint": "We keep the same send attempt. Use “Check status” — it will not create another email.",
        "offers.send.check_status": "Check status",
        "offers.send.status_check_resumed": "Checking status for the same send attempt…",
        "offers.send.mailed_needs_followup": "Email was sent, but the revision needs follow-up.",
        "offers.send.mailed_needs_followup_hint": "The email was already sent. Use “Finish revision” — the same send attempt resumes without another email.",
        "offers.send.sent_needs_attention": "Email was sent, but the revision needs follow-up.",
        "offers.send.finish_revision": "Finish revision",
        "offers.send.queued": "Offer queued for sending…",
        "offers.send.retry": "Sending failed. Please try again.",
        "offers.send.title": "Send offer",
        "offers.send.subtitle": "Choose recipient, offer PDF layout and customer message before sending.",
        "offers.send.revision_lock_note": "Sending this offer will lock the current revision. After sending it cannot be changed.",
        "offers.send.success_with_revision": "Offer sent successfully (revision {{number}}).",
        "offers.history.revisions_title": "Revisions",
        "offers.history.revisions_subtitle": "Sent and draft revisions for this offer.",
        "offers.history.revisions_pending_api": "Full revision list will appear when the revisions API is available.",
        "offers.history.revisions_empty": "No revisions yet.",
        "offers.history.revisions_empty_hint": "A draft is created automatically when you open this tab. You can also create a draft manually, or send the offer to the customer to lock a revision.",
        "offers.history.ensure_draft_cta": "Create draft revision",
        "offers.history.ensure_draft_success": "Draft revision is ready.",
        "offers.history.ensure_draft_failed": "Could not create draft revision.",
        "offers.history.compare_need_two": "Comparison requires at least two revisions.",
        "offers.history.revisions_error": "Could not load revisions.",
        "offers.history.revision_number": "Revision {{number}}",
        "offers.history.revision_id_fallback": "ID {{id}}",
        "offers.history.submit_review_hint": "Send the draft for internal review with",
        "offers.history.send_lock_hint": "«Send offer» to the customer locks the current revision.",
        "offers.history.send_lock_cta": "Send offer",
        "offers.history.approval_tab_hint": "Approval and customer acceptance are handled under the Approval tab.",
        "offers.history.lines_count": "{{count}} lines",
        "offers.history.amount": "Amount",
        "offers.history.locked": "Locked",
        "offers.history.locked_at": "Locked",
        "offers.history.submitted_for_review_at": "Submitted for review",
        "offers.history.reviewer": "Reviewer",
        "offers.history.is_accepted": "Accepted",
        "offers.history.open_pdf": "Open PDF",
        "offers.history.pdf_failed": "Could not open PDF for this revision.",
        "offers.history.accept": "Accept",
        "offers.history.restore_calc": "Restore calculation",
        "offers.history.restore_calc_confirm": "Replace the draft calculation with the locked tree from revision {{number}}? Unsaved calculation edits will be lost.",
        "offers.history.restore_calc_success": "Calculation restored from revision {{number}}",
        "offers.history.restore_calc_failed": "Could not restore calculation from revision",
        "offers.history.restore_calc_note": "Restored calculation from revision {{number}}",
        "offers.history.accept_success": "Revision {{number}} was accepted.",
        "offers.history.accept_failed": "Could not accept the revision.",
        "offers.history.revision_status.draft": "Draft",
        "offers.history.revision_status.pending_review": "Pending review",
        "offers.history.revision_status.approved": "Approved",
        "offers.history.revision_status.issued": "Issued",
        "offers.history.revision_status.sent": "Sent",
        "offers.history.revision_status.accepted": "Accepted",
        "offers.history.revision_status.rejected": "Rejected",
        "offers.history.revision_status.superseded": "Superseded",
        "offers.history.send_title": "Send history",
        "offers.history.send_subtitle": "Overview of every time this offer has been sent.",
        "offers.history.send_empty": "No send history yet.",
        "offers.history.send_empty_hint": "When you send the offer it will show up here.",
        "offers.history.sent_to": "Sent to {{recipient}}",
        "offers.history.sent_by": "Sent by",
        "offers.history.status_delivered": "Delivered",
        "offers.history.status_pending": "Pending",
        "offers.history.status_failed": "Failed",
        "offers.approval.title": "Approval required",
        "offers.approval.subtitle": "Review key figures and approve or reject the revision before sending and customer acceptance.",
        "offers.approval.unavailable": "Approval is not available until revisions are enabled for the company.",

        "offers.settings.title": "Offer settings",
        "offers.settings.subtitle": "Choose which offer tools are available for the company.",
        "offers.settings.intro":
          "These options control tabs and workflow in the offer module. Recommended options are marked. Changes apply company-wide immediately.",
        "offers.settings.open_guide": "Open the offer setup guide",
        "offers.settings.recommended": "Recommended",
        "offers.settings.saved": "Setting saved",
        "offers.settings.load_error": "Could not load offer settings",
        "offers.settings.save_error": "Could not save the setting",
        "offers.settings.groups.workflow": "Workflow",
        "offers.settings.groups.workflow_hint": "Checklist, internal review and approval before sending.",
        "offers.settings.groups.calculation": "Calculation",
        "offers.settings.groups.calculation_hint": "New calculation engine, formulas, module builder and templates.",
        "offers.settings.groups.document": "Document",
        "offers.settings.groups.document_hint": "Offer document and AI help for text.",
        "offers.settings.groups.import": "Import and project",
        "offers.settings.groups.import_hint": "Quantity lists, inquiries and conversion to project.",
        "offers.settings.groups.overview": "Overview",
        "offers.settings.groups.overview_hint": "New overview and template versioning.",
        "offers.settings.groups.other": "Other",
        "offers.settings.groups.other_hint": "",
        "offers.settings.flags.offer_revisions.title": "Revisions and approval",
        "offers.settings.flags.offer_revisions.description":
          "Enables the Approval and Revisions tabs. Internal review before the offer is sent to the customer.",
        "offers.settings.flags.offer_checklist.title": "Checklist",
        "offers.settings.flags.offer_checklist.description":
          "Shows the checklist tab on the offer so you can quality-check before sending.",
        "offers.settings.flags.offer_checklist_required_on_send.title": "Require checklist before send",
        "offers.settings.flags.offer_checklist_required_on_send.description":
          "Blocks sending to the customer until the checklist is complete. Turn on after checklists are in use.",
        "offers.settings.flags.offer_calculation_v2.title": "Calculation v2",
        "offers.settings.flags.offer_calculation_v2.description":
          "More accurate totals (cost, contribution margin and DG%) from the server. Recommended.",
        "offers.settings.flags.offer_safe_formula_engine.title": "Safe formula engine",
        "offers.settings.flags.offer_safe_formula_engine.description":
          "Allows only simple arithmetic in calculation types, without unsafe code execution.",
        "offers.settings.flags.offer_module_builder.title": "Module builder",
        "offers.settings.flags.offer_module_builder.description":
          "Visual graph for composite calculation modules (AHU, ducting and similar).",
        "offers.settings.flags.offer_calculation_templates.title": "Calculation templates",
        "offers.settings.flags.offer_calculation_templates.description":
          "Extended template library. Adding and saving calculation templates on an offer always works.",
        "offers.settings.flags.offer_calculation_template_versions.title": "Calculation template versions",
        "offers.settings.flags.offer_calculation_template_versions.description":
          "History and restore for calculation templates.",
        "offers.settings.flags.offer_document_builder.title": "Document builder",
        "offers.settings.flags.offer_document_builder.description":
          "Build the offer document with text blocks, reservations and customer-facing layout.",
        "offers.settings.flags.offer_document_ai.title": "AI in document",
        "offers.settings.flags.offer_document_ai.description":
          "AI help for text and attachment analysis. Requires document builder.",
        "offers.settings.flags.offer_import_v2.title": "Quantity list import",
        "offers.settings.flags.offer_import_v2.description":
          "Import rows into the calculation from a file, with product matching.",
        "offers.settings.flags.offer_inquiries.title": "Multi-requestor inquiries",
        "offers.settings.flags.offer_inquiries.description":
          "Handle several requestors on the same tender.",
        "offers.settings.flags.offer_project_conversion_v2.title": "Convert to project",
        "offers.settings.flags.offer_project_conversion_v2.description":
          "New flow for creating a project from an accepted offer.",
        "offers.settings.flags.offer_v2_overview.title": "New overview",
        "offers.settings.flags.offer_v2_overview.description":
          "Richer overview with contribution margin and status KPIs.",
        "offers.settings.flags.offer_template_versions.title": "Offer template versions",
        "offers.settings.flags.offer_template_versions.description":
          "History for full offer templates, not only the calculation.",
        "offers.approval.empty": "No revision to process yet.",
        "offers.approval.empty_hint": "Create or edit the offer to get a draft. Use «Send for review» for internal review.",
        "offers.approval.approvers_title": "Approvers",
        "offers.approval.approvers_mvp_note": "Multiple approvers and staged flow come later. You approve with your own user.",
        "offers.approval.approvers_one_step_note": "One-step approval: the selected reviewer is shown here. You approve with your own user when you have access.",
        "offers.approval.approver_you": "You",
        "offers.approval.approver_unassigned": "No reviewer selected",
        "offers.approval.approver_role": "Offer access",
        "offers.approval.approver_pending": "Pending",
        "offers.approval.approver_done": "Done",
        "offers.approval.approver_idle": "Ready",
        "offers.approval.pending_review_hint": "The revision has been submitted for internal review and can be approved.",
        "offers.approval.pending_review_hint_reviewer": "The revision was submitted for review ({{reviewer}}) and can be approved.",
        "offers.approval.section_internal_title": "Internal approval",
        "offers.approval.section_internal_subtitle": "Internal review, approve and reject. An approved revision is locked — further edits require a new revision.",
        "offers.approval.section_customer_title": "Customer approval",
        "offers.approval.section_customer_subtitle": "Send the offer to the customer and register customer acceptance.",
        "offers.approval.approved_at_hint": "A previous revision is approved internally. You are now working on a new draft.",
        "offers.approval.approved_locked_hint": "The revision is approved and locked. Create a new revision to edit further.",
        "offers.approval.reopen_cta": "Create new revision",
        "offers.approval.reopen_success": "New revision created based on revision {{number}}.",
        "offers.approval.reopen_failed": "Could not create a new revision.",
        "offers.approval.reopen_note": "Reopened for editing from revision {{number}}",
        "offers.create_revision.title": "Create new revision",
        "offers.create_revision.intro":
          "Choose how to continue. A new revision is right when you need to change this offer further — not when you need a completely new offer.",
        "offers.create_revision.bullet_based_on":
          "The new revision is based on the latest locked revision (based_on).",
        "offers.create_revision.bullet_locked":
          "The approved/sent revision stays locked and unchanged.",
        "offers.create_revision.bullet_draft":
          "You get an editable draft that becomes the current draft.",
        "offers.create_revision.bullet_kalkyle":
          "The calculation unlocks for editing on the new draft.",
        "offers.create_revision.based_on_label":
          "The new revision will be based on locked revision {{number}}.",
        "offers.create_revision.choose_label": "What do you want to do?",
        "offers.create_revision.option_revision_title": "Create a new revision of this offer",
        "offers.create_revision.option_revision_hint":
          "Keeps offer number and history. Recommended after internal approval or send.",
        "offers.create_revision.option_copy_title": "Copy as a new offer",
        "offers.create_revision.option_copy_hint":
          "Better when you need a separate offer (other customer, project or variant).",
        "offers.create_revision.option_blank_title": "Start a blank offer",
        "offers.create_revision.option_blank_hint":
          "When you should not build on the content here.",
        "offers.create_revision.already_draft":
          "This offer already has an editable draft. Use it, or copy as a new offer.",
        "offers.create_revision.already_draft_hint":
          "You already have a draft. A new revision is not needed — keep editing, or choose copy/blank below.",
        "offers.create_revision.missing_locked":
          "No locked revision found to base a new revision on.",
        "offers.create_revision.confirm": "Create revision",
        "offers.create_revision.confirm_copy": "Continue to copy",
        "offers.create_revision.confirm_blank": "Open new offer",
        "offers.approval.approve": "Approve",
        "offers.approval.reject": "Reject",
        "offers.approval.accept": "Register acceptance",
        "offers.approval.send": "Send for review",
        "offers.approval.key_figures": "Key figures",
        "offers.approval.discount": "Discount",
        "offers.approval.workflow_hint": "Flow: internal review → approve (locked) → create a new revision if needed → send offer to customer → register acceptance. Details and PDF are under Revisions.",
        "offers.approval.approve_success": "Revision {{number}} was approved and locked.",
        "offers.approval.approve_failed": "Could not approve the revision.",
        "offers.approval.reject_success": "Revision {{number}} was rejected.",
        "offers.approval.reject_failed": "Could not reject the revision.",
        "offers.approval.api_unavailable": "The approval API is not available yet. Try again later.",
        "offers.approval.confirm_approve_title": "Confirm approval",
        "offers.approval.confirm_approve_body": "Approve revision {{number}}? The revision is locked. To edit further you must create a new revision.",
        "offers.approval.confirm_approve_submit": "Yes, approve",
        "offers.approval.confirm_accept_title": "Confirm customer acceptance",
        "offers.approval.confirm_accept_body": "Register that the customer accepted revision {{number}}?",
        "offers.approval.confirm_accept_submit": "Yes, register acceptance",
        "offers.approval.reject_dialog_title": "Reject revision",
        "offers.approval.reject_dialog_body": "Reject revision {{number}}. Describe what must change before the offer can be approved again.",
        "offers.approval.reject_reason_label": "What must change?",
        "offers.approval.reject_reason_placeholder": "E.g. adjust quantities, fix prices, add installation…",
        "offers.approval.reject_reason_required": "You must describe what must change.",
        "offers.approval.reject_confirm": "Reject revision",
        "offers.approval.warning.low_dg": "Contribution margin ({{value}}) is below the threshold ({{threshold}}%).",
        "offers.approval.warning.low_dg_short": "Below {{threshold}}% threshold",
        "offers.approval.warning.negative_margin": "Negative contribution margin — review the calculation before approving.",
        "offers.approval.warning.no_lines": "The offer has neither a calculation nor customer lines.",
        "offers.approval.warning.lines_materialize_on_approve": "Customer lines are materialized from the calculation on approve/send (ADR-005).",
        "offers.diff.title": "Compare revisions",
        "offers.diff.locked_calc_title": "Locked calculation",
        "offers.diff.locked_calc_hint": "Snapshot from the revision — live calculation edits do not change this view.",
        "offers.diff.locked_calc_from": "Locked calculation · rev. {{number}} (from)",
        "offers.diff.locked_calc_to": "Locked calculation · rev. {{number}} (to)",
        "offers.diff.no_locked_calc": "No calculation snapshot on this revision (sent before REV-001).",
        "offers.diff.no_locked_calc_public": "No calculation snapshot on this revision.",
        "offers.diff.subtitle": "See economic and line differences between two revisions.",
        "offers.diff.toggle_show": "Compare",
        "offers.diff.toggle_hide": "Hide comparison",
        "offers.diff.from": "From",
        "offers.diff.to": "To",
        "offers.diff.metric": "Metric",
        "offers.diff.change": "Change",
        "offers.diff.offer_total": "Offer total",
        "offers.diff.contribution_margin": "Contribution margin",
        "offers.diff.contribution_margin_percent": "Contribution margin %",
        "offers.diff.no_change": "No change",
        "offers.diff.lines_title": "Line changes",
        "offers.diff.added": "Added",
        "offers.diff.removed": "Removed",
        "offers.diff.changed": "Changed",
        "offers.diff.no_line_changes": "No changes to the lines.",
        "offers.diff.unchanged_count": "{{count}} unchanged lines",
        "offers.diff.untitled_line": "Untitled",
        "offers.diff.field.quantity": "Quantity",
        "offers.diff.field.sales_price": "Price",
        "offers.diff.field.line_total": "Total",
        "offers.diff.field.title": "Title",
        "offers.diff.field.description": "Description",
        "offers.diff.error": "Could not load the revisions for comparison.",
        "offers.diff.empty": "Select two revisions to compare.",
        "offers.diff.same_revision": "Select two different revisions to see differences.",
        "offers.overview.kpi.total": "Offer total",
        "offers.overview.kpi.cost": "Cost",
        "offers.overview.kpi.contribution_margin": "Contribution margin",
        "offers.overview.kpi.contribution_margin_percent": "Contribution ratio",
        "offers.overview.kpi.probability": "Probability",
        "offers.overview.kpi.cost.info_aria": "Information about cost",
        "offers.overview.kpi.cost.info_body": "Cost is the total cost price for the offer. It uses the saved cost_total on the offer when available; otherwise it is summed from calculations (offer_calculation_v2) or estimated from lines (cost price × quantity). This feeds contribution margin and contribution ratio.",
        "offers.overview.kpi.contribution_margin.info_aria": "Information about contribution margin",
        "offers.overview.kpi.contribution_margin.info_body": "Contribution margin (DB) is sales total minus cost. When the offer has a saved contribution_margin, that value is used. Otherwise it is summed or derived from calculations, or estimated as sales minus cost.",
        "offers.overview.kpi.contribution_margin_percent.info_aria": "Information about contribution ratio",
        "offers.overview.kpi.contribution_margin_percent.info_body": "Contribution ratio (DG%) is contribution margin as a percentage of sales. When contribution_margin_percent is saved on the offer, that value is used. Otherwise it is calculated as DB ÷ sales × 100 from calculation or estimated values.",
        "offers.overview.kpi.probability.info_aria": "Information about probability",
        "offers.overview.kpi.probability.info_body": "Probability is the expected win chance for the offer (0–100%). It is set on the offer when the field is in use. It is not calculated automatically from calculations or lines.",
        "offers.overview.kpi.probability_empty_hint": "Not set",
        "offers.overview.authoritative_hint": "Server-calculated",
        "offers.overview.estimate_hint": "Estimate",
        "offers.overview.negative_margin": "Negative contribution margin",
        "offers.overview.activity.title": "Activity",
        "offers.overview.activity.empty": "No activity yet",
        "offers.overview.activity.revision_status": "Revision {{number}} – {{status}}",
        "offers.overview.activity.converted": "Converted to project",
        "offers.overview.activity.created": "Offer created",
        "offers.overview.activity.today": "Today",
        "offers.overview.activity.yesterday": "Yesterday",
        "offers.overview.activity.days_ago": "{{count}} days",
        "offers.overview.activity.with_actor": "{{text}} by {{actor}}",
        "offers.inquiries.title": "Inquiries / tenders",
        "offers.inquiries.subtitle": "Multiple requesting companies on the same offer. Calculation and revision are shared.",
        "offers.inquiries.add": "New inquiry",
        "offers.inquiries.add_title": "New inquiry",
        "offers.inquiries.edit": "Edit",
        "offers.inquiries.edit_title": "Edit inquiry",
        "offers.inquiries.delete": "Delete",
        "offers.inquiries.delete_title": "Delete inquiry",
        "offers.inquiries.delete_confirm": "Are you sure you want to delete this inquiry?",
        "offers.inquiries.empty": "No inquiries yet.",
        "offers.inquiries.no_contact": "No contact person",
        "offers.inquiries.due": "Due",
        "offers.inquiries.created": "Inquiry created",
        "offers.inquiries.updated": "Inquiry updated",
        "offers.inquiries.deleted": "Inquiry deleted",
        "offers.inquiries.save_failed": "Could not save the inquiry.",
        "offers.inquiries.delete_failed": "Could not delete the inquiry.",
        "offers.inquiries.validation.company_required": "Select the requesting company from the customer register.",
        "offers.inquiries.fields.company": "Requesting company",
        "offers.inquiries.fields.contact_name": "Contact person",
        "offers.inquiries.fields.contact_email": "Email",
        "offers.inquiries.fields.contact_phone": "Phone",
        "offers.inquiries.fields.status": "Status",
        "offers.inquiries.fields.due_at": "Due date",
        "offers.inquiries.fields.notes": "Notes",
        "offers.inquiries.change_status": "Change status",
        "offers.inquiries.status_title": "Change status",
        "offers.inquiries.status_updated": "Status updated",
        "offers.inquiries.status.requested": "Requested",
        "offers.inquiries.status.in_progress": "In progress",
        "offers.inquiries.status.offered": "Offered",
        "offers.inquiries.status.declined": "Declined",
        "offers.inquiries.status.won": "Won",
        "offers.inquiries.status.lost": "Lost",
        "offers.banner.offer": "Offer",
        "offers.banner.new": "New offer",
        "offers.banner.revision": "Rev.",
        "offers.banner.project": "Project",
        "offers.banner.responsible": "Responsible",
        "offers.banner.total": "Offer total",
        "offers.banner.valid_to": "Valid until",
        "offers.banner.edit": "Edit",
        "offers.banner.send": "Send for review",
        "offers.banner.send_offer": "Send offer",
        "offers.menu.send_offer": "Send offer",
        "offers.menu.create_revision": "Create new revision",
        "offers.banner.pdf": "PDF",
        "offers.banner.pdf_simple": "PDF — simple",
        "offers.banner.pdf_document": "PDF — document",
        "offers.banner.print_current": "Print ({{layout}})",
        "offers.banner.print_other": "Other layout ({{layout}})",
        "offers.banner.convert": "Convert",
        "offers.banner.more": "More actions",
        "offers.banner.copy": "Copy",
        "offers.banner.delete": "Delete",
        "offers.banner.tabs": "Tabs",
        "offers.banner.copy_coming": "Copying offers is coming soon.",
        "offers.submit_review.title": "Send for review",
        "offers.submit_review.description": "Mark the revision as ready for internal review. This does not send the offer to the customer.",
        "offers.submit_review.reviewer_label": "Reviewer (optional)",
        "offers.submit_review.reviewer_optional_hint": "You can confirm without selecting a reviewer.",
        "offers.submit_review.confirm": "Send for review",
        "offers.submit_review.success": "Sent for review",
        "offers.submit_review.failed": "Could not submit for review.",
        "offers.submit_review.missing_revision": "No draft revision found to submit for review.",
        "offers.tabs.calculation": "Calculation",
        "offers.tabs.overview": "Overview",
        "offers.tabs.lines": "Customer view",
        "offers.tabs.update_snapshot": "Update snapshot",
        "offers.template_wizard.title": "Customize template before load",
        "offers.template_wizard.hint": "Answer the parameters this template asks for. Then the calculation loads with your values.",
        "offers.template_wizard.empty": "This template has no parameters — it loads directly.",
        "offers.template_wizard.apply": "Load template",
        "offers.template_wizard.root_section": "Main calculation",
        "offers.tabs.advanced_menu": "Advanced",
        "offers.tabs.enable_legacy_edit": "Allow legacy line editing",
        "offers.tabs.legacy_edit_banner": "Advanced snapshot editing — not daily offer building. Build in the calculation; this only stages temporary customer lines.",
        "offers.tabs.legacy_edit_locked_hint": "Customer view is driven by calculation + presentation. Enable legacy editing under Advanced if needed.",
        "offers.pricing.open_button": "Pricing method…",
        "offers.pricing.dialog_title": "Pricing method (markup / target margin)",
        "offers.pricing.dialog_hint": "Separate markup (cost × (1+p)) from target margin (cost / (1−margin)). Legacy surcharge is a sales adjustment.",
        "offers.pricing.method": "Method",
        "offers.pricing.method_legacy": "Legacy surcharge (default)",
        "offers.pricing.method_markup": "Markup on cost",
        "offers.pricing.method_target_margin": "Target contribution margin",
        "offers.pricing.method_fixed_sales": "Fixed sales price",
        "offers.pricing.rate_percent": "Percent",
        "offers.pricing.price_status": "Price status",
        "offers.pricing.status_estimated": "Estimated",
        "offers.pricing.status_missing": "Missing",
        "offers.pricing.status_confirmed_zero": "Confirmed zero",
        "offers.pricing.surcharge_disabled_hint": "Disabled while pricing method is set",
        "offers.presentation.open_button": "Presentation…",
        "offers.presentation.dialog_title": "Customer / PDF presentation",
        "offers.presentation.dialog_hint": "One offer calculation. Line calculations appear as groups. Choose sum only or show child lines — not multiple root calculations.",
        "offers.presentation.default_group": "Default for groups / root calculation",
        "offers.presentation.default_nested": "Default for line calculations",
        "offers.presentation.show_product_info": "Show product info under lines",
        "offers.presentation.show_product_info_hint": "Applies when children are shown. Off = title/price only, without product description.",
        "offers.presentation.include_product_short": "Include short product description",
        "offers.presentation.include_product_short_hint": "Writes to presentation rules and offer calculations. Shows the product short_description in customer view and PDF when the field is filled.",
        "offers.presentation.tab.structure": "Structure",
        "offers.presentation.tab.document": "Document",
        "offers.presentation.tab.lines": "Lines",
        "offers.presentation.include_notes": "Show notes on the offer",
        "offers.presentation.include_notes_hint": "Notes from the calculation (text lines and module notes). Off = hidden in customer view. Per-note visibility is also controlled with “Show on offer” on the line.",
        "offers.presentation.fields_heading": "Fields shown on lines",
        "offers.presentation.field.description": "Description",
        "offers.presentation.field.quantity": "Quantity",
        "offers.presentation.field.unit": "Unit",
        "offers.presentation.field.unit_price": "Unit price",
        "offers.presentation.field.product_image": "Product image",
        "offers.presentation.field.product_url": "Product link",
        "offers.presentation.lines_hint": "Hide a whole line, or turn off individual fields. Only lines that exist in the calculation appear here — unused firm templates do not.",
        "offers.presentation.line_visible": "Visible",
        "offers.presentation.line_fallback": "Line {{n}}",
        "offers.presentation.empty_lines": "No calculation lines yet — add content on the Calculation tab first.",
        "offers.presentation.overview_only_hint": "Customer view shows only what was added to the calculation. A calculation template that is not a line in the overview is not shown.",
        "offers.presentation.kind.group": "Group",
        "offers.presentation.kind.root_calc": "Offer calculation",
        "offers.presentation.kind.nested_calculation": "Line calculation",
        "offers.presentation.empty_tree": "No groups or calculations yet — build structure in Calculation first.",
        "offers.presentation.mode.show_children": "Show child lines",
        "offers.presentation.mode.sum_only": "Sum only",
        "offers.presentation.mode.hide": "Hide",
        "offers.presentation.cancel": "Cancel",
        "offers.presentation.save": "Save",
        "offers.presentation.saving": "Saving…",
        "offers.presentation.save_success": "Presentation rules saved",
        "offers.presentation.save_failed": "Could not save presentation rules",
        "offers.tabs.document": "Document",
        "offers.tabs.attachments": "Attachments",
        "offers.tabs.checklist": "Checklist",
        "offers.tabs.revisions": "Revisions",
        "offers.tabs.approval": "Approval",
        "offers.tabs.history": "History",
        "offers.activity.filters.all": "All",
        "offers.activity.filters.kalkyle": "Calculation",
        "offers.activity.filters.linjer": "Lines",
        "offers.activity.filters.grupper": "Groups",
        "offers.activity.filters.dokument": "Document",
        "offers.activity.filters.revisjoner": "Revisions",
        "offers.activity.filters.import": "Import",
        "offers.activity.filters.godkjenning": "Approval",
        "offers.activity.filters.system": "System",
        "offers.activity.groups.this_week": "This week",
        "offers.activity.groups.last_week": "Last week",
        "offers.activity.groups.older": "Older",
        "offers.activity.system_actor": "System",
        "offers.activity.empty_title": "No activity yet",
        "offers.activity.empty_hint": "When something happens on this offer — calculation, revisions, import or approval — it will show up here.",
        "offers.activity.error": "Could not load activity history.",
        "offers.activity.error_unauthorized": "You do not have access to activity history.",
        "offers.activity.loading": "Loading activity…",
        "offers.activity.badge.rev": "Rev. {{number}}",
        "offers.activity.badge.version": "v{{from}} → v{{to}}",
        "offers.activity.badge.matched": "{{matched}} / {{rows}} matched",
        "offers.activity.time.just_now": "Just now",
        "offers.activity.time.minutes_ago": "{{count}} min ago",
        "offers.activity.time.today_at": "Today {{time}}",
        "offers.activity.time.yesterday_at": "Yesterday {{time}}",
        "offers.activity.time.days_ago": "{{count}} days ago",
        "offers.activity.actions.compare_revisions": "Compare revisions →",
        "offers.activity.actions.view_import_log": "View import log →",
        "offers.activity.actions.open_revision": "Open revision →",
        "offers.activity.actions.open_related": "Open →",
        "offers.activity.actions.import_coming": "Import opens from the calculation tab. Detailed log coming soon.",
        "offers.activity.events.unknown.title": "Activity",
        "offers.activity.events.offer_created.title": "Offer created",
        "offers.activity.events.offer_created.title_template": "Offer created from template",
        "offers.activity.events.offer_created.description": "The offer was created.",
        "offers.activity.events.offer_created.description_template": "Template: {{title}}",
        "offers.activity.events.revision_created.title": "Revision {{revision_number}} created",
        "offers.activity.events.revision_created.description": "Revision {{revision_number}} was created.",
        "offers.activity.events.revision_created.description_based": "Based on Revision {{based_on}}. {{lines}} lines recorded.",
        "offers.activity.events.revision_approved.title": "Revision {{revision_number}} approved",
        "offers.activity.events.revision_approved.title_named": "Revision {{number}} approved",
        "offers.activity.events.revision_approved.description": "Revision {{revision_number}} was approved internally.",
        "offers.activity.events.revision_approved.description_empty": "Approved without comments.",
        "offers.activity.events.revision_rejected.title": "Revision {{revision_number}} rejected",
        "offers.activity.events.revision_rejected.description": "Revision {{revision_number}} was rejected.",
        "offers.activity.events.revision_rejected.description_with_note": "Revision {{revision_number}} was rejected: {{note}}",
        "offers.activity.events.revision_sent.title": "Revision {{revision_number}} sent",
        "offers.activity.events.revision_sent.description": "Revision {{revision_number}} was sent to the customer.",
        "offers.activity.events.revision_submitted_for_review.title": "Revision {{revision_number}} submitted for review",
        "offers.activity.events.revision_submitted_for_review.title_named": "Revision {{number}} submitted for review",
        "offers.activity.events.revision_submitted_for_review.description": "Revision {{revision_number}} was submitted for internal review.",
        "offers.activity.events.revision_accepted.title": "Revision {{revision_number}} accepted",
        "offers.activity.events.revision_accepted.description": "The customer accepted revision {{revision_number}}.",
        "offers.activity.events.calc_version_created.title": "Calculation version created",
        "offers.activity.events.calc_version_created.title_named": "{{title}} updated",
        "offers.activity.events.calc_version_created.description": "A new calculation version was saved.",
        "offers.activity.events.calc_version_created.description_bump": "Version v{{from}} → v{{to}}.",
        "offers.activity.events.import_applied.title": "Quantity list imported",
        "offers.activity.events.import_applied.title_file": "Quantity list imported ({{filename}})",
        "offers.activity.events.import_applied.description": "An import was applied to the calculation.",
        "offers.activity.events.import_applied.description_stats": "{{applied}} lines imported. {{matched}} of {{rows}} matched to the product catalog.",
        "offers.activity.events.lines_changed.title": "Offer lines updated",
        "offers.activity.events.lines_changed.description": "{{created_count}} added, {{updated_count}} changed, {{deleted_count}} deleted.",
        "offers.activity.events.lines_generated.title": "Lines generated from calculation",
        "offers.activity.events.lines_generated.description": "Customer lines were generated from the calculation.",
        "offers.activity.events.groups_changed.title": "Groups updated",
        "offers.activity.events.groups_changed.description": "Trade/group hierarchy was changed.",
        "offers.activity.events.currency_changed.title": "Currency changed ({{from}} → {{to}})",
        "offers.activity.events.currency_changed.description": "Currency changed from {{from}} to {{to}}.",
        "offers.activity.events.document_structure_changed.title": "Document structure changed",
        "offers.activity.events.document_structure_changed.description": "The offer document structure was updated.",
        "offers.activity.events.template_loaded.title": "Template loaded",
        "offers.activity.events.template_loaded.description": "Template: {{template_title}}",
        "offers.activity.events.calculation_lines_changed.title": "Calculation lines changed",
        "offers.activity.events.calculation_lines_changed.description": "Lines in the calculation were updated.",
        "offers.edit.currency_option.NOK": "NOK — Norwegian kroner",
        "offers.edit.currency_option.SEK": "SEK — Swedish kronor",
        "offers.edit.currency_option.DKK": "DKK — Danish kroner",
        "offers.edit.currency_option.EUR": "EUR — Euro",
        "offers.edit.currency_option.USD": "USD — US dollars",
        "offers.edit.currency_coming_soon": "coming soon",
        "offers.edit.currency_hint": "Only NOK can be selected for now.",
        "offers.help.open": "Help",
        "offers.help.eyebrow": "Offer module",
        "offers.help.title": "How offers work",
        "offers.help.intro": "An offer has several tabs with different roles. Here is a short overview — see the docs for details.",
        "offers.help.calc_vs_lines_title": "Calculation vs offer lines",
        "offers.help.calc_vs_lines_body": "The calculation is the internal cost/sales breakdown (manual, hours, products, nested calcs). Offer lines are what the customer sees — often generated from the calculation, with per-line visibility.",
        "offers.help.doc_vs_attachments_title": "Document vs attachments",
        "offers.help.doc_vs_attachments_body": "Document is the offer document itself (structure, cover, sections). Attachments are extra files that accompany the offer.",
        "offers.help.revisions_title": "Revisions, approval and history",
        "offers.help.revisions_body": "Revisions handle drafts, PDF and diff. Approval is internal approve/reject and customer acceptance. History is the timeline of what happened.",
        "offers.help.grouping_title": "Grouping and numbering",
        "offers.help.grouping_body": "Groups can have a trade/discipline and hierarchical numbers (e.g. Ventilation 1.0, Aggregates 1.1). Create and rename under Offer lines.",
        "offers.help.link_module": "Module docs",
        "offers.help.link_screens": "Screen specification",
        "offers.help.link_calculations": "Calculation docs",
        "offers.help.link_document": "Document structure",
        "offers.groups.discipline": "Trade/discipline",
        "offers.groups.save_failed": "Could not save groups.",
        "offers.groups.saved": "Groups saved.",
        "offers.groups.prompt_child_title": "Child group title",
        "offers.groups.prompt_top_title": "Group title (e.g. Ventilation)",
        "offers.groups.add_top": "New group",
        "offers.groups.add_child": "New child group",
        "offers.groups.rename": "Rename",
        "offers.groups.edit": "Edit group",
        "offers.groups.delete": "Delete group",
        "offers.groups.delete_confirm": "Delete structure group “{{title}}”? Lines in the group stay, but become ungrouped.",
        "offers.groups.delete_confirm_with_children": "Delete “{{title}}” and {{count}} subgroup(s)? Lines stay but become ungrouped.",
        "offers.groups.edit_hint": "Double-click or use the pencil to edit",
        "offers.groups.dialog_title_create": "New structure group",
        "offers.groups.dialog_title_edit": "Edit structure group",
        "offers.groups.field_title": "Title",
        "offers.groups.field_description": "Description",
        "offers.groups.field_discipline": "Discipline",
        "offers.groups.field_parent": "Choose a parent group. Empty = top level.",
        "offers.groups.field_number": "Number",
        "offers.groups.field_group_type": "Group type",
        "offers.groups.group_type_default": "Not set",
        "offers.groups.group_type_discipline": "Discipline",
        "offers.groups.group_type_section": "Section",
        "offers.groups.parent_root": "Top level (root)",
        "offers.groups.move_to": "Move to…",
        "offers.groups.save": "Save",
        "offers.groups.cancel": "Cancel",
        "offers.groups.empty_title": "No groups yet",
        "offers.groups.empty_hint": "Use «New structure» in the line editor or + in the structure panel to create trade groups (1.0, 1.1, …).",
        "offers.groups.title_required": "Title is required.",
        "offers.groups.panel_title": "Trades and groups",
        "offers.groups.panel_hint": "Edit in the Calculation tab structure panel (numbers 1.0, 1.1, …).",
        "offers.groups.saving": "Saving…",
        "offers.groups.save_rename": "Save",
        "offers.groups.selected": "Selected group",
        "offers.groups.select_hint": "Select a group in the tree, or add a new one.",
        "offers.groups.untitled": "Untitled",
        "offers.groups.rename_hint": "Double-click to rename",
        "offers.groups.ungrouped": "Ungrouped",
        "offers.groups.move_line": "Move to group",
        "offers.groups.folder_aria": "Folder {{name}}",
        "offers.help.open_short": "Help",
        "offers.activity.events.lines_generated.title_count": "{{count}} lines generated from calculation",
        "offers.activity.events.lines_generated_from_calculation.title": "Lines generated from calculation",
        "offers.activity.events.lines_generated_from_calculation.description": "Customer-facing offer lines were generated from the calculation.",
        "offers.activity.events.offer_accepted.title": "Offer accepted",
        "offers.activity.events.offer_accepted.description": "The offer was accepted.",
        "offers.activity.events.template_loaded.title_named": "Template loaded: {{title}}",
        "offers.tabs.lines_coming_title": "Offer lines coming soon",
        "offers.tabs.lines_coming_desc": "Editing of offer lines will move here in a later update.",
        "offers.tabs.document_coming_title": "Document coming soon",
        "offers.tabs.document_coming_desc": "Cover page and document setup for the offer will move here in a later update.",
        "offers.tabs.lines_intro": "Customer-facing lines, text, calculations and groupings shown on the offer.",
        "offers.tabs.lines_customer_hint": "Customer view — generated from the calculation. Internal prices and detail are hidden.",
        "offers.tabs.lines_customer_hint_public": "Customer view — generated from the calculation. Internal prices and detail are hidden.",
        "offers.tabs.lines_view.label": "View options",
        "offers.tabs.lines_view.hint": "View options control how lines are grouped for the customer/PDF. Each line’s inclusion (included/optional/hidden) decides whether the customer sees it.",
        "offers.tabs.lines_view.per_calc": "Per calculation",
        "offers.tabs.lines_view.kapittel": "Chapters",
        "offers.tabs.lines_view.flat": "Flat list",
        "offers.tabs.lines_view.kundegrupper": "Customer groups only",
        "offers.tabs.lines_view.ungrouped": "Ungrouped",
        "offers.tabs.generate_from_calculation": "Generate from calculation",
        "offers.tabs.generate_from_calculation_success": "Offer lines generated from calculation.",
        "offers.tabs.generate_from_calculation_failed": "Could not generate offer lines from calculation.",
        "offers.tabs.generate_from_calculation_empty": "No calculation to generate from. Add a calculation first.",
        "offers.tabs.columns.chapter": "Chapter / description",
        "offers.tabs.columns.qty": "Qty",
        "offers.tabs.columns.unit": "Unit",
        "offers.tabs.columns.unit_price": "Unit price",
        "offers.tabs.columns.line_sum": "Line total",
        "offers.tabs.columns.visible": "Visible",
        "offers.tabs.lines_empty_title": "No customer lines yet",
        "offers.tabs.lines_empty_desc": "Build the offer in the calculation. Customer view is generated automatically — manual editing is under Advanced.",
        "offers.printLinesPreview.toggle": "Print preview",
        "offers.printLinesPreview.edit_mode": "Edit",
        "offers.printLinesPreview.empty": "No lines visible to the customer",
        "offers.printLinesPreview.empty_no_lines": "No offer lines yet",
        "offers.printLinesPreview.empty_all_hidden": "All lines are hidden from the customer",
        "offers.printLinesPreview.empty_hint": "Add lines, or generate from the calculation. Set inclusion to “Included” for them to appear here.",
        "offers.printLinesPreview.empty_hidden_hint": "{{count}} line(s) are hidden. Change inclusion under Edit to show them to the customer.",
        "offers.printLinesPreview.total": "Total excl. VAT",
        "offers.printLinesPreview.mode_hint": "How lines appear on the PDF/print (customer view).",
        "offers.printLinesPreview.mode_hint_document": "Print is the designed document on the left — the same PDF the customer receives. The line table is the price-section content.",
        "offers.tabs.calculation_use_template": "From template",
        "offers.tabs.calculation_new": "New calculation",
        "offers.tabs.calculation_empty": "No calculations yet",
        "offers.tabs.calculation_empty_hint": "Calculations are optional. Continue with offer lines without one, or add a calculation if you need it.",
        "offers.tabs.calculation_page_title": "Calculation",
        "offers.tabs.calculation_creating": "Creating calculation…",
        "offers.tabs.calculation_added": "Calculation added to the offer",
        "offers.tabs.calculation_load_failed": "Could not load calculation",
        "offers.tabs.calculation_save_failed": "Could not save the calculation. The change has not been saved yet.",
        "offers.tabs.calculation_conflict": "The calculation was changed in another tab or by another user. Deleted rows stay filtered locally — reload before saving again.",
        "offers.tabs.calculation_conflict_resolve_hint": "Autosave is paused. Choose “Use mine” to save your local edits on top of the server version, or “Use latest saved version” to discard local edits.",
        "offers.tabs.calculation_conflict_use_mine": "Use mine",
        "offers.tabs.calculation_conflict_blocked": "Resolve the conflict before saving or sending.",
        "offers.tabs.calculation_conflict_server_unavailable": "Could not load the latest saved version. Try “Use latest saved version” again, or “Use mine”.",
        "offers.tabs.calculation_locked_title": "Calculation is read-only",
        "offers.tabs.calculation_locked_hint": "The offer was approved by a reviewer and is locked. Create a new revision under Approval to edit further.",
        "offers.tabs.calculation_locked_save": "Could not save — the offer is locked. Create a new revision to edit the calculation.",
        "offers.tabs.calculation_locked_empty": "No calculation to show. Create a new revision to build a calculation.",
        "offers.tabs.calculation_removed": "Calculation removed",
        "offers.tabs.calculation_remove": "Remove",
        "offers.tabs.calculation_remove_confirm": "Are you sure you want to remove this calculation from the offer?",
        "offers.tabs.calculation_select_title": "Select calculation",
        "offers.tabs.calculation_select_template_title": "Select calculation template",
        "offers.tabs.calculation_select_template_as_line": "Select calculation template as a line",
        "offers.tabs.calculation_select_template_replace": "Load calculation template into the page",
        "offers.tabs.calculation_select_template_attach": "Attach calculation template to a line",
        "offers.tabs.calculation_replace_template_confirm": "Replace the calculation page content with the selected template? Existing lines will be replaced.",
        "offers.tabs.calculation_template_loaded": "Calculation template loaded",
        "offers.tabs.calculation_line_added": "Calculation template added as a line",
        "offers.tabs.calculation_untitled": "Calculation {{n}}",
        "offers.menu.save_as": "Save as new offer",
        "offers.menu.overwrite": "Overwrite existing offer",
        "offers.menu.save_as_template": "Save as offer template",
        "offers.menu.save_to_template": "Update offer template…",
        "offers.menu.template_versions": "Version history (template)",
        "offers.save_as.title": "Save as new offer",
        "offers.save_as.description": "Create a copy of this offer as a new, independent offer.",
        "offers.save_as.reference_label": "Reference (optional)",
        "offers.save_as.reference_placeholder": "e.g. title of the new offer",
        "offers.save_as.customer_label": "Customer (optional)",
        "offers.save_as.project_label": "Project (optional)",
        "offers.save_as.confirm": "Save as new offer",
        "offers.save_as.success": "Offer saved as a new offer",
        "offers.save_as.failed": "Could not save as new offer",
        "offers.overwrite.title": "Overwrite existing offer",
        "offers.overwrite.warning": "This overwrites the content of the selected offer with the content of this offer. This cannot be undone.",
        "offers.overwrite.search_placeholder": "Search for offers …",
        "offers.overwrite.no_results": "No offers found",
        "offers.overwrite.confirm_label": "Type \"{{number}}\" to confirm",
        "offers.overwrite.confirm": "Overwrite offer",
        "offers.overwrite.success": "Offer {{number}} was overwritten",
        "offers.overwrite.failed": "Could not overwrite the offer",
        "offers.save_as_template.title": "Save as offer template",
        "offers.save_as_template.description": "Save the content of this offer as a new offer template for future offers.",
        "offers.save_as_template.reference_label": "Reference (optional)",
        "offers.save_as_template.reference_placeholder": "Name of the template",
        "offers.save_as_template.change_note_label": "Version note (optional)",
        "offers.save_as_template.confirm": "Save as template",
        "offers.save_as_template.success": "Offer saved as an offer template",
        "offers.save_as_template.failed": "Could not save the offer as a template",
        "offers.save_to_template.title": "Update offer template",
        "offers.save_to_template.description": "Pick an existing offer template to update with the content of this offer.",
        "offers.save_to_template.search_placeholder": "Search for offer templates …",
        "offers.save_to_template.no_results": "No offer templates found",
        "offers.save_to_template.change_note_label": "Version note (optional)",
        "offers.save_to_template.confirm": "Update template",
        "offers.save_to_template.success": "Offer template updated",
        "offers.save_to_template.failed": "Could not update the offer template",
        "offers.versions.title": "Version history",
        "offers.versions.template_title": "Version history (template)",
        "offers.versions.load_failed": "Could not load version history",
        "offers.versions.unavailable": "Version history isn't available yet.",
        "offers.versions.empty": "No versions recorded yet",
        "offers.versions.empty_hint": "Versions are created automatically when changes are saved.",
        "offers.versions.restore": "Restore",
        "offers.versions.confirm_restore": "Confirm restore",
        "offers.versions.restore_success": "Version restored",
        "offers.versions.restore_failed": "Could not restore the version",
        "offers.versions.version_number": "Version {{number}}",
        "offers.versions.by": "By {{name}}",
        "offers.templates.versions.title": "Offer template version history",
        "offers.calculation.versions.title": "Version history",
        "offers.calculation.template_actions.menu_label": "Template",
        "offers.calculation.template_actions.versions": "Template versions",
        "offers.calculation.template_actions.versions_title": "Template versions",
        "offers.calculation.template_actions.update_template": "Update template",
        "offers.calculation.template_actions.update_description": "Update the calculation template with the content of this offer-specific calculation. This applies to all future uses of the template.",
        "offers.calculation.template_actions.update_confirm": "Update template",
        "offers.calculation.template_actions.update_success": "Calculation template updated",
        "offers.calculation.template_actions.update_failed": "Could not update the calculation template",
        "offers.calculation.template_actions.save_new_template": "Save as new template",
        "offers.calculation.template_actions.save_new_description": "Save this calculation as a brand-new calculation template.",
        "offers.calculation.template_actions.save_new_confirm": "Save as new template",
        "offers.calculation.template_actions.save_new_success": "Calculation saved as a new template",
        "offers.calculation.template_actions.save_new_failed": "Could not save the calculation as a new template",
        "offers.calculation.template_actions.title_label": "New template name",
        "offers.calculation.template_actions.title_placeholder": "e.g. Standard electrical work",
        "offers.calculation.template_actions.title_required": "Please enter a name for the new template",
        "offers.calculation.template_actions.change_note_label": "Version note (optional)",
        "offers.calculation.template_actions.change_note_placeholder": "What changed?",
        "offers.calculation.selector.title": "Select calculation template",
        "offers.calculation.selector.title_multiple": "Select calculation templates",
        "offers.calculation.selector.search_placeholder": "Search calculation templates…",
        "offers.calculation.selector.loading": "Loading calculation templates…",
        "offers.calculation.selector.error": "Could not load calculation templates",
        "offers.calculation.selector.empty": "No calculation templates yet",
        "offers.calculation.selector.empty_hint": "Company templates are created under Offers → Calculations, or by saving the calculation you are working on as a template.",
        "offers.calculation.selector.empty_search": "No templates match the search",
        "offers.calculation.selector.create_template": "Create template",
        "offers.calculation.selector.load_more": "Load more templates",
        "offers.calculation.selector.selected_count": "{{count}} selected",
        "offers.calculation.selector.clear": "Clear selection",
        "offers.calculation.selector.close": "Close",
        "offers.calculation.selector.total": "Total",
        "offers.calculation.selector.type": "Type",
        "offers.calculation.selector.untitled": "Calculation #{{id}}",
        "offers.calculation.nested.edit_title": "Edit calculation: {{title}}",
        "offers.calculation.nested.eyebrow": "Edit calculation",
        "offers.calculation.nested.offer_only_hint": "Changes apply only to this offer. The company template is not updated.",
        "offers.calculation.nested.save": "Save",
        "offers.calculation.nested.save_success": "Calculation saved for this offer",
        "offers.calculation.nested.tab_products": "Products & fields",
        "offers.calculation.nested.tab_notes": "Notes",
        "offers.calculation.nested.tab_display": "Display",
        "offers.calculation.nested.tab_builder": "Module builder",
        "offers.calculation.nested.products_panel_hint": "Link lines to catalog products and refresh prices. This is the main surface for day-to-day nested calculation work.",
        "offers.calculation.nested.no_product_catalogs": "No product-list nodes in this module yet. Add “Product list” in the module builder.",
        "offers.calculation.nested.unit_total_label": "Unit total (module)",
        "offers.calculation.nested.unit_total_hint": "Offer line total = quantity × this unit total.",
        "offers.calculation.nested.notes_heading": "Module notes",
        "offers.calculation.nested.notes_panel_hint": "Edit module notes and choose what appears on the offer/PDF. Order here controls order in the offer text.",
        "offers.calculation.nested.notes_offer_text_hint": "Optional customer text for the whole module (shown on the offer when filled in).",
        "offers.calculation.nested.notes_empty": "No note nodes in this module yet. Add “Note” in the module builder.",
        "offers.calculation.nested.notes_item_label": "Note {{n}}",
        "offers.calculation.nested.notes_body_placeholder": "Write the note…",
        "offers.calculation.nested.notes_show_in_offer_hint": "Checked = the text becomes customer copy on the offer/PDF. Visible by default.",
        "offers.calculation.nested.tab_lines": "Lines",
        "offers.calculation.nested.display.panel_hint": "Control how this calculation, nested modules/lines, and products appear for the customer and in the PDF. Edit content and prices in the other tabs.",
        "offers.calculation.nested.display.structure_heading": "Customer structure",
        "offers.calculation.nested.display.structure_hint": "Choose whether the customer sees child lines, sum only, or the node is hidden. Saved in the offer presentation rules.",
        "offers.calculation.nested.display.structure_needs_offer": "Structure rules require the calculation to be linked to an offer.",
        "offers.calculation.nested.display.show_product_info_hint": "Applies to the whole offer when children are shown. Off = title/price only, without product description.",
        "offers.calculation.nested.display.content_heading": "Offer/PDF content",
        "offers.calculation.nested.display.content_hint": "Existing calculation show_* fields for this calculation.",
        "offers.calculation.nested.display.show_hours": "Show hours",
        "offers.calculation.nested.display.show_hours_hint": "Show hours for this calculation on the offer/PDF.",
        "offers.calculation.nested.display.show_quantities": "Show quantities",
        "offers.calculation.nested.display.show_quantities_hint": "Show quantities for lines under this calculation.",
        "offers.calculation.nested.display.show_products": "Show products",
        "offers.calculation.nested.display.show_products_hint": "Show product lines on the offer/PDF.",
        "offers.calculation.nested.display.show_setup_only": "Setup only (title/sum)",
        "offers.calculation.nested.display.show_setup_only_hint": "When on: only title, description and subtotal — not products or hour breakdown.",
        "offers.calculation.nested.display.show_quantities_offer_item": "Quantity on offer line only",
        "offers.calculation.nested.display.show_quantities_offer_item_hint": "Hide quantities on nested products; show quantity on the offer line.",
        "offers.calculation.nested.display.include_product_short": "Include short product description",
        "offers.calculation.nested.display.include_product_short_hint": "Show the product short_description when image/URL is shown.",
        "offers.calculation.nested.display.products_heading": "Product lines",
        "offers.calculation.nested.display.products_hint": "Per-line visibility (image, URL, hours) stored on the line.",
        "offers.calculation.nested.display.product_line_fallback": "Product line {{n}}",
        "offers.calculation.nested.display.line_show_hours": "Show hours on the line",
        "offers.calculation.nested.display.notes_heading": "Note visibility",
        "offers.calculation.nested.display.notes_hint": "Same show_in_offer as under Notes — visibility only here, not note content.",
        "offers.calculation.nested.this_calculation": "This calculation",
        "offers.calculation.nested.structure_heading": "Calculation structure",
        "offers.calculation.nested.structure_hint": "Nested calculation templates under this line. Open to edit recommended fields and structure at each level.",
        "offers.calculation.nested.edit_structure": "Edit",
        "offers.calculation.nested.back_in_tree": "Back",
        "offer.calculation.line.insert_title": "Recommended fields",
        "offer.calculation.line.insert_hint": "Fields the template leaves open to edit. Open the calculation dialog for products and prices.",
        "offer.calculation.line.insert_locked": "All fields are locked in the template. Open the module builder to edit.",
        "offer.calculation.line.open_builder": "Open calculation",
        "offer.calculation.line.products_in_builder": "Products are edited under Products & fields.",
        "offer.calculation.line.products_jump": "Go to product list",
        "offer.calculation.line.insert_needs_attention": "Recommended fields have not been reviewed yet",
        "offer.calculation.line.insert_done": "Done",
        "offer.calculation.line.qty_times_unit": "Qty × unit price: {{formula}}",
        "offer.calculation.line.module_notes_count": "{{count}} note in module",
        "offer.calculation.line.module_notes_count_plural": "{{count}} notes in module",
        "offers.calculation.save_template_dialog.title": "Save calculation template?",
        "offers.calculation.save_template_dialog.description": "You're editing a calculation template from an offer. Do you want to update the template too, or only save the changes for this offer?",
        "offers.calculation.save_template_dialog.update_template": "Update template",
        "offers.calculation.save_template_dialog.update_template_hint": "Changes will apply to all future uses of this template.",
        "offers.calculation.save_template_dialog.offer_only": "Only for this offer",
        "offers.calculation.save_template_dialog.offer_only_hint": "Changes are saved only for this offer. The template stays unchanged.",
        "offers.calculation.save_template_dialog.save_failed": "Could not save the calculation",
        "offers.tabs.document_intro": "The outgoing offer document — structure and preview for send and PDF. This is not a generic file list.",
        "offers.documentBuilder.structure_title": "Document structure",
        "offers.documentBuilder.add_block": "+ Add block",
        "offers.documentBuilder.move_up": "Move up",
        "offers.documentBuilder.move_down": "Move down",
        "offers.documentBuilder.saving": "Saving…",
        "offers.documentBuilder.saved": "Saved",
        "offers.documentBuilder.blocks.cover": "Cover",
        "offers.documentBuilder.blocks.letter": "Cover letter",
        "offers.documentBuilder.blocks.project_description": "Project description",
        "offers.documentBuilder.blocks.scope": "Scope of delivery",
        "offers.documentBuilder.blocks.price": "Price",
        "offers.documentBuilder.blocks.alternatives": "Alternatives",
        "offers.documentBuilder.blocks.attachments": "Attachments",
        "offers.documentBuilder.blocks.signature": "Signature",
        "offers.documentBuilder.blocks.custom_text": "Custom text",
        "offers.documentBuilder.preview.label": "Preview",
        "offers.documentBuilder.preview.title_prefix": "Offer:",
        "offers.documentBuilder.preview.untitled": "Untitled",
        "offers.documentBuilder.preview.rev": "Rev. {{rev}}",
        "offers.documentBuilder.preview.price_label": "Offer total excl. VAT",
        "offers.documentBuilder.preview.attachments_placeholder": "Attachments are listed in the final document. Upload files under the Attachments tab.",
        "offers.documentBuilder.preview.empty_section": "No text yet",
        "offers.documentBuilder.preview.alternatives_hint": "Alternatives and optional extras are not included in the offer total unless selected.",
        "offers.documentBuilder.preview.alternative_selected": "Selected in offer",
        "offers.documentBuilder.preview.alternative_option": "Alternative",
        "offers.documentBuilder.preview.optional_extras": "Optional extras",
        "offers.documentBuilder.editor.title_label": "Title",
        "offers.documentBuilder.editor.body_label": "Text",
        "offers.documentBuilder.editor.body_placeholder": "Write content for this section…",
        "offers.documentBuilder.editor.title_placeholder": "Block title",
        "offers.documentBuilder.editor.custom_section": "Custom text block",
        "offers.documentBuilder.editor.price_hint": "Price is taken live from the offer total (excl. VAT) and cannot be edited here.",
        "offers.documentBuilder.editor.attachments_hint": "This block is a section in the document structure. Files are managed under the Attachments tab.",
        "offers.documentBuilder.editor.offer_edit_sourced_hint": "This text is edited under “Edit offer → Project description”.",
        "offers.documentBuilder.editor.alternatives_hint": "Alternatives are pulled automatically from lines with an alternative group or «optional» role. You can add intro text under Advanced layout if needed.",
        "offers.documentBuilder.preview.page_break": "Page break",
        "offers.documentBuilder.preview.refresh": "Update preview",
        "offers.documentBuilder.preview.showing_saved": "Showing saved version",
        "offers.documentBuilder.preview.loading": "Loading preview…",
        "offers.documentBuilder.preview.pdf_failed": "Could not load PDF preview",
        "offers.documentBuilder.preview.empty_live": "No PDF to show yet. Update the preview when the document is saved.",
        "offers.documentBuilder.preview.show_html_mock": "Show HTML sketch",
        "offers.documentBuilder.preview.show_live_pdf": "Show live PDF",
        "offers.documentBuilder.editor.inspector_title": "Block settings",
        "offers.documentBuilder.editor.inspector_subtitle": "{{type}} — content and settings for this section",
        "offers.documentBuilder.editor.settings_title": "Settings",
        "offers.documentBuilder.editor.enabled_label": "Enabled",
        "offers.documentBuilder.editor.enabled_hint": "Show this section in the document",
        "offers.documentBuilder.editor.show_in_pdf_label": "Show in PDF",
        "offers.documentBuilder.editor.show_in_pdf_hint": "Include the section when the offer is exported to PDF",
        "offers.documentBuilder.editor.page_break_label": "Page break before",
        "offers.documentBuilder.editor.page_break_hint": "Start this section on a new page in the PDF",
        "offers.documentBuilder.editor.heading_level_label": "Heading level",
        "offers.documentBuilder.editor.heading_level_none": "None",
        "offers.documentBuilder.editor.visibility_label": "Visibility",
        "offers.documentBuilder.editor.visibility_all": "Everywhere",
        "offers.documentBuilder.editor.visibility_pdf_only": "PDF only",
        "offers.documentBuilder.editor.visibility_screen_only": "Screen only",
        "offers.documentBuilder.editor.advanced_layout": "Advanced layout",
        "offers.documentBuilder.editor.padding_label": "Padding",
        "offers.documentBuilder.editor.margin_label": "Margin",
        "offers.documentBuilder.editor.side_top": "Top",
        "offers.documentBuilder.editor.side_right": "Right",
        "offers.documentBuilder.editor.side_bottom": "Bottom",
        "offers.documentBuilder.editor.side_left": "Left",
        "offers.documentBuilder.editor.load_template": "Load Promang template",
        "offers.documentBuilder.editor.cover.settings_title": "Cover settings",
        "offers.documentBuilder.editor.cover.subtitle_label": "Subtitle",
        "offers.documentBuilder.editor.cover.subtitle_placeholder": "Write a subtitle for the cover…",
        "offers.documentBuilder.editor.cover.show_customer_label": "Show customer",
        "offers.documentBuilder.editor.cover.show_offer_date_label": "Show offer date",
        "offers.documentBuilder.editor.cover.image_hint": "The cover image is set in the Cover section below and is reused automatically for this block.",
        "offers.documentBuilder.editor.letter.settings_title": "Letter settings",
        "offers.documentBuilder.editor.letter.greeting_label": "Greeting",
        "offers.documentBuilder.editor.letter.greeting_placeholder": "E.g. \"Hi,\"",
        "offers.documentBuilder.editor.letter.signoff_label": "Sign-off",
        "offers.documentBuilder.editor.letter.signoff_placeholder": "E.g. \"Best regards\"",
        "offers.documentBuilder.editor.price.settings_title": "Price settings",
        "offers.documentBuilder.editor.price.show_vat_label": "Show VAT",
        "offers.documentBuilder.editor.price.show_summary_table_label": "Show summary table",
        "offers.documentBuilder.editor.price.note_label": "Note",
        "offers.documentBuilder.editor.price.note_placeholder": "Optional note under the price…",
        "offers.documentBuilder.editor.signature.settings_title": "Signature settings",
        "offers.documentBuilder.editor.signature.show_date_field_label": "Show date field",
        "offers.documentBuilder.editor.signature.show_title_field_label": "Show job title field",
        "offers.documentBuilder.editor.signature.signatory_count_label": "Number of signatories",
        "offers.tabs.attachments_intro": "Generic attachments and documentation for this offer (Promang DocumentManager). Upload files here.",
        "offers.tabs.save_lines": "Save lines",
        "offers.tabs.no_offer": "The offer must be saved before you can edit this.",
        "offers.edit.title": "Edit offer",
        "offers.edit.tab.stamdata": "Master data",
        "offers.edit.tab.comments": "Comments",
        "offers.edit.tab.project_description": "Project description",
        "offers.edit.customer": "Customer",
        "offers.edit.customer_required": "Customer is required",
        "offers.edit.contact": "Customer contact",
        "offers.edit.project": "Project",
        "offers.edit.department": "Department",
        "offers.edit.responsible": "Our contact person",
        "offers.edit.currency": "Currency",
        "offers.edit.offer_title": "Title",
        "offers.edit.offer_number": "Offer number",
        "offers.edit.reference": "Reference",
        "offers.edit.offer_date": "Offer date",
        "offers.edit.valid_from": "Valid from",
        "offers.edit.valid_to": "Valid until",
        "offers.edit.comment": "Comment",
        "offers.edit.comment_hint": "Used in the simple PDF layout.",
        "offers.edit.comment_placeholder": "Write a comment for the offer…",
        "offers.edit.project_description": "Project description",
        "offers.edit.project_description_hint": "Shown in the document layout and print.",
        "offers.edit.project_description_placeholder": "Describe the project…",
        "offers.edit.scope": "Scope / Delivery scope",
        "offers.edit.scope_hint": "Shown in the document layout and print.",
        "offers.edit.scope_placeholder": "Describe the scope and delivery…",
        "offers.edit.cancel": "Cancel",
        "offers.edit.save": "Save",
        "offers.edit.saving": "Saving…",
        "offers.delete.confirm": "This offer will be permanently removed and cannot be undone.",
        "offers.create.title": "Create offer",
        "offers.create.intro": "Enter the master data to start a new offer.",
        "offers.create.customer": "Customer",
        "offers.create.customer_required": "A customer must be selected before the offer can be created.",
        "offers.create.project": "Project",
        "offers.create.contact": "Customer contact",
        "offers.create.responsible": "Our contact person",
        "offers.create.reference": "Reference",
        "offers.create.description": "Description",
        "offers.create.cancel": "Cancel",
        "offers.create.submit": "Create offer",
        "offers.create.creating": "Creating…",
        "offers.create.success": "Offer created.",
        "offers.create.failed": "Could not create the offer.",
        "offers.checklist.title": "Checklist",
        "offers.checklist.intro": "Plan and follow up the items for this offer.",
        "offers.checklist.empty_title": "No checklist has been created",
        "offers.checklist.empty_description": "Create a checklist to ensure the offer is complete before it is sent.",
        "offers.checklist.create": "Create checklist",
        "offers.checklist.created": "Checklist created.",
        "offers.checklist.create_error": "Could not create the checklist.",
        "offers.checklist.load_error": "Could not load the checklist.",
        "offers.checklist.save_error": "Could not save the checklist.",
        "offers.checklist.delete": "Delete checklist",
        "offers.checklist.deleted": "Checklist deleted.",
        "offers.checklist.delete_error": "Could not delete the checklist.",
        "offers.checklist.delete_confirm": "Are you sure you want to delete the checklist?",
        "offers.checklist.unavailable": "Checklist is not available for this offer.",
        "offers.checklist.type_label": "Checklist type",
        "offers.checklist.type_blank": "Empty checklist (no template)",
        "offers.checklist.types_loading": "Loading types…",
        "offers.checklist.type_hint": "Optional: pick a company template to prefill items.",
        "offers.send.checklist_required": "This company requires a checklist before sending. Create one under the Checklist tab.",
        "offers.send.contact_load_failed": "Could not load contact information",
        "offers.send.send_to": "Send to",
        "offers.send.me": "Me",
        "offers.send.customer": "Customer",
        "offers.send.contact": "Contact",
        "offers.send.loading": "Loading…",
        "offers.send.name": "Name",
        "offers.send.email": "Email",
        "offers.send.offer_type": "Offer type",
        "offers.send.internal_offer": "Internal offer",
        "offers.send.customer_offer": "Customer offer",
        "offers.send.open_pdf": "Open selected offer PDF",
        "offers.send.pdf_preview_pending": "PDF preview will be available when the selected offer type is generated.",
        "offers.send.message": "Message to customer",
        "offers.send.close": "Close",
        "offers.send.sending": "Sending…",
        "offers.send.submit": "Send",
        "offers.workspace.save_idle": "No unsaved changes",
        "offers.workspace.conflict_resolve": "Choose a value for each field before merging",
        "offers.documentAi.attachments_title": "Attachments",
        "offers.documentAi.attachments_intro": "Upload and manage documents related to this offer.",
        "offers.attachments.dropzone_title": "Drag and drop files here, or click to choose",
        "offers.attachments.dropzone_hint": "PDF, images, Word, Excel and more",
        "offers.attachments.drop_here": "Drop files here",
        "offers.documentAi.title": "Document review",
        "offers.documentAi.intro": "Analyze an attachment or paste text. Suggestions must be approved before they are added.",
        "offers.documentAi.document": "Select attachment",
        "offers.documentAi.select_document": "Select document",
        "offers.documentAi.paste_text": "Or paste text",
        "offers.documentAi.source_required": "Select an attachment or paste text first.",
        "offers.documentAi.analyze": "Analyze document",
        "offers.documentAi.analyzing": "Analyzing…",
        "offers.documentAi.failed": "Could not analyze the document.",
        "offers.documentAi.summary": "Summary",
        "offers.documentAi.gaps": "Missing information",
        "offers.documentAi.suggested_lines": "Suggested lines",
        "offers.documentAi.checklist_hints": "Checklist suggestions",
        "offers.documentAi.copy": "Copy selected",
        "offers.documentAi.copied": "Selected lines were copied.",
        "offers.documentAi.copy_failed": "Could not copy the selected lines.",
        "offers.documentAi.apply_notes": "Add to comment",
        "offers.documentAi.applied": "Selected lines were added to the comment.",
        "offers.documentAi.apply_failed": "Could not add the selected lines.",
        "offer.calculation.totals.summary_title": "Totals (from server)",
        "offer.calculation.totals.sales_total": "Sales total",
        "offer.calculation.totals.cost_total": "Cost total",
        "offer.calculation.totals.contribution_margin": "Contribution margin",
        "offer.calculation.totals.contribution_margin_percent": "Contribution margin %",
        "offer.calculation.totals.authoritative_hint": "Server-calculated",
        "offer.calculation.totals.estimate_hint": "Estimate",
        "offer.calculation.line.total": "Line total",
        "offer.calculation.line.cost_total": "Line cost",
        "offer.calculation.line.price_source": "Price source",
        "offer.calculation.line.price_dated_at": "Price date",
        "offer.calculation.import.title": "Import quantities (CSV/Excel)",
        "offer.calculation.import.subtitle": "Upload CSV or Excel, review chapter, product match, suggested price/hours, then add lines. Nothing is written until you apply.",
        "offer.calculation.import.upload": "Upload",
        "offer.calculation.import.apply": "Add to calculation",
        "offer.calculation.import.file_required": "Choose a CSV or Excel file first.",
        "offer.calculation.import.failed": "Could not complete the import.",
        "offer.calculation.import.upload_success": "File uploaded and matched.",
        "offer.calculation.import.apply_success": "{{count}} lines were added to the calculation.",
        "offer.calculation.import.job_status": "Status",
        "offer.calculation.import.confirm": "Confirm match",
        "offer.calculation.import.skip": "Skip",
        "offer.calculation.import.col.confirm": "Confirm",
        "offer.calculation.import.col.sheet": "Sheet",
        "offer.calculation.import.col.chapter": "Chapter",
        "offer.calculation.import.col.sku": "Item no.",
        "offer.calculation.import.col.name": "Description",
        "offer.calculation.import.col.qty": "Quantity",
        "offer.calculation.import.col.price": "Suggested price",
        "offer.calculation.import.col.discount": "Discount",
        "offer.calculation.import.col.surcharge": "Surcharge",
        "offer.calculation.import.col.hours": "Hours",
        "offer.calculation.import.col.match": "Match",
        "offer.calculation.import.col.product": "Product",
        "offer.calculation.import.col.actions": "Actions",
        "offer.calculation.import.counts.confirmed": "Confirmed",
        "offer.calculation.import.counts.suggested": "Suggested",
        "offer.calculation.import.counts.unmatched": "Unmatched",
        "offer.calculation.import.match_status.unmatched": "No match",
        "offer.calculation.import.match_status.suggested": "Suggested",
        "offer.calculation.import.match_status.confirmed": "Confirmed",
        "offer.calculation.import.match_status.skipped": "Skipped",
        "offer.calculation.import.match_status.applied": "Applied",
        "offer.calculation.workspace.title": "Calculation workspace",
        "offer.calculation.workspace.structure_title": "Structure",
        "offer.calculation.workspace.add_structure": "New structure",
        "offer.calculation.workspace.context_title": "Line details",
        "offer.calculation.workspace.properties": "Properties",
        "offer.calculation.workspace.show_structure": "Show structure",
        "offer.calculation.workspace.hide_structure": "Hide structure",
        "offer.calculation.workspace.show_context": "Show context",
        "offer.calculation.workspace.hide_context": "Hide context",
        "offer.calculation.workspace.structure_empty_title": "No lines yet",
        "offer.calculation.workspace.structure_empty_hint": "Add a line in the center pane to build the structure.",
        "offer.calculation.workspace.context_empty_title": "No line selected",
        "offer.calculation.workspace.context_empty_hint": "Select a line in the structure or list to see details here.",
        "offer.calculation.workspace.chapter_properties": "Chapter",
        "offer.calculation.workspace.chapter_subtotal": "Chapter total",
        "offer.calculation.workspace.chapter_lines": "{{count}} line(s) in chapter",
        "offer.calculation.workspace.lines_empty_title": "No lines",
        "offer.calculation.workspace.lines_empty_hint": "Click “New manual line” to add the first row.",
        "offer.calculation.workspace.untitled_line": "Line {{n}}",
        "offer.calculation.workspace.selected_line": "Selected line {{n}}",
        "offer.calculation.workspace.edit_line": "Edit line",
        "offer.calculation.workspace.field.quantity": "Quantity",
        "offer.calculation.workspace.field.hours": "Hours",
        "offer.calculation.workspace.field.cost_unit": "Cost / unit",
        "offer.calculation.workspace.field.markup": "Markup",
        "offer.calculation.workspace.field.sales_unit": "Sales price / unit",
        "offer.calculation.workspace.field.cost": "Cost",
        "offer.calculation.workspace.field.total": "Total",
        "offer.calculation.workspace.field.margin": "Margin rate",
        "offer.calculation.workspace.override_title": "Manual override",
        "offer.calculation.workspace.override_hint": "This line has a manual price override.",
        "offer.calculation.workspace.validation_title": "Validation",
        "offer.calculation.workspace.source": "Source",
        "offer.calculation.workspace.line_type.manual": "Manual",
        "offer.calculation.workspace.line_type.product": "Product",
        "offer.calculation.workspace.line_type.hours": "Hours",
        "offer.calculation.workspace.line_type.calculation": "Calculation",
        "offer.calculation.workspace.line_type.note": "Note",
        "offer.calculation.workspace.line_type.other": "Other",
        "offer.calculation.workspace.col.line": "#",
        "offer.calculation.workspace.col.description": "Description",
        "offer.calculation.workspace.col.type": "Type",
        "offer.calculation.workspace.col.quantity": "Quantity",
        "offer.calculation.workspace.col.unit": "Unit",
        "offer.calculation.workspace.col.cost_price": "Cost price",
        "offer.calculation.workspace.col.sales_price": "Sales price",
        "offer.calculation.workspace.col.line_sum": "Line total",
        "offer.calculation.workspace.col.margin": "Margin %",
        "offer.calculation.workspace.totals_cost": "Cost",
        "offer.calculation.workspace.totals_sales": "Offer total",
        "offer.calculation.workspace.totals_margin": "Contribution margin",
        "offer.calculation.workspace.totals_margin_percent": "Margin rate",
        "offer.calculation.workspace.col.unit_short": "Unit",
        "offer.calculation.workspace.col.hours": "Hours",
        "offer.calculation.workspace.col.cost": "Cost",
        "offer.calculation.workspace.col.markup": "Markup",
        "offer.calculation.workspace.col.total": "Total",
        "offer.calculation.workspace.col.risk": "Risk",
        "offer.calculation.workspace.col.source": "Source",
        "offer.calculation.workspace.columns": "Columns",
        "offer.calculation.workspace.settings": "Display settings",
        "offer.calculation.workspace.settings_aria": "Open display settings for density and columns",
        "offer.calculation.workspace.density": "Density",
        "offer.calculation.workspace.density.compact": "Compact",
        "offer.calculation.workspace.density.comfortable": "Comfortable",
        "offer.calculation.workspace.use_template": "Use calculation template",
        "offer.calculation.workspace.load_page_template": "Load calculation template",
        "offer.calculation.workspace.use_template_stub": "Calculation templates are not available yet.",
        "offer.calculation.nested.blank_title": "New nested calculation",
        "offer.calculation.nested_source.title": "Use calculation template",
        "offer.calculation.nested_source.hint": "Choose whether to create a new nested calculation, or use an existing company template.",
        "offer.calculation.nested_source.new_title": "New",
        "offer.calculation.nested_source.new_hint": "Create an empty nested calculation (calculation inside calculation) that you can edit.",
        "offer.calculation.nested_source.existing_title": "Existing",
        "offer.calculation.nested_source.existing_hint": "Pick a company template and copy it in as a nested calculation. The template is not changed.",
        "offer.calculation.nested_source.cancel": "Cancel",
        "offer.calculation.workspace.save_status.idle": "Ready",
        "offer.calculation.workspace.save_status.pending": "Changes pending…",
        "offer.calculation.workspace.save_status.saved": "All changes saved",
        "offer.calculation.workspace.save_status.saving": "Saving…",
        "offer.calculation.workspace.save_status.error": "Save failed",
        "offer.calculation.workspace.missing_cost_line": "Cost price is missing on this line.",
        "offer.calculation.workspace.missing_cost": "{{count}} line(s) missing cost price",
        "offer.calculation.workspace.totals.material": "Material cost",
        "offer.calculation.workspace.totals.labor": "Labor",
        "offer.calculation.workspace.totals.module": "Module",
        "offer.calculation.workspace.totals.hours_sum": "Total hours",
        "offer.calculation.workspace.totals.total_cost": "Total cost",
        "offer.calculation.workspace.totals.contribution": "Contribution margin",
        "offer.calculation.workspace.totals.margin_rate": "Margin rate",
        "offer.calculation.workspace.totals.offer_ex_vat": "Offer total excl. VAT",
        "offer.calculation.workspace.totals.compact": "Offer total excl. VAT: {{sales}} · CM {{dg}}",
        "offer.calculation.workspace.totals.collapse": "Collapse totals",
        "offer.calculation.workspace.totals.expand": "Expand totals",
        "offer.calculation.summary.title": "Calculation summary",
        "offer.calculation.summary.subtitle": "Authoritative totals from API (BigDecimal)",
        "offer.calculation.summary.hours_total": "Total hours",
        "offer.calculation.summary.hours_by_role": "Hours by role",
        "offer.calculation.summary.material_cost": "Material cost",
        "offer.calculation.summary.labor_cost": "Labor cost",
        "offer.calculation.summary.cost_total": "Total cost",
        "offer.calculation.summary.db": "Contribution margin (DB)",
        "offer.calculation.summary.dg": "Margin rate (DG%)",
        "offer.calculation.summary.sales_total": "Offer total excl. VAT",
        "offer.calculation.summary.info_aria": "How is {{label}} calculated?",
        "offer.calculation.summary.role.montor": "Fitter",
        "offer.calculation.summary.role.montasjeleder": "Installation lead",
        "offer.calculation.summary.role.prosjektleder": "Project manager",
        "offer.calculation.summary.role.prosjektering": "Engineering",
        "offer.calculation.summary.role.innleid": "Hired-in",
        "offer.calculation.summary.role_key_label": "Role",
        "offer.calculation.summary.guide.hours.title": "Total hours",
        "offer.calculation.summary.guide.hours.body": "Sums hours per line (quantity × hours) by role via labor_role or hours_by_role. Backend is authoritative.",
        "offer.calculation.summary.guide.material.title": "Material cost",
        "offer.calculation.summary.guide.material.body": "Cost of product/manual lines (not hours). From API summary.material_cost.",
        "offer.calculation.summary.guide.labor.title": "Labor cost",
        "offer.calculation.summary.guide.labor.body": "Cost of hour lines (line_type hours or lines with hours). From summary.labor_cost.",
        "offer.calculation.summary.guide.cost.title": "Total cost",
        "offer.calculation.summary.guide.cost.body": "Combined cost (material + labor + module). With offer_calculation_v2 uses stored cost_total from Offers::RecalculateCalculation.",
        "offer.calculation.summary.guide.db.title": "Contribution margin (DB)",
        "offer.calculation.summary.guide.db.body": "DB = offer total − cost. Same as contribution_margin from the backend.",
        "offer.calculation.summary.guide.dg.title": "Margin rate (DG%)",
        "offer.calculation.summary.guide.dg.body": "DG% = (DB / offer total) × 100. Zero when offer total is 0.",
        "offer.calculation.summary.guide.sales.title": "Offer total",
        "offer.calculation.summary.guide.sales.body": "Total sales excl. VAT from calculation lines (total_amount / summary.sales_total).",
        "offer.calculation.workspace.display_settings": "Display settings",

        "offer.calculation.workspace.bulk.select_all": "Select all lines",
        "offer.calculation.workspace.bulk.select_row": "Select line",
        "offer.calculation.workspace.bulk.delete_selected": "Delete selected",
        "offer.calculation.workspace.bulk.clear": "Clear selection",
        "offer.calculation.workspace.bulk.delete_confirm": "Are you sure you want to delete {{count}} selected lines?",
        "offer.calculation.line_editor.standard_fields": "Standard fields",
        "offer.calculation.line_editor.quantity": "Quantity",
        "offer.calculation.line_editor.hours_count": "Hours",
        "offer.calculation.line_editor.sales_price_auto": "Sales price (auto)",
        "offer.calculation.line_editor.cost_price_auto": "Cost price (auto)",
        "offer.calculation.line_editor.show_in_offer": "Show in offer",
        "offer.calculation.line_editor.delete_confirm": "Are you sure you want to delete this row?",
        "offer.calculation.line_editor.hour_rate": "Hour rate",
        "offer.calculation.line_editor.cost_hour_rate": "Cost hour rate",
        "offer.calculation.line_editor.select_hour_rate": "Select hour rate",
        "offer.calculation.line_editor.hour_rate_from_catalog": "Loaded from Hour rates (/offers/hour-rates)",
        "offer.calculation.line_editor.no_hour_rates": "No hour rates found.",
        "offer.calculation.line_editor.create_hour_rate": "Create hour rate",
        "offer.calculation.line_editor.hours_section": "Time calculation",
        "offer.calculation.line_editor.hide_hours": "Hide",
        "offer.calculation.line_editor.add_hours": "Add time calculation",
        "offer.calculation.line_editor.hours_pricing_mode": "How should time be calculated?",
        "offer.calculation.line_editor.hours_mode_product_plus_hours": "Time in addition to product price",
        "offer.calculation.line_editor.hours_mode_from_price": "Derive hours from price (informational, not added)",
        "offer.calculation.line_editor.hours_mode_product_plus_hours_hint": "Unit price = product price + hours × hour rate. Line amount = unit × quantity.",
        "offer.calculation.line_editor.auto_calc_hours": "Calculate hours automatically",
        "offer.calculation.line_editor.from_sales_price": "From sales price",
        "offer.calculation.line_editor.from_cost_price": "From cost price",
        "offer.calculation.line_editor.hours_amount": "Hours amount",
        "offer.calculation.line_editor.unit_with_hours": "Unit price with time",
        "offer.calculation.line_editor.hours_focus_hint": "Time only — description, hours and rates",
        "offer.calculation.line_editor.product_focus_hint": "Product, quantity and prices",
        "offer.calculation.line_editor.manual_focus_hint": "Free description and amounts",
        "offer.calculation.line_editor.calculation_focus_hint": "Nested calculation / module",
        "offer.calculation.line_editor.note_focus_hint": "Customer / PDF text only — no quantity or price",
        "offer.calculation.line_editor.note_text": "Note text",
        "offer.calculation.line_editor.select_product": "Select product",
        "offer.calculation.line_editor.unit_hours": "Hour",
        "offer.calculation.line_editor.price_mode": "Price calculation",
        "offer.calculation.line_editor.price_mode_automatic": "Automatic (from hours)",
        "offer.calculation.line_editor.price_mode_custom": "Manual",
        "offer.calculation.line_editor.hours_notes_section": "Notes (calculations / products)",
        "offer.calculation.line_editor.hours_notes_hint": "On hours lines, calculations and products are stored as notes only — they do not affect price or product_id.",
        "offer.calculation.line_editor.add_calc_as_note": "Add calculation as note",
        "offer.calculation.line_editor.add_product_as_note": "Add product as note",
        "offer.calculation.line_editor.calcs_and_products": "Calculations and products",
        "offer.calculation.line_editor.line_n": "Line {{n}}",
        "offer.calculation.line_editor.discount_pct": "Discount %",
        "offer.calculation.line_editor.surcharge_pct": "Markup %",
        "offer.calculation.line_editor.display_options": "Display options",
        "offer.calculation.line_editor.show_product_image_pdf": "Show product image in PDF",
        "offer.calculation.line_editor.show_product_url_pdf": "Show product URL in PDF",
        "offer.calculation.line_editor.add_note": "Add note",
        "offer.calculation.line_editor.edit_note": "Edit note",
        "offer.calculation.line_editor.update_note": "Update",
        "offer.calculation.line_editor.notes_section": "Notes",
        "offer.calculation.line_editor.note_title": "Title",
        "offer.calculation.line_editor.note_title_placeholder": "Note title (optional)",
        "offer.calculation.line_editor.show_note_title": "Show title",
        "offer.calculation.line_editor.note_use_template_title": "Use template title",
        "offer.calculation.line_editor.note_placeholder": "Write a note or insert a template…",
        "offer.calculation.line_editor.note_template_button": "Template",
        "offer.calculation.line_editor.note_from_template": "Template: {{title}}",
        "offer.calculation.line_editor.shown_in_offer": "Shown in offer",
        "offer.calculation.line_editor.delete_row": "Delete line",
        "offer.calculation.module.result_hint_server": "Server-calculated total (after save). Edit the canvas for a local preview.",
        "offer.calculation.module.formula.assistant_subtitle_safe": "Choose a template or insert variables. Safe mode supports + − × ÷, IF, MIN, MAX, ROUND, SUM and module references.",
        "offer.calculation.module.formula.error.empty": "{{title}}: Formula is empty",
        "offer.calculation.module.formula.error.division_by_zero": "{{title}}: Cannot divide by zero",
        "offer.calculation.module.formula.error.unknown_variable": "{{title}}: Unknown variable “{{name}}”",
        "offer.calculation.module.formula.error.invalid": "{{title}}: Formula is invalid",
        "offer.calculation.module.formula.error.unsupported_chars": "{{title}}: Formula contains unsupported characters",
        "offer.calculation.module.formula.error.unsupported_function": "{{title}}: Unknown function. Allowed: IF, MIN, MAX, ROUND, SUM",
        "offer.calculation.module.formula.error.wrong_arity": "{{title}}: Function has the wrong number of arguments",
        "offer.calculation.module.formula.error.circular": "Circular reference around {{title}}",
        "offer.calculation.module.evaluation_order": "Evaluation order",
        "Processing": "Processing",
        "Closed": "Closed",
        "case.view.new_case": "New case",
        "case.view.close_case": "Close case",
        "cases.access.forbidden_title": "No access",
        "cases.access.save_step": "Save case",
        "cases.access.edit_forbidden": "You do not have permission to edit this case.",
        "cases.access.create_forbidden": "You do not have permission to create cases.",
        "case.view.due": "Due",
        "case.view.sent_email_to_employee": "sent email to employee",
        "case.summary.title": "AI summary",
        "case.summary.updated": "Updated {{time}}",
        "case.summary.empty":
          "The summary is generated automatically as soon as there is enough content in the case.",
        "case.summary.new_updates": "New updates",
        "case.summary.generating": "Updating …",
        "case.summary.error": "Could not load the summary right now.",
        "case.summary.disabled": "AI summary is not enabled",
        "case.summary.show_more": "Show more",
        "case.summary.show_less": "Show less",
        "case.feed.activity._default": "updated the case",
        "case.feed.activity.ADDED._default": "added an update",
        "case.feed.activity.ADDED.description": "added an update",
        "case.feed.activity.ADDED.report": "added a report to the case",
        "case.feed.activity.ADDED.service_agreement": "added a service agreement",
        "case.feed.activity.ADDED.project": "added a project",
        "case.feed.activity.ADDED.order": "added an order",
        "case.feed.activity.ADDED.customer": "added a customer",
        "case.feed.activity.ADDED.contact": "added a contact",
        "case.feed.activity.ADDED.note": "added a note",
        "case.feed.activity.ADDED.customer_communication": "added a message",
        "case.feed.activity.ADDED.phone": "added a phone call",
        "case.feed.activity.ADDED.employee": "added an employee",
        "case.feed.activity.ATTACHED._default": "attached a file",
        "case.feed.activity.LINKED._default": "linked to the case",
        "case.feed.activity.LINKED.report": "linked a report to the case",
        "case.feed.activity.CREATE._default": "created the case",
        "case.feed.activity.CREATE.case": "created the case",
        "case.feed.activity.CREATE.report": "created a report",
        "case.feed.activity.CREATED._default": "created the case",
        "case.feed.activity.CREATED.case": "created the case",
        "case.feed.activity.UPDATE._default": "updated the case",
        "case.feed.activity.UPDATE.case": "updated this case",
        "case.feed.activity.UPDATED._default": "updated the case",
        "case.feed.activity.UPDATED.case": "updated this case",
        "case.feed.activity.CHANGED._default": "made a change",
        "case.feed.activity.STATUS_UPDATE._default": "updated the case status",
        "case.feed.activity.DELETED._default": "deleted an item",
        "case.feed.activity.FINISHED._default": "finished the case",
        "case.feed.activity.CLOSED._default": "closed the case",
        "case.feed.activity.EMAIL_SENT_TO_EMPLOYEE._default": "sent an email to an employee",
        "case.feed.activity.sent_sms_to_customer._default": "sent an SMS to the customer",
        "case.feed.activity.cancel_report_agreement._default": "cancelled an agreement",
        "case.feed.activity.new_report_agreement._default": "created a new agreement",
        "case.feed.activity.case_guide_run.request_info": "answered requested information",
        "case.feed.activity.case_guide_run.completed": "completed a guide",
        "case.view.composer_placeholder": "Write a comment … use @ to mention someone",
        "case.view.composer_open": "Write a comment",
        "Felter": "Fields",
        "Internt notat": "Internal note",
        "Slipp filer her for å laste opp": "Drop files here to upload",
        "Attach file": "Attach file",
        "Add image": "Add image",
        "Ctrl+Enter for å sende": "Ctrl+Enter to send",
        "Dokument": "Document",
        "Handlinger": "Actions",
        "Lukk sak": "Close case",
        "Saksbehandler": "Assignee",
        "Forfallsdato": "Due date",
        "Kart": "Map",
        "Åpne i Google Maps": "Open in Google Maps",
        "Åpne": "Open",
        "Vis mer": "Show more",
        "Vis mindre": "Show less",
        "Select Priority": "Select priority",
        "Phone Call": "Phone call",
        "duration": "Duration",
        "Sak": "Case",
        "Kunde": "Customer",
        "Prosjekt": "Project",
        "Serviceavtale": "Service agreement",
        "Avtale": "Agreement",
        "Ordre": "Order",
        "Servicerapport": "Service report",
        "Rapport": "Report",
        "Notat": "Note",
        "Telefon": "Phone",
        "SMS": "SMS",
        "E-post": "Email",
        "Select status": "Select status",
        "Moduler": "Modules",
        "Kontakt": "Contact",
        "Ingen tilknyttede moduler": "No linked modules",
        "Legg til modul": "Add module",
        "Service Report": "Service Report",
        "Egendefinerte felter": "Custom fields",
        "Ingen felter ennå": "No fields yet",
        "Legg til felt": "Add field",
        "Bilde": "Image",

        "Human resources": "Human resources",
        "Ledige stillinger": "Job openings",
        "Employees": "Employees",
        "Users": "Users",

        "hr.employees.page_title": "Employees",
        "hr.employees.hero.kicker": "Human resources",
        "hr.employees.hero.subtitle":
          "Shows only users who are employed in the company (active employment).",
        "hr.employees.section.title": "Employees",
        "hr.employees.section.subtitle": "Filtered to active employments",
        "hr.employees.section.kicker": "Employees",

        "hr.common.loading": "Loading…",
        "hr.common.cancel": "Cancel",
        "hr.common.create": "Create",
        "hr.common.save": "Save",
        "hr.common.edit": "Edit",
        "hr.common.delete": "Delete",
        "hr.common.close": "Close",
        "hr.common.back": "Back",
        "hr.common.open": "Open",
        "hr.common.yes": "Yes",
        "hr.common.no": "No",
        "hr.common.empty": "Not filled in yet",
        "hr.common.uploading": "Uploading…",
        "hr.common.all": "All",
        "hr.common.all_statuses": "All statuses",

        "hr.job_openings.title": "Job openings",
        "hr.job_openings.subtitle": "Manage listings, public website visibility and candidates",
        "hr.job_openings.new": "New opening",
        "hr.job_openings.edit": "Edit opening",
        "hr.job_openings.status": "Status",
        "hr.job_openings.candidates": "Candidates",
        "hr.job_openings.on_website": "On website",
        "hr.job_openings.search_placeholder": "Search openings…",
        "hr.job_openings.empty_title": "No job openings yet",
        "hr.job_openings.empty_body": "Create an opening to start recruiting.",
        "hr.job_openings.load_failed": "Could not load job openings",
        "hr.job_openings.create_failed": "Could not create job opening",
        "hr.job_openings.created": "Job opening created",
        "hr.job_openings.updated": "Job opening updated",
        "hr.job_openings.update_failed": "Could not update job opening",
        "hr.job_openings.deleted": "Job opening deleted",
        "hr.job_openings.delete_failed": "Could not delete job opening",
        "hr.job_openings.delete_confirm": "Are you sure you want to archive this job opening?",
        "hr.job_openings.validation.title": "Title is required",
        "hr.job_openings.fields.title": "Title",
        "hr.job_openings.fields.short_description": "Short description",
        "hr.job_openings.fields.description": "Description",
        "hr.job_openings.fields.responsibilities": "Responsibilities",
        "hr.job_openings.fields.requirements": "Requirements",
        "hr.job_openings.fields.requirements_hint": "Checklist shown on the website application form and when adding a candidate manually.",
        "hr.job_openings.fields.requirements_add": "Add requirement",
        "hr.job_openings.fields.benefits": "Benefits",
        "hr.job_openings.fields.location": "Location",
        "hr.job_openings.fields.employment_type": "Employment type",
        "hr.job_openings.fields.department": "Department",
        "hr.job_openings.fields.salary_info": "Salary",
        "hr.job_openings.fields.work_percentage": "Work percentage",
        "hr.job_openings.fields.deadline": "Application deadline",
        "hr.job_openings.fields.starts_on": "Start date",
        "hr.job_openings.fields.contact_name": "Contact name",
        "hr.job_openings.fields.contact_email": "Contact email",
        "hr.job_openings.fields.contact_phone": "Contact phone",
        "hr.job_openings.fields.contact_user": "Responsible contact",
        "hr.job_openings.fields.contact_user_hint": "Pick an employee. Name, email and phone come from their profile and appear on the opening. Company HR responsibles are shown as “Other contacts”.",
        "hr.job_openings.fields.contact_user_empty": "No responsible contact selected.",
        "hr.job_openings.fields.contact_user_pick": "Choose employee",
        "hr.job_openings.fields.contact_user_change": "Change employee",
        "hr.job_openings.fields.contact_user_clear": "Clear",
        "hr.job_openings.fields.show_on_website": "Show on website",
        "hr.job_openings.hide_from_website": "Hide from website",
        "hr.job_openings.open_on_website": "Open on website",
        "hr.job_openings.website_shown": "Opening is visible on the website",
        "hr.job_openings.website_hidden": "Opening is hidden from the website",
        "hr.job_openings.employment_types.full_time": "Full time",
        "hr.job_openings.employment_types.part_time": "Part time",
        "hr.job_openings.employment_types.temporary": "Temporary",
        "hr.job_openings.employment_types.internship": "Internship",
        "hr.job_openings.employment_types.freelance": "Freelance",
        "hr.job_openings.statuses.draft": "Draft",
        "hr.job_openings.statuses.published": "Published",
        "hr.job_openings.statuses.closed": "Closed",
        "hr.job_openings.statuses.archived": "Archived",
        "hr.job_openings.sections.overview": "Key details",
        "hr.job_openings.sections.description": "About the role",
        "hr.job_openings.sections.responsibilities": "Responsibilities",
        "hr.job_openings.sections.requirements": "Requirements",
        "hr.job_openings.sections.benefits": "Benefits",
        "hr.job_openings.sections.contact": "Contact",
        "hr.job_openings.sections.updates": "Updates",
        "hr.job_openings.sections.history": "History / Updates",
        "hr.job_openings.sections.history_hint": "Notes on this opening, plus candidate status changes.",
        "hr.job_openings.json.open_dialog": "JSON / AI",
        "hr.job_openings.json.dialog_title": "Job openings — JSON and AI",
        "hr.job_openings.json.tab_json": "Paste JSON",
        "hr.job_openings.json.tab_ai_guide": "AI instructions",
        "hr.job_openings.json.hint":
          "Paste or upload JSON. Creates new openings or updates by slug in this company. Existing openings are not deleted. Requirements: prefer requirement_items [{id,text}] (slug ids, not UUIDs). Contact is chosen as an employee in Promang — do not invent name, email or phone. Optional candidates can sit under applications with requirement_checks.",
        "hr.job_openings.json.existing_openings": "Existing openings (do not duplicate)",
        "hr.job_openings.json.loading": "loading…",
        "hr.job_openings.json.copy_json": "Copy JSON",
        "hr.job_openings.json.copy_success": "JSON copied",
        "hr.job_openings.json.reload_blank": "Clear template",
        "hr.job_openings.json.reload_success": "Blank template loaded",
        "hr.job_openings.json.insert_sample": "Insert sample",
        "hr.job_openings.json.upload": "Upload JSON",
        "hr.job_openings.json.file_loaded": "JSON file loaded",
        "hr.job_openings.json.file_failed": "Could not read the file",
        "hr.job_openings.json.preview": "Preview import",
        "hr.job_openings.json.preview_title": "Preview: {{count}} opening(s)",
        "hr.job_openings.json.preview_applications": "candidate(s)",
        "hr.job_openings.json.preview_hint":
          "Nothing is saved yet. Check the list and confirm to import into Promang.",
        "hr.job_openings.json.confirm_import": "Confirm import ({{count}})",
        "hr.job_openings.json.importing": "Importing…",
        "hr.job_openings.json.imported":
          "Imported: {{created}} created, {{updated}} updated, {{applications}} candidate(s)",
        "hr.job_openings.json.import_failed": "Import failed",
        "hr.job_openings.json.clipboard_failed": "Could not copy to the clipboard",
        "hr.job_openings.json.ai_guide_intro":
          "Copy the instructions below into ChatGPT, Claude or another AI. Then paste the JSON response in the Paste JSON tab.",
        "hr.job_openings.json.copy_ai_guide": "Copy AI instructions",
        "hr.job_openings.json.ai_guide_copied": "AI instructions copied",
        "hr.job_openings.json.generate_with_ai": "Generate with AI",
        "hr.job_openings.json.ai_parse_error": "Could not parse AI response as JSON",
        "hr.job_openings.json.ai_apply_success":
          "{{count}} opening(s) loaded from AI — review and import",
        "hr.job_openings.json.error_empty": "JSON is empty",
        "hr.job_openings.json.error_invalid_json": "Invalid JSON",
        "hr.job_openings.json.error_invalid_shape": "Invalid JSON structure",
        "hr.job_openings.json.error_no_valid_items": "No valid openings in the JSON",
        "hr.job_openings.json.error_too_many_openings": "Too many openings (max 50)",
        "hr.job_openings.json.atomic": "Atomic import (roll back on error)",
        "hr.job_openings.json.dropped_rows":
          "{{count}} row(s) skipped before import: {{detail}}",
        "hr.job_openings.json.result_title": "Import result",
        "hr.job_openings.json.result_hint": "Open the listings below to review copy and pipeline.",
        "hr.job_openings.json.result_none": "No openings were created or updated.",

        "hr.candidates.title": "Candidates",
        "hr.candidates.add": "Add candidate",
        "hr.candidates.empty": "No candidates registered for this opening yet.",
        "hr.candidates.pipeline": "Pipeline",
        "hr.candidates.total": "Total",
        "hr.candidates.documents": "Documents",
        "hr.candidates.upload": "Upload CV / file",
        "hr.candidates.no_docs": "No documents uploaded.",
        "hr.candidates.created": "Candidate added",
        "hr.candidates.create_failed": "Could not add candidate",
        "hr.candidates.updated": "Candidate updated",
        "hr.candidates.update_failed": "Could not update candidate",
        "hr.candidates.deleted": "Candidate deleted",
        "hr.candidates.delete_failed": "Could not delete candidate",
        "hr.candidates.delete_confirm": "Are you sure you want to delete this candidate?",
        "hr.candidates.docs_uploaded": "Document uploaded",
        "hr.candidates.docs_upload_failed": "Could not upload document",
        "hr.candidates.validation.first_name": "First name is required",
        "hr.candidates.validation.last_name": "Last name is required",
        "hr.candidates.validation.email": "A valid email is required",
        "hr.candidates.fields.first_name": "First name",
        "hr.candidates.fields.last_name": "Last name",
        "hr.candidates.fields.email": "Email",
        "hr.candidates.fields.phone": "Phone",
        "hr.candidates.fields.city": "City",
        "hr.candidates.fields.linkedin": "LinkedIn",
        "hr.candidates.fields.cover_letter": "Cover letter",
        "hr.candidates.fields.requirements": "Requirements",
        "hr.candidates.fields.requirements_hint": "Check what applies.",
        "hr.candidates.fields.requirements_toggle_hint": "Check what applies. The text cannot be changed here.",
        "hr.candidates.fields.requirements_readonly_hint": "The candidate submitted this themselves. The list is read-only.",
        "hr.candidates.fields.requirements_add": "Add requirement",
        "hr.candidates.fields.notes": "Internal note",
        "hr.candidates.fields.legacy_note": "Internal note",
        "hr.candidates.fields.notes_hint": "Optional. Further follow-up is written under Update after the candidate is created.",
        "hr.candidates.sections.updates": "Updates",
        "hr.candidates.sections.history": "History / Updates",
        "hr.candidates.sections.history_hint": "Status changes are logged automatically. Write further follow-up here.",
        "hr.candidates.sections.details": "Contact",
        "hr.candidates.not_found": "Could not find this candidate on the opening.",
        "hr.candidates.load_failed": "Could not load the candidate",
        "hr.candidates.fields.source": "Source",
        "hr.candidates.sources.manual": "Manual",
        "hr.candidates.sources.website": "Website",
        "hr.candidates.sources.email": "Email",
        "hr.candidates.sources.other": "Other",
        "hr.candidates.fields.status": "Status",
        "hr.candidates.fields.applied_at": "Applied",
        "hr.candidates.statuses.new": "New",
        "hr.candidates.statuses.reviewing": "Reviewing",
        "hr.candidates.statuses.interview": "Interview",
        "hr.candidates.statuses.offer": "Offer",
        "hr.candidates.statuses.hired": "Hired",
        "hr.candidates.statuses.rejected": "Rejected",
        "hr.candidates.statuses.withdrawn": "Withdrawn",

        "hr.settings.title": "HR settings",
        "hr.settings.subtitle": "Responsibles, website form and notifications",
        "hr.settings.load_failed": "Could not load HR settings",
        "hr.settings.saved": "HR settings saved",
        "hr.settings.save_failed": "Could not save HR settings",
        "hr.settings.form.title": "Website application form",
        "hr.settings.form.description": "Enable the form submitted through the public API, for example the Airon website.",
        "hr.settings.form.toggle": "Enable form for external website",
        "hr.settings.form.toggle_hint": "When this is off, openings stay visible, but applicants cannot submit the form.",
        "hr.settings.responsibles.title": "HR responsibles",
        "hr.settings.responsibles.description": "One or more people receive email on new applications, and a daily digest of changes on open openings. Name, email and phone are also shown on the public job and application page.",
        "hr.settings.responsibles.empty": "No HR responsibles have been added yet.",
        "hr.settings.responsibles.add": "Add responsible",
        "hr.settings.responsibles.remove": "Remove",
        "hr.settings.digest.title": "Daily digest",
        "hr.settings.digest.description": "Status changes and other candidate updates are collected and sent once per day, only for open openings. New applications are emailed immediately.",
        "hr.settings.digest.hour": "Send digest at (Europe/Oslo)",

        "hse.evaluation.title": "Evaluation",
        "hse.evaluation.subtitle": "KPIs, internal audit, management review and customer feedback",
        "hse.evaluation.restricted": "Limited access",
        "hse.evaluation.restricted_body": "You do not have access to the evaluation overview. Contact management.",
        "hse.evaluation.back": "Back",
        "hse.evaluation.recent": "Recent evaluations",
        "hse.evaluation.nav.kpi": "KPI",
        "hse.evaluation.nav.kpi_hint": "Key figures and measurements",
        "hse.evaluation.nav.audit_hint": "Check that procedures are actually followed",
        "hse.evaluation.nav.review_hint": "Management assesses whether the system works",
        "hse.evaluation.nav.feedback": "Customer satisfaction",
        "hse.evaluation.nav.feedback_hint": "Feedback and satisfaction",
        "hse.evaluation.types.management_review": "Management review",
        "hse.evaluation.types.internal_audit": "Internal audit",
        "hse.evaluation.help.open": "What does {{term}} mean?",
        "hse.evaluation.help.management_review.title": "Management review",
        "hse.evaluation.help.management_review.body": "Management periodically reviews the HSE/QMS system: does it work, what must change, and which actions should be followed up? Required by ISO 9001 and internal control rules.",
        "hse.evaluation.help.internal_audit.title": "Internal audit",
        "hse.evaluation.help.internal_audit.body": "A planned check that the company follows its own procedures and the law. Findings are recorded, and actions are created where something must be fixed.",
        "hse.evaluation.help.tiltak.title": "Action",
        "hse.evaluation.help.tiltak.body": "A concrete task that corrects or prevents a finding. Has an owner, due date and status.",
        "hse.evaluation.help.finding.title": "Finding",
        "hse.evaluation.help.finding.body": "Something uncovered in the review or audit. A finding can be linked to one or more actions.",
        "hse.evaluation.list.title_reviews": "Management review",
        "hse.evaluation.list.title_audits": "Internal audit",
        "hse.evaluation.list.subtitle_reviews": "Planned and completed management reviews",
        "hse.evaluation.list.subtitle_audits": "Planned and completed internal audits",
        "hse.evaluation.list.search": "Search title or conclusion…",
        "hse.evaluation.list.empty": "No evaluations yet. Create the first one.",
        "hse.evaluation.list.load_failed": "Could not load evaluations",
        "hse.evaluation.list.new_review": "New review",
        "hse.evaluation.list.new_audit": "New audit",
        "hse.evaluation.list.findings_count": "{{count}} findings",
        "hse.evaluation.fields.title": "Title",
        "hse.evaluation.fields.description": "Description",
        "hse.evaluation.fields.status": "Status",
        "hse.evaluation.fields.type": "Type",
        "hse.evaluation.fields.scheduled_on": "Planned",
        "hse.evaluation.fields.conducted_on": "Held",
        "hse.evaluation.fields.next_review_on": "Next",
        "hse.evaluation.fields.scope": "Scope",
        "hse.evaluation.fields.conclusion": "Conclusion",
        "hse.evaluation.fields.notes": "Notes",
        "hse.evaluation.fields.lead": "Lead",
        "hse.evaluation.fields.participants": "Participants",
        "hse.evaluation.fields.responsible": "Owner",
        "hse.evaluation.fields.due_date": "Due date",
        "hse.evaluation.statuses.draft": "Draft",
        "hse.evaluation.statuses.planned": "Planned",
        "hse.evaluation.statuses.in_progress": "In progress",
        "hse.evaluation.statuses.completed": "Completed",
        "hse.evaluation.statuses.cancelled": "Cancelled",
        "hse.evaluation.severities.low": "Low",
        "hse.evaluation.severities.medium": "Medium",
        "hse.evaluation.severities.high": "High",
        "hse.evaluation.severities.critical": "Critical",
        "hse.evaluation.form.new_review": "New review",
        "hse.evaluation.form.edit_review": "Edit review",
        "hse.evaluation.form.new_audit": "New audit",
        "hse.evaluation.form.edit_audit": "Edit audit",
        "hse.evaluation.form.save": "Save",
        "hse.evaluation.form.saving": "Saving…",
        "hse.evaluation.form.cancel": "Cancel",
        "hse.evaluation.form.saved": "Evaluation saved",
        "hse.evaluation.form.save_failed": "Could not save the evaluation",
        "hse.evaluation.form.title_required": "Title is required",
        "hse.evaluation.form.section.basics": "Basics",
        "hse.evaluation.form.section.dates": "Dates",
        "hse.evaluation.form.section.people": "People",
        "hse.evaluation.form.section.conclusion": "Conclusion",
        "hse.evaluation.view.open": "Open",
        "hse.evaluation.view.edit": "Edit",
        "hse.evaluation.view.findings": "All findings",
        "hse.evaluation.view.report": "Report",
        "hse.evaluation.view.not_found": "Evaluation not found",
        "hse.evaluation.view.no_conclusion": "No conclusion has been written yet.",
        "hse.evaluation.findings.title": "Findings",
        "hse.evaluation.findings.empty": "No findings recorded.",
        "hse.evaluation.findings.add": "Add",
        "hse.evaluation.findings.title_placeholder": "Short finding",
        "hse.evaluation.findings.description_placeholder": "What was observed?",
        "hse.evaluation.findings.title_required": "A finding needs a title",
        "hse.evaluation.findings.saved": "Finding saved",
        "hse.evaluation.findings.save_failed": "Could not save the finding",
        "hse.evaluation.findings.create_tiltak": "Create action",
        "hse.evaluation.participants.choose": "Select participants",
        "hse.evaluation.participants.choose_one": "Select person",
        "hse.evaluation.participants.chosen": "{{count}} selected",
        "hse.evaluation.participants.empty": "No participants recorded",
        "hse.evaluation.tiltak": "Action",
        "hse.evaluation.tiltak.dialog_title": "New action",
        "hse.evaluation.tiltak.dialog_hint": "Create an action from this finding, or open the actions page.",
        "hse.evaluation.tiltak.create": "Create action",
        "hse.evaluation.tiltak.created": "Action created",
        "hse.evaluation.tiltak.create_failed": "Could not create an action here. Open the actions page instead.",
        "hse.evaluation.tiltak.title_required": "An action needs a title",
        "hse.evaluation.tiltak.open_page": "Open actions page",
        "hse.evaluation.tiltak.open_existing": "View action",
        "hse.evaluation.statuses.closed": "Closed",
        "hse.evaluation.fields.held_on": "Held",
        "hse.evaluation.fields.period_from": "Period from",
        "hse.evaluation.fields.period_to": "Period to",
        "hse.evaluation.fields.result": "Result",
        "hse.evaluation.fields.summary": "Summary",
        "hse.evaluation.fields.conclusions": "Conclusion",
        "hse.evaluation.fields.action_type": "Action type",
        "hse.evaluation.results.none": "Not set",
        "hse.evaluation.results.passed": "Passed",
        "hse.evaluation.results.failed": "Failed",
        "hse.evaluation.results.conditional": "Conditional",
        "hse.evaluation.export_pdf": "Download PDF",
        "hse.evaluation.exporting": "Downloading PDF…",
        "hse.evaluation.export_failed": "Could not download PDF",
        "hse.evaluation.tiltak.empty": "No actions linked to this evaluation.",
        "hse.evaluation.tiltak.open_count": "{{count}} open actions",
        "hse.evaluation.tiltak.deadline_required": "An action needs a due date",
        "hse.evaluation.tiltak.responsible_required": "An action needs an owner",
        "hse.evaluation.tiltak.types.generic": "Follow-up",
        "hse.evaluation.tiltak.types.new_routine": "New routine",
        "hse.evaluation.tiltak.types.linked_document": "Document action",
        "common.error_state.not_found.title": "Page not found",
        "common.error_state.not_found.description": "We could not find what you were looking for. It may have been deleted, moved, or the address is wrong.",
        "common.error_state.forbidden.title": "Access denied",
        "common.error_state.forbidden.description": "You do not have access to this page or resource.",
        "common.error_state.load_error.title": "Could not load",
        "common.error_state.load_error.description": "Something went wrong while fetching data. Check your connection and try again.",
        "common.unexpected_error": "Something went wrong. Try again.",
        "common.error_state.empty.title": "Nothing here yet",
        "common.error_state.empty.description": "There are no items to show here yet.",
        "common.error_state.action.back": "Back",
        "common.error_state.action.dashboard": "Go to dashboard",
        "common.error_state.action.retry": "Try again",
        "common.error_state.action.home": "Go to home",
        "common.error_state.details_heading": "Details",
        "hse.events.title": "Events",
        "hse.events.subtitle": "Deviations, near misses, accidents and observations",
        "hse.events.search": "Search events…",
        "hse.events.empty": "No events found",
        "hse.events.nav.aria": "Event types",
        "hse.events.tab.all": "All",
        "hse.events.tab.deviations": "Deviations",
        "hse.events.tab.near_misses": "Near misses",
        "hse.events.tab.accidents": "Accidents",
        "hse.events.tab.complaints": "Complaints",
        "hse.events.tab.observations": "Observations",
        "hse.competency.nav.aria": "Competency pages",
        "hse.competency.nav.my": "My competency",
        "hse.competency.nav.definitions": "Definitions",
        "hse.competency.nav.matrix": "Matrix",
        "hse.competency.nav.roles": "Roles",
        "hse.competency.nav.employees": "Employees",
        "hse.competency.nav.expiring": "Expiring",
        "hse.competency.nav.courses": "Courses",
        "hse.competency.nav.training_plan": "Training plan",
        "hse.competency.nav.guide": "Guide",
        "hse.events.new": "New event",
        "hse.events.type.injury": "Injury",
        "hse.events.type.near_miss": "Near miss",
        "hse.events.type.property_damage": "Property damage",
        "hse.events.type.environmental": "Environmental",
        "hse.events.type.other": "Other",
        "hse.documents.title": "Documents",
        "hse.documents.subtitle": "Controlled documents with versioning",
        "hse.documents.nav.aria": "Document types",
        "hse.documents.tab.all": "All",
        "hse.documents.tab.policies": "Policies",
        "hse.documents.tab.procedures": "Procedures",
        "hse.documents.tab.instructions": "Instructions",
        "hse.documents.tab.forms": "Forms",
        "hse.documents.tab.guidance": "Guidance",
        "hse.documents.tab.record": "Records",
        "hse.documents.tab.template": "Templates",
        "hse.documents.new": "New document",
        "hse.actions.open": "Open",
        "hse.actions.edit": "Edit",
        "hse.actions.export_pdf": "Export PDF",
        "hse.actions.export_pdf_loading": "Exporting…",
        "hse.actions.export_pdf_success": "PDF downloaded",
        "hse.actions.export_pdf_error": "Could not export PDF",
        "hse.actions.approve": "Approve",
        "hse.actions.revisions": "Revisions",
        "hse.actions.submit": "Submit",
        "hse.actions.close_event": "Close event",
        "hse.actions.delete": "Delete",
        "hse.events.delete_confirm": "Are you sure you want to delete this event?",
        "hse.events.deleted": "Event deleted",
        "hse.events.delete_error": "Could not delete event",
        "hse.events.submitted": "Event submitted",
        "hse.events.submit_error": "Could not submit event",
        "hse.events.closed": "Event closed",
        "hse.events.close_error": "Could not close event",
        "hse.protective.title": "Safety rounds",
        "hse.protective.subtitle": "Safety rounds and personal protective equipment",
        "hse.protective.new": "New safety round",
        "hse.protective.search": "Search safety rounds…",
        "hse.protective.empty": "No safety rounds found",
        "hse.protective.equipment_title": "Personal protective equipment",
        "hse.protective.equipment_empty": "No protective equipment found",
        "hse.protective.status.draft": "Draft",
        "hse.protective.status.in_progress": "In progress",
        "hse.protective.status.completed": "Completed",
        "hse.protective.status.closed": "Closed",
        "hse.actions.menu": "Actions",
        "hse.protective.open": "Open",
        "hse.protective.edit": "Edit",
        "hse.protective.actions": "Actions",
        "hse.protective.col_title": "Title",
        "hse.protective.col_date": "Date",
        "hse.protective.col_location": "Location",
        "hse.protective.col_status": "Status",
        "hse.protective.field.description": "Description",
        "hse.protective.field.registered_by": "Registered by",
        "hse.protective.view_title": "Safety round",
        "hse.protective.view_subtitle": "Details and results for the safety round",
        "hse.protective.load_failed": "Could not load the safety round",
        "hse.protective.export_pdf": "Download PDF",
        "hse.protective.export_pdf_loading": "Downloading PDF…",
        "hse.protective.export_pdf_success": "PDF downloaded",
        "hse.protective.export_pdf_error": "Could not download PDF",

        // i18n hotfix 2026-09-07 — filled missing dotted keys
        "absence.overview.export_hint": "Download the absence overview as PDF.",
        "absence.overview.export_pdf": "Export PDF",
        "absence.overview.exporting": "Exporting…",
        "absence.overview.pdf_export_failed": "Could not export PDF",
        "absence.overview.pdf_exported": "PDF downloaded",
        "absence.overview.pdf_too_small": "The PDF file was too small. Try again.",
        "absence.overview.debug_export": "Export time-off-in-lieu JSON",
        "absence.overview.debug_exporting": "Exporting…",
        "absence.overview.debug_export_hint": "Download how remaining compensatory time off is calculated (hours, formula and lines).",
        "absence.overview.debug_exported": "Time-off-in-lieu JSON downloaded",
        "absence.overview.debug_export_failed": "Could not export time-off-in-lieu JSON",
        "absence.stats.avspassering.title": "Time off in lieu",
        "absence.stats.avspassering.earned_last_year": "Earned last year",
        "absence.stats.avspassering.used_last_year": "Used last year",
        "absence.stats.avspassering.earned_this_year": "Earned in period",
        "absence.stats.avspassering.used_this_year": "Used in period",
        "absence.stats.avspassering.remaining": "Remaining",
        "absence.stats.avspassering.guide_aria": "How compensatory time off is calculated",
        "absence.stats.avspassering.guide_title": "How compensatory time off is calculated",
        "absence.stats.avspassering.guide_body": "Remaining = (earned last year − used last year) + (earned in the period − used in the period).\n\nEarned is daily overtime: registered hours minus expected hours from the work schedule (scaled by employment percentage). Public holidays and zero-hour weekdays have expected 0.\n\nUsed is scheduled hours on compensatory-time-off absences that are not denied, clipped to the window.\n\nOnly the previous calendar year carries in. Download JSON from the overview to inspect every line.",
        "cases.create.user_assigned": "Case created and assigned",
        "cases.settings.notify.description": "Send an email when a new case arrives automatically.",
        "cases.settings.notify.load_failed": "Could not load notification settings",
        "cases.settings.notify.loading": "Loading settings…",
        "cases.settings.notify.missing_email": "Enter an email address for notifications.",
        "cases.settings.notify.no_company_email": "no company email",
        "cases.settings.notify.override_hint": "Leave empty to use {{email}}.",
        "cases.settings.notify.override_label": "Other notification address",
        "cases.settings.notify.save": "Save",
        "cases.settings.notify.save_failed": "Could not save notification settings",
        "cases.settings.notify.saved": "Notification settings saved",
        "cases.settings.notify.saving": "Saving…",
        "cases.settings.notify.title": "Automatic case notifications",
        "cases.settings.notify.toggle": "Notify on new cases",
        "cases.settings.notify.toggle_hint": "Sends email when a case is created automatically.",
        "chemical.inventory.disposal_considerations": "Disposal considerations",
        "chemical.inventory.ecological_info": "Ecological information",
        "chemical.inventory.exposure_limits": "Exposure limits",
        "chemical.inventory.fire_measures": "Fire-fighting measures",
        "chemical.inventory.general_use": "General use",
        "chemical.inventory.general_use_risk": "Risk assessment – general use",
        "chemical.inventory.hazard_classification": "Hazard classification",
        "chemical.inventory.location_specific_risk": "Location-specific risk assessment",
        "chemical.inventory.per_operation_risk": "Risk assessment – per operation",
        "chemical.inventory.risk_assessment": "Risk assessment",
        "chemical.inventory.risk_assessment_documents": "Risk assessment documents",
        "chemical.inventory.spill_measures": "Spill measures",
        "chemical.inventory.stability_reactivity": "Stability and reactivity",
        "chemical.inventory.storage_conditions": "Storage conditions",
        "chemical.inventory.storage_location": "Storage location",
        "chemical.inventory.toxicological_info": "Toxicological information",
        "chemical.inventory.transport_info": "Transport information",
        "chemical.inventory.usage_instructions": "Usage instructions",
        "common.cancel": "Cancel",
        "common.active": "Active",
        "common.description": "Description",
        "common.no": "No",
        "common.yes": "Yes",
        "common.back": "Back",
        "common.close": "Close",
        "common.new": "New",
        "common.menu": "Menu",
        "common.edit": "Edit",
        "common.delete": "Delete",
        "common.open": "Open",
        "common.details": "Details",
        "common.none": "None",
        "common.create": "Create",
        "common.creating": "Creating…",
        "common.saving": "Saving…",
        "common.update": "Update",
        "connected.to.phonero.but.presence.not.available": "Connected to Phonero, but presence is not available.",
        "contact.customer.explanation": "The contact is linked to the customer.",
        "contact.email": "Email",
        "contact.mobile": "Mobile",
        "contact.name": "Name",
        "contacts.create": "New contact",
        "crew.shift.week_of": "Week of",
        "customers.create": "New customer",
        "deviation.notification.failed_at": "Failed",
        "deviation.notification.mode.digest": "Digest",
        "deviation.notification.mode.immediate": "Immediate",
        "deviation.notification.scheduled_at": "Scheduled",
        "deviation.notification.send_log_empty": "No sends yet.",
        "deviation.notification.send_log_title": "Send log",
        "deviation.notification.sent_at": "Sent",
        "deviation.notification.status.failed": "Failed",
        "deviation.notification.status.cancelled": "Cancelled",
        "deviation.notification.status.scheduled": "Scheduled",
        "deviation.email_failed.banner": "Sending by email failed. Open the deviation and send it again.",
        "deviation.email_failed.row": "Email failed",
        "deviation.description.title": "Description",
        "deviation.description.help": "The description is stored on the deviation. Images and documentation stay together below.",
        "deviation.description.placeholder": "Write what happened",
        "deviation.description.save": "Save description",
        "deviation.description.saved": "Description saved",
        "deviation.description.empty": "No description yet.",
        "deviation.description.legacy_title": "Previous explanation",
        "deviation.description.legacy_help": "This text comes from older deviation items. It stays where it is and is not moved or deleted.",
        "deviation.documents.help": "Upload images and documentation. A drawing stores both the snapshot and the photo on the deviation.",
        "deviation.priority": "Priority",
        "deviation.item.consequence": "Consequence",
        "common.title": "Title",
        "deviation.form.choose_who_should_own_this_deviation": "Choose who should own this deviation",
        "deviation.form.create": "Create",
        "deviation.form.create_deviation": "Create Deviation",
        "deviation.form.deviation_type": "Deviation Type",
        "deviation.form.edit_deviation": "Edit Deviation",
        "deviation.form.no_email": "No email",
        "deviation.form.no_employees_found": "No employees found",
        "deviation.form.responsible_for_follow_up": "Responsible for follow-up",
        "deviation.form.responsible_user": "Responsible User",
        "deviation.form.search_employees": "Search employees",
        "deviation.form.select_deviation_type": "Select Deviation Type",
        "deviation.form.select_priority": "Select Priority",
        "deviation.form.select_responsible_user": "Select Responsible User",
        "deviation.form.select_severity": "Select Severity",
        "deviation.form.selected": "Selected",
        "deviation.form.update": "Update",

        "vehicle.body_style": "Body style",
        "vehicle.current_odometer_km": "Current Odometer (km)",
        "vehicle.edit_vehicle": "Edit Vehicle",
        "vehicle.engine_size_cc": "Engine Size (cc)",
        "vehicle.first_registration": "First Registration",
        "vehicle.fuel_type": "Fuel Type",
        "vehicle.inspection_information": "Inspection Information",
        "vehicle.inspection_result": "Inspection Result",
        "vehicle.inspection_station": "Inspection Station",
        "vehicle.last_inspection_date": "Last Inspection Date",
        "vehicle.last_ride": "Last Ride",
        "vehicle.last_service_date": "Last Service Date",
        "vehicle.make": "Make",
        "vehicle.model": "Model",
        "vehicle.model_year": "Model Year",
        "vehicle.next_inspection_date": "Next Inspection Date",
        "vehicle.next_service_date": "Next Service Date",
        "vehicle.nickname": "Nickname",
        "vehicle.norwegian": "Norwegian",
        "vehicle.number_plate": "Number Plate",
        "vehicle.power_kw": "Power (kW)",
        "vehicle.registration_date": "Registration Date",
        "vehicle.service_information": "Service Information",
        "vehicle.service_interval_km": "Service Interval (km)",
        "vehicle.service_provider": "Service Provider",
        "vehicle.statens_vegvesen_information": "Statens Vegvesen Information",
        "vehicle.vehicle_handbook": "Vehicle handbook",
        "vehicle.vehicle_information": "Vehicle Information",
        "vehicle.vehicle_type": "Vehicle Type",
        "vehicle.vin_chassis_number": "VIN (Chassis Number)",
        "vehicle.warranty_end_date": "Warranty End Date",
        "vehicle.warranty_type": "Warranty Type",

        "deviation.list.title": "Deviations",
        "deviation.list.statuses": "Statuses",
        "deviation.list.types": "Deviation types",
        "deviation.list.priorities": "Priorities",
        "deviation.list.type": "Type",
        "deviation.table.number": "Number",
        "deviation.table.deviation": "Deviation",
        "deviation.table.untitled": "Untitled",
        "deviation.table.type_missing": "Type missing",
        "deviation.table.unlinked": "Not linked",
        "deviation.table.status": "Status",
        "deviation.table.responsible": "Responsible",
        "deviation.table.unassigned": "Unassigned",
        "deviation.table.created": "Created",
        "deviation.consequence.pick": "Choose a consequence type",
        "deviation.consequence.dialog_title": "Consequence: {{type}}",
        "deviation.consequence.save": "Save consequence",
        "deviation.consequence.type.1": "Economic",
        "deviation.consequence.type.2": "Progress",
        "deviation.consequence.type.3": "Safety",
        "deviation.consequence.type.4": "Environment",
        "deviation.consequence.type.5": "Quality",
        "deviation.consequence.type.6": "Authority",
        "deviation.consequence.type.7": "Other",
        "deviation.delete.action": "Delete",
        "deviation.delete.forbidden": "You do not have access to delete or close this deviation.",
        "deviation.delete.can_delete_title": "This deviation can be deleted",
        "deviation.delete.can_delete_body": "Important links are removed or closed. The deviation will be deleted.",
        "deviation.delete.close_title": "This deviation cannot be deleted",
        "deviation.delete.close_body": "You can close it without completing it. It is closed, but not marked as finished.",
        "deviation.delete.confirm_delete": "Delete deviation",
        "deviation.delete.confirm_close": "Close without completing",
        "deviation.delete.reasons": "Why it cannot be deleted",
        "deviation.delete.closed": "The deviation was closed without being completed",
        "deviation.delete.deleted": "The deviation was deleted",
        "deviation.history.caption": "This is what has happened on the deviation, including work orders and sending.",
        "deviation.work_order.linked_banner": "This deviation is linked to work order {{title}}.",
        "deviation.send.copy_always": "Always copy",
        "deviation.send.copy_off": "No copy",
        "deviation.send.digest_hint": "Collected and sent in the next digest.",
        "deviation.send.immediate_hint": "Sent immediately.",
        "deviation.send.failed": "Could not send the deviation",
        "deviation.send.success_partial": "Some recipients received the deviation. See the send log.",
        "deviation.send.success_scheduled": "The deviation is queued for sending.",
        "deviation.send.success_sent": "The deviation has been sent.",
        "deviation.settings.subtitle": "Deviation notification and sending",
        "drawings.observation.deviation_consequence_placeholder": "Any consequences or risk if the deviation is not rectified.",
        "drawings.observation.deviation_explanation_placeholder": "Explanation of the deviation – what happened, where and when.",
        "drawings.observation.field.consequence": "Possible consequences",
        "drawings.observation.field.explanation": "Explanation",
        "employee.contact.information": "Contact information",
        "employee.view.profile": "View profile",
        "employee.work.mobile": "Work mobile",
        "employee_selector.clear_all": "Clear all",
        "employee_selector.confirm": "Select",
        "employee_selector.empty_hint": "Search by name or email.",
        "employee_selector.load_error": "Could not load employees",
        "employee_selector.load_more": "Load more",
        "employee_selector.loading": "Loading…",
        "employee_selector.no_results": "No results",
        "employee_selector.search_placeholder": "Search employees…",
        "employee_selector.selected_count": "{{count}} selected",
        "employee_selector.title_multiple": "Select employees",
        "employee_selector.title_single": "Select employee",
        "error.fetching_communcations": "Could not fetch communications",
        "failed.to.create.communication": "Failed to create communication",
        "failed.to.load.report": "Failed to load report",
        "hours.resource_plan.planned_tasks": "Planned tasks",
        "hours.resource_plan.table.planned": "Planned",
        "hse_document_selector.all_documents": "All documents",
        "hse_document_selector.no_documents": "No documents",
        "hse_document_selector.recent": "Recent",
        "hse_document_selector.search_placeholder": "Search documents…",
        "hse_document_selector.search_results": "Search results",
        "image.select": "Select image",
        "inventory.count.add_items": "Add items",
        "inventory.count.add_items_bulk": "Add multiple items",
        "inventory.count.add_products_bulk": "Add multiple products",
        "inventory.count.adding_products": "Adding products…",
        "inventory.count.bulk.no_valid_items": "No valid lines to add.",
        "inventory.count.copy_all_products_from_storage": "Copy all products from storage",
        "inventory.count.copy_all_products_info": "Copies all products in the storage into the count.",
        "inventory.count.copy_from_count": "Copy from count",
        "inventory.count.copy_from_existing": "Copy from existing",
        "inventory.count.copy_options": "Copy options",
        "inventory.count.create_and_copy": "Create and copy",
        "inventory.count.create_description": "Create a new inventory count.",
        "inventory.count.created": "Count created",
        "inventory.count.description": "Description",
        "inventory.count.item.approve_error": "Could not approve the line",
        "inventory.count.item.approved": "Approved",
        "inventory.count.item.unapproved": "Unapproved",
        "inventory.count.item_number_placeholder": "Item number",
        "inventory.count.items_add_error": "Could not add items",
        "inventory.count.items_added": "Items added",
        "inventory.count.none": "No counts",
        "inventory.count.product.add_error": "Could not add the product",
        "inventory.count.product.found": "Product found",
        "inventory.count.product.no_exact_match": "No exact match",
        "inventory.count.products_added": "Products added",
        "inventory.count.unapproved": "Unapproved",
        "microsoft.ai_mailboxes.ai_routing.create_case_and_reply_hint": "Creates a case and suggests a reply.",
        "microsoft.ai_mailboxes.settings.case_filters_replaced_body": "The old case filters have been replaced by new rules.",
        "microsoft.ai_mailboxes.settings.case_filters_replaced_title": "Case filters replaced",
        "no.communications.found": "No communications found",
        "no.number": "None",
        "offer.calculation.load_error": "Could not load the calculation",
        "product.brands.edit": "Edit brand",
        "product.edit": "Edit product",
        "project.activities.duplicate": "Duplicate",
        "project.activities.duplicate_error": "Could not duplicate the activity",
        "project.activities.duplicated": "Activity duplicated",
        "project.activities.duplicating": "Duplicating…",
        "project.activities.export_pdf": "Export PDF",
        "project.activities.export_pdf_error": "Could not export PDF",
        "project.activities.export_pdf_loading": "Creating PDF…",
        "project.activities.export_pdf_success": "PDF downloaded",
        "project.activities.group_add_activity": "Add activity to the group",
        "project.activities.group_created": "Group created",
        "project.activities.group_delete": "Delete group",
        "project.activities.group_delete_confirm": "Delete this group? Activities will become ungrouped.",
        "project.activities.group_delete_error": "Could not delete the group",
        "project.activities.group_deleted": "Group deleted",
        "project.activities.group_drag": "Drag to move",
        "project.activities.group_duplicate": "Duplicate group",
        "project.activities.group_duplicate_confirm": "Duplicate",
        "project.activities.group_duplicate_error": "Could not duplicate the group",
        "project.activities.group_duplicate_hint": "Create a copy of the group and its activities.",
        "project.activities.group_duplicate_name_suggestion": "{{name}} (copy)",
        "project.activities.group_duplicated": "Group duplicated",
        "project.activities.group_edit": "Edit group",
        "project.activities.group_empty": "No activities in the group",
        "project.activities.group_load_error": "Could not load groups",
        "project.activities.group_new": "New group",
        "project.activities.group_reorder_error": "Could not change the order",
        "project.activities.group_save_error": "Could not save the group",
        "project.activities.group_title": "Group title",
        "project.activities.group_title_placeholder": "Group name",
        "project.activities.group_title_required": "Group title is required",
        "project.activities.group_updated": "Group updated",
        "project.billing_plan.invoice": "Invoice",
        "project.description": "Description",
        "project.end_date": "End date",
        "project.hourly_costs": "Hourly costs",
        "project.hourly_costs.calculation": "Hourly cost calculation",
        "project.hourly_costs.missing_rate_warning": "Missing a valid hourly rate for this employee",
        "project.hourly_costs.social_expenses": "Social expenses (28%)",
        "project.hourly_costs.total_cost": "Total hourly cost",
        "project.hourly_costs.warning_title": "Warning: missing hourly cost",
        "project.item_list.purchase_price": "Purchase price",
        "project.item_list.sales_price": "Sales price",
        "project.item_list.select_warehouse_description": "Select the warehouse the items should come from.",
        "project.manager.required": "Project manager is required",
        "project.name": "Project name",
        "project.name.required": "Project name is required",
        "project.number": "Project number",
        "project.order_line.a_account": "Progress invoice",
        "project.order_line.description": "Description",
        "project.required": "Project is required",
        "project.settings": "Project settings",
        "project.settings.default_due_days": "Default 60 days",
        "project.settings.final_invoice_due_days": "Final invoice retention due days",
        "project.start_date": "Start date",
        "project.supplier_invoices.create": "Create supplier invoice",
        "project.supplier_invoices.error.title": "Supplier invoice error",
        "project.supplier_invoices.overview": "Supplier invoices",
        "project.supplier_invoices.status.approved": "Approved",
        "project.supplier_invoices.status.not_approved": "Not approved",
        "project.supplier_invoices.status.overdue": "Overdue",
        "project.supplier_invoices.status.paid": "Paid",
        "project.supplier_invoices.status.pending": "Pending",
        "project.tripletex_sync.disabled": "Sync disabled for projects with multiple invoices",
        "project.tripletex_sync.reason": "The project has more than one invoice and is synced with Tripletex",
        "project_activity.ungrouped": "Ungrouped",
        "projects.create": "New project",
        "projects.edit": "Edit project",
        "quality.checklist.page.missingTitle": "Untitled checklist",
        "quality.checklist.page.qualitySubtitle": "Quality checklist",
        "quality.checklist.page.reportSubtitle": "Report checklist",
        "report.agreement.redesign.day_help": "Choose which day the agreement applies to.",
        "report.agreement.redesign.next_day_time": "Next day and time",
        "report.agreement.redesign.next_settings": "Next settings",
        "report.agreement.redesign.step_day": "Day",
        "report.finish.description": "Finish and close the report.",
        "report.hours.description": "Hours logged on the report.",
        "report.list.agreed_date": "Agreed date",
        "report.price_lines.confirm_delete": "Delete this price line?",
        "report.variables.description": "Variables on the report.",
        "report.write.description": "Write and complete the report.",
        "service.agreement_types.create": "New agreement type",
        "service.agreement_types.edit": "Edit agreement type",
        "service.agreements.info.vat_excluded": "Prices exclude VAT",
        "service.checklist_types.create": "New checklist type",
        "service.checklist_types.edit": "Edit checklist type",
        "service.variable_types.create": "New variable type",
        "service.variable_types.edit": "Edit variable type",
        "storage.add": "Add storage",
        "user_guide.hub.badge": "User guide",
        "work_order.plan_modal.plan_description": "Plan description",
        "work_order.plan_modal.plan_description_placeholder": "What should be done?",
        "work_order.plan_modal.plan_title_help": "Short title shown in the plan.",
        "operation_feedback.processing": "Processing…",
        "operation_feedback.hide": "Hide progress",
        "operation_feedback.close": "Close",
        "operation_feedback.step.pending": "Waiting",
        "operation_feedback.step.running": "In progress",
        "operation_feedback.step.completed": "Completed",
        "operation_feedback.step.already_applied": "Already done",
        "operation_feedback.step.not_relevant": "Not relevant",
        "operation_feedback.step.needs_fix": "Needs fixing",
        "operation_feedback.step.not_done": "Not done",
        "operation_feedback.step.failed": "Failed",
        "operation_feedback.step.rolled_back": "Rolled back",
        "operation_feedback.step.unconfirmed": "Unconfirmed",
        "operation_feedback.step.cancelled": "Cancelled",
        "operation_feedback.saved_list_refresh_failed": "Saved. The list could not be refreshed.",
        "operation_feedback.taking_longer": "This is taking longer than usual. Checking status…",
        "operation_feedback.finish_report.title": "Finishing service report {{number}}",
        "operation_feedback.finish_report.step.preflight": "Required information checked",
        "operation_feedback.finish_report.step.save": "Saving the report",
        "operation_feedback.finish_report.step.finish_checklist": "Updating checklist",
        "operation_feedback.finish_report.step.update_agreement": "Updating service agreement",
        "operation_feedback.finish_report.step.refresh": "Refreshing the view",
        "operation_feedback.finish_report.preflight_ok": "Prerequisites are met.",
        "operation_feedback.finish_report.preflight_skipped": "No preflight checklist loaded.",
        "operation_feedback.finish_report.preflight_blocked": "The report cannot be finished. Fix the checklist items first.",
        "operation_feedback.finish_report.save_ok": "The report was saved as finished.",
        "operation_feedback.finish_report.success": "The service report is finished.",
        "operation_feedback.finish_report.open_report": "Open report",
        "operation_feedback.create_reports.title": "Creating service reports for {{count}} subs",
        "operation_feedback.create_reports.step.preflight": "Checking selection and delivery address",
        "operation_feedback.create_reports.step.create": "Creating service reports",
        "operation_feedback.create_reports.step.refresh": "Refreshing the view",
        "operation_feedback.create_reports.preflight_ok": "Selection and addresses look good.",
        "operation_feedback.create_reports.preflight_no_selection": "No subs are selected.",
        "operation_feedback.create_reports.create_ok": "Created {{count}} service report(s).",
        "operation_feedback.create_reports.success": "{{count}} service report(s) created.",
        "operation_feedback.create_reports.atomic_failed": "No service reports were created.",
        "operation_feedback.create_reports.open_report": "Open report {{id}}",
        "operation_feedback.send_report.title": "Sending service report {{number}}",
        "operation_feedback.send_report.step.preflight": "Checking recipient and report type",
        "operation_feedback.send_report.step.queue": "Queuing send",
        "operation_feedback.send_report.step.deliver": "Generating PDF and sending",
        "operation_feedback.send_report.step.refresh": "Refreshing the view",
        "operation_feedback.send_report.preflight_ok": "Recipient and report type look good.",
        "operation_feedback.send_report.preflight_missing_email": "Email address is missing.",
        "operation_feedback.send_report.preflight_missing_type": "Report type is missing.",
        "operation_feedback.send_report.preflight_missing_id": "Report ID is missing.",
        "operation_feedback.send_report.queue_ok": "Send has been queued.",
        "operation_feedback.send_report.deliver_sync": "Send completed without a background job.",
        "operation_feedback.send_report.deliver_queued": "Waiting in queue…",
        "operation_feedback.send_report.deliver_processing": "Generating PDF and sending…",
        "operation_feedback.send_report.deliver_ok": "The report was sent.",
        "operation_feedback.send_report.deliver_failed": "Sending failed.",
        "operation_feedback.send_report.deliver_poll_retry": "Status check failed (retrying): {{message}}",
        "operation_feedback.send_report.deliver_timeout": "Sending timed out. Check status manually.",
        "operation_feedback.send_report.success": "The service report was sent.",
        "operation_feedback.send_report.open_report": "Open report",
        "operation_feedback.list_update_agreements.title": "Updating {{count}} service agreements",
        "operation_feedback.list_update_agreements.dialog_title": "Editing {{count}} agreements",
        "operation_feedback.list_update_agreements.step.preflight": "Checking selection",
        "operation_feedback.list_update_agreements.step.update": "Updating agreements",
        "operation_feedback.list_update_agreements.step.refresh": "Refreshing the list",
        "operation_feedback.list_update_agreements.preflight_ok": "{{count}} agreement(s) selected.",
        "operation_feedback.list_update_agreements.preflight_no_selection": "No agreements are selected.",
        "operation_feedback.list_update_agreements.update_ok": "{{count}} agreement(s) updated.",
        "operation_feedback.list_update_agreements.success": "{{count}} service agreement(s) updated.",
        "operation_feedback.list_update_agreements.confirm_title": "Are you sure?",
        "operation_feedback.list_update_agreements.confirm_body": "You are editing {{count}} agreement(s). This cannot be undone.",
        "operation_feedback.list_update_reports.title": "Updating {{count}} service reports",
        "operation_feedback.list_update_reports.dialog_title": "Editing {{count}} reports",
        "operation_feedback.list_update_reports.step.preflight": "Checking selection",
        "operation_feedback.list_update_reports.step.update": "Updating reports",
        "operation_feedback.list_update_reports.step.refresh": "Refreshing the list",
        "operation_feedback.list_update_reports.preflight_ok": "{{count}} report(s) selected.",
        "operation_feedback.list_update_reports.preflight_no_selection": "No reports are selected.",
        "operation_feedback.list_update_reports.update_ok": "{{count}} report(s) updated.",
        "operation_feedback.list_update_reports.success": "{{count}} service report(s) updated.",
        "operation_feedback.list_update_reports.confirm_title": "Are you sure?",
        "operation_feedback.list_update_reports.confirm_body": "You are editing {{count}} report(s). This cannot be undone.",
        "operation_feedback.create_next_job.title_report": "Creating service report for agreement {{id}}",
        "operation_feedback.create_next_job.title_order": "Creating order for agreement {{id}}",
        "operation_feedback.create_next_job.step.preflight": "Checking agreement",
        "operation_feedback.create_next_job.step.create_report": "Creating service report",
        "operation_feedback.create_next_job.step.create_order": "Creating order",
        "operation_feedback.create_next_job.step.refresh": "Refreshing the view",
        "operation_feedback.create_next_job.preflight_ok": "Agreement is ready.",
        "operation_feedback.create_next_job.preflight_failed": "Cannot start next job.",
        "operation_feedback.create_next_job.create_report_ok": "Service report created.",
        "operation_feedback.create_next_job.create_order_ok": "Order created.",
        "operation_feedback.create_next_job.success_report": "The service report was created.",
        "operation_feedback.create_next_job.success_order": "The order was created.",
        "operation_feedback.create_next_job.open_report": "Open report {{id}}",
        "operation_feedback.create_next_job.open_order": "Open order {{id}}",
        "operation_feedback.create_next_job.create_unconfirmed": "Creation was not confirmed. Check the agreement before trying again.",
        "operation_feedback.update_agreement_orderlines.title": "Saving order lines for agreement {{id}}",
        "operation_feedback.update_agreement_orderlines.step.preflight": "Checking agreement",
        "operation_feedback.update_agreement_orderlines.step.save": "Saving order lines",
        "operation_feedback.update_agreement_orderlines.step.refresh": "Refreshing the view",
        "operation_feedback.update_agreement_orderlines.preflight_ok": "Agreement is ready.",
        "operation_feedback.update_agreement_orderlines.preflight_failed": "Cannot save order lines.",
        "operation_feedback.update_agreement_orderlines.save_ok": "Order lines saved.",
        "operation_feedback.update_agreement_orderlines.success": "Order lines were saved.",
        "operation_feedback.copy_report.title": "Copying service report {{number}}",
        "operation_feedback.copy_report.step.preflight": "Checking report",
        "operation_feedback.copy_report.step.copy": "Copying report",
        "operation_feedback.copy_report.step.checklist": "Creating checklist",
        "operation_feedback.copy_report.preflight_ok": "Report is ready to copy.",
        "operation_feedback.copy_report.preflight_failed": "Cannot copy the report.",
        "operation_feedback.copy_report.copy_ok": "Report copied.",
        "operation_feedback.copy_report.checklist_ok": "Checklist created.",
        "operation_feedback.copy_report.partial_checklist": "Report copied, but checklist could not be created.",
        "operation_feedback.copy_report.success": "The report was copied.",
        "operation_feedback.copy_report.open_report": "Open report {{id}}",
        "operation_feedback.rectify_report.title": "Creating follow-up for {{number}}",
        "operation_feedback.rectify_report.step.preflight": "Checking report",
        "operation_feedback.rectify_report.step.create_sequel": "Creating follow-up",
        "operation_feedback.rectify_report.step.checklist": "Creating checklist",
        "operation_feedback.rectify_report.preflight_ok": "Report is ready.",
        "operation_feedback.rectify_report.preflight_failed": "Cannot create follow-up.",
        "operation_feedback.rectify_report.preflight_has_sequel": "The report already has a follow-up.",
        "operation_feedback.rectify_report.create_ok": "Follow-up created.",
        "operation_feedback.rectify_report.checklist_ok": "Checklist created.",
        "operation_feedback.rectify_report.partial_checklist": "Follow-up created, but checklist could not be created.",
        "operation_feedback.rectify_report.success": "The follow-up was created.",
        "operation_feedback.rectify_report.open_report": "Open report {{id}}",
        "operation_feedback.export_reports_excel.title": "Exporting service reports to Excel",
        "operation_feedback.export_reports_excel.step.preflight": "Checking filters",
        "operation_feedback.export_reports_excel.step.export": "Generating Excel",
        "operation_feedback.export_reports_excel.preflight_ok": "Filters look good.",
        "operation_feedback.export_reports_excel.preflight_failed": "Cannot start export.",
        "operation_feedback.export_reports_excel.export_ok": "Excel is ready.",
        "operation_feedback.export_reports_excel.export_failed": "Could not generate Excel.",
        "operation_feedback.export_reports_excel.success": "Excel export is ready.",
        "operation_feedback.export_reports_excel.download": "Download Excel",
        "operation_feedback.generic_error": "An unexpected error occurred.",
        "operation_feedback.diagnostics.toggle": "Technical details",
        "operation_feedback.diagnostics.loading": "Loading technical details…",
        "operation_feedback.diagnostics.copy": "Copy error details",
        "operation_feedback.diagnostics.copied": "Copied",
        "operation_feedback.diagnostics.not_found": "No technical details found for this reference.",
        "operation_feedback.diagnostics.forbidden": "You do not have access to technical details.",
        "operation_feedback.diagnostics.load_failed": "Could not load technical details.",
    }
}
